module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "fae3");
/******/ })
/************************************************************************/
/******/ ({

/***/ "0094":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__("da84");
var uncurryThis = __webpack_require__("e330");
var defineBuiltIns = __webpack_require__("6964");
var InternalMetadataModule = __webpack_require__("f183");
var collection = __webpack_require__("6d61");
var collectionWeak = __webpack_require__("acac");
var isObject = __webpack_require__("861d");
var isExtensible = __webpack_require__("4fad");
var enforceInternalState = __webpack_require__("69f3").enforce;
var NATIVE_WEAK_MAP = __webpack_require__("7f9a");

var IS_IE11 = !global.ActiveXObject && 'ActiveXObject' in global;
var InternalWeakMap;

var wrapper = function (init) {
  return function WeakMap() {
    return init(this, arguments.length ? arguments[0] : undefined);
  };
};

// `WeakMap` constructor
// https://tc39.es/ecma262/#sec-weakmap-constructor
var $WeakMap = collection('WeakMap', wrapper, collectionWeak);

// IE11 WeakMap frozen keys fix
// We can't use feature detection because it crash some old IE builds
// https://github.com/zloirock/core-js/issues/485
if (NATIVE_WEAK_MAP && IS_IE11) {
  InternalWeakMap = collectionWeak.getConstructor(wrapper, 'WeakMap', true);
  InternalMetadataModule.enable();
  var WeakMapPrototype = $WeakMap.prototype;
  var nativeDelete = uncurryThis(WeakMapPrototype['delete']);
  var nativeHas = uncurryThis(WeakMapPrototype.has);
  var nativeGet = uncurryThis(WeakMapPrototype.get);
  var nativeSet = uncurryThis(WeakMapPrototype.set);
  defineBuiltIns(WeakMapPrototype, {
    'delete': function (key) {
      if (isObject(key) && !isExtensible(key)) {
        var state = enforceInternalState(this);
        if (!state.frozen) state.frozen = new InternalWeakMap();
        return nativeDelete(this, key) || state.frozen['delete'](key);
      } return nativeDelete(this, key);
    },
    has: function has(key) {
      if (isObject(key) && !isExtensible(key)) {
        var state = enforceInternalState(this);
        if (!state.frozen) state.frozen = new InternalWeakMap();
        return nativeHas(this, key) || state.frozen.has(key);
      } return nativeHas(this, key);
    },
    get: function get(key) {
      if (isObject(key) && !isExtensible(key)) {
        var state = enforceInternalState(this);
        if (!state.frozen) state.frozen = new InternalWeakMap();
        return nativeHas(this, key) ? nativeGet(this, key) : state.frozen.get(key);
      } return nativeGet(this, key);
    },
    set: function set(key, value) {
      if (isObject(key) && !isExtensible(key)) {
        var state = enforceInternalState(this);
        if (!state.frozen) state.frozen = new InternalWeakMap();
        nativeHas(this, key) ? nativeSet(this, key, value) : state.frozen.set(key, value);
      } else nativeSet(this, key, value);
      return this;
    }
  });
}


/***/ }),

/***/ "00b4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// TODO: Remove from `core-js@4` since it's moved to entry points
__webpack_require__("ac1f");
var $ = __webpack_require__("23e7");
var global = __webpack_require__("da84");
var call = __webpack_require__("c65b");
var uncurryThis = __webpack_require__("e330");
var isCallable = __webpack_require__("1626");
var isObject = __webpack_require__("861d");

var DELEGATES_TO_EXEC = function () {
  var execCalled = false;
  var re = /[ac]/;
  re.exec = function () {
    execCalled = true;
    return /./.exec.apply(this, arguments);
  };
  return re.test('abc') === true && execCalled;
}();

var Error = global.Error;
var un$Test = uncurryThis(/./.test);

// `RegExp.prototype.test` method
// https://tc39.es/ecma262/#sec-regexp.prototype.test
$({ target: 'RegExp', proto: true, forced: !DELEGATES_TO_EXEC }, {
  test: function (str) {
    var exec = this.exec;
    if (!isCallable(exec)) return un$Test(this, str);
    var result = call(exec, this, str);
    if (result !== null && !isObject(result)) {
      throw new Error('RegExp exec method returned something other than an Object or null');
    }
    return !!result;
  }
});


/***/ }),

/***/ "00ee":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("b622");

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var test = {};

test[TO_STRING_TAG] = 'z';

module.exports = String(test) === '[object z]';


/***/ }),

/***/ "0179":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ChoiceQuestion_vue_vue_type_style_index_1_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("a9bd");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ChoiceQuestion_vue_vue_type_style_index_1_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ChoiceQuestion_vue_vue_type_style_index_1_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "01b4":
/***/ (function(module, exports) {

var Queue = function () {
  this.head = null;
  this.tail = null;
};

Queue.prototype = {
  add: function (item) {
    var entry = { item: item, next: null };
    if (this.head) this.tail.next = entry;
    else this.head = entry;
    this.tail = entry;
  },
  get: function () {
    var entry = this.head;
    if (entry) {
      this.head = entry.next;
      if (this.tail === entry) this.tail = null;
      return entry.item;
    }
  }
};

module.exports = Queue;


/***/ }),

/***/ "02ec":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var trimStart = __webpack_require__("67b6");

// `String.prototype.trimLeft` method
// https://tc39.es/ecma262/#sec-string.prototype.trimleft
// eslint-disable-next-line es-x/no-string-prototype-trimleft-trimright -- safe
$({ target: 'String', proto: true, name: 'trimStart', forced: ''.trimLeft !== trimStart }, {
  trimLeft: trimStart
});


/***/ }),

/***/ "0366":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("e330");
var aCallable = __webpack_require__("59ed");
var NATIVE_BIND = __webpack_require__("40d5");

var bind = uncurryThis(uncurryThis.bind);

// optional / simple context binding
module.exports = function (fn, that) {
  aCallable(fn);
  return that === undefined ? fn : NATIVE_BIND ? bind(fn, that) : function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),

/***/ "0383":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "041b":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "04d1":
/***/ (function(module, exports, __webpack_require__) {

var userAgent = __webpack_require__("342f");

var firefox = userAgent.match(/firefox\/(\d+)/i);

module.exports = !!firefox && +firefox[1];


/***/ }),

/***/ "0538":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__("da84");
var uncurryThis = __webpack_require__("e330");
var aCallable = __webpack_require__("59ed");
var isObject = __webpack_require__("861d");
var hasOwn = __webpack_require__("1a2d");
var arraySlice = __webpack_require__("f36a");
var NATIVE_BIND = __webpack_require__("40d5");

var Function = global.Function;
var concat = uncurryThis([].concat);
var join = uncurryThis([].join);
var factories = {};

var construct = function (C, argsLength, args) {
  if (!hasOwn(factories, argsLength)) {
    for (var list = [], i = 0; i < argsLength; i++) list[i] = 'a[' + i + ']';
    factories[argsLength] = Function('C,a', 'return new C(' + join(list, ',') + ')');
  } return factories[argsLength](C, args);
};

// `Function.prototype.bind` method implementation
// https://tc39.es/ecma262/#sec-function.prototype.bind
module.exports = NATIVE_BIND ? Function.bind : function bind(that /* , ...args */) {
  var F = aCallable(this);
  var Prototype = F.prototype;
  var partArgs = arraySlice(arguments, 1);
  var boundFunction = function bound(/* args... */) {
    var args = concat(partArgs, arraySlice(arguments));
    return this instanceof boundFunction ? construct(F, args.length, args) : F.apply(that, args);
  };
  if (isObject(Prototype)) boundFunction.prototype = Prototype;
  return boundFunction;
};


/***/ }),

/***/ "057f":
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable es-x/no-object-getownpropertynames -- safe */
var classof = __webpack_require__("c6b6");
var toIndexedObject = __webpack_require__("fc6a");
var $getOwnPropertyNames = __webpack_require__("241c").f;
var arraySlice = __webpack_require__("4dae");

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return $getOwnPropertyNames(it);
  } catch (error) {
    return arraySlice(windowNames);
  }
};

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && classof(it) == 'Window'
    ? getWindowNames(it)
    : $getOwnPropertyNames(toIndexedObject(it));
};


/***/ }),

/***/ "06cf":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var call = __webpack_require__("c65b");
var propertyIsEnumerableModule = __webpack_require__("d1e7");
var createPropertyDescriptor = __webpack_require__("5c6c");
var toIndexedObject = __webpack_require__("fc6a");
var toPropertyKey = __webpack_require__("a04b");
var hasOwn = __webpack_require__("1a2d");
var IE8_DOM_DEFINE = __webpack_require__("0cfb");

// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
exports.f = DESCRIPTORS ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject(O);
  P = toPropertyKey(P);
  if (IE8_DOM_DEFINE) try {
    return $getOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (hasOwn(O, P)) return createPropertyDescriptor(!call(propertyIsEnumerableModule.f, O, P), O[P]);
};


/***/ }),

/***/ "07fa":
/***/ (function(module, exports, __webpack_require__) {

var toLength = __webpack_require__("50c4");

// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
module.exports = function (obj) {
  return toLength(obj.length);
};


/***/ }),

/***/ "0ab9":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "0b42":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var isArray = __webpack_require__("e8b5");
var isConstructor = __webpack_require__("68ee");
var isObject = __webpack_require__("861d");
var wellKnownSymbol = __webpack_require__("b622");

var SPECIES = wellKnownSymbol('species');
var Array = global.Array;

// a part of `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
module.exports = function (originalArray) {
  var C;
  if (isArray(originalArray)) {
    C = originalArray.constructor;
    // cross-realm fallback
    if (isConstructor(C) && (C === Array || isArray(C.prototype))) C = undefined;
    else if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),

/***/ "0c47":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var setToStringTag = __webpack_require__("d44e");

// JSON[@@toStringTag] property
// https://tc39.es/ecma262/#sec-json-@@tostringtag
setToStringTag(global.JSON, 'JSON', true);


/***/ }),

/***/ "0cb2":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("e330");
var toObject = __webpack_require__("7b0b");

var floor = Math.floor;
var charAt = uncurryThis(''.charAt);
var replace = uncurryThis(''.replace);
var stringSlice = uncurryThis(''.slice);
var SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d{1,2}|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d{1,2})/g;

// `GetSubstitution` abstract operation
// https://tc39.es/ecma262/#sec-getsubstitution
module.exports = function (matched, str, position, captures, namedCaptures, replacement) {
  var tailPos = position + matched.length;
  var m = captures.length;
  var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
  if (namedCaptures !== undefined) {
    namedCaptures = toObject(namedCaptures);
    symbols = SUBSTITUTION_SYMBOLS;
  }
  return replace(replacement, symbols, function (match, ch) {
    var capture;
    switch (charAt(ch, 0)) {
      case '$': return '$';
      case '&': return matched;
      case '`': return stringSlice(str, 0, position);
      case "'": return stringSlice(str, tailPos);
      case '<':
        capture = namedCaptures[stringSlice(ch, 1, -1)];
        break;
      default: // \d\d?
        var n = +ch;
        if (n === 0) return match;
        if (n > m) {
          var f = floor(n / 10);
          if (f === 0) return match;
          if (f <= m) return captures[f - 1] === undefined ? charAt(ch, 1) : captures[f - 1] + charAt(ch, 1);
          return match;
        }
        capture = captures[n - 1];
    }
    return capture === undefined ? '' : capture;
  });
};


/***/ }),

/***/ "0cfb":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var fails = __webpack_require__("d039");
var createElement = __webpack_require__("cc12");

// Thanks to IE8 for its funny defineProperty
module.exports = !DESCRIPTORS && !fails(function () {
  // eslint-disable-next-line es-x/no-object-defineproperty -- required for testing
  return Object.defineProperty(createElement('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});


/***/ }),

/***/ "0d3b":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");
var wellKnownSymbol = __webpack_require__("b622");
var IS_PURE = __webpack_require__("c430");

var ITERATOR = wellKnownSymbol('iterator');

module.exports = !fails(function () {
  // eslint-disable-next-line unicorn/relative-url-style -- required for testing
  var url = new URL('b?a=1&b=2&c=3', 'http://a');
  var searchParams = url.searchParams;
  var result = '';
  url.pathname = 'c%20d';
  searchParams.forEach(function (value, key) {
    searchParams['delete']('b');
    result += key + value;
  });
  return (IS_PURE && !url.toJSON)
    || !searchParams.sort
    || url.href !== 'http://a/c%20d?a=1&c=3'
    || searchParams.get('c') !== '3'
    || String(new URLSearchParams('?a=1')) !== 'a=1'
    || !searchParams[ITERATOR]
    // throws in Edge
    || new URL('https://a@b').username !== 'a'
    || new URLSearchParams(new URLSearchParams('a=b')).get('a') !== 'b'
    // not punycoded in Edge
    || new URL('http://тест').host !== 'xn--e1aybc'
    // not escaped in Chrome 62-
    || new URL('http://a#б').hash !== '#%D0%B1'
    // fails in Chrome 66-
    || result !== 'a1c3'
    // throws in Safari
    || new URL('http://x', undefined).host !== 'x';
});


/***/ }),

/***/ "0d51":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");

var String = global.String;

module.exports = function (argument) {
  try {
    return String(argument);
  } catch (error) {
    return 'Object';
  }
};


/***/ }),

/***/ "0f53":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_DtArray_vue_vue_type_style_index_0_id_56c83ae0_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("dc1f");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_DtArray_vue_vue_type_style_index_0_id_56c83ae0_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_DtArray_vue_vue_type_style_index_0_id_56c83ae0_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "107c":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");
var global = __webpack_require__("da84");

// babel-minify and Closure Compiler transpiles RegExp('(?<a>b)', 'g') -> /(?<a>b)/g and it causes SyntaxError
var $RegExp = global.RegExp;

module.exports = fails(function () {
  var re = $RegExp('(?<a>b)', 'g');
  return re.exec('b').groups.a !== 'b' ||
    'b'.replace(re, '$<a>c') !== 'bc';
});


/***/ }),

/***/ "1081":
/***/ (function(module, exports) {

module.exports = require("@molit/fhir-api");

/***/ }),

/***/ "10d1":
/***/ (function(module, exports, __webpack_require__) {

// TODO: Remove this module from `core-js@4` since it's replaced to module below
__webpack_require__("0094");


/***/ }),

/***/ "1148":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__("da84");
var toIntegerOrInfinity = __webpack_require__("5926");
var toString = __webpack_require__("577e");
var requireObjectCoercible = __webpack_require__("1d80");

var RangeError = global.RangeError;

// `String.prototype.repeat` method implementation
// https://tc39.es/ecma262/#sec-string.prototype.repeat
module.exports = function repeat(count) {
  var str = toString(requireObjectCoercible(this));
  var result = '';
  var n = toIntegerOrInfinity(count);
  if (n < 0 || n == Infinity) throw RangeError('Wrong number of repetitions');
  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) result += str;
  return result;
};


/***/ }),

/***/ "1276":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var apply = __webpack_require__("2ba4");
var call = __webpack_require__("c65b");
var uncurryThis = __webpack_require__("e330");
var fixRegExpWellKnownSymbolLogic = __webpack_require__("d784");
var isRegExp = __webpack_require__("44e7");
var anObject = __webpack_require__("825a");
var requireObjectCoercible = __webpack_require__("1d80");
var speciesConstructor = __webpack_require__("4840");
var advanceStringIndex = __webpack_require__("8aa5");
var toLength = __webpack_require__("50c4");
var toString = __webpack_require__("577e");
var getMethod = __webpack_require__("dc4a");
var arraySlice = __webpack_require__("4dae");
var callRegExpExec = __webpack_require__("14c3");
var regexpExec = __webpack_require__("9263");
var stickyHelpers = __webpack_require__("9f7f");
var fails = __webpack_require__("d039");

var UNSUPPORTED_Y = stickyHelpers.UNSUPPORTED_Y;
var MAX_UINT32 = 0xFFFFFFFF;
var min = Math.min;
var $push = [].push;
var exec = uncurryThis(/./.exec);
var push = uncurryThis($push);
var stringSlice = uncurryThis(''.slice);

// Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
// Weex JS has frozen built-in prototypes, so use try / catch wrapper
var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = !fails(function () {
  // eslint-disable-next-line regexp/no-empty-group -- required for testing
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length !== 2 || result[0] !== 'a' || result[1] !== 'b';
});

// @@split logic
fixRegExpWellKnownSymbolLogic('split', function (SPLIT, nativeSplit, maybeCallNative) {
  var internalSplit;
  if (
    'abbc'.split(/(b)*/)[1] == 'c' ||
    // eslint-disable-next-line regexp/no-empty-group -- required for testing
    'test'.split(/(?:)/, -1).length != 4 ||
    'ab'.split(/(?:ab)*/).length != 2 ||
    '.'.split(/(.?)(.?)/).length != 4 ||
    // eslint-disable-next-line regexp/no-empty-capturing-group, regexp/no-empty-group -- required for testing
    '.'.split(/()()/).length > 1 ||
    ''.split(/.?/).length
  ) {
    // based on es5-shim implementation, need to rework it
    internalSplit = function (separator, limit) {
      var string = toString(requireObjectCoercible(this));
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (separator === undefined) return [string];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) {
        return call(nativeSplit, string, separator, lim);
      }
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var match, lastIndex, lastLength;
      while (match = call(regexpExec, separatorCopy, string)) {
        lastIndex = separatorCopy.lastIndex;
        if (lastIndex > lastLastIndex) {
          push(output, stringSlice(string, lastLastIndex, match.index));
          if (match.length > 1 && match.index < string.length) apply($push, output, arraySlice(match, 1));
          lastLength = match[0].length;
          lastLastIndex = lastIndex;
          if (output.length >= lim) break;
        }
        if (separatorCopy.lastIndex === match.index) separatorCopy.lastIndex++; // Avoid an infinite loop
      }
      if (lastLastIndex === string.length) {
        if (lastLength || !exec(separatorCopy, '')) push(output, '');
      } else push(output, stringSlice(string, lastLastIndex));
      return output.length > lim ? arraySlice(output, 0, lim) : output;
    };
  // Chakra, V8
  } else if ('0'.split(undefined, 0).length) {
    internalSplit = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : call(nativeSplit, this, separator, limit);
    };
  } else internalSplit = nativeSplit;

  return [
    // `String.prototype.split` method
    // https://tc39.es/ecma262/#sec-string.prototype.split
    function split(separator, limit) {
      var O = requireObjectCoercible(this);
      var splitter = separator == undefined ? undefined : getMethod(separator, SPLIT);
      return splitter
        ? call(splitter, separator, O, limit)
        : call(internalSplit, toString(O), separator, limit);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function (string, limit) {
      var rx = anObject(this);
      var S = toString(string);
      var res = maybeCallNative(internalSplit, rx, S, limit, internalSplit !== nativeSplit);

      if (res.done) return res.value;

      var C = speciesConstructor(rx, RegExp);

      var unicodeMatching = rx.unicode;
      var flags = (rx.ignoreCase ? 'i' : '') +
                  (rx.multiline ? 'm' : '') +
                  (rx.unicode ? 'u' : '') +
                  (UNSUPPORTED_Y ? 'g' : 'y');

      // ^(? + rx + ) is needed, in combination with some S slicing, to
      // simulate the 'y' flag.
      var splitter = new C(UNSUPPORTED_Y ? '^(?:' + rx.source + ')' : rx, flags);
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
      var p = 0;
      var q = 0;
      var A = [];
      while (q < S.length) {
        splitter.lastIndex = UNSUPPORTED_Y ? 0 : q;
        var z = callRegExpExec(splitter, UNSUPPORTED_Y ? stringSlice(S, q) : S);
        var e;
        if (
          z === null ||
          (e = min(toLength(splitter.lastIndex + (UNSUPPORTED_Y ? q : 0)), S.length)) === p
        ) {
          q = advanceStringIndex(S, q, unicodeMatching);
        } else {
          push(A, stringSlice(S, p, q));
          if (A.length === lim) return A;
          for (var i = 1; i <= z.length - 1; i++) {
            push(A, z[i]);
            if (A.length === lim) return A;
          }
          q = p = e;
        }
      }
      push(A, stringSlice(S, p));
      return A;
    }
  ];
}, !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC, UNSUPPORTED_Y);


/***/ }),

/***/ "127b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_GroupsQuestionnaire_vue_vue_type_style_index_0_id_3cbd7814_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("69af");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_GroupsQuestionnaire_vue_vue_type_style_index_0_id_3cbd7814_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_GroupsQuestionnaire_vue_vue_type_style_index_0_id_3cbd7814_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "131a":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var setPrototypeOf = __webpack_require__("d2bb");

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
$({ target: 'Object', stat: true }, {
  setPrototypeOf: setPrototypeOf
});


/***/ }),

/***/ "132d":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "13d2":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");
var isCallable = __webpack_require__("1626");
var hasOwn = __webpack_require__("1a2d");
var defineProperty = __webpack_require__("9bf2").f;
var CONFIGURABLE_FUNCTION_NAME = __webpack_require__("5e77").CONFIGURABLE;
var inspectSource = __webpack_require__("8925");
var InternalStateModule = __webpack_require__("69f3");

var enforceInternalState = InternalStateModule.enforce;
var getInternalState = InternalStateModule.get;

var CONFIGURABLE_LENGTH = !fails(function () {
  return defineProperty(function () { /* empty */ }, 'length', { value: 8 }).length !== 8;
});

var TEMPLATE = String(String).split('String');

var makeBuiltIn = module.exports = function (value, name, options) {
  if (String(name).slice(0, 7) === 'Symbol(') {
    name = '[' + String(name).replace(/^Symbol\(([^)]*)\)/, '$1') + ']';
  }
  if (options && options.getter) name = 'get ' + name;
  if (options && options.setter) name = 'set ' + name;
  if (!hasOwn(value, 'name') || (CONFIGURABLE_FUNCTION_NAME && value.name !== name)) {
    defineProperty(value, 'name', { value: name, configurable: true });
  }
  if (CONFIGURABLE_LENGTH && options && hasOwn(options, 'arity') && value.length !== options.arity) {
    defineProperty(value, 'length', { value: options.arity });
  }
  var state = enforceInternalState(value);
  if (!hasOwn(state, 'source')) {
    state.source = TEMPLATE.join(typeof name == 'string' ? name : '');
  } return value;
};

// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = makeBuiltIn(function toString() {
  return isCallable(this) && getInternalState(this).source || inspectSource(this);
}, 'toString');


/***/ }),

/***/ "14c3":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var call = __webpack_require__("c65b");
var anObject = __webpack_require__("825a");
var isCallable = __webpack_require__("1626");
var classof = __webpack_require__("c6b6");
var regexpExec = __webpack_require__("9263");

var TypeError = global.TypeError;

// `RegExpExec` abstract operation
// https://tc39.es/ecma262/#sec-regexpexec
module.exports = function (R, S) {
  var exec = R.exec;
  if (isCallable(exec)) {
    var result = call(exec, R, S);
    if (result !== null) anObject(result);
    return result;
  }
  if (classof(R) === 'RegExp') return call(regexpExec, R, S);
  throw TypeError('RegExp#exec called on incompatible receiver');
};


/***/ }),

/***/ "14dc":
/***/ (function(module) {

module.exports = JSON.parse("{\"resourceType\":\"ValueSet\",\"status\":\"active\",\"compose\":{\"include\":[{\"system\":\"http://hl7.org/fhir/identifier-use\"}]},\"expansion\":{\"identifier\":\"urn:uuid:4267d82a-6f1a-4f19-9fe2-80e9b9950d24\",\"timestamp\":\"2018-09-17T17:09:02+02:00\",\"total\":4,\"parameter\":[{\"name\":\"version\",\"valueUri\":\"http://hl7.org/fhir/identifier-use|3.0.1\"}],\"contains\":[{\"system\":\"http://hl7.org/fhir/identifier-use\",\"code\":\"usual\",\"display\":\"Usual\"},{\"system\":\"http://hl7.org/fhir/identifier-use\",\"code\":\"official\",\"display\":\"Official\"},{\"system\":\"http://hl7.org/fhir/identifier-use\",\"code\":\"temp\",\"display\":\"Temp\"},{\"system\":\"http://hl7.org/fhir/identifier-use\",\"code\":\"secondary\",\"display\":\"Secondary\"}]}}");

/***/ }),

/***/ "14e5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var call = __webpack_require__("c65b");
var aCallable = __webpack_require__("59ed");
var newPromiseCapabilityModule = __webpack_require__("f069");
var perform = __webpack_require__("e667");
var iterate = __webpack_require__("2266");
var PROMISE_STATICS_INCORRECT_ITERATION = __webpack_require__("5eed");

// `Promise.all` method
// https://tc39.es/ecma262/#sec-promise.all
$({ target: 'Promise', stat: true, forced: PROMISE_STATICS_INCORRECT_ITERATION }, {
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapabilityModule.f(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aCallable(C.resolve);
      var values = [];
      var counter = 0;
      var remaining = 1;
      iterate(iterable, function (promise) {
        var index = counter++;
        var alreadyCalled = false;
        remaining++;
        call($promiseResolve, C, promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});


/***/ }),

/***/ "159b":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var DOMIterables = __webpack_require__("fdbc");
var DOMTokenListPrototype = __webpack_require__("785a");
var forEach = __webpack_require__("17c2");
var createNonEnumerableProperty = __webpack_require__("9112");

var handlePrototype = function (CollectionPrototype) {
  // some Chrome versions have non-configurable methods on DOMTokenList
  if (CollectionPrototype && CollectionPrototype.forEach !== forEach) try {
    createNonEnumerableProperty(CollectionPrototype, 'forEach', forEach);
  } catch (error) {
    CollectionPrototype.forEach = forEach;
  }
};

for (var COLLECTION_NAME in DOMIterables) {
  if (DOMIterables[COLLECTION_NAME]) {
    handlePrototype(global[COLLECTION_NAME] && global[COLLECTION_NAME].prototype);
  }
}

handlePrototype(DOMTokenListPrototype);


/***/ }),

/***/ "1626":
/***/ (function(module, exports) {

// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
module.exports = function (argument) {
  return typeof argument == 'function';
};


/***/ }),

/***/ "17c2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $forEach = __webpack_require__("b727").forEach;
var arrayMethodIsStrict = __webpack_require__("a640");

var STRICT_METHOD = arrayMethodIsStrict('forEach');

// `Array.prototype.forEach` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.foreach
module.exports = !STRICT_METHOD ? function forEach(callbackfn /* , thisArg */) {
  return $forEach(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
// eslint-disable-next-line es-x/no-array-prototype-foreach -- safe
} : [].forEach;


/***/ }),

/***/ "19aa":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var isPrototypeOf = __webpack_require__("3a9b");

var TypeError = global.TypeError;

module.exports = function (it, Prototype) {
  if (isPrototypeOf(Prototype, it)) return it;
  throw TypeError('Incorrect invocation');
};


/***/ }),

/***/ "1a2d":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("e330");
var toObject = __webpack_require__("7b0b");

var hasOwnProperty = uncurryThis({}.hasOwnProperty);

// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es-x/no-object-hasown -- safe
module.exports = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty(toObject(it), key);
};


/***/ }),

/***/ "1a4e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PaginatedList_vue_vue_type_style_index_0_id_d16b3252_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("aa13");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PaginatedList_vue_vue_type_style_index_0_id_d16b3252_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_PaginatedList_vue_vue_type_style_index_0_id_d16b3252_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "1be4":
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__("d066");

module.exports = getBuiltIn('document', 'documentElement');


/***/ }),

/***/ "1c7e":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("b622");

var ITERATOR = wellKnownSymbol('iterator');
var SAFE_CLOSING = false;

try {
  var called = 0;
  var iteratorWithReturn = {
    next: function () {
      return { done: !!called++ };
    },
    'return': function () {
      SAFE_CLOSING = true;
    }
  };
  iteratorWithReturn[ITERATOR] = function () {
    return this;
  };
  // eslint-disable-next-line es-x/no-array-from, no-throw-literal -- required for testing
  Array.from(iteratorWithReturn, function () { throw 2; });
} catch (error) { /* empty */ }

module.exports = function (exec, SKIP_CLOSING) {
  if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
  var ITERATION_SUPPORT = false;
  try {
    var object = {};
    object[ITERATOR] = function () {
      return {
        next: function () {
          return { done: ITERATION_SUPPORT = true };
        }
      };
    };
    exec(object);
  } catch (error) { /* empty */ }
  return ITERATION_SUPPORT;
};


/***/ }),

/***/ "1cdc":
/***/ (function(module, exports, __webpack_require__) {

var userAgent = __webpack_require__("342f");

module.exports = /(?:ipad|iphone|ipod).*applewebkit/i.test(userAgent);


/***/ }),

/***/ "1d80":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");

var TypeError = global.TypeError;

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on " + it);
  return it;
};


/***/ }),

/***/ "1dde":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");
var wellKnownSymbol = __webpack_require__("b622");
var V8_VERSION = __webpack_require__("2d00");

var SPECIES = wellKnownSymbol('species');

module.exports = function (METHOD_NAME) {
  // We can't use this feature detection in V8 since it causes
  // deoptimization and serious performance degradation
  // https://github.com/zloirock/core-js/issues/677
  return V8_VERSION >= 51 || !fails(function () {
    var array = [];
    var constructor = array.constructor = {};
    constructor[SPECIES] = function () {
      return { foo: 1 };
    };
    return array[METHOD_NAME](Boolean).foo !== 1;
  });
};


/***/ }),

/***/ "1ee0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_StepperQuestionnaire_vue_vue_type_style_index_0_id_640840c0_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("0ab9");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_StepperQuestionnaire_vue_vue_type_style_index_0_id_640840c0_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_StepperQuestionnaire_vue_vue_type_style_index_0_id_640840c0_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "2266":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var bind = __webpack_require__("0366");
var call = __webpack_require__("c65b");
var anObject = __webpack_require__("825a");
var tryToString = __webpack_require__("0d51");
var isArrayIteratorMethod = __webpack_require__("e95a");
var lengthOfArrayLike = __webpack_require__("07fa");
var isPrototypeOf = __webpack_require__("3a9b");
var getIterator = __webpack_require__("9a1f");
var getIteratorMethod = __webpack_require__("35a1");
var iteratorClose = __webpack_require__("2a62");

var TypeError = global.TypeError;

var Result = function (stopped, result) {
  this.stopped = stopped;
  this.result = result;
};

var ResultPrototype = Result.prototype;

module.exports = function (iterable, unboundFunction, options) {
  var that = options && options.that;
  var AS_ENTRIES = !!(options && options.AS_ENTRIES);
  var IS_ITERATOR = !!(options && options.IS_ITERATOR);
  var INTERRUPTED = !!(options && options.INTERRUPTED);
  var fn = bind(unboundFunction, that);
  var iterator, iterFn, index, length, result, next, step;

  var stop = function (condition) {
    if (iterator) iteratorClose(iterator, 'normal', condition);
    return new Result(true, condition);
  };

  var callFn = function (value) {
    if (AS_ENTRIES) {
      anObject(value);
      return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
    } return INTERRUPTED ? fn(value, stop) : fn(value);
  };

  if (IS_ITERATOR) {
    iterator = iterable;
  } else {
    iterFn = getIteratorMethod(iterable);
    if (!iterFn) throw TypeError(tryToString(iterable) + ' is not iterable');
    // optimisation for array iterators
    if (isArrayIteratorMethod(iterFn)) {
      for (index = 0, length = lengthOfArrayLike(iterable); length > index; index++) {
        result = callFn(iterable[index]);
        if (result && isPrototypeOf(ResultPrototype, result)) return result;
      } return new Result(false);
    }
    iterator = getIterator(iterable, iterFn);
  }

  next = iterator.next;
  while (!(step = call(next, iterator)).done) {
    try {
      result = callFn(step.value);
    } catch (error) {
      iteratorClose(iterator, 'throw', error);
    }
    if (typeof result == 'object' && result && isPrototypeOf(ResultPrototype, result)) return result;
  } return new Result(false);
};


/***/ }),

/***/ "23cb":
/***/ (function(module, exports, __webpack_require__) {

var toIntegerOrInfinity = __webpack_require__("5926");

var max = Math.max;
var min = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
module.exports = function (index, length) {
  var integer = toIntegerOrInfinity(index);
  return integer < 0 ? max(integer + length, 0) : min(integer, length);
};


/***/ }),

/***/ "23dc":
/***/ (function(module, exports, __webpack_require__) {

var setToStringTag = __webpack_require__("d44e");

// Math[@@toStringTag] property
// https://tc39.es/ecma262/#sec-math-@@tostringtag
setToStringTag(Math, 'Math', true);


/***/ }),

/***/ "23e7":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var getOwnPropertyDescriptor = __webpack_require__("06cf").f;
var createNonEnumerableProperty = __webpack_require__("9112");
var defineBuiltIn = __webpack_require__("cb2d");
var setGlobal = __webpack_require__("ce4e");
var copyConstructorProperties = __webpack_require__("e893");
var isForced = __webpack_require__("94ca");

/*
  options.target      - name of the target object
  options.global      - target is the global object
  options.stat        - export as static methods of target
  options.proto       - export as prototype methods of target
  options.real        - real prototype method for the `pure` version
  options.forced      - export even if the native feature is available
  options.bind        - bind methods to the target, required for the `pure` version
  options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe      - use the simple assignment of property instead of delete + defineProperty
  options.sham        - add a flag to not completely full polyfills
  options.enumerable  - export as enumerable property
  options.noTargetGet - prevent calling a getter on target
  options.name        - the .name of the function if it does not match the key
*/
module.exports = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global;
  } else if (STATIC) {
    target = global[TARGET] || setGlobal(TARGET, {});
  } else {
    target = (global[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.noTargetGet) {
      descriptor = getOwnPropertyDescriptor(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty == typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty(sourceProperty, 'sham', true);
    }
    defineBuiltIn(target, key, sourceProperty, options);
  }
};


/***/ }),

/***/ "241c":
/***/ (function(module, exports, __webpack_require__) {

var internalObjectKeys = __webpack_require__("ca84");
var enumBugKeys = __webpack_require__("7839");

var hiddenKeys = enumBugKeys.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es-x/no-object-getownpropertynames -- safe
exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys(O, hiddenKeys);
};


/***/ }),

/***/ "2532":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var uncurryThis = __webpack_require__("e330");
var notARegExp = __webpack_require__("5a34");
var requireObjectCoercible = __webpack_require__("1d80");
var toString = __webpack_require__("577e");
var correctIsRegExpLogic = __webpack_require__("ab13");

var stringIndexOf = uncurryThis(''.indexOf);

// `String.prototype.includes` method
// https://tc39.es/ecma262/#sec-string.prototype.includes
$({ target: 'String', proto: true, forced: !correctIsRegExpLogic('includes') }, {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~stringIndexOf(
      toString(requireObjectCoercible(this)),
      toString(notARegExp(searchString)),
      arguments.length > 1 ? arguments[1] : undefined
    );
  }
});


/***/ }),

/***/ "2555":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "25f0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var PROPER_FUNCTION_NAME = __webpack_require__("5e77").PROPER;
var defineBuiltIn = __webpack_require__("cb2d");
var anObject = __webpack_require__("825a");
var $toString = __webpack_require__("577e");
var fails = __webpack_require__("d039");
var getRegExpFlags = __webpack_require__("90d8");

var TO_STRING = 'toString';
var RegExpPrototype = RegExp.prototype;
var n$ToString = RegExpPrototype[TO_STRING];

var NOT_GENERIC = fails(function () { return n$ToString.call({ source: 'a', flags: 'b' }) != '/a/b'; });
// FF44- RegExp#toString has a wrong name
var INCORRECT_NAME = PROPER_FUNCTION_NAME && n$ToString.name != TO_STRING;

// `RegExp.prototype.toString` method
// https://tc39.es/ecma262/#sec-regexp.prototype.tostring
if (NOT_GENERIC || INCORRECT_NAME) {
  defineBuiltIn(RegExp.prototype, TO_STRING, function toString() {
    var R = anObject(this);
    var pattern = $toString(R.source);
    var flags = $toString(getRegExpFlags(R));
    return '/' + pattern + '/' + flags;
  }, { unsafe: true });
}


/***/ }),

/***/ "2626":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var getBuiltIn = __webpack_require__("d066");
var definePropertyModule = __webpack_require__("9bf2");
var wellKnownSymbol = __webpack_require__("b622");
var DESCRIPTORS = __webpack_require__("83ab");

var SPECIES = wellKnownSymbol('species');

module.exports = function (CONSTRUCTOR_NAME) {
  var Constructor = getBuiltIn(CONSTRUCTOR_NAME);
  var defineProperty = definePropertyModule.f;

  if (DESCRIPTORS && Constructor && !Constructor[SPECIES]) {
    defineProperty(Constructor, SPECIES, {
      configurable: true,
      get: function () { return this; }
    });
  }
};


/***/ }),

/***/ "2982":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "2a62":
/***/ (function(module, exports, __webpack_require__) {

var call = __webpack_require__("c65b");
var anObject = __webpack_require__("825a");
var getMethod = __webpack_require__("dc4a");

module.exports = function (iterator, kind, value) {
  var innerResult, innerError;
  anObject(iterator);
  try {
    innerResult = getMethod(iterator, 'return');
    if (!innerResult) {
      if (kind === 'throw') throw value;
      return value;
    }
    innerResult = call(innerResult, iterator);
  } catch (error) {
    innerError = true;
    innerResult = error;
  }
  if (kind === 'throw') throw value;
  if (innerError) throw innerResult;
  anObject(innerResult);
  return value;
};


/***/ }),

/***/ "2b16":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_MolecularReport_vue_vue_type_style_index_0_id_133eff7a_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("9ff0");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_MolecularReport_vue_vue_type_style_index_0_id_133eff7a_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_MolecularReport_vue_vue_type_style_index_0_id_133eff7a_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "2ba4":
/***/ (function(module, exports, __webpack_require__) {

var NATIVE_BIND = __webpack_require__("40d5");

var FunctionPrototype = Function.prototype;
var apply = FunctionPrototype.apply;
var call = FunctionPrototype.call;

// eslint-disable-next-line es-x/no-reflect -- safe
module.exports = typeof Reflect == 'object' && Reflect.apply || (NATIVE_BIND ? call.bind(apply) : function () {
  return call.apply(apply, arguments);
});


/***/ }),

/***/ "2be5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_IntegerQuestion_vue_vue_type_style_index_0_id_c279d800_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("df33");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_IntegerQuestion_vue_vue_type_style_index_0_id_c279d800_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_IntegerQuestion_vue_vue_type_style_index_0_id_c279d800_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "2c3e":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var DESCRIPTORS = __webpack_require__("83ab");
var MISSED_STICKY = __webpack_require__("9f7f").MISSED_STICKY;
var classof = __webpack_require__("c6b6");
var defineBuiltInAccessor = __webpack_require__("edd0");
var getInternalState = __webpack_require__("69f3").get;

var RegExpPrototype = RegExp.prototype;
var TypeError = global.TypeError;

// `RegExp.prototype.sticky` getter
// https://tc39.es/ecma262/#sec-get-regexp.prototype.sticky
if (DESCRIPTORS && MISSED_STICKY) {
  defineBuiltInAccessor(RegExpPrototype, 'sticky', {
    configurable: true,
    get: function sticky() {
      if (this === RegExpPrototype) return undefined;
      // We can't use InternalStateModule.getterFor because
      // we don't add metadata for regexps created by a literal.
      if (classof(this) === 'RegExp') {
        return !!getInternalState(this).sticky;
      }
      throw TypeError('Incompatible receiver, RegExp required');
    }
  });
}


/***/ }),

/***/ "2ca0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var uncurryThis = __webpack_require__("e330");
var getOwnPropertyDescriptor = __webpack_require__("06cf").f;
var toLength = __webpack_require__("50c4");
var toString = __webpack_require__("577e");
var notARegExp = __webpack_require__("5a34");
var requireObjectCoercible = __webpack_require__("1d80");
var correctIsRegExpLogic = __webpack_require__("ab13");
var IS_PURE = __webpack_require__("c430");

// eslint-disable-next-line es-x/no-string-prototype-startswith -- safe
var un$StartsWith = uncurryThis(''.startsWith);
var stringSlice = uncurryThis(''.slice);
var min = Math.min;

var CORRECT_IS_REGEXP_LOGIC = correctIsRegExpLogic('startsWith');
// https://github.com/zloirock/core-js/pull/702
var MDN_POLYFILL_BUG = !IS_PURE && !CORRECT_IS_REGEXP_LOGIC && !!function () {
  var descriptor = getOwnPropertyDescriptor(String.prototype, 'startsWith');
  return descriptor && !descriptor.writable;
}();

// `String.prototype.startsWith` method
// https://tc39.es/ecma262/#sec-string.prototype.startswith
$({ target: 'String', proto: true, forced: !MDN_POLYFILL_BUG && !CORRECT_IS_REGEXP_LOGIC }, {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = toString(requireObjectCoercible(this));
    notARegExp(searchString);
    var index = toLength(min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = toString(searchString);
    return un$StartsWith
      ? un$StartsWith(that, search, index)
      : stringSlice(that, index, index + search.length) === search;
  }
});


/***/ }),

/***/ "2cf4":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var apply = __webpack_require__("2ba4");
var bind = __webpack_require__("0366");
var isCallable = __webpack_require__("1626");
var hasOwn = __webpack_require__("1a2d");
var fails = __webpack_require__("d039");
var html = __webpack_require__("1be4");
var arraySlice = __webpack_require__("f36a");
var createElement = __webpack_require__("cc12");
var validateArgumentsLength = __webpack_require__("d6d6");
var IS_IOS = __webpack_require__("1cdc");
var IS_NODE = __webpack_require__("605d");

var set = global.setImmediate;
var clear = global.clearImmediate;
var process = global.process;
var Dispatch = global.Dispatch;
var Function = global.Function;
var MessageChannel = global.MessageChannel;
var String = global.String;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var location, defer, channel, port;

try {
  // Deno throws a ReferenceError on `location` access without `--location` flag
  location = global.location;
} catch (error) { /* empty */ }

var run = function (id) {
  if (hasOwn(queue, id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};

var runner = function (id) {
  return function () {
    run(id);
  };
};

var listener = function (event) {
  run(event.data);
};

var post = function (id) {
  // old engines have not location.origin
  global.postMessage(String(id), location.protocol + '//' + location.host);
};

// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!set || !clear) {
  set = function setImmediate(handler) {
    validateArgumentsLength(arguments.length, 1);
    var fn = isCallable(handler) ? handler : Function(handler);
    var args = arraySlice(arguments, 1);
    queue[++counter] = function () {
      apply(fn, undefined, args);
    };
    defer(counter);
    return counter;
  };
  clear = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (IS_NODE) {
    defer = function (id) {
      process.nextTick(runner(id));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(runner(id));
    };
  // Browsers with MessageChannel, includes WebWorkers
  // except iOS - https://github.com/zloirock/core-js/issues/624
  } else if (MessageChannel && !IS_IOS) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = bind(port.postMessage, port);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (
    global.addEventListener &&
    isCallable(global.postMessage) &&
    !global.importScripts &&
    location && location.protocol !== 'file:' &&
    !fails(post)
  ) {
    defer = post;
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in createElement('script')) {
    defer = function (id) {
      html.appendChild(createElement('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(runner(id), 0);
    };
  }
}

module.exports = {
  set: set,
  clear: clear
};


/***/ }),

/***/ "2d00":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var userAgent = __webpack_require__("342f");

var process = global.process;
var Deno = global.Deno;
var versions = process && process.versions || Deno && Deno.version;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  // in old Chrome, versions of V8 isn't V8 = Chrome / 10
  // but their correct versions are not interesting for us
  version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
}

// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!version && userAgent) {
  match = userAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent.match(/Chrome\/(\d+)/);
    if (match) version = +match[1];
  }
}

module.exports = version;


/***/ }),

/***/ "3410":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var fails = __webpack_require__("d039");
var toObject = __webpack_require__("7b0b");
var nativeGetPrototypeOf = __webpack_require__("e163");
var CORRECT_PROTOTYPE_GETTER = __webpack_require__("e177");

var FAILS_ON_PRIMITIVES = fails(function () { nativeGetPrototypeOf(1); });

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES, sham: !CORRECT_PROTOTYPE_GETTER }, {
  getPrototypeOf: function getPrototypeOf(it) {
    return nativeGetPrototypeOf(toObject(it));
  }
});



/***/ }),

/***/ "342f":
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__("d066");

module.exports = getBuiltIn('navigator', 'userAgent') || '';


/***/ }),

/***/ "3529":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var call = __webpack_require__("c65b");
var aCallable = __webpack_require__("59ed");
var newPromiseCapabilityModule = __webpack_require__("f069");
var perform = __webpack_require__("e667");
var iterate = __webpack_require__("2266");
var PROMISE_STATICS_INCORRECT_ITERATION = __webpack_require__("5eed");

// `Promise.race` method
// https://tc39.es/ecma262/#sec-promise.race
$({ target: 'Promise', stat: true, forced: PROMISE_STATICS_INCORRECT_ITERATION }, {
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapabilityModule.f(C);
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aCallable(C.resolve);
      iterate(iterable, function (promise) {
        call($promiseResolve, C, promise).then(capability.resolve, reject);
      });
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});


/***/ }),

/***/ "35a1":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("f5df");
var getMethod = __webpack_require__("dc4a");
var Iterators = __webpack_require__("3f8c");
var wellKnownSymbol = __webpack_require__("b622");

var ITERATOR = wellKnownSymbol('iterator');

module.exports = function (it) {
  if (it != undefined) return getMethod(it, ITERATOR)
    || getMethod(it, '@@iterator')
    || Iterators[classof(it)];
};


/***/ }),

/***/ "37e8":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var V8_PROTOTYPE_DEFINE_BUG = __webpack_require__("aed9");
var definePropertyModule = __webpack_require__("9bf2");
var anObject = __webpack_require__("825a");
var toIndexedObject = __webpack_require__("fc6a");
var objectKeys = __webpack_require__("df75");

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es-x/no-object-defineproperties -- safe
exports.f = DESCRIPTORS && !V8_PROTOTYPE_DEFINE_BUG ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var props = toIndexedObject(Properties);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule.f(O, key = keys[index++], props[key]);
  return O;
};


/***/ }),

/***/ "3a9b":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("e330");

module.exports = uncurryThis({}.isPrototypeOf);


/***/ }),

/***/ "3b3f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_GroupQuestion_vue_vue_type_style_index_0_id_32607e7a_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("041b");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_GroupQuestion_vue_vue_type_style_index_0_id_32607e7a_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_GroupQuestion_vue_vue_type_style_index_0_id_32607e7a_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "3bbe":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var isCallable = __webpack_require__("1626");

var String = global.String;
var TypeError = global.TypeError;

module.exports = function (argument) {
  if (typeof argument == 'object' || isCallable(argument)) return argument;
  throw TypeError("Can't set " + String(argument) + ' as a prototype');
};


/***/ }),

/***/ "3ca3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var charAt = __webpack_require__("6547").charAt;
var toString = __webpack_require__("577e");
var InternalStateModule = __webpack_require__("69f3");
var defineIterator = __webpack_require__("7dd0");

var STRING_ITERATOR = 'String Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(STRING_ITERATOR);

// `String.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-string.prototype-@@iterator
defineIterator(String, 'String', function (iterated) {
  setInternalState(this, {
    type: STRING_ITERATOR,
    string: toString(iterated),
    index: 0
  });
// `%StringIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
  var state = getInternalState(this);
  var string = state.string;
  var index = state.index;
  var point;
  if (index >= string.length) return { value: undefined, done: true };
  point = charAt(string, index);
  state.index += point.length;
  return { value: point, done: false };
});


/***/ }),

/***/ "3d87":
/***/ (function(module, exports, __webpack_require__) {

var NATIVE_SYMBOL = __webpack_require__("4930");

/* eslint-disable es-x/no-symbol -- safe */
module.exports = NATIVE_SYMBOL && !!Symbol['for'] && !!Symbol.keyFor;


/***/ }),

/***/ "3f8c":
/***/ (function(module, exports) {

module.exports = {};


/***/ }),

/***/ "408a":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("e330");

// `thisNumberValue` abstract operation
// https://tc39.es/ecma262/#sec-thisnumbervalue
module.exports = uncurryThis(1.0.valueOf);


/***/ }),

/***/ "40d5":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");

module.exports = !fails(function () {
  // eslint-disable-next-line es-x/no-function-prototype-bind -- safe
  var test = (function () { /* empty */ }).bind();
  // eslint-disable-next-line no-prototype-builtins -- safe
  return typeof test != 'function' || test.hasOwnProperty('prototype');
});


/***/ }),

/***/ "428f":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");

module.exports = global;


/***/ }),

/***/ "44ad":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var uncurryThis = __webpack_require__("e330");
var fails = __webpack_require__("d039");
var classof = __webpack_require__("c6b6");

var Object = global.Object;
var split = uncurryThis(''.split);

// fallback for non-array-like ES3 and non-enumerable old V8 strings
module.exports = fails(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof(it) == 'String' ? split(it, '') : Object(it);
} : Object;


/***/ }),

/***/ "44d2":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("b622");
var create = __webpack_require__("7c73");
var definePropertyModule = __webpack_require__("9bf2");

var UNSCOPABLES = wellKnownSymbol('unscopables');
var ArrayPrototype = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype[UNSCOPABLES] == undefined) {
  definePropertyModule.f(ArrayPrototype, UNSCOPABLES, {
    configurable: true,
    value: create(null)
  });
}

// add a key to Array.prototype[@@unscopables]
module.exports = function (key) {
  ArrayPrototype[UNSCOPABLES][key] = true;
};


/***/ }),

/***/ "44de":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");

module.exports = function (a, b) {
  var console = global.console;
  if (console && console.error) {
    arguments.length == 1 ? console.error(a) : console.error(a, b);
  }
};


/***/ }),

/***/ "44e7":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("861d");
var classof = __webpack_require__("c6b6");
var wellKnownSymbol = __webpack_require__("b622");

var MATCH = wellKnownSymbol('match');

// `IsRegExp` abstract operation
// https://tc39.es/ecma262/#sec-isregexp
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : classof(it) == 'RegExp');
};


/***/ }),

/***/ "4541":
/***/ (function(module, exports) {

module.exports = require("@molit/fhir-util");

/***/ }),

/***/ "466d":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var call = __webpack_require__("c65b");
var fixRegExpWellKnownSymbolLogic = __webpack_require__("d784");
var anObject = __webpack_require__("825a");
var toLength = __webpack_require__("50c4");
var toString = __webpack_require__("577e");
var requireObjectCoercible = __webpack_require__("1d80");
var getMethod = __webpack_require__("dc4a");
var advanceStringIndex = __webpack_require__("8aa5");
var regExpExec = __webpack_require__("14c3");

// @@match logic
fixRegExpWellKnownSymbolLogic('match', function (MATCH, nativeMatch, maybeCallNative) {
  return [
    // `String.prototype.match` method
    // https://tc39.es/ecma262/#sec-string.prototype.match
    function match(regexp) {
      var O = requireObjectCoercible(this);
      var matcher = regexp == undefined ? undefined : getMethod(regexp, MATCH);
      return matcher ? call(matcher, regexp, O) : new RegExp(regexp)[MATCH](toString(O));
    },
    // `RegExp.prototype[@@match]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@match
    function (string) {
      var rx = anObject(this);
      var S = toString(string);
      var res = maybeCallNative(nativeMatch, rx, S);

      if (res.done) return res.value;

      if (!rx.global) return regExpExec(rx, S);

      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
      var A = [];
      var n = 0;
      var result;
      while ((result = regExpExec(rx, S)) !== null) {
        var matchStr = toString(result[0]);
        A[n] = matchStr;
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
        n++;
      }
      return n === 0 ? null : A;
    }
  ];
});


/***/ }),

/***/ "4738":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var NativePromiseConstructor = __webpack_require__("d256");
var isCallable = __webpack_require__("1626");
var isForced = __webpack_require__("94ca");
var inspectSource = __webpack_require__("8925");
var wellKnownSymbol = __webpack_require__("b622");
var IS_BROWSER = __webpack_require__("6069");
var IS_PURE = __webpack_require__("c430");
var V8_VERSION = __webpack_require__("2d00");

var NativePromisePrototype = NativePromiseConstructor && NativePromiseConstructor.prototype;
var SPECIES = wellKnownSymbol('species');
var SUBCLASSING = false;
var NATIVE_PROMISE_REJECTION_EVENT = isCallable(global.PromiseRejectionEvent);

var FORCED_PROMISE_CONSTRUCTOR = isForced('Promise', function () {
  var PROMISE_CONSTRUCTOR_SOURCE = inspectSource(NativePromiseConstructor);
  var GLOBAL_CORE_JS_PROMISE = PROMISE_CONSTRUCTOR_SOURCE !== String(NativePromiseConstructor);
  // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
  // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
  // We can't detect it synchronously, so just check versions
  if (!GLOBAL_CORE_JS_PROMISE && V8_VERSION === 66) return true;
  // We need Promise#{ catch, finally } in the pure version for preventing prototype pollution
  if (IS_PURE && !(NativePromisePrototype['catch'] && NativePromisePrototype['finally'])) return true;
  // We can't use @@species feature detection in V8 since it causes
  // deoptimization and performance degradation
  // https://github.com/zloirock/core-js/issues/679
  if (V8_VERSION >= 51 && /native code/.test(PROMISE_CONSTRUCTOR_SOURCE)) return false;
  // Detect correctness of subclassing with @@species support
  var promise = new NativePromiseConstructor(function (resolve) { resolve(1); });
  var FakePromise = function (exec) {
    exec(function () { /* empty */ }, function () { /* empty */ });
  };
  var constructor = promise.constructor = {};
  constructor[SPECIES] = FakePromise;
  SUBCLASSING = promise.then(function () { /* empty */ }) instanceof FakePromise;
  if (!SUBCLASSING) return true;
  // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
  return !GLOBAL_CORE_JS_PROMISE && IS_BROWSER && !NATIVE_PROMISE_REJECTION_EVENT;
});

module.exports = {
  CONSTRUCTOR: FORCED_PROMISE_CONSTRUCTOR,
  REJECTION_EVENT: NATIVE_PROMISE_REJECTION_EVENT,
  SUBCLASSING: SUBCLASSING
};


/***/ }),

/***/ "4766":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "4840":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("825a");
var aConstructor = __webpack_require__("5087");
var wellKnownSymbol = __webpack_require__("b622");

var SPECIES = wellKnownSymbol('species');

// `SpeciesConstructor` abstract operation
// https://tc39.es/ecma262/#sec-speciesconstructor
module.exports = function (O, defaultConstructor) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? defaultConstructor : aConstructor(S);
};


/***/ }),

/***/ "4849":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_QuestionnaireRenderer_vue_vue_type_style_index_0_id_4e53f25c_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("96d5");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_QuestionnaireRenderer_vue_vue_type_style_index_0_id_4e53f25c_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_QuestionnaireRenderer_vue_vue_type_style_index_0_id_4e53f25c_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "485a":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var call = __webpack_require__("c65b");
var isCallable = __webpack_require__("1626");
var isObject = __webpack_require__("861d");

var TypeError = global.TypeError;

// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
module.exports = function (input, pref) {
  var fn, val;
  if (pref === 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
  if (isCallable(fn = input.valueOf) && !isObject(val = call(fn, input))) return val;
  if (pref !== 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ "48f4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_FullQuestionnaire_vue_vue_type_style_index_0_id_612ed1f2_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("9015");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_FullQuestionnaire_vue_vue_type_style_index_0_id_612ed1f2_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_FullQuestionnaire_vue_vue_type_style_index_0_id_612ed1f2_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "4930":
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable es-x/no-symbol -- required for testing */
var V8_VERSION = __webpack_require__("2d00");
var fails = __webpack_require__("d039");

// eslint-disable-next-line es-x/no-object-getownpropertysymbols -- required for testing
module.exports = !!Object.getOwnPropertySymbols && !fails(function () {
  var symbol = Symbol();
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  return !String(symbol) || !(Object(symbol) instanceof Symbol) ||
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION && V8_VERSION < 41;
});


/***/ }),

/***/ "498a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var $trim = __webpack_require__("58a8").trim;
var forcedStringTrimMethod = __webpack_require__("c8d2");

// `String.prototype.trim` method
// https://tc39.es/ecma262/#sec-string.prototype.trim
$({ target: 'String', proto: true, forced: forcedStringTrimMethod('trim') }, {
  trim: function trim() {
    return $trim(this);
  }
});


/***/ }),

/***/ "4a33":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "4a9f":
/***/ (function(module) {

module.exports = JSON.parse("{\"resourceType\":\"ValueSet\",\"status\":\"active\",\"compose\":{\"include\":[{\"system\":\"http://hl7.org/fhir/name-use\"}]},\"expansion\":{\"identifier\":\"urn:uuid:b101c0b3-5e87-4523-9c19-6afc4179fdd0\",\"timestamp\":\"2018-09-13T12:04:26+02:00\",\"total\":7,\"parameter\":[{\"name\":\"version\",\"valueUri\":\"http://hl7.org/fhir/name-use|3.0.1\"}],\"contains\":[{\"system\":\"http://hl7.org/fhir/name-use\",\"code\":\"usual\",\"display\":\"Usual\"},{\"system\":\"http://hl7.org/fhir/name-use\",\"code\":\"official\",\"display\":\"Official\"},{\"system\":\"http://hl7.org/fhir/name-use\",\"code\":\"temp\",\"display\":\"Temp\"},{\"system\":\"http://hl7.org/fhir/name-use\",\"code\":\"nickname\",\"display\":\"Nickname\"},{\"system\":\"http://hl7.org/fhir/name-use\",\"code\":\"anonymous\",\"display\":\"Anonymous\"},{\"system\":\"http://hl7.org/fhir/name-use\",\"code\":\"old\",\"display\":\"Old\"},{\"system\":\"http://hl7.org/fhir/name-use\",\"code\":\"maiden\",\"display\":\"Name changed for Marriage\"}]}}");

/***/ }),

/***/ "4ae1":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var getBuiltIn = __webpack_require__("d066");
var apply = __webpack_require__("2ba4");
var bind = __webpack_require__("0538");
var aConstructor = __webpack_require__("5087");
var anObject = __webpack_require__("825a");
var isObject = __webpack_require__("861d");
var create = __webpack_require__("7c73");
var fails = __webpack_require__("d039");

var nativeConstruct = getBuiltIn('Reflect', 'construct');
var ObjectPrototype = Object.prototype;
var push = [].push;

// `Reflect.construct` method
// https://tc39.es/ecma262/#sec-reflect.construct
// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails(function () {
  function F() { /* empty */ }
  return !(nativeConstruct(function () { /* empty */ }, [], F) instanceof F);
});

var ARGS_BUG = !fails(function () {
  nativeConstruct(function () { /* empty */ });
});

var FORCED = NEW_TARGET_BUG || ARGS_BUG;

$({ target: 'Reflect', stat: true, forced: FORCED, sham: FORCED }, {
  construct: function construct(Target, args /* , newTarget */) {
    aConstructor(Target);
    anObject(args);
    var newTarget = arguments.length < 3 ? Target : aConstructor(arguments[2]);
    if (ARGS_BUG && !NEW_TARGET_BUG) return nativeConstruct(Target, args, newTarget);
    if (Target == newTarget) {
      // w/o altered newTarget, optimization for 0-4 arguments
      switch (args.length) {
        case 0: return new Target();
        case 1: return new Target(args[0]);
        case 2: return new Target(args[0], args[1]);
        case 3: return new Target(args[0], args[1], args[2]);
        case 4: return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      apply(push, $args, args);
      return new (apply(bind, Target, $args))();
    }
    // with altered newTarget, not support built-in constructors
    var proto = newTarget.prototype;
    var instance = create(isObject(proto) ? proto : ObjectPrototype);
    var result = apply(Target, instance, args);
    return isObject(result) ? result : instance;
  }
});


/***/ }),

/***/ "4c53":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var createHTML = __webpack_require__("857a");
var forcedStringHTMLMethod = __webpack_require__("af03");

// `String.prototype.sub` method
// https://tc39.es/ecma262/#sec-string.prototype.sub
$({ target: 'String', proto: true, forced: forcedStringHTMLMethod('sub') }, {
  sub: function sub() {
    return createHTML(this, 'sub', '', '');
  }
});


/***/ }),

/***/ "4c60":
/***/ (function(module) {

module.exports = JSON.parse("{\"resourceType\":\"ValueSet\",\"status\":\"active\",\"compose\":{\"include\":[{\"system\":\"http://hl7.org/fhir/contact-point-use\"}]},\"expansion\":{\"identifier\":\"urn:uuid:2ecfdd41-340c-4005-940f-4df95a61b887\",\"timestamp\":\"2018-09-19T15:42:13+02:00\",\"total\":5,\"parameter\":[{\"name\":\"version\",\"valueUri\":\"http://hl7.org/fhir/contact-point-use|3.0.1\"}],\"contains\":[{\"system\":\"http://hl7.org/fhir/contact-point-use\",\"code\":\"home\",\"display\":\"Home\"},{\"system\":\"http://hl7.org/fhir/contact-point-use\",\"code\":\"work\",\"display\":\"Work\"},{\"system\":\"http://hl7.org/fhir/contact-point-use\",\"code\":\"temp\",\"display\":\"Temp\"},{\"system\":\"http://hl7.org/fhir/contact-point-use\",\"code\":\"old\",\"display\":\"Old\"},{\"system\":\"http://hl7.org/fhir/contact-point-use\",\"code\":\"mobile\",\"display\":\"Mobile\"}]}}");

/***/ }),

/***/ "4d63":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var global = __webpack_require__("da84");
var uncurryThis = __webpack_require__("e330");
var isForced = __webpack_require__("94ca");
var inheritIfRequired = __webpack_require__("7156");
var createNonEnumerableProperty = __webpack_require__("9112");
var getOwnPropertyNames = __webpack_require__("241c").f;
var isPrototypeOf = __webpack_require__("3a9b");
var isRegExp = __webpack_require__("44e7");
var toString = __webpack_require__("577e");
var getRegExpFlags = __webpack_require__("90d8");
var stickyHelpers = __webpack_require__("9f7f");
var proxyAccessor = __webpack_require__("aeb0");
var defineBuiltIn = __webpack_require__("cb2d");
var fails = __webpack_require__("d039");
var hasOwn = __webpack_require__("1a2d");
var enforceInternalState = __webpack_require__("69f3").enforce;
var setSpecies = __webpack_require__("2626");
var wellKnownSymbol = __webpack_require__("b622");
var UNSUPPORTED_DOT_ALL = __webpack_require__("fce3");
var UNSUPPORTED_NCG = __webpack_require__("107c");

var MATCH = wellKnownSymbol('match');
var NativeRegExp = global.RegExp;
var RegExpPrototype = NativeRegExp.prototype;
var SyntaxError = global.SyntaxError;
var exec = uncurryThis(RegExpPrototype.exec);
var charAt = uncurryThis(''.charAt);
var replace = uncurryThis(''.replace);
var stringIndexOf = uncurryThis(''.indexOf);
var stringSlice = uncurryThis(''.slice);
// TODO: Use only propper RegExpIdentifierName
var IS_NCG = /^\?<[^\s\d!#%&*+<=>@^][^\s!#%&*+<=>@^]*>/;
var re1 = /a/g;
var re2 = /a/g;

// "new" should create a new object, old webkit bug
var CORRECT_NEW = new NativeRegExp(re1) !== re1;

var MISSED_STICKY = stickyHelpers.MISSED_STICKY;
var UNSUPPORTED_Y = stickyHelpers.UNSUPPORTED_Y;

var BASE_FORCED = DESCRIPTORS &&
  (!CORRECT_NEW || MISSED_STICKY || UNSUPPORTED_DOT_ALL || UNSUPPORTED_NCG || fails(function () {
    re2[MATCH] = false;
    // RegExp constructor can alter flags and IsRegExp works correct with @@match
    return NativeRegExp(re1) != re1 || NativeRegExp(re2) == re2 || NativeRegExp(re1, 'i') != '/a/i';
  }));

var handleDotAll = function (string) {
  var length = string.length;
  var index = 0;
  var result = '';
  var brackets = false;
  var chr;
  for (; index <= length; index++) {
    chr = charAt(string, index);
    if (chr === '\\') {
      result += chr + charAt(string, ++index);
      continue;
    }
    if (!brackets && chr === '.') {
      result += '[\\s\\S]';
    } else {
      if (chr === '[') {
        brackets = true;
      } else if (chr === ']') {
        brackets = false;
      } result += chr;
    }
  } return result;
};

var handleNCG = function (string) {
  var length = string.length;
  var index = 0;
  var result = '';
  var named = [];
  var names = {};
  var brackets = false;
  var ncg = false;
  var groupid = 0;
  var groupname = '';
  var chr;
  for (; index <= length; index++) {
    chr = charAt(string, index);
    if (chr === '\\') {
      chr = chr + charAt(string, ++index);
    } else if (chr === ']') {
      brackets = false;
    } else if (!brackets) switch (true) {
      case chr === '[':
        brackets = true;
        break;
      case chr === '(':
        if (exec(IS_NCG, stringSlice(string, index + 1))) {
          index += 2;
          ncg = true;
        }
        result += chr;
        groupid++;
        continue;
      case chr === '>' && ncg:
        if (groupname === '' || hasOwn(names, groupname)) {
          throw new SyntaxError('Invalid capture group name');
        }
        names[groupname] = true;
        named[named.length] = [groupname, groupid];
        ncg = false;
        groupname = '';
        continue;
    }
    if (ncg) groupname += chr;
    else result += chr;
  } return [result, named];
};

// `RegExp` constructor
// https://tc39.es/ecma262/#sec-regexp-constructor
if (isForced('RegExp', BASE_FORCED)) {
  var RegExpWrapper = function RegExp(pattern, flags) {
    var thisIsRegExp = isPrototypeOf(RegExpPrototype, this);
    var patternIsRegExp = isRegExp(pattern);
    var flagsAreUndefined = flags === undefined;
    var groups = [];
    var rawPattern = pattern;
    var rawFlags, dotAll, sticky, handled, result, state;

    if (!thisIsRegExp && patternIsRegExp && flagsAreUndefined && pattern.constructor === RegExpWrapper) {
      return pattern;
    }

    if (patternIsRegExp || isPrototypeOf(RegExpPrototype, pattern)) {
      pattern = pattern.source;
      if (flagsAreUndefined) flags = getRegExpFlags(rawPattern);
    }

    pattern = pattern === undefined ? '' : toString(pattern);
    flags = flags === undefined ? '' : toString(flags);
    rawPattern = pattern;

    if (UNSUPPORTED_DOT_ALL && 'dotAll' in re1) {
      dotAll = !!flags && stringIndexOf(flags, 's') > -1;
      if (dotAll) flags = replace(flags, /s/g, '');
    }

    rawFlags = flags;

    if (MISSED_STICKY && 'sticky' in re1) {
      sticky = !!flags && stringIndexOf(flags, 'y') > -1;
      if (sticky && UNSUPPORTED_Y) flags = replace(flags, /y/g, '');
    }

    if (UNSUPPORTED_NCG) {
      handled = handleNCG(pattern);
      pattern = handled[0];
      groups = handled[1];
    }

    result = inheritIfRequired(NativeRegExp(pattern, flags), thisIsRegExp ? this : RegExpPrototype, RegExpWrapper);

    if (dotAll || sticky || groups.length) {
      state = enforceInternalState(result);
      if (dotAll) {
        state.dotAll = true;
        state.raw = RegExpWrapper(handleDotAll(pattern), rawFlags);
      }
      if (sticky) state.sticky = true;
      if (groups.length) state.groups = groups;
    }

    if (pattern !== rawPattern) try {
      // fails in old engines, but we have no alternatives for unsupported regex syntax
      createNonEnumerableProperty(result, 'source', rawPattern === '' ? '(?:)' : rawPattern);
    } catch (error) { /* empty */ }

    return result;
  };

  for (var keys = getOwnPropertyNames(NativeRegExp), index = 0; keys.length > index;) {
    proxyAccessor(RegExpWrapper, NativeRegExp, keys[index++]);
  }

  RegExpPrototype.constructor = RegExpWrapper;
  RegExpWrapper.prototype = RegExpPrototype;
  defineBuiltIn(global, 'RegExp', RegExpWrapper);
}

// https://tc39.es/ecma262/#sec-get-regexp-@@species
setSpecies('RegExp');


/***/ }),

/***/ "4d64":
/***/ (function(module, exports, __webpack_require__) {

var toIndexedObject = __webpack_require__("fc6a");
var toAbsoluteIndex = __webpack_require__("23cb");
var lengthOfArrayLike = __webpack_require__("07fa");

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject($this);
    var length = lengthOfArrayLike(O);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

module.exports = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};


/***/ }),

/***/ "4d72":
/***/ (function(module, exports) {

module.exports = require("moment-timezone");

/***/ }),

/***/ "4dae":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var toAbsoluteIndex = __webpack_require__("23cb");
var lengthOfArrayLike = __webpack_require__("07fa");
var createProperty = __webpack_require__("8418");

var Array = global.Array;
var max = Math.max;

module.exports = function (O, start, end) {
  var length = lengthOfArrayLike(O);
  var k = toAbsoluteIndex(start, length);
  var fin = toAbsoluteIndex(end === undefined ? length : end, length);
  var result = Array(max(fin - k, 0));
  for (var n = 0; k < fin; k++, n++) createProperty(result, n, O[k]);
  result.length = n;
  return result;
};


/***/ }),

/***/ "4de4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var $filter = __webpack_require__("b727").filter;
var arrayMethodHasSpeciesSupport = __webpack_require__("1dde");

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('filter');

// `Array.prototype.filter` method
// https://tc39.es/ecma262/#sec-array.prototype.filter
// with adding support of @@species
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ "4df4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__("da84");
var bind = __webpack_require__("0366");
var call = __webpack_require__("c65b");
var toObject = __webpack_require__("7b0b");
var callWithSafeIterationClosing = __webpack_require__("9bdd");
var isArrayIteratorMethod = __webpack_require__("e95a");
var isConstructor = __webpack_require__("68ee");
var lengthOfArrayLike = __webpack_require__("07fa");
var createProperty = __webpack_require__("8418");
var getIterator = __webpack_require__("9a1f");
var getIteratorMethod = __webpack_require__("35a1");

var Array = global.Array;

// `Array.from` method implementation
// https://tc39.es/ecma262/#sec-array.from
module.exports = function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
  var O = toObject(arrayLike);
  var IS_CONSTRUCTOR = isConstructor(this);
  var argumentsLength = arguments.length;
  var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
  var mapping = mapfn !== undefined;
  if (mapping) mapfn = bind(mapfn, argumentsLength > 2 ? arguments[2] : undefined);
  var iteratorMethod = getIteratorMethod(O);
  var index = 0;
  var length, result, step, iterator, next, value;
  // if the target is not iterable or it's an array with the default iterator - use a simple case
  if (iteratorMethod && !(this == Array && isArrayIteratorMethod(iteratorMethod))) {
    iterator = getIterator(O, iteratorMethod);
    next = iterator.next;
    result = IS_CONSTRUCTOR ? new this() : [];
    for (;!(step = call(next, iterator)).done; index++) {
      value = mapping ? callWithSafeIterationClosing(iterator, mapfn, [step.value, index], true) : step.value;
      createProperty(result, index, value);
    }
  } else {
    length = lengthOfArrayLike(O);
    result = IS_CONSTRUCTOR ? new this(length) : Array(length);
    for (;length > index; index++) {
      value = mapping ? mapfn(O[index], index) : O[index];
      createProperty(result, index, value);
    }
  }
  result.length = index;
  return result;
};


/***/ }),

/***/ "4e82":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var uncurryThis = __webpack_require__("e330");
var aCallable = __webpack_require__("59ed");
var toObject = __webpack_require__("7b0b");
var lengthOfArrayLike = __webpack_require__("07fa");
var toString = __webpack_require__("577e");
var fails = __webpack_require__("d039");
var internalSort = __webpack_require__("addb");
var arrayMethodIsStrict = __webpack_require__("a640");
var FF = __webpack_require__("04d1");
var IE_OR_EDGE = __webpack_require__("d998");
var V8 = __webpack_require__("2d00");
var WEBKIT = __webpack_require__("512c");

var test = [];
var un$Sort = uncurryThis(test.sort);
var push = uncurryThis(test.push);

// IE8-
var FAILS_ON_UNDEFINED = fails(function () {
  test.sort(undefined);
});
// V8 bug
var FAILS_ON_NULL = fails(function () {
  test.sort(null);
});
// Old WebKit
var STRICT_METHOD = arrayMethodIsStrict('sort');

var STABLE_SORT = !fails(function () {
  // feature detection can be too slow, so check engines versions
  if (V8) return V8 < 70;
  if (FF && FF > 3) return;
  if (IE_OR_EDGE) return true;
  if (WEBKIT) return WEBKIT < 603;

  var result = '';
  var code, chr, value, index;

  // generate an array with more 512 elements (Chakra and old V8 fails only in this case)
  for (code = 65; code < 76; code++) {
    chr = String.fromCharCode(code);

    switch (code) {
      case 66: case 69: case 70: case 72: value = 3; break;
      case 68: case 71: value = 4; break;
      default: value = 2;
    }

    for (index = 0; index < 47; index++) {
      test.push({ k: chr + index, v: value });
    }
  }

  test.sort(function (a, b) { return b.v - a.v; });

  for (index = 0; index < test.length; index++) {
    chr = test[index].k.charAt(0);
    if (result.charAt(result.length - 1) !== chr) result += chr;
  }

  return result !== 'DGBEFHACIJK';
});

var FORCED = FAILS_ON_UNDEFINED || !FAILS_ON_NULL || !STRICT_METHOD || !STABLE_SORT;

var getSortCompare = function (comparefn) {
  return function (x, y) {
    if (y === undefined) return -1;
    if (x === undefined) return 1;
    if (comparefn !== undefined) return +comparefn(x, y) || 0;
    return toString(x) > toString(y) ? 1 : -1;
  };
};

// `Array.prototype.sort` method
// https://tc39.es/ecma262/#sec-array.prototype.sort
$({ target: 'Array', proto: true, forced: FORCED }, {
  sort: function sort(comparefn) {
    if (comparefn !== undefined) aCallable(comparefn);

    var array = toObject(this);

    if (STABLE_SORT) return comparefn === undefined ? un$Sort(array) : un$Sort(array, comparefn);

    var items = [];
    var arrayLength = lengthOfArrayLike(array);
    var itemsLength, index;

    for (index = 0; index < arrayLength; index++) {
      if (index in array) push(items, array[index]);
    }

    internalSort(items, getSortCompare(comparefn));

    itemsLength = items.length;
    index = 0;

    while (index < itemsLength) array[index] = items[index++];
    while (index < arrayLength) delete array[index++];

    return array;
  }
});


/***/ }),

/***/ "4fad":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");
var isObject = __webpack_require__("861d");
var classof = __webpack_require__("c6b6");
var ARRAY_BUFFER_NON_EXTENSIBLE = __webpack_require__("d86b");

// eslint-disable-next-line es-x/no-object-isextensible -- safe
var $isExtensible = Object.isExtensible;
var FAILS_ON_PRIMITIVES = fails(function () { $isExtensible(1); });

// `Object.isExtensible` method
// https://tc39.es/ecma262/#sec-object.isextensible
module.exports = (FAILS_ON_PRIMITIVES || ARRAY_BUFFER_NON_EXTENSIBLE) ? function isExtensible(it) {
  if (!isObject(it)) return false;
  if (ARRAY_BUFFER_NON_EXTENSIBLE && classof(it) == 'ArrayBuffer') return false;
  return $isExtensible ? $isExtensible(it) : true;
} : $isExtensible;


/***/ }),

/***/ "5087":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var isConstructor = __webpack_require__("68ee");
var tryToString = __webpack_require__("0d51");

var TypeError = global.TypeError;

// `Assert: IsConstructor(argument) is true`
module.exports = function (argument) {
  if (isConstructor(argument)) return argument;
  throw TypeError(tryToString(argument) + ' is not a constructor');
};


/***/ }),

/***/ "50c4":
/***/ (function(module, exports, __webpack_require__) {

var toIntegerOrInfinity = __webpack_require__("5926");

var min = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
module.exports = function (argument) {
  return argument > 0 ? min(toIntegerOrInfinity(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


/***/ }),

/***/ "512c":
/***/ (function(module, exports, __webpack_require__) {

var userAgent = __webpack_require__("342f");

var webkit = userAgent.match(/AppleWebKit\/(\d+)\./);

module.exports = !!webkit && +webkit[1];


/***/ }),

/***/ "5319":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var apply = __webpack_require__("2ba4");
var call = __webpack_require__("c65b");
var uncurryThis = __webpack_require__("e330");
var fixRegExpWellKnownSymbolLogic = __webpack_require__("d784");
var fails = __webpack_require__("d039");
var anObject = __webpack_require__("825a");
var isCallable = __webpack_require__("1626");
var toIntegerOrInfinity = __webpack_require__("5926");
var toLength = __webpack_require__("50c4");
var toString = __webpack_require__("577e");
var requireObjectCoercible = __webpack_require__("1d80");
var advanceStringIndex = __webpack_require__("8aa5");
var getMethod = __webpack_require__("dc4a");
var getSubstitution = __webpack_require__("0cb2");
var regExpExec = __webpack_require__("14c3");
var wellKnownSymbol = __webpack_require__("b622");

var REPLACE = wellKnownSymbol('replace');
var max = Math.max;
var min = Math.min;
var concat = uncurryThis([].concat);
var push = uncurryThis([].push);
var stringIndexOf = uncurryThis(''.indexOf);
var stringSlice = uncurryThis(''.slice);

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// IE <= 11 replaces $0 with the whole match, as if it was $&
// https://stackoverflow.com/questions/6024666/getting-ie-to-replace-a-regex-with-the-literal-string-0
var REPLACE_KEEPS_$0 = (function () {
  // eslint-disable-next-line regexp/prefer-escape-replacement-dollar-char -- required for testing
  return 'a'.replace(/./, '$0') === '$0';
})();

// Safari <= 13.0.3(?) substitutes nth capture where n>m with an empty string
var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = (function () {
  if (/./[REPLACE]) {
    return /./[REPLACE]('a', '$0') === '';
  }
  return false;
})();

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  // eslint-disable-next-line regexp/no-useless-dollar-replacements -- false positive
  return ''.replace(re, '$<a>') !== '7';
});

// @@replace logic
fixRegExpWellKnownSymbolLogic('replace', function (_, nativeReplace, maybeCallNative) {
  var UNSAFE_SUBSTITUTE = REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE ? '$' : '$0';

  return [
    // `String.prototype.replace` method
    // https://tc39.es/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = requireObjectCoercible(this);
      var replacer = searchValue == undefined ? undefined : getMethod(searchValue, REPLACE);
      return replacer
        ? call(replacer, searchValue, O, replaceValue)
        : call(nativeReplace, toString(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@replace
    function (string, replaceValue) {
      var rx = anObject(this);
      var S = toString(string);

      if (
        typeof replaceValue == 'string' &&
        stringIndexOf(replaceValue, UNSAFE_SUBSTITUTE) === -1 &&
        stringIndexOf(replaceValue, '$<') === -1
      ) {
        var res = maybeCallNative(nativeReplace, rx, S, replaceValue);
        if (res.done) return res.value;
      }

      var functionalReplace = isCallable(replaceValue);
      if (!functionalReplace) replaceValue = toString(replaceValue);

      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regExpExec(rx, S);
        if (result === null) break;

        push(results, result);
        if (!global) break;

        var matchStr = toString(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }

      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];

        var matched = toString(result[0]);
        var position = max(min(toIntegerOrInfinity(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) push(captures, maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = concat([matched], captures, position, S);
          if (namedCaptures !== undefined) push(replacerArgs, namedCaptures);
          var replacement = toString(apply(replaceValue, undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += stringSlice(S, nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + stringSlice(S, nextSourcePosition);
    }
  ];
}, !REPLACE_SUPPORTS_NAMED_GROUPS || !REPLACE_KEEPS_$0 || REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE);


/***/ }),

/***/ "5352":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// TODO: in core-js@4, move /modules/ dependencies to public entries for better optimization by tools like `preset-env`
__webpack_require__("e260");
var $ = __webpack_require__("23e7");
var global = __webpack_require__("da84");
var call = __webpack_require__("c65b");
var uncurryThis = __webpack_require__("e330");
var DESCRIPTORS = __webpack_require__("83ab");
var USE_NATIVE_URL = __webpack_require__("0d3b");
var defineBuiltIn = __webpack_require__("cb2d");
var defineBuiltIns = __webpack_require__("6964");
var setToStringTag = __webpack_require__("d44e");
var createIteratorConstructor = __webpack_require__("9ed3");
var InternalStateModule = __webpack_require__("69f3");
var anInstance = __webpack_require__("19aa");
var isCallable = __webpack_require__("1626");
var hasOwn = __webpack_require__("1a2d");
var bind = __webpack_require__("0366");
var classof = __webpack_require__("f5df");
var anObject = __webpack_require__("825a");
var isObject = __webpack_require__("861d");
var $toString = __webpack_require__("577e");
var create = __webpack_require__("7c73");
var createPropertyDescriptor = __webpack_require__("5c6c");
var getIterator = __webpack_require__("9a1f");
var getIteratorMethod = __webpack_require__("35a1");
var validateArgumentsLength = __webpack_require__("d6d6");
var wellKnownSymbol = __webpack_require__("b622");
var arraySort = __webpack_require__("addb");

var ITERATOR = wellKnownSymbol('iterator');
var URL_SEARCH_PARAMS = 'URLSearchParams';
var URL_SEARCH_PARAMS_ITERATOR = URL_SEARCH_PARAMS + 'Iterator';
var setInternalState = InternalStateModule.set;
var getInternalParamsState = InternalStateModule.getterFor(URL_SEARCH_PARAMS);
var getInternalIteratorState = InternalStateModule.getterFor(URL_SEARCH_PARAMS_ITERATOR);
// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Avoid NodeJS experimental warning
var safeGetBuiltIn = function (name) {
  if (!DESCRIPTORS) return global[name];
  var descriptor = getOwnPropertyDescriptor(global, name);
  return descriptor && descriptor.value;
};

var nativeFetch = safeGetBuiltIn('fetch');
var NativeRequest = safeGetBuiltIn('Request');
var Headers = safeGetBuiltIn('Headers');
var RequestPrototype = NativeRequest && NativeRequest.prototype;
var HeadersPrototype = Headers && Headers.prototype;
var RegExp = global.RegExp;
var TypeError = global.TypeError;
var decodeURIComponent = global.decodeURIComponent;
var encodeURIComponent = global.encodeURIComponent;
var charAt = uncurryThis(''.charAt);
var join = uncurryThis([].join);
var push = uncurryThis([].push);
var replace = uncurryThis(''.replace);
var shift = uncurryThis([].shift);
var splice = uncurryThis([].splice);
var split = uncurryThis(''.split);
var stringSlice = uncurryThis(''.slice);

var plus = /\+/g;
var sequences = Array(4);

var percentSequence = function (bytes) {
  return sequences[bytes - 1] || (sequences[bytes - 1] = RegExp('((?:%[\\da-f]{2}){' + bytes + '})', 'gi'));
};

var percentDecode = function (sequence) {
  try {
    return decodeURIComponent(sequence);
  } catch (error) {
    return sequence;
  }
};

var deserialize = function (it) {
  var result = replace(it, plus, ' ');
  var bytes = 4;
  try {
    return decodeURIComponent(result);
  } catch (error) {
    while (bytes) {
      result = replace(result, percentSequence(bytes--), percentDecode);
    }
    return result;
  }
};

var find = /[!'()~]|%20/g;

var replacements = {
  '!': '%21',
  "'": '%27',
  '(': '%28',
  ')': '%29',
  '~': '%7E',
  '%20': '+'
};

var replacer = function (match) {
  return replacements[match];
};

var serialize = function (it) {
  return replace(encodeURIComponent(it), find, replacer);
};

var URLSearchParamsIterator = createIteratorConstructor(function Iterator(params, kind) {
  setInternalState(this, {
    type: URL_SEARCH_PARAMS_ITERATOR,
    iterator: getIterator(getInternalParamsState(params).entries),
    kind: kind
  });
}, 'Iterator', function next() {
  var state = getInternalIteratorState(this);
  var kind = state.kind;
  var step = state.iterator.next();
  var entry = step.value;
  if (!step.done) {
    step.value = kind === 'keys' ? entry.key : kind === 'values' ? entry.value : [entry.key, entry.value];
  } return step;
}, true);

var URLSearchParamsState = function (init) {
  this.entries = [];
  this.url = null;

  if (init !== undefined) {
    if (isObject(init)) this.parseObject(init);
    else this.parseQuery(typeof init == 'string' ? charAt(init, 0) === '?' ? stringSlice(init, 1) : init : $toString(init));
  }
};

URLSearchParamsState.prototype = {
  type: URL_SEARCH_PARAMS,
  bindURL: function (url) {
    this.url = url;
    this.update();
  },
  parseObject: function (object) {
    var iteratorMethod = getIteratorMethod(object);
    var iterator, next, step, entryIterator, entryNext, first, second;

    if (iteratorMethod) {
      iterator = getIterator(object, iteratorMethod);
      next = iterator.next;
      while (!(step = call(next, iterator)).done) {
        entryIterator = getIterator(anObject(step.value));
        entryNext = entryIterator.next;
        if (
          (first = call(entryNext, entryIterator)).done ||
          (second = call(entryNext, entryIterator)).done ||
          !call(entryNext, entryIterator).done
        ) throw TypeError('Expected sequence with length 2');
        push(this.entries, { key: $toString(first.value), value: $toString(second.value) });
      }
    } else for (var key in object) if (hasOwn(object, key)) {
      push(this.entries, { key: key, value: $toString(object[key]) });
    }
  },
  parseQuery: function (query) {
    if (query) {
      var attributes = split(query, '&');
      var index = 0;
      var attribute, entry;
      while (index < attributes.length) {
        attribute = attributes[index++];
        if (attribute.length) {
          entry = split(attribute, '=');
          push(this.entries, {
            key: deserialize(shift(entry)),
            value: deserialize(join(entry, '='))
          });
        }
      }
    }
  },
  serialize: function () {
    var entries = this.entries;
    var result = [];
    var index = 0;
    var entry;
    while (index < entries.length) {
      entry = entries[index++];
      push(result, serialize(entry.key) + '=' + serialize(entry.value));
    } return join(result, '&');
  },
  update: function () {
    this.entries.length = 0;
    this.parseQuery(this.url.query);
  },
  updateURL: function () {
    if (this.url) this.url.update();
  }
};

// `URLSearchParams` constructor
// https://url.spec.whatwg.org/#interface-urlsearchparams
var URLSearchParamsConstructor = function URLSearchParams(/* init */) {
  anInstance(this, URLSearchParamsPrototype);
  var init = arguments.length > 0 ? arguments[0] : undefined;
  setInternalState(this, new URLSearchParamsState(init));
};

var URLSearchParamsPrototype = URLSearchParamsConstructor.prototype;

defineBuiltIns(URLSearchParamsPrototype, {
  // `URLSearchParams.prototype.append` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-append
  append: function append(name, value) {
    validateArgumentsLength(arguments.length, 2);
    var state = getInternalParamsState(this);
    push(state.entries, { key: $toString(name), value: $toString(value) });
    state.updateURL();
  },
  // `URLSearchParams.prototype.delete` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-delete
  'delete': function (name) {
    validateArgumentsLength(arguments.length, 1);
    var state = getInternalParamsState(this);
    var entries = state.entries;
    var key = $toString(name);
    var index = 0;
    while (index < entries.length) {
      if (entries[index].key === key) splice(entries, index, 1);
      else index++;
    }
    state.updateURL();
  },
  // `URLSearchParams.prototype.get` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-get
  get: function get(name) {
    validateArgumentsLength(arguments.length, 1);
    var entries = getInternalParamsState(this).entries;
    var key = $toString(name);
    var index = 0;
    for (; index < entries.length; index++) {
      if (entries[index].key === key) return entries[index].value;
    }
    return null;
  },
  // `URLSearchParams.prototype.getAll` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-getall
  getAll: function getAll(name) {
    validateArgumentsLength(arguments.length, 1);
    var entries = getInternalParamsState(this).entries;
    var key = $toString(name);
    var result = [];
    var index = 0;
    for (; index < entries.length; index++) {
      if (entries[index].key === key) push(result, entries[index].value);
    }
    return result;
  },
  // `URLSearchParams.prototype.has` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-has
  has: function has(name) {
    validateArgumentsLength(arguments.length, 1);
    var entries = getInternalParamsState(this).entries;
    var key = $toString(name);
    var index = 0;
    while (index < entries.length) {
      if (entries[index++].key === key) return true;
    }
    return false;
  },
  // `URLSearchParams.prototype.set` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-set
  set: function set(name, value) {
    validateArgumentsLength(arguments.length, 1);
    var state = getInternalParamsState(this);
    var entries = state.entries;
    var found = false;
    var key = $toString(name);
    var val = $toString(value);
    var index = 0;
    var entry;
    for (; index < entries.length; index++) {
      entry = entries[index];
      if (entry.key === key) {
        if (found) splice(entries, index--, 1);
        else {
          found = true;
          entry.value = val;
        }
      }
    }
    if (!found) push(entries, { key: key, value: val });
    state.updateURL();
  },
  // `URLSearchParams.prototype.sort` method
  // https://url.spec.whatwg.org/#dom-urlsearchparams-sort
  sort: function sort() {
    var state = getInternalParamsState(this);
    arraySort(state.entries, function (a, b) {
      return a.key > b.key ? 1 : -1;
    });
    state.updateURL();
  },
  // `URLSearchParams.prototype.forEach` method
  forEach: function forEach(callback /* , thisArg */) {
    var entries = getInternalParamsState(this).entries;
    var boundFunction = bind(callback, arguments.length > 1 ? arguments[1] : undefined);
    var index = 0;
    var entry;
    while (index < entries.length) {
      entry = entries[index++];
      boundFunction(entry.value, entry.key, this);
    }
  },
  // `URLSearchParams.prototype.keys` method
  keys: function keys() {
    return new URLSearchParamsIterator(this, 'keys');
  },
  // `URLSearchParams.prototype.values` method
  values: function values() {
    return new URLSearchParamsIterator(this, 'values');
  },
  // `URLSearchParams.prototype.entries` method
  entries: function entries() {
    return new URLSearchParamsIterator(this, 'entries');
  }
}, { enumerable: true });

// `URLSearchParams.prototype[@@iterator]` method
defineBuiltIn(URLSearchParamsPrototype, ITERATOR, URLSearchParamsPrototype.entries, { name: 'entries' });

// `URLSearchParams.prototype.toString` method
// https://url.spec.whatwg.org/#urlsearchparams-stringification-behavior
defineBuiltIn(URLSearchParamsPrototype, 'toString', function toString() {
  return getInternalParamsState(this).serialize();
}, { enumerable: true });

setToStringTag(URLSearchParamsConstructor, URL_SEARCH_PARAMS);

$({ global: true, forced: !USE_NATIVE_URL }, {
  URLSearchParams: URLSearchParamsConstructor
});

// Wrap `fetch` and `Request` for correct work with polyfilled `URLSearchParams`
if (!USE_NATIVE_URL && isCallable(Headers)) {
  var headersHas = uncurryThis(HeadersPrototype.has);
  var headersSet = uncurryThis(HeadersPrototype.set);

  var wrapRequestOptions = function (init) {
    if (isObject(init)) {
      var body = init.body;
      var headers;
      if (classof(body) === URL_SEARCH_PARAMS) {
        headers = init.headers ? new Headers(init.headers) : new Headers();
        if (!headersHas(headers, 'content-type')) {
          headersSet(headers, 'content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
        }
        return create(init, {
          body: createPropertyDescriptor(0, $toString(body)),
          headers: createPropertyDescriptor(0, headers)
        });
      }
    } return init;
  };

  if (isCallable(nativeFetch)) {
    $({ global: true, enumerable: true, noTargetGet: true, forced: true }, {
      fetch: function fetch(input /* , init */) {
        return nativeFetch(input, arguments.length > 1 ? wrapRequestOptions(arguments[1]) : {});
      }
    });
  }

  if (isCallable(NativeRequest)) {
    var RequestConstructor = function Request(input /* , init */) {
      anInstance(this, RequestPrototype);
      return new NativeRequest(input, arguments.length > 1 ? wrapRequestOptions(arguments[1]) : {});
    };

    RequestPrototype.constructor = RequestConstructor;
    RequestConstructor.prototype = RequestPrototype;

    $({ global: true, forced: true, noTargetGet: true }, {
      Request: RequestConstructor
    });
  }
}

module.exports = {
  URLSearchParams: URLSearchParamsConstructor,
  getState: getInternalParamsState
};


/***/ }),

/***/ "5692":
/***/ (function(module, exports, __webpack_require__) {

var IS_PURE = __webpack_require__("c430");
var store = __webpack_require__("c6cd");

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.22.4',
  mode: IS_PURE ? 'pure' : 'global',
  copyright: '© 2014-2022 Denis Pushkarev (zloirock.ru)',
  license: 'https://github.com/zloirock/core-js/blob/v3.22.4/LICENSE',
  source: 'https://github.com/zloirock/core-js'
});


/***/ }),

/***/ "56ef":
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__("d066");
var uncurryThis = __webpack_require__("e330");
var getOwnPropertyNamesModule = __webpack_require__("241c");
var getOwnPropertySymbolsModule = __webpack_require__("7418");
var anObject = __webpack_require__("825a");

var concat = uncurryThis([].concat);

// all object keys, includes non-enumerable and symbols
module.exports = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  return getOwnPropertySymbols ? concat(keys, getOwnPropertySymbols(it)) : keys;
};


/***/ }),

/***/ "577e":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var classof = __webpack_require__("f5df");

var String = global.String;

module.exports = function (argument) {
  if (classof(argument) === 'Symbol') throw TypeError('Cannot convert a Symbol value to a string');
  return String(argument);
};


/***/ }),

/***/ "57b9":
/***/ (function(module, exports, __webpack_require__) {

var call = __webpack_require__("c65b");
var getBuiltIn = __webpack_require__("d066");
var wellKnownSymbol = __webpack_require__("b622");
var defineBuiltIn = __webpack_require__("cb2d");

module.exports = function () {
  var Symbol = getBuiltIn('Symbol');
  var SymbolPrototype = Symbol && Symbol.prototype;
  var valueOf = SymbolPrototype && SymbolPrototype.valueOf;
  var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');

  if (SymbolPrototype && !SymbolPrototype[TO_PRIMITIVE]) {
    // `Symbol.prototype[@@toPrimitive]` method
    // https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
    // eslint-disable-next-line no-unused-vars -- required for .length
    defineBuiltIn(SymbolPrototype, TO_PRIMITIVE, function (hint) {
      return call(valueOf, this);
    }, { arity: 1 });
  }
};


/***/ }),

/***/ "5899":
/***/ (function(module, exports) {

// a string of all valid unicode whitespaces
module.exports = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u2000\u2001\u2002' +
  '\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),

/***/ "58a8":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("e330");
var requireObjectCoercible = __webpack_require__("1d80");
var toString = __webpack_require__("577e");
var whitespaces = __webpack_require__("5899");

var replace = uncurryThis(''.replace);
var whitespace = '[' + whitespaces + ']';
var ltrim = RegExp('^' + whitespace + whitespace + '*');
var rtrim = RegExp(whitespace + whitespace + '*$');

// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
var createMethod = function (TYPE) {
  return function ($this) {
    var string = toString(requireObjectCoercible($this));
    if (TYPE & 1) string = replace(string, ltrim, '');
    if (TYPE & 2) string = replace(string, rtrim, '');
    return string;
  };
};

module.exports = {
  // `String.prototype.{ trimLeft, trimStart }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimstart
  start: createMethod(1),
  // `String.prototype.{ trimRight, trimEnd }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimend
  end: createMethod(2),
  // `String.prototype.trim` method
  // https://tc39.es/ecma262/#sec-string.prototype.trim
  trim: createMethod(3)
};


/***/ }),

/***/ "58ed":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "5926":
/***/ (function(module, exports) {

var ceil = Math.ceil;
var floor = Math.floor;

// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
module.exports = function (argument) {
  var number = +argument;
  // eslint-disable-next-line no-self-compare -- safe
  return number !== number || number === 0 ? 0 : (number > 0 ? floor : ceil)(number);
};


/***/ }),

/***/ "59ed":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var isCallable = __webpack_require__("1626");
var tryToString = __webpack_require__("0d51");

var TypeError = global.TypeError;

// `Assert: IsCallable(argument) is true`
module.exports = function (argument) {
  if (isCallable(argument)) return argument;
  throw TypeError(tryToString(argument) + ' is not a function');
};


/***/ }),

/***/ "5a34":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var isRegExp = __webpack_require__("44e7");

var TypeError = global.TypeError;

module.exports = function (it) {
  if (isRegExp(it)) {
    throw TypeError("The method doesn't accept regular expressions");
  } return it;
};


/***/ }),

/***/ "5a47":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var NATIVE_SYMBOL = __webpack_require__("4930");
var fails = __webpack_require__("d039");
var getOwnPropertySymbolsModule = __webpack_require__("7418");
var toObject = __webpack_require__("7b0b");

// V8 ~ Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FORCED = !NATIVE_SYMBOL || fails(function () { getOwnPropertySymbolsModule.f(1); });

// `Object.getOwnPropertySymbols` method
// https://tc39.es/ecma262/#sec-object.getownpropertysymbols
$({ target: 'Object', stat: true, forced: FORCED }, {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    var $getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
    return $getOwnPropertySymbols ? $getOwnPropertySymbols(toObject(it)) : [];
  }
});


/***/ }),

/***/ "5c6c":
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ "5d38":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_GeneticReport_vue_vue_type_style_index_0_id_3c67fb3e_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("0383");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_GeneticReport_vue_vue_type_style_index_0_id_3c67fb3e_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_GeneticReport_vue_vue_type_style_index_0_id_3c67fb3e_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "5d41":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var call = __webpack_require__("c65b");
var isObject = __webpack_require__("861d");
var anObject = __webpack_require__("825a");
var isDataDescriptor = __webpack_require__("c60d");
var getOwnPropertyDescriptorModule = __webpack_require__("06cf");
var getPrototypeOf = __webpack_require__("e163");

// `Reflect.get` method
// https://tc39.es/ecma262/#sec-reflect.get
function get(target, propertyKey /* , receiver */) {
  var receiver = arguments.length < 3 ? target : arguments[2];
  var descriptor, prototype;
  if (anObject(target) === receiver) return target[propertyKey];
  descriptor = getOwnPropertyDescriptorModule.f(target, propertyKey);
  if (descriptor) return isDataDescriptor(descriptor)
    ? descriptor.value
    : descriptor.get === undefined ? undefined : call(descriptor.get, receiver);
  if (isObject(prototype = getPrototypeOf(target))) return get(prototype, propertyKey, receiver);
}

$({ target: 'Reflect', stat: true }, {
  get: get
});


/***/ }),

/***/ "5e4d":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "5e77":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var hasOwn = __webpack_require__("1a2d");

var FunctionPrototype = Function.prototype;
// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var getDescriptor = DESCRIPTORS && Object.getOwnPropertyDescriptor;

var EXISTS = hasOwn(FunctionPrototype, 'name');
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS && (function something() { /* empty */ }).name === 'something';
var CONFIGURABLE = EXISTS && (!DESCRIPTORS || (DESCRIPTORS && getDescriptor(FunctionPrototype, 'name').configurable));

module.exports = {
  EXISTS: EXISTS,
  PROPER: PROPER,
  CONFIGURABLE: CONFIGURABLE
};


/***/ }),

/***/ "5e7e":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var IS_PURE = __webpack_require__("c430");
var IS_NODE = __webpack_require__("605d");
var global = __webpack_require__("da84");
var call = __webpack_require__("c65b");
var defineBuiltIn = __webpack_require__("cb2d");
var setPrototypeOf = __webpack_require__("d2bb");
var setToStringTag = __webpack_require__("d44e");
var setSpecies = __webpack_require__("2626");
var aCallable = __webpack_require__("59ed");
var isCallable = __webpack_require__("1626");
var isObject = __webpack_require__("861d");
var anInstance = __webpack_require__("19aa");
var speciesConstructor = __webpack_require__("4840");
var task = __webpack_require__("2cf4").set;
var microtask = __webpack_require__("b575");
var hostReportErrors = __webpack_require__("44de");
var perform = __webpack_require__("e667");
var Queue = __webpack_require__("01b4");
var InternalStateModule = __webpack_require__("69f3");
var NativePromiseConstructor = __webpack_require__("d256");
var PromiseConstructorDetection = __webpack_require__("4738");
var newPromiseCapabilityModule = __webpack_require__("f069");

var PROMISE = 'Promise';
var FORCED_PROMISE_CONSTRUCTOR = PromiseConstructorDetection.CONSTRUCTOR;
var NATIVE_PROMISE_REJECTION_EVENT = PromiseConstructorDetection.REJECTION_EVENT;
var NATIVE_PROMISE_SUBCLASSING = PromiseConstructorDetection.SUBCLASSING;
var getInternalPromiseState = InternalStateModule.getterFor(PROMISE);
var setInternalState = InternalStateModule.set;
var NativePromisePrototype = NativePromiseConstructor && NativePromiseConstructor.prototype;
var PromiseConstructor = NativePromiseConstructor;
var PromisePrototype = NativePromisePrototype;
var TypeError = global.TypeError;
var document = global.document;
var process = global.process;
var newPromiseCapability = newPromiseCapabilityModule.f;
var newGenericPromiseCapability = newPromiseCapability;

var DISPATCH_EVENT = !!(document && document.createEvent && global.dispatchEvent);
var UNHANDLED_REJECTION = 'unhandledrejection';
var REJECTION_HANDLED = 'rejectionhandled';
var PENDING = 0;
var FULFILLED = 1;
var REJECTED = 2;
var HANDLED = 1;
var UNHANDLED = 2;

var Internal, OwnPromiseCapability, PromiseWrapper, nativeThen;

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && isCallable(then = it.then) ? then : false;
};

var callReaction = function (reaction, state) {
  var value = state.value;
  var ok = state.state == FULFILLED;
  var handler = ok ? reaction.ok : reaction.fail;
  var resolve = reaction.resolve;
  var reject = reaction.reject;
  var domain = reaction.domain;
  var result, then, exited;
  try {
    if (handler) {
      if (!ok) {
        if (state.rejection === UNHANDLED) onHandleUnhandled(state);
        state.rejection = HANDLED;
      }
      if (handler === true) result = value;
      else {
        if (domain) domain.enter();
        result = handler(value); // can throw
        if (domain) {
          domain.exit();
          exited = true;
        }
      }
      if (result === reaction.promise) {
        reject(TypeError('Promise-chain cycle'));
      } else if (then = isThenable(result)) {
        call(then, result, resolve, reject);
      } else resolve(result);
    } else reject(value);
  } catch (error) {
    if (domain && !exited) domain.exit();
    reject(error);
  }
};

var notify = function (state, isReject) {
  if (state.notified) return;
  state.notified = true;
  microtask(function () {
    var reactions = state.reactions;
    var reaction;
    while (reaction = reactions.get()) {
      callReaction(reaction, state);
    }
    state.notified = false;
    if (isReject && !state.rejection) onUnhandled(state);
  });
};

var dispatchEvent = function (name, promise, reason) {
  var event, handler;
  if (DISPATCH_EVENT) {
    event = document.createEvent('Event');
    event.promise = promise;
    event.reason = reason;
    event.initEvent(name, false, true);
    global.dispatchEvent(event);
  } else event = { promise: promise, reason: reason };
  if (!NATIVE_PROMISE_REJECTION_EVENT && (handler = global['on' + name])) handler(event);
  else if (name === UNHANDLED_REJECTION) hostReportErrors('Unhandled promise rejection', reason);
};

var onUnhandled = function (state) {
  call(task, global, function () {
    var promise = state.facade;
    var value = state.value;
    var IS_UNHANDLED = isUnhandled(state);
    var result;
    if (IS_UNHANDLED) {
      result = perform(function () {
        if (IS_NODE) {
          process.emit('unhandledRejection', value, promise);
        } else dispatchEvent(UNHANDLED_REJECTION, promise, value);
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      state.rejection = IS_NODE || isUnhandled(state) ? UNHANDLED : HANDLED;
      if (result.error) throw result.value;
    }
  });
};

var isUnhandled = function (state) {
  return state.rejection !== HANDLED && !state.parent;
};

var onHandleUnhandled = function (state) {
  call(task, global, function () {
    var promise = state.facade;
    if (IS_NODE) {
      process.emit('rejectionHandled', promise);
    } else dispatchEvent(REJECTION_HANDLED, promise, state.value);
  });
};

var bind = function (fn, state, unwrap) {
  return function (value) {
    fn(state, value, unwrap);
  };
};

var internalReject = function (state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  state.value = value;
  state.state = REJECTED;
  notify(state, true);
};

var internalResolve = function (state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  try {
    if (state.facade === value) throw TypeError("Promise can't be resolved itself");
    var then = isThenable(value);
    if (then) {
      microtask(function () {
        var wrapper = { done: false };
        try {
          call(then, value,
            bind(internalResolve, wrapper, state),
            bind(internalReject, wrapper, state)
          );
        } catch (error) {
          internalReject(wrapper, error, state);
        }
      });
    } else {
      state.value = value;
      state.state = FULFILLED;
      notify(state, false);
    }
  } catch (error) {
    internalReject({ done: false }, error, state);
  }
};

// constructor polyfill
if (FORCED_PROMISE_CONSTRUCTOR) {
  // 25.4.3.1 Promise(executor)
  PromiseConstructor = function Promise(executor) {
    anInstance(this, PromisePrototype);
    aCallable(executor);
    call(Internal, this);
    var state = getInternalPromiseState(this);
    try {
      executor(bind(internalResolve, state), bind(internalReject, state));
    } catch (error) {
      internalReject(state, error);
    }
  };

  PromisePrototype = PromiseConstructor.prototype;

  // eslint-disable-next-line no-unused-vars -- required for `.length`
  Internal = function Promise(executor) {
    setInternalState(this, {
      type: PROMISE,
      done: false,
      notified: false,
      parent: false,
      reactions: new Queue(),
      rejection: false,
      state: PENDING,
      value: undefined
    });
  };

  // `Promise.prototype.then` method
  // https://tc39.es/ecma262/#sec-promise.prototype.then
  Internal.prototype = defineBuiltIn(PromisePrototype, 'then', function then(onFulfilled, onRejected) {
    var state = getInternalPromiseState(this);
    var reaction = newPromiseCapability(speciesConstructor(this, PromiseConstructor));
    state.parent = true;
    reaction.ok = isCallable(onFulfilled) ? onFulfilled : true;
    reaction.fail = isCallable(onRejected) && onRejected;
    reaction.domain = IS_NODE ? process.domain : undefined;
    if (state.state == PENDING) state.reactions.add(reaction);
    else microtask(function () {
      callReaction(reaction, state);
    });
    return reaction.promise;
  });

  OwnPromiseCapability = function () {
    var promise = new Internal();
    var state = getInternalPromiseState(promise);
    this.promise = promise;
    this.resolve = bind(internalResolve, state);
    this.reject = bind(internalReject, state);
  };

  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === PromiseConstructor || C === PromiseWrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };

  if (!IS_PURE && isCallable(NativePromiseConstructor) && NativePromisePrototype !== Object.prototype) {
    nativeThen = NativePromisePrototype.then;

    if (!NATIVE_PROMISE_SUBCLASSING) {
      // make `Promise#then` return a polyfilled `Promise` for native promise-based APIs
      defineBuiltIn(NativePromisePrototype, 'then', function then(onFulfilled, onRejected) {
        var that = this;
        return new PromiseConstructor(function (resolve, reject) {
          call(nativeThen, that, resolve, reject);
        }).then(onFulfilled, onRejected);
      // https://github.com/zloirock/core-js/issues/640
      }, { unsafe: true });
    }

    // make `.constructor === Promise` work for native promise-based APIs
    try {
      delete NativePromisePrototype.constructor;
    } catch (error) { /* empty */ }

    // make `instanceof Promise` work for native promise-based APIs
    if (setPrototypeOf) {
      setPrototypeOf(NativePromisePrototype, PromisePrototype);
    }
  }
}

$({ global: true, wrap: true, forced: FORCED_PROMISE_CONSTRUCTOR }, {
  Promise: PromiseConstructor
});

setToStringTag(PromiseConstructor, PROMISE, false, true);
setSpecies(PROMISE);


/***/ }),

/***/ "5eed":
/***/ (function(module, exports, __webpack_require__) {

var NativePromiseConstructor = __webpack_require__("d256");
var checkCorrectnessOfIteration = __webpack_require__("1c7e");
var FORCED_PROMISE_CONSTRUCTOR = __webpack_require__("4738").CONSTRUCTOR;

module.exports = FORCED_PROMISE_CONSTRUCTOR || !checkCorrectnessOfIteration(function (iterable) {
  NativePromiseConstructor.all(iterable).then(undefined, function () { /* empty */ });
});


/***/ }),

/***/ "605d":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("c6b6");
var global = __webpack_require__("da84");

module.exports = classof(global.process) == 'process';


/***/ }),

/***/ "6069":
/***/ (function(module, exports) {

module.exports = typeof window == 'object' && typeof Deno != 'object';


/***/ }),

/***/ "60bb":
/***/ (function(module, exports) {

module.exports = require("lodash");

/***/ }),

/***/ "60d4":
/***/ (function(module) {

module.exports = JSON.parse("{\"resourceType\":\"ValueSet\",\"status\":\"active\",\"compose\":{\"include\":[{\"system\":\"http://hl7.org/fhir/address-use\"}]},\"expansion\":{\"identifier\":\"urn:uuid:85c97012-21ae-4489-84ca-35afd1326789\",\"timestamp\":\"2018-09-13T12:05:14+02:00\",\"total\":4,\"parameter\":[{\"name\":\"version\",\"valueUri\":\"http://hl7.org/fhir/address-use|3.0.1\"}],\"contains\":[{\"system\":\"http://hl7.org/fhir/address-use\",\"code\":\"home\",\"display\":\"Home\"},{\"system\":\"http://hl7.org/fhir/address-use\",\"code\":\"work\",\"display\":\"Work\"},{\"system\":\"http://hl7.org/fhir/address-use\",\"code\":\"temp\",\"display\":\"Temporary\"},{\"system\":\"http://hl7.org/fhir/address-use\",\"code\":\"old\",\"display\":\"Old / Incorrect\"}]}}");

/***/ }),

/***/ "60da":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__("83ab");
var uncurryThis = __webpack_require__("e330");
var call = __webpack_require__("c65b");
var fails = __webpack_require__("d039");
var objectKeys = __webpack_require__("df75");
var getOwnPropertySymbolsModule = __webpack_require__("7418");
var propertyIsEnumerableModule = __webpack_require__("d1e7");
var toObject = __webpack_require__("7b0b");
var IndexedObject = __webpack_require__("44ad");

// eslint-disable-next-line es-x/no-object-assign -- safe
var $assign = Object.assign;
// eslint-disable-next-line es-x/no-object-defineproperty -- required for testing
var defineProperty = Object.defineProperty;
var concat = uncurryThis([].concat);

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
module.exports = !$assign || fails(function () {
  // should have correct order of operations (Edge bug)
  if (DESCRIPTORS && $assign({ b: 1 }, $assign(defineProperty({}, 'a', {
    enumerable: true,
    get: function () {
      defineProperty(this, 'b', {
        value: 3,
        enumerable: false
      });
    }
  }), { b: 2 })).b !== 1) return true;
  // should work with symbols and should have deterministic property order (V8 bug)
  var A = {};
  var B = {};
  // eslint-disable-next-line es-x/no-symbol -- safe
  var symbol = Symbol();
  var alphabet = 'abcdefghijklmnopqrst';
  A[symbol] = 7;
  alphabet.split('').forEach(function (chr) { B[chr] = chr; });
  return $assign({}, A)[symbol] != 7 || objectKeys($assign({}, B)).join('') != alphabet;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars -- required for `.length`
  var T = toObject(target);
  var argumentsLength = arguments.length;
  var index = 1;
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  var propertyIsEnumerable = propertyIsEnumerableModule.f;
  while (argumentsLength > index) {
    var S = IndexedObject(arguments[index++]);
    var keys = getOwnPropertySymbols ? concat(objectKeys(S), getOwnPropertySymbols(S)) : objectKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || call(propertyIsEnumerable, S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),

/***/ "610f":
/***/ (function(module, exports) {



/***/ }),

/***/ "6547":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("e330");
var toIntegerOrInfinity = __webpack_require__("5926");
var toString = __webpack_require__("577e");
var requireObjectCoercible = __webpack_require__("1d80");

var charAt = uncurryThis(''.charAt);
var charCodeAt = uncurryThis(''.charCodeAt);
var stringSlice = uncurryThis(''.slice);

var createMethod = function (CONVERT_TO_STRING) {
  return function ($this, pos) {
    var S = toString(requireObjectCoercible($this));
    var position = toIntegerOrInfinity(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = charCodeAt(S, position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size
      || (second = charCodeAt(S, position + 1)) < 0xDC00 || second > 0xDFFF
        ? CONVERT_TO_STRING
          ? charAt(S, position)
          : first
        : CONVERT_TO_STRING
          ? stringSlice(S, position, position + 2)
          : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };
};

module.exports = {
  // `String.prototype.codePointAt` method
  // https://tc39.es/ecma262/#sec-string.prototype.codepointat
  codeAt: createMethod(false),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod(true)
};


/***/ }),

/***/ "65f0":
/***/ (function(module, exports, __webpack_require__) {

var arraySpeciesConstructor = __webpack_require__("0b42");

// `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
module.exports = function (originalArray, length) {
  return new (arraySpeciesConstructor(originalArray))(length === 0 ? 0 : length);
};


/***/ }),

/***/ "67b6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $trimStart = __webpack_require__("58a8").start;
var forcedStringTrimMethod = __webpack_require__("c8d2");

// `String.prototype.{ trimStart, trimLeft }` method
// https://tc39.es/ecma262/#sec-string.prototype.trimstart
// https://tc39.es/ecma262/#String.prototype.trimleft
module.exports = forcedStringTrimMethod('trimStart') ? function trimStart() {
  return $trimStart(this);
// eslint-disable-next-line es-x/no-string-prototype-trimstart-trimend -- safe
} : ''.trimStart;


/***/ }),

/***/ "68ee":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("e330");
var fails = __webpack_require__("d039");
var isCallable = __webpack_require__("1626");
var classof = __webpack_require__("f5df");
var getBuiltIn = __webpack_require__("d066");
var inspectSource = __webpack_require__("8925");

var noop = function () { /* empty */ };
var empty = [];
var construct = getBuiltIn('Reflect', 'construct');
var constructorRegExp = /^\s*(?:class|function)\b/;
var exec = uncurryThis(constructorRegExp.exec);
var INCORRECT_TO_STRING = !constructorRegExp.exec(noop);

var isConstructorModern = function isConstructor(argument) {
  if (!isCallable(argument)) return false;
  try {
    construct(noop, empty, argument);
    return true;
  } catch (error) {
    return false;
  }
};

var isConstructorLegacy = function isConstructor(argument) {
  if (!isCallable(argument)) return false;
  switch (classof(argument)) {
    case 'AsyncFunction':
    case 'GeneratorFunction':
    case 'AsyncGeneratorFunction': return false;
  }
  try {
    // we can't check .prototype since constructors produced by .bind haven't it
    // `Function#toString` throws on some built-it function in some legacy engines
    // (for example, `DOMQuad` and similar in FF41-)
    return INCORRECT_TO_STRING || !!exec(constructorRegExp, inspectSource(argument));
  } catch (error) {
    return true;
  }
};

isConstructorLegacy.sham = true;

// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
module.exports = !construct || fails(function () {
  var called;
  return isConstructorModern(isConstructorModern.call)
    || !isConstructorModern(Object)
    || !isConstructorModern(function () { called = true; })
    || called;
}) ? isConstructorLegacy : isConstructorModern;


/***/ }),

/***/ "6964":
/***/ (function(module, exports, __webpack_require__) {

var defineBuiltIn = __webpack_require__("cb2d");

module.exports = function (target, src, options) {
  for (var key in src) defineBuiltIn(target, key, src[key], options);
  return target;
};


/***/ }),

/***/ "69af":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "69f3":
/***/ (function(module, exports, __webpack_require__) {

var NATIVE_WEAK_MAP = __webpack_require__("7f9a");
var global = __webpack_require__("da84");
var uncurryThis = __webpack_require__("e330");
var isObject = __webpack_require__("861d");
var createNonEnumerableProperty = __webpack_require__("9112");
var hasOwn = __webpack_require__("1a2d");
var shared = __webpack_require__("c6cd");
var sharedKey = __webpack_require__("f772");
var hiddenKeys = __webpack_require__("d012");

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var TypeError = global.TypeError;
var WeakMap = global.WeakMap;
var set, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject(it) || (state = get(it)).type !== TYPE) {
      throw TypeError('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP || shared.state) {
  var store = shared.state || (shared.state = new WeakMap());
  var wmget = uncurryThis(store.get);
  var wmhas = uncurryThis(store.has);
  var wmset = uncurryThis(store.set);
  set = function (it, metadata) {
    if (wmhas(store, it)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    wmset(store, it, metadata);
    return metadata;
  };
  get = function (it) {
    return wmget(store, it) || {};
  };
  has = function (it) {
    return wmhas(store, it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys[STATE] = true;
  set = function (it, metadata) {
    if (hasOwn(it, STATE)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return hasOwn(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return hasOwn(it, STATE);
  };
}

module.exports = {
  set: set,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};


/***/ }),

/***/ "6ae1":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "6bb0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_StringQuestion_vue_vue_type_style_index_0_id_1aeb363e_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("8822");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_StringQuestion_vue_vue_type_style_index_0_id_1aeb363e_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_StringQuestion_vue_vue_type_style_index_0_id_1aeb363e_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "6d61":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var global = __webpack_require__("da84");
var uncurryThis = __webpack_require__("e330");
var isForced = __webpack_require__("94ca");
var defineBuiltIn = __webpack_require__("cb2d");
var InternalMetadataModule = __webpack_require__("f183");
var iterate = __webpack_require__("2266");
var anInstance = __webpack_require__("19aa");
var isCallable = __webpack_require__("1626");
var isObject = __webpack_require__("861d");
var fails = __webpack_require__("d039");
var checkCorrectnessOfIteration = __webpack_require__("1c7e");
var setToStringTag = __webpack_require__("d44e");
var inheritIfRequired = __webpack_require__("7156");

module.exports = function (CONSTRUCTOR_NAME, wrapper, common) {
  var IS_MAP = CONSTRUCTOR_NAME.indexOf('Map') !== -1;
  var IS_WEAK = CONSTRUCTOR_NAME.indexOf('Weak') !== -1;
  var ADDER = IS_MAP ? 'set' : 'add';
  var NativeConstructor = global[CONSTRUCTOR_NAME];
  var NativePrototype = NativeConstructor && NativeConstructor.prototype;
  var Constructor = NativeConstructor;
  var exported = {};

  var fixMethod = function (KEY) {
    var uncurriedNativeMethod = uncurryThis(NativePrototype[KEY]);
    defineBuiltIn(NativePrototype, KEY,
      KEY == 'add' ? function add(value) {
        uncurriedNativeMethod(this, value === 0 ? 0 : value);
        return this;
      } : KEY == 'delete' ? function (key) {
        return IS_WEAK && !isObject(key) ? false : uncurriedNativeMethod(this, key === 0 ? 0 : key);
      } : KEY == 'get' ? function get(key) {
        return IS_WEAK && !isObject(key) ? undefined : uncurriedNativeMethod(this, key === 0 ? 0 : key);
      } : KEY == 'has' ? function has(key) {
        return IS_WEAK && !isObject(key) ? false : uncurriedNativeMethod(this, key === 0 ? 0 : key);
      } : function set(key, value) {
        uncurriedNativeMethod(this, key === 0 ? 0 : key, value);
        return this;
      }
    );
  };

  var REPLACE = isForced(
    CONSTRUCTOR_NAME,
    !isCallable(NativeConstructor) || !(IS_WEAK || NativePrototype.forEach && !fails(function () {
      new NativeConstructor().entries().next();
    }))
  );

  if (REPLACE) {
    // create collection constructor
    Constructor = common.getConstructor(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER);
    InternalMetadataModule.enable();
  } else if (isForced(CONSTRUCTOR_NAME, true)) {
    var instance = new Constructor();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~ Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    // eslint-disable-next-line no-new -- required for testing
    var ACCEPT_ITERABLES = checkCorrectnessOfIteration(function (iterable) { new NativeConstructor(iterable); });
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new NativeConstructor();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });

    if (!ACCEPT_ITERABLES) {
      Constructor = wrapper(function (dummy, iterable) {
        anInstance(dummy, NativePrototype);
        var that = inheritIfRequired(new NativeConstructor(), dummy, Constructor);
        if (iterable != undefined) iterate(iterable, that[ADDER], { that: that, AS_ENTRIES: IS_MAP });
        return that;
      });
      Constructor.prototype = NativePrototype;
      NativePrototype.constructor = Constructor;
    }

    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }

    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);

    // weak collections should not contains .clear method
    if (IS_WEAK && NativePrototype.clear) delete NativePrototype.clear;
  }

  exported[CONSTRUCTOR_NAME] = Constructor;
  $({ global: true, forced: Constructor != NativeConstructor }, exported);

  setToStringTag(Constructor, CONSTRUCTOR_NAME);

  if (!IS_WEAK) common.setStrong(Constructor, CONSTRUCTOR_NAME, IS_MAP);

  return Constructor;
};


/***/ }),

/***/ "7039":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var fails = __webpack_require__("d039");
var getOwnPropertyNames = __webpack_require__("057f").f;

// eslint-disable-next-line es-x/no-object-getownpropertynames -- required for testing
var FAILS_ON_PRIMITIVES = fails(function () { return !Object.getOwnPropertyNames(1); });

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES }, {
  getOwnPropertyNames: getOwnPropertyNames
});


/***/ }),

/***/ "7149":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var getBuiltIn = __webpack_require__("d066");
var IS_PURE = __webpack_require__("c430");
var NativePromiseConstructor = __webpack_require__("d256");
var FORCED_PROMISE_CONSTRUCTOR = __webpack_require__("4738").CONSTRUCTOR;
var promiseResolve = __webpack_require__("cdf9");

var PromiseConstructorWrapper = getBuiltIn('Promise');
var CHECK_WRAPPER = IS_PURE && !FORCED_PROMISE_CONSTRUCTOR;

// `Promise.resolve` method
// https://tc39.es/ecma262/#sec-promise.resolve
$({ target: 'Promise', stat: true, forced: IS_PURE || FORCED_PROMISE_CONSTRUCTOR }, {
  resolve: function resolve(x) {
    return promiseResolve(CHECK_WRAPPER && this === PromiseConstructorWrapper ? NativePromiseConstructor : this, x);
  }
});


/***/ }),

/***/ "7156":
/***/ (function(module, exports, __webpack_require__) {

var isCallable = __webpack_require__("1626");
var isObject = __webpack_require__("861d");
var setPrototypeOf = __webpack_require__("d2bb");

// makes subclassing work correct for wrapped built-ins
module.exports = function ($this, dummy, Wrapper) {
  var NewTarget, NewTargetPrototype;
  if (
    // it can work only with native `setPrototypeOf`
    setPrototypeOf &&
    // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
    isCallable(NewTarget = dummy.constructor) &&
    NewTarget !== Wrapper &&
    isObject(NewTargetPrototype = NewTarget.prototype) &&
    NewTargetPrototype !== Wrapper.prototype
  ) setPrototypeOf($this, NewTargetPrototype);
  return $this;
};


/***/ }),

/***/ "7418":
/***/ (function(module, exports) {

// eslint-disable-next-line es-x/no-object-getownpropertysymbols -- safe
exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ "746f":
/***/ (function(module, exports, __webpack_require__) {

var path = __webpack_require__("428f");
var hasOwn = __webpack_require__("1a2d");
var wrappedWellKnownSymbolModule = __webpack_require__("e538");
var defineProperty = __webpack_require__("9bf2").f;

module.exports = function (NAME) {
  var Symbol = path.Symbol || (path.Symbol = {});
  if (!hasOwn(Symbol, NAME)) defineProperty(Symbol, NAME, {
    value: wrappedWellKnownSymbolModule.f(NAME)
  });
};


/***/ }),

/***/ "7479":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_TextQuestion_vue_vue_type_style_index_0_id_6b31ed0b_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("98cd");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_TextQuestion_vue_vue_type_style_index_0_id_6b31ed0b_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_TextQuestion_vue_vue_type_style_index_0_id_6b31ed0b_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "7745":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ListView_vue_vue_type_style_index_0_id_d4863738_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2555");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ListView_vue_vue_type_style_index_0_id_d4863738_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ListView_vue_vue_type_style_index_0_id_d4863738_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "7839":
/***/ (function(module, exports) {

// IE8- don't enum bug keys
module.exports = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];


/***/ }),

/***/ "785a":
/***/ (function(module, exports, __webpack_require__) {

// in old WebKit versions, `element.classList` is not an instance of global `DOMTokenList`
var documentCreateElement = __webpack_require__("cc12");

var classList = documentCreateElement('span').classList;
var DOMTokenListPrototype = classList && classList.constructor && classList.constructor.prototype;

module.exports = DOMTokenListPrototype === Object.prototype ? undefined : DOMTokenListPrototype;


/***/ }),

/***/ "7868":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "7b0b":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var requireObjectCoercible = __webpack_require__("1d80");

var Object = global.Object;

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
module.exports = function (argument) {
  return Object(requireObjectCoercible(argument));
};


/***/ }),

/***/ "7c73":
/***/ (function(module, exports, __webpack_require__) {

/* global ActiveXObject -- old IE, WSH */
var anObject = __webpack_require__("825a");
var definePropertiesModule = __webpack_require__("37e8");
var enumBugKeys = __webpack_require__("7839");
var hiddenKeys = __webpack_require__("d012");
var html = __webpack_require__("1be4");
var documentCreateElement = __webpack_require__("cc12");
var sharedKey = __webpack_require__("f772");

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO = sharedKey('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    activeXDocument = new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = typeof document != 'undefined'
    ? document.domain && activeXDocument
      ? NullProtoObjectViaActiveX(activeXDocument) // old IE
      : NullProtoObjectViaIFrame()
    : NullProtoObjectViaActiveX(activeXDocument); // WSH
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys[IE_PROTO] = true;

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es-x/no-object-create -- safe
module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : definePropertiesModule.f(result, Properties);
};


/***/ }),

/***/ "7db0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var $find = __webpack_require__("b727").find;
var addToUnscopables = __webpack_require__("44d2");

var FIND = 'find';
var SKIPS_HOLES = true;

// Shouldn't skip holes
if (FIND in []) Array(1)[FIND](function () { SKIPS_HOLES = false; });

// `Array.prototype.find` method
// https://tc39.es/ecma262/#sec-array.prototype.find
$({ target: 'Array', proto: true, forced: SKIPS_HOLES }, {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables(FIND);


/***/ }),

/***/ "7dd0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var call = __webpack_require__("c65b");
var IS_PURE = __webpack_require__("c430");
var FunctionName = __webpack_require__("5e77");
var isCallable = __webpack_require__("1626");
var createIteratorConstructor = __webpack_require__("9ed3");
var getPrototypeOf = __webpack_require__("e163");
var setPrototypeOf = __webpack_require__("d2bb");
var setToStringTag = __webpack_require__("d44e");
var createNonEnumerableProperty = __webpack_require__("9112");
var defineBuiltIn = __webpack_require__("cb2d");
var wellKnownSymbol = __webpack_require__("b622");
var Iterators = __webpack_require__("3f8c");
var IteratorsCore = __webpack_require__("ae93");

var PROPER_FUNCTION_NAME = FunctionName.PROPER;
var CONFIGURABLE_FUNCTION_NAME = FunctionName.CONFIGURABLE;
var IteratorPrototype = IteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR = wellKnownSymbol('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis = function () { return this; };

module.exports = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
    switch (KIND) {
      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
    } return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
    if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if (!IS_PURE && getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
        if (setPrototypeOf) {
          setPrototypeOf(CurrentIteratorPrototype, IteratorPrototype);
        } else if (!isCallable(CurrentIteratorPrototype[ITERATOR])) {
          defineBuiltIn(CurrentIteratorPrototype, ITERATOR, returnThis);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
      if (IS_PURE) Iterators[TO_STRING_TAG] = returnThis;
    }
  }

  // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
  if (PROPER_FUNCTION_NAME && DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    if (!IS_PURE && CONFIGURABLE_FUNCTION_NAME) {
      createNonEnumerableProperty(IterablePrototype, 'name', VALUES);
    } else {
      INCORRECT_VALUES_NAME = true;
      defaultIterator = function values() { return call(nativeIterator, this); };
    }
  }

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        defineBuiltIn(IterablePrototype, KEY, methods[KEY]);
      }
    } else $({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
  }

  // define iterator
  if ((!IS_PURE || FORCED) && IterablePrototype[ITERATOR] !== defaultIterator) {
    defineBuiltIn(IterablePrototype, ITERATOR, defaultIterator, { name: DEFAULT });
  }
  Iterators[NAME] = defaultIterator;

  return methods;
};


/***/ }),

/***/ "7f9a":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var isCallable = __webpack_require__("1626");
var inspectSource = __webpack_require__("8925");

var WeakMap = global.WeakMap;

module.exports = isCallable(WeakMap) && /native code/.test(inspectSource(WeakMap));


/***/ }),

/***/ "81d5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toObject = __webpack_require__("7b0b");
var toAbsoluteIndex = __webpack_require__("23cb");
var lengthOfArrayLike = __webpack_require__("07fa");

// `Array.prototype.fill` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.fill
module.exports = function fill(value /* , start = 0, end = @length */) {
  var O = toObject(this);
  var length = lengthOfArrayLike(O);
  var argumentsLength = arguments.length;
  var index = toAbsoluteIndex(argumentsLength > 1 ? arguments[1] : undefined, length);
  var end = argumentsLength > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
  while (endPos > index) O[index++] = value;
  return O;
};


/***/ }),

/***/ "81f2":
/***/ (function(module, exports) {

module.exports = require("debounce");

/***/ }),

/***/ "8225":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ChoiceQuestion_vue_vue_type_style_index_0_id_f44c2f94_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("4766");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ChoiceQuestion_vue_vue_type_style_index_0_id_f44c2f94_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ChoiceQuestion_vue_vue_type_style_index_0_id_f44c2f94_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "825a":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var isObject = __webpack_require__("861d");

var String = global.String;
var TypeError = global.TypeError;

// `Assert: Type(argument) is Object`
module.exports = function (argument) {
  if (isObject(argument)) return argument;
  throw TypeError(String(argument) + ' is not an object');
};


/***/ }),

/***/ "83ab":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");

// Detect IE8's incomplete defineProperty implementation
module.exports = !fails(function () {
  // eslint-disable-next-line es-x/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});


/***/ }),

/***/ "8418":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toPropertyKey = __webpack_require__("a04b");
var definePropertyModule = __webpack_require__("9bf2");
var createPropertyDescriptor = __webpack_require__("5c6c");

module.exports = function (object, key, value) {
  var propertyKey = toPropertyKey(key);
  if (propertyKey in object) definePropertyModule.f(object, propertyKey, createPropertyDescriptor(0, value));
  else object[propertyKey] = value;
};


/***/ }),

/***/ "857a":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("e330");
var requireObjectCoercible = __webpack_require__("1d80");
var toString = __webpack_require__("577e");

var quot = /"/g;
var replace = uncurryThis(''.replace);

// `CreateHTML` abstract operation
// https://tc39.es/ecma262/#sec-createhtml
module.exports = function (string, tag, attribute, value) {
  var S = toString(requireObjectCoercible(string));
  var p1 = '<' + tag;
  if (attribute !== '') p1 += ' ' + attribute + '="' + replace(toString(value), quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};


/***/ }),

/***/ "861d":
/***/ (function(module, exports, __webpack_require__) {

var isCallable = __webpack_require__("1626");

module.exports = function (it) {
  return typeof it == 'object' ? it !== null : isCallable(it);
};


/***/ }),

/***/ "8822":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "8875":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// addapted from the document.currentScript polyfill by Adam Miller
// MIT license
// source: https://github.com/amiller-gh/currentScript-polyfill

// added support for Firefox https://bugzilla.mozilla.org/show_bug.cgi?id=1620505

(function (root, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {}
}(typeof self !== 'undefined' ? self : this, function () {
  function getCurrentScript () {
    var descriptor = Object.getOwnPropertyDescriptor(document, 'currentScript')
    // for chrome
    if (!descriptor && 'currentScript' in document && document.currentScript) {
      return document.currentScript
    }

    // for other browsers with native support for currentScript
    if (descriptor && descriptor.get !== getCurrentScript && document.currentScript) {
      return document.currentScript
    }
  
    // IE 8-10 support script readyState
    // IE 11+ & Firefox support stack trace
    try {
      throw new Error();
    }
    catch (err) {
      // Find the second match for the "at" string to get file src url from stack.
      var ieStackRegExp = /.*at [^(]*\((.*):(.+):(.+)\)$/ig,
        ffStackRegExp = /@([^@]*):(\d+):(\d+)\s*$/ig,
        stackDetails = ieStackRegExp.exec(err.stack) || ffStackRegExp.exec(err.stack),
        scriptLocation = (stackDetails && stackDetails[1]) || false,
        line = (stackDetails && stackDetails[2]) || false,
        currentLocation = document.location.href.replace(document.location.hash, ''),
        pageSource,
        inlineScriptSourceRegExp,
        inlineScriptSource,
        scripts = document.getElementsByTagName('script'); // Live NodeList collection
  
      if (scriptLocation === currentLocation) {
        pageSource = document.documentElement.outerHTML;
        inlineScriptSourceRegExp = new RegExp('(?:[^\\n]+?\\n){0,' + (line - 2) + '}[^<]*<script>([\\d\\D]*?)<\\/script>[\\d\\D]*', 'i');
        inlineScriptSource = pageSource.replace(inlineScriptSourceRegExp, '$1').trim();
      }
  
      for (var i = 0; i < scripts.length; i++) {
        // If ready state is interactive, return the script tag
        if (scripts[i].readyState === 'interactive') {
          return scripts[i];
        }
  
        // If src matches, return the script tag
        if (scripts[i].src === scriptLocation) {
          return scripts[i];
        }
  
        // If inline source matches, return the script tag
        if (
          scriptLocation === currentLocation &&
          scripts[i].innerHTML &&
          scripts[i].innerHTML.trim() === inlineScriptSource
        ) {
          return scripts[i];
        }
      }
  
      // If no match, return null
      return null;
    }
  };

  return getCurrentScript
}));


/***/ }),

/***/ "8925":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("e330");
var isCallable = __webpack_require__("1626");
var store = __webpack_require__("c6cd");

var functionToString = uncurryThis(Function.toString);

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable(store.inspectSource)) {
  store.inspectSource = function (it) {
    return functionToString(it);
  };
}

module.exports = store.inspectSource;


/***/ }),

/***/ "8a79":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var uncurryThis = __webpack_require__("e330");
var getOwnPropertyDescriptor = __webpack_require__("06cf").f;
var toLength = __webpack_require__("50c4");
var toString = __webpack_require__("577e");
var notARegExp = __webpack_require__("5a34");
var requireObjectCoercible = __webpack_require__("1d80");
var correctIsRegExpLogic = __webpack_require__("ab13");
var IS_PURE = __webpack_require__("c430");

// eslint-disable-next-line es-x/no-string-prototype-endswith -- safe
var un$EndsWith = uncurryThis(''.endsWith);
var slice = uncurryThis(''.slice);
var min = Math.min;

var CORRECT_IS_REGEXP_LOGIC = correctIsRegExpLogic('endsWith');
// https://github.com/zloirock/core-js/pull/702
var MDN_POLYFILL_BUG = !IS_PURE && !CORRECT_IS_REGEXP_LOGIC && !!function () {
  var descriptor = getOwnPropertyDescriptor(String.prototype, 'endsWith');
  return descriptor && !descriptor.writable;
}();

// `String.prototype.endsWith` method
// https://tc39.es/ecma262/#sec-string.prototype.endswith
$({ target: 'String', proto: true, forced: !MDN_POLYFILL_BUG && !CORRECT_IS_REGEXP_LOGIC }, {
  endsWith: function endsWith(searchString /* , endPosition = @length */) {
    var that = toString(requireObjectCoercible(this));
    notARegExp(searchString);
    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
    var len = that.length;
    var end = endPosition === undefined ? len : min(toLength(endPosition), len);
    var search = toString(searchString);
    return un$EndsWith
      ? un$EndsWith(that, search, end)
      : slice(that, end - search.length, end) === search;
  }
});


/***/ }),

/***/ "8aa5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var charAt = __webpack_require__("6547").charAt;

// `AdvanceStringIndex` abstract operation
// https://tc39.es/ecma262/#sec-advancestringindex
module.exports = function (S, index, unicode) {
  return index + (unicode ? charAt(S, index).length : 1);
};


/***/ }),

/***/ "8ba4":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var isIntegralNumber = __webpack_require__("eac5");

// `Number.isInteger` method
// https://tc39.es/ecma262/#sec-number.isinteger
$({ target: 'Number', stat: true }, {
  isInteger: isIntegralNumber
});


/***/ }),

/***/ "9015":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "90d8":
/***/ (function(module, exports, __webpack_require__) {

var call = __webpack_require__("c65b");
var hasOwn = __webpack_require__("1a2d");
var isPrototypeOf = __webpack_require__("3a9b");
var regExpFlags = __webpack_require__("ad6d");

var RegExpPrototype = RegExp.prototype;

module.exports = function (R) {
  var flags = R.flags;
  return flags === undefined && !('flags' in RegExpPrototype) && !hasOwn(R, 'flags') && isPrototypeOf(RegExpPrototype, R)
    ? call(regExpFlags, R) : flags;
};


/***/ }),

/***/ "90e3":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("e330");

var id = 0;
var postfix = Math.random();
var toString = uncurryThis(1.0.toString);

module.exports = function (key) {
  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString(++id + postfix, 36);
};


/***/ }),

/***/ "9112":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var definePropertyModule = __webpack_require__("9bf2");
var createPropertyDescriptor = __webpack_require__("5c6c");

module.exports = DESCRIPTORS ? function (object, key, value) {
  return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ "914f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_DisplayQuestion_vue_vue_type_style_index_0_id_1ef7c3f4_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ecec");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_DisplayQuestion_vue_vue_type_style_index_0_id_1ef7c3f4_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_DisplayQuestion_vue_vue_type_style_index_0_id_1ef7c3f4_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "9263":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* eslint-disable regexp/no-empty-capturing-group, regexp/no-empty-group, regexp/no-lazy-ends -- testing */
/* eslint-disable regexp/no-useless-quantifier -- testing */
var call = __webpack_require__("c65b");
var uncurryThis = __webpack_require__("e330");
var toString = __webpack_require__("577e");
var regexpFlags = __webpack_require__("ad6d");
var stickyHelpers = __webpack_require__("9f7f");
var shared = __webpack_require__("5692");
var create = __webpack_require__("7c73");
var getInternalState = __webpack_require__("69f3").get;
var UNSUPPORTED_DOT_ALL = __webpack_require__("fce3");
var UNSUPPORTED_NCG = __webpack_require__("107c");

var nativeReplace = shared('native-string-replace', String.prototype.replace);
var nativeExec = RegExp.prototype.exec;
var patchedExec = nativeExec;
var charAt = uncurryThis(''.charAt);
var indexOf = uncurryThis(''.indexOf);
var replace = uncurryThis(''.replace);
var stringSlice = uncurryThis(''.slice);

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/;
  var re2 = /b*/g;
  call(nativeExec, re1, 'a');
  call(nativeExec, re2, 'a');
  return re1.lastIndex !== 0 || re2.lastIndex !== 0;
})();

var UNSUPPORTED_Y = stickyHelpers.BROKEN_CARET;

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED || UNSUPPORTED_Y || UNSUPPORTED_DOT_ALL || UNSUPPORTED_NCG;

if (PATCH) {
  patchedExec = function exec(string) {
    var re = this;
    var state = getInternalState(re);
    var str = toString(string);
    var raw = state.raw;
    var result, reCopy, lastIndex, match, i, object, group;

    if (raw) {
      raw.lastIndex = re.lastIndex;
      result = call(patchedExec, raw, str);
      re.lastIndex = raw.lastIndex;
      return result;
    }

    var groups = state.groups;
    var sticky = UNSUPPORTED_Y && re.sticky;
    var flags = call(regexpFlags, re);
    var source = re.source;
    var charsAdded = 0;
    var strCopy = str;

    if (sticky) {
      flags = replace(flags, 'y', '');
      if (indexOf(flags, 'g') === -1) {
        flags += 'g';
      }

      strCopy = stringSlice(str, re.lastIndex);
      // Support anchored sticky behavior.
      if (re.lastIndex > 0 && (!re.multiline || re.multiline && charAt(str, re.lastIndex - 1) !== '\n')) {
        source = '(?: ' + source + ')';
        strCopy = ' ' + strCopy;
        charsAdded++;
      }
      // ^(? + rx + ) is needed, in combination with some str slicing, to
      // simulate the 'y' flag.
      reCopy = new RegExp('^(?:' + source + ')', flags);
    }

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + source + '$(?!\\s)', flags);
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;

    match = call(nativeExec, sticky ? reCopy : re, strCopy);

    if (sticky) {
      if (match) {
        match.input = stringSlice(match.input, charsAdded);
        match[0] = stringSlice(match[0], charsAdded);
        match.index = re.lastIndex;
        re.lastIndex += match[0].length;
      } else re.lastIndex = 0;
    } else if (UPDATES_LAST_INDEX_WRONG && match) {
      re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      call(nativeReplace, match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    if (match && groups) {
      match.groups = object = create(null);
      for (i = 0; i < groups.length; i++) {
        group = groups[i];
        object[group[0]] = match[group[1]];
      }
    }

    return match;
  };
}

module.exports = patchedExec;


/***/ }),

/***/ "93f7":
/***/ (function(module) {

module.exports = JSON.parse("{\"resourceType\":\"ValueSet\",\"status\":\"active\",\"compose\":{\"include\":[{\"system\":\"http://hl7.org/fhir/address-type\"}]},\"expansion\":{\"identifier\":\"urn:uuid:357e3759-a7c9-4d3b-842e-ba1cde07110e\",\"timestamp\":\"2018-09-13T12:06:01+02:00\",\"total\":3,\"parameter\":[{\"name\":\"version\",\"valueUri\":\"http://hl7.org/fhir/address-type|3.0.1\"}],\"contains\":[{\"system\":\"http://hl7.org/fhir/address-type\",\"code\":\"postal\",\"display\":\"Postal\"},{\"system\":\"http://hl7.org/fhir/address-type\",\"code\":\"physical\",\"display\":\"Physical\"},{\"system\":\"http://hl7.org/fhir/address-type\",\"code\":\"both\",\"display\":\"Postal & Physical\"}]}}");

/***/ }),

/***/ "944a":
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__("d066");
var defineWellKnownSymbol = __webpack_require__("746f");
var setToStringTag = __webpack_require__("d44e");

// `Symbol.toStringTag` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.tostringtag
defineWellKnownSymbol('toStringTag');

// `Symbol.prototype[@@toStringTag]` property
// https://tc39.es/ecma262/#sec-symbol.prototype-@@tostringtag
setToStringTag(getBuiltIn('Symbol'), 'Symbol');


/***/ }),

/***/ "94ca":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");
var isCallable = __webpack_require__("1626");

var replacement = /#|\.prototype\./;

var isForced = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : isCallable(detection) ? fails(detection)
    : !!detection;
};

var normalize = isForced.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced.data = {};
var NATIVE = isForced.NATIVE = 'N';
var POLYFILL = isForced.POLYFILL = 'P';

module.exports = isForced;


/***/ }),

/***/ "96cf":
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var runtime = (function (exports) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
    return obj[key];
  }
  try {
    // IE 8 has a broken Object.defineProperty that only works on DOM objects.
    define({}, "");
  } catch (err) {
    define = function(obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  exports.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = GeneratorFunctionPrototype;
  define(Gp, "constructor", GeneratorFunctionPrototype);
  define(GeneratorFunctionPrototype, "constructor", GeneratorFunction);
  GeneratorFunction.displayName = define(
    GeneratorFunctionPrototype,
    toStringTagSymbol,
    "GeneratorFunction"
  );

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      define(prototype, method, function(arg) {
        return this._invoke(method, arg);
      });
    });
  }

  exports.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  exports.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      define(genFun, toStringTagSymbol, "GeneratorFunction");
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  exports.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return PromiseImpl.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return PromiseImpl.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration.
          result.value = unwrapped;
          resolve(result);
        }, function(error) {
          // If a rejected Promise was yielded, throw the rejection back
          // into the async generator function so it can be handled there.
          return invoke("throw", error, resolve, reject);
        });
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  });
  exports.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    if (PromiseImpl === void 0) PromiseImpl = Promise;

    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList),
      PromiseImpl
    );

    return exports.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        // Note: ["return"] must be used for ES3 parsing compatibility.
        if (delegate.iterator["return"]) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  define(Gp, toStringTagSymbol, "Generator");

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  define(Gp, iteratorSymbol, function() {
    return this;
  });

  define(Gp, "toString", function() {
    return "[object Generator]";
  });

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  exports.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  exports.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };

  // Regardless of whether this script is executing as a CommonJS module
  // or not, return the runtime object so that we can declare the variable
  // regeneratorRuntime in the outer scope, which allows this module to be
  // injected easily by `bin/regenerator --include-runtime script.js`.
  return exports;

}(
  // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
   true ? module.exports : undefined
));

try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  // This module should not be running in strict mode, so the above
  // assignment should always work unless something is misconfigured. Just
  // in case runtime.js accidentally runs in strict mode, in modern engines
  // we can explicitly access globalThis. In older engines we can escape
  // strict mode using a global Function call. This could conceivably fail
  // if a Content Security Policy forbids using Function, but in that case
  // the proper solution is to fix the accidental strict mode problem. If
  // you've misconfigured your bundler to force strict mode and applied a
  // CSP to forbid Function, and you're not willing to fix either of those
  // problems, please detail your unique predicament in a GitHub issue.
  if (typeof globalThis === "object") {
    globalThis.regeneratorRuntime = runtime;
  } else {
    Function("r", "regeneratorRuntime = r")(runtime);
  }
}


/***/ }),

/***/ "96d5":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "9861":
/***/ (function(module, exports, __webpack_require__) {

// TODO: Remove this module from `core-js@4` since it's replaced to module below
__webpack_require__("5352");


/***/ }),

/***/ "98cd":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "9911":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var createHTML = __webpack_require__("857a");
var forcedStringHTMLMethod = __webpack_require__("af03");

// `String.prototype.link` method
// https://tc39.es/ecma262/#sec-string.prototype.link
$({ target: 'String', proto: true, forced: forcedStringHTMLMethod('link') }, {
  link: function link(url) {
    return createHTML(this, 'a', 'href', url);
  }
});


/***/ }),

/***/ "99af":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var global = __webpack_require__("da84");
var fails = __webpack_require__("d039");
var isArray = __webpack_require__("e8b5");
var isObject = __webpack_require__("861d");
var toObject = __webpack_require__("7b0b");
var lengthOfArrayLike = __webpack_require__("07fa");
var createProperty = __webpack_require__("8418");
var arraySpeciesCreate = __webpack_require__("65f0");
var arrayMethodHasSpeciesSupport = __webpack_require__("1dde");
var wellKnownSymbol = __webpack_require__("b622");
var V8_VERSION = __webpack_require__("2d00");

var IS_CONCAT_SPREADABLE = wellKnownSymbol('isConcatSpreadable');
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF;
var MAXIMUM_ALLOWED_INDEX_EXCEEDED = 'Maximum allowed index exceeded';
var TypeError = global.TypeError;

// We can't use this feature detection in V8 since it causes
// deoptimization and serious performance degradation
// https://github.com/zloirock/core-js/issues/679
var IS_CONCAT_SPREADABLE_SUPPORT = V8_VERSION >= 51 || !fails(function () {
  var array = [];
  array[IS_CONCAT_SPREADABLE] = false;
  return array.concat()[0] !== array;
});

var SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('concat');

var isConcatSpreadable = function (O) {
  if (!isObject(O)) return false;
  var spreadable = O[IS_CONCAT_SPREADABLE];
  return spreadable !== undefined ? !!spreadable : isArray(O);
};

var FORCED = !IS_CONCAT_SPREADABLE_SUPPORT || !SPECIES_SUPPORT;

// `Array.prototype.concat` method
// https://tc39.es/ecma262/#sec-array.prototype.concat
// with adding support of @@isConcatSpreadable and @@species
$({ target: 'Array', proto: true, arity: 1, forced: FORCED }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  concat: function concat(arg) {
    var O = toObject(this);
    var A = arraySpeciesCreate(O, 0);
    var n = 0;
    var i, k, length, len, E;
    for (i = -1, length = arguments.length; i < length; i++) {
      E = i === -1 ? O : arguments[i];
      if (isConcatSpreadable(E)) {
        len = lengthOfArrayLike(E);
        if (n + len > MAX_SAFE_INTEGER) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
        for (k = 0; k < len; k++, n++) if (k in E) createProperty(A, n, E[k]);
      } else {
        if (n >= MAX_SAFE_INTEGER) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
        createProperty(A, n++, E);
      }
    }
    A.length = n;
    return A;
  }
});


/***/ }),

/***/ "9a1f":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var call = __webpack_require__("c65b");
var aCallable = __webpack_require__("59ed");
var anObject = __webpack_require__("825a");
var tryToString = __webpack_require__("0d51");
var getIteratorMethod = __webpack_require__("35a1");

var TypeError = global.TypeError;

module.exports = function (argument, usingIterator) {
  var iteratorMethod = arguments.length < 2 ? getIteratorMethod(argument) : usingIterator;
  if (aCallable(iteratorMethod)) return anObject(call(iteratorMethod, argument));
  throw TypeError(tryToString(argument) + ' is not iterable');
};


/***/ }),

/***/ "9b20":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "9bdd":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("825a");
var iteratorClose = __webpack_require__("2a62");

// call something on iterator step with safe closing on error
module.exports = function (iterator, fn, value, ENTRIES) {
  try {
    return ENTRIES ? fn(anObject(value)[0], value[1]) : fn(value);
  } catch (error) {
    iteratorClose(iterator, 'throw', error);
  }
};


/***/ }),

/***/ "9bf2":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var DESCRIPTORS = __webpack_require__("83ab");
var IE8_DOM_DEFINE = __webpack_require__("0cfb");
var V8_PROTOTYPE_DEFINE_BUG = __webpack_require__("aed9");
var anObject = __webpack_require__("825a");
var toPropertyKey = __webpack_require__("a04b");

var TypeError = global.TypeError;
// eslint-disable-next-line es-x/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;
// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var ENUMERABLE = 'enumerable';
var CONFIGURABLE = 'configurable';
var WRITABLE = 'writable';

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
exports.f = DESCRIPTORS ? V8_PROTOTYPE_DEFINE_BUG ? function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPropertyKey(P);
  anObject(Attributes);
  if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
    var current = $getOwnPropertyDescriptor(O, P);
    if (current && current[WRITABLE]) {
      O[P] = Attributes.value;
      Attributes = {
        configurable: CONFIGURABLE in Attributes ? Attributes[CONFIGURABLE] : current[CONFIGURABLE],
        enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
        writable: false
      };
    }
  } return $defineProperty(O, P, Attributes);
} : $defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPropertyKey(P);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ "9c81":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_DateTimeQuestion_vue_vue_type_style_index_0_id_75a65e6a_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("7868");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_DateTimeQuestion_vue_vue_type_style_index_0_id_75a65e6a_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_DateTimeQuestion_vue_vue_type_style_index_0_id_75a65e6a_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "9cd7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_DtHumanName_de_basis_vue_vue_type_style_index_0_id_9381ab08_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("132d");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_DtHumanName_de_basis_vue_vue_type_style_index_0_id_9381ab08_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_DtHumanName_de_basis_vue_vue_type_style_index_0_id_9381ab08_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "9d6a":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "9d78":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ResourceSelector_vue_vue_type_style_index_0_id_65e7b3b6_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("5e4d");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ResourceSelector_vue_vue_type_style_index_0_id_65e7b3b6_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ResourceSelector_vue_vue_type_style_index_0_id_65e7b3b6_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "9ed3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var IteratorPrototype = __webpack_require__("ae93").IteratorPrototype;
var create = __webpack_require__("7c73");
var createPropertyDescriptor = __webpack_require__("5c6c");
var setToStringTag = __webpack_require__("d44e");
var Iterators = __webpack_require__("3f8c");

var returnThis = function () { return this; };

module.exports = function (IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = create(IteratorPrototype, { next: createPropertyDescriptor(+!ENUMERABLE_NEXT, next) });
  setToStringTag(IteratorConstructor, TO_STRING_TAG, false, true);
  Iterators[TO_STRING_TAG] = returnThis;
  return IteratorConstructor;
};


/***/ }),

/***/ "9f7f":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");
var global = __webpack_require__("da84");

// babel-minify and Closure Compiler transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
var $RegExp = global.RegExp;

var UNSUPPORTED_Y = fails(function () {
  var re = $RegExp('a', 'y');
  re.lastIndex = 2;
  return re.exec('abcd') != null;
});

// UC Browser bug
// https://github.com/zloirock/core-js/issues/1008
var MISSED_STICKY = UNSUPPORTED_Y || fails(function () {
  return !$RegExp('a', 'y').sticky;
});

var BROKEN_CARET = UNSUPPORTED_Y || fails(function () {
  // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
  var re = $RegExp('^r', 'gy');
  re.lastIndex = 2;
  return re.exec('str') != null;
});

module.exports = {
  BROKEN_CARET: BROKEN_CARET,
  MISSED_STICKY: MISSED_STICKY,
  UNSUPPORTED_Y: UNSUPPORTED_Y
};


/***/ }),

/***/ "9ff0":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "a04b":
/***/ (function(module, exports, __webpack_require__) {

var toPrimitive = __webpack_require__("c04e");
var isSymbol = __webpack_require__("d9b5");

// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
module.exports = function (argument) {
  var key = toPrimitive(argument, 'string');
  return isSymbol(key) ? key : key + '';
};


/***/ }),

/***/ "a15b":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var uncurryThis = __webpack_require__("e330");
var IndexedObject = __webpack_require__("44ad");
var toIndexedObject = __webpack_require__("fc6a");
var arrayMethodIsStrict = __webpack_require__("a640");

var un$Join = uncurryThis([].join);

var ES3_STRINGS = IndexedObject != Object;
var STRICT_METHOD = arrayMethodIsStrict('join', ',');

// `Array.prototype.join` method
// https://tc39.es/ecma262/#sec-array.prototype.join
$({ target: 'Array', proto: true, forced: ES3_STRINGS || !STRICT_METHOD }, {
  join: function join(separator) {
    return un$Join(toIndexedObject(this), separator === undefined ? ',' : separator);
  }
});


/***/ }),

/***/ "a434":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var global = __webpack_require__("da84");
var toAbsoluteIndex = __webpack_require__("23cb");
var toIntegerOrInfinity = __webpack_require__("5926");
var lengthOfArrayLike = __webpack_require__("07fa");
var toObject = __webpack_require__("7b0b");
var arraySpeciesCreate = __webpack_require__("65f0");
var createProperty = __webpack_require__("8418");
var arrayMethodHasSpeciesSupport = __webpack_require__("1dde");

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('splice');

var TypeError = global.TypeError;
var max = Math.max;
var min = Math.min;
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF;
var MAXIMUM_ALLOWED_LENGTH_EXCEEDED = 'Maximum allowed length exceeded';

// `Array.prototype.splice` method
// https://tc39.es/ecma262/#sec-array.prototype.splice
// with adding support of @@species
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  splice: function splice(start, deleteCount /* , ...items */) {
    var O = toObject(this);
    var len = lengthOfArrayLike(O);
    var actualStart = toAbsoluteIndex(start, len);
    var argumentsLength = arguments.length;
    var insertCount, actualDeleteCount, A, k, from, to;
    if (argumentsLength === 0) {
      insertCount = actualDeleteCount = 0;
    } else if (argumentsLength === 1) {
      insertCount = 0;
      actualDeleteCount = len - actualStart;
    } else {
      insertCount = argumentsLength - 2;
      actualDeleteCount = min(max(toIntegerOrInfinity(deleteCount), 0), len - actualStart);
    }
    if (len + insertCount - actualDeleteCount > MAX_SAFE_INTEGER) {
      throw TypeError(MAXIMUM_ALLOWED_LENGTH_EXCEEDED);
    }
    A = arraySpeciesCreate(O, actualDeleteCount);
    for (k = 0; k < actualDeleteCount; k++) {
      from = actualStart + k;
      if (from in O) createProperty(A, k, O[from]);
    }
    A.length = actualDeleteCount;
    if (insertCount < actualDeleteCount) {
      for (k = actualStart; k < len - actualDeleteCount; k++) {
        from = k + actualDeleteCount;
        to = k + insertCount;
        if (from in O) O[to] = O[from];
        else delete O[to];
      }
      for (k = len; k > len - actualDeleteCount + insertCount; k--) delete O[k - 1];
    } else if (insertCount > actualDeleteCount) {
      for (k = len - actualDeleteCount; k > actualStart; k--) {
        from = k + actualDeleteCount - 1;
        to = k + insertCount - 1;
        if (from in O) O[to] = O[from];
        else delete O[to];
      }
    }
    for (k = 0; k < insertCount; k++) {
      O[k + actualStart] = arguments[k + 2];
    }
    O.length = len - actualDeleteCount + insertCount;
    return A;
  }
});


/***/ }),

/***/ "a4b4":
/***/ (function(module, exports, __webpack_require__) {

var userAgent = __webpack_require__("342f");

module.exports = /web0s(?!.*chrome)/i.test(userAgent);


/***/ }),

/***/ "a4d3":
/***/ (function(module, exports, __webpack_require__) {

// TODO: Remove this module from `core-js@4` since it's split to modules listed below
__webpack_require__("d9f5");
__webpack_require__("b4f8");
__webpack_require__("c513");
__webpack_require__("e9c4");
__webpack_require__("5a47");


/***/ }),

/***/ "a630":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var from = __webpack_require__("4df4");
var checkCorrectnessOfIteration = __webpack_require__("1c7e");

var INCORRECT_ITERATION = !checkCorrectnessOfIteration(function (iterable) {
  // eslint-disable-next-line es-x/no-array-from -- required for testing
  Array.from(iterable);
});

// `Array.from` method
// https://tc39.es/ecma262/#sec-array.from
$({ target: 'Array', stat: true, forced: INCORRECT_ITERATION }, {
  from: from
});


/***/ }),

/***/ "a640":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__("d039");

module.exports = function (METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call -- required for testing
    method.call(null, argument || function () { return 1; }, 1);
  });
};


/***/ }),

/***/ "a9bd":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "a9e3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__("83ab");
var global = __webpack_require__("da84");
var uncurryThis = __webpack_require__("e330");
var isForced = __webpack_require__("94ca");
var defineBuiltIn = __webpack_require__("cb2d");
var hasOwn = __webpack_require__("1a2d");
var inheritIfRequired = __webpack_require__("7156");
var isPrototypeOf = __webpack_require__("3a9b");
var isSymbol = __webpack_require__("d9b5");
var toPrimitive = __webpack_require__("c04e");
var fails = __webpack_require__("d039");
var getOwnPropertyNames = __webpack_require__("241c").f;
var getOwnPropertyDescriptor = __webpack_require__("06cf").f;
var defineProperty = __webpack_require__("9bf2").f;
var thisNumberValue = __webpack_require__("408a");
var trim = __webpack_require__("58a8").trim;

var NUMBER = 'Number';
var NativeNumber = global[NUMBER];
var NumberPrototype = NativeNumber.prototype;
var TypeError = global.TypeError;
var arraySlice = uncurryThis(''.slice);
var charCodeAt = uncurryThis(''.charCodeAt);

// `ToNumeric` abstract operation
// https://tc39.es/ecma262/#sec-tonumeric
var toNumeric = function (value) {
  var primValue = toPrimitive(value, 'number');
  return typeof primValue == 'bigint' ? primValue : toNumber(primValue);
};

// `ToNumber` abstract operation
// https://tc39.es/ecma262/#sec-tonumber
var toNumber = function (argument) {
  var it = toPrimitive(argument, 'number');
  var first, third, radix, maxCode, digits, length, index, code;
  if (isSymbol(it)) throw TypeError('Cannot convert a Symbol value to a number');
  if (typeof it == 'string' && it.length > 2) {
    it = trim(it);
    first = charCodeAt(it, 0);
    if (first === 43 || first === 45) {
      third = charCodeAt(it, 2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (charCodeAt(it, 1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal of /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal of /^0o[0-7]+$/i
        default: return +it;
      }
      digits = arraySlice(it, 2);
      length = digits.length;
      for (index = 0; index < length; index++) {
        code = charCodeAt(digits, index);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

// `Number` constructor
// https://tc39.es/ecma262/#sec-number-constructor
if (isForced(NUMBER, !NativeNumber(' 0o1') || !NativeNumber('0b1') || NativeNumber('+0x1'))) {
  var NumberWrapper = function Number(value) {
    var n = arguments.length < 1 ? 0 : NativeNumber(toNumeric(value));
    var dummy = this;
    // check on 1..constructor(foo) case
    return isPrototypeOf(NumberPrototype, dummy) && fails(function () { thisNumberValue(dummy); })
      ? inheritIfRequired(Object(n), dummy, NumberWrapper) : n;
  };
  for (var keys = DESCRIPTORS ? getOwnPropertyNames(NativeNumber) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES2015 (in case, if modules with ES2015 Number statics required before):
    'EPSILON,MAX_SAFE_INTEGER,MIN_SAFE_INTEGER,isFinite,isInteger,isNaN,isSafeInteger,parseFloat,parseInt,' +
    // ESNext
    'fromString,range'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (hasOwn(NativeNumber, key = keys[j]) && !hasOwn(NumberWrapper, key)) {
      defineProperty(NumberWrapper, key, getOwnPropertyDescriptor(NativeNumber, key));
    }
  }
  NumberWrapper.prototype = NumberPrototype;
  NumberPrototype.constructor = NumberWrapper;
  defineBuiltIn(global, NUMBER, NumberWrapper);
}


/***/ }),

/***/ "aa13":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "ab13":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("b622");

var MATCH = wellKnownSymbol('match');

module.exports = function (METHOD_NAME) {
  var regexp = /./;
  try {
    '/./'[METHOD_NAME](regexp);
  } catch (error1) {
    try {
      regexp[MATCH] = false;
      return '/./'[METHOD_NAME](regexp);
    } catch (error2) { /* empty */ }
  } return false;
};


/***/ }),

/***/ "ab36":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("861d");
var createNonEnumerableProperty = __webpack_require__("9112");

// `InstallErrorCause` abstract operation
// https://tc39.es/proposal-error-cause/#sec-errorobjects-install-error-cause
module.exports = function (O, options) {
  if (isObject(options) && 'cause' in options) {
    createNonEnumerableProperty(O, 'cause', options.cause);
  }
};


/***/ }),

/***/ "ac1f":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var exec = __webpack_require__("9263");

// `RegExp.prototype.exec` method
// https://tc39.es/ecma262/#sec-regexp.prototype.exec
$({ target: 'RegExp', proto: true, forced: /./.exec !== exec }, {
  exec: exec
});


/***/ }),

/***/ "acac":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__("e330");
var defineBuiltIns = __webpack_require__("6964");
var getWeakData = __webpack_require__("f183").getWeakData;
var anObject = __webpack_require__("825a");
var isObject = __webpack_require__("861d");
var anInstance = __webpack_require__("19aa");
var iterate = __webpack_require__("2266");
var ArrayIterationModule = __webpack_require__("b727");
var hasOwn = __webpack_require__("1a2d");
var InternalStateModule = __webpack_require__("69f3");

var setInternalState = InternalStateModule.set;
var internalStateGetterFor = InternalStateModule.getterFor;
var find = ArrayIterationModule.find;
var findIndex = ArrayIterationModule.findIndex;
var splice = uncurryThis([].splice);
var id = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function (store) {
  return store.frozen || (store.frozen = new UncaughtFrozenStore());
};

var UncaughtFrozenStore = function () {
  this.entries = [];
};

var findUncaughtFrozen = function (store, key) {
  return find(store.entries, function (it) {
    return it[0] === key;
  });
};

UncaughtFrozenStore.prototype = {
  get: function (key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) return entry[1];
  },
  has: function (key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function (key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) entry[1] = value;
    else this.entries.push([key, value]);
  },
  'delete': function (key) {
    var index = findIndex(this.entries, function (it) {
      return it[0] === key;
    });
    if (~index) splice(this.entries, index, 1);
    return !!~index;
  }
};

module.exports = {
  getConstructor: function (wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
    var Constructor = wrapper(function (that, iterable) {
      anInstance(that, Prototype);
      setInternalState(that, {
        type: CONSTRUCTOR_NAME,
        id: id++,
        frozen: undefined
      });
      if (iterable != undefined) iterate(iterable, that[ADDER], { that: that, AS_ENTRIES: IS_MAP });
    });

    var Prototype = Constructor.prototype;

    var getInternalState = internalStateGetterFor(CONSTRUCTOR_NAME);

    var define = function (that, key, value) {
      var state = getInternalState(that);
      var data = getWeakData(anObject(key), true);
      if (data === true) uncaughtFrozenStore(state).set(key, value);
      else data[state.id] = value;
      return that;
    };

    defineBuiltIns(Prototype, {
      // `{ WeakMap, WeakSet }.prototype.delete(key)` methods
      // https://tc39.es/ecma262/#sec-weakmap.prototype.delete
      // https://tc39.es/ecma262/#sec-weakset.prototype.delete
      'delete': function (key) {
        var state = getInternalState(this);
        if (!isObject(key)) return false;
        var data = getWeakData(key);
        if (data === true) return uncaughtFrozenStore(state)['delete'](key);
        return data && hasOwn(data, state.id) && delete data[state.id];
      },
      // `{ WeakMap, WeakSet }.prototype.has(key)` methods
      // https://tc39.es/ecma262/#sec-weakmap.prototype.has
      // https://tc39.es/ecma262/#sec-weakset.prototype.has
      has: function has(key) {
        var state = getInternalState(this);
        if (!isObject(key)) return false;
        var data = getWeakData(key);
        if (data === true) return uncaughtFrozenStore(state).has(key);
        return data && hasOwn(data, state.id);
      }
    });

    defineBuiltIns(Prototype, IS_MAP ? {
      // `WeakMap.prototype.get(key)` method
      // https://tc39.es/ecma262/#sec-weakmap.prototype.get
      get: function get(key) {
        var state = getInternalState(this);
        if (isObject(key)) {
          var data = getWeakData(key);
          if (data === true) return uncaughtFrozenStore(state).get(key);
          return data ? data[state.id] : undefined;
        }
      },
      // `WeakMap.prototype.set(key, value)` method
      // https://tc39.es/ecma262/#sec-weakmap.prototype.set
      set: function set(key, value) {
        return define(this, key, value);
      }
    } : {
      // `WeakSet.prototype.add(value)` method
      // https://tc39.es/ecma262/#sec-weakset.prototype.add
      add: function add(value) {
        return define(this, value, true);
      }
    });

    return Constructor;
  }
};


/***/ }),

/***/ "ad6d":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__("825a");

// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.hasIndices) result += 'd';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.dotAll) result += 's';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),

/***/ "addb":
/***/ (function(module, exports, __webpack_require__) {

var arraySlice = __webpack_require__("4dae");

var floor = Math.floor;

var mergeSort = function (array, comparefn) {
  var length = array.length;
  var middle = floor(length / 2);
  return length < 8 ? insertionSort(array, comparefn) : merge(
    array,
    mergeSort(arraySlice(array, 0, middle), comparefn),
    mergeSort(arraySlice(array, middle), comparefn),
    comparefn
  );
};

var insertionSort = function (array, comparefn) {
  var length = array.length;
  var i = 1;
  var element, j;

  while (i < length) {
    j = i;
    element = array[i];
    while (j && comparefn(array[j - 1], element) > 0) {
      array[j] = array[--j];
    }
    if (j !== i++) array[j] = element;
  } return array;
};

var merge = function (array, left, right, comparefn) {
  var llength = left.length;
  var rlength = right.length;
  var lindex = 0;
  var rindex = 0;

  while (lindex < llength || rindex < rlength) {
    array[lindex + rindex] = (lindex < llength && rindex < rlength)
      ? comparefn(left[lindex], right[rindex]) <= 0 ? left[lindex++] : right[rindex++]
      : lindex < llength ? left[lindex++] : right[rindex++];
  } return array;
};

module.exports = mergeSort;


/***/ }),

/***/ "ae93":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__("d039");
var isCallable = __webpack_require__("1626");
var create = __webpack_require__("7c73");
var getPrototypeOf = __webpack_require__("e163");
var defineBuiltIn = __webpack_require__("cb2d");
var wellKnownSymbol = __webpack_require__("b622");
var IS_PURE = __webpack_require__("c430");

var ITERATOR = wellKnownSymbol('iterator');
var BUGGY_SAFARI_ITERATORS = false;

// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype, PrototypeOfArrayIteratorPrototype, arrayIterator;

/* eslint-disable es-x/no-array-prototype-keys -- safe */
if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS = true;
  else {
    PrototypeOfArrayIteratorPrototype = getPrototypeOf(getPrototypeOf(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype = PrototypeOfArrayIteratorPrototype;
  }
}

var NEW_ITERATOR_PROTOTYPE = IteratorPrototype == undefined || fails(function () {
  var test = {};
  // FF44- legacy iterators case
  return IteratorPrototype[ITERATOR].call(test) !== test;
});

if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype = {};
else if (IS_PURE) IteratorPrototype = create(IteratorPrototype);

// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!isCallable(IteratorPrototype[ITERATOR])) {
  defineBuiltIn(IteratorPrototype, ITERATOR, function () {
    return this;
  });
}

module.exports = {
  IteratorPrototype: IteratorPrototype,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS
};


/***/ }),

/***/ "aeb0":
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__("9bf2").f;

module.exports = function (Target, Source, key) {
  key in Target || defineProperty(Target, key, {
    configurable: true,
    get: function () { return Source[key]; },
    set: function (it) { Source[key] = it; }
  });
};


/***/ }),

/***/ "aed9":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var fails = __webpack_require__("d039");

// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
module.exports = DESCRIPTORS && fails(function () {
  // eslint-disable-next-line es-x/no-object-defineproperty -- required for testing
  return Object.defineProperty(function () { /* empty */ }, 'prototype', {
    value: 42,
    writable: false
  }).prototype != 42;
});


/***/ }),

/***/ "af03":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");

// check the existence of a method, lowercase
// of a tag and escaping quotes in arguments
module.exports = function (METHOD_NAME) {
  return fails(function () {
    var test = ''[METHOD_NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  });
};


/***/ }),

/***/ "b041":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var TO_STRING_TAG_SUPPORT = __webpack_require__("00ee");
var classof = __webpack_require__("f5df");

// `Object.prototype.toString` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.tostring
module.exports = TO_STRING_TAG_SUPPORT ? {}.toString : function toString() {
  return '[object ' + classof(this) + ']';
};


/***/ }),

/***/ "b0c0":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var FUNCTION_NAME_EXISTS = __webpack_require__("5e77").EXISTS;
var uncurryThis = __webpack_require__("e330");
var defineProperty = __webpack_require__("9bf2").f;

var FunctionPrototype = Function.prototype;
var functionToString = uncurryThis(FunctionPrototype.toString);
var nameRE = /function\b(?:\s|\/\*[\S\s]*?\*\/|\/\/[^\n\r]*[\n\r]+)*([^\s(/]*)/;
var regExpExec = uncurryThis(nameRE.exec);
var NAME = 'name';

// Function instances `.name` property
// https://tc39.es/ecma262/#sec-function-instances-name
if (DESCRIPTORS && !FUNCTION_NAME_EXISTS) {
  defineProperty(FunctionPrototype, NAME, {
    configurable: true,
    get: function () {
      try {
        return regExpExec(nameRE, functionToString(this))[1];
      } catch (error) {
        return '';
      }
    }
  });
}


/***/ }),

/***/ "b20e":
/***/ (function(module, exports) {

module.exports = require("vue-simple-spinner");

/***/ }),

/***/ "b316":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_TimeQuestion_vue_vue_type_style_index_0_id_3dc00ce8_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("9b20");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_TimeQuestion_vue_vue_type_style_index_0_id_3dc00ce8_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_TimeQuestion_vue_vue_type_style_index_0_id_3dc00ce8_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "b409":
/***/ (function(module) {

module.exports = JSON.parse("{\"resourceType\":\"ValueSet\",\"status\":\"active\",\"compose\":{\"include\":[{\"system\":\"http://hl7.org/fhir/administrative-gender\"}]},\"expansion\":{\"identifier\":\"urn:uuid:a51aa32a-1e35-451e-a49d-c3d2a023fe96\",\"timestamp\":\"2018-09-13T12:06:17+02:00\",\"total\":4,\"parameter\":[{\"name\":\"version\",\"valueUri\":\"http://hl7.org/fhir/administrative-gender|3.0.1\"}],\"contains\":[{\"system\":\"http://hl7.org/fhir/administrative-gender\",\"code\":\"male\",\"display\":\"Male\"},{\"system\":\"http://hl7.org/fhir/administrative-gender\",\"code\":\"female\",\"display\":\"Female\"},{\"system\":\"http://hl7.org/fhir/administrative-gender\",\"code\":\"other\",\"display\":\"Other\"},{\"system\":\"http://hl7.org/fhir/administrative-gender\",\"code\":\"unknown\",\"display\":\"Unknown\"}]}}");

/***/ }),

/***/ "b4f8":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var getBuiltIn = __webpack_require__("d066");
var hasOwn = __webpack_require__("1a2d");
var toString = __webpack_require__("577e");
var shared = __webpack_require__("5692");
var NATIVE_SYMBOL_REGISTRY = __webpack_require__("3d87");

var StringToSymbolRegistry = shared('string-to-symbol-registry');
var SymbolToStringRegistry = shared('symbol-to-string-registry');

// `Symbol.for` method
// https://tc39.es/ecma262/#sec-symbol.for
$({ target: 'Symbol', stat: true, forced: !NATIVE_SYMBOL_REGISTRY }, {
  'for': function (key) {
    var string = toString(key);
    if (hasOwn(StringToSymbolRegistry, string)) return StringToSymbolRegistry[string];
    var symbol = getBuiltIn('Symbol')(string);
    StringToSymbolRegistry[string] = symbol;
    SymbolToStringRegistry[symbol] = string;
    return symbol;
  }
});


/***/ }),

/***/ "b575":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var bind = __webpack_require__("0366");
var getOwnPropertyDescriptor = __webpack_require__("06cf").f;
var macrotask = __webpack_require__("2cf4").set;
var IS_IOS = __webpack_require__("1cdc");
var IS_IOS_PEBBLE = __webpack_require__("d4c3");
var IS_WEBOS_WEBKIT = __webpack_require__("a4b4");
var IS_NODE = __webpack_require__("605d");

var MutationObserver = global.MutationObserver || global.WebKitMutationObserver;
var document = global.document;
var process = global.process;
var Promise = global.Promise;
// Node.js 11 shows ExperimentalWarning on getting `queueMicrotask`
var queueMicrotaskDescriptor = getOwnPropertyDescriptor(global, 'queueMicrotask');
var queueMicrotask = queueMicrotaskDescriptor && queueMicrotaskDescriptor.value;

var flush, head, last, notify, toggle, node, promise, then;

// modern engines have queueMicrotask method
if (!queueMicrotask) {
  flush = function () {
    var parent, fn;
    if (IS_NODE && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (error) {
        if (head) notify();
        else last = undefined;
        throw error;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
  // also except WebOS Webkit https://github.com/zloirock/core-js/issues/898
  if (!IS_IOS && !IS_NODE && !IS_WEBOS_WEBKIT && MutationObserver && document) {
    toggle = true;
    node = document.createTextNode('');
    new MutationObserver(flush).observe(node, { characterData: true });
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (!IS_IOS_PEBBLE && Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    promise = Promise.resolve(undefined);
    // workaround of WebKit ~ iOS Safari 10.1 bug
    promise.constructor = Promise;
    then = bind(promise.then, promise);
    notify = function () {
      then(flush);
    };
  // Node.js without promises
  } else if (IS_NODE) {
    notify = function () {
      process.nextTick(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessage
  // - onreadystatechange
  // - setTimeout
  } else {
    // strange IE + webpack dev server bug - use .bind(global)
    macrotask = bind(macrotask, global);
    notify = function () {
      macrotask(flush);
    };
  }
}

module.exports = queueMicrotask || function (fn) {
  var task = { fn: fn, next: undefined };
  if (last) last.next = task;
  if (!head) {
    head = task;
    notify();
  } last = task;
};


/***/ }),

/***/ "b622":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var shared = __webpack_require__("5692");
var hasOwn = __webpack_require__("1a2d");
var uid = __webpack_require__("90e3");
var NATIVE_SYMBOL = __webpack_require__("4930");
var USE_SYMBOL_AS_UID = __webpack_require__("fdbf");

var WellKnownSymbolsStore = shared('wks');
var Symbol = global.Symbol;
var symbolFor = Symbol && Symbol['for'];
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol : Symbol && Symbol.withoutSetter || uid;

module.exports = function (name) {
  if (!hasOwn(WellKnownSymbolsStore, name) || !(NATIVE_SYMBOL || typeof WellKnownSymbolsStore[name] == 'string')) {
    var description = 'Symbol.' + name;
    if (NATIVE_SYMBOL && hasOwn(Symbol, name)) {
      WellKnownSymbolsStore[name] = Symbol[name];
    } else if (USE_SYMBOL_AS_UID && symbolFor) {
      WellKnownSymbolsStore[name] = symbolFor(description);
    } else {
      WellKnownSymbolsStore[name] = createWellKnownSymbol(description);
    }
  } return WellKnownSymbolsStore[name];
};


/***/ }),

/***/ "b64b":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var toObject = __webpack_require__("7b0b");
var nativeKeys = __webpack_require__("df75");
var fails = __webpack_require__("d039");

var FAILS_ON_PRIMITIVES = fails(function () { nativeKeys(1); });

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES }, {
  keys: function keys(it) {
    return nativeKeys(toObject(it));
  }
});


/***/ }),

/***/ "b65f":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");

var ceil = Math.ceil;
var floor = Math.floor;

// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
$({ target: 'Math', stat: true }, {
  trunc: function trunc(it) {
    return (it > 0 ? floor : ceil)(it);
  }
});


/***/ }),

/***/ "b680":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var global = __webpack_require__("da84");
var uncurryThis = __webpack_require__("e330");
var toIntegerOrInfinity = __webpack_require__("5926");
var thisNumberValue = __webpack_require__("408a");
var $repeat = __webpack_require__("1148");
var fails = __webpack_require__("d039");

var RangeError = global.RangeError;
var String = global.String;
var floor = Math.floor;
var repeat = uncurryThis($repeat);
var stringSlice = uncurryThis(''.slice);
var un$ToFixed = uncurryThis(1.0.toFixed);

var pow = function (x, n, acc) {
  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
};

var log = function (x) {
  var n = 0;
  var x2 = x;
  while (x2 >= 4096) {
    n += 12;
    x2 /= 4096;
  }
  while (x2 >= 2) {
    n += 1;
    x2 /= 2;
  } return n;
};

var multiply = function (data, n, c) {
  var index = -1;
  var c2 = c;
  while (++index < 6) {
    c2 += n * data[index];
    data[index] = c2 % 1e7;
    c2 = floor(c2 / 1e7);
  }
};

var divide = function (data, n) {
  var index = 6;
  var c = 0;
  while (--index >= 0) {
    c += data[index];
    data[index] = floor(c / n);
    c = (c % n) * 1e7;
  }
};

var dataToString = function (data) {
  var index = 6;
  var s = '';
  while (--index >= 0) {
    if (s !== '' || index === 0 || data[index] !== 0) {
      var t = String(data[index]);
      s = s === '' ? t : s + repeat('0', 7 - t.length) + t;
    }
  } return s;
};

var FORCED = fails(function () {
  return un$ToFixed(0.00008, 3) !== '0.000' ||
    un$ToFixed(0.9, 0) !== '1' ||
    un$ToFixed(1.255, 2) !== '1.25' ||
    un$ToFixed(1000000000000000128.0, 0) !== '1000000000000000128';
}) || !fails(function () {
  // V8 ~ Android 4.3-
  un$ToFixed({});
});

// `Number.prototype.toFixed` method
// https://tc39.es/ecma262/#sec-number.prototype.tofixed
$({ target: 'Number', proto: true, forced: FORCED }, {
  toFixed: function toFixed(fractionDigits) {
    var number = thisNumberValue(this);
    var fractDigits = toIntegerOrInfinity(fractionDigits);
    var data = [0, 0, 0, 0, 0, 0];
    var sign = '';
    var result = '0';
    var e, z, j, k;

    // TODO: ES2018 increased the maximum number of fraction digits to 100, need to improve the implementation
    if (fractDigits < 0 || fractDigits > 20) throw RangeError('Incorrect fraction digits');
    // eslint-disable-next-line no-self-compare -- NaN check
    if (number != number) return 'NaN';
    if (number <= -1e21 || number >= 1e21) return String(number);
    if (number < 0) {
      sign = '-';
      number = -number;
    }
    if (number > 1e-21) {
      e = log(number * pow(2, 69, 1)) - 69;
      z = e < 0 ? number * pow(2, -e, 1) : number / pow(2, e, 1);
      z *= 0x10000000000000;
      e = 52 - e;
      if (e > 0) {
        multiply(data, 0, z);
        j = fractDigits;
        while (j >= 7) {
          multiply(data, 1e7, 0);
          j -= 7;
        }
        multiply(data, pow(10, j, 1), 0);
        j = e - 1;
        while (j >= 23) {
          divide(data, 1 << 23);
          j -= 23;
        }
        divide(data, 1 << j);
        multiply(data, 1, 1);
        divide(data, 2);
        result = dataToString(data);
      } else {
        multiply(data, 0, z);
        multiply(data, 1 << -e, 0);
        result = dataToString(data) + repeat('0', fractDigits);
      }
    }
    if (fractDigits > 0) {
      k = result.length;
      result = sign + (k <= fractDigits
        ? '0.' + repeat('0', fractDigits - k) + result
        : stringSlice(result, 0, k - fractDigits) + '.' + stringSlice(result, k - fractDigits));
    } else {
      result = sign + result;
    } return result;
  }
});


/***/ }),

/***/ "b727":
/***/ (function(module, exports, __webpack_require__) {

var bind = __webpack_require__("0366");
var uncurryThis = __webpack_require__("e330");
var IndexedObject = __webpack_require__("44ad");
var toObject = __webpack_require__("7b0b");
var lengthOfArrayLike = __webpack_require__("07fa");
var arraySpeciesCreate = __webpack_require__("65f0");

var push = uncurryThis([].push);

// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterReject }` methods implementation
var createMethod = function (TYPE) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var IS_FILTER_REJECT = TYPE == 7;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  return function ($this, callbackfn, that, specificCreate) {
    var O = toObject($this);
    var self = IndexedObject(O);
    var boundFunction = bind(callbackfn, that);
    var length = lengthOfArrayLike(self);
    var index = 0;
    var create = specificCreate || arraySpeciesCreate;
    var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_REJECT ? create($this, 0) : undefined;
    var value, result;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      value = self[index];
      result = boundFunction(value, index, O);
      if (TYPE) {
        if (IS_MAP) target[index] = result; // map
        else if (result) switch (TYPE) {
          case 3: return true;              // some
          case 5: return value;             // find
          case 6: return index;             // findIndex
          case 2: push(target, value);      // filter
        } else switch (TYPE) {
          case 4: return false;             // every
          case 7: push(target, value);      // filterReject
        }
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
  };
};

module.exports = {
  // `Array.prototype.forEach` method
  // https://tc39.es/ecma262/#sec-array.prototype.foreach
  forEach: createMethod(0),
  // `Array.prototype.map` method
  // https://tc39.es/ecma262/#sec-array.prototype.map
  map: createMethod(1),
  // `Array.prototype.filter` method
  // https://tc39.es/ecma262/#sec-array.prototype.filter
  filter: createMethod(2),
  // `Array.prototype.some` method
  // https://tc39.es/ecma262/#sec-array.prototype.some
  some: createMethod(3),
  // `Array.prototype.every` method
  // https://tc39.es/ecma262/#sec-array.prototype.every
  every: createMethod(4),
  // `Array.prototype.find` method
  // https://tc39.es/ecma262/#sec-array.prototype.find
  find: createMethod(5),
  // `Array.prototype.findIndex` method
  // https://tc39.es/ecma262/#sec-array.prototype.findIndex
  findIndex: createMethod(6),
  // `Array.prototype.filterReject` method
  // https://github.com/tc39/proposal-array-filtering
  filterReject: createMethod(7)
};


/***/ }),

/***/ "b980":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");
var createPropertyDescriptor = __webpack_require__("5c6c");

module.exports = !fails(function () {
  var error = Error('a');
  if (!('stack' in error)) return true;
  // eslint-disable-next-line es-x/no-object-defineproperty -- safe
  Object.defineProperty(error, 'stack', createPropertyDescriptor(1, 7));
  return error.stack !== 7;
});


/***/ }),

/***/ "bb2f":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");

module.exports = !fails(function () {
  // eslint-disable-next-line es-x/no-object-isextensible, es-x/no-object-preventextensions -- required for testing
  return Object.isExtensible(Object.preventExtensions({}));
});


/***/ }),

/***/ "bb9e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_DateQuestion_vue_vue_type_style_index_0_id_faa9c936_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("f1a3");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_DateQuestion_vue_vue_type_style_index_0_id_faa9c936_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_DateQuestion_vue_vue_type_style_index_0_id_faa9c936_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "bd92":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ListItem_vue_vue_type_style_index_0_id_407472fa_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2982");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ListItem_vue_vue_type_style_index_0_id_407472fa_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ListItem_vue_vue_type_style_index_0_id_407472fa_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "c04e":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var call = __webpack_require__("c65b");
var isObject = __webpack_require__("861d");
var isSymbol = __webpack_require__("d9b5");
var getMethod = __webpack_require__("dc4a");
var ordinaryToPrimitive = __webpack_require__("485a");
var wellKnownSymbol = __webpack_require__("b622");

var TypeError = global.TypeError;
var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
module.exports = function (input, pref) {
  if (!isObject(input) || isSymbol(input)) return input;
  var exoticToPrim = getMethod(input, TO_PRIMITIVE);
  var result;
  if (exoticToPrim) {
    if (pref === undefined) pref = 'default';
    result = call(exoticToPrim, input, pref);
    if (!isObject(result) || isSymbol(result)) return result;
    throw TypeError("Can't convert object to primitive value");
  }
  if (pref === undefined) pref = 'number';
  return ordinaryToPrimitive(input, pref);
};


/***/ }),

/***/ "c32d":
/***/ (function(module, exports) {

module.exports = require("moment");

/***/ }),

/***/ "c430":
/***/ (function(module, exports) {

module.exports = false;


/***/ }),

/***/ "c513":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var hasOwn = __webpack_require__("1a2d");
var isSymbol = __webpack_require__("d9b5");
var tryToString = __webpack_require__("0d51");
var shared = __webpack_require__("5692");
var NATIVE_SYMBOL_REGISTRY = __webpack_require__("3d87");

var SymbolToStringRegistry = shared('symbol-to-string-registry');

// `Symbol.keyFor` method
// https://tc39.es/ecma262/#sec-symbol.keyfor
$({ target: 'Symbol', stat: true, forced: !NATIVE_SYMBOL_REGISTRY }, {
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(tryToString(sym) + ' is not a symbol');
    if (hasOwn(SymbolToStringRegistry, sym)) return SymbolToStringRegistry[sym];
  }
});


/***/ }),

/***/ "c607":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var DESCRIPTORS = __webpack_require__("83ab");
var UNSUPPORTED_DOT_ALL = __webpack_require__("fce3");
var classof = __webpack_require__("c6b6");
var defineBuiltInAccessor = __webpack_require__("edd0");
var getInternalState = __webpack_require__("69f3").get;

var RegExpPrototype = RegExp.prototype;
var TypeError = global.TypeError;

// `RegExp.prototype.dotAll` getter
// https://tc39.es/ecma262/#sec-get-regexp.prototype.dotall
if (DESCRIPTORS && UNSUPPORTED_DOT_ALL) {
  defineBuiltInAccessor(RegExpPrototype, 'dotAll', {
    configurable: true,
    get: function dotAll() {
      if (this === RegExpPrototype) return undefined;
      // We can't use InternalStateModule.getterFor because
      // we don't add metadata for regexps created by a literal.
      if (classof(this) === 'RegExp') {
        return !!getInternalState(this).dotAll;
      }
      throw TypeError('Incompatible receiver, RegExp required');
    }
  });
}


/***/ }),

/***/ "c60d":
/***/ (function(module, exports, __webpack_require__) {

var hasOwn = __webpack_require__("1a2d");

module.exports = function (descriptor) {
  return descriptor !== undefined && (hasOwn(descriptor, 'value') || hasOwn(descriptor, 'writable'));
};


/***/ }),

/***/ "c65b":
/***/ (function(module, exports, __webpack_require__) {

var NATIVE_BIND = __webpack_require__("40d5");

var call = Function.prototype.call;

module.exports = NATIVE_BIND ? call.bind(call) : function () {
  return call.apply(call, arguments);
};


/***/ }),

/***/ "c6b6":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("e330");

var toString = uncurryThis({}.toString);
var stringSlice = uncurryThis(''.slice);

module.exports = function (it) {
  return stringSlice(toString(it), 8, -1);
};


/***/ }),

/***/ "c6cd":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var setGlobal = __webpack_require__("ce4e");

var SHARED = '__core-js_shared__';
var store = global[SHARED] || setGlobal(SHARED, {});

module.exports = store;


/***/ }),

/***/ "c740":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var $findIndex = __webpack_require__("b727").findIndex;
var addToUnscopables = __webpack_require__("44d2");

var FIND_INDEX = 'findIndex';
var SKIPS_HOLES = true;

// Shouldn't skip holes
if (FIND_INDEX in []) Array(1)[FIND_INDEX](function () { SKIPS_HOLES = false; });

// `Array.prototype.findIndex` method
// https://tc39.es/ecma262/#sec-array.prototype.findindex
$({ target: 'Array', proto: true, forced: SKIPS_HOLES }, {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $findIndex(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables(FIND_INDEX);


/***/ }),

/***/ "c770":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("e330");

var $Error = Error;
var replace = uncurryThis(''.replace);

var TEST = (function (arg) { return String($Error(arg).stack); })('zxcasd');
var V8_OR_CHAKRA_STACK_ENTRY = /\n\s*at [^:]*:[^\n]*/;
var IS_V8_OR_CHAKRA_STACK = V8_OR_CHAKRA_STACK_ENTRY.test(TEST);

module.exports = function (stack, dropEntries) {
  if (IS_V8_OR_CHAKRA_STACK && typeof stack == 'string' && !$Error.prepareStackTrace) {
    while (dropEntries--) stack = replace(stack, V8_OR_CHAKRA_STACK_ENTRY, '');
  } return stack;
};


/***/ }),

/***/ "c8ba":
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || new Function("return this")();
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),

/***/ "c8d2":
/***/ (function(module, exports, __webpack_require__) {

var PROPER_FUNCTION_NAME = __webpack_require__("5e77").PROPER;
var fails = __webpack_require__("d039");
var whitespaces = __webpack_require__("5899");

var non = '\u200B\u0085\u180E';

// check that a method works with the correct list
// of whitespaces and has a correct name
module.exports = function (METHOD_NAME) {
  return fails(function () {
    return !!whitespaces[METHOD_NAME]()
      || non[METHOD_NAME]() !== non
      || (PROPER_FUNCTION_NAME && whitespaces[METHOD_NAME].name !== METHOD_NAME);
  });
};


/***/ }),

/***/ "ca84":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("e330");
var hasOwn = __webpack_require__("1a2d");
var toIndexedObject = __webpack_require__("fc6a");
var indexOf = __webpack_require__("4d64").indexOf;
var hiddenKeys = __webpack_require__("d012");

var push = uncurryThis([].push);

module.exports = function (object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !hasOwn(hiddenKeys, key) && hasOwn(O, key) && push(result, key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (hasOwn(O, key = names[i++])) {
    ~indexOf(result, key) || push(result, key);
  }
  return result;
};


/***/ }),

/***/ "caad":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var $includes = __webpack_require__("4d64").includes;
var fails = __webpack_require__("d039");
var addToUnscopables = __webpack_require__("44d2");

// FF99+ bug
var BROKEN_ON_SPARSE = fails(function () {
  return !Array(1).includes();
});

// `Array.prototype.includes` method
// https://tc39.es/ecma262/#sec-array.prototype.includes
$({ target: 'Array', proto: true, forced: BROKEN_ON_SPARSE }, {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('includes');


/***/ }),

/***/ "cb29":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var fill = __webpack_require__("81d5");
var addToUnscopables = __webpack_require__("44d2");

// `Array.prototype.fill` method
// https://tc39.es/ecma262/#sec-array.prototype.fill
$({ target: 'Array', proto: true }, {
  fill: fill
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('fill');


/***/ }),

/***/ "cb2d":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var isCallable = __webpack_require__("1626");
var createNonEnumerableProperty = __webpack_require__("9112");
var makeBuiltIn = __webpack_require__("13d2");
var setGlobal = __webpack_require__("ce4e");

module.exports = function (O, key, value, options) {
  var unsafe = options ? !!options.unsafe : false;
  var simple = options ? !!options.enumerable : false;
  var noTargetGet = options ? !!options.noTargetGet : false;
  var name = options && options.name !== undefined ? options.name : key;
  if (isCallable(value)) makeBuiltIn(value, name, options);
  if (O === global) {
    if (simple) O[key] = value;
    else setGlobal(key, value);
    return O;
  } else if (!unsafe) {
    delete O[key];
  } else if (!noTargetGet && O[key]) {
    simple = true;
  }
  if (simple) O[key] = value;
  else createNonEnumerableProperty(O, key, value);
  return O;
};


/***/ }),

/***/ "cc12":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var isObject = __webpack_require__("861d");

var document = global.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject(document) && isObject(document.createElement);

module.exports = function (it) {
  return EXISTS ? document.createElement(it) : {};
};


/***/ }),

/***/ "cc98":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var IS_PURE = __webpack_require__("c430");
var FORCED_PROMISE_CONSTRUCTOR = __webpack_require__("4738").CONSTRUCTOR;
var NativePromiseConstructor = __webpack_require__("d256");
var getBuiltIn = __webpack_require__("d066");
var isCallable = __webpack_require__("1626");
var defineBuiltIn = __webpack_require__("cb2d");

var NativePromisePrototype = NativePromiseConstructor && NativePromiseConstructor.prototype;

// `Promise.prototype.catch` method
// https://tc39.es/ecma262/#sec-promise.prototype.catch
$({ target: 'Promise', proto: true, forced: FORCED_PROMISE_CONSTRUCTOR, real: true }, {
  'catch': function (onRejected) {
    return this.then(undefined, onRejected);
  }
});

// makes sure that native promise-based APIs `Promise#catch` properly works with patched `Promise#then`
if (!IS_PURE && isCallable(NativePromiseConstructor)) {
  var method = getBuiltIn('Promise').prototype['catch'];
  if (NativePromisePrototype['catch'] !== method) {
    defineBuiltIn(NativePromisePrototype, 'catch', method, { unsafe: true });
  }
}


/***/ }),

/***/ "cca6":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var assign = __webpack_require__("60da");

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
// eslint-disable-next-line es-x/no-object-assign -- required for testing
$({ target: 'Object', stat: true, arity: 2, forced: Object.assign !== assign }, {
  assign: assign
});


/***/ }),

/***/ "cdf9":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("825a");
var isObject = __webpack_require__("861d");
var newPromiseCapability = __webpack_require__("f069");

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),

/***/ "ce4e":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");

// eslint-disable-next-line es-x/no-object-defineproperty -- safe
var defineProperty = Object.defineProperty;

module.exports = function (key, value) {
  try {
    defineProperty(global, key, { value: value, configurable: true, writable: true });
  } catch (error) {
    global[key] = value;
  } return value;
};


/***/ }),

/***/ "d012":
/***/ (function(module, exports) {

module.exports = {};


/***/ }),

/***/ "d039":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};


/***/ }),

/***/ "d066":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var isCallable = __webpack_require__("1626");

var aFunction = function (argument) {
  return isCallable(argument) ? argument : undefined;
};

module.exports = function (namespace, method) {
  return arguments.length < 2 ? aFunction(global[namespace]) : global[namespace] && global[namespace][method];
};


/***/ }),

/***/ "d1e7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor && !$propertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;


/***/ }),

/***/ "d256":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");

module.exports = global.Promise;


/***/ }),

/***/ "d28b":
/***/ (function(module, exports, __webpack_require__) {

var defineWellKnownSymbol = __webpack_require__("746f");

// `Symbol.iterator` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.iterator
defineWellKnownSymbol('iterator');


/***/ }),

/***/ "d2bb":
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable no-proto -- safe */
var uncurryThis = __webpack_require__("e330");
var anObject = __webpack_require__("825a");
var aPossiblePrototype = __webpack_require__("3bbe");

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es-x/no-object-setprototypeof -- safe
module.exports = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    // eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
    setter = uncurryThis(Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set);
    setter(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    anObject(O);
    aPossiblePrototype(proto);
    if (CORRECT_SETTER) setter(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);


/***/ }),

/***/ "d3b7":
/***/ (function(module, exports, __webpack_require__) {

var TO_STRING_TAG_SUPPORT = __webpack_require__("00ee");
var defineBuiltIn = __webpack_require__("cb2d");
var toString = __webpack_require__("b041");

// `Object.prototype.toString` method
// https://tc39.es/ecma262/#sec-object.prototype.tostring
if (!TO_STRING_TAG_SUPPORT) {
  defineBuiltIn(Object.prototype, 'toString', toString, { unsafe: true });
}


/***/ }),

/***/ "d44e":
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__("9bf2").f;
var hasOwn = __webpack_require__("1a2d");
var wellKnownSymbol = __webpack_require__("b622");

var TO_STRING_TAG = wellKnownSymbol('toStringTag');

module.exports = function (target, TAG, STATIC) {
  if (target && !STATIC) target = target.prototype;
  if (target && !hasOwn(target, TO_STRING_TAG)) {
    defineProperty(target, TO_STRING_TAG, { configurable: true, value: TAG });
  }
};


/***/ }),

/***/ "d4c3":
/***/ (function(module, exports, __webpack_require__) {

var userAgent = __webpack_require__("342f");
var global = __webpack_require__("da84");

module.exports = /ipad|iphone|ipod/i.test(userAgent) && global.Pebble !== undefined;


/***/ }),

/***/ "d5f8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_DecimalQuestion_vue_vue_type_style_index_0_id_5987878e_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("9d6a");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_DecimalQuestion_vue_vue_type_style_index_0_id_5987878e_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_DecimalQuestion_vue_vue_type_style_index_0_id_5987878e_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "d6d6":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");

var TypeError = global.TypeError;

module.exports = function (passed, required) {
  if (passed < required) throw TypeError('Not enough arguments');
  return passed;
};


/***/ }),

/***/ "d784":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// TODO: Remove from `core-js@4` since it's moved to entry points
__webpack_require__("ac1f");
var uncurryThis = __webpack_require__("e330");
var defineBuiltIn = __webpack_require__("cb2d");
var regexpExec = __webpack_require__("9263");
var fails = __webpack_require__("d039");
var wellKnownSymbol = __webpack_require__("b622");
var createNonEnumerableProperty = __webpack_require__("9112");

var SPECIES = wellKnownSymbol('species');
var RegExpPrototype = RegExp.prototype;

module.exports = function (KEY, exec, FORCED, SHAM) {
  var SYMBOL = wellKnownSymbol(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;

    if (KEY === 'split') {
      // We can't use real regex here since it causes deoptimization
      // and serious performance degradation in V8
      // https://github.com/zloirock/core-js/issues/306
      re = {};
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
      re.flags = '';
      re[SYMBOL] = /./[SYMBOL];
    }

    re.exec = function () { execCalled = true; return null; };

    re[SYMBOL]('');
    return !execCalled;
  });

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    FORCED
  ) {
    var uncurriedNativeRegExpMethod = uncurryThis(/./[SYMBOL]);
    var methods = exec(SYMBOL, ''[KEY], function (nativeMethod, regexp, str, arg2, forceStringMethod) {
      var uncurriedNativeMethod = uncurryThis(nativeMethod);
      var $exec = regexp.exec;
      if ($exec === regexpExec || $exec === RegExpPrototype.exec) {
        if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
          // The native String method already delegates to @@method (this
          // polyfilled function), leasing to infinite recursion.
          // We avoid it by directly calling the native @@method method.
          return { done: true, value: uncurriedNativeRegExpMethod(regexp, str, arg2) };
        }
        return { done: true, value: uncurriedNativeMethod(str, regexp, arg2) };
      }
      return { done: false };
    });

    defineBuiltIn(String.prototype, KEY, methods[0]);
    defineBuiltIn(RegExpPrototype, SYMBOL, methods[1]);
  }

  if (SHAM) createNonEnumerableProperty(RegExpPrototype[SYMBOL], 'sham', true);
};


/***/ }),

/***/ "d81d":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var $map = __webpack_require__("b727").map;
var arrayMethodHasSpeciesSupport = __webpack_require__("1dde");

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('map');

// `Array.prototype.map` method
// https://tc39.es/ecma262/#sec-array.prototype.map
// with adding support of @@species
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ "d86b":
/***/ (function(module, exports, __webpack_require__) {

// FF26- bug: ArrayBuffers are non-extensible, but Object.isExtensible does not report it
var fails = __webpack_require__("d039");

module.exports = fails(function () {
  if (typeof ArrayBuffer == 'function') {
    var buffer = new ArrayBuffer(8);
    // eslint-disable-next-line es-x/no-object-isextensible, es-x/no-object-defineproperty -- safe
    if (Object.isExtensible(buffer)) Object.defineProperty(buffer, 'a', { value: 8 });
  }
});


/***/ }),

/***/ "d998":
/***/ (function(module, exports, __webpack_require__) {

var UA = __webpack_require__("342f");

module.exports = /MSIE|Trident/.test(UA);


/***/ }),

/***/ "d9b5":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var getBuiltIn = __webpack_require__("d066");
var isCallable = __webpack_require__("1626");
var isPrototypeOf = __webpack_require__("3a9b");
var USE_SYMBOL_AS_UID = __webpack_require__("fdbf");

var Object = global.Object;

module.exports = USE_SYMBOL_AS_UID ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  var $Symbol = getBuiltIn('Symbol');
  return isCallable($Symbol) && isPrototypeOf($Symbol.prototype, Object(it));
};


/***/ }),

/***/ "d9e2":
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable no-unused-vars -- required for functions `.length` */
var $ = __webpack_require__("23e7");
var global = __webpack_require__("da84");
var apply = __webpack_require__("2ba4");
var wrapErrorConstructorWithCause = __webpack_require__("e5cb");

var WEB_ASSEMBLY = 'WebAssembly';
var WebAssembly = global[WEB_ASSEMBLY];

var FORCED = Error('e', { cause: 7 }).cause !== 7;

var exportGlobalErrorCauseWrapper = function (ERROR_NAME, wrapper) {
  var O = {};
  O[ERROR_NAME] = wrapErrorConstructorWithCause(ERROR_NAME, wrapper, FORCED);
  $({ global: true, arity: 1, forced: FORCED }, O);
};

var exportWebAssemblyErrorCauseWrapper = function (ERROR_NAME, wrapper) {
  if (WebAssembly && WebAssembly[ERROR_NAME]) {
    var O = {};
    O[ERROR_NAME] = wrapErrorConstructorWithCause(WEB_ASSEMBLY + '.' + ERROR_NAME, wrapper, FORCED);
    $({ target: WEB_ASSEMBLY, stat: true, arity: 1, forced: FORCED }, O);
  }
};

// https://github.com/tc39/proposal-error-cause
exportGlobalErrorCauseWrapper('Error', function (init) {
  return function Error(message) { return apply(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('EvalError', function (init) {
  return function EvalError(message) { return apply(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('RangeError', function (init) {
  return function RangeError(message) { return apply(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('ReferenceError', function (init) {
  return function ReferenceError(message) { return apply(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('SyntaxError', function (init) {
  return function SyntaxError(message) { return apply(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('TypeError', function (init) {
  return function TypeError(message) { return apply(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('URIError', function (init) {
  return function URIError(message) { return apply(init, this, arguments); };
});
exportWebAssemblyErrorCauseWrapper('CompileError', function (init) {
  return function CompileError(message) { return apply(init, this, arguments); };
});
exportWebAssemblyErrorCauseWrapper('LinkError', function (init) {
  return function LinkError(message) { return apply(init, this, arguments); };
});
exportWebAssemblyErrorCauseWrapper('RuntimeError', function (init) {
  return function RuntimeError(message) { return apply(init, this, arguments); };
});


/***/ }),

/***/ "d9f5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var global = __webpack_require__("da84");
var call = __webpack_require__("c65b");
var uncurryThis = __webpack_require__("e330");
var IS_PURE = __webpack_require__("c430");
var DESCRIPTORS = __webpack_require__("83ab");
var NATIVE_SYMBOL = __webpack_require__("4930");
var fails = __webpack_require__("d039");
var hasOwn = __webpack_require__("1a2d");
var isPrototypeOf = __webpack_require__("3a9b");
var anObject = __webpack_require__("825a");
var toIndexedObject = __webpack_require__("fc6a");
var toPropertyKey = __webpack_require__("a04b");
var $toString = __webpack_require__("577e");
var createPropertyDescriptor = __webpack_require__("5c6c");
var nativeObjectCreate = __webpack_require__("7c73");
var objectKeys = __webpack_require__("df75");
var getOwnPropertyNamesModule = __webpack_require__("241c");
var getOwnPropertyNamesExternal = __webpack_require__("057f");
var getOwnPropertySymbolsModule = __webpack_require__("7418");
var getOwnPropertyDescriptorModule = __webpack_require__("06cf");
var definePropertyModule = __webpack_require__("9bf2");
var definePropertiesModule = __webpack_require__("37e8");
var propertyIsEnumerableModule = __webpack_require__("d1e7");
var defineBuiltIn = __webpack_require__("cb2d");
var shared = __webpack_require__("5692");
var sharedKey = __webpack_require__("f772");
var hiddenKeys = __webpack_require__("d012");
var uid = __webpack_require__("90e3");
var wellKnownSymbol = __webpack_require__("b622");
var wrappedWellKnownSymbolModule = __webpack_require__("e538");
var defineWellKnownSymbol = __webpack_require__("746f");
var defineSymbolToPrimitive = __webpack_require__("57b9");
var setToStringTag = __webpack_require__("d44e");
var InternalStateModule = __webpack_require__("69f3");
var $forEach = __webpack_require__("b727").forEach;

var HIDDEN = sharedKey('hidden');
var SYMBOL = 'Symbol';
var PROTOTYPE = 'prototype';

var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(SYMBOL);

var ObjectPrototype = Object[PROTOTYPE];
var $Symbol = global.Symbol;
var SymbolPrototype = $Symbol && $Symbol[PROTOTYPE];
var TypeError = global.TypeError;
var QObject = global.QObject;
var nativeGetOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
var nativeDefineProperty = definePropertyModule.f;
var nativeGetOwnPropertyNames = getOwnPropertyNamesExternal.f;
var nativePropertyIsEnumerable = propertyIsEnumerableModule.f;
var push = uncurryThis([].push);

var AllSymbols = shared('symbols');
var ObjectPrototypeSymbols = shared('op-symbols');
var WellKnownSymbolsStore = shared('wks');

// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var USE_SETTER = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDescriptor = DESCRIPTORS && fails(function () {
  return nativeObjectCreate(nativeDefineProperty({}, 'a', {
    get: function () { return nativeDefineProperty(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (O, P, Attributes) {
  var ObjectPrototypeDescriptor = nativeGetOwnPropertyDescriptor(ObjectPrototype, P);
  if (ObjectPrototypeDescriptor) delete ObjectPrototype[P];
  nativeDefineProperty(O, P, Attributes);
  if (ObjectPrototypeDescriptor && O !== ObjectPrototype) {
    nativeDefineProperty(ObjectPrototype, P, ObjectPrototypeDescriptor);
  }
} : nativeDefineProperty;

var wrap = function (tag, description) {
  var symbol = AllSymbols[tag] = nativeObjectCreate(SymbolPrototype);
  setInternalState(symbol, {
    type: SYMBOL,
    tag: tag,
    description: description
  });
  if (!DESCRIPTORS) symbol.description = description;
  return symbol;
};

var $defineProperty = function defineProperty(O, P, Attributes) {
  if (O === ObjectPrototype) $defineProperty(ObjectPrototypeSymbols, P, Attributes);
  anObject(O);
  var key = toPropertyKey(P);
  anObject(Attributes);
  if (hasOwn(AllSymbols, key)) {
    if (!Attributes.enumerable) {
      if (!hasOwn(O, HIDDEN)) nativeDefineProperty(O, HIDDEN, createPropertyDescriptor(1, {}));
      O[HIDDEN][key] = true;
    } else {
      if (hasOwn(O, HIDDEN) && O[HIDDEN][key]) O[HIDDEN][key] = false;
      Attributes = nativeObjectCreate(Attributes, { enumerable: createPropertyDescriptor(0, false) });
    } return setSymbolDescriptor(O, key, Attributes);
  } return nativeDefineProperty(O, key, Attributes);
};

var $defineProperties = function defineProperties(O, Properties) {
  anObject(O);
  var properties = toIndexedObject(Properties);
  var keys = objectKeys(properties).concat($getOwnPropertySymbols(properties));
  $forEach(keys, function (key) {
    if (!DESCRIPTORS || call($propertyIsEnumerable, properties, key)) $defineProperty(O, key, properties[key]);
  });
  return O;
};

var $create = function create(O, Properties) {
  return Properties === undefined ? nativeObjectCreate(O) : $defineProperties(nativeObjectCreate(O), Properties);
};

var $propertyIsEnumerable = function propertyIsEnumerable(V) {
  var P = toPropertyKey(V);
  var enumerable = call(nativePropertyIsEnumerable, this, P);
  if (this === ObjectPrototype && hasOwn(AllSymbols, P) && !hasOwn(ObjectPrototypeSymbols, P)) return false;
  return enumerable || !hasOwn(this, P) || !hasOwn(AllSymbols, P) || hasOwn(this, HIDDEN) && this[HIDDEN][P]
    ? enumerable : true;
};

var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(O, P) {
  var it = toIndexedObject(O);
  var key = toPropertyKey(P);
  if (it === ObjectPrototype && hasOwn(AllSymbols, key) && !hasOwn(ObjectPrototypeSymbols, key)) return;
  var descriptor = nativeGetOwnPropertyDescriptor(it, key);
  if (descriptor && hasOwn(AllSymbols, key) && !(hasOwn(it, HIDDEN) && it[HIDDEN][key])) {
    descriptor.enumerable = true;
  }
  return descriptor;
};

var $getOwnPropertyNames = function getOwnPropertyNames(O) {
  var names = nativeGetOwnPropertyNames(toIndexedObject(O));
  var result = [];
  $forEach(names, function (key) {
    if (!hasOwn(AllSymbols, key) && !hasOwn(hiddenKeys, key)) push(result, key);
  });
  return result;
};

var $getOwnPropertySymbols = function (O) {
  var IS_OBJECT_PROTOTYPE = O === ObjectPrototype;
  var names = nativeGetOwnPropertyNames(IS_OBJECT_PROTOTYPE ? ObjectPrototypeSymbols : toIndexedObject(O));
  var result = [];
  $forEach(names, function (key) {
    if (hasOwn(AllSymbols, key) && (!IS_OBJECT_PROTOTYPE || hasOwn(ObjectPrototype, key))) {
      push(result, AllSymbols[key]);
    }
  });
  return result;
};

// `Symbol` constructor
// https://tc39.es/ecma262/#sec-symbol-constructor
if (!NATIVE_SYMBOL) {
  $Symbol = function Symbol() {
    if (isPrototypeOf(SymbolPrototype, this)) throw TypeError('Symbol is not a constructor');
    var description = !arguments.length || arguments[0] === undefined ? undefined : $toString(arguments[0]);
    var tag = uid(description);
    var setter = function (value) {
      if (this === ObjectPrototype) call(setter, ObjectPrototypeSymbols, value);
      if (hasOwn(this, HIDDEN) && hasOwn(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDescriptor(this, tag, createPropertyDescriptor(1, value));
    };
    if (DESCRIPTORS && USE_SETTER) setSymbolDescriptor(ObjectPrototype, tag, { configurable: true, set: setter });
    return wrap(tag, description);
  };

  SymbolPrototype = $Symbol[PROTOTYPE];

  defineBuiltIn(SymbolPrototype, 'toString', function toString() {
    return getInternalState(this).tag;
  });

  defineBuiltIn($Symbol, 'withoutSetter', function (description) {
    return wrap(uid(description), description);
  });

  propertyIsEnumerableModule.f = $propertyIsEnumerable;
  definePropertyModule.f = $defineProperty;
  definePropertiesModule.f = $defineProperties;
  getOwnPropertyDescriptorModule.f = $getOwnPropertyDescriptor;
  getOwnPropertyNamesModule.f = getOwnPropertyNamesExternal.f = $getOwnPropertyNames;
  getOwnPropertySymbolsModule.f = $getOwnPropertySymbols;

  wrappedWellKnownSymbolModule.f = function (name) {
    return wrap(wellKnownSymbol(name), name);
  };

  if (DESCRIPTORS) {
    // https://github.com/tc39/proposal-Symbol-description
    nativeDefineProperty(SymbolPrototype, 'description', {
      configurable: true,
      get: function description() {
        return getInternalState(this).description;
      }
    });
    if (!IS_PURE) {
      defineBuiltIn(ObjectPrototype, 'propertyIsEnumerable', $propertyIsEnumerable, { unsafe: true });
    }
  }
}

$({ global: true, wrap: true, forced: !NATIVE_SYMBOL, sham: !NATIVE_SYMBOL }, {
  Symbol: $Symbol
});

$forEach(objectKeys(WellKnownSymbolsStore), function (name) {
  defineWellKnownSymbol(name);
});

$({ target: SYMBOL, stat: true, forced: !NATIVE_SYMBOL }, {
  useSetter: function () { USE_SETTER = true; },
  useSimple: function () { USE_SETTER = false; }
});

$({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL, sham: !DESCRIPTORS }, {
  // `Object.create` method
  // https://tc39.es/ecma262/#sec-object.create
  create: $create,
  // `Object.defineProperty` method
  // https://tc39.es/ecma262/#sec-object.defineproperty
  defineProperty: $defineProperty,
  // `Object.defineProperties` method
  // https://tc39.es/ecma262/#sec-object.defineproperties
  defineProperties: $defineProperties,
  // `Object.getOwnPropertyDescriptor` method
  // https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor
});

$({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL }, {
  // `Object.getOwnPropertyNames` method
  // https://tc39.es/ecma262/#sec-object.getownpropertynames
  getOwnPropertyNames: $getOwnPropertyNames
});

// `Symbol.prototype[@@toPrimitive]` method
// https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
defineSymbolToPrimitive();

// `Symbol.prototype[@@toStringTag]` property
// https://tc39.es/ecma262/#sec-symbol.prototype-@@tostringtag
setToStringTag($Symbol, SYMBOL);

hiddenKeys[HIDDEN] = true;


/***/ }),

/***/ "da84":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
module.exports =
  // eslint-disable-next-line es-x/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof global == 'object' && global) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || Function('return this')();

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("c8ba")))

/***/ }),

/***/ "dab1":
/***/ (function(module) {

module.exports = JSON.parse("{\"resourceType\":\"ValueSet\",\"status\":\"active\",\"compose\":{\"include\":[{\"system\":\"http://hl7.org/fhir/contact-point-system\"}]},\"expansion\":{\"identifier\":\"urn:uuid:82c933c0-aa9b-40f5-b29d-129f367f3275\",\"timestamp\":\"2018-09-13T16:50:59+02:00\",\"total\":7,\"parameter\":[{\"name\":\"version\",\"valueUri\":\"http://hl7.org/fhir/contact-point-system|3.0.1\"}],\"contains\":[{\"system\":\"http://hl7.org/fhir/contact-point-system\",\"code\":\"phone\",\"display\":\"Phone\"},{\"system\":\"http://hl7.org/fhir/contact-point-system\",\"code\":\"fax\",\"display\":\"Fax\"},{\"system\":\"http://hl7.org/fhir/contact-point-system\",\"code\":\"email\",\"display\":\"Email\"},{\"system\":\"http://hl7.org/fhir/contact-point-system\",\"code\":\"pager\",\"display\":\"Pager\"},{\"system\":\"http://hl7.org/fhir/contact-point-system\",\"code\":\"url\",\"display\":\"URL\"},{\"system\":\"http://hl7.org/fhir/contact-point-system\",\"code\":\"sms\",\"display\":\"SMS\"},{\"system\":\"http://hl7.org/fhir/contact-point-system\",\"code\":\"other\",\"display\":\"Other\"}]}}");

/***/ }),

/***/ "dbb4":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var DESCRIPTORS = __webpack_require__("83ab");
var ownKeys = __webpack_require__("56ef");
var toIndexedObject = __webpack_require__("fc6a");
var getOwnPropertyDescriptorModule = __webpack_require__("06cf");
var createProperty = __webpack_require__("8418");

// `Object.getOwnPropertyDescriptors` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
$({ target: 'Object', stat: true, sham: !DESCRIPTORS }, {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIndexedObject(object);
    var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
    var keys = ownKeys(O);
    var result = {};
    var index = 0;
    var key, descriptor;
    while (keys.length > index) {
      descriptor = getOwnPropertyDescriptor(O, key = keys[index++]);
      if (descriptor !== undefined) createProperty(result, key, descriptor);
    }
    return result;
  }
});


/***/ }),

/***/ "dc1f":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "dc4a":
/***/ (function(module, exports, __webpack_require__) {

var aCallable = __webpack_require__("59ed");

// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
module.exports = function (V, P) {
  var func = V[P];
  return func == null ? undefined : aCallable(func);
};


/***/ }),

/***/ "dca8":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var FREEZING = __webpack_require__("bb2f");
var fails = __webpack_require__("d039");
var isObject = __webpack_require__("861d");
var onFreeze = __webpack_require__("f183").onFreeze;

// eslint-disable-next-line es-x/no-object-freeze -- safe
var $freeze = Object.freeze;
var FAILS_ON_PRIMITIVES = fails(function () { $freeze(1); });

// `Object.freeze` method
// https://tc39.es/ecma262/#sec-object.freeze
$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES, sham: !FREEZING }, {
  freeze: function freeze(it) {
    return $freeze && isObject(it) ? $freeze(onFreeze(it)) : it;
  }
});


/***/ }),

/***/ "ddb0":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var DOMIterables = __webpack_require__("fdbc");
var DOMTokenListPrototype = __webpack_require__("785a");
var ArrayIteratorMethods = __webpack_require__("e260");
var createNonEnumerableProperty = __webpack_require__("9112");
var wellKnownSymbol = __webpack_require__("b622");

var ITERATOR = wellKnownSymbol('iterator');
var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var ArrayValues = ArrayIteratorMethods.values;

var handlePrototype = function (CollectionPrototype, COLLECTION_NAME) {
  if (CollectionPrototype) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype[ITERATOR] !== ArrayValues) try {
      createNonEnumerableProperty(CollectionPrototype, ITERATOR, ArrayValues);
    } catch (error) {
      CollectionPrototype[ITERATOR] = ArrayValues;
    }
    if (!CollectionPrototype[TO_STRING_TAG]) {
      createNonEnumerableProperty(CollectionPrototype, TO_STRING_TAG, COLLECTION_NAME);
    }
    if (DOMIterables[COLLECTION_NAME]) for (var METHOD_NAME in ArrayIteratorMethods) {
      // some Chrome versions have non-configurable methods on DOMTokenList
      if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME]) try {
        createNonEnumerableProperty(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
      } catch (error) {
        CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
      }
    }
  }
};

for (var COLLECTION_NAME in DOMIterables) {
  handlePrototype(global[COLLECTION_NAME] && global[COLLECTION_NAME].prototype, COLLECTION_NAME);
}

handlePrototype(DOMTokenListPrototype, 'DOMTokenList');


/***/ }),

/***/ "df33":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "df75":
/***/ (function(module, exports, __webpack_require__) {

var internalObjectKeys = __webpack_require__("ca84");
var enumBugKeys = __webpack_require__("7839");

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es-x/no-object-keys -- safe
module.exports = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys);
};


/***/ }),

/***/ "e01a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// `Symbol.prototype.description` getter
// https://tc39.es/ecma262/#sec-symbol.prototype.description

var $ = __webpack_require__("23e7");
var DESCRIPTORS = __webpack_require__("83ab");
var global = __webpack_require__("da84");
var uncurryThis = __webpack_require__("e330");
var hasOwn = __webpack_require__("1a2d");
var isCallable = __webpack_require__("1626");
var isPrototypeOf = __webpack_require__("3a9b");
var toString = __webpack_require__("577e");
var defineProperty = __webpack_require__("9bf2").f;
var copyConstructorProperties = __webpack_require__("e893");

var NativeSymbol = global.Symbol;
var SymbolPrototype = NativeSymbol && NativeSymbol.prototype;

if (DESCRIPTORS && isCallable(NativeSymbol) && (!('description' in SymbolPrototype) ||
  // Safari 12 bug
  NativeSymbol().description !== undefined
)) {
  var EmptyStringDescriptionStore = {};
  // wrap Symbol constructor for correct work with undefined description
  var SymbolWrapper = function Symbol() {
    var description = arguments.length < 1 || arguments[0] === undefined ? undefined : toString(arguments[0]);
    var result = isPrototypeOf(SymbolPrototype, this)
      ? new NativeSymbol(description)
      // in Edge 13, String(Symbol(undefined)) === 'Symbol(undefined)'
      : description === undefined ? NativeSymbol() : NativeSymbol(description);
    if (description === '') EmptyStringDescriptionStore[result] = true;
    return result;
  };

  copyConstructorProperties(SymbolWrapper, NativeSymbol);
  SymbolWrapper.prototype = SymbolPrototype;
  SymbolPrototype.constructor = SymbolWrapper;

  var NATIVE_SYMBOL = String(NativeSymbol('test')) == 'Symbol(test)';
  var symbolToString = uncurryThis(SymbolPrototype.toString);
  var symbolValueOf = uncurryThis(SymbolPrototype.valueOf);
  var regexp = /^Symbol\((.*)\)[^)]+$/;
  var replace = uncurryThis(''.replace);
  var stringSlice = uncurryThis(''.slice);

  defineProperty(SymbolPrototype, 'description', {
    configurable: true,
    get: function description() {
      var symbol = symbolValueOf(this);
      var string = symbolToString(symbol);
      if (hasOwn(EmptyStringDescriptionStore, symbol)) return '';
      var desc = NATIVE_SYMBOL ? stringSlice(string, 7, -1) : replace(string, regexp, '$1');
      return desc === '' ? undefined : desc;
    }
  });

  $({ global: true, forced: true }, {
    Symbol: SymbolWrapper
  });
}


/***/ }),

/***/ "e163":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var hasOwn = __webpack_require__("1a2d");
var isCallable = __webpack_require__("1626");
var toObject = __webpack_require__("7b0b");
var sharedKey = __webpack_require__("f772");
var CORRECT_PROTOTYPE_GETTER = __webpack_require__("e177");

var IE_PROTO = sharedKey('IE_PROTO');
var Object = global.Object;
var ObjectPrototype = Object.prototype;

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
module.exports = CORRECT_PROTOTYPE_GETTER ? Object.getPrototypeOf : function (O) {
  var object = toObject(O);
  if (hasOwn(object, IE_PROTO)) return object[IE_PROTO];
  var constructor = object.constructor;
  if (isCallable(constructor) && object instanceof constructor) {
    return constructor.prototype;
  } return object instanceof Object ? ObjectPrototype : null;
};


/***/ }),

/***/ "e177":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");

module.exports = !fails(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  // eslint-disable-next-line es-x/no-object-getprototypeof -- required for testing
  return Object.getPrototypeOf(new F()) !== F.prototype;
});


/***/ }),

/***/ "e260":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toIndexedObject = __webpack_require__("fc6a");
var addToUnscopables = __webpack_require__("44d2");
var Iterators = __webpack_require__("3f8c");
var InternalStateModule = __webpack_require__("69f3");
var defineProperty = __webpack_require__("9bf2").f;
var defineIterator = __webpack_require__("7dd0");
var IS_PURE = __webpack_require__("c430");
var DESCRIPTORS = __webpack_require__("83ab");

var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
module.exports = defineIterator(Array, 'Array', function (iterated, kind) {
  setInternalState(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject(iterated), // target
    index: 0,                          // next index
    kind: kind                         // kind
  });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState(this);
  var target = state.target;
  var kind = state.kind;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = undefined;
    return { value: undefined, done: true };
  }
  if (kind == 'keys') return { value: index, done: false };
  if (kind == 'values') return { value: target[index], done: false };
  return { value: [index, target[index]], done: false };
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
var values = Iterators.Arguments = Iterators.Array;

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');

// V8 ~ Chrome 45- bug
if (!IS_PURE && DESCRIPTORS && values.name !== 'values') try {
  defineProperty(values, 'name', { value: 'values' });
} catch (error) { /* empty */ }


/***/ }),

/***/ "e285":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");

var globalIsFinite = global.isFinite;

// `Number.isFinite` method
// https://tc39.es/ecma262/#sec-number.isfinite
// eslint-disable-next-line es-x/no-number-isfinite -- safe
module.exports = Number.isFinite || function isFinite(it) {
  return typeof it == 'number' && globalIsFinite(it);
};


/***/ }),

/***/ "e330":
/***/ (function(module, exports, __webpack_require__) {

var NATIVE_BIND = __webpack_require__("40d5");

var FunctionPrototype = Function.prototype;
var bind = FunctionPrototype.bind;
var call = FunctionPrototype.call;
var uncurryThis = NATIVE_BIND && bind.bind(call, call);

module.exports = NATIVE_BIND ? function (fn) {
  return fn && uncurryThis(fn);
} : function (fn) {
  return fn && function () {
    return call.apply(fn, arguments);
  };
};


/***/ }),

/***/ "e391":
/***/ (function(module, exports, __webpack_require__) {

var toString = __webpack_require__("577e");

module.exports = function (argument, $default) {
  return argument === undefined ? arguments.length < 2 ? '' : $default : toString(argument);
};


/***/ }),

/***/ "e439":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var fails = __webpack_require__("d039");
var toIndexedObject = __webpack_require__("fc6a");
var nativeGetOwnPropertyDescriptor = __webpack_require__("06cf").f;
var DESCRIPTORS = __webpack_require__("83ab");

var FAILS_ON_PRIMITIVES = fails(function () { nativeGetOwnPropertyDescriptor(1); });
var FORCED = !DESCRIPTORS || FAILS_ON_PRIMITIVES;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
$({ target: 'Object', stat: true, forced: FORCED, sham: !DESCRIPTORS }, {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(it, key) {
    return nativeGetOwnPropertyDescriptor(toIndexedObject(it), key);
  }
});


/***/ }),

/***/ "e538":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("b622");

exports.f = wellKnownSymbol;


/***/ }),

/***/ "e5cb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var getBuiltIn = __webpack_require__("d066");
var hasOwn = __webpack_require__("1a2d");
var createNonEnumerableProperty = __webpack_require__("9112");
var isPrototypeOf = __webpack_require__("3a9b");
var setPrototypeOf = __webpack_require__("d2bb");
var copyConstructorProperties = __webpack_require__("e893");
var proxyAccessor = __webpack_require__("aeb0");
var inheritIfRequired = __webpack_require__("7156");
var normalizeStringArgument = __webpack_require__("e391");
var installErrorCause = __webpack_require__("ab36");
var clearErrorStack = __webpack_require__("c770");
var ERROR_STACK_INSTALLABLE = __webpack_require__("b980");
var DESCRIPTORS = __webpack_require__("83ab");
var IS_PURE = __webpack_require__("c430");

module.exports = function (FULL_NAME, wrapper, FORCED, IS_AGGREGATE_ERROR) {
  var STACK_TRACE_LIMIT = 'stackTraceLimit';
  var OPTIONS_POSITION = IS_AGGREGATE_ERROR ? 2 : 1;
  var path = FULL_NAME.split('.');
  var ERROR_NAME = path[path.length - 1];
  var OriginalError = getBuiltIn.apply(null, path);

  if (!OriginalError) return;

  var OriginalErrorPrototype = OriginalError.prototype;

  // V8 9.3- bug https://bugs.chromium.org/p/v8/issues/detail?id=12006
  if (!IS_PURE && hasOwn(OriginalErrorPrototype, 'cause')) delete OriginalErrorPrototype.cause;

  if (!FORCED) return OriginalError;

  var BaseError = getBuiltIn('Error');

  var WrappedError = wrapper(function (a, b) {
    var message = normalizeStringArgument(IS_AGGREGATE_ERROR ? b : a, undefined);
    var result = IS_AGGREGATE_ERROR ? new OriginalError(a) : new OriginalError();
    if (message !== undefined) createNonEnumerableProperty(result, 'message', message);
    if (ERROR_STACK_INSTALLABLE) createNonEnumerableProperty(result, 'stack', clearErrorStack(result.stack, 2));
    if (this && isPrototypeOf(OriginalErrorPrototype, this)) inheritIfRequired(result, this, WrappedError);
    if (arguments.length > OPTIONS_POSITION) installErrorCause(result, arguments[OPTIONS_POSITION]);
    return result;
  });

  WrappedError.prototype = OriginalErrorPrototype;

  if (ERROR_NAME !== 'Error') {
    if (setPrototypeOf) setPrototypeOf(WrappedError, BaseError);
    else copyConstructorProperties(WrappedError, BaseError, { name: true });
  } else if (DESCRIPTORS && STACK_TRACE_LIMIT in OriginalError) {
    proxyAccessor(WrappedError, OriginalError, STACK_TRACE_LIMIT);
    proxyAccessor(WrappedError, OriginalError, 'prepareStackTrace');
  }

  copyConstructorProperties(WrappedError, OriginalError);

  if (!IS_PURE) try {
    // Safari 13- bug: WebAssembly errors does not have a proper `.name`
    if (OriginalErrorPrototype.name !== ERROR_NAME) {
      createNonEnumerableProperty(OriginalErrorPrototype, 'name', ERROR_NAME);
    }
    OriginalErrorPrototype.constructor = WrappedError;
  } catch (error) { /* empty */ }

  return WrappedError;
};


/***/ }),

/***/ "e667":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { error: false, value: exec() };
  } catch (error) {
    return { error: true, value: error };
  }
};


/***/ }),

/***/ "e6cf":
/***/ (function(module, exports, __webpack_require__) {

// TODO: Remove this module from `core-js@4` since it's split to modules listed below
__webpack_require__("5e7e");
__webpack_require__("14e5");
__webpack_require__("cc98");
__webpack_require__("3529");
__webpack_require__("f22b");
__webpack_require__("7149");


/***/ }),

/***/ "e893":
/***/ (function(module, exports, __webpack_require__) {

var hasOwn = __webpack_require__("1a2d");
var ownKeys = __webpack_require__("56ef");
var getOwnPropertyDescriptorModule = __webpack_require__("06cf");
var definePropertyModule = __webpack_require__("9bf2");

module.exports = function (target, source, exceptions) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!hasOwn(target, key) && !(exceptions && hasOwn(exceptions, key))) {
      defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
  }
};


/***/ }),

/***/ "e8b5":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("c6b6");

// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es-x/no-array-isarray -- safe
module.exports = Array.isArray || function isArray(argument) {
  return classof(argument) == 'Array';
};


/***/ }),

/***/ "e95a":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("b622");
var Iterators = __webpack_require__("3f8c");

var ITERATOR = wellKnownSymbol('iterator');
var ArrayPrototype = Array.prototype;

// check on default Array iterator
module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayPrototype[ITERATOR] === it);
};


/***/ }),

/***/ "e9c4":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var getBuiltIn = __webpack_require__("d066");
var apply = __webpack_require__("2ba4");
var call = __webpack_require__("c65b");
var uncurryThis = __webpack_require__("e330");
var fails = __webpack_require__("d039");
var isArray = __webpack_require__("e8b5");
var isCallable = __webpack_require__("1626");
var isObject = __webpack_require__("861d");
var isSymbol = __webpack_require__("d9b5");
var arraySlice = __webpack_require__("f36a");
var NATIVE_SYMBOL = __webpack_require__("4930");

var $stringify = getBuiltIn('JSON', 'stringify');
var exec = uncurryThis(/./.exec);
var charAt = uncurryThis(''.charAt);
var charCodeAt = uncurryThis(''.charCodeAt);
var replace = uncurryThis(''.replace);
var numberToString = uncurryThis(1.0.toString);

var tester = /[\uD800-\uDFFF]/g;
var low = /^[\uD800-\uDBFF]$/;
var hi = /^[\uDC00-\uDFFF]$/;

var WRONG_SYMBOLS_CONVERSION = !NATIVE_SYMBOL || fails(function () {
  var symbol = getBuiltIn('Symbol')();
  // MS Edge converts symbol values to JSON as {}
  return $stringify([symbol]) != '[null]'
    // WebKit converts symbol values to JSON as null
    || $stringify({ a: symbol }) != '{}'
    // V8 throws on boxed symbols
    || $stringify(Object(symbol)) != '{}';
});

// https://github.com/tc39/proposal-well-formed-stringify
var ILL_FORMED_UNICODE = fails(function () {
  return $stringify('\uDF06\uD834') !== '"\\udf06\\ud834"'
    || $stringify('\uDEAD') !== '"\\udead"';
});

var stringifyWithSymbolsFix = function (it, replacer) {
  var args = arraySlice(arguments);
  var $replacer = replacer;
  if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
  if (!isArray(replacer)) replacer = function (key, value) {
    if (isCallable($replacer)) value = call($replacer, this, key, value);
    if (!isSymbol(value)) return value;
  };
  args[1] = replacer;
  return apply($stringify, null, args);
};

var fixIllFormed = function (match, offset, string) {
  var prev = charAt(string, offset - 1);
  var next = charAt(string, offset + 1);
  if ((exec(low, match) && !exec(hi, next)) || (exec(hi, match) && !exec(low, prev))) {
    return '\\u' + numberToString(charCodeAt(match, 0), 16);
  } return match;
};

if ($stringify) {
  // `JSON.stringify` method
  // https://tc39.es/ecma262/#sec-json.stringify
  $({ target: 'JSON', stat: true, arity: 3, forced: WRONG_SYMBOLS_CONVERSION || ILL_FORMED_UNICODE }, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    stringify: function stringify(it, replacer, space) {
      var args = arraySlice(arguments);
      var result = apply(WRONG_SYMBOLS_CONVERSION ? stringifyWithSymbolsFix : $stringify, null, args);
      return ILL_FORMED_UNICODE && typeof result == 'string' ? replace(result, tester, fixIllFormed) : result;
    }
  });
}


/***/ }),

/***/ "ea92":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UrlQuestion_vue_vue_type_style_index_0_id_544dc1c0_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ee3a");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UrlQuestion_vue_vue_type_style_index_0_id_544dc1c0_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_UrlQuestion_vue_vue_type_style_index_0_id_544dc1c0_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "eac5":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("861d");

var floor = Math.floor;

// `IsIntegralNumber` abstract operation
// https://tc39.es/ecma262/#sec-isintegralnumber
// eslint-disable-next-line es-x/no-number-isinteger -- safe
module.exports = Number.isInteger || function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};


/***/ }),

/***/ "ecec":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "ed8c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_BooleanQuestion_vue_vue_type_style_index_0_id_605b57c9_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("6ae1");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_BooleanQuestion_vue_vue_type_style_index_0_id_605b57c9_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_BooleanQuestion_vue_vue_type_style_index_0_id_605b57c9_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "edd0":
/***/ (function(module, exports, __webpack_require__) {

var makeBuiltIn = __webpack_require__("13d2");
var defineProperty = __webpack_require__("9bf2");

module.exports = function (target, name, descriptor) {
  if (descriptor.get) makeBuiltIn(descriptor.get, name, { getter: true });
  if (descriptor.set) makeBuiltIn(descriptor.set, name, { setter: true });
  return defineProperty.f(target, name, descriptor);
};


/***/ }),

/***/ "ee3a":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "eee7":
/***/ (function(module, exports, __webpack_require__) {

// TODO: Remove this line from `core-js@4`
__webpack_require__("02ec");
var $ = __webpack_require__("23e7");
var trimStart = __webpack_require__("67b6");

// `String.prototype.trimStart` method
// https://tc39.es/ecma262/#sec-string.prototype.trimstart
// eslint-disable-next-line es-x/no-string-prototype-trimstart-trimend -- safe
$({ target: 'String', proto: true, name: 'trimStart', forced: ''.trimStart !== trimStart }, {
  trimStart: trimStart
});


/***/ }),

/***/ "f00c":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var numberIsFinite = __webpack_require__("e285");

// `Number.isFinite` method
// https://tc39.es/ecma262/#sec-number.isfinite
$({ target: 'Number', stat: true }, { isFinite: numberIsFinite });


/***/ }),

/***/ "f069":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var aCallable = __webpack_require__("59ed");

var PromiseCapability = function (C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aCallable(resolve);
  this.reject = aCallable(reject);
};

// `NewPromiseCapability` abstract operation
// https://tc39.es/ecma262/#sec-newpromisecapability
module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),

/***/ "f183":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var uncurryThis = __webpack_require__("e330");
var hiddenKeys = __webpack_require__("d012");
var isObject = __webpack_require__("861d");
var hasOwn = __webpack_require__("1a2d");
var defineProperty = __webpack_require__("9bf2").f;
var getOwnPropertyNamesModule = __webpack_require__("241c");
var getOwnPropertyNamesExternalModule = __webpack_require__("057f");
var isExtensible = __webpack_require__("4fad");
var uid = __webpack_require__("90e3");
var FREEZING = __webpack_require__("bb2f");

var REQUIRED = false;
var METADATA = uid('meta');
var id = 0;

var setMetadata = function (it) {
  defineProperty(it, METADATA, { value: {
    objectID: 'O' + id++, // object ID
    weakData: {}          // weak collections IDs
  } });
};

var fastKey = function (it, create) {
  // return a primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!hasOwn(it, METADATA)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMetadata(it);
  // return object ID
  } return it[METADATA].objectID;
};

var getWeakData = function (it, create) {
  if (!hasOwn(it, METADATA)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMetadata(it);
  // return the store of weak collections IDs
  } return it[METADATA].weakData;
};

// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZING && REQUIRED && isExtensible(it) && !hasOwn(it, METADATA)) setMetadata(it);
  return it;
};

var enable = function () {
  meta.enable = function () { /* empty */ };
  REQUIRED = true;
  var getOwnPropertyNames = getOwnPropertyNamesModule.f;
  var splice = uncurryThis([].splice);
  var test = {};
  test[METADATA] = 1;

  // prevent exposing of metadata key
  if (getOwnPropertyNames(test).length) {
    getOwnPropertyNamesModule.f = function (it) {
      var result = getOwnPropertyNames(it);
      for (var i = 0, length = result.length; i < length; i++) {
        if (result[i] === METADATA) {
          splice(result, i, 1);
          break;
        }
      } return result;
    };

    $({ target: 'Object', stat: true, forced: true }, {
      getOwnPropertyNames: getOwnPropertyNamesExternalModule.f
    });
  }
};

var meta = module.exports = {
  enable: enable,
  fastKey: fastKey,
  getWeakData: getWeakData,
  onFreeze: onFreeze
};

hiddenKeys[METADATA] = true;


/***/ }),

/***/ "f1a3":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "f22b":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var call = __webpack_require__("c65b");
var newPromiseCapabilityModule = __webpack_require__("f069");
var FORCED_PROMISE_CONSTRUCTOR = __webpack_require__("4738").CONSTRUCTOR;

// `Promise.reject` method
// https://tc39.es/ecma262/#sec-promise.reject
$({ target: 'Promise', stat: true, forced: FORCED_PROMISE_CONSTRUCTOR }, {
  reject: function reject(r) {
    var capability = newPromiseCapabilityModule.f(this);
    call(capability.reject, undefined, r);
    return capability.promise;
  }
});


/***/ }),

/***/ "f36a":
/***/ (function(module, exports, __webpack_require__) {

var uncurryThis = __webpack_require__("e330");

module.exports = uncurryThis([].slice);


/***/ }),

/***/ "f5b2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var codeAt = __webpack_require__("6547").codeAt;

// `String.prototype.codePointAt` method
// https://tc39.es/ecma262/#sec-string.prototype.codepointat
$({ target: 'String', proto: true }, {
  codePointAt: function codePointAt(pos) {
    return codeAt(this, pos);
  }
});


/***/ }),

/***/ "f5df":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var TO_STRING_TAG_SUPPORT = __webpack_require__("00ee");
var isCallable = __webpack_require__("1626");
var classofRaw = __webpack_require__("c6b6");
var wellKnownSymbol = __webpack_require__("b622");

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var Object = global.Object;

// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
module.exports = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = Object(it), TO_STRING_TAG)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) == 'Object' && isCallable(O.callee) ? 'Arguments' : result;
};


/***/ }),

/***/ "f674":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_GeneticVariantTable_vue_vue_type_style_index_0_id_d6788aaa_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("58ed");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_GeneticVariantTable_vue_vue_type_style_index_0_id_d6788aaa_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_GeneticVariantTable_vue_vue_type_style_index_0_id_d6788aaa_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),

/***/ "f6d6":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var global = __webpack_require__("da84");
var uncurryThis = __webpack_require__("e330");
var toAbsoluteIndex = __webpack_require__("23cb");

var RangeError = global.RangeError;
var fromCharCode = String.fromCharCode;
// eslint-disable-next-line es-x/no-string-fromcodepoint -- required for testing
var $fromCodePoint = String.fromCodePoint;
var join = uncurryThis([].join);

// length should be 1, old FF problem
var INCORRECT_LENGTH = !!$fromCodePoint && $fromCodePoint.length != 1;

// `String.fromCodePoint` method
// https://tc39.es/ecma262/#sec-string.fromcodepoint
$({ target: 'String', stat: true, arity: 1, forced: INCORRECT_LENGTH }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  fromCodePoint: function fromCodePoint(x) {
    var elements = [];
    var length = arguments.length;
    var i = 0;
    var code;
    while (length > i) {
      code = +arguments[i++];
      if (toAbsoluteIndex(code, 0x10FFFF) !== code) throw RangeError(code + ' is not a valid code point');
      elements[i] = code < 0x10000
        ? fromCharCode(code)
        : fromCharCode(((code -= 0x10000) >> 10) + 0xD800, code % 0x400 + 0xDC00);
    } return join(elements, '');
  }
});


/***/ }),

/***/ "f772":
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__("5692");
var uid = __webpack_require__("90e3");

var keys = shared('keys');

module.exports = function (key) {
  return keys[key] || (keys[key] = uid(key));
};


/***/ }),

/***/ "f8c9":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var global = __webpack_require__("da84");
var setToStringTag = __webpack_require__("d44e");

$({ global: true }, { Reflect: {} });

// Reflect[@@toStringTag] property
// https://tc39.es/ecma262/#sec-reflect-@@tostringtag
setToStringTag(global.Reflect, 'Reflect', true);


/***/ }),

/***/ "fae3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "PaginatedList", function() { return /* reexport */ PaginatedList; });
__webpack_require__.d(__webpack_exports__, "ListView", function() { return /* reexport */ ListView; });
__webpack_require__.d(__webpack_exports__, "PatientList", function() { return /* reexport */ PatientList; });
__webpack_require__.d(__webpack_exports__, "QuestionnaireRenderer", function() { return /* reexport */ QuestionnaireRenderer; });
__webpack_require__.d(__webpack_exports__, "QuestionnaireList", function() { return /* reexport */ QuestionnaireList; });
__webpack_require__.d(__webpack_exports__, "PatientDeBase", function() { return /* reexport */ Patient_de_basis; });
__webpack_require__.d(__webpack_exports__, "DtAddressDeBase", function() { return /* reexport */ DtAddress_de_basis; });
__webpack_require__.d(__webpack_exports__, "DtAttachment", function() { return /* reexport */ DtAttachment; });
__webpack_require__.d(__webpack_exports__, "DtCodeableConcept", function() { return /* reexport */ DtCodeableConcept; });
__webpack_require__.d(__webpack_exports__, "DtContactPoint", function() { return /* reexport */ DtContactPoint; });
__webpack_require__.d(__webpack_exports__, "DtHumanNameDeBase", function() { return /* reexport */ DtHumanName_de_basis; });
__webpack_require__.d(__webpack_exports__, "DtIdentifier", function() { return /* reexport */ DtIdentifier; });
__webpack_require__.d(__webpack_exports__, "DtPeriod", function() { return /* reexport */ DtPeriod; });
__webpack_require__.d(__webpack_exports__, "DtArray", function() { return /* reexport */ DtArray; });
__webpack_require__.d(__webpack_exports__, "DtBase64Binary", function() { return /* reexport */ DtBase64Binary; });
__webpack_require__.d(__webpack_exports__, "DtBoolean", function() { return /* reexport */ DtBoolean; });
__webpack_require__.d(__webpack_exports__, "DtCode", function() { return /* reexport */ DtCode; });
__webpack_require__.d(__webpack_exports__, "DtDate", function() { return /* reexport */ DtDate; });
__webpack_require__.d(__webpack_exports__, "DtDateTime", function() { return /* reexport */ DtDateTime; });
__webpack_require__.d(__webpack_exports__, "DtInteger", function() { return /* reexport */ DtInteger; });
__webpack_require__.d(__webpack_exports__, "DtMarkdown", function() { return /* reexport */ DtMarkdown; });
__webpack_require__.d(__webpack_exports__, "DtString", function() { return /* reexport */ DtString; });
__webpack_require__.d(__webpack_exports__, "DtStringArray", function() { return /* reexport */ DtStringArray; });
__webpack_require__.d(__webpack_exports__, "DtUri", function() { return /* reexport */ DtUri; });
__webpack_require__.d(__webpack_exports__, "ResourceSelector", function() { return /* reexport */ ResourceSelector; });
__webpack_require__.d(__webpack_exports__, "MolecularReport", function() { return /* reexport */ MolecularReport; });
__webpack_require__.d(__webpack_exports__, "GeneticReport", function() { return /* reexport */ GeneticReport; });
__webpack_require__.d(__webpack_exports__, "GeneticVariantTable", function() { return /* reexport */ GeneticVariantTable; });

// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  var currentScript = window.document.currentScript
  if (true) {
    var getCurrentScript = __webpack_require__("8875")
    currentScript = getCurrentScript()

    // for backward compatibility, because previously we directly included the polyfill
    if (!('currentScript' in document)) {
      Object.defineProperty(document, 'currentScript', { get: getCurrentScript })
    }
  }

  var src = currentScript && currentScript.src.match(/(.+\/)[^/]+\.js(\?.*)?$/)
  if (src) {
    __webpack_require__.p = src[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ var setPublicPath = (null);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"465b08a6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/PaginatedList.vue?vue&type=template&id=d16b3252&scoped=true&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.searchable)?_c('div',{staticClass:"form-group"},[_c('input',{staticClass:"form-control",attrs:{"placeholder":_vm.searchInputPlaceholder},on:{"input":_vm.updateSearch}})]):_vm._e(),_vm._t("default"),(_vm.bundle && _vm.bundle.entry && _vm.bundle.entry[0] && _vm.showPagination)?_c('nav',[_c('div',{staticClass:"text-muted results-description"}),_c('ul',{staticClass:"pagination"},[_c('li',{class:['page-item ', { disabled: _vm.currentPage === 1 }]},[(_vm.useQueryParams)?_c('router-link',{staticClass:"page-link",attrs:{"to":{ path: _vm.currentPath, query: _vm.firstPageParams }}},[_vm._t("firstPage",function(){return [_vm._v("<<")]})],2):_c('a',{staticClass:"page-link",attrs:{"href":"javascript:void(0);"},on:{"click":_vm.navigateToFirstPage}},[_vm._t("firstPage",function(){return [_vm._v("<<")]})],2)],1),_c('li',{class:['page-item ', { disabled: _vm.currentPage === 1 }]},[(_vm.useQueryParams)?_c('router-link',{staticClass:"page-link",attrs:{"to":{ path: _vm.currentPath, query: _vm.prevPageParams }}},[_vm._t("previousPage",function(){return [_vm._v("<")]})],2):_c('a',{staticClass:"page-link",attrs:{"href":"javascript:void(0);"},on:{"click":_vm.navigateToPrevPage}},[_vm._t("previousPage",function(){return [_vm._v("<")]})],2)],1),(_vm.currentPage > _vm.paginationSize)?_c('li',{staticClass:"page-item disabled"},[_c('a',{staticClass:"page-link",attrs:{"href":"javascript:void(0);"}},[_vm._v("...")])]):_vm._e(),_vm._l((_vm.paginationArray),function(n){return _c('li',{key:n,class:['page-item ', { active: _vm.currentPage === n }]},[(_vm.useQueryParams)?_c('router-link',{staticClass:"page-link",attrs:{"to":{ path: _vm.currentPath, query: _vm.getQueryParamsForPage(n, _vm.count) }}},[_vm._v(_vm._s(n))]):_c('a',{staticClass:"page-link",attrs:{"href":"javascript:void(0);"},on:{"click":function($event){return _vm.navigateToPage(n)}}},[_vm._v(_vm._s(n))])],1)}),(_vm.currentPage < _vm.bundle.total / _vm.count - (_vm.paginationSize - 1))?_c('li',{staticClass:"page-item disabled"},[_c('a',{staticClass:"page-link",attrs:{"href":"javascript:void(0);"}},[_vm._v("...")])]):_vm._e(),_c('li',{class:['page-item ', { disabled: _vm.currentPage === _vm.lastPage }]},[(_vm.useQueryParams)?_c('router-link',{staticClass:"page-link",attrs:{"to":{ path: _vm.currentPath, query: _vm.nextPageParams }}},[_vm._t("nextPage",function(){return [_vm._v(">")]})],2):_c('a',{staticClass:"page-link",attrs:{"href":"javascript:void(0);"},on:{"click":_vm.navigateToNextPage}},[_vm._t("nextPage",function(){return [_vm._v(">")]})],2)],1),_c('li',{class:['page-item ', { disabled: _vm.currentPage === _vm.lastPage }]},[(_vm.useQueryParams)?_c('router-link',{staticClass:"page-link",attrs:{"to":{ path: _vm.currentPath, query: _vm.lastPageParams }}},[_vm._t("lastPage",function(){return [_vm._v(">>")]})],2):_c('a',{staticClass:"page-link",attrs:{"href":"javascript:void(0);"},on:{"click":_vm.navigateToLastPage}},[_vm._t("lastPage",function(){return [_vm._v(">>")]})],2)],1)],2)]):_vm._e()],2)}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/PaginatedList.vue?vue&type=template&id=d16b3252&scoped=true&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("d3b7");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.promise.js
var es_promise = __webpack_require__("e6cf");

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js



function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("b64b");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("a4d3");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("4de4");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("e439");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("159b");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("dbb4");

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js









function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}
// EXTERNAL MODULE: ./node_modules/regenerator-runtime/runtime.js
var runtime = __webpack_require__("96cf");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__("a9e3");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.error.cause.js
var es_error_cause = __webpack_require__("d9e2");

// EXTERNAL MODULE: external "@molit/fhir-api"
var fhir_api_ = __webpack_require__("1081");

// EXTERNAL MODULE: external "debounce"
var external_debounce_ = __webpack_require__("81f2");
var external_debounce_default = /*#__PURE__*/__webpack_require__.n(external_debounce_);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/PaginatedList.vue?vue&type=script&lang=js&








//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

 // @group Lists

/* harmony default export */ var PaginatedListvue_type_script_lang_js_ = ({
  props: {
    // The authentication token
    token: {
      type: String,
      default: null
    },
    // Whether to show pagination
    showPagination: {
      type: Boolean,
      default: true
    },
    // The base URL of the FHIR server
    fhirBaseUrl: {
      type: String,
      required: true
    },
    // Number of entries per page
    pageCount: {
      type: Number,
      default: 20
    },
    // Parameters used in fhir query
    searchParams: {
      type: Object,
      // {}
      default: function _default() {
        return {};
      }
    },
    // Whether to use url query params
    useQueryParams: {
      type: Boolean,
      default: false
    },
    // Name of the resource
    resourceName: {
      type: String,
      required: true
    },
    // Whether the list is searchable
    searchable: {
      type: Boolean,
      default: true
    },
    searchAttributes: {
      type: Array,
      default: function _default() {
        return [{
          name: "ID",
          value: "_id"
        }];
      }
    },
    searchDebounceTime: {
      type: Number,
      default: 500
    },
    detailPageName: {
      type: String
    },
    viewBehavior: {
      type: String,
      default: "href"
    },
    searchInputPlaceholder: {
      type: String,
      default: "Search.."
    },
    usePostForQuery: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      bundle: undefined,
      getpagesoffset: 0,
      count: 20,
      paginationSize: 5,
      searchTerm: null
    };
  },
  computed: {
    currentPath: function currentPath() {
      return this.$route.path;
    },
    currentPage: function currentPage() {
      return this.getpagesoffset / this.count + 1;
    },
    currentLower: function currentLower() {
      return Math.min(this.getpagesoffset + 1, this.bundle.total);
    },
    currentUpper: function currentUpper() {
      return Math.min(this.getpagesoffset + this.count, this.bundle.total);
    },
    lastPage: function lastPage() {
      return Math.ceil(this.bundle.total / this.count);
    },
    params: function params() {
      var params = _objectSpread2(_objectSpread2({}, this.searchParams), {}, {
        _total: "accurate",
        _getpagesoffset: this.getpagesoffset,
        _count: this.count
      });

      if (this.useQueryParams) {
        params = _objectSpread2(_objectSpread2({}, params), this.$route.query);
      }

      if (this.searchTerm && this.searchAttributes && this.searchAttributes[0]) {
        params[this.searchAttributes[0].value] = this.searchTerm;
      } else if (!this.searchTerm && this.searchAttributes && this.searchAttributes[0]) {
        delete params[this.searchAttributes[0].value];
      }

      Object.keys(params).forEach(function (key) {
        return !params[key] && params[key] === "" && delete params[key];
      });
      return params;
    },
    firstPageOffset: function firstPageOffset() {
      return 0;
    },
    prevPageOffset: function prevPageOffset() {
      return Math.max(this.getpagesoffset - this.count, 0);
    },
    nextPageOffset: function nextPageOffset() {
      return Math.min(this.getpagesoffset + this.count, this.bundle.total);
    },
    lastPageOffset: function lastPageOffset() {
      return (this.lastPage - 1) * this.count;
    },
    firstPageParams: function firstPageParams() {
      return _objectSpread2(_objectSpread2({}, this.params), {}, {
        _getpagesoffset: this.firstPageOffset
      });
    },
    prevPageParams: function prevPageParams() {
      return _objectSpread2(_objectSpread2({}, this.params), {}, {
        _getpagesoffset: this.prevPageOffset
      });
    },
    nextPageParams: function nextPageParams() {
      return _objectSpread2(_objectSpread2({}, this.params), {}, {
        _getpagesoffset: this.nextPageOffset
      });
    },
    lastPageParams: function lastPageParams() {
      return _objectSpread2(_objectSpread2({}, this.params), {}, {
        _getpagesoffset: this.lastPageOffset
      });
    },
    paginationArray: function paginationArray() {
      var paginationArray = [];

      for (var i = 1; i <= this.lastPage; i++) {
        if (this.currentPage < i + this.paginationSize && this.currentPage > i - this.paginationSize) {
          paginationArray.push(i);
        }
      }

      return paginationArray;
    }
  },
  methods: {
    setQueryParams: function setQueryParams() {
      if (this.$route.query._count != null && this.$route.query._count != undefined) {
        this.count = parseInt(this.$route.query._count);
      }

      if (this.$route.query._getpagesoffset !== null && this.$route.query._getpagesoffset !== undefined) {
        this.getpagesoffset = parseInt(this.$route.query._getpagesoffset);
      }

      if (this.searchAttributes && this.searchAttributes[0] && this.$route.query[this.searchAttributes[0].value]) {
        this.searchTerm = this.$route.query[this.searchAttributes[0].value];
      }
    },
    initializeView: function initializeView() {
      if (this.useQueryParams) {
        this.setQueryParams();
      }

      this.fetchResources();
    },
    fetchResources: function fetchResources() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                _this.$emit("updateStart");

                if (!_this.usePostForQuery) {
                  _context.next = 8;
                  break;
                }

                _context.next = 5;
                return fhir_api_["fetchResourcesPost"](_this.fhirBaseUrl, _this.resourceName, _this.params, _this.token);

              case 5:
                _this.bundle = _context.sent.data;
                _context.next = 11;
                break;

              case 8:
                _context.next = 10;
                return fhir_api_["fetchResources"](_this.fhirBaseUrl, _this.resourceName, _this.params, _this.token);

              case 10:
                _this.bundle = _context.sent.data;

              case 11:
                _context.next = 17;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context["catch"](0);

                _this.$emit("error", _context.t0);

                throw new Error(_context.t0, "Could not load FHIR resources.");

              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 13]]);
      }))();
    },
    getQueryParamsForPage: function getQueryParamsForPage(pageNumber, count) {
      return _objectSpread2(_objectSpread2({}, this.params), {}, {
        _getpagesoffset: (pageNumber - 1) * count
      });
    },
    navigateToFirstPage: function navigateToFirstPage() {
      this.getpagesoffset = 0;
      this.initializeView();
    },
    navigateToPrevPage: function navigateToPrevPage() {
      this.getpagesoffset = this.prevPageOffset;
      this.initializeView();
    },
    navigateToNextPage: function navigateToNextPage() {
      this.getpagesoffset = this.nextPageOffset;
      this.initializeView();
    },
    navigateToLastPage: function navigateToLastPage() {
      this.getpagesoffset = this.lastPageOffset;
      this.initializeView();
    },
    navigateToPage: function navigateToPage(pageNumber) {
      this.getpagesoffset = (pageNumber - 1) * this.count;
      this.initializeView();
    },
    keyup: function keyup(event) {
      if (this.bundle && document.activeElement.tagName !== "INPUT") {
        if (event.code === "ArrowLeft" && this.currentPage !== 1) {
          if (this.useQueryParams) {
            this.$router.push({
              path: this.currentPath,
              query: this.prevPageParams
            });
          } else {
            this.navigateToPrevPage();
          }
        } else if (event.code === "ArrowRight" && this.currentPage !== this.lastPage) {
          if (this.useQueryParams) {
            this.$router.push({
              path: this.currentPath,
              query: this.nextPageParams
            });
          } else {
            this.navigateToNextPage();
          }
        }
      }
    }
  },
  watch: {
    $route: function $route() {
      this.initializeView();
    },
    searchTerm: function searchTerm() {
      if (this.useQueryParams) {
        this.$router.push({
          path: this.currentPath,
          query: this.firstPageParams
        });
      } else {
        this.navigateToFirstPage();
      }
    },
    bundle: function bundle(value) {
      this.$emit("update", value);
    },
    pageCount: function pageCount() {
      this.count = this.pageCount;
      this.initializeView();
    },
    searchParams: {
      deep: true,
      handler: function handler() {
        this.initializeView();
      }
    }
  },
  created: function created() {
    var _this2 = this;

    this.count = this.pageCount;
    window.addEventListener("keyup", this.keyup);
    this.updateSearch = external_debounce_default()(function (e) {
      _this2.searchTerm = e.target.value;
    }, this.searchDebounceTime);
  },
  mounted: function mounted() {
    this.initializeView();
  },
  destroyed: function destroyed() {
    window.removeEventListener("keyup", this.keyup);
  }
});
// CONCATENATED MODULE: ./src/components/PaginatedList.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_PaginatedListvue_type_script_lang_js_ = (PaginatedListvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/PaginatedList.vue?vue&type=style&index=0&id=d16b3252&lang=scss&scoped=true&
var PaginatedListvue_type_style_index_0_id_d16b3252_lang_scss_scoped_true_ = __webpack_require__("1a4e");

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent (
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier, /* server only */
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () {
        injectStyles.call(
          this,
          (options.functional ? this.parent : this).$root.$options.shadowRoot
        )
      }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functional component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}

// CONCATENATED MODULE: ./src/components/PaginatedList.vue






/* normalize component */

var component = normalizeComponent(
  components_PaginatedListvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "d16b3252",
  null
  
)

/* harmony default export */ var PaginatedList = (component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"465b08a6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/ListView.vue?vue&type=template&id=d4863738&scoped=true&
var ListViewvue_type_template_id_d4863738_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('paginated-list',{attrs:{"resourceName":_vm.resourceName,"fhirBaseUrl":_vm.fhirBaseUrl,"searchParams":_vm.searchParams,"pageCount":_vm.pageCount,"searchAttributes":_vm.searchAttributes,"sortable":_vm.sortable,"sortAttributes":_vm.sortAttributes,"searchDebounceTime":_vm.searchDebounceTime,"useQueryParams":_vm.useQueryParams,"searchable":_vm.searchable},on:{"update":_vm.bundleUpdated}},[_c('div',{staticClass:"card list-data"},[(!_vm.bundle)?_c('div',{staticClass:"loading"},[_c('spinner')],1):_vm._e(),(_vm.bundle && !_vm.bundle.entry)?_c('div',{staticClass:"no-results"}):(_vm.bundle)?_c('ul',{staticClass:"list-group list-group-flush"},_vm._l((_vm.bundle.entry),function(entry){return _c('list-item',{key:entry.resource.id,attrs:{"viewBehavior":_vm.viewBehavior,"title":_vm.getAttributesAsString(entry.resource, _vm.titleAttributes),"subtitle":_vm.getAttributesAsString(entry.resource, _vm.subtitleAttributes),"urlView":_vm.detailPageName + '/' + entry.resource.id},on:{"view":function($event){return _vm.$emit('view', entry.resource)}}})}),1):_vm._e()])])],1)}
var ListViewvue_type_template_id_d4863738_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/ListView.vue?vue&type=template&id=d4863738&scoped=true&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__("ac1f");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.replace.js
var es_string_replace = __webpack_require__("5319");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.split.js
var es_string_split = __webpack_require__("1276");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.join.js
var es_array_join = __webpack_require__("a15b");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("d81d");

// EXTERNAL MODULE: external "vue-simple-spinner"
var external_vue_simple_spinner_ = __webpack_require__("b20e");
var external_vue_simple_spinner_default = /*#__PURE__*/__webpack_require__.n(external_vue_simple_spinner_);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"465b08a6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/ListItem.vue?vue&type=template&id=407472fa&scoped=true&
var ListItemvue_type_template_id_407472fa_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"list-group-item"},[_c('div',{staticClass:"avatar"},[_vm._v(" "+_vm._s(_vm.title[0])+" ")]),_c('div',[_c('div',{staticClass:"title"},[(_vm.viewBehavior === 'href')?_c('a',{attrs:{"href":_vm.urlView}},[_vm._v(_vm._s(_vm.title))]):_c('a',{attrs:{"href":"javascript:void(0);"},on:{"click":function($event){return _vm.$emit('view')}}},[_vm._v(_vm._s(_vm.title))])]),_c('div',[_vm._v(_vm._s(_vm.subtitle))])]),_c('div',{staticClass:"actions"},[_c('a',{attrs:{"href":_vm.urlEdit},on:{"click":function($event){return _vm.$emit('edit')}}},[_c('i',{staticClass:"fas fa-pencil-alt"})])])])}
var ListItemvue_type_template_id_407472fa_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/ListItem.vue?vue&type=template&id=407472fa&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/ListItem.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var ListItemvue_type_script_lang_js_ = ({
  props: {
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String
    },
    icon: {
      type: String,
      default: ""
    },
    urlView: {
      type: String
    },
    urlEdit: {
      type: String
    },
    viewBehavior: {
      type: String,
      default: "href"
    }
  }
});
// CONCATENATED MODULE: ./src/components/ListItem.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_ListItemvue_type_script_lang_js_ = (ListItemvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/ListItem.vue?vue&type=style&index=0&id=407472fa&lang=scss&scoped=true&
var ListItemvue_type_style_index_0_id_407472fa_lang_scss_scoped_true_ = __webpack_require__("bd92");

// CONCATENATED MODULE: ./src/components/ListItem.vue






/* normalize component */

var ListItem_component = normalizeComponent(
  components_ListItemvue_type_script_lang_js_,
  ListItemvue_type_template_id_407472fa_scoped_true_render,
  ListItemvue_type_template_id_407472fa_scoped_true_staticRenderFns,
  false,
  null,
  "407472fa",
  null
  
)

/* harmony default export */ var ListItem = (ListItem_component.exports);
// EXTERNAL MODULE: external "@molit/fhir-util"
var fhir_util_ = __webpack_require__("4541");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/ListView.vue?vue&type=script&lang=js&






//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



 // @group Lists

/* harmony default export */ var ListViewvue_type_script_lang_js_ = ({
  props: {
    fhirBaseUrl: {
      type: String,
      required: true
    },
    pageCount: {
      type: Number,
      default: 20
    },
    searchParams: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    useQueryParams: {
      type: Boolean,
      default: false
    },
    resourceName: {
      type: String,
      required: true
    },
    titleAttributes: {
      type: Array,
      default: function _default() {
        return [{
          value: "id",
          type: ""
        }];
      }
    },
    subtitleAttributes: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    sortable: {
      type: Boolean,
      default: false
    },
    sortAttributes: {
      type: Array,
      default: function _default() {
        return [{
          name: "ID",
          value: "_id"
        }];
      }
    },
    searchable: {
      type: Boolean,
      default: true
    },
    searchAttributes: {
      type: Array,
      default: function _default() {
        return [{
          name: "ID",
          value: "_id"
        }];
      }
    },
    searchDebounceTime: {
      type: Number,
      default: 500
    },
    detailPageName: {
      type: String
    },
    viewBehavior: {
      type: String,
      default: "href"
    }
  },
  data: function data() {
    return {
      bundle: null
    };
  },
  methods: {
    bundleUpdated: function bundleUpdated(bundle) {
      this.bundle = bundle;
    },
    byString: function byString(o, s) {
      s = s.replace(/\[(\w+)\]/g, ".$1"); // https://stackoverflow.com/questions/6491463/accessing-nested-javascript-objects-with-string-key

      s = s.replace(/^\./, "");
      var a = s.split(".");

      for (var i = 0, n = a.length; i < n; ++i) {
        var k = a[i];

        if (k in o) {
          o = o[k];
        } else {
          return;
        }
      }

      return o;
    },
    getAttribute: function getAttribute(resource, attributeName, attributeType) {
      if (!resource) {
        return "";
      } else if (!attributeName) {
        return resource.id;
      }

      var attribute = this.byString(resource, attributeName);

      switch (attributeType) {
        case "HumanName":
          return Object(fhir_util_["getStringFromHumanName"])(attribute);

        default:
          return attribute;
      }
    },
    getAttributesAsString: function getAttributesAsString(resource, attributes) {
      var _this = this;

      return attributes.map(function (attribute) {
        return _this.getAttribute(resource, attribute.value, attribute.type);
      }).join(" ");
    }
  },
  components: {
    ListItem: ListItem,
    PaginatedList: PaginatedList,
    Spinner: external_vue_simple_spinner_default.a
  }
});
// CONCATENATED MODULE: ./src/components/ListView.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_ListViewvue_type_script_lang_js_ = (ListViewvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/ListView.vue?vue&type=style&index=0&id=d4863738&lang=scss&scoped=true&
var ListViewvue_type_style_index_0_id_d4863738_lang_scss_scoped_true_ = __webpack_require__("7745");

// CONCATENATED MODULE: ./src/components/ListView.vue






/* normalize component */

var ListView_component = normalizeComponent(
  components_ListViewvue_type_script_lang_js_,
  ListViewvue_type_template_id_d4863738_scoped_true_render,
  ListViewvue_type_template_id_d4863738_scoped_true_staticRenderFns,
  false,
  null,
  "d4863738",
  null
  
)

/* harmony default export */ var ListView = (ListView_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"465b08a6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/BaseList.vue?vue&type=template&id=7d96f883&
var BaseListvue_type_template_id_7d96f883_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('list-view',{attrs:{"viewBehavior":_vm.viewBehavior,"fhirBaseUrl":_vm.fhirBaseUrl,"resourceName":_vm.resourceName,"titleAttributes":_vm.titleAttributes,"subtitleAttributes":_vm.subtitleAttributes,"sortAttributes":_vm.sortAttributes,"searchAttributes":_vm.searchAttributes,"detailPageName":_vm.detailPageName,"useQueryParams":_vm.useQueryParams},on:{"view":function($event){return _vm.$emit('view', $event)}}})}
var BaseListvue_type_template_id_7d96f883_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/BaseList.vue?vue&type=template&id=7d96f883&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/BaseList.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
 // @group Lists

/* harmony default export */ var BaseListvue_type_script_lang_js_ = ({
  props: {
    fhirBaseUrl: {
      type: String,
      required: true
    },
    titleAttributes: {
      type: Array,
      default: function _default() {
        return [{
          value: "id",
          type: ""
        }];
      }
    },
    useQueryParams: {
      type: Boolean,
      default: false
    },
    subtitleAttributes: {
      type: Array,
      default: function _default() {
        return [{
          value: "id",
          type: ""
        }];
      }
    },
    viewBehavior: {
      type: String,
      default: "href"
    }
  },
  data: function data() {
    return {
      resourceName: "",
      sortAttributes: [{
        name: "Id",
        value: "_id"
      }]
    };
  },
  components: {
    ListView: ListView
  }
});
// CONCATENATED MODULE: ./src/components/BaseList.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_BaseListvue_type_script_lang_js_ = (BaseListvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/BaseList.vue





/* normalize component */

var BaseList_component = normalizeComponent(
  components_BaseListvue_type_script_lang_js_,
  BaseListvue_type_template_id_7d96f883_render,
  BaseListvue_type_template_id_7d96f883_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var BaseList = (BaseList_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/PatientList.vue?vue&type=script&lang=js&
 // @group Lists

/* harmony default export */ var PatientListvue_type_script_lang_js_ = ({
  extends: BaseList,
  props: {
    detailPageName: {
      type: String,
      default: "patient"
    },
    titleAttributes: {
      type: Array,
      default: function _default() {
        return [{
          value: "name",
          type: "HumanName"
        }];
      }
    },
    subtitleAttributes: {
      type: Array,
      default: function _default() {
        return [{
          value: "birthDate",
          type: ""
        }, {
          value: "gender",
          type: ""
        }];
      }
    }
  },
  data: function data() {
    return {
      resourceName: "Patient",
      sortAttributes: [{
        name: "Name",
        value: "name"
      }],
      searchAttributes: [{
        name: "Name",
        value: "name"
      }]
    };
  }
});
// CONCATENATED MODULE: ./src/components/PatientList.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_PatientListvue_type_script_lang_js_ = (PatientListvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/PatientList.vue
var PatientList_render, PatientList_staticRenderFns




/* normalize component */

var PatientList_component = normalizeComponent(
  components_PatientListvue_type_script_lang_js_,
  PatientList_render,
  PatientList_staticRenderFns,
  false,
  null,
  "9bf6a156",
  null
  
)

/* harmony default export */ var PatientList = (PatientList_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"465b08a6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/QuestionnaireRenderer.vue?vue&type=template&id=4e53f25c&scoped=true&
var QuestionnaireRenderervue_type_template_id_4e53f25c_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.modal)?_c(_vm.mode,{tag:"component",attrs:{"filteredItemList":_vm.filteredItemList,"questionnaire":_vm.currentQuestionnaire,"questionnaireResponse":_vm.currentQuestionnaireResponse,"requiredQuestionList":_vm.answeredRequiredQuestionsList,"valueSets":_vm.currentValueSets,"lastQuestion":_vm.lastQuestion,"startCount":_vm.currentStartCount,"baseUrl":_vm.baseUrl,"editMode":_vm.editMode,"primary":_vm.primary,"secondary":_vm.secondary,"danger":_vm.danger,"enableReturn":_vm.enableReturn,"language":_vm.language,"spinner":_vm.spinner},on:{"summary":function($event){return _vm.backToSummary()},"finished":function($event){return _vm.finishQuestionnaire()},"return":function($event){return _vm.leaveQuestionnaireRenderer()},"answer":function($event){return _vm.handleQuestionnaireResponseEvent($event)}}}):_vm._e(),(_vm.modal)?_c('div',{staticClass:"align-vertical",staticStyle:{"height":"calc(100vh - 200px)"}},[_c('div',{staticClass:"note-modal"},[_c('div',[_c('div',[_vm._v(_vm._s(_vm.language.questionDeactivated))]),_c('div',{staticClass:"button-container"},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){return _vm.backToSummary()}}},[_vm._v(_vm._s(_vm.language.backtoSummary))])])])])]):_vm._e()],1)}
var QuestionnaireRenderervue_type_template_id_4e53f25c_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/QuestionnaireRenderer.vue?vue&type=template&id=4e53f25c&scoped=true&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.json.stringify.js
var es_json_stringify = __webpack_require__("e9c4");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.splice.js
var es_array_splice = __webpack_require__("a434");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.find.js
var es_array_find = __webpack_require__("7db0");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.find-index.js
var es_array_find_index = __webpack_require__("c740");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("99af");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.starts-with.js
var es_string_starts_with = __webpack_require__("2ca0");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__("b0c0");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.assign.js
var es_object_assign = __webpack_require__("cca6");

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/classCallCheck.js

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/createClass.js
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
// CONCATENATED MODULE: ./src/util/questionnaireResponse.js



/**
 * Represents a Questionnaire Response
 * source: http://hl7.org/fhir/questionnaireresponse.html
 */
var questionnaireResponse_QuestionnaireResponse = /*#__PURE__*/function () {
  function QuestionnaireResponse() {
    _classCallCheck(this, QuestionnaireResponse);
  }

  _createClass(QuestionnaireResponse, null, [{
    key: "create",
    value: function create() {
      return {
        resourceType: "QuestionnaireResponse",
        questionnaire: null,
        status: null,
        subject: null,
        authored: null,
        source: null,
        item: []
      };
    }
  }]);

  return QuestionnaireResponse;
}();
/**
 * A question as an item, containing linkId,definition,text, and no,one or more than one answers
 * source: http://hl7.org/fhir/questionnaireresponse.html
 */

var questionnaireResponse_Item = /*#__PURE__*/function () {
  function Item() {
    _classCallCheck(this, Item);
  }

  _createClass(Item, null, [{
    key: "create",
    value: function create() {
      return {
        linkId: null,
        definition: null,
        text: null,
        answer: [],
        item: []
      };
    }
  }]);

  return Item;
}();
/**
 * Answer, which contains the value and items
 * source: http://hl7.org/fhir/questionnaireresponse.html
 */

var questionnaireResponse_Answer = /*#__PURE__*/function () {
  function Answer() {
    _classCallCheck(this, Answer);
  }

  _createClass(Answer, null, [{
    key: "create",
    value: function create() {
      return {
        item: []
      };
    }
  }]);

  return Answer;
}();
/* harmony default export */ var util_questionnaireResponse = ({
  QuestionnaireResponse: questionnaireResponse_QuestionnaireResponse,
  Item: questionnaireResponse_Item,
  Answer: questionnaireResponse_Answer
});
// EXTERNAL MODULE: external "moment"
var external_moment_ = __webpack_require__("c32d");
var external_moment_default = /*#__PURE__*/__webpack_require__.n(external_moment_);

// CONCATENATED MODULE: ./src/util/dateTimeController.js


/**
 * Adds a 0 in case the length is smaller than the given length. number is not allowed to be null/undefined,
 * length is not allowed to be null/undefined or its value below 2, else the return will be set to "00"
 * source : https://stackoverflow.com/questions/1091372/getting-the-clients-timezone-in-javascript
 */

function pad(number, length) {
  if (number === null || number === undefined || length === null || length < 2) {
    throw new Error("number or length was null or length smaller than 2");
  } else {
    var str = "" + number;

    while (str.length < length) {
      str = "0" + str;
    }

    return str;
  }
}
/**
 * Gets the current timezone from the users device. Should return a string with the format "+-hh:mm"
 * source : https://stackoverflow.com/questions/1091372/getting-the-clients-timezone-in-javascript
 */

function getTimezone() {
  //get timezone
  var offset = new Date().getTimezoneOffset(); //format

  offset = (offset < 0 ? "+" : "-") + pad(parseInt(Math.abs(offset / 60)), 2) + ":" + pad(Math.abs(offset % 60), 2); //return

  return offset;
}
/**
 * Gets the current date and time in a fhir format
 */

function getTimestamp() {
  return external_moment_default()().format();
}
/* harmony default export */ var dateTimeController = ({
  pad: pad,
  getTimezone: getTimezone,
  getTimestamp: getTimestamp
});
// CONCATENATED MODULE: ./src/util/valueTypes.js
var valueTypes = {
  BOOLEAN: "boolean",
  DECIMAL: "decimal",
  INTEGER: "integer",
  GROUP: "group",
  DATE: "date",
  TIME: "time",
  DATETIME: "dateTime",
  TEXT: "text",
  STRING: "string",
  URI: "url",
  CODING: "coding",
  ATTACHMENT: "attachment",
  QUANTITY: "quantity"
};
/* harmony default export */ var util_valueTypes = ({
  valueTypes: valueTypes
});
// CONCATENATED MODULE: ./src/util/questionnaireResponseController.js






 //#region CREATE QUESTIONNAIRE RESPONSE

/**
 * Gets a Questionnaire and returns a QuestionnaireResponse.
 * Parameter Questionnaire-may not be null or undefined
 * return QuestionnaireResponse
 *
 * @param {Object} questionnaire The Questionnaire
 */

function questionnaireResponseController_createQuestionnaireResponse(questionnaire, subject) {
  if (questionnaire) {
    var questResp = questionnaireResponse_QuestionnaireResponse.create(); //QUESTIONNAIRE

    questResp.questionnaire = "Questionnaire/" + questionnaire.id; //STATUS

    questResp.status = "in-progress"; //SOURCE

    if (subject) {
      questResp.source = {
        reference: subject.resourceType + "/" + subject.id,
        display: fhir_util_["getStringFromHumanName"](subject.name)
      }; //SUBJECT

      questResp.subject = {
        reference: subject.resourceType + "/" + subject.id,
        display: fhir_util_["getStringFromHumanName"](subject.name)
      };
    } //AUTHORED date when response created


    questResp.authored = dateTimeController.getTimestamp(); //ITEMS | filling item with items

    if (questionnaire.item) {
      questResp.item = createItemArray(questionnaire.item);
    }

    return questResp;
  } else {
    throw new Error("Creating a Questionnaire Response failed because the given Questionnaire or Patient was null or undefined");
  }
} //#endregion
//#region HANDLING QUESTIONNAIRE ITEM TO RESPONSE ITEM

/**
 * Creates an Array with all the Items from the Questionnaire Item.
 *
 * @param {Object} questionnaireItem the current questionnaire item to be used
 */

function createItemArray(questionnaireItem) {
  var itemList = [];

  for (var i = 0; i < questionnaireItem.length; i++) {
    if (questionnaireItem[i].type === "group") {
      itemList.push(createGroupItem(questionnaireItem[i]));
    } else {
      itemList.push(createQuestionItem(questionnaireItem[i]));
    }
  }

  return itemList;
}
/**
 * Creates a new Item for a Group-Question and calls the createItemArray-Method to create more Items in itself if needed
 *
 * @param {*} groupItem A item with the type "group"
 */


function createGroupItem(groupItem) {
  var item = questionnaireResponse_Item.create();
  item.linkId = groupItem.linkId;
  item.definition = Object.assign({
    reference: groupItem.definition
  });
  item.text = groupItem.text;
  item.answer = [];
  item.item = createItemArray(groupItem.item);
  return item;
}
/**
 * Creates a new QuestionItem
 * @param {*} questionItem A normal question Item with no Group in it
 */


function createQuestionItem(questionItem) {
  var item = questionnaireResponse_Item.create();
  item.linkId = questionItem.linkId;
  item.definition = questionItem.definition;
  item.text = questionItem.text;
  item.answer = [];
  item.item = null;
  return item;
} //#endregion
//#region ANSWER-CREATION AND QUESTION-FINDING

/**
 * Creates a new Answer-Object with the given value
 *
 * @param {*} data
 * @param {*} type type of the answer
 */


function createAnswer(data, type) {
  //create answer
  var answer = questionnaireResponse_Answer.create(); //create value

  var value = null;
  var coding = null; //fill value depending on type

  if (data && type) {
    switch (type) {
      case valueTypes.BOOLEAN:
        if (data === "yes") {
          data = true;
        } else if (data === "no") {
          data = false;
        }

        value = Object.assign({
          valueBoolean: data
        });
        break;

      case valueTypes.STRING:
        value = Object.assign({
          valueString: data
        });
        break;

      case valueTypes.CODING:
        coding = Object.assign({
          display: data.display,
          code: data.code
        });
        value = Object.assign({
          valueCoding: coding
        });
        break;

      case valueTypes.INTEGER:
        value = Object.assign({
          valueInteger: "" + data
        });
        break;

      case valueTypes.DECIMAL:
        value = Object.assign({
          valueDecimal: "" + data
        });
        break;

      case valueTypes.DATE:
        value = Object.assign({
          valueDate: data
        });
        break;

      case valueTypes.DATETIME:
        value = Object.assign({
          valueDateTime: data
        });
        break;

      case valueTypes.TIME:
        value = Object.assign({
          valueTime: data
        });
        break;

      case valueTypes.TEXT:
        value = Object.assign({
          valueString: data
        });
        break;

      case valueTypes.URI:
        value = Object.assign({
          valueUri: data
        });
        break;

      default:
    }
  } //add value to answer


  answer = value; //return answer

  return answer;
}
/**
 * Creates an Array with Answers
 *
 * @param {Array} array Array containing the given answers
 * @param {String} type
 */

function createAnswers(array, type) {
  var newArray = [];

  if (array && type) {
    for (var i = 0; i < array.length; i++) {
      newArray.push(createAnswer(array[i], type));
    }
  }

  return newArray;
}
/**
 * Adds an Array of Answers to the questionnaireResponse
 *
 * @param {Object} questionnaireResponse
 * @param {String} linkId Question linkId
 * @param {Array} array Array with one or more Answers
 * @param {String} type type of the question
 */

function addAnswersToQuestionnaireResponse(questionnaireResponse, linkId, array, type) {
  var questResp = questionnaireResponse;

  try {
    if (questResp && linkId && type && array !== null) {
      questResp.item = addAnswersToQuestion(questResp.item, linkId, array, type);

      if (!questResp.item) {
        throw new Error("Adding Answers to Question did not work, the QuestionnaireResponse items were null or undefined");
      }
    }

    return questResp;
  } catch (error) {
    throw new Error("Adding Answers to questionnaireResponse failed, because the given parameters were null or undefined");
  }
}
/**
 * Looks for the linkId of a question and adds the answers
 *
 * @param {Object} varitem
 * @param {String} linkId Question linkId
 * @param {Array} array Array with one or more Answers
 * @param {String} type type of the question
 */

function addAnswersToQuestion(varitem, linkId, array, type) {
  for (var i = 0; i < varitem.length; i++) {
    if (varitem[i].item) {
      varitem[i].item = addAnswersToQuestion(varitem[i].item, linkId, array, type);
    } else {
      if (varitem[i].linkId === linkId) {
        varitem[i].answer = createAnswers(array, type);
      }
    }
  }

  return varitem;
} //#endregion
//#region GETTING ANSWER VALUE

/**
 * Returns all the given Answers of a specific Item in a QuestionnaireResponse
 *
 * @param {Object} questionnaireResponse
 * @param {String} linkId
 * @param {String} type
 */


function getAnswersFromQuestionnaireResponse(questionnaireResponse, linkId, type) {
  var answerValue = null;
  var codingValue = [];

  try {
    if (questionnaireResponse && linkId && type) {
      var itemList = this.createItemList(questionnaireResponse); //Iterating through all items in the list checking types

      for (var i = 0; i < itemList.length; i++) {
        if (itemList[i].linkId === linkId && itemList[i].answer[0]) {
          switch (type) {
            case valueTypes.BOOLEAN:
              answerValue = itemList[i].answer[0].valueBoolean;
              break;

            case valueTypes.STRING:
              answerValue = itemList[i].answer[0].valueString;
              break;

            case valueTypes.CODING:
              for (var a = 0; a < itemList[i].answer.length; a++) {
                codingValue.push(Object.assign({
                  display: itemList[i].answer[a].valueCoding.display,
                  code: itemList[i].answer[a].valueCoding.code
                }));
              }

              break;

            case valueTypes.INTEGER:
              answerValue = itemList[i].answer[0].valueInteger;
              break;

            case valueTypes.DECIMAL:
              answerValue = itemList[i].answer[0].valueDecimal;
              break;

            case valueTypes.DATE:
              answerValue = itemList[i].answer[0].valueDate;
              break;

            case valueTypes.DATETIME:
              answerValue = itemList[i].answer[0].valueDateTime;
              break;

            case valueTypes.TIME:
              answerValue = itemList[i].answer[0].valueTime;
              break;

            case valueTypes.TEXT:
              answerValue = itemList[i].answer[0].valueString;
              break;

            case valueTypes.URI:
              answerValue = itemList[i].answer[0].valueUri;
              break;

            default:
          }
        }
      }
    } else {
      throw new Error("The given questionnaireResponse, linkId or type was null,undefined,0 or false");
    }
  } catch (error) {
    answerValue = null;
  }

  if (type && type === valueTypes.CODING) {
    return codingValue;
  } else {
    return answerValue;
  }
} //#endregion
//#region CREATE ITEMLIST

/**
 * Creates a flat List of all Items
 * @param {Object} questionnaire
 */

function createItemList(object) {
  if (object) {
    var itemList = [];
    getGroupsAndItems(object, itemList);
    return itemList;
  } else {
    throw new Error("Creating an ItemList failed, because the given object was null or undefined");
  }
}
/**
 *
 */

function getGroupsAndItems(varitem, itemList) {
  if (varitem && varitem.item && itemList) {
    for (var i = 0; i < varitem.item.length; i++) {
      if (varitem.item[i].item) {
        itemList.push(varitem.item[i]);
        getGroupsAndItems(varitem.item[i], itemList);
      } else {
        itemList.push(varitem.item[i]);
      }
    }
  } else {
    throw new Error("Getting Groups and Items for the ItemList failed, because the given parameters were null or undefined");
  }
} //#endregion
//#region GET QUESTIONTYPE FROM Answer IN ITEM

/**
 *Takes the given answers and returns the type
 *
 * @param {Object} answers
 */


function getAnswerType(answers) {
  if (answers && answers.length !== 0) {
    if (answers[0].valueBoolean || answers[0].valueBoolean === false) {
      return valueTypes.BOOLEAN;
    } else if (answers[0].valueDecimal) {
      return valueTypes.DECIMAL;
    } else if (answers[0].valueInteger) {
      return valueTypes.INTEGER;
    } else if (answers[0].valueDate) {
      return valueTypes.DATE;
    } else if (answers[0].valueDateTime) {
      return valueTypes.DATETIME;
    } else if (answers[0].valueTime) {
      return valueTypes.TIME;
    } else if (answers[0].valueString) {
      return valueTypes.STRING;
    } else if (answers[0].valueUri) {
      return valueTypes.URI;
    } else if (answers[0].valueAttachment) {
      return valueTypes.ATTACHMENT;
    } else if (answers[0].valueCoding) {
      return valueTypes.CODING;
    } else if (answers[0].valueQuantity) {
      return valueTypes.QUANTITY;
    } else {
      return "notype";
    }
  } else {
    throw new Error("Getting the AnswerType failed because the given answer object was null or undefined");
  }
} //#endregion

/* harmony default export */ var questionnaireResponseController = ({
  createQuestionnaireResponse: questionnaireResponseController_createQuestionnaireResponse,
  addAnswersToQuestionnaireResponse: addAnswersToQuestionnaireResponse,
  getAnswersFromQuestionnaireResponse: getAnswersFromQuestionnaireResponse,
  createItemList: createItemList,
  getAnswerType: getAnswerType
});
// CONCATENATED MODULE: ./src/util/questionnaireController.js









/**
 * Takes the given question and returns an Array of options for the Gui to iterate through. Handling reference and ValueSets
 *
 * @param {Object} questionnaire the Questionnaire needed for the referenced Valuesets
 * @param {Object} question
 */

function questionnaireController_getChoiceOptions(questionnaire, question, valueSets, FHIR_URL) {
  //check if reference or ValueSet
  if (questionnaire && question) {
    if (question.answerValueSet) {
      var reference = question.answerValueSet;

      if (reference.startsWith("#")) {
        return getReferenceOptions(questionnaire, reference);
      } else {
        if (FHIR_URL && valueSets) {
          return getValueSetOptions(reference, valueSets, FHIR_URL);
        } else {
          throw new Error("The given FHIR_URL or ValueSets was null or undefined");
        }
      }
    } else if (question.answerOption) {
      var optionsList = [];

      for (var i = 0; i < question.answerOption.length; i++) {
        var count = i + 1;
        var option = {
          display: getAnswerOptionValue(question.answerOption[i]),
          code: "A" + count
        };
        optionsList.push(option);
      }

      return optionsList;
    }
  } else {
    throw new Error("Getting Choice Options failed, because the given parameters were null, undefined or empty");
  }
}
/**
 * Return the value of the given answerOption
 * @param {Array} answerOption
 */

function getAnswerOptionValue(answerOption) {
  if (answerOption.valueInteger) {
    return answerOption.valueInteger;
  }

  if (answerOption.valueDate) {
    return answerOption.valueDate;
  }

  if (answerOption.valueTime) {
    return answerOption.valueTime;
  }

  if (answerOption.valueString) {
    return answerOption.valueString;
  }

  if (answerOption.valueCoding) {
    return answerOption.valueCoding.display;
  }
}
/**
 * Gets all Options from a Reference in the questionnaire
 * @param {Object} questionnaire
 * @param {String} reference
 */


function getReferenceOptions(questionnaire, reference) {
  //getting reference id to compare to ValueSet-Id
  if (questionnaire && reference) {
    var referenceSplit = reference.split("#", 2);
    var referenceId = referenceSplit[1];

    for (var i = 0; i < questionnaire.contained.length; i++) {
      if (questionnaire.contained[i].id === referenceId) {
        if (questionnaire.contained[i].compose.include[0].concept) {
          return questionnaire.contained[i].compose.include[0].concept;
        }
      }
    }
  } else {
    return [];
  }
}
/**
 * Fetches the given ValueSet from the FHIR-Server
 * NEW: Gets the given ValueSet from the Store or tries to download it if not yet stored
 * @param {String} url The ValueSets url
 */


function getValueSetOptions(_x, _x2) {
  return _getValueSetOptions.apply(this, arguments);
}
/**
 * Handles enable-when in questions by taking the current QuestionnaireResponse and logicList and check if any Question that is referenced in the logic-list has been answered.
 * If the logic returns true, the logic-question will be added to the current Itemlist.
 * @param {Array} currentQuestionnaireResponse The current QuestionnaireResponse
 * @param {Array} itemList original unflattened items of the questionnaire
 *
 * @returns itemList
 */


function _getValueSetOptions() {
  _getValueSetOptions = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(reference, valueSets) {
    var valueSet, i, valueSetUrl;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            valueSet = null;

            for (i = 0; i < valueSets.length; i++) {
              valueSetUrl = valueSets[i].url;

              if (reference === valueSetUrl) {
                valueSet = valueSets[i];
              }
            }

            if (!(valueSet && valueSet.expansion && valueSet.expansion.contains)) {
              _context.next = 6;
              break;
            }

            _context.next = 5;
            return valueSet.expansion.contains;

          case 5:
            return _context.abrupt("return", _context.sent);

          case 6:
            if (!(valueSet && valueSet.compose && valueSet.compose.include)) {
              _context.next = 8;
              break;
            }

            return _context.abrupt("return", valueSet.compose.include[0].concept);

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _getValueSetOptions.apply(this, arguments);
}

function handleEnableWhen(currentQuestionnaireResponse, itemList) {
  var newItemList = [];
  var answersList = questionnaireResponseController.createItemList(currentQuestionnaireResponse);
  addItemToList(answersList, itemList, newItemList);
  return newItemList;
}
/**
 * This Method adds Items to the given List by checking every question for an enable-when, then checking if there are answers for this question and if so, will run
 * the Logic-Method. If the Logic-Method returns true, the question will be added to the new List.
 * @param {*} answersList  List of all answers
 * @param {*} itemList  original unflattened items of the questionnaire
 * @param {*} newItemList new ItemList containing all questions and activated questions
 */

function addItemToList(answersList, itemList, newItemList) {
  var _loop = function _loop(i) {
    if (itemList[i].enableWhen) {
      var results = [];

      var _loop2 = function _loop2(x) {
        var item = answersList.find(function (element) {
          return element.linkId === itemList[i].enableWhen[x].question;
        });

        if (item.answer && item.answer.length !== 0) {
          if (handleEnableWhenLogic(item, itemList[i].enableWhen[x])) {
            results.push(true);
          }
        }
      };

      for (var x = 0; x < itemList[i].enableWhen.length; x++) {
        _loop2(x);
      }

      if (itemList[i].enableBehavior) {
        switch (itemList[i].enableBehavior) {
          case "All":
            if (results.length === itemList[i].enableWhen.length) {
              newItemList.push(itemList[i]);

              if (itemList[i].type === "group") {
                addItemToList(answersList, itemList[i].item, newItemList);
              }
            }

            break;

          case "Any":
            if (results.length > 0) {
              newItemList.push(itemList[i]);

              if (itemList[i].type === "group") {
                addItemToList(answersList, itemList[i].item, newItemList);
              }
            }

            break;

          default:
            if (results.length > 0) {
              newItemList.push(itemList[i]);

              if (itemList[i].type === "group") {
                addItemToList(answersList, itemList[i].item, newItemList);
              }
            }

            break;
        }
      } else {
        if (results.length > 0) {
          newItemList.push(itemList[i]);

          if (itemList[i].type === "group") {
            addItemToList(answersList, itemList[i].item, newItemList);
          }
        }
      }
    } else {
      newItemList.push(itemList[i]);

      if (itemList[i].type === "group") {
        addItemToList(answersList, itemList[i].item, newItemList);
      }
    }
  };

  for (var i = 0; i < itemList.length; i++) {
    _loop(i);
  }
}
/**
 * Compares the given answers with the given enableWhen-value using the operator
 * @param {Object} item Contains the answer to question that is referenced in the logicQuestion
 * @param {Object} enableWhen Contains the Reference, operator and expected result needed for the logic operation
 * @returns {Boolean} Returns true if at least one answer is true with the given operator, else returns false by default
 */


function handleEnableWhenLogic(item, enableWhen) {
  var result = false; //liste mit results

  for (var i = 0; i < item.answer.length; i++) {
    switch (enableWhen.operator) {
      case "exists":
        result = true;
        break;

      case "=":
        if (handleEnableWhenValueType(item.answer[i]) === handleEnableWhenAnswerType(enableWhen)) {
          result = true;
        }

        break;

      case "!=":
        if (handleEnableWhenValueType(item.answer[i]) !== handleEnableWhenAnswerType(enableWhen)) {
          result = true;
        }

        break;

      case ">":
        if (handleEnableWhenValueType(item.answer[i]) > handleEnableWhenAnswerType(enableWhen)) {
          result = true;
        }

        break;

      case "<":
        if (handleEnableWhenValueType(item.answer[i]) < handleEnableWhenAnswerType(enableWhen)) {
          result = true;
        }

        break;

      case ">=":
        if (handleEnableWhenValueType(item.answer[i]) >= handleEnableWhenAnswerType(enableWhen)) {
          result = true;
        }

        break;

      case "<=":
        if (handleEnableWhenValueType(item.answer[i]) <= handleEnableWhenAnswerType(enableWhen)) {
          result = true;
        }

        break;

      default:
    }
  }

  return result;
}
/**
 * Returns the value of the answer, by checking for every available type if the value is true or not.
 * @param {*} value
 */


function handleEnableWhenValueType(value) {
  if (value.valueBoolean || value.valueBoolean === false) {
    return value.valueBoolean;
  } else if (value.valueDecimal) {
    return value.valueDecimal;
  } else if (value.valueInteger) {
    return value.valueInteger;
  } else if (value.valueDate) {
    return value.valueDate;
  } else if (value.valueDateTime) {
    return value.valueDateTime;
  } else if (value.valueTime) {
    return value.valueTime;
  } else if (value.valueString) {
    return value.valueString;
  } else if (value.valueUri) {
    return value.valueUri;
  } else if (value.valueAttachment) {
    return value.valueAttachment;
  } else if (value.valueCoding) {
    return value.valueCoding.display;
  } else if (value.valueQuantity) {
    return value.valueQuantity;
  } else {
    return null;
  }
}
/**
 * Returns the value of the answer, by checking for every available type if the value is true or not.
 * @param {*} value
 */


function handleEnableWhenAnswerType(value) {
  if (value.answerBoolean || value.answerBoolean === false) {
    return value.answerBoolean;
  } else if (value.answerDecimal) {
    return value.answerDecimal;
  } else if (value.answerInteger) {
    return value.answerInteger;
  } else if (value.answerDate) {
    return value.answerDate;
  } else if (value.answerDateTime) {
    return value.answerDateTime;
  } else if (value.answerTime) {
    return value.answerTime;
  } else if (value.answerString) {
    return value.answerString;
  } else if (value.answerUri) {
    return value.answerUri;
  } else if (value.answerAttachment) {
    return value.answerAttachment;
  } else if (value.answerCoding) {
    return value.answerCoding.display;
  } else if (value.answerQuantity) {
    return value.answerQuantity;
  } else {
    return null;
  }
}

/* harmony default export */ var questionnaireController = ({
  handleEnableWhen: handleEnableWhen,
  getChoiceOptions: questionnaireController_getChoiceOptions
});
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"465b08a6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/questionnaire/FullQuestionnaire.vue?vue&type=template&id=612ed1f2&scoped=true&
var FullQuestionnairevue_type_template_id_612ed1f2_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.questionnaire)?_c('div',[(_vm.spinner.loading)?_c('div',{staticClass:"card card-basic-margins"},[_c('div',{staticClass:"card-body"},[_c('spinner',{staticClass:"mt4",attrs:{"size":"large","message":_vm.spinner.message}})],1)]):_vm._e(),(!_vm.spinner.loading)?_c('div',[_c('transition-group',{attrs:{"name":"list-complete","tag":"p"}},_vm._l((_vm.filteredItemList),function(question,index){return _c('span',{key:question.linkId,staticClass:"list-complete-item"},[_c('div',{staticClass:"card card-basic-margins",attrs:{"id":index}},[(_vm.language)?_c('div',{staticClass:"card-body"},[(question.type !== 'group')?_c('div',[_vm._v(_vm._s(_vm.language.question)+" "+_vm._s(_vm.getQuestionIndex(question) + 1)+" "+_vm._s(_vm.language.of)+" "+_vm._s(_vm.questionsList.length))]):_vm._e(),(question.groupId && !question.item)?_c('div',{staticClass:"question-group-text"},[_vm._v(" "+_vm._s(_vm.getGroupText(question))+" ")]):_vm._e(),_c(question.type + 'Question',{tag:"component",attrs:{"question":question,"questionnaireResponse":_vm.questionnaireResponse,"questionnaire":_vm.questionnaire,"valueSets":_vm.valueSets,"baseUrl":_vm.baseUrl,"primary":_vm.primary,"secondary":_vm.secondary,"danger":_vm.danger,"language":_vm.language},on:{"answer":function($event){return _vm.relayAnswer($event)}}})],1):_vm._e()])])}),0),_c('div',{staticClass:"card-margin-bottom"},[(_vm.language)?_c('div',{staticClass:"summary-button"},[_c('button',{staticClass:"btn button btn-outline-primary btn-lg",attrs:{"type":"button"},on:{"click":function($event){return _vm.backToQuestionnaireList()}}},[_vm._v(" "+_vm._s(_vm.language.back)+" ")]),_c('button',{staticClass:"btn button btn-primary btn-lg",attrs:{"type":"button","disabled":_vm.notAllRequiredQuestionsCompleted},on:{"click":_vm.goToSummary}},[_vm._v(" "+_vm._s(_vm.language.next)+" ")])]):_vm._e()])],1):_vm._e()]):_vm._e()}
var FullQuestionnairevue_type_template_id_612ed1f2_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/questionnaire/FullQuestionnaire.vue?vue&type=template&id=612ed1f2&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"465b08a6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/questions/DisplayQuestion.vue?vue&type=template&id=1ef7c3f4&scoped=true&
var DisplayQuestionvue_type_template_id_1ef7c3f4_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"display"},[_c('h5',{},[_vm._v(_vm._s(_vm.question.prefix)+" "+_vm._s(_vm.question.text))])])])}
var DisplayQuestionvue_type_template_id_1ef7c3f4_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/questions/DisplayQuestion.vue?vue&type=template&id=1ef7c3f4&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/questions/DisplayQuestion.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var DisplayQuestionvue_type_script_lang_js_ = ({
  props: {
    question: Object,
    mode: null,

    /**
     *  Object containing the translations for the current locale
     */
    language: {
      type: Object
    }
  }
});
// CONCATENATED MODULE: ./src/components/questions/DisplayQuestion.vue?vue&type=script&lang=js&
 /* harmony default export */ var questions_DisplayQuestionvue_type_script_lang_js_ = (DisplayQuestionvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/questions/DisplayQuestion.vue?vue&type=style&index=0&id=1ef7c3f4&lang=scss&scoped=true&
var DisplayQuestionvue_type_style_index_0_id_1ef7c3f4_lang_scss_scoped_true_ = __webpack_require__("914f");

// CONCATENATED MODULE: ./src/components/questions/DisplayQuestion.vue






/* normalize component */

var DisplayQuestion_component = normalizeComponent(
  questions_DisplayQuestionvue_type_script_lang_js_,
  DisplayQuestionvue_type_template_id_1ef7c3f4_scoped_true_render,
  DisplayQuestionvue_type_template_id_1ef7c3f4_scoped_true_staticRenderFns,
  false,
  null,
  "1ef7c3f4",
  null
  
)

/* harmony default export */ var DisplayQuestion = (DisplayQuestion_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"465b08a6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/questions/IntegerQuestion.vue?vue&type=template&id=c279d800&scoped=true&
var IntegerQuestionvue_type_template_id_c279d800_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[_vm._v(_vm._s(_vm.question.prefix)+" "+_vm._s(_vm.question.text))]),(_vm.language)?_c('div',{class:[{ hidden: _vm.validate || !_vm.question.required }],style:({ color: this.danger })},[_vm._v(" "+_vm._s(_vm.language.mandatory_question)+" ")]):_vm._e(),_c('hr'),_c('div',{staticClass:"class option-card"},[(_vm.isVasQuestion === true)?_c('vas-question',{attrs:{"min":_vm.minVas,"max":_vm.maxVas,"step":_vm.stepVas,"selected":_vm.selected,"labelLower":_vm.labelLowerVas,"labelUpper":_vm.labelUpperVas},on:{"selected-value":_vm.handleInputVas}}):_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"size",class:[{ 'was-validated': _vm.selected !== '' && _vm.selected }],attrs:{"id":'integer' + _vm.question.linkId}},[_c('label',{attrs:{"for":"integerInput"}},[_vm._v(_vm._s(_vm.language.integer.text)+":")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected),expression:"selected"}],ref:"integerInput",staticClass:"form-control",attrs:{"type":"number","step":"1","onkeypress":"return (event.charCode !== 44 && event.charCode !== 46)","inputMode":"numeric","pattern":"[0-9]*"},domProps:{"value":(_vm.selected)},on:{"input":function($event){if($event.target.composing){ return; }_vm.selected=$event.target.value}}}),(_vm.language)?_c('div',{staticClass:"my-invalid-feedback",class:_vm.validate !== false ? 'hidden' : _vm.selected === null ? 'hidden' : 'visible'},[_vm._v(" "+_vm._s(_vm.language.integer.invalid)+" ")]):_vm._e()])]),_c('br')],1)])}
var IntegerQuestionvue_type_template_id_c279d800_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/questions/IntegerQuestion.vue?vue&type=template&id=c279d800&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"465b08a6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/questions/VasQuestion.vue?vue&type=template&id=24872054&scoped=true&
var VasQuestionvue_type_template_id_24872054_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"class option-card"},[_c('div',{staticClass:"labels"},[_c('p',[_vm._v(_vm._s(_vm.labelLower))]),_c('p',[_vm._v(_vm._s(_vm.labelUpper))])]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.value),expression:"value"}],staticClass:"range",attrs:{"name":"vas","type":"range","min":_vm.min,"max":_vm.max,"step":_vm.step},domProps:{"value":(_vm.value)},on:{"input":function($event){return _vm.$emit('selected-value', _vm.value)},"__r":function($event){_vm.value=$event.target.value}}}),_c('div',{staticClass:"sliderticks"},_vm._l((_vm.range),function(n){return _c('p',{key:n},[_vm._v(_vm._s(n))])}),0)])])}
var VasQuestionvue_type_template_id_24872054_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/questions/VasQuestion.vue?vue&type=template&id=24872054&scoped=true&

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayWithoutHoles.js

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __webpack_require__("e01a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.iterator.js
var es_symbol_iterator = __webpack_require__("d28b");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.iterator.js
var es_array_iterator = __webpack_require__("e260");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.iterator.js
var es_string_iterator = __webpack_require__("3ca3");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.iterator.js
var web_dom_collections_iterator = __webpack_require__("ddb0");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.from.js
var es_array_from = __webpack_require__("a630");

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/iterableToArray.js








function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.slice.js
var es_array_slice = __webpack_require__("fb6a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.test.js
var es_regexp_test = __webpack_require__("00b4");

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js








function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/nonIterableSpread.js

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js




function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/questions/VasQuestion.vue?vue&type=script&lang=js&



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var VasQuestionvue_type_script_lang_js_ = ({
  props: {
    selected: {
      type: Number,
      default: 0
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 100
    },
    step: {
      type: Number,
      default: 1
    },
    labelLower: {
      type: String,
      default: "Lower-bound"
    },
    labelUpper: {
      type: String,
      default: "Upper-bound"
    }
  },
  data: function data() {
    return {
      value: this.selected
    };
  },
  computed: {
    range: function range() {
      var range = [];

      for (var i = this.min; i < this.max / 10 + 1; i++) {
        range = [].concat(_toConsumableArray(range), [i]);
      }

      return range;
    }
  }
});
// CONCATENATED MODULE: ./src/components/questions/VasQuestion.vue?vue&type=script&lang=js&
 /* harmony default export */ var questions_VasQuestionvue_type_script_lang_js_ = (VasQuestionvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/questions/VasQuestion.vue?vue&type=style&index=0&id=24872054&lang=scss&scoped=true&
var VasQuestionvue_type_style_index_0_id_24872054_lang_scss_scoped_true_ = __webpack_require__("fe0f");

// CONCATENATED MODULE: ./src/components/questions/VasQuestion.vue






/* normalize component */

var VasQuestion_component = normalizeComponent(
  questions_VasQuestionvue_type_script_lang_js_,
  VasQuestionvue_type_template_id_24872054_scoped_true_render,
  VasQuestionvue_type_template_id_24872054_scoped_true_staticRenderFns,
  false,
  null,
  "24872054",
  null
  
)

/* harmony default export */ var VasQuestion = (VasQuestion_component.exports);
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js







function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.to-string-tag.js
var es_symbol_to_string_tag = __webpack_require__("944a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.json.to-string-tag.js
var es_json_to_string_tag = __webpack_require__("0c47");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.math.to-string-tag.js
var es_math_to_string_tag = __webpack_require__("23dc");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__("25f0");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.set-prototype-of.js
var es_object_set_prototype_of = __webpack_require__("131a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.reflect.construct.js
var es_reflect_construct = __webpack_require__("4ae1");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.reflect.to-string-tag.js
var es_reflect_to_string_tag = __webpack_require__("f8c9");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.reflect.get.js
var es_reflect_get = __webpack_require__("5d41");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-prototype-of.js
var es_object_get_prototype_of = __webpack_require__("3410");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.constructor.js
var es_regexp_constructor = __webpack_require__("4d63");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.dot-all.js
var es_regexp_dot_all = __webpack_require__("c607");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.sticky.js
var es_regexp_sticky = __webpack_require__("2c3e");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.is-integer.js
var es_number_is_integer = __webpack_require__("8ba4");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.match.js
var es_string_match = __webpack_require__("466d");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.sort.js
var es_array_sort = __webpack_require__("4e82");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.trim.js
var es_string_trim = __webpack_require__("498a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.code-point-at.js
var es_string_code_point_at = __webpack_require__("f5b2");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.from-code-point.js
var es_string_from_code_point = __webpack_require__("f6d6");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.weak-map.js
var es_weak_map = __webpack_require__("10d1");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-own-property-names.js
var es_object_get_own_property_names = __webpack_require__("7039");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.sub.js
var es_string_sub = __webpack_require__("4c53");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.ends-with.js
var es_string_ends_with = __webpack_require__("8a79");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.fill.js
var es_array_fill = __webpack_require__("cb29");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.is-finite.js
var es_number_is_finite = __webpack_require__("f00c");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.freeze.js
var es_object_freeze = __webpack_require__("dca8");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__("2532");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.math.trunc.js
var es_math_trunc = __webpack_require__("b65f");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__("caad");

// CONCATENATED MODULE: ./src/assets/js/fhirpath.min.js
var fhirpath=function(e){var t={};function n(l){if(t[l])return t[l].exports;var i=t[l]={i:l,l:!1,exports:{}};return e[l].call(i.exports,i,i.exports,n),i.l=!0,i.exports;}return n.m=e,n.c=t,n.d=function(e,t,l){n.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:l});},n.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0});},n.t=function(e,t){if(1&t&&(e=n(e)),8&t)return e;if(4&t&&"object"==_typeof(e)&&e&&e.__esModule)return e;var l=Object.create(null);if(n.r(l),Object.defineProperty(l,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var i in e){n.d(l,i,function(t){return e[t];}.bind(null,i));}return l;},n.n=function(e){var t=e&&e.__esModule?function(){return e.default;}:function(){return e;};return n.d(t,"a",t),t;},n.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t);},n.p="",n(n.s=49);}([function(e,t){function n(e){return"["+e.join(", ")+"]";}function l(e,t){return e.equals(t);}function i(e){return e.hashCode();}function r(e,t){return this.data={},this.hashFunction=e||i,this.equalsFunction=t||l,this;}function s(){return this.data=[],this;}function a(e,t){return this.data={},this.hashFunction=e||i,this.equalsFunction=t||l,this;}function o(){return this.data={},this;}function u(e){return this.defaultMapCtor=e||a,this.cacheMap=new this.defaultMapCtor(),this;}function c(){return this.count=0,this.hash=0,this;}String.prototype.seed=String.prototype.seed||Math.round(Math.random()*Math.pow(2,32)),String.prototype.hashCode=function(){var e,t,n,l,i,r,s,a,o=this.toString();for(e=3&o.length,t=o.length-e,n=String.prototype.seed,i=3432918353,r=461845907,a=0;a<t;){s=255&o.charCodeAt(a)|(255&o.charCodeAt(++a))<<8|(255&o.charCodeAt(++a))<<16|(255&o.charCodeAt(++a))<<24,++a,n=27492+(65535&(l=5*(65535&(n=(n^=s=(65535&(s=(s=(65535&s)*i+(((s>>>16)*i&65535)<<16)&4294967295)<<15|s>>>17))*r+(((s>>>16)*r&65535)<<16)&4294967295)<<13|n>>>19))+((5*(n>>>16)&65535)<<16)&4294967295))+((58964+(l>>>16)&65535)<<16);}switch(s=0,e){case 3:s^=(255&o.charCodeAt(a+2))<<16;case 2:s^=(255&o.charCodeAt(a+1))<<8;case 1:n^=s=(65535&(s=(s=(65535&(s^=255&o.charCodeAt(a)))*i+(((s>>>16)*i&65535)<<16)&4294967295)<<15|s>>>17))*r+(((s>>>16)*r&65535)<<16)&4294967295;}return n^=o.length,n=2246822507*(65535&(n^=n>>>16))+((2246822507*(n>>>16)&65535)<<16)&4294967295,n=3266489909*(65535&(n^=n>>>13))+((3266489909*(n>>>16)&65535)<<16)&4294967295,(n^=n>>>16)>>>0;},Object.defineProperty(r.prototype,"length",{get:function get(){var e=0;for(var t in this.data){0===t.indexOf("hash_")&&(e+=this.data[t].length);}return e;}}),r.prototype.add=function(e){var t="hash_"+this.hashFunction(e);if(t in this.data){for(var n=this.data[t],l=0;l<n.length;l++){if(this.equalsFunction(e,n[l]))return n[l];}return n.push(e),e;}return this.data[t]=[e],e;},r.prototype.contains=function(e){return null!=this.get(e);},r.prototype.get=function(e){var t="hash_"+this.hashFunction(e);if(t in this.data)for(var n=this.data[t],l=0;l<n.length;l++){if(this.equalsFunction(e,n[l]))return n[l];}return null;},r.prototype.values=function(){var e=[];for(var t in this.data){0===t.indexOf("hash_")&&(e=e.concat(this.data[t]));}return e;},r.prototype.toString=function(){return n(this.values());},s.prototype.add=function(e){this.data[e]=!0;},s.prototype.or=function(e){var t=this;Object.keys(e.data).map(function(e){t.add(e);});},s.prototype.remove=function(e){delete this.data[e];},s.prototype.contains=function(e){return!0===this.data[e];},s.prototype.values=function(){return Object.keys(this.data);},s.prototype.minValue=function(){return Math.min.apply(null,this.values());},s.prototype.hashCode=function(){var e=new c();return e.update(this.values()),e.finish();},s.prototype.equals=function(e){return e instanceof s&&this.hashCode()===e.hashCode();},Object.defineProperty(s.prototype,"length",{get:function get(){return this.values().length;}}),s.prototype.toString=function(){return"{"+this.values().join(", ")+"}";},Object.defineProperty(a.prototype,"length",{get:function get(){var e=0;for(var t in this.data){0===t.indexOf("hash_")&&(e+=this.data[t].length);}return e;}}),a.prototype.put=function(e,t){var n="hash_"+this.hashFunction(e);if(n in this.data){for(var l=this.data[n],i=0;i<l.length;i++){var r=l[i];if(this.equalsFunction(e,r.key)){var s=r.value;return r.value=t,s;}}return l.push({key:e,value:t}),t;}return this.data[n]=[{key:e,value:t}],t;},a.prototype.containsKey=function(e){var t="hash_"+this.hashFunction(e);if(t in this.data)for(var n=this.data[t],l=0;l<n.length;l++){var i=n[l];if(this.equalsFunction(e,i.key))return!0;}return!1;},a.prototype.get=function(e){var t="hash_"+this.hashFunction(e);if(t in this.data)for(var n=this.data[t],l=0;l<n.length;l++){var i=n[l];if(this.equalsFunction(e,i.key))return i.value;}return null;},a.prototype.entries=function(){var e=[];for(var t in this.data){0===t.indexOf("hash_")&&(e=e.concat(this.data[t]));}return e;},a.prototype.getKeys=function(){return this.entries().map(function(e){return e.key;});},a.prototype.getValues=function(){return this.entries().map(function(e){return e.value;});},a.prototype.toString=function(){return"["+this.entries().map(function(e){return"{"+e.key+":"+e.value+"}";}).join(", ")+"]";},o.prototype.get=function(e){return(e="k-"+e)in this.data?this.data[e]:null;},o.prototype.put=function(e,t){e="k-"+e,this.data[e]=t;},o.prototype.values=function(){var e=this.data;return Object.keys(this.data).map(function(t){return e[t];});},c.prototype.update=function(){for(var e=0;e<arguments.length;e++){var t=arguments[e];if(null!=t)if(Array.isArray(t))this.update.apply(this,t);else{var n=0;switch(_typeof(t)){case"undefined":case"function":continue;case"number":case"boolean":n=t;break;case"string":n=t.hashCode();break;default:t.updateHashCode?t.updateHashCode(this):console.log("No updateHashCode for "+t.toString());continue;}n=(n*=3432918353)<<15|n>>>17,n*=461845907,this.count=this.count+1;var l=this.hash^n;l=5*(l=l<<13|l>>>19)+3864292196,this.hash=l;}}},c.prototype.finish=function(){var e=this.hash^4*this.count;return e^=e>>>16,e*=2246822507,e^=e>>>13,e*=3266489909,e^=e>>>16;},u.prototype.get=function(e,t){var n=this.cacheMap.get(e)||null;return null===n?null:n.get(t)||null;},u.prototype.set=function(e,t,n){var l=this.cacheMap.get(e)||null;null===l&&(l=new this.defaultMapCtor(),this.cacheMap.put(e,l)),l.put(t,n);},t.Hash=c,t.Set=r,t.Map=a,t.BitSet=s,t.AltDict=o,t.DoubleDict=u,t.hashStuff=function(){var e=new c();return e.update.apply(e,arguments),e.finish();},t.escapeWhitespace=function(e,t){return e=e.replace(/\t/g,"\\t").replace(/\n/g,"\\n").replace(/\r/g,"\\r"),t&&(e=e.replace(/ /g,"·")),e;},t.arrayToString=n,t.titleCase=function(e){return e.replace(/\w\S*/g,function(e){return e.charAt(0).toUpperCase()+e.substr(1);});},t.equalArrays=function(e,t){if(!Array.isArray(e)||!Array.isArray(t))return!1;if(e==t)return!0;if(e.length!=t.length)return!1;for(var n=0;n<e.length;n++){if(e[n]!=t[n]&&!e[n].equals(t[n]))return!1;}return!0;};},function(e,t){function n(){return this.source=null,this.type=null,this.channel=null,this.start=null,this.stop=null,this.tokenIndex=null,this.line=null,this.column=null,this._text=null,this;}function l(e,t,i,r,s){return n.call(this),this.source=void 0!==e?e:l.EMPTY_SOURCE,this.type=void 0!==t?t:null,this.channel=void 0!==i?i:n.DEFAULT_CHANNEL,this.start=void 0!==r?r:-1,this.stop=void 0!==s?s:-1,this.tokenIndex=-1,null!==this.source[0]?(this.line=e[0].line,this.column=e[0].column):this.column=-1,this;}n.INVALID_TYPE=0,n.EPSILON=-2,n.MIN_USER_TOKEN_TYPE=1,n.EOF=-1,n.DEFAULT_CHANNEL=0,n.HIDDEN_CHANNEL=1,Object.defineProperty(n.prototype,"text",{get:function get(){return this._text;},set:function set(e){this._text=e;}}),n.prototype.getTokenSource=function(){return this.source[0];},n.prototype.getInputStream=function(){return this.source[1];},l.prototype=Object.create(n.prototype),l.prototype.constructor=l,l.EMPTY_SOURCE=[null,null],l.prototype.clone=function(){var e=new l(this.source,this.type,this.channel,this.start,this.stop);return e.tokenIndex=this.tokenIndex,e.line=this.line,e.column=this.column,e.text=this.text,e;},Object.defineProperty(l.prototype,"text",{get:function get(){if(null!==this._text)return this._text;var e=this.getInputStream();if(null===e)return null;var t=e.size;return this.start<t&&this.stop<t?e.getText(this.start,this.stop):"<EOF>";},set:function set(e){this._text=e;}}),l.prototype.toString=function(){var e=this.text;return e=null!==e?e.replace(/\n/g,"\\n").replace(/\r/g,"\\r").replace(/\t/g,"\\t"):"<no text>","[@"+this.tokenIndex+","+this.start+":"+this.stop+"='"+e+"',<"+this.type+">"+(this.channel>0?",channel="+this.channel:"")+","+this.line+":"+this.column+"]";},t.Token=n,t.CommonToken=l;},function(e,t,n){var l=n(1).Token;function i(e,t){return this.start=e,this.stop=t,this;}function r(){this.intervals=null,this.readOnly=!1;}i.prototype.contains=function(e){return e>=this.start&&e<this.stop;},i.prototype.toString=function(){return this.start===this.stop-1?this.start.toString():this.start.toString()+".."+(this.stop-1).toString();},Object.defineProperty(i.prototype,"length",{get:function get(){return this.stop-this.start;}}),r.prototype.first=function(e){return null===this.intervals||0===this.intervals.length?l.INVALID_TYPE:this.intervals[0].start;},r.prototype.addOne=function(e){this.addInterval(new i(e,e+1));},r.prototype.addRange=function(e,t){this.addInterval(new i(e,t+1));},r.prototype.addInterval=function(e){if(null===this.intervals)this.intervals=[],this.intervals.push(e);else{for(var t=0;t<this.intervals.length;t++){var n=this.intervals[t];if(e.stop<n.start)return void this.intervals.splice(t,0,e);if(e.stop===n.start)return void(this.intervals[t].start=e.start);if(e.start<=n.stop)return this.intervals[t]=new i(Math.min(n.start,e.start),Math.max(n.stop,e.stop)),void this.reduce(t);}this.intervals.push(e);}},r.prototype.addSet=function(e){if(null!==e.intervals)for(var t=0;t<e.intervals.length;t++){var n=e.intervals[t];this.addInterval(new i(n.start,n.stop));}return this;},r.prototype.reduce=function(e){if(e<this.intervalslength-1){var t=this.intervals[e],n=this.intervals[e+1];t.stop>=n.stop?(this.intervals.pop(e+1),this.reduce(e)):t.stop>=n.start&&(this.intervals[e]=new i(t.start,n.stop),this.intervals.pop(e+1));}},r.prototype.complement=function(e,t){var n=new r();n.addInterval(new i(e,t+1));for(var l=0;l<this.intervals.length;l++){n.removeRange(this.intervals[l]);}return n;},r.prototype.contains=function(e){if(null===this.intervals)return!1;for(var t=0;t<this.intervals.length;t++){if(this.intervals[t].contains(e))return!0;}return!1;},Object.defineProperty(r.prototype,"length",{get:function get(){var e=0;return this.intervals.map(function(t){e+=t.length;}),e;}}),r.prototype.removeRange=function(e){if(e.start===e.stop-1)this.removeOne(e.start);else if(null!==this.intervals)for(var t=0,n=0;n<this.intervals.length;n++){var l=this.intervals[t];if(e.stop<=l.start)return;if(e.start>l.start&&e.stop<l.stop){this.intervals[t]=new i(l.start,e.start);var r=new i(e.stop,l.stop);return void this.intervals.splice(t,0,r);}e.start<=l.start&&e.stop>=l.stop?(this.intervals.splice(t,1),t-=1):e.start<l.stop?this.intervals[t]=new i(l.start,e.start):e.stop<l.stop&&(this.intervals[t]=new i(e.stop,l.stop)),t+=1;}},r.prototype.removeOne=function(e){if(null!==this.intervals)for(var t=0;t<this.intervals.length;t++){var n=this.intervals[t];if(e<n.start)return;if(e===n.start&&e===n.stop-1)return void this.intervals.splice(t,1);if(e===n.start)return void(this.intervals[t]=new i(n.start+1,n.stop));if(e===n.stop-1)return void(this.intervals[t]=new i(n.start,n.stop-1));if(e<n.stop-1){var l=new i(n.start,e);return n.start=e+1,void this.intervals.splice(t,0,l);}}},r.prototype.toString=function(e,t,n){return e=e||null,t=t||null,n=n||!1,null===this.intervals?"{}":null!==e||null!==t?this.toTokenString(e,t):n?this.toCharString():this.toIndexString();},r.prototype.toCharString=function(){for(var e=[],t=0;t<this.intervals.length;t++){var n=this.intervals[t];n.stop===n.start+1?n.start===l.EOF?e.push("<EOF>"):e.push("'"+String.fromCharCode(n.start)+"'"):e.push("'"+String.fromCharCode(n.start)+"'..'"+String.fromCharCode(n.stop-1)+"'");}return e.length>1?"{"+e.join(", ")+"}":e[0];},r.prototype.toIndexString=function(){for(var e=[],t=0;t<this.intervals.length;t++){var n=this.intervals[t];n.stop===n.start+1?n.start===l.EOF?e.push("<EOF>"):e.push(n.start.toString()):e.push(n.start.toString()+".."+(n.stop-1).toString());}return e.length>1?"{"+e.join(", ")+"}":e[0];},r.prototype.toTokenString=function(e,t){for(var n=[],l=0;l<this.intervals.length;l++){for(var i=this.intervals[l],r=i.start;r<i.stop;r++){n.push(this.elementName(e,t,r));}}return n.length>1?"{"+n.join(", ")+"}":n[0];},r.prototype.elementName=function(e,t,n){return n===l.EOF?"<EOF>":n===l.EPSILON?"<EPSILON>":e[n]||t[n];},t.Interval=i,t.IntervalSet=r;},function(e,t){function n(){return this.atn=null,this.stateNumber=n.INVALID_STATE_NUMBER,this.stateType=null,this.ruleIndex=0,this.epsilonOnlyTransitions=!1,this.transitions=[],this.nextTokenWithinRule=null,this;}function l(){return n.call(this),this.stateType=n.BASIC,this;}function i(){return n.call(this),this.decision=-1,this.nonGreedy=!1,this;}function r(){return i.call(this),this.endState=null,this;}function s(){return r.call(this),this.stateType=n.BLOCK_START,this;}function a(){return n.call(this),this.stateType=n.BLOCK_END,this.startState=null,this;}function o(){return n.call(this),this.stateType=n.RULE_STOP,this;}function u(){return n.call(this),this.stateType=n.RULE_START,this.stopState=null,this.isPrecedenceRule=!1,this;}function c(){return i.call(this),this.stateType=n.PLUS_LOOP_BACK,this;}function f(){return r.call(this),this.stateType=n.PLUS_BLOCK_START,this.loopBackState=null,this;}function m(){return r.call(this),this.stateType=n.STAR_BLOCK_START,this;}function p(){return n.call(this),this.stateType=n.STAR_LOOP_BACK,this;}function h(){return i.call(this),this.stateType=n.STAR_LOOP_ENTRY,this.loopBackState=null,this.isPrecedenceDecision=null,this;}function d(){return n.call(this),this.stateType=n.LOOP_END,this.loopBackState=null,this;}function g(){return i.call(this),this.stateType=n.TOKEN_START,this;}n.INVALID_TYPE=0,n.BASIC=1,n.RULE_START=2,n.BLOCK_START=3,n.PLUS_BLOCK_START=4,n.STAR_BLOCK_START=5,n.TOKEN_START=6,n.RULE_STOP=7,n.BLOCK_END=8,n.STAR_LOOP_BACK=9,n.STAR_LOOP_ENTRY=10,n.PLUS_LOOP_BACK=11,n.LOOP_END=12,n.serializationNames=["INVALID","BASIC","RULE_START","BLOCK_START","PLUS_BLOCK_START","STAR_BLOCK_START","TOKEN_START","RULE_STOP","BLOCK_END","STAR_LOOP_BACK","STAR_LOOP_ENTRY","PLUS_LOOP_BACK","LOOP_END"],n.INVALID_STATE_NUMBER=-1,n.prototype.toString=function(){return this.stateNumber;},n.prototype.equals=function(e){return e instanceof n&&this.stateNumber===e.stateNumber;},n.prototype.isNonGreedyExitState=function(){return!1;},n.prototype.addTransition=function(e,t){void 0===t&&(t=-1),0===this.transitions.length?this.epsilonOnlyTransitions=e.isEpsilon:this.epsilonOnlyTransitions!==e.isEpsilon&&(this.epsilonOnlyTransitions=!1),-1===t?this.transitions.push(e):this.transitions.splice(t,1,e);},l.prototype=Object.create(n.prototype),l.prototype.constructor=l,i.prototype=Object.create(n.prototype),i.prototype.constructor=i,r.prototype=Object.create(i.prototype),r.prototype.constructor=r,s.prototype=Object.create(r.prototype),s.prototype.constructor=s,a.prototype=Object.create(n.prototype),a.prototype.constructor=a,o.prototype=Object.create(n.prototype),o.prototype.constructor=o,u.prototype=Object.create(n.prototype),u.prototype.constructor=u,c.prototype=Object.create(i.prototype),c.prototype.constructor=c,f.prototype=Object.create(r.prototype),f.prototype.constructor=f,m.prototype=Object.create(r.prototype),m.prototype.constructor=m,p.prototype=Object.create(n.prototype),p.prototype.constructor=p,h.prototype=Object.create(i.prototype),h.prototype.constructor=h,d.prototype=Object.create(n.prototype),d.prototype.constructor=d,g.prototype=Object.create(i.prototype),g.prototype.constructor=g,t.ATNState=n,t.BasicState=l,t.DecisionState=i,t.BlockStartState=r,t.BlockEndState=a,t.LoopEndState=d,t.RuleStartState=u,t.RuleStopState=o,t.TokensStartState=g,t.PlusLoopbackState=c,t.StarLoopbackState=p,t.StarLoopEntryState=h,t.PlusBlockStartState=f,t.StarBlockStartState=m,t.BasicBlockStartState=s;},function(e,t,n){var l=n(1).Token,i=n(2).Interval,r=new i(-1,-2);n(0);function s(){return this;}function a(){return s.call(this),this;}function o(){return a.call(this),this;}function u(){return o.call(this),this;}function c(){return o.call(this),this;}function f(){return c.call(this),this;}function m(){return this;}function p(){return this;}function h(e){return c.call(this),this.parentCtx=null,this.symbol=e,this;}function d(e){return h.call(this,e),this;}function g(){return this;}a.prototype=Object.create(s.prototype),a.prototype.constructor=a,o.prototype=Object.create(a.prototype),o.prototype.constructor=o,u.prototype=Object.create(o.prototype),u.prototype.constructor=u,c.prototype=Object.create(o.prototype),c.prototype.constructor=c,f.prototype=Object.create(c.prototype),f.prototype.constructor=f,m.prototype.visit=function(e){return Array.isArray(e)?e.map(function(e){return e.accept(this);},this):e.accept(this);},m.prototype.visitChildren=function(e){return e.children?this.visit(e.children):null;},m.prototype.visitTerminal=function(e){},m.prototype.visitErrorNode=function(e){},p.prototype.visitTerminal=function(e){},p.prototype.visitErrorNode=function(e){},p.prototype.enterEveryRule=function(e){},p.prototype.exitEveryRule=function(e){},h.prototype=Object.create(c.prototype),h.prototype.constructor=h,h.prototype.getChild=function(e){return null;},h.prototype.getSymbol=function(){return this.symbol;},h.prototype.getParent=function(){return this.parentCtx;},h.prototype.getPayload=function(){return this.symbol;},h.prototype.getSourceInterval=function(){if(null===this.symbol)return r;var e=this.symbol.tokenIndex;return new i(e,e);},h.prototype.getChildCount=function(){return 0;},h.prototype.accept=function(e){return e.visitTerminal(this);},h.prototype.getText=function(){return this.symbol.text;},h.prototype.toString=function(){return this.symbol.type===l.EOF?"<EOF>":this.symbol.text;},d.prototype=Object.create(h.prototype),d.prototype.constructor=d,d.prototype.isErrorNode=function(){return!0;},d.prototype.accept=function(e){return e.visitErrorNode(this);},g.prototype.walk=function(e,t){if(t instanceof f||void 0!==t.isErrorNode&&t.isErrorNode())e.visitErrorNode(t);else if(t instanceof c)e.visitTerminal(t);else{this.enterRule(e,t);for(var n=0;n<t.getChildCount();n++){var l=t.getChild(n);this.walk(e,l);}this.exitRule(e,t);}},g.prototype.enterRule=function(e,t){var n=t.getRuleContext();e.enterEveryRule(n),n.enterRule(e);},g.prototype.exitRule=function(e,t){var n=t.getRuleContext();n.exitRule(e),e.exitEveryRule(n);},g.DEFAULT=new g(),t.RuleNode=u,t.ErrorNode=f,t.TerminalNode=c,t.ErrorNodeImpl=d,t.TerminalNodeImpl=h,t.ParseTreeListener=p,t.ParseTreeVisitor=m,t.ParseTreeWalker=g,t.INVALID_INTERVAL=r;},function(e,t,n){var l=n(9).PredicateTransition;function i(e){if(Error.call(this),Error.captureStackTrace)Error.captureStackTrace(this,i);else new Error().stack;return this.message=e.message,this.recognizer=e.recognizer,this.input=e.input,this.ctx=e.ctx,this.offendingToken=null,this.offendingState=-1,null!==this.recognizer&&(this.offendingState=this.recognizer.state),this;}function r(e,t,n,l){return i.call(this,{message:"",recognizer:e,input:t,ctx:null}),this.startIndex=n,this.deadEndConfigs=l,this;}function s(e,t,n,l,r,s){s=s||e._ctx,l=l||e.getCurrentToken(),n=n||e.getCurrentToken(),t=t||e.getInputStream(),i.call(this,{message:"",recognizer:e,input:t,ctx:s}),this.deadEndConfigs=r,this.startToken=n,this.offendingToken=l;}function a(e){i.call(this,{message:"",recognizer:e,input:e.getInputStream(),ctx:e._ctx}),this.offendingToken=e.getCurrentToken();}function o(e,t,n){i.call(this,{message:this.formatMessage(t,n||null),recognizer:e,input:e.getInputStream(),ctx:e._ctx});var r=e._interp.atn.states[e.state].transitions[0];return r instanceof l?(this.ruleIndex=r.ruleIndex,this.predicateIndex=r.predIndex):(this.ruleIndex=0,this.predicateIndex=0),this.predicate=t,this.offendingToken=e.getCurrentToken(),this;}function u(){return Error.call(this),Error.captureStackTrace(this,u),this;}i.prototype=Object.create(Error.prototype),i.prototype.constructor=i,i.prototype.getExpectedTokens=function(){return null!==this.recognizer?this.recognizer.atn.getExpectedTokens(this.offendingState,this.ctx):null;},i.prototype.toString=function(){return this.message;},r.prototype=Object.create(i.prototype),r.prototype.constructor=r,r.prototype.toString=function(){var e="";return this.startIndex>=0&&this.startIndex<this.input.size&&(e=this.input.getText((this.startIndex,this.startIndex))),"LexerNoViableAltException"+e;},s.prototype=Object.create(i.prototype),s.prototype.constructor=s,a.prototype=Object.create(i.prototype),a.prototype.constructor=a,o.prototype=Object.create(i.prototype),o.prototype.constructor=o,o.prototype.formatMessage=function(e,t){return null!==t?t:"failed predicate: {"+e+"}?";},u.prototype=Object.create(Error.prototype),u.prototype.constructor=u,t.RecognitionException=i,t.NoViableAltException=s,t.LexerNoViableAltException=r,t.InputMismatchException=a,t.FailedPredicateException=o,t.ParseCancellationException=u;},function(e,t,n){var l=n(18).RuleContext,i=n(0).Hash,r=n(0).Map;function s(e){this.cachedHashCode=e;}function a(){return this.cache=new r(),this;}function o(e,t){var n,l=new i();null!==e?l.update(e,t):l.update(1),n=l.finish(),s.call(this,n),this.parentCtx=e,this.returnState=t;}function u(){return o.call(this,null,s.EMPTY_RETURN_STATE),this;}function c(e,t){var n=new i();n.update(e,t);var l=n.finish();return s.call(this,l),this.parents=e,this.returnStates=t,this;}function f(e,t,n,l){if(e===t)return e;if(e instanceof o&&t instanceof o)return function(e,t,n,l){if(null!==l){var i=l.get(e,t);if(null!==i)return i;if(null!==(i=l.get(t,e)))return i;}var r=function(e,t,n){if(n){if(e===s.EMPTY)return s.EMPTY;if(t===s.EMPTY)return s.EMPTY;}else{if(e===s.EMPTY&&t===s.EMPTY)return s.EMPTY;if(e===s.EMPTY){var l=[t.returnState,s.EMPTY_RETURN_STATE];return new c([t.parentCtx,null],l);}if(t===s.EMPTY){l=[e.returnState,s.EMPTY_RETURN_STATE];return new c([e.parentCtx,null],l);}}return null;}(e,t,n);if(null!==r)return null!==l&&l.set(e,t,r),r;if(e.returnState===t.returnState){var a=f(e.parentCtx,t.parentCtx,n,l);if(a===e.parentCtx)return e;if(a===t.parentCtx)return t;var u=o.create(a,e.returnState);return null!==l&&l.set(e,t,u),u;}var m=null;if((e===t||null!==e.parentCtx&&e.parentCtx===t.parentCtx)&&(m=e.parentCtx),null!==m){var p=[e.returnState,t.returnState];e.returnState>t.returnState&&(p[0]=t.returnState,p[1]=e.returnState);var h=new c(d=[m,m],p);return null!==l&&l.set(e,t,h),h;}p=[e.returnState,t.returnState];var d=[e.parentCtx,t.parentCtx];e.returnState>t.returnState&&(p[0]=t.returnState,p[1]=e.returnState,d=[t.parentCtx,e.parentCtx]);var g=new c(d,p);return null!==l&&l.set(e,t,g),g;}(e,t,n,l);if(n){if(e instanceof u)return e;if(t instanceof u)return t;}return e instanceof o&&(e=new c([e.getParent()],[e.returnState])),t instanceof o&&(t=new c([t.getParent()],[t.returnState])),function(e,t,n,l){if(null!==l){var i=l.get(e,t);if(null!==i)return i;if(null!==(i=l.get(t,e)))return i;}var a=0,u=0,m=0,p=[],h=[];for(;a<e.returnStates.length&&u<t.returnStates.length;){var d=e.parents[a],g=t.parents[u];if(e.returnStates[a]===t.returnStates[u]){var y=e.returnStates[a],C=y===s.EMPTY_RETURN_STATE&&null===d&&null===g,_=null!==d&&null!==g&&d===g;if(C||_)h[m]=d,p[m]=y;else{var v=f(d,g,n,l);h[m]=v,p[m]=y;}a+=1,u+=1;}else e.returnStates[a]<t.returnStates[u]?(h[m]=d,p[m]=e.returnStates[a],a+=1):(h[m]=g,p[m]=t.returnStates[u],u+=1);m+=1;}if(a<e.returnStates.length)for(var L=a;L<e.returnStates.length;L++){h[m]=e.parents[L],p[m]=e.returnStates[L],m+=1;}else for(L=u;L<t.returnStates.length;L++){h[m]=t.parents[L],p[m]=t.returnStates[L],m+=1;}if(m<h.length){if(1===m){var b=o.create(h[0],p[0]);return null!==l&&l.set(e,t,b),b;}h=h.slice(0,m),p=p.slice(0,m);}var U=new c(h,p);if(U===e)return null!==l&&l.set(e,t,e),e;if(U===t)return null!==l&&l.set(e,t,t),t;(function(e){for(var t=new r(),n=0;n<e.length;n++){var l=e[n];t.containsKey(l)||t.put(l,l);}for(var i=0;i<e.length;i++){e[i]=t.get(e[i]);}})(h),null!==l&&l.set(e,t,U);return U;}(e,t,n,l);}s.EMPTY=null,s.EMPTY_RETURN_STATE=2147483647,s.globalNodeCount=1,s.id=s.globalNodeCount,s.prototype.isEmpty=function(){return this===s.EMPTY;},s.prototype.hasEmptyPath=function(){return this.getReturnState(this.length-1)===s.EMPTY_RETURN_STATE;},s.prototype.hashCode=function(){return this.cachedHashCode;},s.prototype.updateHashCode=function(e){e.update(this.cachedHashCode);},a.prototype.add=function(e){if(e===s.EMPTY)return s.EMPTY;var t=this.cache.get(e)||null;return null!==t?t:(this.cache.put(e,e),e);},a.prototype.get=function(e){return this.cache.get(e)||null;},Object.defineProperty(a.prototype,"length",{get:function get(){return this.cache.length;}}),o.prototype=Object.create(s.prototype),o.prototype.contructor=o,o.create=function(e,t){return t===s.EMPTY_RETURN_STATE&&null===e?s.EMPTY:new o(e,t);},Object.defineProperty(o.prototype,"length",{get:function get(){return 1;}}),o.prototype.getParent=function(e){return this.parentCtx;},o.prototype.getReturnState=function(e){return this.returnState;},o.prototype.equals=function(e){return this===e||e instanceof o&&this.hashCode()===e.hashCode()&&this.returnState===e.returnState&&(null==this.parentCtx?null==e.parentCtx:this.parentCtx.equals(e.parentCtx));},o.prototype.toString=function(){var e=null===this.parentCtx?"":this.parentCtx.toString();return 0===e.length?this.returnState===s.EMPTY_RETURN_STATE?"$":""+this.returnState:this.returnState+" "+e;},u.prototype=Object.create(o.prototype),u.prototype.constructor=u,u.prototype.isEmpty=function(){return!0;},u.prototype.getParent=function(e){return null;},u.prototype.getReturnState=function(e){return this.returnState;},u.prototype.equals=function(e){return this===e;},u.prototype.toString=function(){return"$";},s.EMPTY=new u(),c.prototype=Object.create(s.prototype),c.prototype.constructor=c,c.prototype.isEmpty=function(){return this.returnStates[0]===s.EMPTY_RETURN_STATE;},Object.defineProperty(c.prototype,"length",{get:function get(){return this.returnStates.length;}}),c.prototype.getParent=function(e){return this.parents[e];},c.prototype.getReturnState=function(e){return this.returnStates[e];},c.prototype.equals=function(e){return this===e||e instanceof c&&this.hashCode()===e.hashCode()&&this.returnStates===e.returnStates&&this.parents===e.parents;},c.prototype.toString=function(){if(this.isEmpty())return"[]";for(var e="[",t=0;t<this.returnStates.length;t++){t>0&&(e+=", "),this.returnStates[t]!==s.EMPTY_RETURN_STATE?(e+=this.returnStates[t],null!==this.parents[t]?e=e+" "+this.parents[t]:e+="null"):e+="$";}return e+"]";},t.merge=f,t.PredictionContext=s,t.PredictionContextCache=a,t.SingletonPredictionContext=o,t.predictionContextFromRuleContext=function e(t,n){if(null==n&&(n=l.EMPTY),null===n.parentCtx||n===l.EMPTY)return s.EMPTY;var i=e(t,n.parentCtx),r=t.states[n.invokingState].transitions[0];return o.create(i,r.followState.stateNumber);},t.getCachedPredictionContext=function e(t,n,l){if(t.isEmpty())return t;var i=l.get(t)||null;if(null!==i)return i;if(null!==(i=n.get(t)))return l.put(t,i),i;for(var r=!1,a=[],u=0;u<a.length;u++){var f=e(t.getParent(u),n,l);if(r||f!==t.getParent(u)){if(!r){a=[];for(var m=0;m<t.length;m++){a[m]=t.getParent(m);}r=!0;}a[u]=f;}}if(!r)return n.add(t),l.put(t,t),t;var p=null;return p=0===a.length?s.EMPTY:1===a.length?o.create(a[0],t.getReturnState(0)):new c(a,t.returnStates),n.add(p),l.put(p,p),l.put(t,p),p;};},function(e,t,n){function l(e){return(l="function"==typeof Symbol&&"symbol"==_typeof(Symbol.iterator)?function(e){return _typeof(e);}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":_typeof(e);})(e);}var i={},r=n(10).ResourceNode;i.raiseError=function(e,t){throw(t=t?t+": ":"")+e;},i.assertAtMostOne=function(e,t){e.length>1&&i.raiseError("Was expecting no more than one element but got "+JSON.stringify(e),t);},i.assertType=function(e,t,n){var r=this.valData(e);if(t.indexOf(l(r))<0){var s=t.length>1?"one of "+t.join(", "):t[0];i.raiseError("Found type '"+l(e)+"' but was expecting "+s,n);}return r;},i.isEmpty=function(e){return Array.isArray(e)&&0==e.length;},i.isSome=function(e){return null!=e&&!i.isEmpty(e);},i.isTrue=function(e){return null!=e&&(!0===e||1==e.length&&!0===e[0]);},i.isFalse=function(e){return null!=e&&(!1===e||1==e.length&&!1===e[0]);},i.isCapitalized=function(e){return e&&e[0]===e[0].toUpperCase();},i.flatten=function(e){return e.reduce(function(e,t){return Array.isArray(t)?e=e.concat(t):e.push(t),e;},[]);},i.arraify=function(e){return Array.isArray(e)?e:i.isSome(e)?[e]:[];},i.valData=function(e){return e instanceof r?e.data:e;},e.exports=i;},function(e,t,n){var l=n(52).LL1Analyzer,i=n(2).IntervalSet;function r(e,t){return this.grammarType=e,this.maxTokenType=t,this.states=[],this.decisionToState=[],this.ruleToStartState=[],this.ruleToStopState=null,this.modeNameToStartState={},this.ruleToTokenType=null,this.lexerActions=null,this.modeToStartState=[],this;}r.prototype.nextTokensInContext=function(e,t){return new l(this).LOOK(e,null,t);},r.prototype.nextTokensNoContext=function(e){return null!==e.nextTokenWithinRule||(e.nextTokenWithinRule=this.nextTokensInContext(e,null),e.nextTokenWithinRule.readOnly=!0),e.nextTokenWithinRule;},r.prototype.nextTokens=function(e,t){return void 0===t?this.nextTokensNoContext(e):this.nextTokensInContext(e,t);},r.prototype.addState=function(e){null!==e&&(e.atn=this,e.stateNumber=this.states.length),this.states.push(e);},r.prototype.removeState=function(e){this.states[e.stateNumber]=null;},r.prototype.defineDecisionState=function(e){return this.decisionToState.push(e),e.decision=this.decisionToState.length-1,e.decision;},r.prototype.getDecisionState=function(e){return 0===this.decisionToState.length?null:this.decisionToState[e];};var s=n(1).Token;r.prototype.getExpectedTokens=function(e,t){if(e<0||e>=this.states.length)throw"Invalid state number.";var n=this.states[e],l=this.nextTokens(n);if(!l.contains(s.EPSILON))return l;var r=new i();for(r.addSet(l),r.removeOne(s.EPSILON);null!==t&&t.invokingState>=0&&l.contains(s.EPSILON);){var a=this.states[t.invokingState].transitions[0];l=this.nextTokens(a.followState),r.addSet(l),r.removeOne(s.EPSILON),t=t.parentCtx;}return l.contains(s.EPSILON)&&r.addOne(s.EOF),r;},r.INVALID_ALT_NUMBER=0,t.ATN=r;},function(e,t,n){var l=n(1).Token,i=(n(2).Interval,n(2).IntervalSet),r=n(13).Predicate,s=n(13).PrecedencePredicate;function a(e){if(null==e)throw"target cannot be null.";return this.target=e,this.isEpsilon=!1,this.label=null,this;}function o(e,t){return a.call(this,e),this.label_=t,this.label=this.makeLabel(),this.serializationType=a.ATOM,this;}function u(e,t,n,l){return a.call(this,e),this.ruleIndex=t,this.precedence=n,this.followState=l,this.serializationType=a.RULE,this.isEpsilon=!0,this;}function c(e,t){return a.call(this,e),this.serializationType=a.EPSILON,this.isEpsilon=!0,this.outermostPrecedenceReturn=t,this;}function f(e,t,n){return a.call(this,e),this.serializationType=a.RANGE,this.start=t,this.stop=n,this.label=this.makeLabel(),this;}function m(e){return a.call(this,e),this;}function p(e,t,n,l){return m.call(this,e),this.serializationType=a.PREDICATE,this.ruleIndex=t,this.predIndex=n,this.isCtxDependent=l,this.isEpsilon=!0,this;}function h(e,t,n,l){return a.call(this,e),this.serializationType=a.ACTION,this.ruleIndex=t,this.actionIndex=void 0===n?-1:n,this.isCtxDependent=void 0!==l&&l,this.isEpsilon=!0,this;}function d(e,t){return a.call(this,e),this.serializationType=a.SET,null!=t?this.label=t:(this.label=new i(),this.label.addOne(l.INVALID_TYPE)),this;}function g(e,t){return d.call(this,e,t),this.serializationType=a.NOT_SET,this;}function y(e){return a.call(this,e),this.serializationType=a.WILDCARD,this;}function C(e,t){return m.call(this,e),this.serializationType=a.PRECEDENCE,this.precedence=t,this.isEpsilon=!0,this;}a.EPSILON=1,a.RANGE=2,a.RULE=3,a.PREDICATE=4,a.ATOM=5,a.ACTION=6,a.SET=7,a.NOT_SET=8,a.WILDCARD=9,a.PRECEDENCE=10,a.serializationNames=["INVALID","EPSILON","RANGE","RULE","PREDICATE","ATOM","ACTION","SET","NOT_SET","WILDCARD","PRECEDENCE"],a.serializationTypes={EpsilonTransition:a.EPSILON,RangeTransition:a.RANGE,RuleTransition:a.RULE,PredicateTransition:a.PREDICATE,AtomTransition:a.ATOM,ActionTransition:a.ACTION,SetTransition:a.SET,NotSetTransition:a.NOT_SET,WildcardTransition:a.WILDCARD,PrecedencePredicateTransition:a.PRECEDENCE},o.prototype=Object.create(a.prototype),o.prototype.constructor=o,o.prototype.makeLabel=function(){var e=new i();return e.addOne(this.label_),e;},o.prototype.matches=function(e,t,n){return this.label_===e;},o.prototype.toString=function(){return this.label_;},u.prototype=Object.create(a.prototype),u.prototype.constructor=u,u.prototype.matches=function(e,t,n){return!1;},c.prototype=Object.create(a.prototype),c.prototype.constructor=c,c.prototype.matches=function(e,t,n){return!1;},c.prototype.toString=function(){return"epsilon";},f.prototype=Object.create(a.prototype),f.prototype.constructor=f,f.prototype.makeLabel=function(){var e=new i();return e.addRange(this.start,this.stop),e;},f.prototype.matches=function(e,t,n){return e>=this.start&&e<=this.stop;},f.prototype.toString=function(){return"'"+String.fromCharCode(this.start)+"'..'"+String.fromCharCode(this.stop)+"'";},m.prototype=Object.create(a.prototype),m.prototype.constructor=m,p.prototype=Object.create(m.prototype),p.prototype.constructor=p,p.prototype.matches=function(e,t,n){return!1;},p.prototype.getPredicate=function(){return new r(this.ruleIndex,this.predIndex,this.isCtxDependent);},p.prototype.toString=function(){return"pred_"+this.ruleIndex+":"+this.predIndex;},h.prototype=Object.create(a.prototype),h.prototype.constructor=h,h.prototype.matches=function(e,t,n){return!1;},h.prototype.toString=function(){return"action_"+this.ruleIndex+":"+this.actionIndex;},d.prototype=Object.create(a.prototype),d.prototype.constructor=d,d.prototype.matches=function(e,t,n){return this.label.contains(e);},d.prototype.toString=function(){return this.label.toString();},g.prototype=Object.create(d.prototype),g.prototype.constructor=g,g.prototype.matches=function(e,t,n){return e>=t&&e<=n&&!d.prototype.matches.call(this,e,t,n);},g.prototype.toString=function(){return"~"+d.prototype.toString.call(this);},y.prototype=Object.create(a.prototype),y.prototype.constructor=y,y.prototype.matches=function(e,t,n){return e>=t&&e<=n;},y.prototype.toString=function(){return".";},C.prototype=Object.create(m.prototype),C.prototype.constructor=C,C.prototype.matches=function(e,t,n){return!1;},C.prototype.getPredicate=function(){return new s(this.precedence);},C.prototype.toString=function(){return this.precedence+" >= _p";},t.Transition=a,t.AtomTransition=o,t.SetTransition=d,t.NotSetTransition=g,t.RuleTransition=u,t.ActionTransition=h,t.EpsilonTransition=c,t.RangeTransition=f,t.WildcardTransition=y,t.PredicateTransition=p,t.PrecedencePredicateTransition=C,t.AbstractPredicateTransition=m;},function(e,t,n){function l(e){return(l="function"==typeof Symbol&&"symbol"==_typeof(Symbol.iterator)?function(e){return _typeof(e);}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":_typeof(e);})(e);}function i(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),t&&r(e,t);}function r(e,t){return(r=Object.setPrototypeOf||function(e,t){return e.__proto__=t,e;})(e,t);}function s(e){return function(){var t,n=p(e);if(o()){var l=p(this).constructor;t=Reflect.construct(n,arguments,l);}else t=n.apply(this,arguments);return a(this,t);};}function a(e,t){return!t||"object"!==l(t)&&"function"!=typeof t?function(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e;}(e):t;}function o(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Date.prototype.toString.call(Reflect.construct(Date,[],function(){})),!0;}catch(e){return!1;}}function u(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function");}function c(e,t){for(var n=0;n<t.length;n++){var l=t[n];l.enumerable=l.enumerable||!1,l.configurable=!0,"value"in l&&(l.writable=!0),Object.defineProperty(e,l.key,l);}}function f(e,t,n){return t&&c(e.prototype,t),n&&c(e,n),e;}function m(e,t,n){return(m="undefined"!=typeof Reflect&&Reflect.get?Reflect.get:function(e,t,n){var l=function(e,t){for(;!Object.prototype.hasOwnProperty.call(e,t)&&null!==(e=p(e));){;}return e;}(e,t);if(l){var i=Object.getOwnPropertyDescriptor(l,t);return i.get?i.get.call(n):i.value;}})(e,t,n||e);}function p(e){return(p=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e);})(e);}var h=n(37),d=n(38).UcumLhcUtils.getInstance(),g=n(42),y="[0-9][0-9](\\:[0-9][0-9](\\:[0-9][0-9](\\.[0-9]+)?)?)?(Z|(\\+|-)[0-9][0-9]\\:[0-9][0-9])?",C=new RegExp("^T?"+y+"$"),_=new RegExp("^[0-9][0-9][0-9][0-9](-[0-9][0-9](-[0-9][0-9](T"+y+")?)?)?Z?$"),v=function(){function e(){u(this,e);}return f(e,[{key:"equals",value:function value(){return!1;}},{key:"equivalentTo",value:function value(){return!1;}},{key:"toString",value:function value(){return this.asStr?this.asStr:m(p(e.prototype),"toString",this).call(this);}},{key:"toJSON",value:function value(){return this.toString();}},{key:"compare",value:function value(){throw"Not implemented";}}]),e;}(),L=function(e){i(n,e);var t=s(n);function n(e,l){var i;return u(this,n),(i=t.call(this)).asStr=e+" "+l,i.value=e,i.unit=l,i;}return f(n,[{key:"equals",value:function value(e){if(!(e instanceof this.constructor))return!1;if(this.unit===e.unit)return g.isEqual(this.value,e.value);var t=this._compareYearsAndMonths(e);if(t)return t.isEqual;var l=n.toUcumQuantity(this.value,this.unit),i=n.toUcumQuantity(e.value,e.unit),r=d.convertUnitTo(i.unit,i.value,l.unit);return"succeeded"===r.status&&g.isEqual(l.value,r.toVal);}},{key:"equivalentTo",value:function value(e){if(!(e instanceof this.constructor))return!1;if(this.unit===e.unit)return g.isEquivalent(this.value,e.value);var t=n.getEquivalentUcumUnitCode(this.unit),l=n.getEquivalentUcumUnitCode(e.unit),i=d.convertUnitTo(l,e.value,t);return"succeeded"===i.status&&g.isEquivalent(this.value,i.toVal);}},{key:"_compareYearsAndMonths",value:function value(e){var t=n._yearMonthConversionFactor[this.unit],l=n._yearMonthConversionFactor[e.unit];return t&&l?{isEqual:g.isEqual(this.value*t,e.value*l)}:null;}}]),n;}(v),b=/^'|'$/g;L.getEquivalentUcumUnitCode=function(e){return L.mapTimeUnitsToUCUMCode[e]||e.replace(b,"");},L.toUcumQuantity=function(e,t){var n=L._calendarDuration2Seconds[t];return n?{value:n*e,unit:"s"}:{value:e,unit:t.replace(b,"")};},L.convUnitTo=function(e,t,n){var l=L._yearMonthConversionFactor[e],i=L._yearMonthConversionFactor[n];if(l&&i)return new L(l*t/i,n);var r=L._calendarDuration2Seconds[e],s=L._calendarDuration2Seconds[n];if(s){if(r)return new L(r*t/s,n);var a=d.convertUnitTo(e.replace(/^'|'$/g,""),t,"s");if("succeeded"===a.status)return new L(a.toVal/s,n);}else{var o=r?d.convertUnitTo("s",r*t,n.replace(/^'|'$/g,"")):d.convertUnitTo(e.replace(/^'|'$/g,""),t,n.replace(/^'|'$/g,""));if("succeeded"===o.status)return new L(o.toVal,n);}return null;},L._calendarDuration2Seconds={years:31536e3,months:2592e3,weeks:604800,days:86400,hours:3600,minutes:60,seconds:1,milliseconds:.001,year:31536e3,month:2592e3,week:604800,day:86400,hour:3600,minute:60,second:1,millisecond:.001},L._yearMonthConversionFactor={years:12,months:1,year:12,month:1},L.timeUnitsToUCUM={years:"'a'",months:"'mo'",weeks:"'wk'",days:"'d'",hours:"'h'",minutes:"'min'",seconds:"'s'",milliseconds:"'ms'",year:"'a'",month:"'mo'",week:"'wk'",day:"'d'",hour:"'h'",minute:"'min'",second:"'s'",millisecond:"'ms'","'a'":"'a'","'mo'":"'mo'","'wk'":"'wk'","'d'":"'d'","'h'":"'h'","'min'":"'min'","'s'":"'s'","'ms'":"'ms'"},L.mapUCUMCodeToTimeUnits={a:"year",mo:"month",wk:"week",d:"day",h:"hour",min:"minute",s:"second",ms:"millisecond"},L.mapTimeUnitsToUCUMCode=Object.keys(L.mapUCUMCodeToTimeUnits).reduce(function(e,t){return e[L.mapUCUMCodeToTimeUnits[t]]=t,e[L.mapUCUMCodeToTimeUnits[t]+"s"]=t,e;},{}),L.integerUnits={"'a'":!0,"'mo'":!0,"'wk'":!0,"'d'":!0,"'h'":!0,"'min'":!0};var U=function(e){i(n,e);var t=s(n);function n(e){var l;return u(this,n),(l=t.call(this)).asStr=e,l;}return f(n,[{key:"plus",value:function value(e){var t=e.unit,l=L.timeUnitsToUCUM[t];if(!l)throw new Error("For date/time arithmetic, the unit of the quantity must be a recognized time-based unit");var i=this.constructor,r=i._ucumToDatePrecision[l];if(void 0===r)throw new Error("Unsupported unit for +.  The unit should be one of "+Object.keys(i._ucumToDatePrecision).join(", ")+".");var s=L.integerUnits[l],a=e.value;if(s&&!Number.isInteger(a))throw new Error("When adding a quantity of unit "+t+" to a date/time, the value must be an integer.");if(this._getPrecision()<r){var o=l.slice(1,l.length-1),u=i._datePrecisionToUnquotedUcum[this._getPrecision()],c=d.convertUnitTo(o,a,u);if("succeeded"!=c.status)throw new Error(c.msg.join("\n"));l="'"+u+"'",a=Math.floor(c.toVal);}var f=n.timeUnitToAddFn[l](this._getDateObj(),a),m=i===M,p=this._getPrecision();m&&(p+=3);var h=T.isoDateTime(f,p);return m&&(h=h.slice(h.indexOf("T")+1)),new i(h);}},{key:"equals",value:function value(e){var t;if(e instanceof this.constructor){var n=this._getPrecision(),l=e._getPrecision();if(n==l)t=this._getDateObj().getTime()==e._getDateObj().getTime();else{var i=n<=l?n:l,r=this._getDateObj().toISOString(),s=e._getDateObj().toISOString();this.constructor===M&&(i+=3,n+=3,l+=3);for(var a=n>2?new T(r)._getTimeParts():this._getTimeParts(),o=l>2?new T(s)._getTimeParts():e._getTimeParts(),u=0;u<=i&&!1!==t;++u){t=a[u]==o[u];}t&&(t=void 0);}}else t=!1;return t;}},{key:"equivalentTo",value:function value(e){var t=e instanceof this.constructor;t&&(t=this._getPrecision()==e._getPrecision())&&(t=this._getDateObj().getTime()==e._getDateObj().getTime());return t;}},{key:"compare",value:function value(e){var t=this._getPrecision(),n=e._getPrecision(),l=t<=n?this._getDateObj().getTime():this._dateAtPrecision(n).getTime(),i=n<=t?e._getDateObj().getTime():e._dateAtPrecision(t).getTime();return l<i?-1:l===i?0:1;}},{key:"_getPrecision",value:function value(){return void 0===this.precision&&this._getMatchData(),this.precision;}},{key:"_getMatchData",value:function value(e,t){if(void 0===this.timeMatchData&&(this.timeMatchData=this.asStr.match(e),this.timeMatchData))for(var n=t;n>=0&&void 0===this.precision;--n){this.timeMatchData[n]&&(this.precision=n);}return this.timeMatchData;}},{key:"_getTimeParts",value:function value(e){var t=[];t=[e[0]];var n=e[4];if(n){var l=t[0];t[0]=l.slice(0,l.length-n.length);}var i=e[1];if(i){var r=t[0];t[0]=r.slice(0,r.length-i.length),t[1]=i;var s=e[2];if(s){t[1]=i.slice(0,i.length-s.length),t[2]=s;var a=e[3];a&&(t[2]=s.slice(0,s.length-a.length),t[3]=a);}}return t;}},{key:"_getDateObj",value:function value(){if(!this.dateObj){var e=this._getPrecision();this.dateObj=this._dateAtPrecision(e);}return this.dateObj;}},{key:"_createDate",value:function value(e,t,n,l,i,r,s,a){var o=new Date(e,t,n,l,i,r,s);if(a){var u=o.getTimezoneOffset(),c=0;if("Z"!=a){var f=a.split(":"),m=parseInt(f[0]);c=parseInt(f[1]),m<0&&(c=-c),c+=60*m;}o=h(o,-u-c);}return o;}}]),n;}(v);U.timeUnitToAddFn={"'a'":n(80),"'mo'":n(43),"'wk'":n(82),"'d'":n(44),"'h'":n(83),"'min'":n(37),"'s'":n(84),"'ms'":n(22)};var T=function(e){i(n,e);var t=s(n);function n(e){return u(this,n),t.call(this,e);}return f(n,[{key:"compare",value:function value(e){if(!(e instanceof n))throw"Invalid comparison of a DateTime with something else";return m(p(n.prototype),"compare",this).call(this,e);}},{key:"_getMatchData",value:function value(){return m(p(n.prototype),"_getMatchData",this).call(this,_,6);}},{key:"_getTimeParts",value:function value(){if(!this.timeParts){var e=this._getMatchData(),t=e[0];this.timeParts=[t];var l=e[1];if(l){this.timeParts[0]=t.slice(0,t.length-l.length),this.timeParts[1]=l;var i=e[2];if(i){this.timeParts[1]=l.slice(0,l.length-i.length),this.timeParts[2]=i;var r=e[3];r&&(this.timeParts[2]=i.slice(0,i.length-r.length),"T"===r[0]&&(e[3]=r.slice(1)),this.timeParts=this.timeParts.concat(m(p(n.prototype),"_getTimeParts",this).call(this,e.slice(3))));}}}return this.timeParts;}},{key:"_dateAtPrecision",value:function value(e){var t=this._getTimeParts(),n=this._getMatchData()[7],l=this._getPrecision(),i=parseInt(t[0]),r=l>0?parseInt(t[1].slice(1))-1:0,s=l>1?parseInt(t[2].slice(1)):1,a=l>2?parseInt(t[3]):0,o=l>3?parseInt(t[4].slice(1)):0,u=l>4?parseInt(t[5].slice(1)):0,c=l>5?parseInt(t[6].slice(1)):0,f=this._createDate(i,r,s,a,o,u,c,n);return e<this._getPrecision()&&(i=f.getFullYear(),r=e>0?f.getMonth():0,s=e>1?f.getDate():1,a=e>2?f.getHours():0,o=e>3?f.getMinutes():0,u=e>4?f.getSeconds():0,c=e>5?f.getMilliseconds():0,f=new Date(i,r,s,a,o,u,c)),f;}}]),n;}(U);T.checkString=function(e){var t=new T(e);return t._getMatchData()||(t=null),t;},T._ucumToDatePrecision={"'a'":0,"'mo'":1,"'wk'":2,"'d'":2,"'h'":3,"'min'":4,"'s'":5,"'ms'":6},T._datePrecisionToUnquotedUcum=["a","mo","d","h","min","s","ms"];var M=function(e){i(n,e);var t=s(n);function n(e){return u(this,n),"T"==e[0]&&(e=e.slice(1)),t.call(this,e);}return f(n,[{key:"compare",value:function value(e){if(!(e instanceof n))throw"Invalid comparison of a time with something else";return m(p(n.prototype),"compare",this).call(this,e);}},{key:"_dateAtPrecision",value:function value(e){var t=this._getTimeParts(),n=this._getMatchData()[4],l=this._getPrecision(),i=parseInt(t[0]),r=l>0?parseInt(t[1].slice(1)):0,s=l>1?parseInt(t[2].slice(1)):0,a=l>2?parseInt(t[3].slice(1)):0,o=this._createDate(2010,0,1,i,r,s,a,n);return n&&(o.setYear(2010),o.setMonth(0),o.setDate(1)),e<this._getPrecision()&&(i=o.getHours(),r=e>0?o.getMinutes():0,s=e>1?o.getSeconds():0,a=e>2?o.getMilliseconds():0,o=new Date(2010,0,1,i,r,s,a)),o;}},{key:"_getMatchData",value:function value(){return m(p(n.prototype),"_getMatchData",this).call(this,C,3);}},{key:"_getTimeParts",value:function value(){return this.timeParts||(this.timeParts=m(p(n.prototype),"_getTimeParts",this).call(this,this._getMatchData())),this.timeParts;}}]),n;}(U);function x(e,t){var n=e;return 3===t&&e<100&&(n="0"+e),e<10&&(n="0"+n),n;}M.checkString=function(e){var t=new M(e);return t._getMatchData()||(t=null),t;},M._ucumToDatePrecision={"'h'":0,"'min'":1,"'s'":2,"'ms'":3},M._datePrecisionToUnquotedUcum=["h","min","s","ms"],T.isoDateTime=function(e,t){void 0===t&&(t=6);var n=""+e.getFullYear();if(t>0&&(n+="-"+x(e.getMonth()+1),t>1&&(n+="-"+x(e.getDate()),t>2&&(n+="T"+x(e.getHours()),t>3&&(n+=":"+x(e.getMinutes()),t>4&&(n+=":"+x(e.getSeconds()),t>5&&(n+="."+x(e.getMilliseconds(),3))))))),t>2){var l=e.getTimezoneOffset(),i=l<0?"+":"-",r=(l=Math.abs(l))%60;n+=i+x((l-r)/60)+":"+x(r);}return n;},T.isoDate=function(e,t){return(void 0===t||t>2)&&(t=2),T.isoDateTime(e,t);};var S=function(){function e(t,n){u(this,e),t.resourceType&&(n=t.resourceType),this.path=n,this.data=function(e,t){"Quantity"===t&&"http://unitsofmeasure.org"===e.system&&"number"==typeof e.value&&"string"==typeof e.code&&(e=new L(e.value,L.mapUCUMCodeToTimeUnits[e.code]||"'"+e.code+"'"));return e;}(t,n);}return f(e,[{key:"toJSON",value:function value(){return JSON.stringify(this.data);}}]),e;}();S.makeResNode=function(e,t){return e instanceof S?e:new S(e,t);},e.exports={FP_Type:v,FP_TimeBase:U,FP_DateTime:T,FP_Time:M,FP_Quantity:L,timeRE:C,dateTimeRE:_,ResourceNode:S};},function(e,t,n){var l=n(8).ATN,i=n(0),r=i.Hash,s=i.Set,a=n(13).SemanticContext,o=n(6).merge;function u(e){return e.hashCodeForConfigSet();}function c(e,t){return e===t||null!==e&&null!==t&&e.equalsForConfigSet(t);}function f(e){return this.configLookup=new s(u,c),this.fullCtx=void 0===e||e,this.readOnly=!1,this.configs=[],this.uniqueAlt=0,this.conflictingAlts=null,this.hasSemanticContext=!1,this.dipsIntoOuterContext=!1,this.cachedHashCode=-1,this;}function m(){return f.call(this),this.configLookup=new s(),this;}f.prototype.add=function(e,t){if(void 0===t&&(t=null),this.readOnly)throw"This set is readonly";e.semanticContext!==a.NONE&&(this.hasSemanticContext=!0),e.reachesIntoOuterContext>0&&(this.dipsIntoOuterContext=!0);var n=this.configLookup.add(e);if(n===e)return this.cachedHashCode=-1,this.configs.push(e),!0;var l=!this.fullCtx,i=o(n.context,e.context,l,t);return n.reachesIntoOuterContext=Math.max(n.reachesIntoOuterContext,e.reachesIntoOuterContext),e.precedenceFilterSuppressed&&(n.precedenceFilterSuppressed=!0),n.context=i,!0;},f.prototype.getStates=function(){for(var e=new s(),t=0;t<this.configs.length;t++){e.add(this.configs[t].state);}return e;},f.prototype.getPredicates=function(){for(var e=[],t=0;t<this.configs.length;t++){var n=this.configs[t].semanticContext;n!==a.NONE&&e.push(n.semanticContext);}return e;},Object.defineProperty(f.prototype,"items",{get:function get(){return this.configs;}}),f.prototype.optimizeConfigs=function(e){if(this.readOnly)throw"This set is readonly";if(0!==this.configLookup.length)for(var t=0;t<this.configs.length;t++){var n=this.configs[t];n.context=e.getCachedContext(n.context);}},f.prototype.addAll=function(e){for(var t=0;t<e.length;t++){this.add(e[t]);}return!1;},f.prototype.equals=function(e){return this===e||e instanceof f&&i.equalArrays(this.configs,e.configs)&&this.fullCtx===e.fullCtx&&this.uniqueAlt===e.uniqueAlt&&this.conflictingAlts===e.conflictingAlts&&this.hasSemanticContext===e.hasSemanticContext&&this.dipsIntoOuterContext===e.dipsIntoOuterContext;},f.prototype.hashCode=function(){var e=new r();return e.update(this.configs),e.finish();},f.prototype.updateHashCode=function(e){this.readOnly?(-1===this.cachedHashCode&&(this.cachedHashCode=this.hashCode()),e.update(this.cachedHashCode)):e.update(this.hashCode());},Object.defineProperty(f.prototype,"length",{get:function get(){return this.configs.length;}}),f.prototype.isEmpty=function(){return 0===this.configs.length;},f.prototype.contains=function(e){if(null===this.configLookup)throw"This method is not implemented for readonly sets.";return this.configLookup.contains(e);},f.prototype.containsFast=function(e){if(null===this.configLookup)throw"This method is not implemented for readonly sets.";return this.configLookup.containsFast(e);},f.prototype.clear=function(){if(this.readOnly)throw"This set is readonly";this.configs=[],this.cachedHashCode=-1,this.configLookup=new s();},f.prototype.setReadonly=function(e){this.readOnly=e,e&&(this.configLookup=null);},f.prototype.toString=function(){return i.arrayToString(this.configs)+(this.hasSemanticContext?",hasSemanticContext="+this.hasSemanticContext:"")+(this.uniqueAlt!==l.INVALID_ALT_NUMBER?",uniqueAlt="+this.uniqueAlt:"")+(null!==this.conflictingAlts?",conflictingAlts="+this.conflictingAlts:"")+(this.dipsIntoOuterContext?",dipsIntoOuterContext":"");},m.prototype=Object.create(f.prototype),m.prototype.constructor=m,t.ATNConfigSet=f,t.OrderedATNConfigSet=m;},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.Ucum=void 0;t.Ucum={dimLen_:7,validOps_:[".","/"],codeSep_:": ",valMsgStart_:"Did you mean ",valMsgEnd_:"?",cnvMsgStart_:"We assumed you meant ",cnvMsgEnd_:".",openEmph_:" ->",closeEmph_:"<- ",openEmphHTML_:'<span class="emphSpan">',closeEmphHTML_:"</span>",bracesMsg_:"FYI - annotations (text in curly braces {}) are ignored, except that an annotation without a leading symbol implies the default unit 1 (the unity).",needMoleWeightMsg_:"Did you wish to convert between mass and moles?  The molecular weight of the substance represented by the units is required to perform the conversion.",csvCols_:{"case-sensitive code":"csCode_","LOINC property":"loincProperty_","name (display)":"name_",synonyms:"synonyms_",source:"source_",category:"category_",Guidance:"guidance_"},inputKey_:"case-sensitive code",specUnits_:{"B[10.nV]":"specialUnitOne","[m/s2/Hz^(1/2)]":"specialUnitTwo"}};},function(e,t,n){var l=n(0).Set,i=n(0).Hash;function r(){return this;}function s(e,t,n){return r.call(this),this.ruleIndex=void 0===e?-1:e,this.predIndex=void 0===t?-1:t,this.isCtxDependent=void 0!==n&&n,this;}function a(e){r.call(this),this.precedence=void 0===e?0:e;}function o(e,t){r.call(this);var n=new l();e instanceof o?e.opnds.map(function(e){n.add(e);}):n.add(e),t instanceof o?t.opnds.map(function(e){n.add(e);}):n.add(t);var i=a.filterPrecedencePredicates(n);if(i.length>0){var s=null;i.map(function(e){(null===s||e.precedence<s.precedence)&&(s=e);}),n.add(s);}return this.opnds=n.values(),this;}function u(e,t){r.call(this);var n=new l();e instanceof u?e.opnds.map(function(e){n.add(e);}):n.add(e),t instanceof u?t.opnds.map(function(e){n.add(e);}):n.add(t);var i=a.filterPrecedencePredicates(n);if(i.length>0){var s=i.sort(function(e,t){return e.compareTo(t);}),o=s[s.length-1];n.add(o);}return this.opnds=n.values(),this;}r.prototype.hashCode=function(){var e=new i();return this.updateHashCode(e),e.finish();},r.prototype.evaluate=function(e,t){},r.prototype.evalPrecedence=function(e,t){return this;},r.andContext=function(e,t){if(null===e||e===r.NONE)return t;if(null===t||t===r.NONE)return e;var n=new o(e,t);return 1===n.opnds.length?n.opnds[0]:n;},r.orContext=function(e,t){if(null===e)return t;if(null===t)return e;if(e===r.NONE||t===r.NONE)return r.NONE;var n=new u(e,t);return 1===n.opnds.length?n.opnds[0]:n;},s.prototype=Object.create(r.prototype),s.prototype.constructor=s,r.NONE=new s(),s.prototype.evaluate=function(e,t){var n=this.isCtxDependent?t:null;return e.sempred(n,this.ruleIndex,this.predIndex);},s.prototype.updateHashCode=function(e){e.update(this.ruleIndex,this.predIndex,this.isCtxDependent);},s.prototype.equals=function(e){return this===e||e instanceof s&&this.ruleIndex===e.ruleIndex&&this.predIndex===e.predIndex&&this.isCtxDependent===e.isCtxDependent;},s.prototype.toString=function(){return"{"+this.ruleIndex+":"+this.predIndex+"}?";},a.prototype=Object.create(r.prototype),a.prototype.constructor=a,a.prototype.evaluate=function(e,t){return e.precpred(t,this.precedence);},a.prototype.evalPrecedence=function(e,t){return e.precpred(t,this.precedence)?r.NONE:null;},a.prototype.compareTo=function(e){return this.precedence-e.precedence;},a.prototype.updateHashCode=function(e){e.update(31);},a.prototype.equals=function(e){return this===e||e instanceof a&&this.precedence===e.precedence;},a.prototype.toString=function(){return"{"+this.precedence+">=prec}?";},a.filterPrecedencePredicates=function(e){var t=[];return e.values().map(function(e){e instanceof a&&t.push(e);}),t;},o.prototype=Object.create(r.prototype),o.prototype.constructor=o,o.prototype.equals=function(e){return this===e||e instanceof o&&this.opnds===e.opnds;},o.prototype.updateHashCode=function(e){e.update(this.opnds,"AND");},o.prototype.evaluate=function(e,t){for(var n=0;n<this.opnds.length;n++){if(!this.opnds[n].evaluate(e,t))return!1;}return!0;},o.prototype.evalPrecedence=function(e,t){for(var n=!1,l=[],i=0;i<this.opnds.length;i++){var s=this.opnds[i],a=s.evalPrecedence(e,t);if(n|=a!==s,null===a)return null;a!==r.NONE&&l.push(a);}if(!n)return this;if(0===l.length)return r.NONE;var o=null;return l.map(function(e){o=null===o?e:r.andContext(o,e);}),o;},o.prototype.toString=function(){var e="";return this.opnds.map(function(t){e+="&& "+t.toString();}),e.length>3?e.slice(3):e;},u.prototype=Object.create(r.prototype),u.prototype.constructor=u,u.prototype.constructor=function(e){return this===e||e instanceof u&&this.opnds===e.opnds;},u.prototype.updateHashCode=function(e){e.update(this.opnds,"OR");},u.prototype.evaluate=function(e,t){for(var n=0;n<this.opnds.length;n++){if(this.opnds[n].evaluate(e,t))return!0;}return!1;},u.prototype.evalPrecedence=function(e,t){for(var n=!1,l=[],i=0;i<this.opnds.length;i++){var s=this.opnds[i],a=s.evalPrecedence(e,t);if(n|=a!==s,a===r.NONE)return r.NONE;null!==a&&l.push(a);}if(!n)return this;if(0===l.length)return null;return l.map(function(e){return e;}),null;},u.prototype.toString=function(){var e="";return this.opnds.map(function(t){e+="|| "+t.toString();}),e.length>3?e.slice(3):e;},t.SemanticContext=r,t.PrecedencePredicate=a,t.Predicate=s;},function(e,t,n){var l=n(11).ATNConfigSet,i=n(0),r=i.Hash,s=i.Set;function a(e,t){return this.alt=t,this.pred=e,this;}function o(e,t){return null===e&&(e=-1),null===t&&(t=new l()),this.stateNumber=e,this.configs=t,this.edges=null,this.isAcceptState=!1,this.prediction=0,this.lexerActionExecutor=null,this.requiresFullContext=!1,this.predicates=null,this;}a.prototype.toString=function(){return"("+this.pred+", "+this.alt+")";},o.prototype.getAltSet=function(){var e=new s();if(null!==this.configs)for(var t=0;t<this.configs.length;t++){var n=this.configs[t];e.add(n.alt);}return 0===e.length?null:e;},o.prototype.equals=function(e){return this===e||e instanceof o&&this.configs.equals(e.configs);},o.prototype.toString=function(){var e=this.stateNumber+":"+this.configs;return this.isAcceptState&&(e+="=>",null!==this.predicates?e+=this.predicates:e+=this.prediction),e;},o.prototype.hashCode=function(){var e=new r();return e.update(this.configs),e.finish();},t.DFAState=o,t.PredPrediction=a;},function(e,t,n){"use strict";function l(e,t){for(var n=0;n<t.length;n++){var l=t[n];l.enumerable=l.enumerable||!1,l.configurable=!0,"value"in l&&(l.writable=!0),Object.defineProperty(e,l.key,l);}}Object.defineProperty(t,"__esModule",{value:!0}),t.UnitTables=void 0;var i=n(12).Ucum,r=new(function(){function e(){!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function");}(this,e),this.unitNames_={},this.unitCodes_={},this.codeOrder_=[],this.unitStrings_={},this.unitDimensions_={},this.unitSynonyms_={},this.massDimIndex_=0;}var t,n,r;return t=e,(n=[{key:"unitsCount",value:function value(){return Object.keys(this.unitCodes_).length;}},{key:"addUnit",value:function value(e){e.name_&&this.addUnitName(e),this.addUnitCode(e),this.addUnitString(e);try{e.dim_.getProperty("dimVec_")&&this.addUnitDimension(e);}catch(e){}}},{key:"addUnitName",value:function value(e){var t=e.name_;if(!t)throw new Error("UnitTables.addUnitName called for a unit with no name.  "+"Unit code = ".concat(e.csCode_,"."));this.unitNames_[t]?this.unitNames_[t].push(e):this.unitNames_[t]=[e];}},{key:"addUnitCode",value:function value(e){var t=e.csCode_;if(!t)throw new Error("UnitTables.addUnitCode called for unit that has no code.");if(this.unitCodes_[t])throw new Error("UnitTables.addUnitCode called, already contains entry for "+"unit with code = ".concat(t));if(this.unitCodes_[t]=e,this.codeOrder_.push(t),"g"==t){for(var n=e.dim_.dimVec_,l=0;l<n.length&&n[l]<1;l++){;}this.massDimIndex_=l;}}},{key:"addUnitString",value:function value(e){var t=null;if(t=1==i.caseSensitive_?e.csUnitString_:e.ciUnitString_){var n={mag:e.baseFactorStr_,unit:e};this.unitStrings_[t]?this.unitStrings_[t].push(n):this.unitStrings_[t]=[n];}}},{key:"addUnitDimension",value:function value(e){var t=e.dim_.getProperty("dimVec_");if(!t)throw new Error("UnitTables.addUnitDimension called for a unit with no dimension.  "+"Unit code = ".concat(e.csCode_,"."));this.unitDimensions_[t]?this.unitDimensions_[t].push(e):this.unitDimensions_[t]=[e];}},{key:"buildUnitSynonyms",value:function value(){for(var e in this.unitCodes_){var t=this.unitCodes_[e],n=t.synonyms_;if(n){var l=n.split(";");if(""!==l[0])for(var i=l.length,r=0;r<i;r++){var s=l[r].trim();this.addSynonymCodes(e,s);}}this.addSynonymCodes(e,t.name_);}}},{key:"addSynonymCodes",value:function value(e,t){for(var n=t.split(" "),l=n.length,i=0;i<l;i++){var r=n[i];this.unitSynonyms_[r]?-1===this.unitSynonyms_[r].indexOf(e)&&this.unitSynonyms_[r].push(e):this.unitSynonyms_[r]=[e];}}},{key:"getUnitByCode",value:function value(e){var t=null;return e&&(t=this.unitCodes_[e]),t;}},{key:"getUnitByName",value:function value(e){if(null==e)throw new Error("Unable to find unit by name because no name was provided.");var t=e.indexOf(i.codeSep_),n=null;t>=1&&(n=e.substr(t+i.codeSep_.length),e=e.substr(0,t));var l=this.unitNames_[e];if(l){var r=l.length;if(n&&r>1){for(var s=0;l[s].csCode_!==n&&s<r;s++){;}l=s<r?[l[s]]:null;}}return l;}},{key:"getUnitByString",value:function value(e){var t=null;return e&&void 0===(t=this.unitStrings_[e])&&(t=null),t;}},{key:"getUnitsByDimension",value:function value(e){var t;if(null==e)throw new Error("Unable to find unit by because no dimension vector was provided.");return null==(t=this.unitDimensions_[e])&&console.log("Unable to find unit with dimension = ".concat(e)),t;}},{key:"getUnitBySynonym",value:function value(e){var t={},n=[];try{if(null==e)throw t.status="error",new Error("Unable to find unit by synonym because no synonym was provided.");var l;if(0===Object.keys(this.unitSynonyms_).length&&this.buildUnitSynonyms(),l=this.unitSynonyms_[e]){t.status="succeeded";for(var i=l.length,r=0;r<i;r++){n.push(this.unitCodes_[l[r]]);}t.units=n;}0===n.length&&(t.status="failed",t.msg="Unable to find any units with synonym = ".concat(e));}catch(e){t.msg=e.message;}return t;}},{key:"getAllUnitNames",value:function value(){return Object.keys(this.unitNames_);}},{key:"getUnitNamesList",value:function value(){var e=[],t=Object.keys(this.unitCodes_);t.sort(this.compareCodes);for(var n=t.length,l=0;l<n;l++){e[l]=t[l]+i.codeSep_+this.unitCodes_[t[l]].name_;}return e;}},{key:"getMassDimensionIndex",value:function value(){return this.massDimIndex_;}},{key:"compareCodes",value:function value(e,t){return(e=(e=e.replace(/[\[\]]/g,"")).toLowerCase())<(t=(t=t.replace(/[\[\]]/g,"")).toLowerCase())?-1:1;}},{key:"getAllUnitCodes",value:function value(){return Object.keys(this.unitCodes_);}},{key:"allUnitsByDef",value:function value(){for(var e=[],t=this.codeOrder_.length,n=0;n<t;n++){e.push(this.getUnitByCode(this.codeOrder_[n]));}return e;}},{key:"allUnitsByName",value:function value(e,t){null==t&&(t="|");for(var n="",l=this.getAllUnitNames(),i=l.length,r=e.length,s=0;s<i;s++){for(var a=this.getUnitByName(l[s]),o=0;o<a.length;o++){for(var u=a[o],c=0;c<r;c++){if(c>0&&(n+=t),"dim_"===e[c])null!==u.dim_&&void 0!==u.dim_&&u.dim_.dimVec_ instanceof Array?n+="["+u.dim_.dimVec_.join(",")+"]":n+="";else{var f=u[e[c]];n+="string"==typeof f?f.replace(/[\n\r]/g," "):f;}}n+="\r\n";}}return n;}},{key:"printUnits",value:function value(e,t){void 0===e&&(e=!1),void 0===t&&(t="|");var n="",l=this.codeOrder_.length,i="csCode"+t;e&&(i+="ciCode"+t),i+="name"+t,e&&(i+="isBase"+t),i+="magnitude"+t+"dimension"+t+"from unit(s)"+t+"value"+t+"function"+t,e&&(i+="property"+t+"printSymbol"+t+"synonyms"+t+"source"+t+"class"+t+"isMetric"+t+"variable"+t+"isSpecial"+t+"isAbitrary"+t),n=(i+="comment")+"\n";for(var r=0;r<l;r++){var s=this.getUnitByCode(this.codeOrder_[r]);i=this.codeOrder_[r]+t,e&&(i+=s.getProperty("ciCode_")+t),i+=s.getProperty("name_")+t,e&&(s.getProperty("isBase_")?i+="true"+t:i+="false"+t),i+=s.getProperty("magnitude_")+t;var a=s.getProperty("dim_");i+=a?a.dimVec_+t:"null"+t,s.csUnitString_?i+=s.csUnitString_+t+s.baseFactor_+t:i+="null"+t+"null"+t,s.cnv_?i+=s.cnv_+t:i+="null"+t,e&&(i+=s.getProperty("property_")+t+s.getProperty("printSymbol_")+t+s.getProperty("synonyms_")+t+s.getProperty("source_")+t+s.getProperty("class_")+t+s.getProperty("isMetric_")+t+s.getProperty("variable_")+t+s.getProperty("isSpecial_")+t+s.getProperty("isArbitrary_")+t),s.defError_&&(i+="problem parsing this one, deferred to later."),n+=i+"\n";}return n;}}])&&l(t.prototype,n),r&&l(t,r),e;}())(),s={getInstance:function getInstance(){return r;}};t.UnitTables=s;},function(e,t,n){t.atn=n(51),t.codepointat=n(33),t.dfa=n(58),t.fromcodepoint=n(34),t.tree=n(60),t.error=n(61),t.Token=n(1).Token,t.CommonToken=n(1).CommonToken,t.InputStream=n(63).InputStream,t.CommonTokenStream=n(64).CommonTokenStream,t.Lexer=n(19).Lexer,t.Parser=n(66).Parser;var l=n(6);t.PredictionContextCache=l.PredictionContextCache,t.ParserRuleContext=n(24).ParserRuleContext,t.Interval=n(2).Interval,t.Utils=n(0);},function(e,t,n){var l=n(3).DecisionState,i=n(13).SemanticContext,r=n(0).Hash;function s(e,t){if(null===e){var n={state:null,alt:null,context:null,semanticContext:null};return t&&(n.reachesIntoOuterContext=0),n;}var l={};return l.state=e.state||null,l.alt=void 0===e.alt?null:e.alt,l.context=e.context||null,l.semanticContext=e.semanticContext||null,t&&(l.reachesIntoOuterContext=e.reachesIntoOuterContext||0,l.precedenceFilterSuppressed=e.precedenceFilterSuppressed||!1),l;}function a(e,t){return this.checkContext(e,t),e=s(e),t=s(t,!0),this.state=null!==e.state?e.state:t.state,this.alt=null!==e.alt?e.alt:t.alt,this.context=null!==e.context?e.context:t.context,this.semanticContext=null!==e.semanticContext?e.semanticContext:null!==t.semanticContext?t.semanticContext:i.NONE,this.reachesIntoOuterContext=t.reachesIntoOuterContext,this.precedenceFilterSuppressed=t.precedenceFilterSuppressed,this;}function o(e,t){a.call(this,e,t);var n=e.lexerActionExecutor||null;return this.lexerActionExecutor=n||(null!==t?t.lexerActionExecutor:null),this.passedThroughNonGreedyDecision=null!==t&&this.checkNonGreedyDecision(t,this.state),this;}a.prototype.checkContext=function(e,t){null!==e.context&&void 0!==e.context||null!==t&&null!==t.context&&void 0!==t.context||(this.context=null);},a.prototype.hashCode=function(){var e=new r();return this.updateHashCode(e),e.finish();},a.prototype.updateHashCode=function(e){e.update(this.state.stateNumber,this.alt,this.context,this.semanticContext);},a.prototype.equals=function(e){return this===e||e instanceof a&&this.state.stateNumber===e.state.stateNumber&&this.alt===e.alt&&(null===this.context?null===e.context:this.context.equals(e.context))&&this.semanticContext.equals(e.semanticContext)&&this.precedenceFilterSuppressed===e.precedenceFilterSuppressed;},a.prototype.hashCodeForConfigSet=function(){var e=new r();return e.update(this.state.stateNumber,this.alt,this.semanticContext),e.finish();},a.prototype.equalsForConfigSet=function(e){return this===e||e instanceof a&&this.state.stateNumber===e.state.stateNumber&&this.alt===e.alt&&this.semanticContext.equals(e.semanticContext);},a.prototype.toString=function(){return"("+this.state+","+this.alt+(null!==this.context?",["+this.context.toString()+"]":"")+(this.semanticContext!==i.NONE?","+this.semanticContext.toString():"")+(this.reachesIntoOuterContext>0?",up="+this.reachesIntoOuterContext:"")+")";},o.prototype=Object.create(a.prototype),o.prototype.constructor=o,o.prototype.updateHashCode=function(e){e.update(this.state.stateNumber,this.alt,this.context,this.semanticContext,this.passedThroughNonGreedyDecision,this.lexerActionExecutor);},o.prototype.equals=function(e){return this===e||e instanceof o&&this.passedThroughNonGreedyDecision==e.passedThroughNonGreedyDecision&&(this.lexerActionExecutor?this.lexerActionExecutor.equals(e.lexerActionExecutor):!e.lexerActionExecutor)&&a.prototype.equals.call(this,e);},o.prototype.hashCodeForConfigSet=o.prototype.hashCode,o.prototype.equalsForConfigSet=o.prototype.equals,o.prototype.checkNonGreedyDecision=function(e,t){return e.passedThroughNonGreedyDecision||t instanceof l&&t.nonGreedy;},t.ATNConfig=a,t.LexerATNConfig=o;},function(e,t,n){var l=n(4).RuleNode,i=n(4).INVALID_INTERVAL,r=n(8).INVALID_ALT_NUMBER;function s(e,t){return l.call(this),this.parentCtx=e||null,this.invokingState=t||-1,this;}s.prototype=Object.create(l.prototype),s.prototype.constructor=s,s.prototype.depth=function(){for(var e=0,t=this;null!==t;){t=t.parentCtx,e+=1;}return e;},s.prototype.isEmpty=function(){return-1===this.invokingState;},s.prototype.getSourceInterval=function(){return i;},s.prototype.getRuleContext=function(){return this;},s.prototype.getPayload=function(){return this;},s.prototype.getText=function(){return 0===this.getChildCount()?"":this.children.map(function(e){return e.getText();}).join("");},s.prototype.getAltNumber=function(){return r;},s.prototype.setAltNumber=function(e){},s.prototype.getChild=function(e){return null;},s.prototype.getChildCount=function(){return 0;},s.prototype.accept=function(e){return e.visitChildren(this);},t.RuleContext=s;var a=n(26).Trees;s.prototype.toStringTree=function(e,t){return a.toStringTree(this,e,t);},s.prototype.toString=function(e,t){e=e||null,t=t||null;for(var n=this,l="[";null!==n&&n!==t;){if(null===e)n.isEmpty()||(l+=n.invokingState);else{var i=n.ruleIndex;l+=i>=0&&i<e.length?e[i]:""+i;}null===n.parentCtx||null===e&&n.parentCtx.isEmpty()||(l+=" "),n=n.parentCtx;}return l+="]";};},function(e,t,n){var l=n(1).Token,i=n(30).Recognizer,r=n(55).CommonTokenFactory,s=n(5).RecognitionException,a=n(5).LexerNoViableAltException;function o(e){return i.call(this),this._input=e,this._factory=r.DEFAULT,this._tokenFactorySourcePair=[this,e],this._interp=null,this._token=null,this._tokenStartCharIndex=-1,this._tokenStartLine=-1,this._tokenStartColumn=-1,this._hitEOF=!1,this._channel=l.DEFAULT_CHANNEL,this._type=l.INVALID_TYPE,this._modeStack=[],this._mode=o.DEFAULT_MODE,this._text=null,this;}o.prototype=Object.create(i.prototype),o.prototype.constructor=o,o.DEFAULT_MODE=0,o.MORE=-2,o.SKIP=-3,o.DEFAULT_TOKEN_CHANNEL=l.DEFAULT_CHANNEL,o.HIDDEN=l.HIDDEN_CHANNEL,o.MIN_CHAR_VALUE=0,o.MAX_CHAR_VALUE=1114111,o.prototype.reset=function(){null!==this._input&&this._input.seek(0),this._token=null,this._type=l.INVALID_TYPE,this._channel=l.DEFAULT_CHANNEL,this._tokenStartCharIndex=-1,this._tokenStartColumn=-1,this._tokenStartLine=-1,this._text=null,this._hitEOF=!1,this._mode=o.DEFAULT_MODE,this._modeStack=[],this._interp.reset();},o.prototype.nextToken=function(){if(null===this._input)throw"nextToken requires a non-null input stream.";var e=this._input.mark();try{for(;;){if(this._hitEOF)return this.emitEOF(),this._token;this._token=null,this._channel=l.DEFAULT_CHANNEL,this._tokenStartCharIndex=this._input.index,this._tokenStartColumn=this._interp.column,this._tokenStartLine=this._interp.line,this._text=null;for(var t=!1;;){this._type=l.INVALID_TYPE;var n=o.SKIP;try{n=this._interp.match(this._input,this._mode);}catch(e){if(!(e instanceof s))throw console.log(e.stack),e;this.notifyListeners(e),this.recover(e);}if(this._input.LA(1)===l.EOF&&(this._hitEOF=!0),this._type===l.INVALID_TYPE&&(this._type=n),this._type===o.SKIP){t=!0;break;}if(this._type!==o.MORE)break;}if(!t)return null===this._token&&this.emit(),this._token;}}finally{this._input.release(e);}},o.prototype.skip=function(){this._type=o.SKIP;},o.prototype.more=function(){this._type=o.MORE;},o.prototype.mode=function(e){this._mode=e;},o.prototype.pushMode=function(e){this._interp.debug&&console.log("pushMode "+e),this._modeStack.push(this._mode),this.mode(e);},o.prototype.popMode=function(){if(0===this._modeStack.length)throw"Empty Stack";return this._interp.debug&&console.log("popMode back to "+this._modeStack.slice(0,-1)),this.mode(this._modeStack.pop()),this._mode;},Object.defineProperty(o.prototype,"inputStream",{get:function get(){return this._input;},set:function set(e){this._input=null,this._tokenFactorySourcePair=[this,this._input],this.reset(),this._input=e,this._tokenFactorySourcePair=[this,this._input];}}),Object.defineProperty(o.prototype,"sourceName",{get:function get(){return this._input.sourceName;}}),o.prototype.emitToken=function(e){this._token=e;},o.prototype.emit=function(){var e=this._factory.create(this._tokenFactorySourcePair,this._type,this._text,this._channel,this._tokenStartCharIndex,this.getCharIndex()-1,this._tokenStartLine,this._tokenStartColumn);return this.emitToken(e),e;},o.prototype.emitEOF=function(){var e=this.column,t=this.line,n=this._factory.create(this._tokenFactorySourcePair,l.EOF,null,l.DEFAULT_CHANNEL,this._input.index,this._input.index-1,t,e);return this.emitToken(n),n;},Object.defineProperty(o.prototype,"type",{get:function get(){return this.type;},set:function set(e){this._type=e;}}),Object.defineProperty(o.prototype,"line",{get:function get(){return this._interp.line;},set:function set(e){this._interp.line=e;}}),Object.defineProperty(o.prototype,"column",{get:function get(){return this._interp.column;},set:function set(e){this._interp.column=e;}}),o.prototype.getCharIndex=function(){return this._input.index;},Object.defineProperty(o.prototype,"text",{get:function get(){return null!==this._text?this._text:this._interp.getText(this._input);},set:function set(e){this._text=e;}}),o.prototype.getAllTokens=function(){for(var e=[],t=this.nextToken();t.type!==l.EOF;){e.push(t),t=this.nextToken();}return e;},o.prototype.notifyListeners=function(e){var t=this._tokenStartCharIndex,n=this._input.index,l=this._input.getText(t,n),i="token recognition error at: '"+this.getErrorDisplay(l)+"'";this.getErrorListenerDispatch().syntaxError(this,null,this._tokenStartLine,this._tokenStartColumn,i,e);},o.prototype.getErrorDisplay=function(e){for(var t=[],n=0;n<e.length;n++){t.push(e[n]);}return t.join("");},o.prototype.getErrorDisplayForChar=function(e){return e.charCodeAt(0)===l.EOF?"<EOF>":"\n"===e?"\\n":"\t"===e?"\\t":"\r"===e?"\\r":e;},o.prototype.getCharErrorDisplay=function(e){return"'"+this.getErrorDisplayForChar(e)+"'";},o.prototype.recover=function(e){this._input.LA(1)!==l.EOF&&(e instanceof a?this._interp.consume(this._input):this._input.consume());},t.Lexer=o;},function(e,t){function n(){return this;}function l(){return n.call(this),this;}function i(e){if(n.call(this),null===e)throw"delegates";return this.delegates=e,this;}n.prototype.syntaxError=function(e,t,n,l,i,r){},n.prototype.reportAmbiguity=function(e,t,n,l,i,r,s){},n.prototype.reportAttemptingFullContext=function(e,t,n,l,i,r){},n.prototype.reportContextSensitivity=function(e,t,n,l,i,r){},l.prototype=Object.create(n.prototype),l.prototype.constructor=l,l.INSTANCE=new l(),l.prototype.syntaxError=function(e,t,n,l,i,r){console.error("line "+n+":"+l+" "+i);},i.prototype=Object.create(n.prototype),i.prototype.constructor=i,i.prototype.syntaxError=function(e,t,n,l,i,r){this.delegates.map(function(s){s.syntaxError(e,t,n,l,i,r);});},i.prototype.reportAmbiguity=function(e,t,n,l,i,r,s){this.delegates.map(function(a){a.reportAmbiguity(e,t,n,l,i,r,s);});},i.prototype.reportAttemptingFullContext=function(e,t,n,l,i,r){this.delegates.map(function(s){s.reportAttemptingFullContext(e,t,n,l,i,r);});},i.prototype.reportContextSensitivity=function(e,t,n,l,i,r){this.delegates.map(function(s){s.reportContextSensitivity(e,t,n,l,i,r);});},t.ErrorListener=n,t.ConsoleErrorListener=l,t.ProxyErrorListener=i;},function(e,t){function n(e,t,n){return this.dfa=e,this.literalNames=t||[],this.symbolicNames=n||[],this;}function l(e){return n.call(this,e,null),this;}n.prototype.toString=function(){if(null===this.dfa.s0)return null;for(var e="",t=this.dfa.sortedStates(),n=0;n<t.length;n++){var l=t[n];if(null!==l.edges)for(var i=l.edges.length,r=0;r<i;r++){var s=l.edges[r]||null;null!==s&&2147483647!==s.stateNumber&&(e=(e=(e=(e=(e=(e=e.concat(this.getStateString(l))).concat("-")).concat(this.getEdgeLabel(r))).concat("->")).concat(this.getStateString(s))).concat("\n"));}}return 0===e.length?null:e;},n.prototype.getEdgeLabel=function(e){return 0===e?"EOF":null!==this.literalNames||null!==this.symbolicNames?this.literalNames[e-1]||this.symbolicNames[e-1]:String.fromCharCode(e-1);},n.prototype.getStateString=function(e){var t=(e.isAcceptState?":":"")+"s"+e.stateNumber+(e.requiresFullContext?"^":"");return e.isAcceptState?null!==e.predicates?t+"=>"+e.predicates.toString():t+"=>"+e.prediction.toString():t;},l.prototype=Object.create(n.prototype),l.prototype.constructor=l,l.prototype.getEdgeLabel=function(e){return"'"+String.fromCharCode(e)+"'";},t.DFASerializer=n,t.LexerDFASerializer=l;},function(e,t,n){var l=n(23);e.exports=function(e,t){var n=l(e).getTime(),i=Number(t);return new Date(n+i);};},function(e,t,n){var l=n(69),i=n(70),r=/[T ]/,s=/:/,a=/^(\d{2})$/,o=[/^([+-]\d{2})$/,/^([+-]\d{3})$/,/^([+-]\d{4})$/],u=/^(\d{4})/,c=[/^([+-]\d{4})/,/^([+-]\d{5})/,/^([+-]\d{6})/],f=/^-(\d{2})$/,m=/^-?(\d{3})$/,p=/^-?(\d{2})-?(\d{2})$/,h=/^-?W(\d{2})$/,d=/^-?W(\d{2})-?(\d{1})$/,g=/^(\d{2}([.,]\d*)?)$/,y=/^(\d{2}):?(\d{2}([.,]\d*)?)$/,C=/^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,_=/([Z+-].*)$/,v=/^(Z)$/,L=/^([+-])(\d{2})$/,b=/^([+-])(\d{2}):?(\d{2})$/;function U(e,t,n){t=t||0,n=n||0;var l=new Date(0);l.setUTCFullYear(e,0,4);var i=7*t+n+1-(l.getUTCDay()||7);return l.setUTCDate(l.getUTCDate()+i),l;}e.exports=function(e,t){if(i(e))return new Date(e.getTime());if("string"!=typeof e)return new Date(e);var n=(t||{}).additionalDigits;n=null==n?2:Number(n);var T=function(e){var t,n={},l=e.split(r);s.test(l[0])?(n.date=null,t=l[0]):(n.date=l[0],t=l[1]);if(t){var i=_.exec(t);i?(n.time=t.replace(i[1],""),n.timezone=i[1]):n.time=t;}return n;}(e),M=function(e,t){var n,l=o[t],i=c[t];if(n=u.exec(e)||i.exec(e)){var r=n[1];return{year:parseInt(r,10),restDateString:e.slice(r.length)};}if(n=a.exec(e)||l.exec(e)){var s=n[1];return{year:100*parseInt(s,10),restDateString:e.slice(s.length)};}return{year:null};}(T.date,n),x=M.year,S=function(e,t){if(null===t)return null;var n,l,i,r;if(0===e.length)return(l=new Date(0)).setUTCFullYear(t),l;if(n=f.exec(e))return l=new Date(0),i=parseInt(n[1],10)-1,l.setUTCFullYear(t,i),l;if(n=m.exec(e)){l=new Date(0);var s=parseInt(n[1],10);return l.setUTCFullYear(t,0,s),l;}if(n=p.exec(e)){l=new Date(0),i=parseInt(n[1],10)-1;var a=parseInt(n[2],10);return l.setUTCFullYear(t,i,a),l;}if(n=h.exec(e))return r=parseInt(n[1],10)-1,U(t,r);if(n=d.exec(e)){r=parseInt(n[1],10)-1;var o=parseInt(n[2],10)-1;return U(t,r,o);}return null;}(M.restDateString,x);if(S){var I,N=S.getTime(),O=0;if(T.time&&(O=function(e){var t,n,l;if(t=g.exec(e))return(n=parseFloat(t[1].replace(",",".")))%24*36e5;if(t=y.exec(e))return n=parseInt(t[1],10),l=parseFloat(t[2].replace(",",".")),n%24*36e5+6e4*l;if(t=C.exec(e)){n=parseInt(t[1],10),l=parseInt(t[2],10);var i=parseFloat(t[3].replace(",","."));return n%24*36e5+6e4*l+1e3*i;}return null;}(T.time)),T.timezone)I=6e4*function(e){var t,n;if(t=v.exec(e))return 0;if(t=L.exec(e))return n=60*parseInt(t[2],10),"+"===t[1]?-n:n;if(t=b.exec(e))return n=60*parseInt(t[2],10)+parseInt(t[3],10),"+"===t[1]?-n:n;return 0;}(T.timezone);else{var E=N+O,k=new Date(E);I=l(k);var A=new Date(E);A.setDate(k.getDate()+1);var R=l(A)-l(k);R>0&&(I+=R);}return new Date(N+O+I);}return new Date(e);};},function(e,t,n){var l=n(18).RuleContext,i=n(4),r=i.INVALID_INTERVAL,s=i.TerminalNode,a=i.TerminalNodeImpl,o=i.ErrorNodeImpl,u=n(2).Interval;function c(e,t){e=e||null,t=t||null,l.call(this,e,t),this.ruleIndex=-1,this.children=null,this.start=null,this.stop=null,this.exception=null;}function f(e,t,n){return c.call(e,t),this.ruleIndex=n,this;}c.prototype=Object.create(l.prototype),c.prototype.constructor=c,c.prototype.copyFrom=function(e){this.parentCtx=e.parentCtx,this.invokingState=e.invokingState,this.children=null,this.start=e.start,this.stop=e.stop,e.children&&(this.children=[],e.children.map(function(e){e instanceof o&&(this.children.push(e),e.parentCtx=this);},this));},c.prototype.enterRule=function(e){},c.prototype.exitRule=function(e){},c.prototype.addChild=function(e){return null===this.children&&(this.children=[]),this.children.push(e),e;},c.prototype.removeLastChild=function(){null!==this.children&&this.children.pop();},c.prototype.addTokenNode=function(e){var t=new a(e);return this.addChild(t),t.parentCtx=this,t;},c.prototype.addErrorNode=function(e){var t=new o(e);return this.addChild(t),t.parentCtx=this,t;},c.prototype.getChild=function(e,t){if(t=t||null,null===this.children||e<0||e>=this.children.length)return null;if(null===t)return this.children[e];for(var n=0;n<this.children.length;n++){var l=this.children[n];if(l instanceof t){if(0===e)return l;e-=1;}}return null;},c.prototype.getToken=function(e,t){if(null===this.children||t<0||t>=this.children.length)return null;for(var n=0;n<this.children.length;n++){var l=this.children[n];if(l instanceof s&&l.symbol.type===e){if(0===t)return l;t-=1;}}return null;},c.prototype.getTokens=function(e){if(null===this.children)return[];for(var t=[],n=0;n<this.children.length;n++){var l=this.children[n];l instanceof s&&l.symbol.type===e&&t.push(l);}return t;},c.prototype.getTypedRuleContext=function(e,t){return this.getChild(t,e);},c.prototype.getTypedRuleContexts=function(e){if(null===this.children)return[];for(var t=[],n=0;n<this.children.length;n++){var l=this.children[n];l instanceof e&&t.push(l);}return t;},c.prototype.getChildCount=function(){return null===this.children?0:this.children.length;},c.prototype.getSourceInterval=function(){return null===this.start||null===this.stop?r:new u(this.start.tokenIndex,this.stop.tokenIndex);},l.EMPTY=new c(),f.prototype=Object.create(c.prototype),f.prototype.constructor=f,t.ParserRuleContext=c;},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.isNumericString=function(e){var t=""+e;return!isNaN(t)&&!isNaN(parseFloat(t));},t.isIntegerUnit=function(e){return /^\d+$/.test(e);},t.getSynonyms=function(e){var t,n={},i=l.getInstance();if((t=i.getUnitBySynonym(e)).units){n.status="succeeded";var r=t.units.length;n.units=[];for(var s=0;s<r;s++){var a=t.units[s];n.units[s]={code:a.csCode_,name:a.name_,guidance:a.guidance_};}}else n.status=t.status,n.msg=t.msg;return n;};var l=n(15).UnitTables;},function(e,t,n){var l=n(0),i=n(1).Token,r=(n(4).RuleNode,n(4).ErrorNode),s=n(4).TerminalNode,a=n(24).ParserRuleContext,o=n(18).RuleContext,u=n(8).INVALID_ALT_NUMBER;function c(){}c.toStringTree=function(e,t,n){t=t||null,null!==(n=n||null)&&(t=n.ruleNames);var i=c.getNodeText(e,t);i=l.escapeWhitespace(i,!1);var r=e.getChildCount();if(0===r)return i;var s="("+i+" ";r>0&&(i=c.toStringTree(e.getChild(0),t),s=s.concat(i));for(var a=1;a<r;a++){i=c.toStringTree(e.getChild(a),t),s=s.concat(" "+i);}return s=s.concat(")");},c.getNodeText=function(e,t,n){if(t=t||null,null!==(n=n||null)&&(t=n.ruleNames),null!==t){if(e instanceof o){var l=e.getAltNumber();return l!=u?t[e.ruleIndex]+":"+l:t[e.ruleIndex];}if(e instanceof r)return e.toString();if(e instanceof s&&null!==e.symbol)return e.symbol.text;}var a=e.getPayload();return a instanceof i?a.text:e.getPayload().toString();},c.getChildren=function(e){for(var t=[],n=0;n<e.getChildCount();n++){t.push(e.getChild(n));}return t;},c.getAncestors=function(e){var t=[];for(e=e.getParent();null!==e;){t=[e].concat(t),e=e.getParent();}return t;},c.findAllTokenNodes=function(e,t){return c.findAllNodes(e,t,!0);},c.findAllRuleNodes=function(e,t){return c.findAllNodes(e,t,!1);},c.findAllNodes=function(e,t,n){var l=[];return c._findAllNodes(e,t,n,l),l;},c._findAllNodes=function(e,t,n,l){n&&e instanceof s?e.symbol.type===t&&l.push(e):!n&&e instanceof a&&e.ruleIndex===t&&l.push(e);for(var i=0;i<e.getChildCount();i++){c._findAllNodes(e.getChild(i),t,n,l);}},c.descendants=function(e){for(var t=[e],n=0;n<e.getChildCount();n++){t=t.concat(c.descendants(e.getChild(n)));}return t;},t.Trees=c;},function(e,t,n){var l=n(1).Token,i=n(8).ATN,r=n(53).ATNType,s=n(3),a=s.ATNState,o=s.BasicState,u=s.DecisionState,c=s.BlockStartState,f=s.BlockEndState,m=s.LoopEndState,p=s.RuleStartState,h=s.RuleStopState,d=s.TokensStartState,g=s.PlusLoopbackState,y=s.StarLoopbackState,C=s.StarLoopEntryState,_=s.PlusBlockStartState,v=s.StarBlockStartState,L=s.BasicBlockStartState,b=n(9),U=b.Transition,T=b.AtomTransition,M=b.SetTransition,x=b.NotSetTransition,S=b.RuleTransition,I=b.RangeTransition,N=b.ActionTransition,O=b.EpsilonTransition,E=b.WildcardTransition,k=b.PredicateTransition,A=b.PrecedencePredicateTransition,R=n(2).IntervalSet,w=(n(2).Interval,n(28).ATNDeserializationOptions),P=n(29),D=P.LexerActionType,F=P.LexerSkipAction,q=P.LexerChannelAction,B=P.LexerCustomAction,H=P.LexerMoreAction,z=P.LexerTypeAction,G=P.LexerPushModeAction,V=P.LexerPopModeAction,j=P.LexerModeAction,K="59627784-3BE5-417A-B9EB-8131A7286089",W=["AADB8D7E-AEEF-4415-AD2B-8204D6CF042E",K];function J(e,t){var n=[];return n[e-1]=t,n.map(function(e){return t;});}function Y(e){return null==e&&(e=w.defaultOptions),this.deserializationOptions=e,this.stateFactories=null,this.actionFactories=null,this;}Y.prototype.isFeatureSupported=function(e,t){var n=W.indexOf(e);return!(n<0)&&W.indexOf(t)>=n;},Y.prototype.deserialize=function(e){this.reset(e),this.checkVersion(),this.checkUUID();var t=this.readATN();this.readStates(t),this.readRules(t),this.readModes(t);var n=[];return this.readSets(t,n,this.readInt.bind(this)),this.isFeatureSupported(K,this.uuid)&&this.readSets(t,n,this.readInt32.bind(this)),this.readEdges(t,n),this.readDecisions(t),this.readLexerActions(t),this.markPrecedenceDecisions(t),this.verifyATN(t),this.deserializationOptions.generateRuleBypassTransitions&&t.grammarType===r.PARSER&&(this.generateRuleBypassTransitions(t),this.verifyATN(t)),t;},Y.prototype.reset=function(e){var t=e.split("").map(function(e){var t=e.charCodeAt(0);return t>1?t-2:t+65534;});t[0]=e.charCodeAt(0),this.data=t,this.pos=0;},Y.prototype.checkVersion=function(){var e=this.readInt();if(3!==e)throw"Could not deserialize ATN with version "+e+" (expected 3).";},Y.prototype.checkUUID=function(){var e=this.readUUID();if(W.indexOf(e)<0)throw"59627784-3BE5-417A-B9EB-8131A7286089";this.uuid=e;},Y.prototype.readATN=function(){var e=this.readInt(),t=this.readInt();return new i(e,t);},Y.prototype.readStates=function(e){for(var t,n,l,i=[],r=[],s=this.readInt(),o=0;o<s;o++){var u=this.readInt();if(u!==a.INVALID_TYPE){var f=this.readInt();65535===f&&(f=-1);var m=this.stateFactory(u,f);if(u===a.LOOP_END){var p=this.readInt();i.push([m,p]);}else if(m instanceof c){var h=this.readInt();r.push([m,h]);}e.addState(m);}else e.addState(null);}for(t=0;t<i.length;t++){(n=i[t])[0].loopBackState=e.states[n[1]];}for(t=0;t<r.length;t++){(n=r[t])[0].endState=e.states[n[1]];}var d=this.readInt();for(t=0;t<d;t++){l=this.readInt(),e.states[l].nonGreedy=!0;}var g=this.readInt();for(t=0;t<g;t++){l=this.readInt(),e.states[l].isPrecedenceRule=!0;}},Y.prototype.readRules=function(e){var t,n=this.readInt();for(e.grammarType===r.LEXER&&(e.ruleToTokenType=J(n,0)),e.ruleToStartState=J(n,0),t=0;t<n;t++){var i=this.readInt(),s=e.states[i];if(e.ruleToStartState[t]=s,e.grammarType===r.LEXER){var a=this.readInt();65535===a&&(a=l.EOF),e.ruleToTokenType[t]=a;}}for(e.ruleToStopState=J(n,0),t=0;t<e.states.length;t++){var o=e.states[t];o instanceof h&&(e.ruleToStopState[o.ruleIndex]=o,e.ruleToStartState[o.ruleIndex].stopState=o);}},Y.prototype.readModes=function(e){for(var t=this.readInt(),n=0;n<t;n++){var l=this.readInt();e.modeToStartState.push(e.states[l]);}},Y.prototype.readSets=function(e,t,n){for(var l=this.readInt(),i=0;i<l;i++){var r=new R();t.push(r);var s=this.readInt();0!==this.readInt()&&r.addOne(-1);for(var a=0;a<s;a++){var o=n(),u=n();r.addRange(o,u);}}},Y.prototype.readEdges=function(e,t){var n,l,i,r,s,a=this.readInt();for(n=0;n<a;n++){var o=this.readInt(),u=this.readInt(),f=this.readInt(),m=this.readInt(),p=this.readInt(),h=this.readInt();r=this.edgeFactory(e,f,o,u,m,p,h,t),e.states[o].addTransition(r);}for(n=0;n<e.states.length;n++){for(i=e.states[n],l=0;l<i.transitions.length;l++){var d=i.transitions[l];if(d instanceof S){var v=-1;e.ruleToStartState[d.target.ruleIndex].isPrecedenceRule&&0===d.precedence&&(v=d.target.ruleIndex),r=new O(d.followState,v),e.ruleToStopState[d.target.ruleIndex].addTransition(r);}}}for(n=0;n<e.states.length;n++){if((i=e.states[n])instanceof c){if(null===i.endState)throw"IllegalState";if(null!==i.endState.startState)throw"IllegalState";i.endState.startState=i;}if(i instanceof g)for(l=0;l<i.transitions.length;l++){(s=i.transitions[l].target)instanceof _&&(s.loopBackState=i);}else if(i instanceof y)for(l=0;l<i.transitions.length;l++){(s=i.transitions[l].target)instanceof C&&(s.loopBackState=i);}}},Y.prototype.readDecisions=function(e){for(var t=this.readInt(),n=0;n<t;n++){var l=this.readInt(),i=e.states[l];e.decisionToState.push(i),i.decision=n;}},Y.prototype.readLexerActions=function(e){if(e.grammarType===r.LEXER){var t=this.readInt();e.lexerActions=J(t,null);for(var n=0;n<t;n++){var l=this.readInt(),i=this.readInt();65535===i&&(i=-1);var s=this.readInt();65535===s&&(s=-1);var a=this.lexerActionFactory(l,i,s);e.lexerActions[n]=a;}}},Y.prototype.generateRuleBypassTransitions=function(e){var t,n=e.ruleToStartState.length;for(t=0;t<n;t++){e.ruleToTokenType[t]=e.maxTokenType+t+1;}for(t=0;t<n;t++){this.generateRuleBypassTransition(e,t);}},Y.prototype.generateRuleBypassTransition=function(e,t){var n,l,i=new L();i.ruleIndex=t,e.addState(i);var r=new f();r.ruleIndex=t,e.addState(r),i.endState=r,e.defineDecisionState(i),r.startState=i;var s=null,a=null;if(e.ruleToStartState[t].isPrecedenceRule){for(a=null,n=0;n<e.states.length;n++){if(l=e.states[n],this.stateIsEndStateFor(l,t)){a=l,s=l.loopBackState.transitions[0];break;}}if(null===s)throw"Couldn't identify final state of the precedence rule prefix section.";}else a=e.ruleToStopState[t];for(n=0;n<e.states.length;n++){l=e.states[n];for(var u=0;u<l.transitions.length;u++){var c=l.transitions[u];c!==s&&c.target===a&&(c.target=r);}}for(var m=e.ruleToStartState[t],p=m.transitions.length;p>0;){i.addTransition(m.transitions[p-1]),m.transitions=m.transitions.slice(-1);}e.ruleToStartState[t].addTransition(new O(i)),r.addTransition(new O(a));var h=new o();e.addState(h),h.addTransition(new T(r,e.ruleToTokenType[t])),i.addTransition(new O(h));},Y.prototype.stateIsEndStateFor=function(e,t){if(e.ruleIndex!==t)return null;if(!(e instanceof C))return null;var n=e.transitions[e.transitions.length-1].target;return n instanceof m&&n.epsilonOnlyTransitions&&n.transitions[0].target instanceof h?e:null;},Y.prototype.markPrecedenceDecisions=function(e){for(var t=0;t<e.states.length;t++){var n=e.states[t];if(n instanceof C&&e.ruleToStartState[n.ruleIndex].isPrecedenceRule){var l=n.transitions[n.transitions.length-1].target;l instanceof m&&l.epsilonOnlyTransitions&&l.transitions[0].target instanceof h&&(n.isPrecedenceDecision=!0);}}},Y.prototype.verifyATN=function(e){if(this.deserializationOptions.verifyATN)for(var t=0;t<e.states.length;t++){var n=e.states[t];if(null!==n)if(this.checkCondition(n.epsilonOnlyTransitions||n.transitions.length<=1),n instanceof _)this.checkCondition(null!==n.loopBackState);else if(n instanceof C){if(this.checkCondition(null!==n.loopBackState),this.checkCondition(2===n.transitions.length),n.transitions[0].target instanceof v)this.checkCondition(n.transitions[1].target instanceof m),this.checkCondition(!n.nonGreedy);else{if(!(n.transitions[0].target instanceof m))throw"IllegalState";this.checkCondition(n.transitions[1].target instanceof v),this.checkCondition(n.nonGreedy);}}else n instanceof y?(this.checkCondition(1===n.transitions.length),this.checkCondition(n.transitions[0].target instanceof C)):n instanceof m?this.checkCondition(null!==n.loopBackState):n instanceof p?this.checkCondition(null!==n.stopState):n instanceof c?this.checkCondition(null!==n.endState):n instanceof f?this.checkCondition(null!==n.startState):n instanceof u?this.checkCondition(n.transitions.length<=1||n.decision>=0):this.checkCondition(n.transitions.length<=1||n instanceof h);}},Y.prototype.checkCondition=function(e,t){if(!e)throw null==t&&(t="IllegalState"),t;},Y.prototype.readInt=function(){return this.data[this.pos++];},Y.prototype.readInt32=function(){return this.readInt()|this.readInt()<<16;},Y.prototype.readLong=function(){return 4294967295&this.readInt32()|this.readInt32()<<32;};var Q=function(){for(var e=[],t=0;t<256;t++){e[t]=(t+256).toString(16).substr(1).toUpperCase();}return e;}();Y.prototype.readUUID=function(){for(var e=[],t=7;t>=0;t--){var n=this.readInt();e[2*t+1]=255&n,e[2*t]=n>>8&255;}return Q[e[0]]+Q[e[1]]+Q[e[2]]+Q[e[3]]+"-"+Q[e[4]]+Q[e[5]]+"-"+Q[e[6]]+Q[e[7]]+"-"+Q[e[8]]+Q[e[9]]+"-"+Q[e[10]]+Q[e[11]]+Q[e[12]]+Q[e[13]]+Q[e[14]]+Q[e[15]];},Y.prototype.edgeFactory=function(e,t,n,i,r,s,a,o){var u=e.states[i];switch(t){case U.EPSILON:return new O(u);case U.RANGE:return new I(u,0!==a?l.EOF:r,s);case U.RULE:return new S(e.states[r],s,a,u);case U.PREDICATE:return new k(u,r,s,0!==a);case U.PRECEDENCE:return new A(u,r);case U.ATOM:return new T(u,0!==a?l.EOF:r);case U.ACTION:return new N(u,r,s,0!==a);case U.SET:return new M(u,o[r]);case U.NOT_SET:return new x(u,o[r]);case U.WILDCARD:return new E(u);default:throw"The specified transition type: "+t+" is not valid.";}},Y.prototype.stateFactory=function(e,t){if(null===this.stateFactories){var n=[];n[a.INVALID_TYPE]=null,n[a.BASIC]=function(){return new o();},n[a.RULE_START]=function(){return new p();},n[a.BLOCK_START]=function(){return new L();},n[a.PLUS_BLOCK_START]=function(){return new _();},n[a.STAR_BLOCK_START]=function(){return new v();},n[a.TOKEN_START]=function(){return new d();},n[a.RULE_STOP]=function(){return new h();},n[a.BLOCK_END]=function(){return new f();},n[a.STAR_LOOP_BACK]=function(){return new y();},n[a.STAR_LOOP_ENTRY]=function(){return new C();},n[a.PLUS_LOOP_BACK]=function(){return new g();},n[a.LOOP_END]=function(){return new m();},this.stateFactories=n;}if(e>this.stateFactories.length||null===this.stateFactories[e])throw"The specified state type "+e+" is not valid.";var l=this.stateFactories[e]();if(null!==l)return l.ruleIndex=t,l;},Y.prototype.lexerActionFactory=function(e,t,n){if(null===this.actionFactories){var l=[];l[D.CHANNEL]=function(e,t){return new q(e);},l[D.CUSTOM]=function(e,t){return new B(e,t);},l[D.MODE]=function(e,t){return new j(e);},l[D.MORE]=function(e,t){return H.INSTANCE;},l[D.POP_MODE]=function(e,t){return V.INSTANCE;},l[D.PUSH_MODE]=function(e,t){return new G(e);},l[D.SKIP]=function(e,t){return F.INSTANCE;},l[D.TYPE]=function(e,t){return new z(e);},this.actionFactories=l;}if(e>this.actionFactories.length||null===this.actionFactories[e])throw"The specified lexer action type "+e+" is not valid.";return this.actionFactories[e](t,n);},t.ATNDeserializer=Y;},function(e,t){function n(e){return void 0===e&&(e=null),this.readOnly=!1,this.verifyATN=null===e||e.verifyATN,this.generateRuleBypassTransitions=null!==e&&e.generateRuleBypassTransitions,this;}n.defaultOptions=new n(),n.defaultOptions.readOnly=!0,t.ATNDeserializationOptions=n;},function(e,t){function n(){}function l(e){return this.actionType=e,this.isPositionDependent=!1,this;}function i(){return l.call(this,n.SKIP),this;}function r(e){return l.call(this,n.TYPE),this.type=e,this;}function s(e){return l.call(this,n.PUSH_MODE),this.mode=e,this;}function a(){return l.call(this,n.POP_MODE),this;}function o(){return l.call(this,n.MORE),this;}function u(e){return l.call(this,n.MODE),this.mode=e,this;}function c(e,t){return l.call(this,n.CUSTOM),this.ruleIndex=e,this.actionIndex=t,this.isPositionDependent=!0,this;}function f(e){return l.call(this,n.CHANNEL),this.channel=e,this;}function m(e,t){return l.call(this,t.actionType),this.offset=e,this.action=t,this.isPositionDependent=!0,this;}n.CHANNEL=0,n.CUSTOM=1,n.MODE=2,n.MORE=3,n.POP_MODE=4,n.PUSH_MODE=5,n.SKIP=6,n.TYPE=7,l.prototype.hashCode=function(){var e=new Hash();return this.updateHashCode(e),e.finish();},l.prototype.updateHashCode=function(e){e.update(this.actionType);},l.prototype.equals=function(e){return this===e;},i.prototype=Object.create(l.prototype),i.prototype.constructor=i,i.INSTANCE=new i(),i.prototype.execute=function(e){e.skip();},i.prototype.toString=function(){return"skip";},r.prototype=Object.create(l.prototype),r.prototype.constructor=r,r.prototype.execute=function(e){e.type=this.type;},r.prototype.updateHashCode=function(e){e.update(this.actionType,this.type);},r.prototype.equals=function(e){return this===e||e instanceof r&&this.type===e.type;},r.prototype.toString=function(){return"type("+this.type+")";},s.prototype=Object.create(l.prototype),s.prototype.constructor=s,s.prototype.execute=function(e){e.pushMode(this.mode);},s.prototype.updateHashCode=function(e){e.update(this.actionType,this.mode);},s.prototype.equals=function(e){return this===e||e instanceof s&&this.mode===e.mode;},s.prototype.toString=function(){return"pushMode("+this.mode+")";},a.prototype=Object.create(l.prototype),a.prototype.constructor=a,a.INSTANCE=new a(),a.prototype.execute=function(e){e.popMode();},a.prototype.toString=function(){return"popMode";},o.prototype=Object.create(l.prototype),o.prototype.constructor=o,o.INSTANCE=new o(),o.prototype.execute=function(e){e.more();},o.prototype.toString=function(){return"more";},u.prototype=Object.create(l.prototype),u.prototype.constructor=u,u.prototype.execute=function(e){e.mode(this.mode);},u.prototype.updateHashCode=function(e){e.update(this.actionType,this.mode);},u.prototype.equals=function(e){return this===e||e instanceof u&&this.mode===e.mode;},u.prototype.toString=function(){return"mode("+this.mode+")";},c.prototype=Object.create(l.prototype),c.prototype.constructor=c,c.prototype.execute=function(e){e.action(null,this.ruleIndex,this.actionIndex);},c.prototype.updateHashCode=function(e){e.update(this.actionType,this.ruleIndex,this.actionIndex);},c.prototype.equals=function(e){return this===e||e instanceof c&&this.ruleIndex===e.ruleIndex&&this.actionIndex===e.actionIndex;},f.prototype=Object.create(l.prototype),f.prototype.constructor=f,f.prototype.execute=function(e){e._channel=this.channel;},f.prototype.updateHashCode=function(e){e.update(this.actionType,this.channel);},f.prototype.equals=function(e){return this===e||e instanceof f&&this.channel===e.channel;},f.prototype.toString=function(){return"channel("+this.channel+")";},m.prototype=Object.create(l.prototype),m.prototype.constructor=m,m.prototype.execute=function(e){this.action.execute(e);},m.prototype.updateHashCode=function(e){e.update(this.actionType,this.offset,this.action);},m.prototype.equals=function(e){return this===e||e instanceof m&&this.offset===e.offset&&this.action===e.action;},t.LexerActionType=n,t.LexerSkipAction=i,t.LexerChannelAction=f,t.LexerCustomAction=c,t.LexerIndexedCustomAction=m,t.LexerMoreAction=o,t.LexerTypeAction=r,t.LexerPushModeAction=s,t.LexerPopModeAction=a,t.LexerModeAction=u;},function(e,t,n){var l=n(1).Token,i=n(20).ConsoleErrorListener,r=n(20).ProxyErrorListener;function s(){return this._listeners=[i.INSTANCE],this._interp=null,this._stateNumber=-1,this;}s.tokenTypeMapCache={},s.ruleIndexMapCache={},s.prototype.checkVersion=function(e){"4.8"!==e&&console.log("ANTLR runtime and generated code versions disagree: 4.8!="+e);},s.prototype.addErrorListener=function(e){this._listeners.push(e);},s.prototype.removeErrorListeners=function(){this._listeners=[];},s.prototype.getTokenTypeMap=function(){var e=this.getTokenNames();if(null===e)throw"The current recognizer does not provide a list of token names.";var t=this.tokenTypeMapCache[e];return void 0===t&&((t=e.reduce(function(e,t,n){e[t]=n;})).EOF=l.EOF,this.tokenTypeMapCache[e]=t),t;},s.prototype.getRuleIndexMap=function(){var e=this.ruleNames;if(null===e)throw"The current recognizer does not provide a list of rule names.";var t=this.ruleIndexMapCache[e];return void 0===t&&(t=e.reduce(function(e,t,n){e[t]=n;}),this.ruleIndexMapCache[e]=t),t;},s.prototype.getTokenType=function(e){var t=this.getTokenTypeMap()[e];return void 0!==t?t:l.INVALID_TYPE;},s.prototype.getErrorHeader=function(e){return"line "+e.getOffendingToken().line+":"+e.getOffendingToken().column;},s.prototype.getTokenErrorDisplay=function(e){if(null===e)return"<no token>";var t=e.text;return null===t&&(t=e.type===l.EOF?"<EOF>":"<"+e.type+">"),"'"+(t=t.replace("\n","\\n").replace("\r","\\r").replace("\t","\\t"))+"'";},s.prototype.getErrorListenerDispatch=function(){return new r(this._listeners);},s.prototype.sempred=function(e,t,n){return!0;},s.prototype.precpred=function(e,t){return!0;},Object.defineProperty(s.prototype,"state",{get:function get(){return this._stateNumber;},set:function set(e){this._stateNumber=e;}}),t.Recognizer=s;},function(e,t,n){var l=n(14).DFAState,i=n(11).ATNConfigSet,r=n(6).getCachedPredictionContext,s=n(0).Map;function a(e,t){return this.atn=e,this.sharedContextCache=t,this;}a.ERROR=new l(2147483647,new i()),a.prototype.getCachedContext=function(e){if(null===this.sharedContextCache)return e;var t=new s();return r(e,this.sharedContextCache,t);},t.ATNSimulator=a;},function(e,t,n){n(0).Set;var l=n(0).Map,i=n(0).BitSet,r=n(0).AltDict,s=n(8).ATN,a=n(3).RuleStopState,o=n(11).ATNConfigSet,u=n(17).ATNConfig,c=n(13).SemanticContext,f=(n(0).Hash,n(0).hashStuff);n(0).equalArrays;function m(){return this;}m.SLL=0,m.LL=1,m.LL_EXACT_AMBIG_DETECTION=2,m.hasSLLConflictTerminatingPrediction=function(e,t){if(m.allConfigsInRuleStopStates(t))return!0;if(e===m.SLL&&t.hasSemanticContext){for(var n=new o(),l=0;l<t.items.length;l++){var i=t.items[l];i=new u({semanticContext:c.NONE},i),n.add(i);}t=n;}var r=m.getConflictingAltSubsets(t);return m.hasConflictingAltSet(r)&&!m.hasStateAssociatedWithOneAlt(t);},m.hasConfigInRuleStopState=function(e){for(var t=0;t<e.items.length;t++){if(e.items[t].state instanceof a)return!0;}return!1;},m.allConfigsInRuleStopStates=function(e){for(var t=0;t<e.items.length;t++){if(!(e.items[t].state instanceof a))return!1;}return!0;},m.resolvesToJustOneViableAlt=function(e){return m.getSingleViableAlt(e);},m.allSubsetsConflict=function(e){return!m.hasNonConflictingAltSet(e);},m.hasNonConflictingAltSet=function(e){for(var t=0;t<e.length;t++){if(1===e[t].length)return!0;}return!1;},m.hasConflictingAltSet=function(e){for(var t=0;t<e.length;t++){if(e[t].length>1)return!0;}return!1;},m.allSubsetsEqual=function(e){for(var t=null,n=0;n<e.length;n++){var l=e[n];if(null===t)t=l;else if(l!==t)return!1;}return!0;},m.getUniqueAlt=function(e){var t=m.getAlts(e);return 1===t.length?t.minValue():s.INVALID_ALT_NUMBER;},m.getAlts=function(e){var t=new i();return e.map(function(e){t.or(e);}),t;},m.getConflictingAltSubsets=function(e){var t=new l();return t.hashFunction=function(e){f(e.state.stateNumber,e.context);},t.equalsFunction=function(e,t){return e.state.stateNumber==t.state.stateNumber&&e.context.equals(t.context);},e.items.map(function(e){var n=t.get(e);null===n&&(n=new i(),t.put(e,n)),n.add(e.alt);}),t.getValues();},m.getStateToAltMap=function(e){var t=new r();return e.items.map(function(e){var n=t.get(e.state);null===n&&(n=new i(),t.put(e.state,n)),n.add(e.alt);}),t;},m.hasStateAssociatedWithOneAlt=function(e){for(var t=m.getStateToAltMap(e).values(),n=0;n<t.length;n++){if(1===t[n].length)return!0;}return!1;},m.getSingleViableAlt=function(e){for(var t=null,n=0;n<e.length;n++){var l=e[n].minValue();if(null===t)t=l;else if(t!==l)return s.INVALID_ALT_NUMBER;}return t;},t.PredictionMode=m;},function(e,t){/*! https://mths.be/codepointat v0.2.0 by @mathias */String.prototype.codePointAt||function(){"use strict";var e=function(){try{var e={},t=Object.defineProperty,n=t(e,e,e)&&t;}catch(e){}return n;}(),t=function t(e){if(null==this)throw TypeError();var t=String(this),n=t.length,l=e?Number(e):0;if(l!=l&&(l=0),!(l<0||l>=n)){var i,r=t.charCodeAt(l);return r>=55296&&r<=56319&&n>l+1&&(i=t.charCodeAt(l+1))>=56320&&i<=57343?1024*(r-55296)+i-56320+65536:r;}};e?e(String.prototype,"codePointAt",{value:t,configurable:!0,writable:!0}):String.prototype.codePointAt=t;}();},function(e,t){var n,l,i,r;/*! https://mths.be/fromcodepoint v0.2.1 by @mathias */String.fromCodePoint||(n=function(){try{var e={},t=Object.defineProperty,n=t(e,e,e)&&t;}catch(e){}return n;}(),l=String.fromCharCode,i=Math.floor,r=function r(e){var t,n,r=16384,s=[],a=-1,o=arguments.length;if(!o)return"";for(var u="";++a<o;){var c=Number(arguments[a]);if(!isFinite(c)||c<0||c>1114111||i(c)!=c)throw RangeError("Invalid code point: "+c);c<=65535?s.push(c):(t=55296+((c-=65536)>>10),n=c%1024+56320,s.push(t,n)),(a+1==o||s.length>r)&&(u+=l.apply(null,s),s.length=0);}return u;},n?n(String,"fromCodePoint",{value:r,configurable:!0,writable:!0}):String.fromCodePoint=r);},function(e,t,n){var l=n(1).Token,i=n(5),r=i.NoViableAltException,s=i.InputMismatchException,a=i.FailedPredicateException,o=i.ParseCancellationException,u=n(3).ATNState,c=n(2).Interval,f=n(2).IntervalSet;function m(){}function p(){return m.call(this),this.errorRecoveryMode=!1,this.lastErrorIndex=-1,this.lastErrorStates=null,this;}function h(){return p.call(this),this;}m.prototype.reset=function(e){},m.prototype.recoverInline=function(e){},m.prototype.recover=function(e,t){},m.prototype.sync=function(e){},m.prototype.inErrorRecoveryMode=function(e){},m.prototype.reportError=function(e){},p.prototype=Object.create(m.prototype),p.prototype.constructor=p,p.prototype.reset=function(e){this.endErrorCondition(e);},p.prototype.beginErrorCondition=function(e){this.errorRecoveryMode=!0;},p.prototype.inErrorRecoveryMode=function(e){return this.errorRecoveryMode;},p.prototype.endErrorCondition=function(e){this.errorRecoveryMode=!1,this.lastErrorStates=null,this.lastErrorIndex=-1;},p.prototype.reportMatch=function(e){this.endErrorCondition(e);},p.prototype.reportError=function(e,t){this.inErrorRecoveryMode(e)||(this.beginErrorCondition(e),t instanceof r?this.reportNoViableAlternative(e,t):t instanceof s?this.reportInputMismatch(e,t):t instanceof a?this.reportFailedPredicate(e,t):(console.log("unknown recognition error type: "+t.constructor.name),console.log(t.stack),e.notifyErrorListeners(t.getOffendingToken(),t.getMessage(),t)));},p.prototype.recover=function(e,t){this.lastErrorIndex===e.getInputStream().index&&null!==this.lastErrorStates&&this.lastErrorStates.indexOf(e.state)>=0&&e.consume(),this.lastErrorIndex=e._input.index,null===this.lastErrorStates&&(this.lastErrorStates=[]),this.lastErrorStates.push(e.state);var n=this.getErrorRecoverySet(e);this.consumeUntil(e,n);},p.prototype.sync=function(e){if(!this.inErrorRecoveryMode(e)){var t=e._interp.atn.states[e.state],n=e.getTokenStream().LA(1),i=e.atn.nextTokens(t);if(!i.contains(l.EPSILON)&&!i.contains(n))switch(t.stateType){case u.BLOCK_START:case u.STAR_BLOCK_START:case u.PLUS_BLOCK_START:case u.STAR_LOOP_ENTRY:if(null!==this.singleTokenDeletion(e))return;throw new s(e);case u.PLUS_LOOP_BACK:case u.STAR_LOOP_BACK:this.reportUnwantedToken(e);var r=new f();r.addSet(e.getExpectedTokens());var a=r.addSet(this.getErrorRecoverySet(e));this.consumeUntil(e,a);}}},p.prototype.reportNoViableAlternative=function(e,t){var n,i=e.getTokenStream();n=null!==i?t.startToken.type===l.EOF?"<EOF>":i.getText(new c(t.startToken.tokenIndex,t.offendingToken.tokenIndex)):"<unknown input>";var r="no viable alternative at input "+this.escapeWSAndQuote(n);e.notifyErrorListeners(r,t.offendingToken,t);},p.prototype.reportInputMismatch=function(e,t){var n="mismatched input "+this.getTokenErrorDisplay(t.offendingToken)+" expecting "+t.getExpectedTokens().toString(e.literalNames,e.symbolicNames);e.notifyErrorListeners(n,t.offendingToken,t);},p.prototype.reportFailedPredicate=function(e,t){var n="rule "+e.ruleNames[e._ctx.ruleIndex]+" "+t.message;e.notifyErrorListeners(n,t.offendingToken,t);},p.prototype.reportUnwantedToken=function(e){if(!this.inErrorRecoveryMode(e)){this.beginErrorCondition(e);var t=e.getCurrentToken(),n="extraneous input "+this.getTokenErrorDisplay(t)+" expecting "+this.getExpectedTokens(e).toString(e.literalNames,e.symbolicNames);e.notifyErrorListeners(n,t,null);}},p.prototype.reportMissingToken=function(e){if(!this.inErrorRecoveryMode(e)){this.beginErrorCondition(e);var t=e.getCurrentToken(),n="missing "+this.getExpectedTokens(e).toString(e.literalNames,e.symbolicNames)+" at "+this.getTokenErrorDisplay(t);e.notifyErrorListeners(n,t,null);}},p.prototype.recoverInline=function(e){var t=this.singleTokenDeletion(e);if(null!==t)return e.consume(),t;if(this.singleTokenInsertion(e))return this.getMissingSymbol(e);throw new s(e);},p.prototype.singleTokenInsertion=function(e){var t=e.getTokenStream().LA(1),n=e._interp.atn,l=n.states[e.state].transitions[0].target;return!!n.nextTokens(l,e._ctx).contains(t)&&(this.reportMissingToken(e),!0);},p.prototype.singleTokenDeletion=function(e){var t=e.getTokenStream().LA(2);if(this.getExpectedTokens(e).contains(t)){this.reportUnwantedToken(e),e.consume();var n=e.getCurrentToken();return this.reportMatch(e),n;}return null;},p.prototype.getMissingSymbol=function(e){var t,n=e.getCurrentToken(),i=this.getExpectedTokens(e).first();t=i===l.EOF?"<missing EOF>":"<missing "+e.literalNames[i]+">";var r=n,s=e.getTokenStream().LT(-1);return r.type===l.EOF&&null!==s&&(r=s),e.getTokenFactory().create(r.source,i,t,l.DEFAULT_CHANNEL,-1,-1,r.line,r.column);},p.prototype.getExpectedTokens=function(e){return e.getExpectedTokens();},p.prototype.getTokenErrorDisplay=function(e){if(null===e)return"<no token>";var t=e.text;return null===t&&(t=e.type===l.EOF?"<EOF>":"<"+e.type+">"),this.escapeWSAndQuote(t);},p.prototype.escapeWSAndQuote=function(e){return"'"+(e=(e=(e=e.replace(/\n/g,"\\n")).replace(/\r/g,"\\r")).replace(/\t/g,"\\t"))+"'";},p.prototype.getErrorRecoverySet=function(e){for(var t=e._interp.atn,n=e._ctx,i=new f();null!==n&&n.invokingState>=0;){var r=t.states[n.invokingState].transitions[0],s=t.nextTokens(r.followState);i.addSet(s),n=n.parentCtx;}return i.removeOne(l.EPSILON),i;},p.prototype.consumeUntil=function(e,t){for(var n=e.getTokenStream().LA(1);n!==l.EOF&&!t.contains(n);){e.consume(),n=e.getTokenStream().LA(1);}},h.prototype=Object.create(p.prototype),h.prototype.constructor=h,h.prototype.recover=function(e,t){for(var n=e._ctx;null!==n;){n.exception=t,n=n.parentCtx;}throw new o(t);},h.prototype.recoverInline=function(e){this.recover(e,new s(e));},h.prototype.sync=function(e){},t.BailErrorStrategy=h,t.DefaultErrorStrategy=p;},function(e,t,n){var l=n(16);function i(){return l.tree.ParseTreeListener.call(this),this;}i.prototype=Object.create(l.tree.ParseTreeListener.prototype),i.prototype.constructor=i,i.prototype.enterIndexerExpression=function(e){},i.prototype.exitIndexerExpression=function(e){},i.prototype.enterPolarityExpression=function(e){},i.prototype.exitPolarityExpression=function(e){},i.prototype.enterAdditiveExpression=function(e){},i.prototype.exitAdditiveExpression=function(e){},i.prototype.enterMultiplicativeExpression=function(e){},i.prototype.exitMultiplicativeExpression=function(e){},i.prototype.enterUnionExpression=function(e){},i.prototype.exitUnionExpression=function(e){},i.prototype.enterOrExpression=function(e){},i.prototype.exitOrExpression=function(e){},i.prototype.enterAndExpression=function(e){},i.prototype.exitAndExpression=function(e){},i.prototype.enterMembershipExpression=function(e){},i.prototype.exitMembershipExpression=function(e){},i.prototype.enterInequalityExpression=function(e){},i.prototype.exitInequalityExpression=function(e){},i.prototype.enterInvocationExpression=function(e){},i.prototype.exitInvocationExpression=function(e){},i.prototype.enterEqualityExpression=function(e){},i.prototype.exitEqualityExpression=function(e){},i.prototype.enterImpliesExpression=function(e){},i.prototype.exitImpliesExpression=function(e){},i.prototype.enterTermExpression=function(e){},i.prototype.exitTermExpression=function(e){},i.prototype.enterTypeExpression=function(e){},i.prototype.exitTypeExpression=function(e){},i.prototype.enterInvocationTerm=function(e){},i.prototype.exitInvocationTerm=function(e){},i.prototype.enterLiteralTerm=function(e){},i.prototype.exitLiteralTerm=function(e){},i.prototype.enterExternalConstantTerm=function(e){},i.prototype.exitExternalConstantTerm=function(e){},i.prototype.enterParenthesizedTerm=function(e){},i.prototype.exitParenthesizedTerm=function(e){},i.prototype.enterNullLiteral=function(e){},i.prototype.exitNullLiteral=function(e){},i.prototype.enterBooleanLiteral=function(e){},i.prototype.exitBooleanLiteral=function(e){},i.prototype.enterStringLiteral=function(e){},i.prototype.exitStringLiteral=function(e){},i.prototype.enterNumberLiteral=function(e){},i.prototype.exitNumberLiteral=function(e){},i.prototype.enterDateTimeLiteral=function(e){},i.prototype.exitDateTimeLiteral=function(e){},i.prototype.enterTimeLiteral=function(e){},i.prototype.exitTimeLiteral=function(e){},i.prototype.enterQuantityLiteral=function(e){},i.prototype.exitQuantityLiteral=function(e){},i.prototype.enterExternalConstant=function(e){},i.prototype.exitExternalConstant=function(e){},i.prototype.enterMemberInvocation=function(e){},i.prototype.exitMemberInvocation=function(e){},i.prototype.enterFunctionInvocation=function(e){},i.prototype.exitFunctionInvocation=function(e){},i.prototype.enterThisInvocation=function(e){},i.prototype.exitThisInvocation=function(e){},i.prototype.enterIndexInvocation=function(e){},i.prototype.exitIndexInvocation=function(e){},i.prototype.enterTotalInvocation=function(e){},i.prototype.exitTotalInvocation=function(e){},i.prototype.enterFunctn=function(e){},i.prototype.exitFunctn=function(e){},i.prototype.enterParamList=function(e){},i.prototype.exitParamList=function(e){},i.prototype.enterQuantity=function(e){},i.prototype.exitQuantity=function(e){},i.prototype.enterUnit=function(e){},i.prototype.exitUnit=function(e){},i.prototype.enterDateTimePrecision=function(e){},i.prototype.exitDateTimePrecision=function(e){},i.prototype.enterPluralDateTimePrecision=function(e){},i.prototype.exitPluralDateTimePrecision=function(e){},i.prototype.enterTypeSpecifier=function(e){},i.prototype.exitTypeSpecifier=function(e){},i.prototype.enterQualifiedIdentifier=function(e){},i.prototype.exitQualifiedIdentifier=function(e){},i.prototype.enterIdentifier=function(e){},i.prototype.exitIdentifier=function(e){},t.FHIRPathListener=i;},function(e,t,n){var l=n(22);e.exports=function(e,t){var n=Number(t);return l(e,6e4*n);};},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0}),t.UnitTables=t.UcumLhcUtils=t.Ucum=void 0;var l=n(12).Ucum;t.Ucum=l;var i=n(71).UcumLhcUtils;t.UcumLhcUtils=i;var r=n(15).UnitTables;t.UnitTables=r;},function(e,t,n){"use strict";function l(e,t){for(var n=0;n<t.length;n++){var l=t[n];l.enumerable=l.enumerable||!1,l.configurable=!0,"value"in l&&(l.writable=!0),Object.defineProperty(e,l.key,l);}}Object.defineProperty(t,"__esModule",{value:!0}),t.PrefixTables=t.PrefixTablesFactory=void 0;var i=function(){function e(){!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function");}(this,e),this.byCode_={},this.byValue_={};}var t,n,i;return t=e,(n=[{key:"prefixCount",value:function value(){return Object.keys(this.byCode_).length;}},{key:"allPrefixesByValue",value:function value(){for(var e="",t=Object.keys(this.byValue_),n=t.length,l=0;l<n;l++){var i=this.getPrefixByValue(t[l]);e+=i.code_+","+i.name_+",,"+i.value_+"\r\n";}return e;}},{key:"allPrefixesByCode",value:function value(){var e=[],t=Object.keys(this.byCode_);t.sort();for(var n=t.length,l=0;l<n;l++){e.push(this.getPrefixByCode(t[l]));}return e;}},{key:"add",value:function value(e){this.byCode_[e.getCode()]=e,this.byValue_[e.getValue()]=e;}},{key:"isDefined",value:function value(e){return null!==this.byCode_[e]&&void 0!==this.byCode_[e];}},{key:"getPrefixByCode",value:function value(e){return this.byCode_[e];}},{key:"getPrefixByValue",value:function value(e){return this.byValue_[e];}}])&&l(t.prototype,n),i&&l(t,i),e;}();t.PrefixTablesFactory=i;var r=new i(),s={getInstance:function getInstance(){return r;}};t.PrefixTables=s;},function(e,t,n){"use strict";function l(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function");}function i(e,t){for(var n=0;n<t.length;n++){var l=t[n];l.enumerable=l.enumerable||!1,l.configurable=!0,"value"in l&&(l.writable=!0),Object.defineProperty(e,l.key,l);}}function r(e){return(r="function"==typeof Symbol&&"symbol"==_typeof(Symbol.iterator)?function(e){return _typeof(e);}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":_typeof(e);})(e);}Object.defineProperty(t,"__esModule",{value:!0}),t.Unit=void 0;var s,a=(s=n(74))&&s.__esModule?s:{default:s},o=function(e){if(e&&e.__esModule)return e;if(null===e||"object"!==r(e)&&"function"!=typeof e)return{default:e};var t=u();if(t&&t.has(e))return t.get(e);var n={},l=Object.defineProperty&&Object.getOwnPropertyDescriptor;for(var i in e){if(Object.prototype.hasOwnProperty.call(e,i)){var s=l?Object.getOwnPropertyDescriptor(e,i):null;s&&(s.get||s.set)?Object.defineProperty(n,i,s):n[i]=e[i];}}n.default=e,t&&t.set(e,n);return n;}(n(25));function u(){if("function"!=typeof WeakMap)return null;var e=new WeakMap();return u=function u(){return e;},e;}var c,f=n(12).Ucum,m=n(75).Dimension,p=n(41),h=function(){function e(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};l(this,e),this.isBase_=t.isBase_||!1,this.name_=t.name_||"",this.csCode_=t.csCode_||"",this.ciCode_=t.ciCode_||"",this.property_=t.property_||"",this.magnitude_=t.magnitude_||1,void 0===t.dim_||null===t.dim_?this.dim_=new m():void 0!==t.dim_.dimVec_?this.dim_=new m(t.dim_.dimVec_):t.dim_ instanceof m?this.dim_=t.dim_:t.dim_ instanceof Array||p(t.dim_)?this.dim_=new m(t.dim_):this.dim_=new m(),this.printSymbol_=t.printSymbol_||null,this.class_=t.class_||null,this.isMetric_=t.isMetric_||!1,this.variable_=t.variable_||null,this.cnv_=t.cnv_||null,this.cnvPfx_=t.cnvPfx_||1,this.isSpecial_=t.isSpecial_||!1,this.isArbitrary_=t.isArbitrary_||!1,this.moleExp_=t.moleExp_||0,this.synonyms_=t.synonyms_||null,this.source_=t.source_||null,this.loincProperty_=t.loincProperty_||null,this.category_=t.category_||null,this.guidance_=t.guidance_||null,this.csUnitString_=t.csUnitString_||null,this.ciUnitString_=t.ciUnitString_||null,this.baseFactorStr_=t.baseFactorStr_||null,this.baseFactor_=t.baseFactor_||null,this.defError_=t.defError_||!1;}var t,r,s;return t=e,(r=[{key:"assignUnity",value:function value(){return this.name_="",this.magnitude_=1,this.dim_||(this.dim_=new m()),this.dim_.assignZero(),this.cnv_=null,this.cnvPfx_=1,this;}},{key:"assignVals",value:function value(e){for(var t in e){var n="_"===!t.charAt(t.length-1)?t+"_":t;if(!this.hasOwnProperty(n))throw new Error("Parameter error; ".concat(t," is not a property of a Unit"));this[n]=e[t];}}},{key:"clone",value:function value(){var t=this,n=new e();return Object.getOwnPropertyNames(this).forEach(function(e){"dim_"===e?t.dim_?n.dim_=t.dim_.clone():n.dim_=null:n[e]=t[e];}),n;}},{key:"assign",value:function value(e){var t=this;Object.getOwnPropertyNames(e).forEach(function(n){"dim_"===n?e.dim_?t.dim_=e.dim_.clone():t.dim_=null:t[n]=e[n];});}},{key:"equals",value:function value(e){return this.magnitude_===e.magnitude_&&this.cnv_===e.cnv_&&this.cnvPfx_===e.cnvPfx_&&(null===this.dim_&&null===e.dim_||this.dim_.equals(e.dim_));}},{key:"fullEquals",value:function value(e){for(var t=Object.keys(this).sort(),n=Object.keys(e).sort(),l=t.length,i=l===n.length,r=0;r<l&&i;r++){i=t[r]===n[r]&&("dim_"===t[r]?this.dim_.equals(e.dim_):this[t[r]]===e[t[r]]);}return i;}},{key:"getProperty",value:function value(e){return this["_"===e.charAt(e.length-1)?e:e+"_"];}},{key:"convertFrom",value:function value(e,t){var n=0;if(this.isArbitrary_)throw new Error("Attempt to convert arbitrary unit ".concat(this.name_));if(t.isArbitrary_)throw new Error("Attempt to convert to arbitrary unit ".concat(t.name_));if(t.dim_&&this.dim_&&!t.dim_.equals(this.dim_))throw this.isMoleMassCommensurable(t)?new Error(f.needMoleWeightMsg_):new Error("Sorry.  ".concat(t.csCode_," cannot be converted ")+"to ".concat(this.csCode_,"."));if(t.dim_&&(!this.dim_||this.dim_.isNull()))throw new Error("Sorry.  ".concat(t.csCode_," cannot be converted ")+"to ".concat(this.csCode_,"."));if(this.dim_&&(!t.dim_||t.dim_.isNull()))throw new Error("Sorry.  ".concat(t.csCode_," cannot be converted ")+"to ".concat(this.csCode_,"."));var l=t.cnv_,i=t.magnitude_;if(l===this.cnv_)n=e*i/this.magnitude_;else{var r=0;r=null!=l?a.default.forName(l).cnvFrom(e*t.cnvPfx_)*i:e*i,n=null!=this.cnv_?a.default.forName(this.cnv_).cnvTo(r/this.magnitude_)/this.cnvPfx_:r/this.magnitude_;}return n;}},{key:"convertTo",value:function value(e,t){return t.convertFrom(e,this);}},{key:"convertCoherent",value:function value(e){return null!==this.cnv_&&(e=this.cnv_.f_from(e/this.cnvPfx_)*this.magnitude_),e;}},{key:"mutateCoherent",value:function value(e){e=this.convertCoherent(e),this.magnitude_=1,this.cnv_=null,this.cnvPfx_=1,this.name_="";for(var t=0,n=m.getMax();t<n;t++){var l=this.dim_.getElementAt(t),i=this._getUnitTables().getUnitsByDimension(new m(t));if(null==i)throw new Error("Can't find base unit for dimension ".concat(t));this.name_=i.name+l;}return e;}},{key:"convertMassToMol",value:function value(e,t,n){var l=this.magnitude_*e/n,i=this._getUnitTables().getUnitByCode("mol").magnitude_;return l/(t.magnitude_/i);}},{key:"convertMolToMass",value:function value(e,t,n){var l=this._getUnitTables().getUnitByCode("mol").magnitude_;return this.magnitude_/l*e*n/t.magnitude_;}},{key:"mutateRatio",value:function value(e){return null==this.cnv_?this.mutateCoherent(e):e;}},{key:"multiplyThis",value:function value(e){var t=this.clone();null!=t.cnv_?t.cnvPfx_*=e:t.magnitude_*=e;var n=e.toString();return t.name_=this._concatStrs(n,"*",this.name_,"[","]"),t.csCode_=this._concatStrs(n,".",this.csCode_,"(",")"),t.ciCode_=this._concatStrs(n,".",this.ciCode_,"(",")"),t.printSymbol_=this._concatStrs(n,".",this.printSymbol_,"(",")"),t;}},{key:"multiplyThese",value:function value(e){var t=this.clone();if(null!=t.cnv_){if(null!=e.cnv_||e.dim_&&!e.dim_.isZero())throw new Error("Attempt to multiply non-ratio unit ".concat(t.name_," ")+"failed.");t.cnvPfx_*=e.magnitude_;}else if(null!=e.cnv_){if(t.dim_&&!t.dim_.isZero())throw new Error("Attempt to multiply non-ratio unit ".concat(e.name_));t.cnvPfx_=e.cnvPfx_*t.magnitude_,t.cnv_=e.cnv_;}else t.magnitude_*=e.magnitude_;return!t.dim_||t.dim_&&!t.dim_.dimVec_?e.dim_?t.dim_=e.dim_.clone():t.dim_=e.dim_:e.dim_&&e.dim_ instanceof m&&t.dim_.add(e.dim_),t.name_=this._concatStrs(t.name_,"*",e.name_,"[","]"),t.csCode_=this._concatStrs(t.csCode_,".",e.csCode_,"(",")"),t.ciCode_&&e.ciCode_?t.ciCode_=this._concatStrs(t.ciCode_,".",e.ciCode_,"(",")"):e.ciCode_&&(t.ciCode_=e.ciCode_),t.guidance_="",t.printSymbol_&&e.printSymbol_?t.printSymbol_=this._concatStrs(t.printSymbol_,".",e.printSymbol_,"(",")"):e.printSymbol_&&(t.printSymbol_=e.printSymbol_),t.moleExp_=t.moleExp_+e.moleExp_,t.isArbitrary_||(t.isArbitrary_=e.isArbitrary_),t;}},{key:"divide",value:function value(e){var t=this.clone();if(null!=t.cnv_)throw new Error("Attempt to divide non-ratio unit ".concat(t.name_));if(null!=e.cnv_)throw new Error("Attempt to divide by non-ratio unit ".concat(e.name_));return t.name_&&e.name_?t.name_=this._concatStrs(t.name_,"/",e.name_,"[","]"):e.name_&&(t.name_=e.invertString(e.name_)),t.csCode_=this._concatStrs(t.csCode_,"/",e.csCode_,"(",")"),t.ciCode_&&e.ciCode_?t.ciCode_=this._concatStrs(t.ciCode_,"/",e.ciCode_,"(",")"):e.ciCode_&&(t.ciCode_=e.invertString(e.ciCode_)),t.guidance_="",t.magnitude_/=e.magnitude_,t.printSymbol_&&e.printSymbol_?t.printSymbol_=this._concatStrs(t.printSymbol_,"/",e.printSymbol_,"(",")"):e.printSymbol_&&(t.printSymbol_=e.invertString(e.printSymbol_)),e.dim_&&(t.dim_?(t.dim_.isNull()&&t.dim_.assignZero(),t.dim_=t.dim_.sub(e.dim_)):t.dim_=e.dim_.clone().minus()),t.moleExp_=t.moleExp_-e.moleExp_,t.isArbitrary_||(t.isArbitrary_=e.isArbitrary_),t;}},{key:"invert",value:function value(){if(null!=this.cnv_)throw new Error("Attempt to invert a non-ratio unit - ".concat(this.name_));return this.name_=this.invertString(this.name_),this.magnitude_=1/this.magnitude_,this.dim_.minus(),this;}},{key:"invertString",value:function value(e){if(e.length>0){var t=e.replace("/","!").replace(".","/").replace("!",".");switch(t.charAt(0)){case".":e=t.substr(1);break;case"/":e=t;break;default:e="/"+t;}}return e;}},{key:"_concatStrs",value:function value(e,t,n,l,i){return this._buildOneString(e,l,i)+t+this._buildOneString(n,l,i);}},{key:"_buildOneString",value:function value(e,t,n){return o.isNumericString(e)||"("===e.charAt(0)||"["===e.charAt(0)?e:/[./* ]/.test(e)?t+e+n:e;}},{key:"power",value:function value(e){if(null!=this.cnv_)throw new Error("Attempt to raise a non-ratio unit, ".concat(this.name_,", ")+"to a power.");for(var t=this.csCode_.match(/([./]|[^./]+)/g),n=t.length,l=0;l<n;l++){var i=t[l];if("/"!==i&&"."!==i){var r=parseInt(i);if(p(r))t[l]=Math.pow(r,e).toString();else for(var s=i.length,a=s-1;a>=0;a--){var o=parseInt(i[a]);if(!p(o)){if("-"!==i[a]&&"+"!==i[a]||a--,a<s-1){var u=parseInt(i.substr(a));u=Math.pow(u,e),t[l]=i.substr(0,a)+u.toString(),a=-1;}else t[l]+=e.toString(),a=-1;a=-1;}}}}return this.csCode_=t.join(""),this.magnitude_=Math.pow(this.magnitude_,e),this.dim_&&this.dim_.mul(e),this;}},{key:"isMoleMassCommensurable",value:function value(e){var t=this._getUnitTables().getMassDimensionIndex(),n=!1;if(1===this.moleExp_&&0===e.moleExp_){var l=this.dim_.clone(),i=l.getElementAt(t);l.setElementAt(t,i+this.moleExp_),n=l.equals(e.dim_);}else if(1===e.moleExp_&&0===this.moleExp_){var r=e.dim_.clone(),s=r.getElementAt(t);r.setElementAt(t,s+e.moleExp_),n=r.equals(this.dim_);}return n;}},{key:"_getUnitTables",value:function value(){return c||(c=n(15).UnitTables),c.getInstance();}}])&&i(t.prototype,r),s&&i(t,s),e;}();t.Unit=h;},function(e,t,n){var l=n(76);e.exports=Number.isInteger||function(e){return"number"==typeof e&&l(e)&&Math.floor(e)===e;};},function(e,t){var n={};function l(e){var t=/(\d+)(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/.exec(""+ +e);if(!t)return 0;var n=t[2],l=t[3];return Math.max(0,("0"===n?0:(n||"").length)-(l||0));}function i(e,t){var n=Math.pow(10,t);return Math.round(e*n)/n;}function r(e){return 1e-8*Math.round(e/1e-8);}n.isEquivalent=function(e,t){if(Number.isInteger(e)&&Number.isInteger(t))return e===t;var n=Math.min(l(e),l(t));return 0===n?Math.round(e)===Math.round(t):i(e,n)===i(t,n);},n.isEqual=function(e,t){return r(e)===r(t);},e.exports=n;},function(e,t,n){var l=n(23),i=n(81);e.exports=function(e,t){var n=l(e),r=Number(t),s=n.getMonth()+r,a=new Date(0);a.setFullYear(n.getFullYear(),s,1),a.setHours(0,0,0,0);var o=i(a);return n.setMonth(s,Math.min(o,n.getDate())),n;};},function(e,t,n){var l=n(23);e.exports=function(e,t){var n=l(e),i=Number(t);return n.setDate(n.getDate()+i),n;};},function(e,t){e.exports={reset:function reset(){this.nowDate=new Date(),this.today=null,this.now=null,this.localTimezoneOffset=null;},today:null,now:null};},function(e,t,n){function l(e){return(l="function"==typeof Symbol&&"symbol"==_typeof(Symbol.iterator)?function(e){return _typeof(e);}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":_typeof(e);})(e);}var i=n(7),r=n(47),s={};function a(e){return JSON.stringify(o(e));}function o(e){return"object"===l(e)?Array.isArray(e)?e.map(o):Object.keys(e).sort().reduce(function(t,n){var l=e[n];return t[n]=o(l),t;},{}):e;}function u(e,t){var n=e.length<=t.length;if(n)for(var l={},r=0,s=e.length;r<s&&n;++r){var o=a(i.valData(e[r])),u=!1;if(0===r)for(var c=0,f=t.length;c<f;++c){var m=i.valData(t[c]),p=a(m);l[p]=m,u=u||o===p;}else u=!!l[o];n=u;}return n;}s.emptyFn=i.isEmpty,s.notFn=function(e){var t;return 1===e.length&&"boolean"==typeof(t=i.valData(e[0]))?!t:[];},s.existsMacro=function(e,t){var n=e;return t?s.existsMacro(r.whereMacro(e,t)):!i.isEmpty(n);},s.allMacro=function(e,t){for(var n=0,l=e.length;n<l;++n){if(!i.isTrue(t(e[n])))return[!1];}return[!0];},s.allTrueFn=function(e){for(var t=!0,n=0,l=e.length;n<l&&t;++n){t=!0===i.assertType(e[n],["boolean"],"allTrue");}return[t];},s.anyTrueFn=function(e){for(var t=!1,n=0,l=e.length;n<l&&!t;++n){t=!0===i.assertType(e[n],["boolean"],"anyTrue");}return[t];},s.allFalseFn=function(e){for(var t=!0,n=0,l=e.length;n<l&&t;++n){t=!1===i.assertType(e[n],["boolean"],"allFalse");}return[t];},s.anyFalseFn=function(e){for(var t=!1,n=0,l=e.length;n<l&&!t;++n){t=!1===i.assertType(e[n],["boolean"],"anyFalse");}return[t];},s.subsetOfFn=function(e,t){return[u(e,t)];},s.supersetOfFn=function(e,t){return[u(t,e)];},s.isDistinctFn=function(e){return[e.length===s.distinctFn(e).length];},s.distinctFn=function(e){var t=[];if(e.length>0)for(var n={},l=0,i=e.length;l<i;++l){var r=e[l],s=JSON.stringify(r);void 0===n[s]&&(t.push(r),n[s]=r);}return t;},s.countFn=function(e){return e&&e.length?e.length:0;},e.exports=s;},function(e,t,n){function l(e){return(l="function"==typeof Symbol&&"symbol"==_typeof(Symbol.iterator)?function(e){return _typeof(e);}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":_typeof(e);})(e);}var i=n(7),r={};r.whereMacro=function(e,t){return!1===e||e?i.flatten(e.filter(function(e){return t(e)[0];})):[];},r.selectMacro=function(e,t){return!1===e||e?i.flatten(e.map(function(e){return t(e);})):[];},r.repeatMacro=function(e,t){if(!1!==e&&!e)return[];for(var n=[],l=e,i=null;0!=l.length;){(i=t(l.shift()))&&(n=n.concat(i),l=l.concat(i));}return n;},r.singleFn=function(e){return 1==e.length?e:0==e.length?[]:{$status:"error",$error:"Expected single"};},r.firstFn=function(e){return e[0];},r.lastFn=function(e){return e[e.length-1];},r.tailFn=function(e){return e.slice(1,e.length);},r.takeFn=function(e,t){return e.slice(0,t);},r.skipFn=function(e,t){return e.slice(t,e.length);},r.ofTypeFn=function(e,t){return e.filter(function(e){return function(e,t){return l(e)===t||("integer"===t?Number.isInteger(e):"decimal"===t&&"number"==typeof e);}(i.valData(e),t);});},e.exports=r;},function(e,t,n){function l(e){return(l="function"==typeof Symbol&&"symbol"==_typeof(Symbol.iterator)?function(e){return _typeof(e);}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":_typeof(e);})(e);}var i=n(10).FP_Type,r=n(7),s=n(42),a=Array.prototype.slice,o=Object.keys,u=function u(e){return"[object Arguments]"==Object.prototype.toString.call(e);};function c(e){return"string"==typeof e||e instanceof String;}function f(e){return!isNaN(parseFloat(e))&&isFinite(e);}function m(e){return e.toUpperCase().replace(/\s+/," ");}var p=function p(e,t,n){if(n||(n={}),(e=r.valData(e))===(t=r.valData(t)))return!0;if(n.fuzzy){if(c(e)&&c(t))return m(e)==m(t);if(f(e)&&f(t))return s.isEquivalent(e,t);}else if("number"==typeof e&&"number"==typeof t)return s.isEqual(e,t);if(e instanceof Date&&t instanceof Date)return e.getTime()===t.getTime();if(!e||!t||"object"!=l(e)&&"object"!=l(t))return n.strict?e===t:e==t;var a=e instanceof i,o=t instanceof i;if(a&&o)return n.fuzzy?e.equivalentTo(t):e.equals(t);if(a||o){var u,p;a?(u=e,p=t):(u=t,p=e);var h="string"==typeof p;if(h){var g=u.constructor.checkString(p);h=!!g&&(n.fuzzy?e.equivalentTo(g):u.equals(g));}return h;}return d(e,t,n);};function h(e){return null==e;}function d(e,t,n){var i,r;if(h(e)||h(t))return!1;if(e.prototype!==t.prototype)return!1;if(u(e)||u(t))return e=u(e)?a.call(e):e,t=u(t)?a.call(t):t,p(e,t,n);try{var s=o(e),c=o(t);}catch(e){return!1;}if(s.length!=c.length)return!1;for(s.sort(),c.sort(),i=s.length-1;i>=0;i--){if(s[i]!=c[i])return!1;}if(1===s.length)return r=s[0],p(e[r],t[r],n);for(i=s.length-1;i>=0;i--){if(r=s[i],!p(e[r],t[r],n))return!1;}return l(e)===l(t);}e.exports=p;},function(e,t,n){function l(e){return(l="function"==typeof Symbol&&"symbol"==_typeof(Symbol.iterator)?function(e){return _typeof(e);}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":_typeof(e);})(e);}function i(e){if("undefined"==typeof Symbol||null==e[Symbol.iterator]){if(Array.isArray(e)||(e=function(e,t){if(!e)return;if("string"==typeof e)return r(e,t);var n=Object.prototype.toString.call(e).slice(8,-1);"Object"===n&&e.constructor&&(n=e.constructor.name);if("Map"===n||"Set"===n)return Array.from(n);if("Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))return r(e,t);}(e))){var t=0,n=function n(){};return{s:n,n:function n(){return t>=e.length?{done:!0}:{done:!1,value:e[t++]};},e:function e(_e){throw _e;},f:n};}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");}var l,i,s=!0,a=!1;return{s:function s(){l=e[Symbol.iterator]();},n:function n(){var e=l.next();return s=e.done,e;},e:function e(_e2){a=!0,i=_e2;},f:function f(){try{s||null==l.return||l.return();}finally{if(a)throw i;}}};}function r(e,t){(null==t||t>e.length)&&(t=e.length);for(var n=0,l=new Array(t);n<t;n++){l[n]=e[n];}return l;}var s=n(50),a=n(7);n(85);var o=n(45),u={},c=n(46),f=n(47),m=n(86),p=n(87),h=n(88),d=n(89),g=n(90),y=n(91),C=n(92),_=n(93),v=n(94),L=n(10),b=L.FP_DateTime,U=L.FP_Time,T=L.FP_Quantity,M=L.FP_Type,x=L.ResourceNode.makeResNode;u.invocationTable={empty:{fn:c.emptyFn},not:{fn:c.notFn},exists:{fn:c.existsMacro,arity:{0:[],1:["Expr"]}},all:{fn:c.allMacro,arity:{1:["Expr"]}},allTrue:{fn:c.allTrueFn},anyTrue:{fn:c.anyTrueFn},allFalse:{fn:c.allFalseFn},anyFalse:{fn:c.anyFalseFn},subsetOf:{fn:c.subsetOfFn,arity:{1:["AnyAtRoot"]}},supersetOf:{fn:c.supersetOfFn,arity:{1:["AnyAtRoot"]}},isDistinct:{fn:c.isDistinctFn},distinct:{fn:c.distinctFn},count:{fn:c.countFn},where:{fn:f.whereMacro,arity:{1:["Expr"]}},select:{fn:f.selectMacro,arity:{1:["Expr"]}},single:{fn:f.singleFn},first:{fn:f.firstFn},last:{fn:f.lastFn},ofType:{fn:f.ofTypeFn,arity:{1:["Identifier"]}},tail:{fn:f.tailFn},take:{fn:f.takeFn,arity:{1:["Integer"]}},skip:{fn:f.skipFn,arity:{1:["Integer"]}},combine:{fn:m.combineFn,arity:{1:["AnyAtRoot"]}},iif:{fn:p.iifMacro,arity:{3:["Expr","Expr","Expr"]}},trace:{fn:p.traceFn,arity:{0:[],1:["String"]}},toInteger:{fn:p.toInteger},toDecimal:{fn:p.toDecimal},toString:{fn:p.toString},toDateTime:{fn:p.toDateTime},toTime:{fn:p.toTime},toQuantity:{fn:p.toQuantity,arity:{0:[],1:["String"]}},indexOf:{fn:y.indexOf,arity:{1:["String"]}},substring:{fn:y.substring,arity:{1:["Integer"],2:["Integer","Integer"]}},startsWith:{fn:y.startsWith,arity:{1:["String"]}},endsWith:{fn:y.endsWith,arity:{1:["String"]}},contains:{fn:y.containsFn,arity:{1:["String"]}},replace:{fn:y.replace,arity:{2:["String","String"]}},matches:{fn:y.matches,arity:{1:["String"]}},replaceMatches:{fn:y.replaceMatches,arity:{2:["String","String"]}},length:{fn:y.length},abs:{fn:g.abs},ceiling:{fn:g.ceiling},exp:{fn:g.exp},floor:{fn:g.floor},ln:{fn:g.ln},log:{fn:g.log,arity:{1:["Number"]},nullable:!0},power:{fn:g.power,arity:{1:["Number"]},nullable:!0},round:{fn:g.round,arity:{1:["Number"]}},sqrt:{fn:g.sqrt},truncate:{fn:g.truncate},now:{fn:_.now},today:{fn:_.today},repeat:{fn:f.repeatMacro,arity:{1:["Expr"]}},children:{fn:C.children},descendants:{fn:C.descendants},"|":{fn:m.unionOp,arity:{2:["Any","Any"]}},"=":{fn:h.equal,arity:{2:["Any","Any"]},nullable:!0},"!=":{fn:h.unequal,arity:{2:["Any","Any"]},nullable:!0},"~":{fn:h.equival,arity:{2:["Any","Any"]}},"!~":{fn:h.unequival,arity:{2:["Any","Any"]}},"<":{fn:h.lt,arity:{2:["Any","Any"]},nullable:!0},">":{fn:h.gt,arity:{2:["Any","Any"]},nullable:!0},"<=":{fn:h.lte,arity:{2:["Any","Any"]},nullable:!0},">=":{fn:h.gte,arity:{2:["Any","Any"]},nullable:!0},containsOp:{fn:d.contains,arity:{2:["Any","Any"]}},inOp:{fn:d.in,arity:{2:["Any","Any"]}},"&":{fn:g.amp,arity:{2:["String","String"]}},"+":{fn:g.plus,arity:{2:["Any","Any"]},nullable:!0},"-":{fn:g.minus,arity:{2:["Any","Any"]},nullable:!0},"*":{fn:g.mul,arity:{2:["Number","Number"]},nullable:!0},"/":{fn:g.div,arity:{2:["Number","Number"]},nullable:!0},mod:{fn:g.mod,arity:{2:["Number","Number"]},nullable:!0},div:{fn:g.intdiv,arity:{2:["Number","Number"]},nullable:!0},or:{fn:v.orOp,arity:{2:[["Boolean"],["Boolean"]]}},and:{fn:v.andOp,arity:{2:[["Boolean"],["Boolean"]]}},xor:{fn:v.xorOp,arity:{2:[["Boolean"],["Boolean"]]}},implies:{fn:v.impliesOp,arity:{2:[["Boolean"],["Boolean"]]}}},u.InvocationExpression=function(e,t,n){return n.children.reduce(function(t,n){return u.doEval(e,t,n);},t);},u.TermExpression=function(e,t,n){return u.doEval(e,t,n.children[0]);},u.PolarityExpression=function(e,t,n){var l=n.terminalNodeText[0],i=u.doEval(e,t,n.children[0]);if(1!=i.length)throw new Error("Unary "+l+" can only be applied to an individual number.");if("number"!=typeof i[0]||isNaN(i[0]))throw new Error("Unary "+l+" can only be applied to a number.");return"-"===l&&(i[0]=-i[0]),i;},u.ExternalConstantTerm=function(e,t,n){var l=n.children[0].children[0],i=u.Identifier(e,t,l)[0],r=e.vars[i];return void 0===r?[]:r instanceof Array?r:[r];},u.LiteralTerm=function(e,t,n){var l=n.children[0];return l?u.doEval(e,t,l):[n.text];},u.StringLiteral=function(e,t,n){var l=n.text.replace(/(^'|'$)/g,"");return[l=l.replace(/\\(u\d{4}|.)/g,function(e,t){switch(e){case"\\r":return"\r";case"\\n":return"\n";case"\\t":return"\t";case"\\f":return"\f";default:return t.length>1?String.fromCharCode("0x"+t.slice(1)):t;}})];},u.BooleanLiteral=function(e,t,n){return"true"===n.text?[!0]:[!1];},u.QuantityLiteral=function(e,t,n){var l=n.children[0],i=Number(l.terminalNodeText[0]),r=l.children[0],s=r.terminalNodeText[0];return!s&&r.children&&(s=r.children[0].terminalNodeText[0]),[new T(i,s)];},u.DateTimeLiteral=function(e,t,n){var l=n.text.slice(1);return[new b(l)];},u.TimeLiteral=function(e,t,n){var l=n.text.slice(1);return[new U(l)];},u.NumberLiteral=function(e,t,n){return[Number(n.text)];},u.Identifier=function(e,t,n){return[n.text.replace(/(^`|`$)/g,"")];},u.InvocationTerm=function(e,t,n){return u.doEval(e,t,n.children[0]);},u.MemberInvocation=function(e,t,n){var l=u.doEval(e,t,n.children[0])[0],r=e.model;return t?a.isCapitalized(l)?t.filter(function(e){return e.resourceType===l;}).map(function(e){return x(e,l);}):t.reduce(function(e,t){var n,s=(t=x(t)).path+"."+l;if(r){var o=r.pathsDefinedElsewhere[s];o&&(s=o);}var u=r&&r.choiceTypePaths[s];if(u){var c,f=i(u);try{for(f.s();!(c=f.n()).done;){var m=c.value,p=l+m;if(n=t.data[p]){s=m;break;}}}catch(e){f.e(e);}finally{f.f();}}else n=t.data[l];return a.isSome(n)?(Array.isArray(n)?e=e.concat(n.map(function(e){return x(e,s);})):e.push(x(n,s)),e):e;},[]):[];},u.IndexerExpression=function(e,t,n){var l=n.children[0],i=n.children[1],r=u.doEval(e,t,l),s=u.doEval(e,t,i);if(a.isEmpty(s))return[];var o=parseInt(s[0]);return r&&a.isSome(o)&&r.length>o&&o>=0?[r[o]]:[];},u.Functn=function(e,t,n){return n.children.map(function(n){return u.doEval(e,t,n);});},u.realizeParams=function(e,t,n){return n&&n[0]&&n[0].children?n[0].children.map(function(n){return u.doEval(e,t,n);}):[];};var S={Integer:function Integer(e){var t=a.valData(e);if("number"!=typeof t||!Number.isInteger(t))throw new Error("Expected integer, got: "+JSON.stringify(t));return t;},Boolean:function Boolean(e){var t=a.valData(e);if(!0===t||!1===t)return t;throw new Error("Expected boolean, got: "+JSON.stringify(t));},Number:function Number(e){var t=a.valData(e);if("number"!=typeof t)throw new Error("Expected number, got: "+JSON.stringify(t));return t;},String:function String(e){var t=a.valData(e);if("string"!=typeof t)throw new Error("Expected string, got: "+JSON.stringify(t));return t;}};function I(e,t,n,l){if(e.currentData=t,"Expr"===n)return function(t){return u.doEval(e,a.arraify(t),l);};if("AnyAtRoot"===n)return u.doEval(e,e.dataRoot,l);if("Identifier"===n){if("TermExpression"==l.type)return l.text;throw new Error("Expected identifier node, got ",JSON.stringify(l));}var i=u.doEval(e,t,l);if("Any"===n)return i;if(Array.isArray(n)){if(0==i.length)return[];n=n[0];}var r=S[n];if(i.length>1)throw new Error("Unexpected collection"+JSON.stringify(i)+"; expected singleton of type "+n);if(0==i.length)return[];if(r)return r(i[0]);throw console.error(n,l),new Error("IMPL me for "+n);}function N(e){return null==e||a.isEmpty(e);}function O(e,t,n,l){var i=u.invocationTable[t];if(i&&i.fn){var r=l?l.length:0;if(2!=r)throw new Error("Infix invoke should have arity 2");var s=i.arity[r];if(s){for(var o=[],c=0;c<r;c++){var f=s[c],m=l[c];o.push(I(e,n,f,m));}if(i.nullable&&o.some(N))return[];var p=i.fn.apply(e,o);return a.arraify(p);}return console.log(t+" wrong arity: got "+r),[];}throw new Error("Not impl "+t);}u.FunctionInvocation=function(e,t,n){var l=u.doEval(e,t,n.children[0]),i=l[0];return l.shift(),function(e,t,n,l){var i,r=u.invocationTable[t];if(r){if(r.arity){var s=l?l.length:0,o=r.arity[s];if(o){for(var c=[],f=0;f<s;f++){var m=o[f],p=l[f];c.push(I(e,n,m,p));}return c.unshift(n),r.nullable&&c.some(N)?[]:(i=r.fn.apply(e,c),a.arraify(i));}return console.log(t+" wrong arity: got "+s),[];}if(l)throw new Error(t+" expects no params");return i=r.fn.call(e,a.arraify(n)),a.arraify(i);}throw new Error("Not implemented: "+t);}(e,i,t,l&&l[0]&&l[0].children);},u.ParamList=function(e,t,n){return n;},u.UnionExpression=function(e,t,n){return O(e,"|",t,n.children);},u.ThisInvocation=function(e){return a.arraify(e.currentData);},u.OpExpression=function(e,t,n){return O(e,n.terminalNodeText[0],t,n.children);},u.AliasOpExpression=function(e){return function(t,n,l){var i=l.terminalNodeText[0],r=e[i];if(!r)throw new Error("Do not know how to alias "+i+" by "+JSON.stringify(e));return O(t,r,n,l.children);};},u.NullLiteral=function(){return[];},u.ParenthesizedTerm=function(e,t,n){return u.doEval(e,t,n.children[0]);},u.evalTable={BooleanLiteral:u.BooleanLiteral,EqualityExpression:u.OpExpression,FunctionInvocation:u.FunctionInvocation,Functn:u.Functn,Identifier:u.Identifier,IndexerExpression:u.IndexerExpression,InequalityExpression:u.OpExpression,InvocationExpression:u.InvocationExpression,AdditiveExpression:u.OpExpression,MultiplicativeExpression:u.OpExpression,MembershipExpression:u.AliasOpExpression({contains:"containsOp",in:"inOp"}),NullLiteral:u.NullLiteral,InvocationTerm:u.InvocationTerm,LiteralTerm:u.LiteralTerm,MemberInvocation:u.MemberInvocation,NumberLiteral:u.NumberLiteral,ParamList:u.ParamList,ParenthesizedTerm:u.ParenthesizedTerm,StringLiteral:u.StringLiteral,TermExpression:u.TermExpression,ThisInvocation:u.ThisInvocation,UnionExpression:u.UnionExpression,OrExpression:u.OpExpression,ImpliesExpression:u.OpExpression,AndExpression:u.OpExpression,XorExpression:u.OpExpression},u.doEval=function(e,t,n){var l=u.evalTable[n.type]||u[n.type];if(l)return l.call(u,e,t,n);throw new Error("No "+n.type+" evaluator ");};var E=function E(e){return s.parse(e);};function k(e,t,n,i){o.reset();var r=a.arraify(e),s={context:e,ucum:"http://unitsofmeasure.org"},c={dataRoot:r,vars:Object.assign(s,n),model:i},f=u.doEval(c,r,t.children[0]);return f=function e(t){if(t=a.valData(t),Array.isArray(t))for(var n=0,i=t.length;n<i;++n){t[n]=e(t[n]);}else if("object"===l(t)&&!(t instanceof M))for(var r=0,s=Object.keys(t);r<s.length;r++){var o=s[r];t[o]=e(t[o]);}return t;}(f);}e.exports={parse:E,compile:function compile(e,t){var n=E(e);return function(e,l){return k(e,n,l,t);};},evaluate:function evaluate(e,t,n,l){return k(e,s.parse(t),n,l);},ucumUtils:n(38).UcumLhcUtils.getInstance()};},function(e,t,n){function l(e){if("undefined"==typeof Symbol||null==e[Symbol.iterator]){if(Array.isArray(e)||(e=function(e,t){if(!e)return;if("string"==typeof e)return i(e,t);var n=Object.prototype.toString.call(e).slice(8,-1);"Object"===n&&e.constructor&&(n=e.constructor.name);if("Map"===n||"Set"===n)return Array.from(n);if("Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))return i(e,t);}(e))){var t=0,n=function n(){};return{s:n,n:function n(){return t>=e.length?{done:!0}:{done:!1,value:e[t++]};},e:function e(_e3){throw _e3;},f:n};}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");}var l,r,s=!0,a=!1;return{s:function s(){l=e[Symbol.iterator]();},n:function n(){var e=l.next();return s=e.done,e;},e:function e(_e4){a=!0,r=_e4;},f:function f(){try{s||null==l.return||l.return();}finally{if(a)throw r;}}};}function i(e,t){(null==t||t>e.length)&&(t=e.length);for(var n=0,l=new Array(t);n<t;n++){l[n]=e[n];}return l;}var r=n(16),s=n(67).FHIRPathLexer,a=n(68).FHIRPathParser,o=n(36).FHIRPathListener,u=function u(e){return r.error.ErrorListener.call(this),this.errors=e,this;};(u.prototype=Object.create(r.error.ErrorListener.prototype)).constructor=u,u.prototype.syntaxError=function(e,t,n,l,i,r){this.errors.push([e,t,n,l,i,r]);};e.exports={parse:function parse(e){var t=new r.InputStream(e),n=new s(t),i=new r.CommonTokenStream(n),c=new a(i);c.buildParseTrees=!0;var f=[],m=new u(f);n.removeErrorListeners(),n.addErrorListener(m),c.removeErrorListeners(),c.addErrorListener(m);var p=c.expression();function h(){return o.call(this),this;}h.prototype=Object.create(o.prototype),h.prototype.constructor=h;for(var d,g={},y=[g],C=function C(){var e=v[_];e.startsWith("enter")?h.prototype[e]=function(t){var n=y[y.length-1],i=e.slice(5);(d={type:i}).text=t.getText(),n.children||(n.children=[]),n.children.push(d),y.push(d),d.terminalNodeText=[];var r,s=l(t.children);try{for(s.s();!(r=s.n()).done;){var a=r.value;a.symbol&&d.terminalNodeText.push(a.getText());}}catch(e){s.e(e);}finally{s.f();}}:e.startsWith("exit")&&(h.prototype[e]=function(){y.pop();});},_=0,v=Object.keys(o.prototype);_<v.length;_++){C();}var L=new h();if(r.tree.ParseTreeWalker.DEFAULT.walk(L,p),f.length>0){for(var b=[],U=0,T=f.length;U<T;++U){var M=f[U],x="line: "+M[2]+"; column: "+M[3]+"; message: "+M[4];b.push(x);}var S=new Error(b.join("\n"));throw S.errors=f,S;}return g;}};},function(e,t,n){t.ATN=n(8).ATN,t.ATNDeserializer=n(27).ATNDeserializer,t.LexerATNSimulator=n(54).LexerATNSimulator,t.ParserATNSimulator=n(57).ParserATNSimulator,t.PredictionMode=n(32).PredictionMode;},function(e,t,n){var l=n(0).Set,i=n(0).BitSet,r=n(1).Token,s=n(17).ATNConfig,a=(n(2).Interval,n(2).IntervalSet),o=n(3).RuleStopState,u=n(9).RuleTransition,c=n(9).NotSetTransition,f=n(9).WildcardTransition,m=n(9).AbstractPredicateTransition,p=n(6),h=p.predictionContextFromRuleContext,d=p.PredictionContext,g=p.SingletonPredictionContext;function y(e){this.atn=e;}y.HIT_PRED=r.INVALID_TYPE,y.prototype.getDecisionLookahead=function(e){if(null===e)return null;for(var t=e.transitions.length,n=[],r=0;r<t;r++){n[r]=new a();var s=new l();this._LOOK(e.transition(r).target,null,d.EMPTY,n[r],s,new i(),!1,!1),(0===n[r].length||n[r].contains(y.HIT_PRED))&&(n[r]=null);}return n;},y.prototype.LOOK=function(e,t,n){var r=new a(),s=null!==(n=n||null)?h(e.atn,n):null;return this._LOOK(e,t,s,r,new l(),new i(),!0,!0),r;},y.prototype._LOOK=function(e,t,n,l,i,a,p,h){var C=new s({state:e,alt:0,context:n},null);if(!i.contains(C)){if(i.add(C),e===t){if(null===n)return void l.addOne(r.EPSILON);if(n.isEmpty()&&h)return void l.addOne(r.EOF);}if(e instanceof o){if(null===n)return void l.addOne(r.EPSILON);if(n.isEmpty()&&h)return void l.addOne(r.EOF);if(n!==d.EMPTY){for(var _=0;_<n.length;_++){var v=this.atn.states[n.getReturnState(_)],L=a.contains(v.ruleIndex);try{a.remove(v.ruleIndex),this._LOOK(v,t,n.getParent(_),l,i,a,p,h);}finally{L&&a.add(v.ruleIndex);}}return;}}for(var b=0;b<e.transitions.length;b++){var U=e.transitions[b];if(U.constructor===u){if(a.contains(U.target.ruleIndex))continue;var T=g.create(n,U.followState.stateNumber);try{a.add(U.target.ruleIndex),this._LOOK(U.target,t,T,l,i,a,p,h);}finally{a.remove(U.target.ruleIndex);}}else if(U instanceof m)p?this._LOOK(U.target,t,n,l,i,a,p,h):l.addOne(y.HIT_PRED);else if(U.isEpsilon)this._LOOK(U.target,t,n,l,i,a,p,h);else if(U.constructor===f)l.addRange(r.MIN_USER_TOKEN_TYPE,this.atn.maxTokenType);else{var M=U.label;null!==M&&(U instanceof c&&(M=M.complement(r.MIN_USER_TOKEN_TYPE,this.atn.maxTokenType)),l.addSet(M));}}}},t.LL1Analyzer=y;},function(e,t){function n(){}n.LEXER=0,n.PARSER=1,t.ATNType=n;},function(e,t,n){var l=n(1).Token,i=n(19).Lexer,r=n(8).ATN,s=n(31).ATNSimulator,a=n(14).DFAState,o=(n(11).ATNConfigSet,n(11).OrderedATNConfigSet),u=n(6).PredictionContext,c=n(6).SingletonPredictionContext,f=n(3).RuleStopState,m=n(17).LexerATNConfig,p=n(9).Transition,h=n(56).LexerActionExecutor,d=n(5).LexerNoViableAltException;function g(e){e.index=-1,e.line=0,e.column=-1,e.dfaState=null;}function y(){return g(this),this;}function C(e,t,n,l){return s.call(this,t,l),this.decisionToDFA=n,this.recog=e,this.startIndex=-1,this.line=1,this.column=0,this.mode=i.DEFAULT_MODE,this.prevAccept=new y(),this;}y.prototype.reset=function(){g(this);},C.prototype=Object.create(s.prototype),C.prototype.constructor=C,C.debug=!1,C.dfa_debug=!1,C.MIN_DFA_EDGE=0,C.MAX_DFA_EDGE=127,C.match_calls=0,C.prototype.copyState=function(e){this.column=e.column,this.line=e.line,this.mode=e.mode,this.startIndex=e.startIndex;},C.prototype.match=function(e,t){this.match_calls+=1,this.mode=t;var n=e.mark();try{this.startIndex=e.index,this.prevAccept.reset();var l=this.decisionToDFA[t];return null===l.s0?this.matchATN(e):this.execATN(e,l.s0);}finally{e.release(n);}},C.prototype.reset=function(){this.prevAccept.reset(),this.startIndex=-1,this.line=1,this.column=0,this.mode=i.DEFAULT_MODE;},C.prototype.matchATN=function(e){var t=this.atn.modeToStartState[this.mode];C.debug&&console.log("matchATN mode "+this.mode+" start: "+t);var n=this.mode,l=this.computeStartState(e,t),i=l.hasSemanticContext;l.hasSemanticContext=!1;var r=this.addDFAState(l);i||(this.decisionToDFA[this.mode].s0=r);var s=this.execATN(e,r);return C.debug&&console.log("DFA after matchATN: "+this.decisionToDFA[n].toLexerString()),s;},C.prototype.execATN=function(e,t){C.debug&&console.log("start state closure="+t.configs),t.isAcceptState&&this.captureSimState(this.prevAccept,e,t);for(var n=e.LA(1),i=t;;){C.debug&&console.log("execATN loop starting closure: "+i.configs);var r=this.getExistingTargetState(i,n);if(null===r&&(r=this.computeTargetState(e,i,n)),r===s.ERROR)break;if(n!==l.EOF&&this.consume(e),r.isAcceptState&&(this.captureSimState(this.prevAccept,e,r),n===l.EOF))break;n=e.LA(1),i=r;}return this.failOrAccept(this.prevAccept,e,i.configs,n);},C.prototype.getExistingTargetState=function(e,t){if(null===e.edges||t<C.MIN_DFA_EDGE||t>C.MAX_DFA_EDGE)return null;var n=e.edges[t-C.MIN_DFA_EDGE];return void 0===n&&(n=null),C.debug&&null!==n&&console.log("reuse state "+e.stateNumber+" edge to "+n.stateNumber),n;},C.prototype.computeTargetState=function(e,t,n){var l=new o();return this.getReachableConfigSet(e,t.configs,l,n),0===l.items.length?(l.hasSemanticContext||this.addDFAEdge(t,n,s.ERROR),s.ERROR):this.addDFAEdge(t,n,null,l);},C.prototype.failOrAccept=function(e,t,n,i){if(null!==this.prevAccept.dfaState){var r=e.dfaState.lexerActionExecutor;return this.accept(t,r,this.startIndex,e.index,e.line,e.column),e.dfaState.prediction;}if(i===l.EOF&&t.index===this.startIndex)return l.EOF;throw new d(this.recog,t,this.startIndex,n);},C.prototype.getReachableConfigSet=function(e,t,n,i){for(var s=r.INVALID_ALT_NUMBER,a=0;a<t.items.length;a++){var o=t.items[a],u=o.alt===s;if(!u||!o.passedThroughNonGreedyDecision){C.debug&&console.log("testing %s at %s\n",this.getTokenName(i),o.toString(this.recog,!0));for(var c=0;c<o.state.transitions.length;c++){var f=o.state.transitions[c],p=this.getReachableTarget(f,i);if(null!==p){var h=o.lexerActionExecutor;null!==h&&(h=h.fixOffsetBeforeMatch(e.index-this.startIndex));var d=i===l.EOF,g=new m({state:p,lexerActionExecutor:h},o);this.closure(e,g,n,u,!0,d)&&(s=o.alt);}}}}},C.prototype.accept=function(e,t,n,l,i,r){C.debug&&console.log("ACTION %s\n",t),e.seek(l),this.line=i,this.column=r,null!==t&&null!==this.recog&&t.execute(this.recog,e,n);},C.prototype.getReachableTarget=function(e,t){return e.matches(t,0,i.MAX_CHAR_VALUE)?e.target:null;},C.prototype.computeStartState=function(e,t){for(var n=u.EMPTY,l=new o(),i=0;i<t.transitions.length;i++){var r=t.transitions[i].target,s=new m({state:r,alt:i+1,context:n},null);this.closure(e,s,l,!1,!1,!1);}return l;},C.prototype.closure=function(e,t,n,l,i,r){var s=null;if(C.debug&&console.log("closure("+t.toString(this.recog,!0)+")"),t.state instanceof f){if(C.debug&&(null!==this.recog?console.log("closure at %s rule stop %s\n",this.recog.ruleNames[t.state.ruleIndex],t):console.log("closure at rule stop %s\n",t)),null===t.context||t.context.hasEmptyPath()){if(null===t.context||t.context.isEmpty())return n.add(t),!0;n.add(new m({state:t.state,context:u.EMPTY},t)),l=!0;}if(null!==t.context&&!t.context.isEmpty())for(var a=0;a<t.context.length;a++){if(t.context.getReturnState(a)!==u.EMPTY_RETURN_STATE){var o=t.context.getParent(a),c=this.atn.states[t.context.getReturnState(a)];s=new m({state:c,context:o},t),l=this.closure(e,s,n,l,i,r);}}return l;}t.state.epsilonOnlyTransitions||l&&t.passedThroughNonGreedyDecision||n.add(t);for(var p=0;p<t.state.transitions.length;p++){var h=t.state.transitions[p];null!==(s=this.getEpsilonTarget(e,t,h,n,i,r))&&(l=this.closure(e,s,n,l,i,r));}return l;},C.prototype.getEpsilonTarget=function(e,t,n,r,s,a){var o=null;if(n.serializationType===p.RULE){var u=c.create(t.context,n.followState.stateNumber);o=new m({state:n.target,context:u},t);}else{if(n.serializationType===p.PRECEDENCE)throw"Precedence predicates are not supported in lexers.";if(n.serializationType===p.PREDICATE)C.debug&&console.log("EVAL rule "+n.ruleIndex+":"+n.predIndex),r.hasSemanticContext=!0,this.evaluatePredicate(e,n.ruleIndex,n.predIndex,s)&&(o=new m({state:n.target},t));else if(n.serializationType===p.ACTION){if(null===t.context||t.context.hasEmptyPath()){var f=h.append(t.lexerActionExecutor,this.atn.lexerActions[n.actionIndex]);o=new m({state:n.target,lexerActionExecutor:f},t);}else o=new m({state:n.target},t);}else n.serializationType===p.EPSILON?o=new m({state:n.target},t):n.serializationType!==p.ATOM&&n.serializationType!==p.RANGE&&n.serializationType!==p.SET||a&&n.matches(l.EOF,0,i.MAX_CHAR_VALUE)&&(o=new m({state:n.target},t));}return o;},C.prototype.evaluatePredicate=function(e,t,n,l){if(null===this.recog)return!0;if(!l)return this.recog.sempred(null,t,n);var i=this.column,r=this.line,s=e.index,a=e.mark();try{return this.consume(e),this.recog.sempred(null,t,n);}finally{this.column=i,this.line=r,e.seek(s),e.release(a);}},C.prototype.captureSimState=function(e,t,n){e.index=t.index,e.line=this.line,e.column=this.column,e.dfaState=n;},C.prototype.addDFAEdge=function(e,t,n,l){if(void 0===n&&(n=null),void 0===l&&(l=null),null===n&&null!==l){var i=l.hasSemanticContext;if(l.hasSemanticContext=!1,n=this.addDFAState(l),i)return n;}return t<C.MIN_DFA_EDGE||t>C.MAX_DFA_EDGE||(C.debug&&console.log("EDGE "+e+" -> "+n+" upon "+t),null===e.edges&&(e.edges=[]),e.edges[t-C.MIN_DFA_EDGE]=n),n;},C.prototype.addDFAState=function(e){for(var t=new a(null,e),n=null,l=0;l<e.items.length;l++){var i=e.items[l];if(i.state instanceof f){n=i;break;}}null!==n&&(t.isAcceptState=!0,t.lexerActionExecutor=n.lexerActionExecutor,t.prediction=this.atn.ruleToTokenType[n.state.ruleIndex]);var r=this.decisionToDFA[this.mode],s=r.states.get(t);if(null!==s)return s;var o=t;return o.stateNumber=r.states.length,e.setReadonly(!0),o.configs=e,r.states.add(o),o;},C.prototype.getDFA=function(e){return this.decisionToDFA[e];},C.prototype.getText=function(e){return e.getText(this.startIndex,e.index-1);},C.prototype.consume=function(e){e.LA(1)==="\n".charCodeAt(0)?(this.line+=1,this.column=0):this.column+=1,e.consume();},C.prototype.getTokenName=function(e){return-1===e?"EOF":"'"+String.fromCharCode(e)+"'";},t.LexerATNSimulator=C;},function(e,t,n){var l=n(1).CommonToken;function i(){return this;}function r(e){return i.call(this),this.copyText=void 0!==e&&e,this;}r.prototype=Object.create(i.prototype),r.prototype.constructor=r,r.DEFAULT=new r(),r.prototype.create=function(e,t,n,i,r,s,a,o){var u=new l(e,t,i,r,s);return u.line=a,u.column=o,null!==n?u.text=n:this.copyText&&null!==e[1]&&(u.text=e[1].getText(r,s)),u;},r.prototype.createThin=function(e,t){var n=new l(null,e);return n.text=t,n;},t.CommonTokenFactory=r;},function(e,t,n){var l=n(0).hashStuff,i=n(29).LexerIndexedCustomAction;function r(e){return this.lexerActions=null===e?[]:e,this.cachedHashCode=l(e),this;}r.append=function(e,t){return new r(null===e?[t]:e.lexerActions.concat([t]));},r.prototype.fixOffsetBeforeMatch=function(e){for(var t=null,n=0;n<this.lexerActions.length;n++){!this.lexerActions[n].isPositionDependent||this.lexerActions[n]instanceof i||(null===t&&(t=this.lexerActions.concat([])),t[n]=new i(e,this.lexerActions[n]));}return null===t?this:new r(t);},r.prototype.execute=function(e,t,n){var l=!1,r=t.index;try{for(var s=0;s<this.lexerActions.length;s++){var a=this.lexerActions[s];if(a instanceof i){var o=a.offset;t.seek(n+o),a=a.action,l=n+o!==r;}else a.isPositionDependent&&(t.seek(r),l=!1);a.execute(e);}}finally{l&&t.seek(r);}},r.prototype.hashCode=function(){return this.cachedHashCode;},r.prototype.updateHashCode=function(e){e.update(this.cachedHashCode);},r.prototype.equals=function(e){if(this===e)return!0;if(e instanceof r){if(this.cachedHashCode!=e.cachedHashCode)return!1;if(this.lexerActions.length!=e.lexerActions.length)return!1;for(var t=this.lexerActions.length,n=0;n<t;++n){if(!this.lexerActions[n].equals(e.lexerActions[n]))return!1;}return!0;}return!1;},t.LexerActionExecutor=r;},function(e,t,n){var l=n(0),i=l.Set,r=l.BitSet,s=l.DoubleDict,a=n(8).ATN,o=n(3).ATNState,u=n(17).ATNConfig,c=n(11).ATNConfigSet,f=n(1).Token,m=n(14).DFAState,p=n(14).PredPrediction,h=n(31).ATNSimulator,d=n(32).PredictionMode,g=n(18).RuleContext,y=(n(24).ParserRuleContext,n(13).SemanticContext),C=(n(3).StarLoopEntryState,n(3).RuleStopState),_=n(6).PredictionContext,v=n(2).Interval,L=n(9),b=L.Transition,U=L.SetTransition,T=L.NotSetTransition,M=L.RuleTransition,x=L.ActionTransition,S=n(5).NoViableAltException,I=n(6).SingletonPredictionContext,N=n(6).predictionContextFromRuleContext;function O(e,t,n,l){return h.call(this,t,l),this.parser=e,this.decisionToDFA=n,this.predictionMode=d.LL,this._input=null,this._startIndex=0,this._outerContext=null,this._dfa=null,this.mergeCache=null,this;}O.prototype=Object.create(h.prototype),O.prototype.constructor=O,O.prototype.debug=!1,O.prototype.debug_closure=!1,O.prototype.debug_add=!1,O.prototype.debug_list_atn_decisions=!1,O.prototype.dfa_debug=!1,O.prototype.retry_debug=!1,O.prototype.reset=function(){},O.prototype.adaptivePredict=function(e,t,n){(this.debug||this.debug_list_atn_decisions)&&console.log("adaptivePredict decision "+t+" exec LA(1)=="+this.getLookaheadName(e)+" line "+e.LT(1).line+":"+e.LT(1).column),this._input=e,this._startIndex=e.index,this._outerContext=n;var l=this.decisionToDFA[t];this._dfa=l;var i=e.mark(),r=e.index;try{var s;if(null===(s=l.precedenceDfa?l.getPrecedenceStartState(this.parser.getPrecedence()):l.s0)){null===n&&(n=g.EMPTY),(this.debug||this.debug_list_atn_decisions)&&console.log("predictATN decision "+l.decision+" exec LA(1)=="+this.getLookaheadName(e)+", outerContext="+n.toString(this.parser.ruleNames));var a=this.computeStartState(l.atnStartState,g.EMPTY,!1);l.precedenceDfa?(l.s0.configs=a,a=this.applyPrecedenceFilter(a),s=this.addDFAState(l,new m(null,a)),l.setPrecedenceStartState(this.parser.getPrecedence(),s)):(s=this.addDFAState(l,new m(null,a)),l.s0=s);}var o=this.execATN(l,s,e,r,n);return this.debug&&console.log("DFA after predictATN: "+l.toString(this.parser.literalNames)),o;}finally{this._dfa=null,this.mergeCache=null,e.seek(r),e.release(i);}},O.prototype.execATN=function(e,t,n,l,i){var r;(this.debug||this.debug_list_atn_decisions)&&console.log("execATN decision "+e.decision+" exec LA(1)=="+this.getLookaheadName(n)+" line "+n.LT(1).line+":"+n.LT(1).column);var s=t;this.debug&&console.log("s0 = "+t);for(var o=n.LA(1);;){var u=this.getExistingTargetState(s,o);if(null===u&&(u=this.computeTargetState(e,s,o)),u===h.ERROR){var c=this.noViableAlt(n,i,s.configs,l);if(n.seek(l),(r=this.getSynValidOrSemInvalidAltThatFinishedDecisionEntryRule(s.configs,i))!==a.INVALID_ALT_NUMBER)return r;throw c;}if(u.requiresFullContext&&this.predictionMode!==d.SLL){var m=null;if(null!==u.predicates){this.debug&&console.log("DFA state has preds in DFA sim LL failover");var p=n.index;if(p!==l&&n.seek(l),1===(m=this.evalSemanticContext(u.predicates,i,!0)).length)return this.debug&&console.log("Full LL avoided"),m.minValue();p!==l&&n.seek(p);}this.dfa_debug&&console.log("ctx sensitive state "+i+" in "+u);var g=this.computeStartState(e.atnStartState,i,!0);return this.reportAttemptingFullContext(e,m,u.configs,l,n.index),r=this.execATNWithFullContext(e,u,g,n,l,i);}if(u.isAcceptState){if(null===u.predicates)return u.prediction;var y=n.index;n.seek(l);var C=this.evalSemanticContext(u.predicates,i,!0);if(0===C.length)throw this.noViableAlt(n,i,u.configs,l);return 1===C.length||this.reportAmbiguity(e,u,l,y,!1,C,u.configs),C.minValue();}s=u,o!==f.EOF&&(n.consume(),o=n.LA(1));}},O.prototype.getExistingTargetState=function(e,t){var n=e.edges;return null===n?null:n[t+1]||null;},O.prototype.computeTargetState=function(e,t,n){var i=this.computeReachSet(t.configs,n,!1);if(null===i)return this.addDFAEdge(e,t,n,h.ERROR),h.ERROR;var r=new m(null,i),s=this.getUniqueAlt(i);if(this.debug){var o=d.getConflictingAltSubsets(i);console.log("SLL altSubSets="+l.arrayToString(o)+", previous="+t.configs+", configs="+i+", predict="+s+", allSubsetsConflict="+d.allSubsetsConflict(o)+", conflictingAlts="+this.getConflictingAlts(i));}return s!==a.INVALID_ALT_NUMBER?(r.isAcceptState=!0,r.configs.uniqueAlt=s,r.prediction=s):d.hasSLLConflictTerminatingPrediction(this.predictionMode,i)&&(r.configs.conflictingAlts=this.getConflictingAlts(i),r.requiresFullContext=!0,r.isAcceptState=!0,r.prediction=r.configs.conflictingAlts.minValue()),r.isAcceptState&&r.configs.hasSemanticContext&&(this.predicateDFAState(r,this.atn.getDecisionState(e.decision)),null!==r.predicates&&(r.prediction=a.INVALID_ALT_NUMBER)),r=this.addDFAEdge(e,t,n,r);},O.prototype.predicateDFAState=function(e,t){var n=t.transitions.length,l=this.getConflictingAltsOrUniqueAlt(e.configs),i=this.getPredsForAmbigAlts(l,e.configs,n);null!==i?(e.predicates=this.getPredicatePredictions(l,i),e.prediction=a.INVALID_ALT_NUMBER):e.prediction=l.minValue();},O.prototype.execATNWithFullContext=function(e,t,n,l,i,r){(this.debug||this.debug_list_atn_decisions)&&console.log("execATNWithFullContext "+n);var s=!1,o=null,u=n;l.seek(i);for(var c=l.LA(1),m=-1;;){if(null===(o=this.computeReachSet(u,c,!0))){var p=this.noViableAlt(l,r,u,i);l.seek(i);var h=this.getSynValidOrSemInvalidAltThatFinishedDecisionEntryRule(u,r);if(h!==a.INVALID_ALT_NUMBER)return h;throw p;}var g=d.getConflictingAltSubsets(o);if(this.debug&&console.log("LL altSubSets="+g+", predict="+d.getUniqueAlt(g)+", resolvesToJustOneViableAlt="+d.resolvesToJustOneViableAlt(g)),o.uniqueAlt=this.getUniqueAlt(o),o.uniqueAlt!==a.INVALID_ALT_NUMBER){m=o.uniqueAlt;break;}if(this.predictionMode!==d.LL_EXACT_AMBIG_DETECTION){if((m=d.resolvesToJustOneViableAlt(g))!==a.INVALID_ALT_NUMBER)break;}else if(d.allSubsetsConflict(g)&&d.allSubsetsEqual(g)){s=!0,m=d.getSingleViableAlt(g);break;}u=o,c!==f.EOF&&(l.consume(),c=l.LA(1));}return o.uniqueAlt!==a.INVALID_ALT_NUMBER?(this.reportContextSensitivity(e,m,o,i,l.index),m):(this.reportAmbiguity(e,t,i,l.index,s,null,o),m);},O.prototype.computeReachSet=function(e,t,n){this.debug&&console.log("in computeReachSet, starting closure: "+e),null===this.mergeCache&&(this.mergeCache=new s());for(var l=new c(n),r=null,o=0;o<e.items.length;o++){var m=e.items[o];if(this.debug_add&&console.log("testing "+this.getTokenName(t)+" at "+m),m.state instanceof C)(n||t===f.EOF)&&(null===r&&(r=[]),r.push(m),this.debug_add&&console.log("added "+m+" to skippedStopStates"));else for(var p=0;p<m.state.transitions.length;p++){var h=m.state.transitions[p],g=this.getReachableTarget(h,t);if(null!==g){var y=new u({state:g},m);l.add(y,this.mergeCache),this.debug_add&&console.log("added "+y+" to intermediate");}}}var _=null;if(null===r&&t!==f.EOF&&(1===l.items.length||this.getUniqueAlt(l)!==a.INVALID_ALT_NUMBER)&&(_=l),null===_){_=new c(n);for(var v=new i(),L=t===f.EOF,b=0;b<l.items.length;b++){this.closure(l.items[b],_,v,!1,n,L);}}if(t===f.EOF&&(_=this.removeAllConfigsNotInRuleStopState(_,_===l)),!(null===r||n&&d.hasConfigInRuleStopState(_)))for(var U=0;U<r.length;U++){_.add(r[U],this.mergeCache);}return 0===_.items.length?null:_;},O.prototype.removeAllConfigsNotInRuleStopState=function(e,t){if(d.allConfigsInRuleStopStates(e))return e;for(var n=new c(e.fullCtx),l=0;l<e.items.length;l++){var i=e.items[l];if(i.state instanceof C)n.add(i,this.mergeCache);else if(t&&i.state.epsilonOnlyTransitions)if(this.atn.nextTokens(i.state).contains(f.EPSILON)){var r=this.atn.ruleToStopState[i.state.ruleIndex];n.add(new u({state:r},i),this.mergeCache);}}return n;},O.prototype.computeStartState=function(e,t,n){for(var l=N(this.atn,t),r=new c(n),s=0;s<e.transitions.length;s++){var a=e.transitions[s].target,o=new u({state:a,alt:s+1,context:l},null),f=new i();this.closure(o,r,f,!0,n,!1);}return r;},O.prototype.applyPrecedenceFilter=function(e){for(var t,n=[],l=new c(e.fullCtx),i=0;i<e.items.length;i++){if(1===(t=e.items[i]).alt){var r=t.semanticContext.evalPrecedence(this.parser,this._outerContext);null!==r&&(n[t.state.stateNumber]=t.context,r!==t.semanticContext?l.add(new u({semanticContext:r},t),this.mergeCache):l.add(t,this.mergeCache));}}for(i=0;i<e.items.length;i++){if(1!==(t=e.items[i]).alt){if(!t.precedenceFilterSuppressed){var s=n[t.state.stateNumber]||null;if(null!==s&&s.equals(t.context))continue;}l.add(t,this.mergeCache);}}return l;},O.prototype.getReachableTarget=function(e,t){return e.matches(t,0,this.atn.maxTokenType)?e.target:null;},O.prototype.getPredsForAmbigAlts=function(e,t,n){for(var i=[],r=0;r<t.items.length;r++){var s=t.items[r];e.contains(s.alt)&&(i[s.alt]=y.orContext(i[s.alt]||null,s.semanticContext));}var a=0;for(r=1;r<n+1;r++){var o=i[r]||null;null===o?i[r]=y.NONE:o!==y.NONE&&(a+=1);}return 0===a&&(i=null),this.debug&&console.log("getPredsForAmbigAlts result "+l.arrayToString(i)),i;},O.prototype.getPredicatePredictions=function(e,t){for(var n=[],l=!1,i=1;i<t.length;i++){var r=t[i];null!==e&&e.contains(i)&&n.push(new p(r,i)),r!==y.NONE&&(l=!0);}return l?n:null;},O.prototype.getSynValidOrSemInvalidAltThatFinishedDecisionEntryRule=function(e,t){var n=this.splitAccordingToSemanticValidity(e,t),l=n[0],i=n[1],r=this.getAltThatFinishedDecisionEntryRule(l);return r!==a.INVALID_ALT_NUMBER||i.items.length>0&&(r=this.getAltThatFinishedDecisionEntryRule(i))!==a.INVALID_ALT_NUMBER?r:a.INVALID_ALT_NUMBER;},O.prototype.getAltThatFinishedDecisionEntryRule=function(e){for(var t=[],n=0;n<e.items.length;n++){var l=e.items[n];(l.reachesIntoOuterContext>0||l.state instanceof C&&l.context.hasEmptyPath())&&t.indexOf(l.alt)<0&&t.push(l.alt);}return 0===t.length?a.INVALID_ALT_NUMBER:Math.min.apply(null,t);},O.prototype.splitAccordingToSemanticValidity=function(e,t){for(var n=new c(e.fullCtx),l=new c(e.fullCtx),i=0;i<e.items.length;i++){var r=e.items[i];if(r.semanticContext!==y.NONE)r.semanticContext.evaluate(this.parser,t)?n.add(r):l.add(r);else n.add(r);}return[n,l];},O.prototype.evalSemanticContext=function(e,t,n){for(var l=new r(),i=0;i<e.length;i++){var s=e[i];if(s.pred!==y.NONE){var a=s.pred.evaluate(this.parser,t);if((this.debug||this.dfa_debug)&&console.log("eval pred "+s+"="+a),a&&((this.debug||this.dfa_debug)&&console.log("PREDICT "+s.alt),l.add(s.alt),!n))break;}else if(l.add(s.alt),!n)break;}return l;},O.prototype.closure=function(e,t,n,l,i,r){this.closureCheckingStopState(e,t,n,l,i,0,r);},O.prototype.closureCheckingStopState=function(e,t,n,l,i,r,s){if((this.debug||this.debug_closure)&&(console.log("closure("+e.toString(this.parser,!0)+")"),e.reachesIntoOuterContext>50))throw"problem";if(e.state instanceof C){if(!e.context.isEmpty()){for(var a=0;a<e.context.length;a++){if(e.context.getReturnState(a)!==_.EMPTY_RETURN_STATE){var o=this.atn.states[e.context.getReturnState(a)],c=e.context.getParent(a),f={state:o,alt:e.alt,context:c,semanticContext:e.semanticContext},m=new u(f,null);m.reachesIntoOuterContext=e.reachesIntoOuterContext,this.closureCheckingStopState(m,t,n,l,i,r-1,s);}else{if(i){t.add(new u({state:e.state,context:_.EMPTY},e),this.mergeCache);continue;}this.debug&&console.log("FALLING off rule "+this.getRuleName(e.state.ruleIndex)),this.closure_(e,t,n,l,i,r,s);}}return;}if(i)return void t.add(e,this.mergeCache);this.debug&&console.log("FALLING off rule "+this.getRuleName(e.state.ruleIndex));}this.closure_(e,t,n,l,i,r,s);},O.prototype.closure_=function(e,t,n,l,i,r,s){var a=e.state;a.epsilonOnlyTransitions||t.add(e,this.mergeCache);for(var o=0;o<a.transitions.length;o++){if(0!=o||!this.canDropLoopEntryEdgeInLeftRecursiveRule(e)){var u=a.transitions[o],c=l&&!(u instanceof x),f=this.getEpsilonTarget(e,u,c,0===r,i,s);if(null!==f){var m=r;if(e.state instanceof C){if(null!==this._dfa&&this._dfa.precedenceDfa&&u.outermostPrecedenceReturn===this._dfa.atnStartState.ruleIndex&&(f.precedenceFilterSuppressed=!0),f.reachesIntoOuterContext+=1,n.add(f)!==f)continue;t.dipsIntoOuterContext=!0,m-=1,this.debug&&console.log("dips into outer ctx: "+f);}else{if(!u.isEpsilon&&n.add(f)!==f)continue;u instanceof M&&m>=0&&(m+=1);}this.closureCheckingStopState(f,t,n,c,i,m,s);}}}},O.prototype.canDropLoopEntryEdgeInLeftRecursiveRule=function(e){var t=e.state;if(t.stateType!=o.STAR_LOOP_ENTRY)return!1;if(t.stateType!=o.STAR_LOOP_ENTRY||!t.isPrecedenceDecision||e.context.isEmpty()||e.context.hasEmptyPath())return!1;for(var n=e.context.length,l=0;l<n;l++){if((s=this.atn.states[e.context.getReturnState(l)]).ruleIndex!=t.ruleIndex)return!1;}var i=t.transitions[0].target.endState.stateNumber,r=this.atn.states[i];for(l=0;l<n;l++){var s,a=e.context.getReturnState(l);if(1!=(s=this.atn.states[a]).transitions.length||!s.transitions[0].isEpsilon)return!1;var u=s.transitions[0].target;if((s.stateType!=o.BLOCK_END||u!=t)&&s!=r&&u!=r&&(u.stateType!=o.BLOCK_END||1!=u.transitions.length||!u.transitions[0].isEpsilon||u.transitions[0].target!=t))return!1;}return!0;},O.prototype.getRuleName=function(e){return null!==this.parser&&e>=0?this.parser.ruleNames[e]:"<rule "+e+">";},O.prototype.getEpsilonTarget=function(e,t,n,l,i,r){switch(t.serializationType){case b.RULE:return this.ruleTransition(e,t);case b.PRECEDENCE:return this.precedenceTransition(e,t,n,l,i);case b.PREDICATE:return this.predTransition(e,t,n,l,i);case b.ACTION:return this.actionTransition(e,t);case b.EPSILON:return new u({state:t.target},e);case b.ATOM:case b.RANGE:case b.SET:return r&&t.matches(f.EOF,0,1)?new u({state:t.target},e):null;default:return null;}},O.prototype.actionTransition=function(e,t){if(this.debug){var n=-1==t.actionIndex?65535:t.actionIndex;console.log("ACTION edge "+t.ruleIndex+":"+n);}return new u({state:t.target},e);},O.prototype.precedenceTransition=function(e,t,n,i,r){this.debug&&(console.log("PRED (collectPredicates="+n+") "+t.precedence+">=_p, ctx dependent=true"),null!==this.parser&&console.log("context surrounding pred is "+l.arrayToString(this.parser.getRuleInvocationStack())));var s=null;if(n&&i){if(r){var a=this._input.index;this._input.seek(this._startIndex);var o=t.getPredicate().evaluate(this.parser,this._outerContext);this._input.seek(a),o&&(s=new u({state:t.target},e));}else{var c=y.andContext(e.semanticContext,t.getPredicate());s=new u({state:t.target,semanticContext:c},e);}}else s=new u({state:t.target},e);return this.debug&&console.log("config from pred transition="+s),s;},O.prototype.predTransition=function(e,t,n,i,r){this.debug&&(console.log("PRED (collectPredicates="+n+") "+t.ruleIndex+":"+t.predIndex+", ctx dependent="+t.isCtxDependent),null!==this.parser&&console.log("context surrounding pred is "+l.arrayToString(this.parser.getRuleInvocationStack())));var s=null;if(n&&(t.isCtxDependent&&i||!t.isCtxDependent)){if(r){var a=this._input.index;this._input.seek(this._startIndex);var o=t.getPredicate().evaluate(this.parser,this._outerContext);this._input.seek(a),o&&(s=new u({state:t.target},e));}else{var c=y.andContext(e.semanticContext,t.getPredicate());s=new u({state:t.target,semanticContext:c},e);}}else s=new u({state:t.target},e);return this.debug&&console.log("config from pred transition="+s),s;},O.prototype.ruleTransition=function(e,t){this.debug&&console.log("CALL rule "+this.getRuleName(t.target.ruleIndex)+", ctx="+e.context);var n=t.followState,l=I.create(e.context,n.stateNumber);return new u({state:t.target,context:l},e);},O.prototype.getConflictingAlts=function(e){var t=d.getConflictingAltSubsets(e);return d.getAlts(t);},O.prototype.getConflictingAltsOrUniqueAlt=function(e){var t=null;return e.uniqueAlt!==a.INVALID_ALT_NUMBER?(t=new r()).add(e.uniqueAlt):t=e.conflictingAlts,t;},O.prototype.getTokenName=function(e){if(e===f.EOF)return"EOF";if(null!==this.parser&&null!==this.parser.literalNames){if(!(e>=this.parser.literalNames.length&&e>=this.parser.symbolicNames.length))return(this.parser.literalNames[e]||this.parser.symbolicNames[e])+"<"+e+">";console.log(e+" ttype out of range: "+this.parser.literalNames),console.log(""+this.parser.getInputStream().getTokens());}return""+e;},O.prototype.getLookaheadName=function(e){return this.getTokenName(e.LA(1));},O.prototype.dumpDeadEndConfigs=function(e){console.log("dead end configs: ");for(var t=e.getDeadEndConfigs(),n=0;n<t.length;n++){var l=t[n],i="no edges";if(l.state.transitions.length>0){var r=l.state.transitions[0];if(r instanceof AtomTransition)i="Atom "+this.getTokenName(r.label);else if(r instanceof U){i=(r instanceof T?"~":"")+"Set "+r.set;}}console.error(l.toString(this.parser,!0)+":"+i);}},O.prototype.noViableAlt=function(e,t,n,l){return new S(this.parser,e,e.get(l),e.LT(1),n,t);},O.prototype.getUniqueAlt=function(e){for(var t=a.INVALID_ALT_NUMBER,n=0;n<e.items.length;n++){var l=e.items[n];if(t===a.INVALID_ALT_NUMBER)t=l.alt;else if(l.alt!==t)return a.INVALID_ALT_NUMBER;}return t;},O.prototype.addDFAEdge=function(e,t,n,l){if(this.debug&&console.log("EDGE "+t+" -> "+l+" upon "+this.getTokenName(n)),null===l)return null;if(l=this.addDFAState(e,l),null===t||n<-1||n>this.atn.maxTokenType)return l;if(null===t.edges&&(t.edges=[]),t.edges[n+1]=l,this.debug){var i=null===this.parser?null:this.parser.literalNames,r=null===this.parser?null:this.parser.symbolicNames;console.log("DFA=\n"+e.toString(i,r));}return l;},O.prototype.addDFAState=function(e,t){if(t==h.ERROR)return t;var n=e.states.get(t);return null!==n?n:(t.stateNumber=e.states.length,t.configs.readOnly||(t.configs.optimizeConfigs(this),t.configs.setReadonly(!0)),e.states.add(t),this.debug&&console.log("adding new DFA state: "+t),t);},O.prototype.reportAttemptingFullContext=function(e,t,n,l,i){if(this.debug||this.retry_debug){var r=new v(l,i+1);console.log("reportAttemptingFullContext decision="+e.decision+":"+n+", input="+this.parser.getTokenStream().getText(r));}null!==this.parser&&this.parser.getErrorListenerDispatch().reportAttemptingFullContext(this.parser,e,l,i,t,n);},O.prototype.reportContextSensitivity=function(e,t,n,l,i){if(this.debug||this.retry_debug){var r=new v(l,i+1);console.log("reportContextSensitivity decision="+e.decision+":"+n+", input="+this.parser.getTokenStream().getText(r));}null!==this.parser&&this.parser.getErrorListenerDispatch().reportContextSensitivity(this.parser,e,l,i,t,n);},O.prototype.reportAmbiguity=function(e,t,n,l,i,r,s){if(this.debug||this.retry_debug){var a=new v(n,l+1);console.log("reportAmbiguity "+r+":"+s+", input="+this.parser.getTokenStream().getText(a));}null!==this.parser&&this.parser.getErrorListenerDispatch().reportAmbiguity(this.parser,e,n,l,i,r,s);},t.ParserATNSimulator=O;},function(e,t,n){t.DFA=n(59).DFA,t.DFASerializer=n(21).DFASerializer,t.LexerDFASerializer=n(21).LexerDFASerializer,t.PredPrediction=n(14).PredPrediction;},function(e,t,n){var l=n(0).Set,i=n(14).DFAState,r=n(3).StarLoopEntryState,s=n(11).ATNConfigSet,a=n(21).DFASerializer,o=n(21).LexerDFASerializer;function u(e,t){if(void 0===t&&(t=0),this.atnStartState=e,this.decision=t,this._states=new l(),this.s0=null,this.precedenceDfa=!1,e instanceof r&&e.isPrecedenceDecision){this.precedenceDfa=!0;var n=new i(null,new s());n.edges=[],n.isAcceptState=!1,n.requiresFullContext=!1,this.s0=n;}return this;}u.prototype.getPrecedenceStartState=function(e){if(!this.precedenceDfa)throw"Only precedence DFAs may contain a precedence start state.";return e<0||e>=this.s0.edges.length?null:this.s0.edges[e]||null;},u.prototype.setPrecedenceStartState=function(e,t){if(!this.precedenceDfa)throw"Only precedence DFAs may contain a precedence start state.";e<0||(this.s0.edges[e]=t);},u.prototype.setPrecedenceDfa=function(e){if(this.precedenceDfa!==e){if(this._states=new DFAStatesSet(),e){var t=new i(null,new s());t.edges=[],t.isAcceptState=!1,t.requiresFullContext=!1,this.s0=t;}else this.s0=null;this.precedenceDfa=e;}},Object.defineProperty(u.prototype,"states",{get:function get(){return this._states;}}),u.prototype.sortedStates=function(){return this._states.values().sort(function(e,t){return e.stateNumber-t.stateNumber;});},u.prototype.toString=function(e,t){return e=e||null,t=t||null,null===this.s0?"":new a(this,e,t).toString();},u.prototype.toLexerString=function(){return null===this.s0?"":new o(this).toString();},t.DFA=u;},function(e,t,n){var l=n(4);t.Trees=n(26).Trees,t.RuleNode=l.RuleNode,t.ParseTreeListener=l.ParseTreeListener,t.ParseTreeVisitor=l.ParseTreeVisitor,t.ParseTreeWalker=l.ParseTreeWalker;},function(e,t,n){t.RecognitionException=n(5).RecognitionException,t.NoViableAltException=n(5).NoViableAltException,t.LexerNoViableAltException=n(5).LexerNoViableAltException,t.InputMismatchException=n(5).InputMismatchException,t.FailedPredicateException=n(5).FailedPredicateException,t.DiagnosticErrorListener=n(62).DiagnosticErrorListener,t.BailErrorStrategy=n(35).BailErrorStrategy,t.ErrorListener=n(20).ErrorListener;},function(e,t,n){var l=n(0).BitSet,i=n(20).ErrorListener,r=n(2).Interval;function s(e){return i.call(this),e=e||!0,this.exactOnly=e,this;}s.prototype=Object.create(i.prototype),s.prototype.constructor=s,s.prototype.reportAmbiguity=function(e,t,n,l,i,s,a){if(!this.exactOnly||i){var o="reportAmbiguity d="+this.getDecisionDescription(e,t)+": ambigAlts="+this.getConflictingAlts(s,a)+", input='"+e.getTokenStream().getText(new r(n,l))+"'";e.notifyErrorListeners(o);}},s.prototype.reportAttemptingFullContext=function(e,t,n,l,i,s){var a="reportAttemptingFullContext d="+this.getDecisionDescription(e,t)+", input='"+e.getTokenStream().getText(new r(n,l))+"'";e.notifyErrorListeners(a);},s.prototype.reportContextSensitivity=function(e,t,n,l,i,s){var a="reportContextSensitivity d="+this.getDecisionDescription(e,t)+", input='"+e.getTokenStream().getText(new r(n,l))+"'";e.notifyErrorListeners(a);},s.prototype.getDecisionDescription=function(e,t){var n=t.decision,l=t.atnStartState.ruleIndex,i=e.ruleNames;if(l<0||l>=i.length)return""+n;var r=i[l]||null;return null===r||0===r.length?""+n:n+" ("+r+")";},s.prototype.getConflictingAlts=function(e,t){if(null!==e)return e;for(var n=new l(),i=0;i<t.items.length;i++){n.add(t.items[i].alt);}return"{"+n.values().join(", ")+"}";},t.DiagnosticErrorListener=s;},function(e,t,n){var l=n(1).Token;function i(e,t){return this.name="<empty>",this.strdata=e,this.decodeToUnicodeCodePoints=t||!1,function(e){if(e._index=0,e.data=[],e.decodeToUnicodeCodePoints)for(var t=0;t<e.strdata.length;){var n=e.strdata.codePointAt(t);e.data.push(n),t+=n<=65535?1:2;}else for(t=0;t<e.strdata.length;t++){var l=e.strdata.charCodeAt(t);e.data.push(l);}e._size=e.data.length;}(this),this;}n(33),n(34),Object.defineProperty(i.prototype,"index",{get:function get(){return this._index;}}),Object.defineProperty(i.prototype,"size",{get:function get(){return this._size;}}),i.prototype.reset=function(){this._index=0;},i.prototype.consume=function(){if(this._index>=this._size)throw"cannot consume EOF";this._index+=1;},i.prototype.LA=function(e){if(0===e)return 0;e<0&&(e+=1);var t=this._index+e-1;return t<0||t>=this._size?l.EOF:this.data[t];},i.prototype.LT=function(e){return this.LA(e);},i.prototype.mark=function(){return-1;},i.prototype.release=function(e){},i.prototype.seek=function(e){e<=this._index?this._index=e:this._index=Math.min(e,this._size);},i.prototype.getText=function(e,t){if(t>=this._size&&(t=this._size-1),e>=this._size)return"";if(this.decodeToUnicodeCodePoints){for(var n="",l=e;l<=t;l++){n+=String.fromCodePoint(this.data[l]);}return n;}return this.strdata.slice(e,t+1);},i.prototype.toString=function(){return this.strdata;},t.InputStream=i;},function(e,t,n){var l=n(1).Token,i=n(65).BufferedTokenStream;function r(e,t){return i.call(this,e),this.channel=void 0===t?l.DEFAULT_CHANNEL:t,this;}r.prototype=Object.create(i.prototype),r.prototype.constructor=r,r.prototype.adjustSeekIndex=function(e){return this.nextTokenOnChannel(e,this.channel);},r.prototype.LB=function(e){if(0===e||this.index-e<0)return null;for(var t=this.index,n=1;n<=e;){t=this.previousTokenOnChannel(t-1,this.channel),n+=1;}return t<0?null:this.tokens[t];},r.prototype.LT=function(e){if(this.lazyInit(),0===e)return null;if(e<0)return this.LB(-e);for(var t=this.index,n=1;n<e;){this.sync(t+1)&&(t=this.nextTokenOnChannel(t+1,this.channel)),n+=1;}return this.tokens[t];},r.prototype.getNumberOfOnChannelTokens=function(){var e=0;this.fill();for(var t=0;t<this.tokens.length;t++){var n=this.tokens[t];if(n.channel===this.channel&&(e+=1),n.type===l.EOF)break;}return e;},t.CommonTokenStream=r;},function(e,t,n){var l=n(1).Token,i=n(19).Lexer,r=n(2).Interval;function s(){return this;}function a(e){return s.call(this),this.tokenSource=e,this.tokens=[],this.index=-1,this.fetchedEOF=!1,this;}a.prototype=Object.create(s.prototype),a.prototype.constructor=a,a.prototype.mark=function(){return 0;},a.prototype.release=function(e){},a.prototype.reset=function(){this.seek(0);},a.prototype.seek=function(e){this.lazyInit(),this.index=this.adjustSeekIndex(e);},a.prototype.get=function(e){return this.lazyInit(),this.tokens[e];},a.prototype.consume=function(){if(!(this.index>=0&&(this.fetchedEOF?this.index<this.tokens.length-1:this.index<this.tokens.length))&&this.LA(1)===l.EOF)throw"cannot consume EOF";this.sync(this.index+1)&&(this.index=this.adjustSeekIndex(this.index+1));},a.prototype.sync=function(e){var t=e-this.tokens.length+1;return!(t>0)||this.fetch(t)>=t;},a.prototype.fetch=function(e){if(this.fetchedEOF)return 0;for(var t=0;t<e;t++){var n=this.tokenSource.nextToken();if(n.tokenIndex=this.tokens.length,this.tokens.push(n),n.type===l.EOF)return this.fetchedEOF=!0,t+1;}return e;},a.prototype.getTokens=function(e,t,n){if(void 0===n&&(n=null),e<0||t<0)return null;this.lazyInit();var i=[];t>=this.tokens.length&&(t=this.tokens.length-1);for(var r=e;r<t;r++){var s=this.tokens[r];if(s.type===l.EOF)break;(null===n||n.contains(s.type))&&i.push(s);}return i;},a.prototype.LA=function(e){return this.LT(e).type;},a.prototype.LB=function(e){return this.index-e<0?null:this.tokens[this.index-e];},a.prototype.LT=function(e){if(this.lazyInit(),0===e)return null;if(e<0)return this.LB(-e);var t=this.index+e-1;return this.sync(t),t>=this.tokens.length?this.tokens[this.tokens.length-1]:this.tokens[t];},a.prototype.adjustSeekIndex=function(e){return e;},a.prototype.lazyInit=function(){-1===this.index&&this.setup();},a.prototype.setup=function(){this.sync(0),this.index=this.adjustSeekIndex(0);},a.prototype.setTokenSource=function(e){this.tokenSource=e,this.tokens=[],this.index=-1,this.fetchedEOF=!1;},a.prototype.nextTokenOnChannel=function(e,t){if(this.sync(e),e>=this.tokens.length)return-1;for(var n=this.tokens[e];n.channel!==this.channel;){if(n.type===l.EOF)return-1;e+=1,this.sync(e),n=this.tokens[e];}return e;},a.prototype.previousTokenOnChannel=function(e,t){for(;e>=0&&this.tokens[e].channel!==t;){e-=1;}return e;},a.prototype.getHiddenTokensToRight=function(e,t){if(void 0===t&&(t=-1),this.lazyInit(),e<0||e>=this.tokens.length)throw e+" not in 0.."+this.tokens.length-1;var n=this.nextTokenOnChannel(e+1,i.DEFAULT_TOKEN_CHANNEL),l=e+1,r=-1===n?this.tokens.length-1:n;return this.filterForChannel(l,r,t);},a.prototype.getHiddenTokensToLeft=function(e,t){if(void 0===t&&(t=-1),this.lazyInit(),e<0||e>=this.tokens.length)throw e+" not in 0.."+this.tokens.length-1;var n=this.previousTokenOnChannel(e-1,i.DEFAULT_TOKEN_CHANNEL);if(n===e-1)return null;var l=n+1,r=e-1;return this.filterForChannel(l,r,t);},a.prototype.filterForChannel=function(e,t,n){for(var l=[],r=e;r<t+1;r++){var s=this.tokens[r];-1===n?s.channel!==i.DEFAULT_TOKEN_CHANNEL&&l.push(s):s.channel===n&&l.push(s);}return 0===l.length?null:l;},a.prototype.getSourceName=function(){return this.tokenSource.getSourceName();},a.prototype.getText=function(e){this.lazyInit(),this.fill(),null==e&&(e=new r(0,this.tokens.length-1));var t=e.start;t instanceof l&&(t=t.tokenIndex);var n=e.stop;if(n instanceof l&&(n=n.tokenIndex),null===t||null===n||t<0||n<0)return"";n>=this.tokens.length&&(n=this.tokens.length-1);for(var i="",s=t;s<n+1;s++){var a=this.tokens[s];if(a.type===l.EOF)break;i+=a.text;}return i;},a.prototype.fill=function(){for(this.lazyInit();1e3===this.fetch(1e3);){;}},t.BufferedTokenStream=a;},function(e,t,n){var l=n(1).Token,i=n(4).ParseTreeListener,r=n(30).Recognizer,s=n(35).DefaultErrorStrategy,a=n(27).ATNDeserializer,o=n(28).ATNDeserializationOptions,u=n(4).TerminalNode,c=n(4).ErrorNode;function f(e){return i.call(this),this.parser=e,this;}function m(e){return r.call(this),this._input=null,this._errHandler=new s(),this._precedenceStack=[],this._precedenceStack.push(0),this._ctx=null,this.buildParseTrees=!0,this._tracer=null,this._parseListeners=null,this._syntaxErrors=0,this.setInputStream(e),this;}f.prototype=Object.create(i.prototype),f.prototype.constructor=f,f.prototype.enterEveryRule=function(e){console.log("enter   "+this.parser.ruleNames[e.ruleIndex]+", LT(1)="+this.parser._input.LT(1).text);},f.prototype.visitTerminal=function(e){console.log("consume "+e.symbol+" rule "+this.parser.ruleNames[this.parser._ctx.ruleIndex]);},f.prototype.exitEveryRule=function(e){console.log("exit    "+this.parser.ruleNames[e.ruleIndex]+", LT(1)="+this.parser._input.LT(1).text);},m.prototype=Object.create(r.prototype),m.prototype.contructor=m,m.bypassAltsAtnCache={},m.prototype.reset=function(){null!==this._input&&this._input.seek(0),this._errHandler.reset(this),this._ctx=null,this._syntaxErrors=0,this.setTrace(!1),this._precedenceStack=[],this._precedenceStack.push(0),null!==this._interp&&this._interp.reset();},m.prototype.match=function(e){var t=this.getCurrentToken();return t.type===e?(this._errHandler.reportMatch(this),this.consume()):(t=this._errHandler.recoverInline(this),this.buildParseTrees&&-1===t.tokenIndex&&this._ctx.addErrorNode(t)),t;},m.prototype.matchWildcard=function(){var e=this.getCurrentToken();return e.type>0?(this._errHandler.reportMatch(this),this.consume()):(e=this._errHandler.recoverInline(this),this._buildParseTrees&&-1===e.tokenIndex&&this._ctx.addErrorNode(e)),e;},m.prototype.getParseListeners=function(){return this._parseListeners||[];},m.prototype.addParseListener=function(e){if(null===e)throw"listener";null===this._parseListeners&&(this._parseListeners=[]),this._parseListeners.push(e);},m.prototype.removeParseListener=function(e){if(null!==this._parseListeners){var t=this._parseListeners.indexOf(e);t>=0&&this._parseListeners.splice(t,1),0===this._parseListeners.length&&(this._parseListeners=null);}},m.prototype.removeParseListeners=function(){this._parseListeners=null;},m.prototype.triggerEnterRuleEvent=function(){if(null!==this._parseListeners){var e=this._ctx;this._parseListeners.map(function(t){t.enterEveryRule(e),e.enterRule(t);});}},m.prototype.triggerExitRuleEvent=function(){if(null!==this._parseListeners){var e=this._ctx;this._parseListeners.slice(0).reverse().map(function(t){e.exitRule(t),t.exitEveryRule(e);});}},m.prototype.getTokenFactory=function(){return this._input.tokenSource._factory;},m.prototype.setTokenFactory=function(e){this._input.tokenSource._factory=e;},m.prototype.getATNWithBypassAlts=function(){var e=this.getSerializedATN();if(null===e)throw"The current parser does not support an ATN with bypass alternatives.";var t=this.bypassAltsAtnCache[e];if(null===t){var n=new o();n.generateRuleBypassTransitions=!0,t=new a(n).deserialize(e),this.bypassAltsAtnCache[e]=t;}return t;};var p=n(19).Lexer;m.prototype.compileParseTreePattern=function(e,t,n){if(null===(n=n||null)&&null!==this.getTokenStream()){var l=this.getTokenStream().tokenSource;l instanceof p&&(n=l);}if(null===n)throw"Parser can't discover a lexer to use";return new ParseTreePatternMatcher(n,this).compile(e,t);},m.prototype.getInputStream=function(){return this.getTokenStream();},m.prototype.setInputStream=function(e){this.setTokenStream(e);},m.prototype.getTokenStream=function(){return this._input;},m.prototype.setTokenStream=function(e){this._input=null,this.reset(),this._input=e;},m.prototype.getCurrentToken=function(){return this._input.LT(1);},m.prototype.notifyErrorListeners=function(e,t,n){n=n||null,null===(t=t||null)&&(t=this.getCurrentToken()),this._syntaxErrors+=1;var l=t.line,i=t.column;this.getErrorListenerDispatch().syntaxError(this,t,l,i,e,n);},m.prototype.consume=function(){var e=this.getCurrentToken();e.type!==l.EOF&&this.getInputStream().consume();var t,n=null!==this._parseListeners&&this._parseListeners.length>0;(this.buildParseTrees||n)&&((t=this._errHandler.inErrorRecoveryMode(this)?this._ctx.addErrorNode(e):this._ctx.addTokenNode(e)).invokingState=this.state,n&&this._parseListeners.map(function(e){t instanceof c||void 0!==t.isErrorNode&&t.isErrorNode()?e.visitErrorNode(t):t instanceof u&&e.visitTerminal(t);}));return e;},m.prototype.addContextToParseTree=function(){null!==this._ctx.parentCtx&&this._ctx.parentCtx.addChild(this._ctx);},m.prototype.enterRule=function(e,t,n){this.state=t,this._ctx=e,this._ctx.start=this._input.LT(1),this.buildParseTrees&&this.addContextToParseTree(),null!==this._parseListeners&&this.triggerEnterRuleEvent();},m.prototype.exitRule=function(){this._ctx.stop=this._input.LT(-1),null!==this._parseListeners&&this.triggerExitRuleEvent(),this.state=this._ctx.invokingState,this._ctx=this._ctx.parentCtx;},m.prototype.enterOuterAlt=function(e,t){e.setAltNumber(t),this.buildParseTrees&&this._ctx!==e&&null!==this._ctx.parentCtx&&(this._ctx.parentCtx.removeLastChild(),this._ctx.parentCtx.addChild(e)),this._ctx=e;},m.prototype.getPrecedence=function(){return 0===this._precedenceStack.length?-1:this._precedenceStack[this._precedenceStack.length-1];},m.prototype.enterRecursionRule=function(e,t,n,l){this.state=t,this._precedenceStack.push(l),this._ctx=e,this._ctx.start=this._input.LT(1),null!==this._parseListeners&&this.triggerEnterRuleEvent();},m.prototype.pushNewRecursionContext=function(e,t,n){var l=this._ctx;l.parentCtx=e,l.invokingState=t,l.stop=this._input.LT(-1),this._ctx=e,this._ctx.start=l.start,this.buildParseTrees&&this._ctx.addChild(l),null!==this._parseListeners&&this.triggerEnterRuleEvent();},m.prototype.unrollRecursionContexts=function(e){this._precedenceStack.pop(),this._ctx.stop=this._input.LT(-1);var t=this._ctx;if(null!==this._parseListeners)for(;this._ctx!==e;){this.triggerExitRuleEvent(),this._ctx=this._ctx.parentCtx;}else this._ctx=e;t.parentCtx=e,this.buildParseTrees&&null!==e&&e.addChild(t);},m.prototype.getInvokingContext=function(e){for(var t=this._ctx;null!==t;){if(t.ruleIndex===e)return t;t=t.parentCtx;}return null;},m.prototype.precpred=function(e,t){return t>=this._precedenceStack[this._precedenceStack.length-1];},m.prototype.inContext=function(e){return!1;},m.prototype.isExpectedToken=function(e){var t=this._interp.atn,n=this._ctx,i=t.states[this.state],r=t.nextTokens(i);if(r.contains(e))return!0;if(!r.contains(l.EPSILON))return!1;for(;null!==n&&n.invokingState>=0&&r.contains(l.EPSILON);){var s=t.states[n.invokingState].transitions[0];if((r=t.nextTokens(s.followState)).contains(e))return!0;n=n.parentCtx;}return!(!r.contains(l.EPSILON)||e!==l.EOF);},m.prototype.getExpectedTokens=function(){return this._interp.atn.getExpectedTokens(this.state,this._ctx);},m.prototype.getExpectedTokensWithinCurrentRule=function(){var e=this._interp.atn,t=e.states[this.state];return e.nextTokens(t);},m.prototype.getRuleIndex=function(e){var t=this.getRuleIndexMap()[e];return null!==t?t:-1;},m.prototype.getRuleInvocationStack=function(e){null===(e=e||null)&&(e=this._ctx);for(var t=[];null!==e;){var n=e.ruleIndex;n<0?t.push("n/a"):t.push(this.ruleNames[n]),e=e.parentCtx;}return t;},m.prototype.getDFAStrings=function(){return this._interp.decisionToDFA.toString();},m.prototype.dumpDFA=function(){for(var e=!1,t=0;t<this._interp.decisionToDFA.length;t++){var n=this._interp.decisionToDFA[t];n.states.length>0&&(e&&console.log(),this.printer.println("Decision "+n.decision+":"),this.printer.print(n.toString(this.literalNames,this.symbolicNames)),e=!0);}},m.prototype.getSourceName=function(){return this._input.sourceName;},m.prototype.setTrace=function(e){e?(null!==this._tracer&&this.removeParseListener(this._tracer),this._tracer=new f(this),this.addParseListener(this._tracer)):(this.removeParseListener(this._tracer),this._tracer=null);},t.Parser=m;},function(e,t,n){var l=n(16),i=["悋Ꜫ脳맭䅼㯧瞆奤","Aȃ\b\t\t","\t\t\t\t","\b\t\b\t\t\t\n\t\n\v\t\v","\f\t\f\r\t\r\t\t","\t\t\t\t","\t\t\t","\t\t\t\t","\t\t\t",'\t\t \t !\t!"\t"#',"\t#$\t$%\t%&\t&'\t'(\t()\t)","*\t*+\t+,\t,-\t-.\t./\t/0\t0","1\t12\t23\t34\t45\t56\t67\t7","8\t89\t9:\t:;\t;<\t<=\t=>\t>","?\t?@\t@A\tAB\tBC\tCD\tD","","\b","\b\t\t\t\t\n\n\n\n","\v\v\f\f\r\r\r","","","","","","","","",""," ",' !!!!!"""','"""##$$$$$',"$%%%%%%%&","&&&&&&''((","((())))))*","****++++,,",",,,-------",".......///","/////////0","0000011111","1122222233","3334444445","5555555666","6666677777","7777777788","8888888888","88ƃ\n88ƅ\n88Ƈ\n888Ɗ","\n89999:::::","::::::ƚ\n:\r::ƛ",":ƞ\n::Ơ\n::Ƣ\n::::",":::::ƫ\n:;;Ʈ\n;",";;Ʊ\n;\f;;ƴ\v;<<<","<ƹ\n<\f<<Ƽ\v<<<==","==ǃ\n=\f==ǆ\v===>",">ǋ\n>\r>>ǌ>>>Ǒ\n>\r>>ǒ",">Ǖ\n>??ǘ\n?\r??Ǚ?","?@@@@@Ǣ\n@\f@@ǥ\v","@@@@@@AAAA","Aǰ\nA\fAAǳ\vAAABB","BBǺ\nBCCCCCCD","DǣE\t\v","\r\b\t\n\v\f\r","!#%')+","-/13579;= ?!A","\"C#E$G%I&K'M(O)Q*S+U,W-Y.[/]0_1a2c3e4g5i6k7m8o9q:su;w<y={>}","?@A\f","2;--//C\\aac|2;C\\aac|",'^^bb))\v\f""',"\f\f\n))11^^bbhhppttvv2;CHchȔ","","\t","\v\r","","","","","!","#%","')+","-/","13","57","9;","=?A","CE","GI","KM","OQ","SUW","Y[","]_","ac","eg","ikm","oq","uw","y{","}","","","\t\v","\r","","¡","£¦","¨ª","!­#°%³","'µ)·","+º-½","/À1É","3Í5Ð","7Ô9Ü;Þ","=à?â","AäCé","EïGñ","I÷Kþ","MąOćQČ","SĒUė","WěYĠ","[ħ]Į","_ĺaŀ","cŇeōgŒ","iŘkŠ","mŨoŵ","qƋsƏ","uƭwƵ","yƿ{Ǌ}Ǘ","ǝǫ","Ƕǻ","ȁ","0","]","_\b","-\n/","\f,","1","f","kx","o","qf"," ( ","¡¢~¢","£¤>¤¥","?¥¦§",">§¨©","@©ª«","@«¬?¬ ","­®k®¯u",'¯"°±c',"±²u²$³","´?´&µ¶","¶(·¸","#¸¹?¹*","º»#»¼","¼,½¾k","¾¿p¿.","ÀÁeÁÂqÂ","ÃpÃÄvÄÅ","cÅÆkÆÇ","pÇÈuÈ0","ÉÊcÊËp","ËÌfÌ2Í","ÎqÎÏtÏ4","ÐÑzÑÒ","qÒÓtÓ6","ÔÕkÕÖo","Ö×r×ØnØ","ÙkÙÚgÚÛ","uÛ8ÜÝ","*Ý:Þß+","ß<àá}","á>âã","ã@äåvå","ætæçwçè","gèBéê","hêëcëìn","ìíuíîg","îDïð'ð","Fñò&òó","vóôjôõ","kõöuöH","÷ø&øùk","ùúpúûfû","ügüýzýJ","þÿ&ÿĀ","vĀāqāĂv","ĂăcăĄn","ĄLąĆ.Ć","NćĈ{Ĉĉ","gĉĊcĊċ","tċPČčo","čĎqĎďp","ďĐvĐđjđ","RĒēyēĔ","gĔĕgĕĖ","mĖTėĘf","ĘęcęĚ{","ĚVěĜjĜ","ĝqĝĞwĞğ","tğXĠġ","oġĢkĢģp","ģĤwĤĥv","ĥĦgĦZħ","ĨuĨĩgĩĪ","eĪīqīĬ","pĬĭfĭ\\","Įįoįİk","İınıĲnĲ","ĳkĳĴuĴĵ","gĵĶeĶķ","qķĸpĸĹf","Ĺ^ĺĻ{","ĻļgļĽcĽ","ľtľĿuĿ`","ŀŁoŁł","qłŃpŃńv","ńŅjŅņu","ņbŇňyň","ŉgŉŊgŊŋ","mŋŌuŌd","ōŎfŎŏc","ŏŐ{Őőu","őfŒœjœ","ŔqŔŕwŕŖ","tŖŗuŗh","ŘřořŚk","ŚśpśŜw","ŜŝvŝŞgŞ","şuşjŠš","ušŢgŢţ","eţŤqŤťp","ťŦfŦŧu","ŧlŨũoũ","ŪkŪūnūŬ","nŬŭkŭŮ","uŮůgůŰe","ŰűqűŲp","ŲųfųŴuŴ","nŵŶBŶŷ","\tŷŸ\tŸŹ\t","ŹƆ\tźŻ/","Żż\tżƄ\t","Žž/žſ\tſ","Ƃ\tƀƁVƁƃ","s:ƂƀƂƃ","ƃƅƄŽ","ƄƅƅƇ","ƆźƆƇ","ƇƉƈƊ","\\ƉƈƉƊ","ƊpƋƌ","BƌƍVƍƎs:","ƎrƏƐ\tƐ","ơ\tƑƒ<ƒƓ","\tƓƟ\tƔƕ","<ƕƖ\tƖƝ\t","Ɨƙ0Ƙƚ\t","ƙƘƚƛ","ƛƙƛƜ","ƜƞƝƗ","ƝƞƞƠ","ƟƔƟƠ","ƠƢơƑ","ơƢƢƪ","ƣƫ\\Ƥƥ\tƥ","Ʀ\tƦƧ\tƧƨ","<ƨƩ\tƩƫ\t","ƪƣƪƤ","ƪƫƫt","ƬƮ\tƭƬ","ƮƲƯƱ\t","ưƯƱƴ","ƲưƲƳ","ƳvƴƲ","Ƶƺbƶƹ","BƷƹ\nƸƶ","ƸƷƹƼ","ƺƸƺƻ","ƻƽƼƺ","ƽƾbƾx","ƿǄ)ǀǃBǁ","ǃ\nǂǀǂ","ǁǃǆǄ","ǂǄǅǅ","ǇǆǄǇ","ǈ)ǈzǉǋ","\tǊǉǋǌ","ǌǊǌǍ","Ǎǔǎǐ","0ǏǑ\tǐǏ","Ǒǒǒǐ","ǒǓǓǕ","ǔǎǔǕ","Ǖ|ǖǘ\t\b","ǗǖǘǙ","ǙǗǙǚ","ǚǛǛǜ\b?","ǜ~ǝǞ1Ǟ","ǟ,ǟǣǠ","Ǣ\vǡǠǢ","ǥǣǤǣ","ǡǤǦǥ","ǣǦǧ,ǧ","Ǩ1Ǩǩǩ","Ǫ\b@ǪǫǬ","1Ǭǭ1ǭǱ","Ǯǰ\n\tǯǮ","ǰǳǱǯ","ǱǲǲǴ","ǳǱǴǵ\bA","ǵǶǹ^","ǷǺ\t\nǸǺCǹ","ǷǹǸǺ","ǻǼwǼ","ǽDǽǾDǾǿ","DǿȀDȀ","ȁȂ\t\vȂ","ƂƄƆƉƛƝƟ","ơƪƭưƲƸƺǂǄǌǒǔ","ǙǣǱǹ"].join(""),r=new l.atn.ATNDeserializer().deserialize(i),s=r.decisionToState.map(function(e,t){return new l.dfa.DFA(e,t);});function a(e){return l.Lexer.call(this,e),this._interp=new l.atn.LexerATNSimulator(this,r,s,new l.PredictionContextCache()),this;}a.prototype=Object.create(l.Lexer.prototype),a.prototype.constructor=a,Object.defineProperty(a.prototype,"atn",{get:function get(){return r;}}),a.EOF=l.Token.EOF,a.T__0=1,a.T__1=2,a.T__2=3,a.T__3=4,a.T__4=5,a.T__5=6,a.T__6=7,a.T__7=8,a.T__8=9,a.T__9=10,a.T__10=11,a.T__11=12,a.T__12=13,a.T__13=14,a.T__14=15,a.T__15=16,a.T__16=17,a.T__17=18,a.T__18=19,a.T__19=20,a.T__20=21,a.T__21=22,a.T__22=23,a.T__23=24,a.T__24=25,a.T__25=26,a.T__26=27,a.T__27=28,a.T__28=29,a.T__29=30,a.T__30=31,a.T__31=32,a.T__32=33,a.T__33=34,a.T__34=35,a.T__35=36,a.T__36=37,a.T__37=38,a.T__38=39,a.T__39=40,a.T__40=41,a.T__41=42,a.T__42=43,a.T__43=44,a.T__44=45,a.T__45=46,a.T__46=47,a.T__47=48,a.T__48=49,a.T__49=50,a.T__50=51,a.T__51=52,a.T__52=53,a.T__53=54,a.DATETIME=55,a.TIME=56,a.IDENTIFIER=57,a.DELIMITEDIDENTIFIER=58,a.STRING=59,a.NUMBER=60,a.WS=61,a.COMMENT=62,a.LINE_COMMENT=63,a.prototype.channelNames=["DEFAULT_TOKEN_CHANNEL","HIDDEN"],a.prototype.modeNames=["DEFAULT_MODE"],a.prototype.literalNames=[null,"'.'","'['","']'","'+'","'-'","'*'","'/'","'div'","'mod'","'&'","'|'","'<='","'<'","'>'","'>='","'is'","'as'","'='","'~'","'!='","'!~'","'in'","'contains'","'and'","'or'","'xor'","'implies'","'('","')'","'{'","'}'","'true'","'false'","'%'","'$this'","'$index'","'$total'","','","'year'","'month'","'week'","'day'","'hour'","'minute'","'second'","'millisecond'","'years'","'months'","'weeks'","'days'","'hours'","'minutes'","'seconds'","'milliseconds'"],a.prototype.symbolicNames=[null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,"DATETIME","TIME","IDENTIFIER","DELIMITEDIDENTIFIER","STRING","NUMBER","WS","COMMENT","LINE_COMMENT"],a.prototype.ruleNames=["T__0","T__1","T__2","T__3","T__4","T__5","T__6","T__7","T__8","T__9","T__10","T__11","T__12","T__13","T__14","T__15","T__16","T__17","T__18","T__19","T__20","T__21","T__22","T__23","T__24","T__25","T__26","T__27","T__28","T__29","T__30","T__31","T__32","T__33","T__34","T__35","T__36","T__37","T__38","T__39","T__40","T__41","T__42","T__43","T__44","T__45","T__46","T__47","T__48","T__49","T__50","T__51","T__52","T__53","DATETIME","TIME","TIMEFORMAT","IDENTIFIER","DELIMITEDIDENTIFIER","STRING","NUMBER","WS","COMMENT","LINE_COMMENT","ESC","UNICODE","HEX"],a.prototype.grammarFileName="FHIRPath.g4",t.FHIRPathLexer=a;},function(e,t,n){var l=n(16),i=n(36).FHIRPathListener,r=["悋Ꜫ脳맭䅼㯧瞆奤","A\t\t\t","\t\t\t","\b\t\b\t\t\t\n\t\n\v\t\v\f\t\f","\r\t\r\t\t","#\n","","","","","","","K\n\fN\v","","W\n","a\n","f\n","m\n","r\n","\b\b\b\by\n\b\f\b\b|\v\b","\t\t\t\n\t\n\n\n\n\n","\n\v\v\f\f\r\r","\n\f","\v","\b\n\f","\b\v","\f\f","",'"#)018',';<©"V',"`\bb","\nl\fnu","}","","","","\b# !\t",'!#\r"" ',"#L$%\f\f%&\t","&K\r'(\f\v()\t",")K\f*+\f\n+,\r",",K\v-.\f\t./\t","/K\n01\f12\t2","K\b34\f45\t5K","67\f78","8K9:\f:;\t\b;","K<=\f=>",">K?@\f@A","AK\nBC\fCD","DEEFFK","GH\f\bHI\t\tIK","\rJ$J'J*","J-J0","J3J6J9","J<J?JB","JGKNLJ","LMM","NLOW\nPW","QW\bRSST","TUUW","VOVPVQ","VRWXY"," Ya!Za\t\n[a=","\\a>]a9^a:","_a\t`X`Z","`[`\\`]","`^`_","abe$cf","df=eced","f\tgmhm","\fim%jm&km","'lglhl","iljlk","m\vnooq","pr\bqpq","rrsst","t\ruzvw","(wyxvy|","zxz{","{|z}",">~\n~","","\v\f","=","","\t\v","\t\f","","","","","","","\t\r",'"JLV`elqz'].join(""),s=new l.atn.ATNDeserializer().deserialize(r),a=s.decisionToState.map(function(e,t){return new l.dfa.DFA(e,t);}),o=new l.PredictionContextCache(),u=[null,"'.'","'['","']'","'+'","'-'","'*'","'/'","'div'","'mod'","'&'","'|'","'<='","'<'","'>'","'>='","'is'","'as'","'='","'~'","'!='","'!~'","'in'","'contains'","'and'","'or'","'xor'","'implies'","'('","')'","'{'","'}'","'true'","'false'","'%'","'$this'","'$index'","'$total'","','","'year'","'month'","'week'","'day'","'hour'","'minute'","'second'","'millisecond'","'years'","'months'","'weeks'","'days'","'hours'","'minutes'","'seconds'","'milliseconds'"],c=[null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,null,"DATETIME","TIME","IDENTIFIER","DELIMITEDIDENTIFIER","STRING","NUMBER","WS","COMMENT","LINE_COMMENT"],f=["expression","term","literal","externalConstant","invocation","functn","paramList","quantity","unit","dateTimePrecision","pluralDateTimePrecision","typeSpecifier","qualifiedIdentifier","identifier"];function m(e){return l.Parser.call(this,e),this._interp=new l.atn.ParserATNSimulator(this,s,a,o),this.ruleNames=f,this.literalNames=u,this.symbolicNames=c,this;}function p(e,t,n){return void 0===t&&(t=null),null==n&&(n=-1),l.ParserRuleContext.call(this,t,n),this.parser=e,this.ruleIndex=m.RULE_expression,this;}function h(e,t){return p.call(this,e),p.prototype.copyFrom.call(this,t),this;}function d(e,t){return p.call(this,e),p.prototype.copyFrom.call(this,t),this;}function g(e,t){return p.call(this,e),p.prototype.copyFrom.call(this,t),this;}function y(e,t){return p.call(this,e),p.prototype.copyFrom.call(this,t),this;}function C(e,t){return p.call(this,e),p.prototype.copyFrom.call(this,t),this;}function _(e,t){return p.call(this,e),p.prototype.copyFrom.call(this,t),this;}function v(e,t){return p.call(this,e),p.prototype.copyFrom.call(this,t),this;}function L(e,t){return p.call(this,e),p.prototype.copyFrom.call(this,t),this;}function b(e,t){return p.call(this,e),p.prototype.copyFrom.call(this,t),this;}function U(e,t){return p.call(this,e),p.prototype.copyFrom.call(this,t),this;}function T(e,t){return p.call(this,e),p.prototype.copyFrom.call(this,t),this;}function M(e,t){return p.call(this,e),p.prototype.copyFrom.call(this,t),this;}function x(e,t){return p.call(this,e),p.prototype.copyFrom.call(this,t),this;}function S(e,t){return p.call(this,e),p.prototype.copyFrom.call(this,t),this;}function I(e,t,n){return void 0===t&&(t=null),null==n&&(n=-1),l.ParserRuleContext.call(this,t,n),this.parser=e,this.ruleIndex=m.RULE_term,this;}function N(e,t){return I.call(this,e),I.prototype.copyFrom.call(this,t),this;}function O(e,t){return I.call(this,e),I.prototype.copyFrom.call(this,t),this;}function E(e,t){return I.call(this,e),I.prototype.copyFrom.call(this,t),this;}function k(e,t){return I.call(this,e),I.prototype.copyFrom.call(this,t),this;}function A(e,t,n){return void 0===t&&(t=null),null==n&&(n=-1),l.ParserRuleContext.call(this,t,n),this.parser=e,this.ruleIndex=m.RULE_literal,this;}function R(e,t){return A.call(this,e),A.prototype.copyFrom.call(this,t),this;}function w(e,t){return A.call(this,e),A.prototype.copyFrom.call(this,t),this;}function P(e,t){return A.call(this,e),A.prototype.copyFrom.call(this,t),this;}function D(e,t){return A.call(this,e),A.prototype.copyFrom.call(this,t),this;}function F(e,t){return A.call(this,e),A.prototype.copyFrom.call(this,t),this;}function q(e,t){return A.call(this,e),A.prototype.copyFrom.call(this,t),this;}function B(e,t){return A.call(this,e),A.prototype.copyFrom.call(this,t),this;}function H(e,t,n){return void 0===t&&(t=null),null==n&&(n=-1),l.ParserRuleContext.call(this,t,n),this.parser=e,this.ruleIndex=m.RULE_externalConstant,this;}function z(e,t,n){return void 0===t&&(t=null),null==n&&(n=-1),l.ParserRuleContext.call(this,t,n),this.parser=e,this.ruleIndex=m.RULE_invocation,this;}function G(e,t){return z.call(this,e),z.prototype.copyFrom.call(this,t),this;}function V(e,t){return z.call(this,e),z.prototype.copyFrom.call(this,t),this;}function j(e,t){return z.call(this,e),z.prototype.copyFrom.call(this,t),this;}function K(e,t){return z.call(this,e),z.prototype.copyFrom.call(this,t),this;}function W(e,t){return z.call(this,e),z.prototype.copyFrom.call(this,t),this;}function J(e,t,n){return void 0===t&&(t=null),null==n&&(n=-1),l.ParserRuleContext.call(this,t,n),this.parser=e,this.ruleIndex=m.RULE_functn,this;}function Y(e,t,n){return void 0===t&&(t=null),null==n&&(n=-1),l.ParserRuleContext.call(this,t,n),this.parser=e,this.ruleIndex=m.RULE_paramList,this;}function Q(e,t,n){return void 0===t&&(t=null),null==n&&(n=-1),l.ParserRuleContext.call(this,t,n),this.parser=e,this.ruleIndex=m.RULE_quantity,this;}function $(e,t,n){return void 0===t&&(t=null),null==n&&(n=-1),l.ParserRuleContext.call(this,t,n),this.parser=e,this.ruleIndex=m.RULE_unit,this;}function X(e,t,n){return void 0===t&&(t=null),null==n&&(n=-1),l.ParserRuleContext.call(this,t,n),this.parser=e,this.ruleIndex=m.RULE_dateTimePrecision,this;}function Z(e,t,n){return void 0===t&&(t=null),null==n&&(n=-1),l.ParserRuleContext.call(this,t,n),this.parser=e,this.ruleIndex=m.RULE_pluralDateTimePrecision,this;}function ee(e,t,n){return void 0===t&&(t=null),null==n&&(n=-1),l.ParserRuleContext.call(this,t,n),this.parser=e,this.ruleIndex=m.RULE_typeSpecifier,this;}function te(e,t,n){return void 0===t&&(t=null),null==n&&(n=-1),l.ParserRuleContext.call(this,t,n),this.parser=e,this.ruleIndex=m.RULE_qualifiedIdentifier,this;}function ne(e,t,n){return void 0===t&&(t=null),null==n&&(n=-1),l.ParserRuleContext.call(this,t,n),this.parser=e,this.ruleIndex=m.RULE_identifier,this;}m.prototype=Object.create(l.Parser.prototype),m.prototype.constructor=m,Object.defineProperty(m.prototype,"atn",{get:function get(){return s;}}),m.EOF=l.Token.EOF,m.T__0=1,m.T__1=2,m.T__2=3,m.T__3=4,m.T__4=5,m.T__5=6,m.T__6=7,m.T__7=8,m.T__8=9,m.T__9=10,m.T__10=11,m.T__11=12,m.T__12=13,m.T__13=14,m.T__14=15,m.T__15=16,m.T__16=17,m.T__17=18,m.T__18=19,m.T__19=20,m.T__20=21,m.T__21=22,m.T__22=23,m.T__23=24,m.T__24=25,m.T__25=26,m.T__26=27,m.T__27=28,m.T__28=29,m.T__29=30,m.T__30=31,m.T__31=32,m.T__32=33,m.T__33=34,m.T__34=35,m.T__35=36,m.T__36=37,m.T__37=38,m.T__38=39,m.T__39=40,m.T__40=41,m.T__41=42,m.T__42=43,m.T__43=44,m.T__44=45,m.T__45=46,m.T__46=47,m.T__47=48,m.T__48=49,m.T__49=50,m.T__50=51,m.T__51=52,m.T__52=53,m.T__53=54,m.DATETIME=55,m.TIME=56,m.IDENTIFIER=57,m.DELIMITEDIDENTIFIER=58,m.STRING=59,m.NUMBER=60,m.WS=61,m.COMMENT=62,m.LINE_COMMENT=63,m.RULE_expression=0,m.RULE_term=1,m.RULE_literal=2,m.RULE_externalConstant=3,m.RULE_invocation=4,m.RULE_functn=5,m.RULE_paramList=6,m.RULE_quantity=7,m.RULE_unit=8,m.RULE_dateTimePrecision=9,m.RULE_pluralDateTimePrecision=10,m.RULE_typeSpecifier=11,m.RULE_qualifiedIdentifier=12,m.RULE_identifier=13,p.prototype=Object.create(l.ParserRuleContext.prototype),p.prototype.constructor=p,p.prototype.copyFrom=function(e){l.ParserRuleContext.prototype.copyFrom.call(this,e);},h.prototype=Object.create(p.prototype),h.prototype.constructor=h,m.IndexerExpressionContext=h,h.prototype.expression=function(e){return void 0===e&&(e=null),null===e?this.getTypedRuleContexts(p):this.getTypedRuleContext(p,e);},h.prototype.enterRule=function(e){e instanceof i&&e.enterIndexerExpression(this);},h.prototype.exitRule=function(e){e instanceof i&&e.exitIndexerExpression(this);},d.prototype=Object.create(p.prototype),d.prototype.constructor=d,m.PolarityExpressionContext=d,d.prototype.expression=function(){return this.getTypedRuleContext(p,0);},d.prototype.enterRule=function(e){e instanceof i&&e.enterPolarityExpression(this);},d.prototype.exitRule=function(e){e instanceof i&&e.exitPolarityExpression(this);},g.prototype=Object.create(p.prototype),g.prototype.constructor=g,m.AdditiveExpressionContext=g,g.prototype.expression=function(e){return void 0===e&&(e=null),null===e?this.getTypedRuleContexts(p):this.getTypedRuleContext(p,e);},g.prototype.enterRule=function(e){e instanceof i&&e.enterAdditiveExpression(this);},g.prototype.exitRule=function(e){e instanceof i&&e.exitAdditiveExpression(this);},y.prototype=Object.create(p.prototype),y.prototype.constructor=y,m.MultiplicativeExpressionContext=y,y.prototype.expression=function(e){return void 0===e&&(e=null),null===e?this.getTypedRuleContexts(p):this.getTypedRuleContext(p,e);},y.prototype.enterRule=function(e){e instanceof i&&e.enterMultiplicativeExpression(this);},y.prototype.exitRule=function(e){e instanceof i&&e.exitMultiplicativeExpression(this);},C.prototype=Object.create(p.prototype),C.prototype.constructor=C,m.UnionExpressionContext=C,C.prototype.expression=function(e){return void 0===e&&(e=null),null===e?this.getTypedRuleContexts(p):this.getTypedRuleContext(p,e);},C.prototype.enterRule=function(e){e instanceof i&&e.enterUnionExpression(this);},C.prototype.exitRule=function(e){e instanceof i&&e.exitUnionExpression(this);},_.prototype=Object.create(p.prototype),_.prototype.constructor=_,m.OrExpressionContext=_,_.prototype.expression=function(e){return void 0===e&&(e=null),null===e?this.getTypedRuleContexts(p):this.getTypedRuleContext(p,e);},_.prototype.enterRule=function(e){e instanceof i&&e.enterOrExpression(this);},_.prototype.exitRule=function(e){e instanceof i&&e.exitOrExpression(this);},v.prototype=Object.create(p.prototype),v.prototype.constructor=v,m.AndExpressionContext=v,v.prototype.expression=function(e){return void 0===e&&(e=null),null===e?this.getTypedRuleContexts(p):this.getTypedRuleContext(p,e);},v.prototype.enterRule=function(e){e instanceof i&&e.enterAndExpression(this);},v.prototype.exitRule=function(e){e instanceof i&&e.exitAndExpression(this);},L.prototype=Object.create(p.prototype),L.prototype.constructor=L,m.MembershipExpressionContext=L,L.prototype.expression=function(e){return void 0===e&&(e=null),null===e?this.getTypedRuleContexts(p):this.getTypedRuleContext(p,e);},L.prototype.enterRule=function(e){e instanceof i&&e.enterMembershipExpression(this);},L.prototype.exitRule=function(e){e instanceof i&&e.exitMembershipExpression(this);},b.prototype=Object.create(p.prototype),b.prototype.constructor=b,m.InequalityExpressionContext=b,b.prototype.expression=function(e){return void 0===e&&(e=null),null===e?this.getTypedRuleContexts(p):this.getTypedRuleContext(p,e);},b.prototype.enterRule=function(e){e instanceof i&&e.enterInequalityExpression(this);},b.prototype.exitRule=function(e){e instanceof i&&e.exitInequalityExpression(this);},U.prototype=Object.create(p.prototype),U.prototype.constructor=U,m.InvocationExpressionContext=U,U.prototype.expression=function(){return this.getTypedRuleContext(p,0);},U.prototype.invocation=function(){return this.getTypedRuleContext(z,0);},U.prototype.enterRule=function(e){e instanceof i&&e.enterInvocationExpression(this);},U.prototype.exitRule=function(e){e instanceof i&&e.exitInvocationExpression(this);},T.prototype=Object.create(p.prototype),T.prototype.constructor=T,m.EqualityExpressionContext=T,T.prototype.expression=function(e){return void 0===e&&(e=null),null===e?this.getTypedRuleContexts(p):this.getTypedRuleContext(p,e);},T.prototype.enterRule=function(e){e instanceof i&&e.enterEqualityExpression(this);},T.prototype.exitRule=function(e){e instanceof i&&e.exitEqualityExpression(this);},M.prototype=Object.create(p.prototype),M.prototype.constructor=M,m.ImpliesExpressionContext=M,M.prototype.expression=function(e){return void 0===e&&(e=null),null===e?this.getTypedRuleContexts(p):this.getTypedRuleContext(p,e);},M.prototype.enterRule=function(e){e instanceof i&&e.enterImpliesExpression(this);},M.prototype.exitRule=function(e){e instanceof i&&e.exitImpliesExpression(this);},x.prototype=Object.create(p.prototype),x.prototype.constructor=x,m.TermExpressionContext=x,x.prototype.term=function(){return this.getTypedRuleContext(I,0);},x.prototype.enterRule=function(e){e instanceof i&&e.enterTermExpression(this);},x.prototype.exitRule=function(e){e instanceof i&&e.exitTermExpression(this);},S.prototype=Object.create(p.prototype),S.prototype.constructor=S,m.TypeExpressionContext=S,S.prototype.expression=function(){return this.getTypedRuleContext(p,0);},S.prototype.typeSpecifier=function(){return this.getTypedRuleContext(ee,0);},S.prototype.enterRule=function(e){e instanceof i&&e.enterTypeExpression(this);},S.prototype.exitRule=function(e){e instanceof i&&e.exitTypeExpression(this);},m.prototype.expression=function(e){void 0===e&&(e=0);var t=this._ctx,n=this.state,i=new p(this,this._ctx,n);this.enterRecursionRule(i,0,m.RULE_expression,e);var r=0;try{switch(this.enterOuterAlt(i,1),this.state=32,this._errHandler.sync(this),this._input.LA(1)){case m.T__15:case m.T__16:case m.T__21:case m.T__22:case m.T__27:case m.T__29:case m.T__31:case m.T__32:case m.T__33:case m.T__34:case m.T__35:case m.T__36:case m.DATETIME:case m.TIME:case m.IDENTIFIER:case m.DELIMITEDIDENTIFIER:case m.STRING:case m.NUMBER:i=new x(this,i),this._ctx=i,i,this.state=29,this.term();break;case m.T__3:case m.T__4:i=new d(this,i),this._ctx=i,i,this.state=30,(r=this._input.LA(1))!==m.T__3&&r!==m.T__4?this._errHandler.recoverInline(this):(this._errHandler.reportMatch(this),this.consume()),this.state=31,this.expression(11);break;default:throw new l.error.NoViableAltException(this);}this._ctx.stop=this._input.LT(-1),this.state=74,this._errHandler.sync(this);for(var s=this._interp.adaptivePredict(this._input,2,this._ctx);2!=s&&s!=l.atn.ATN.INVALID_ALT_NUMBER;){if(1===s)switch(null!==this._parseListeners&&this.triggerExitRuleEvent(),i,this.state=72,this._errHandler.sync(this),this._interp.adaptivePredict(this._input,1,this._ctx)){case 1:if(i=new y(this,new p(this,t,n)),this.pushNewRecursionContext(i,0,m.RULE_expression),this.state=34,!this.precpred(this._ctx,10))throw new l.error.FailedPredicateException(this,"this.precpred(this._ctx, 10)");this.state=35,0!=(-32&(r=this._input.LA(1)))||0==(1<<r&(1<<m.T__5|1<<m.T__6|1<<m.T__7|1<<m.T__8))?this._errHandler.recoverInline(this):(this._errHandler.reportMatch(this),this.consume()),this.state=36,this.expression(11);break;case 2:if(i=new g(this,new p(this,t,n)),this.pushNewRecursionContext(i,0,m.RULE_expression),this.state=37,!this.precpred(this._ctx,9))throw new l.error.FailedPredicateException(this,"this.precpred(this._ctx, 9)");this.state=38,0!=(-32&(r=this._input.LA(1)))||0==(1<<r&(1<<m.T__3|1<<m.T__4|1<<m.T__9))?this._errHandler.recoverInline(this):(this._errHandler.reportMatch(this),this.consume()),this.state=39,this.expression(10);break;case 3:if(i=new C(this,new p(this,t,n)),this.pushNewRecursionContext(i,0,m.RULE_expression),this.state=40,!this.precpred(this._ctx,8))throw new l.error.FailedPredicateException(this,"this.precpred(this._ctx, 8)");this.state=41,this.match(m.T__10),this.state=42,this.expression(9);break;case 4:if(i=new b(this,new p(this,t,n)),this.pushNewRecursionContext(i,0,m.RULE_expression),this.state=43,!this.precpred(this._ctx,7))throw new l.error.FailedPredicateException(this,"this.precpred(this._ctx, 7)");this.state=44,0!=(-32&(r=this._input.LA(1)))||0==(1<<r&(1<<m.T__11|1<<m.T__12|1<<m.T__13|1<<m.T__14))?this._errHandler.recoverInline(this):(this._errHandler.reportMatch(this),this.consume()),this.state=45,this.expression(8);break;case 5:if(i=new T(this,new p(this,t,n)),this.pushNewRecursionContext(i,0,m.RULE_expression),this.state=46,!this.precpred(this._ctx,5))throw new l.error.FailedPredicateException(this,"this.precpred(this._ctx, 5)");this.state=47,0!=(-32&(r=this._input.LA(1)))||0==(1<<r&(1<<m.T__17|1<<m.T__18|1<<m.T__19|1<<m.T__20))?this._errHandler.recoverInline(this):(this._errHandler.reportMatch(this),this.consume()),this.state=48,this.expression(6);break;case 6:if(i=new L(this,new p(this,t,n)),this.pushNewRecursionContext(i,0,m.RULE_expression),this.state=49,!this.precpred(this._ctx,4))throw new l.error.FailedPredicateException(this,"this.precpred(this._ctx, 4)");this.state=50,(r=this._input.LA(1))!==m.T__21&&r!==m.T__22?this._errHandler.recoverInline(this):(this._errHandler.reportMatch(this),this.consume()),this.state=51,this.expression(5);break;case 7:if(i=new v(this,new p(this,t,n)),this.pushNewRecursionContext(i,0,m.RULE_expression),this.state=52,!this.precpred(this._ctx,3))throw new l.error.FailedPredicateException(this,"this.precpred(this._ctx, 3)");this.state=53,this.match(m.T__23),this.state=54,this.expression(4);break;case 8:if(i=new _(this,new p(this,t,n)),this.pushNewRecursionContext(i,0,m.RULE_expression),this.state=55,!this.precpred(this._ctx,2))throw new l.error.FailedPredicateException(this,"this.precpred(this._ctx, 2)");this.state=56,(r=this._input.LA(1))!==m.T__24&&r!==m.T__25?this._errHandler.recoverInline(this):(this._errHandler.reportMatch(this),this.consume()),this.state=57,this.expression(3);break;case 9:if(i=new M(this,new p(this,t,n)),this.pushNewRecursionContext(i,0,m.RULE_expression),this.state=58,!this.precpred(this._ctx,1))throw new l.error.FailedPredicateException(this,"this.precpred(this._ctx, 1)");this.state=59,this.match(m.T__26),this.state=60,this.expression(2);break;case 10:if(i=new U(this,new p(this,t,n)),this.pushNewRecursionContext(i,0,m.RULE_expression),this.state=61,!this.precpred(this._ctx,13))throw new l.error.FailedPredicateException(this,"this.precpred(this._ctx, 13)");this.state=62,this.match(m.T__0),this.state=63,this.invocation();break;case 11:if(i=new h(this,new p(this,t,n)),this.pushNewRecursionContext(i,0,m.RULE_expression),this.state=64,!this.precpred(this._ctx,12))throw new l.error.FailedPredicateException(this,"this.precpred(this._ctx, 12)");this.state=65,this.match(m.T__1),this.state=66,this.expression(0),this.state=67,this.match(m.T__2);break;case 12:if(i=new S(this,new p(this,t,n)),this.pushNewRecursionContext(i,0,m.RULE_expression),this.state=69,!this.precpred(this._ctx,6))throw new l.error.FailedPredicateException(this,"this.precpred(this._ctx, 6)");this.state=70,(r=this._input.LA(1))!==m.T__15&&r!==m.T__16?this._errHandler.recoverInline(this):(this._errHandler.reportMatch(this),this.consume()),this.state=71,this.typeSpecifier();}this.state=76,this._errHandler.sync(this),s=this._interp.adaptivePredict(this._input,2,this._ctx);}}catch(e){if(!(e instanceof l.error.RecognitionException))throw e;i.exception=e,this._errHandler.reportError(this,e),this._errHandler.recover(this,e);}finally{this.unrollRecursionContexts(t);}return i;},I.prototype=Object.create(l.ParserRuleContext.prototype),I.prototype.constructor=I,I.prototype.copyFrom=function(e){l.ParserRuleContext.prototype.copyFrom.call(this,e);},N.prototype=Object.create(I.prototype),N.prototype.constructor=N,m.ExternalConstantTermContext=N,N.prototype.externalConstant=function(){return this.getTypedRuleContext(H,0);},N.prototype.enterRule=function(e){e instanceof i&&e.enterExternalConstantTerm(this);},N.prototype.exitRule=function(e){e instanceof i&&e.exitExternalConstantTerm(this);},O.prototype=Object.create(I.prototype),O.prototype.constructor=O,m.LiteralTermContext=O,O.prototype.literal=function(){return this.getTypedRuleContext(A,0);},O.prototype.enterRule=function(e){e instanceof i&&e.enterLiteralTerm(this);},O.prototype.exitRule=function(e){e instanceof i&&e.exitLiteralTerm(this);},E.prototype=Object.create(I.prototype),E.prototype.constructor=E,m.ParenthesizedTermContext=E,E.prototype.expression=function(){return this.getTypedRuleContext(p,0);},E.prototype.enterRule=function(e){e instanceof i&&e.enterParenthesizedTerm(this);},E.prototype.exitRule=function(e){e instanceof i&&e.exitParenthesizedTerm(this);},k.prototype=Object.create(I.prototype),k.prototype.constructor=k,m.InvocationTermContext=k,k.prototype.invocation=function(){return this.getTypedRuleContext(z,0);},k.prototype.enterRule=function(e){e instanceof i&&e.enterInvocationTerm(this);},k.prototype.exitRule=function(e){e instanceof i&&e.exitInvocationTerm(this);},m.TermContext=I,m.prototype.term=function(){var e=new I(this,this._ctx,this.state);this.enterRule(e,2,m.RULE_term);try{switch(this.state=84,this._errHandler.sync(this),this._input.LA(1)){case m.T__15:case m.T__16:case m.T__21:case m.T__22:case m.T__34:case m.T__35:case m.T__36:case m.IDENTIFIER:case m.DELIMITEDIDENTIFIER:e=new k(this,e),this.enterOuterAlt(e,1),this.state=77,this.invocation();break;case m.T__29:case m.T__31:case m.T__32:case m.DATETIME:case m.TIME:case m.STRING:case m.NUMBER:e=new O(this,e),this.enterOuterAlt(e,2),this.state=78,this.literal();break;case m.T__33:e=new N(this,e),this.enterOuterAlt(e,3),this.state=79,this.externalConstant();break;case m.T__27:e=new E(this,e),this.enterOuterAlt(e,4),this.state=80,this.match(m.T__27),this.state=81,this.expression(0),this.state=82,this.match(m.T__28);break;default:throw new l.error.NoViableAltException(this);}}catch(t){if(!(t instanceof l.error.RecognitionException))throw t;e.exception=t,this._errHandler.reportError(this,t),this._errHandler.recover(this,t);}finally{this.exitRule();}return e;},A.prototype=Object.create(l.ParserRuleContext.prototype),A.prototype.constructor=A,A.prototype.copyFrom=function(e){l.ParserRuleContext.prototype.copyFrom.call(this,e);},R.prototype=Object.create(A.prototype),R.prototype.constructor=R,m.TimeLiteralContext=R,R.prototype.TIME=function(){return this.getToken(m.TIME,0);},R.prototype.enterRule=function(e){e instanceof i&&e.enterTimeLiteral(this);},R.prototype.exitRule=function(e){e instanceof i&&e.exitTimeLiteral(this);},w.prototype=Object.create(A.prototype),w.prototype.constructor=w,m.NullLiteralContext=w,w.prototype.enterRule=function(e){e instanceof i&&e.enterNullLiteral(this);},w.prototype.exitRule=function(e){e instanceof i&&e.exitNullLiteral(this);},P.prototype=Object.create(A.prototype),P.prototype.constructor=P,m.DateTimeLiteralContext=P,P.prototype.DATETIME=function(){return this.getToken(m.DATETIME,0);},P.prototype.enterRule=function(e){e instanceof i&&e.enterDateTimeLiteral(this);},P.prototype.exitRule=function(e){e instanceof i&&e.exitDateTimeLiteral(this);},D.prototype=Object.create(A.prototype),D.prototype.constructor=D,m.StringLiteralContext=D,D.prototype.STRING=function(){return this.getToken(m.STRING,0);},D.prototype.enterRule=function(e){e instanceof i&&e.enterStringLiteral(this);},D.prototype.exitRule=function(e){e instanceof i&&e.exitStringLiteral(this);},F.prototype=Object.create(A.prototype),F.prototype.constructor=F,m.BooleanLiteralContext=F,F.prototype.enterRule=function(e){e instanceof i&&e.enterBooleanLiteral(this);},F.prototype.exitRule=function(e){e instanceof i&&e.exitBooleanLiteral(this);},q.prototype=Object.create(A.prototype),q.prototype.constructor=q,m.NumberLiteralContext=q,q.prototype.NUMBER=function(){return this.getToken(m.NUMBER,0);},q.prototype.enterRule=function(e){e instanceof i&&e.enterNumberLiteral(this);},q.prototype.exitRule=function(e){e instanceof i&&e.exitNumberLiteral(this);},B.prototype=Object.create(A.prototype),B.prototype.constructor=B,m.QuantityLiteralContext=B,B.prototype.quantity=function(){return this.getTypedRuleContext(Q,0);},B.prototype.enterRule=function(e){e instanceof i&&e.enterQuantityLiteral(this);},B.prototype.exitRule=function(e){e instanceof i&&e.exitQuantityLiteral(this);},m.LiteralContext=A,m.prototype.literal=function(){var e=new A(this,this._ctx,this.state);this.enterRule(e,4,m.RULE_literal);var t=0;try{switch(this.state=94,this._errHandler.sync(this),this._interp.adaptivePredict(this._input,4,this._ctx)){case 1:e=new w(this,e),this.enterOuterAlt(e,1),this.state=86,this.match(m.T__29),this.state=87,this.match(m.T__30);break;case 2:e=new F(this,e),this.enterOuterAlt(e,2),this.state=88,(t=this._input.LA(1))!==m.T__31&&t!==m.T__32?this._errHandler.recoverInline(this):(this._errHandler.reportMatch(this),this.consume());break;case 3:e=new D(this,e),this.enterOuterAlt(e,3),this.state=89,this.match(m.STRING);break;case 4:e=new q(this,e),this.enterOuterAlt(e,4),this.state=90,this.match(m.NUMBER);break;case 5:e=new P(this,e),this.enterOuterAlt(e,5),this.state=91,this.match(m.DATETIME);break;case 6:e=new R(this,e),this.enterOuterAlt(e,6),this.state=92,this.match(m.TIME);break;case 7:e=new B(this,e),this.enterOuterAlt(e,7),this.state=93,this.quantity();}}catch(t){if(!(t instanceof l.error.RecognitionException))throw t;e.exception=t,this._errHandler.reportError(this,t),this._errHandler.recover(this,t);}finally{this.exitRule();}return e;},H.prototype=Object.create(l.ParserRuleContext.prototype),H.prototype.constructor=H,H.prototype.identifier=function(){return this.getTypedRuleContext(ne,0);},H.prototype.STRING=function(){return this.getToken(m.STRING,0);},H.prototype.enterRule=function(e){e instanceof i&&e.enterExternalConstant(this);},H.prototype.exitRule=function(e){e instanceof i&&e.exitExternalConstant(this);},m.ExternalConstantContext=H,m.prototype.externalConstant=function(){var e=new H(this,this._ctx,this.state);this.enterRule(e,6,m.RULE_externalConstant);try{switch(this.enterOuterAlt(e,1),this.state=96,this.match(m.T__33),this.state=99,this._errHandler.sync(this),this._input.LA(1)){case m.T__15:case m.T__16:case m.T__21:case m.T__22:case m.IDENTIFIER:case m.DELIMITEDIDENTIFIER:this.state=97,this.identifier();break;case m.STRING:this.state=98,this.match(m.STRING);break;default:throw new l.error.NoViableAltException(this);}}catch(t){if(!(t instanceof l.error.RecognitionException))throw t;e.exception=t,this._errHandler.reportError(this,t),this._errHandler.recover(this,t);}finally{this.exitRule();}return e;},z.prototype=Object.create(l.ParserRuleContext.prototype),z.prototype.constructor=z,z.prototype.copyFrom=function(e){l.ParserRuleContext.prototype.copyFrom.call(this,e);},G.prototype=Object.create(z.prototype),G.prototype.constructor=G,m.TotalInvocationContext=G,G.prototype.enterRule=function(e){e instanceof i&&e.enterTotalInvocation(this);},G.prototype.exitRule=function(e){e instanceof i&&e.exitTotalInvocation(this);},V.prototype=Object.create(z.prototype),V.prototype.constructor=V,m.ThisInvocationContext=V,V.prototype.enterRule=function(e){e instanceof i&&e.enterThisInvocation(this);},V.prototype.exitRule=function(e){e instanceof i&&e.exitThisInvocation(this);},j.prototype=Object.create(z.prototype),j.prototype.constructor=j,m.IndexInvocationContext=j,j.prototype.enterRule=function(e){e instanceof i&&e.enterIndexInvocation(this);},j.prototype.exitRule=function(e){e instanceof i&&e.exitIndexInvocation(this);},K.prototype=Object.create(z.prototype),K.prototype.constructor=K,m.FunctionInvocationContext=K,K.prototype.functn=function(){return this.getTypedRuleContext(J,0);},K.prototype.enterRule=function(e){e instanceof i&&e.enterFunctionInvocation(this);},K.prototype.exitRule=function(e){e instanceof i&&e.exitFunctionInvocation(this);},W.prototype=Object.create(z.prototype),W.prototype.constructor=W,m.MemberInvocationContext=W,W.prototype.identifier=function(){return this.getTypedRuleContext(ne,0);},W.prototype.enterRule=function(e){e instanceof i&&e.enterMemberInvocation(this);},W.prototype.exitRule=function(e){e instanceof i&&e.exitMemberInvocation(this);},m.InvocationContext=z,m.prototype.invocation=function(){var e=new z(this,this._ctx,this.state);this.enterRule(e,8,m.RULE_invocation);try{switch(this.state=106,this._errHandler.sync(this),this._interp.adaptivePredict(this._input,6,this._ctx)){case 1:e=new W(this,e),this.enterOuterAlt(e,1),this.state=101,this.identifier();break;case 2:e=new K(this,e),this.enterOuterAlt(e,2),this.state=102,this.functn();break;case 3:e=new V(this,e),this.enterOuterAlt(e,3),this.state=103,this.match(m.T__34);break;case 4:e=new j(this,e),this.enterOuterAlt(e,4),this.state=104,this.match(m.T__35);break;case 5:e=new G(this,e),this.enterOuterAlt(e,5),this.state=105,this.match(m.T__36);}}catch(t){if(!(t instanceof l.error.RecognitionException))throw t;e.exception=t,this._errHandler.reportError(this,t),this._errHandler.recover(this,t);}finally{this.exitRule();}return e;},J.prototype=Object.create(l.ParserRuleContext.prototype),J.prototype.constructor=J,J.prototype.identifier=function(){return this.getTypedRuleContext(ne,0);},J.prototype.paramList=function(){return this.getTypedRuleContext(Y,0);},J.prototype.enterRule=function(e){e instanceof i&&e.enterFunctn(this);},J.prototype.exitRule=function(e){e instanceof i&&e.exitFunctn(this);},m.FunctnContext=J,m.prototype.functn=function(){var e=new J(this,this._ctx,this.state);this.enterRule(e,10,m.RULE_functn);var t=0;try{this.enterOuterAlt(e,1),this.state=108,this.identifier(),this.state=109,this.match(m.T__27),this.state=111,this._errHandler.sync(this),(0==(-32&(t=this._input.LA(1)))&&0!=(1<<t&(1<<m.T__3|1<<m.T__4|1<<m.T__15|1<<m.T__16|1<<m.T__21|1<<m.T__22|1<<m.T__27|1<<m.T__29))||0==(t-32&-32)&&0!=(1<<t-32&(1<<m.T__31-32|1<<m.T__32-32|1<<m.T__33-32|1<<m.T__34-32|1<<m.T__35-32|1<<m.T__36-32|1<<m.DATETIME-32|1<<m.TIME-32|1<<m.IDENTIFIER-32|1<<m.DELIMITEDIDENTIFIER-32|1<<m.STRING-32|1<<m.NUMBER-32)))&&(this.state=110,this.paramList()),this.state=113,this.match(m.T__28);}catch(t){if(!(t instanceof l.error.RecognitionException))throw t;e.exception=t,this._errHandler.reportError(this,t),this._errHandler.recover(this,t);}finally{this.exitRule();}return e;},Y.prototype=Object.create(l.ParserRuleContext.prototype),Y.prototype.constructor=Y,Y.prototype.expression=function(e){return void 0===e&&(e=null),null===e?this.getTypedRuleContexts(p):this.getTypedRuleContext(p,e);},Y.prototype.enterRule=function(e){e instanceof i&&e.enterParamList(this);},Y.prototype.exitRule=function(e){e instanceof i&&e.exitParamList(this);},m.ParamListContext=Y,m.prototype.paramList=function(){var e=new Y(this,this._ctx,this.state);this.enterRule(e,12,m.RULE_paramList);var t=0;try{for(this.enterOuterAlt(e,1),this.state=115,this.expression(0),this.state=120,this._errHandler.sync(this),t=this._input.LA(1);t===m.T__37;){this.state=116,this.match(m.T__37),this.state=117,this.expression(0),this.state=122,this._errHandler.sync(this),t=this._input.LA(1);}}catch(t){if(!(t instanceof l.error.RecognitionException))throw t;e.exception=t,this._errHandler.reportError(this,t),this._errHandler.recover(this,t);}finally{this.exitRule();}return e;},Q.prototype=Object.create(l.ParserRuleContext.prototype),Q.prototype.constructor=Q,Q.prototype.NUMBER=function(){return this.getToken(m.NUMBER,0);},Q.prototype.unit=function(){return this.getTypedRuleContext($,0);},Q.prototype.enterRule=function(e){e instanceof i&&e.enterQuantity(this);},Q.prototype.exitRule=function(e){e instanceof i&&e.exitQuantity(this);},m.QuantityContext=Q,m.prototype.quantity=function(){var e=new Q(this,this._ctx,this.state);this.enterRule(e,14,m.RULE_quantity);try{this.enterOuterAlt(e,1),this.state=123,this.match(m.NUMBER),this.state=125,this._errHandler.sync(this),1===this._interp.adaptivePredict(this._input,9,this._ctx)&&(this.state=124,this.unit());}catch(t){if(!(t instanceof l.error.RecognitionException))throw t;e.exception=t,this._errHandler.reportError(this,t),this._errHandler.recover(this,t);}finally{this.exitRule();}return e;},$.prototype=Object.create(l.ParserRuleContext.prototype),$.prototype.constructor=$,$.prototype.dateTimePrecision=function(){return this.getTypedRuleContext(X,0);},$.prototype.pluralDateTimePrecision=function(){return this.getTypedRuleContext(Z,0);},$.prototype.STRING=function(){return this.getToken(m.STRING,0);},$.prototype.enterRule=function(e){e instanceof i&&e.enterUnit(this);},$.prototype.exitRule=function(e){e instanceof i&&e.exitUnit(this);},m.UnitContext=$,m.prototype.unit=function(){var e=new $(this,this._ctx,this.state);this.enterRule(e,16,m.RULE_unit);try{switch(this.state=130,this._errHandler.sync(this),this._input.LA(1)){case m.T__38:case m.T__39:case m.T__40:case m.T__41:case m.T__42:case m.T__43:case m.T__44:case m.T__45:this.enterOuterAlt(e,1),this.state=127,this.dateTimePrecision();break;case m.T__46:case m.T__47:case m.T__48:case m.T__49:case m.T__50:case m.T__51:case m.T__52:case m.T__53:this.enterOuterAlt(e,2),this.state=128,this.pluralDateTimePrecision();break;case m.STRING:this.enterOuterAlt(e,3),this.state=129,this.match(m.STRING);break;default:throw new l.error.NoViableAltException(this);}}catch(t){if(!(t instanceof l.error.RecognitionException))throw t;e.exception=t,this._errHandler.reportError(this,t),this._errHandler.recover(this,t);}finally{this.exitRule();}return e;},X.prototype=Object.create(l.ParserRuleContext.prototype),X.prototype.constructor=X,X.prototype.enterRule=function(e){e instanceof i&&e.enterDateTimePrecision(this);},X.prototype.exitRule=function(e){e instanceof i&&e.exitDateTimePrecision(this);},m.DateTimePrecisionContext=X,m.prototype.dateTimePrecision=function(){var e=new X(this,this._ctx,this.state);this.enterRule(e,18,m.RULE_dateTimePrecision);var t=0;try{this.enterOuterAlt(e,1),this.state=132,0!=((t=this._input.LA(1))-39&-32)||0==(1<<t-39&(1<<m.T__38-39|1<<m.T__39-39|1<<m.T__40-39|1<<m.T__41-39|1<<m.T__42-39|1<<m.T__43-39|1<<m.T__44-39|1<<m.T__45-39))?this._errHandler.recoverInline(this):(this._errHandler.reportMatch(this),this.consume());}catch(t){if(!(t instanceof l.error.RecognitionException))throw t;e.exception=t,this._errHandler.reportError(this,t),this._errHandler.recover(this,t);}finally{this.exitRule();}return e;},Z.prototype=Object.create(l.ParserRuleContext.prototype),Z.prototype.constructor=Z,Z.prototype.enterRule=function(e){e instanceof i&&e.enterPluralDateTimePrecision(this);},Z.prototype.exitRule=function(e){e instanceof i&&e.exitPluralDateTimePrecision(this);},m.PluralDateTimePrecisionContext=Z,m.prototype.pluralDateTimePrecision=function(){var e=new Z(this,this._ctx,this.state);this.enterRule(e,20,m.RULE_pluralDateTimePrecision);var t=0;try{this.enterOuterAlt(e,1),this.state=134,0!=((t=this._input.LA(1))-47&-32)||0==(1<<t-47&(1<<m.T__46-47|1<<m.T__47-47|1<<m.T__48-47|1<<m.T__49-47|1<<m.T__50-47|1<<m.T__51-47|1<<m.T__52-47|1<<m.T__53-47))?this._errHandler.recoverInline(this):(this._errHandler.reportMatch(this),this.consume());}catch(t){if(!(t instanceof l.error.RecognitionException))throw t;e.exception=t,this._errHandler.reportError(this,t),this._errHandler.recover(this,t);}finally{this.exitRule();}return e;},ee.prototype=Object.create(l.ParserRuleContext.prototype),ee.prototype.constructor=ee,ee.prototype.qualifiedIdentifier=function(){return this.getTypedRuleContext(te,0);},ee.prototype.enterRule=function(e){e instanceof i&&e.enterTypeSpecifier(this);},ee.prototype.exitRule=function(e){e instanceof i&&e.exitTypeSpecifier(this);},m.TypeSpecifierContext=ee,m.prototype.typeSpecifier=function(){var e=new ee(this,this._ctx,this.state);this.enterRule(e,22,m.RULE_typeSpecifier);try{this.enterOuterAlt(e,1),this.state=136,this.qualifiedIdentifier();}catch(t){if(!(t instanceof l.error.RecognitionException))throw t;e.exception=t,this._errHandler.reportError(this,t),this._errHandler.recover(this,t);}finally{this.exitRule();}return e;},te.prototype=Object.create(l.ParserRuleContext.prototype),te.prototype.constructor=te,te.prototype.identifier=function(e){return void 0===e&&(e=null),null===e?this.getTypedRuleContexts(ne):this.getTypedRuleContext(ne,e);},te.prototype.enterRule=function(e){e instanceof i&&e.enterQualifiedIdentifier(this);},te.prototype.exitRule=function(e){e instanceof i&&e.exitQualifiedIdentifier(this);},m.QualifiedIdentifierContext=te,m.prototype.qualifiedIdentifier=function(){var e=new te(this,this._ctx,this.state);this.enterRule(e,24,m.RULE_qualifiedIdentifier);try{this.enterOuterAlt(e,1),this.state=138,this.identifier(),this.state=143,this._errHandler.sync(this);for(var t=this._interp.adaptivePredict(this._input,11,this._ctx);2!=t&&t!=l.atn.ATN.INVALID_ALT_NUMBER;){1===t&&(this.state=139,this.match(m.T__0),this.state=140,this.identifier()),this.state=145,this._errHandler.sync(this),t=this._interp.adaptivePredict(this._input,11,this._ctx);}}catch(t){if(!(t instanceof l.error.RecognitionException))throw t;e.exception=t,this._errHandler.reportError(this,t),this._errHandler.recover(this,t);}finally{this.exitRule();}return e;},ne.prototype=Object.create(l.ParserRuleContext.prototype),ne.prototype.constructor=ne,ne.prototype.IDENTIFIER=function(){return this.getToken(m.IDENTIFIER,0);},ne.prototype.DELIMITEDIDENTIFIER=function(){return this.getToken(m.DELIMITEDIDENTIFIER,0);},ne.prototype.enterRule=function(e){e instanceof i&&e.enterIdentifier(this);},ne.prototype.exitRule=function(e){e instanceof i&&e.exitIdentifier(this);},m.IdentifierContext=ne,m.prototype.identifier=function(){var e=new ne(this,this._ctx,this.state);this.enterRule(e,26,m.RULE_identifier);var t=0;try{this.enterOuterAlt(e,1),this.state=146,0==(-32&(t=this._input.LA(1)))&&0!=(1<<t&(1<<m.T__15|1<<m.T__16|1<<m.T__21|1<<m.T__22))||t===m.IDENTIFIER||t===m.DELIMITEDIDENTIFIER?(this._errHandler.reportMatch(this),this.consume()):this._errHandler.recoverInline(this);}catch(t){if(!(t instanceof l.error.RecognitionException))throw t;e.exception=t,this._errHandler.reportError(this,t),this._errHandler.recover(this,t);}finally{this.exitRule();}return e;},m.prototype.sempred=function(e,t,n){switch(t){case 0:return this.expression_sempred(e,n);default:throw"No predicate with index:"+t;}},m.prototype.expression_sempred=function(e,t){switch(t){case 0:return this.precpred(this._ctx,10);case 1:return this.precpred(this._ctx,9);case 2:return this.precpred(this._ctx,8);case 3:return this.precpred(this._ctx,7);case 4:return this.precpred(this._ctx,5);case 5:return this.precpred(this._ctx,4);case 6:return this.precpred(this._ctx,3);case 7:return this.precpred(this._ctx,2);case 8:return this.precpred(this._ctx,1);case 9:return this.precpred(this._ctx,13);case 10:return this.precpred(this._ctx,12);case 11:return this.precpred(this._ctx,6);default:throw"No predicate with index:"+t;}},t.FHIRPathParser=m;},function(e,t){e.exports=function(e){var t=new Date(e.getTime()),n=t.getTimezoneOffset();return t.setSeconds(0,0),6e4*n+t.getTime()%6e4;};},function(e,t){e.exports=function(e){return e instanceof Date;};},function(e,t,n){"use strict";function l(e,t){for(var n=0;n<t.length;n++){var l=t[n];l.enumerable=l.enumerable||!1,l.configurable=!0,"value"in l&&(l.writable=!0),Object.defineProperty(e,l.key,l);}}function i(e){return(i="function"==typeof Symbol&&"symbol"==_typeof(Symbol.iterator)?function(e){return _typeof(e);}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":_typeof(e);})(e);}Object.defineProperty(t,"__esModule",{value:!0}),t.UcumLhcUtils=void 0;var r=n(72),s=function(e){if(e&&e.__esModule)return e;if(null===e||"object"!==i(e)&&"function"!=typeof e)return{default:e};var t=a();if(t&&t.has(e))return t.get(e);var n={},l=Object.defineProperty&&Object.getOwnPropertyDescriptor;for(var r in e){if(Object.prototype.hasOwnProperty.call(e,r)){var s=l?Object.getOwnPropertyDescriptor(e,r):null;s&&(s.get||s.set)?Object.defineProperty(n,r,s):n[r]=e[r];}}n.default=e,t&&t.set(e,n);return n;}(n(25));function a(){if("function"!=typeof WeakMap)return null;var e=new WeakMap();return a=function a(){return e;},e;}var o=n(12).Ucum,u=n(15).UnitTables,c=n(79).UnitString,f=function(){function e(){!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function");}(this,e),0===u.getInstance().unitsCount()&&r.ucumJsonDefs.loadJsonDefs(),this.uStrParser_=c.getInstance();}var t,n,i;return t=e,(n=[{key:"useHTMLInMessages",value:function value(e){void 0===e&&(e=!0),this.uStrParser_.useHTMLInMessages(e);}},{key:"useBraceMsgForEachString",value:function value(e){void 0===e&&(e=!0),this.uStrParser_.useBraceMsgForEachString(e);}},{key:"validateUnitString",value:function value(e,t,n){void 0===t&&(t=!1),void 0===n&&(n="validate");var l=this.getSpecifiedUnit(e,n,t),i=l.unit,r={};return r=i?{status:l.origString===e?"valid":"invalid",ucumCode:l.origString,unit:{code:i.csCode_,name:i.name_,guidance:i.guidance_}}:{status:l.origString&&null!==l.origString?"invalid":"error",ucumCode:null},l.suggestions&&(r.suggestions=l.suggestions),r.msg=l.retMsg,r;}},{key:"convertUnitTo",value:function value(e,t,n,l,i){void 0===l&&(l=!1),void 0===i&&(i=null);var r={status:"failed",toVal:null,msg:[]};if(e&&(e=e.trim()),e&&""!=e||(r.status="error",r.msg.push('No "from" unit expression specified.')),(null===t||isNaN(t)||"number"!=typeof t&&!s.isNumericString(t))&&(r.status="error",r.msg.push('No "from" value, or an invalid "from" value, was specified.')),n&&(n=n.trim()),n&&""!=n||(r.status="error",r.msg.push('No "to" unit expression specified.')),"error"!==r.status)try{var a=null,u=this.getSpecifiedUnit(e,"convert",l);a=u.unit,u.retMsg&&(r.msg=r.msg.concat(u.retMsg)),u.suggestions&&(r.suggestions={},r.suggestions.from=u.suggestions),a||r.msg.push("Unable to find a unit for ".concat(e,", ")+"so no conversion could be performed.");var c=null;if(c=(u=this.getSpecifiedUnit(n,"convert",l)).unit,u.retMsg&&(r.msg=r.msg.concat(u.retMsg)),u.suggestions&&(r.suggestions||(r.suggestions={}),r.suggestions.to=u.suggestions),c||r.msg.push("Unable to find a unit for ".concat(n,", ")+"so no conversion could be performed."),a&&c)try{if(i){if(0!==a.moleExp_&&0!==c.moleExp_)throw new Error("A molecular weight was specified but a mass <-> mole conversion cannot be executed for two mole-based units.  No conversion was attempted.");if(0===a.moleExp_&&0===c.moleExp_)throw new Error("A molecular weight was specified but a mass <-> mole conversion cannot be executed when neither unit is mole-based.  No conversion was attempted.");if(!a.isMoleMassCommensurable(c))throw new Error("Sorry.  ".concat(e," cannot be ")+"converted to ".concat(n,"."));0!==a.moleExp_?r.toVal=a.convertMolToMass(t,c,i):r.toVal=a.convertMassToMol(t,c,i);}else r.toVal=c.convertFrom(t,a);r.status="succeeded",r.fromUnit=a,r.toUnit=c;}catch(e){r.status="failed",r.msg.push(e.message);}}catch(e){e.message==o.needMoleWeightMsg_?r.status="failed":r.status="error",r.msg.push(e.message);}return r;}},{key:"checkSynonyms",value:function value(e){var t={};return null==e?(t.status="error",t.msg="No term specified for synonym search."):t=s.getSynonyms(e),t;}},{key:"getSpecifiedUnit",value:function value(e,t,n){void 0===n&&(n=!1);var l={retMsg:[]};if(e){var i=u.getInstance();e=e.trim();var r=i.getUnitByCode(e);if(r)l.unit=r,l.origString=e;else try{var s=this.uStrParser_.parseString(e,t,n);l.unit=s[0],l.origString=s[1],s[2]&&(l.retMsg=s[2]),l.suggestions=s[3];}catch(t){console.log("Unit requested for unit string ".concat(e,".")+"request unsuccessful; error thrown = "+t.message),l.retMsg.unshift("".concat(e," is not a valid unit.  ")+"".concat(t.message));}}else l.retMsg.push("No unit string specified.");return l;}},{key:"commensurablesList",value:function value(e){var t=[],n=null,l=this.getSpecifiedUnit(e,"validate",!1),i=l.unit;if(l.retMsg.length>0&&(t=l.retMsg),i){var r=null,s=i.getProperty("dim_");if(s){try{r=s.getProperty("dimVec_");}catch(e){t.push(e.message),"Dimension does not have requested property(dimVec_)"===e.message&&(r=null);}r&&(n=u.getInstance().getUnitsByDimension(r));}else t.push("No commensurable units were found for "+e);}else t.push("Could not find unit ".concat(e,"."));return[n,t];}}])&&l(t.prototype,n),i&&l(t,i),e;}();t.UcumLhcUtils=f,f.getInstance=function(){return new f();};},function(e,t,n){"use strict";function l(e,t){for(var n=0;n<t.length;n++){var l=t[n];l.enumerable=l.enumerable||!1,l.configurable=!0,"value"in l&&(l.writable=!0),Object.defineProperty(e,l.key,l);}}Object.defineProperty(t,"__esModule",{value:!0}),t.ucumJsonDefs=t.UcumJsonDefs=void 0;var i=n(73),r=n(39),s=n(40),a=n(15),o=n(77).unpackArray,u=function(){function e(){!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function");}(this,e);}var t,u,c;return t=e,(u=[{key:"loadJsonDefs",value:function value(){var e=n(78);if(e.prefixes=o(e.prefixes),e.units=o(e.units),0===a.UnitTables.getInstance().unitsCount()){for(var t=r.PrefixTables.getInstance(),l=e.prefixes,u=l.length,c=0;c<u;c++){var f=new i.Prefix(l[c]);t.add(f);}for(var m=a.UnitTables.getInstance(),p=e.units,h=p.length,d=0;d<h;d++){var g=new s.Unit(p[d]);m.addUnit(g);}}}}])&&l(t.prototype,u),c&&l(t,c),e;}();t.UcumJsonDefs=u;var c=new u();t.ucumJsonDefs=c;},function(e,t,n){"use strict";function l(e,t){for(var n=0;n<t.length;n++){var l=t[n];l.enumerable=l.enumerable||!1,l.configurable=!0,"value"in l&&(l.writable=!0),Object.defineProperty(e,l.key,l);}}Object.defineProperty(t,"__esModule",{value:!0}),t.Prefix=void 0;n(12);var i=function(){function e(t){if(function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function");}(this,e),void 0===t.code_||null===t.code_||void 0===t.name_||null===t.name_||void 0===t.value_||null===t.value_||void 0===t.exp_)throw new Error("Prefix constructor called missing one or more parameters.  Prefix codes (cs or ci), name, value and exponent must all be specified and all but the exponent must not be null.");this.code_=t.code_,this.ciCode_=t.ciCode_,this.name_=t.name_,this.printSymbol_=t.printSymbol_,"string"==typeof t.value_?this.value_=parseFloat(t.value_):this.value_=t.value_,this.exp_=t.exp_;}var t,n,i;return t=e,(n=[{key:"getValue",value:function value(){return this.value_;}},{key:"getCode",value:function value(){return this.code_;}},{key:"getCiCode",value:function value(){return this.ciCode_;}},{key:"getName",value:function value(){return this.name_;}},{key:"getPrintSymbol",value:function value(){return this.printSymbol_;}},{key:"getExp",value:function value(){return this.exp_;}},{key:"equals",value:function value(e){return this.code_===e.code_&&this.ciCode_===e.ciCode_&&this.name_===e.name_&&this.printSymbol_===e.printSymbol_&&this.value_===e.value_&&this.exp_===e.exp_;}}])&&l(t.prototype,n),i&&l(t,i),e;}();t.Prefix=i;},function(e,t,n){"use strict";function l(e,t){for(var n=0;n<t.length;n++){var l=t[n];l.enumerable=l.enumerable||!1,l.configurable=!0,"value"in l&&(l.writable=!0),Object.defineProperty(e,l.key,l);}}Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var i=new(function(){function e(){!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function");}(this,e),this.funcs={},this.funcs.cel={cnvTo:function cnvTo(e){return e-273.15;},cnvFrom:function cnvFrom(e){return e+273.15;}},this.funcs.degf={cnvTo:function cnvTo(e){return e-459.67;},cnvFrom:function cnvFrom(e){return e+459.67;}},this.funcs.degre={cnvTo:function cnvTo(e){return e-273.15;},cnvFrom:function cnvFrom(e){return e+273.15;}},this.funcs.ph={cnvTo:function cnvTo(e){return-Math.log(e)/Math.LN10;},cnvFrom:function cnvFrom(e){return Math.pow(10,-e);}},this.funcs.ln={cnvTo:function cnvTo(e){return Math.log(e);},cnvFrom:function cnvFrom(e){return Math.exp(e);}},this.funcs["2ln"]={cnvTo:function cnvTo(e){return 2*Math.log(e);},cnvFrom:function cnvFrom(e){return Math.exp(e/2);}},this.funcs.lg={cnvTo:function cnvTo(e){return Math.log(e)/Math.LN10;},cnvFrom:function cnvFrom(e){return Math.pow(10,e);}},this.funcs["10lg"]={cnvTo:function cnvTo(e){return 10*Math.log(e)/Math.LN10;},cnvFrom:function cnvFrom(e){return Math.pow(10,e/10);}},this.funcs["20lg"]={cnvTo:function cnvTo(e){return 20*Math.log(e)/Math.LN10;},cnvFrom:function cnvFrom(e){return Math.pow(10,e/20);}},this.funcs["2lg"]={cnvTo:function cnvTo(e){return 2*Math.log(e)/Math.LN10;},cnvFrom:function cnvFrom(e){return Math.pow(10,e/2);}},this.funcs.lgtimes2=this.funcs["2lg"],this.funcs.ld={cnvTo:function cnvTo(e){return Math.log(e)/Math.LN2;},cnvFrom:function cnvFrom(e){return Math.pow(2,e);}},this.funcs["100tan"]={cnvTo:function cnvTo(e){return 100*Math.tan(e);},cnvFrom:function cnvFrom(e){return Math.atan(e/100);}},this.funcs.tanTimes100=this.funcs["100tan"],this.funcs.sqrt={cnvTo:function cnvTo(e){return Math.sqrt(e);},cnvFrom:function cnvFrom(e){return e*e;}},this.funcs.inv={cnvTo:function cnvTo(e){return 1/e;},cnvFrom:function cnvFrom(e){return 1/e;}},this.funcs.hpX={cnvTo:function cnvTo(e){return-this.funcs.lg(e);},cnvFrom:function cnvFrom(e){return Math.pow(10,-e);}},this.funcs.hpC={cnvTo:function cnvTo(e){return-this.func.ln(e)/this.funcs.ln(100);},cnvFrom:function cnvFrom(e){return Math.pow(100,-e);}},this.funcs.hpM={cnvTo:function cnvTo(e){return-this.funcs.ln(e)/this.funcs.ln(1e3);},cnvFrom:function cnvFrom(e){return Math.pow(1e3,-e);}},this.funcs.hpQ={cnvTo:function cnvTo(e){return-this.funcs.ln(e)/this.funcs.ln(5e4);},cnvFrom:function cnvFrom(e){return Math.pow(5e4,-e);}};}var t,n,i;return t=e,(n=[{key:"forName",value:function value(e){e=e.toLowerCase();var t=this.funcs[e];if(null===t)throw new Error("Requested function ".concat(e," is not defined"));return t;}},{key:"isDefined",value:function value(e){return e=e.toLowerCase(),null!==this.funcs[e];}}])&&l(t.prototype,n),i&&l(t,i),e;}())();t.default=i;},function(e,t,n){"use strict";function l(e){return(l="function"==typeof Symbol&&"symbol"==_typeof(Symbol.iterator)?function(e){return _typeof(e);}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":_typeof(e);})(e);}function i(e,t){for(var n=0;n<t.length;n++){var l=t[n];l.enumerable=l.enumerable||!1,l.configurable=!0,"value"in l&&(l.writable=!0),Object.defineProperty(e,l.key,l);}}Object.defineProperty(t,"__esModule",{value:!0}),t.Dimension=void 0;var r=n(12),s=n(41),a=function(){function e(t){if(function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function");}(this,e),0===r.Ucum.dimLen_)throw new Error("Dimension.setDimensionLen must be called before Dimension constructor");if(null==t)this.assignZero();else if(t instanceof Array){if(t.length!==r.Ucum.dimLen_)throw new Error("Parameter error, incorrect length of vector passed to "+"Dimension constructor, vector = ".concat(JSON.stringify(t)));this.dimVec_=[];for(var n=0;n<r.Ucum.dimLen_;n++){this.dimVec_.push(t[n]);}}else if(s(t)){if(t<0||t>=r.Ucum.dimLen_)throw new Error("Parameter error, invalid element number specified for Dimension constructor");this.assignZero(),this.dimVec_[t]=1;}}var t,n,a;return t=e,(n=[{key:"setElementAt",value:function value(e,t){if(!s(e)||e<0||e>=r.Ucum.dimLen_)throw new Error("Dimension.setElementAt called with an invalid index "+"position (".concat(e,")"));this.dimVec_||this.assignZero(),null==t&&(t=1),this.dimVec_[e]=t;}},{key:"getElementAt",value:function value(e){if(!s(e)||e<0||e>=r.Ucum.dimLen_)throw new Error("Dimension.getElementAt called with an invalid index "+"position (".concat(e,")"));var t=null;return this.dimVec_&&(t=this.dimVec_[e]),t;}},{key:"getProperty",value:function value(e){return this["_"===e.charAt(e.length-1)?e:e+"_"];}},{key:"toString",value:function value(){var e=null;return this.dimVec_&&(e="["+this.dimVec_.join(", ")+"]"),e;}},{key:"add",value:function value(t){if(!t instanceof e)throw new Error("Dimension.add called with an invalid parameter - "+"".concat(l(t)," instead of a Dimension object"));if(this.dimVec_&&t.dimVec_)for(var n=0;n<r.Ucum.dimLen_;n++){this.dimVec_[n]+=t.dimVec_[n];}return this;}},{key:"sub",value:function value(t){if(!t instanceof e)throw new Error("Dimension.sub called with an invalid parameter - "+"".concat(l(t)," instead of a Dimension object"));if(this.dimVec_&&t.dimVec_)for(var n=0;n<r.Ucum.dimLen_;n++){this.dimVec_[n]-=t.dimVec_[n];}return this;}},{key:"minus",value:function value(){if(this.dimVec_)for(var e=0;e<r.Ucum.dimLen_;e++){this.dimVec_[e]=-this.dimVec_[e];}return this;}},{key:"mul",value:function value(e){if(!s(e))throw new Error("Dimension.sub called with an invalid parameter - "+"".concat("undefined"==typeof dim2?"undefined":l(dim2)," instead of a number"));if(this.dimVec_)for(var t=0;t<r.Ucum.dimLen_;t++){this.dimVec_[t]*=e;}return this;}},{key:"equals",value:function value(t){if(!t instanceof e)throw new Error("Dimension.equals called with an invalid parameter - "+"".concat(l(t)," instead of a Dimension object"));var n=!0,i=t.dimVec_;if(this.dimVec_&&i)for(var s=0;n&&s<r.Ucum.dimLen_;s++){n=this.dimVec_[s]===i[s];}else n=null===this.dimVec_&&null===i;return n;}},{key:"assignDim",value:function value(t){if(!t instanceof e)throw new Error("Dimension.assignDim called with an invalid parameter - "+"".concat(l(t)," instead of a Dimension object"));if(null===t.dimVec_)this.dimVec_=null;else{null===this.dimVec_&&(this.dimVec_=[]);for(var n=0;n<r.Ucum.dimLen_;n++){this.dimVec_[n]=t.dimVec_[n];}}return this;}},{key:"assignZero",value:function value(){null!==this.dimVec_&&void 0!==this.dimVec_||(this.dimVec_=[]);for(var e=0;e<r.Ucum.dimLen_;e++){this.dimVec_.push(0);}return this;}},{key:"isZero",value:function value(){var e=null!==this.dimVec_;if(this.dimVec_)for(var t=0;e&&t<r.Ucum.dimLen_;t++){e=0===this.dimVec_[t];}return e;}},{key:"isNull",value:function value(){return null===this.dimVec_;}},{key:"clone",value:function value(){var t=new e();return t.assignDim(this),t;}}])&&i(t.prototype,n),a&&i(t,a),e;}();t.Dimension=a;},function(e,t,n){"use strict";e.exports=Number.isFinite||function(e){return!("number"!=typeof e||e!=e||e===1/0||e===-1/0);};},function(e,t,n){"use strict";function l(e){return function(e){if(Array.isArray(e))return i(e);}(e)||function(e){if("undefined"!=typeof Symbol&&Symbol.iterator in Object(e))return Array.from(e);}(e)||function(e,t){if(!e)return;if("string"==typeof e)return i(e,t);var n=Object.prototype.toString.call(e).slice(8,-1);"Object"===n&&e.constructor&&(n=e.constructor.name);if("Map"===n||"Set"===n)return Array.from(n);if("Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))return i(e,t);}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");}();}function i(e,t){(null==t||t>e.length)&&(t=e.length);for(var n=0,l=new Array(t);n<t;n++){l[n]=e[n];}return l;}Object.defineProperty(t,"__esModule",{value:!0}),t.packArray=function(e){if(e&&e.length){var t=s(e[0]),n=a(t);if(t.length)return{config:t,data:e.map(o.bind(null,n))};}return{config:[],data:e};},t.unpackArray=function(e){var t=e&&e.config;if(t){if(t.length&&e.data){var n=a(t);return e.data.map(u.bind(null,n));}return e.data;}return e;};var r=Array.prototype.push;function s(e){return Object.keys(e).reduce(function(t,n){var i;return i=e[n],"[object Object]"===Object.prototype.toString.call(i)?r.apply(t,s(e[n]).map(function(e){return[n].concat(l([].concat(e)));})):t.push(n),t;},[]);}function a(e){return e.map(function(e){return Array.isArray(e)?e:[e];});}function o(e,t){if(e.join()!==a(s(t)).join())throw new Error("Object of unusual structure");return e.map(function(e){var n=t;return e.forEach(function(e){if(void 0===(n=n[e]))throw new Error("Object of unusual structure");}),n;});}function u(e,t){var n={};return e.forEach(function(e,l){for(var i=n,r=0;r<e.length-1;r++){i=i[e[r]]=i[e[r]]||{};}i[e[e.length-1]]=t[l];}),n;}},function(e){e.exports=JSON.parse('{"license":"The following data (prefixes and units) was generated by the UCUM LHC code from the UCUM data and selected LOINC combinations of UCUM units.  The license for the UCUM LHC code (demo and library code as well as the combined units) is located at https://github.com/lhncbc/ucum-lhc/blob/LICENSE.md.","prefixes":{"config":["code_","ciCode_","name_","printSymbol_","value_","exp_"],"data":[["E","EX","exa","E",1000000000000000000,"18"],["G","GA","giga","G",1000000000,"9"],["Gi","GIB","gibi","Gi",1073741824,null],["Ki","KIB","kibi","Ki",1024,null],["M","MA","mega","M",1000000,"6"],["Mi","MIB","mebi","Mi",1048576,null],["P","PT","peta","P",1000000000000000,"15"],["T","TR","tera","T",1000000000000,"12"],["Ti","TIB","tebi","Ti",1099511627776,null],["Y","YA","yotta","Y",1e+24,"24"],["Z","ZA","zetta","Z",1e+21,"21"],["a","A","atto","a",1e-18,"-18"],["c","C","centi","c",0.01,"-2"],["d","D","deci","d",0.1,"-1"],["da","DA","deka","da",10,"1"],["f","F","femto","f",1e-15,"-15"],["h","H","hecto","h",100,"2"],["k","K","kilo","k",1000,"3"],["m","M","milli","m",0.001,"-3"],["n","N","nano","n",1e-9,"-9"],["p","P","pico","p",1e-12,"-12"],["u","U","micro","μ",0.000001,"-6"],["y","YO","yocto","y",1.0000000000000001e-24,"-24"],["z","ZO","zepto","z",1e-21,"-21"]]},"units":{"config":["isBase_","name_","csCode_","ciCode_","property_","magnitude_",["dim_","dimVec_"],"printSymbol_","class_","isMetric_","variable_","cnv_","cnvPfx_","isSpecial_","isArbitrary_","moleExp_","synonyms_","source_","loincProperty_","category_","guidance_","csUnitString_","ciUnitString_","baseFactorStr_","baseFactor_","defError_"],"data":[[true,"meter","m","M","length",1,[1,0,0,0,0,0,0],"m",null,false,"L",null,1,false,false,0,"meters; metres; distance","UCUM","Len","Clinical","unit of length = 1.09361 yards",null,null,null,null,false],[true,"second - time","s","S","time",1,[0,1,0,0,0,0,0],"s",null,false,"T",null,1,false,false,0,"seconds","UCUM","Time","Clinical","",null,null,null,null,false],[true,"gram","g","G","mass",1,[0,0,1,0,0,0,0],"g",null,false,"M",null,1,false,false,0,"grams; gm","UCUM","Mass","Clinical","",null,null,null,null,false],[true,"radian","rad","RAD","plane angle",1,[0,0,0,1,0,0,0],"rad",null,false,"A",null,1,false,false,0,"radians","UCUM","Angle","Clinical","unit of angular measure where 1 radian = 1/2π turn =  57.296 degrees. ",null,null,null,null,false],[true,"degree Kelvin","K","K","temperature",1,[0,0,0,0,1,0,0],"K",null,false,"C",null,1,false,false,0,"Kelvin; degrees","UCUM","Temp","Clinical","absolute, thermodynamic temperature scale ",null,null,null,null,false],[true,"coulomb","C","C","electric charge",1,[0,0,0,0,0,1,0],"C",null,false,"Q",null,1,false,false,0,"coulombs","UCUM","","Clinical","defined as amount of 1 electron charge = 6.2415093×10^18 e, and equivalent to 1 Ampere-second",null,null,null,null,false],[true,"candela","cd","CD","luminous intensity",1,[0,0,0,0,0,0,1],"cd",null,false,"F",null,1,false,false,0,"candelas","UCUM","","Clinical","SI base unit of luminous intensity",null,null,null,null,false],[false,"the number ten for arbitrary powers","10*","10*","number",10,[0,0,0,0,0,0,0],"10","dimless",false,null,null,1,false,false,0,"10^; 10 to the arbitrary powers","UCUM","Num","Clinical","10* by itself is the same as 10, but users can add digits after the *. For example, 10*3 = 1000.","1","1","10",10,false],[false,"the number ten for arbitrary powers","10^","10^","number",10,[0,0,0,0,0,0,0],"10","dimless",false,null,null,1,false,false,0,"10*; 10 to the arbitrary power","UCUM","Num","Clinical","10* by itself is the same as 10, but users can add digits after the *. For example, 10*3 = 1000.","1","1","10",10,false],[false,"the number pi","[pi]","[PI]","number",3.141592653589793,[0,0,0,0,0,0,0],"π","dimless",false,null,null,1,false,false,0,"π","UCUM","","Constant","a mathematical constant; the ratio of a circle\'s circumference to its diameter ≈ 3.14159","1","1","3.1415926535897932384626433832795028841971693993751058209749445923",3.141592653589793,false],[false,"","%","%","fraction",0.01,[0,0,0,0,0,0,0],"%","dimless",false,null,null,1,false,false,0,"percents","UCUM","FR; NFR; MFR; CFR; SFR Rto; etc. ","Clinical","","10*-2","10*-2","1",1,false],[false,"parts per thousand","[ppth]","[PPTH]","fraction",0.001,[0,0,0,0,0,0,0],"ppth","dimless",false,null,null,1,false,false,0,"ppth; 10^-3","UCUM","MCnc; MCnt","Clinical","[ppth] is often used in solution concentrations as 1 g/L or 1 g/kg.\\n\\nCan be ambigous and would be better if the metric units was used directly. ","10*-3","10*-3","1",1,false],[false,"parts per million","[ppm]","[PPM]","fraction",0.000001,[0,0,0,0,0,0,0],"ppm","dimless",false,null,null,1,false,false,0,"ppm; 10^-6","UCUM","MCnt; MCnc; SFr","Clinical","[ppm] is often used in solution concentrations as 1 mg/L  or 1 mg/kg. Also used to express mole fractions as 1 mmol/mol.\\n\\n[ppm] is also used in nuclear magnetic resonance (NMR) to represent chemical shift - the difference of a measured frequency in parts per million from the reference frequency.\\n\\nCan be ambigous and would be better if the metric units was used directly. ","10*-6","10*-6","1",1,false],[false,"parts per billion","[ppb]","[PPB]","fraction",1e-9,[0,0,0,0,0,0,0],"ppb","dimless",false,null,null,1,false,false,0,"ppb; 10^-9","UCUM","MCnt; MCnc; SFr","Clinical","[ppb] is often used in solution concentrations as 1 ug/L  or 1 ug/kg. Also used to express mole fractions as 1 umol/mol.\\n\\nCan be ambigous and would be better if the metric units was used directly. ","10*-9","10*-9","1",1,false],[false,"parts per trillion","[pptr]","[PPTR]","fraction",1e-12,[0,0,0,0,0,0,0],"pptr","dimless",false,null,null,1,false,false,0,"pptr; 10^-12","UCUM","MCnt; MCnc; SFr","Clinical","[pptr] is often used in solution concentrations as 1 ng/L or 1 ng/kg. Also used to express mole fractions as 1 nmol/mol.\\n\\nCan be ambigous and would be better if the metric units was used directly. ","10*-12","10*-12","1",1,false],[false,"mole","mol","MOL","amount of substance",6.0221367e+23,[0,0,0,0,0,0,0],"mol","si",true,null,null,1,false,false,1,"moles","UCUM","Sub","Clinical","Measure the number of molecules ","10*23","10*23","6.0221367",6.0221367,false],[false,"steradian - solid angle","sr","SR","solid angle",1,[0,0,0,2,0,0,0],"sr","si",true,null,null,1,false,false,0,"square radian; rad2; rad^2","UCUM","Angle","Clinical","unit of solid angle in three-dimensional geometry analagous to radian; used in photometry which measures the perceived brightness of object by human eye (e.g. radiant intensity = watt/steradian)","rad2","RAD2","1",1,false],[false,"hertz","Hz","HZ","frequency",1,[0,-1,0,0,0,0,0],"Hz","si",true,null,null,1,false,false,0,"Herz; frequency; frequencies","UCUM","Freq; Num","Clinical","equal to one cycle per second","s-1","S-1","1",1,false],[false,"newton","N","N","force",1000,[1,-2,1,0,0,0,0],"N","si",true,null,null,1,false,false,0,"Newtons","UCUM","Force","Clinical","unit of force with base units kg.m/s2","kg.m/s2","KG.M/S2","1",1,false],[false,"pascal","Pa","PAL","pressure",1000,[-1,-2,1,0,0,0,0],"Pa","si",true,null,null,1,false,false,0,"pascals","UCUM","Pres","Clinical","standard unit of pressure equal to 1 newton per square meter (N/m2)","N/m2","N/M2","1",1,false],[false,"joule","J","J","energy",1000,[2,-2,1,0,0,0,0],"J","si",true,null,null,1,false,false,0,"joules","UCUM","Enrg","Clinical","unit of energy defined as the work required to move an object 1 m with a force of 1 N (N.m) or an electric charge of 1 C through 1 V (C.V), or to produce 1 W for 1 s (W.s) ","N.m","N.M","1",1,false],[false,"watt","W","W","power",1000,[2,-3,1,0,0,0,0],"W","si",true,null,null,1,false,false,0,"watts","UCUM","EngRat","Clinical","unit of power equal to 1 Joule per second (J/s) =  kg⋅m2⋅s−3","J/s","J/S","1",1,false],[false,"Ampere","A","A","electric current",1,[0,-1,0,0,0,1,0],"A","si",true,null,null,1,false,false,0,"Amperes","UCUM","ElpotRat","Clinical","unit of electric current equal to flow rate of electrons equal to 16.2415×10^18 elementary charges moving past a boundary in one second or 1 Coulomb/second","C/s","C/S","1",1,false],[false,"volt","V","V","electric potential",1000,[2,-2,1,0,0,-1,0],"V","si",true,null,null,1,false,false,0,"volts","UCUM","Elpot","Clinical","unit of electric potential (voltage) = 1 Joule per Coulomb (J/C)","J/C","J/C","1",1,false],[false,"farad","F","F","electric capacitance",0.001,[-2,2,-1,0,0,2,0],"F","si",true,null,null,1,false,false,0,"farads; electric capacitance","UCUM","","Clinical","CGS unit of electric capacitance with base units C/V (Coulomb per Volt)","C/V","C/V","1",1,false],[false,"ohm","Ohm","OHM","electric resistance",1000,[2,-1,1,0,0,-2,0],"Ω","si",true,null,null,1,false,false,0,"Ω; resistance; ohms","UCUM","","Clinical","unit of electrical resistance with units of Volt per Ampere","V/A","V/A","1",1,false],[false,"siemens","S","SIE","electric conductance",0.001,[-2,1,-1,0,0,2,0],"S","si",true,null,null,1,false,false,0,"Reciprocal ohm; mho; Ω−1; conductance","UCUM","","Clinical","unit of electric conductance (the inverse of electrical resistance) equal to ohm^-1","Ohm-1","OHM-1","1",1,false],[false,"weber","Wb","WB","magnetic flux",1000,[2,-1,1,0,0,-1,0],"Wb","si",true,null,null,1,false,false,0,"magnetic flux; webers","UCUM","","Clinical","unit of magnetic flux equal to Volt second","V.s","V.S","1",1,false],[false,"degree Celsius","Cel","CEL","temperature",1,[0,0,0,0,1,0,0],"°C","si",true,null,"Cel",1,true,false,0,"°C; degrees","UCUM","Temp","Clinical","","K",null,null,1,false],[false,"tesla","T","T","magnetic flux density",1000,[0,-1,1,0,0,-1,0],"T","si",true,null,null,1,false,false,0,"Teslas; magnetic field","UCUM","","Clinical","SI unit of magnetic field strength for magnetic field B equal to 1 Weber/square meter =  1 kg/(s2*A)","Wb/m2","WB/M2","1",1,false],[false,"henry","H","H","inductance",1000,[2,0,1,0,0,-2,0],"H","si",true,null,null,1,false,false,0,"henries; inductance","UCUM","","Clinical","unit of electrical inductance; usually expressed in millihenrys (mH) or microhenrys (uH).","Wb/A","WB/A","1",1,false],[false,"lumen","lm","LM","luminous flux",1,[0,0,0,2,0,0,1],"lm","si",true,null,null,1,false,false,0,"luminous flux; lumens","UCUM","","Clinical","unit of luminous flux defined as 1 lm = 1 cd⋅sr (candela times sphere)","cd.sr","CD.SR","1",1,false],[false,"lux","lx","LX","illuminance",1,[-2,0,0,2,0,0,1],"lx","si",true,null,null,1,false,false,0,"illuminance; luxes","UCUM","","Clinical","unit of illuminance equal to one lumen per square meter. ","lm/m2","LM/M2","1",1,false],[false,"becquerel","Bq","BQ","radioactivity",1,[0,-1,0,0,0,0,0],"Bq","si",true,null,null,1,false,false,0,"activity; radiation; becquerels","UCUM","","Clinical","measure of the atomic radiation rate with units s^-1","s-1","S-1","1",1,false],[false,"gray","Gy","GY","energy dose",1,[2,-2,0,0,0,0,0],"Gy","si",true,null,null,1,false,false,0,"absorbed doses; ionizing radiation doses; kerma; grays","UCUM","EngCnt","Clinical","unit of ionizing radiation dose with base units of 1 joule of radiation energy per kilogram of matter","J/kg","J/KG","1",1,false],[false,"sievert","Sv","SV","dose equivalent",1,[2,-2,0,0,0,0,0],"Sv","si",true,null,null,1,false,false,0,"sieverts; radiation dose quantities; equivalent doses; effective dose; operational dose; committed dose","UCUM","","Clinical","SI unit for radiation dose equivalent equal to 1 Joule/kilogram.","J/kg","J/KG","1",1,false],[false,"degree - plane angle","deg","DEG","plane angle",0.017453292519943295,[0,0,0,1,0,0,0],"°","iso1000",false,null,null,1,false,false,0,"°; degree of arc; arc degree; arcdegree; angle","UCUM","Angle","Clinical","one degree is equivalent to π/180 radians.","[pi].rad/360","[PI].RAD/360","2",2,false],[false,"gon","gon","GON","plane angle",0.015707963267948967,[0,0,0,1,0,0,0],"□<sup>g</sup>","iso1000",false,null,null,1,false,false,0,"gon (grade); gons","UCUM","Angle","Nonclinical","unit of plane angle measurement equal to 1/400 circle","deg","DEG","0.9",0.9,false],[false,"arc minute","\'","\'","plane angle",0.0002908882086657216,[0,0,0,1,0,0,0],"\'","iso1000",false,null,null,1,false,false,0,"arcminutes; arcmin; arc minutes; arc mins","UCUM","Angle","Clinical","equal to 1/60 degree; used in optometry and opthamology (e.g. visual acuity tests)","deg/60","DEG/60","1",1,false],[false,"arc second","\'\'","\'\'","plane angle",0.00000484813681109536,[0,0,0,1,0,0,0],"\'\'","iso1000",false,null,null,1,false,false,0,"arcseconds; arcsecs","UCUM","Angle","Clinical","equal to 1/60 arcminute = 1/3600 degree; used in optometry and opthamology (e.g. visual acuity tests)","\'/60","\'/60","1",1,false],[false,"Liters","l","L","volume",0.001,[3,0,0,0,0,0,0],"l","iso1000",true,null,null,1,false,false,0,"cubic decimeters; decimeters cubed; decimetres; dm3; dm^3; litres; liters, LT ","UCUM","Vol","Clinical","Because lower case \\"l\\" can be read as the number \\"1\\", though this is a valid UCUM units. UCUM strongly reccomends using  \\"L\\"","dm3","DM3","1",1,false],[false,"Liters","L","L","volume",0.001,[3,0,0,0,0,0,0],"L","iso1000",true,null,null,1,false,false,0,"cubic decimeters; decimeters cubed; decimetres; dm3; dm^3; litres; liters, LT ","UCUM","Vol","Clinical","Because lower case \\"l\\" can be read as the number \\"1\\", though this is a valid UCUM units. UCUM strongly reccomends using  \\"L\\"","l",null,"1",1,false],[false,"are","ar","AR","area",100,[2,0,0,0,0,0,0],"a","iso1000",true,null,null,1,false,false,0,"100 m2; 100 m^2; 100 square meter; meters squared; metres","UCUM","Area","Clinical","metric base unit for area defined as 100 m^2","m2","M2","100",100,false],[false,"minute","min","MIN","time",60,[0,1,0,0,0,0,0],"min","iso1000",false,null,null,1,false,false,0,"minutes","UCUM","Time","Clinical","","s","S","60",60,false],[false,"hour","h","HR","time",3600,[0,1,0,0,0,0,0],"h","iso1000",false,null,null,1,false,false,0,"hours; hrs; age","UCUM","Time","Clinical","","min","MIN","60",60,false],[false,"day","d","D","time",86400,[0,1,0,0,0,0,0],"d","iso1000",false,null,null,1,false,false,0,"days; age; dy; 24 hours; 24 hrs","UCUM","Time","Clinical","","h","HR","24",24,false],[false,"tropical year","a_t","ANN_T","time",31556925.216,[0,1,0,0,0,0,0],"a<sub>t</sub>","iso1000",false,null,null,1,false,false,0,"solar years; a tropical; years","UCUM","Time","Clinical","has an average of 365.242181 days but is constantly changing.","d","D","365.24219",365.24219,false],[false,"mean Julian year","a_j","ANN_J","time",31557600,[0,1,0,0,0,0,0],"a<sub>j</sub>","iso1000",false,null,null,1,false,false,0,"mean Julian yr; a julian; years","UCUM","Time","Clinical","has an average of 365.25 days, and in everyday use, has been replaced by the Gregorian year. However, this unit is used in astronomy to calculate light year. ","d","D","365.25",365.25,false],[false,"mean Gregorian year","a_g","ANN_G","time",31556952,[0,1,0,0,0,0,0],"a<sub>g</sub>","iso1000",false,null,null,1,false,false,0,"mean Gregorian yr; a gregorian; years","UCUM","Time","Clinical","has an average of 365.2425 days and is the most internationally used civil calendar.","d","D","365.2425",365.2425,false],[false,"year","a","ANN","time",31557600,[0,1,0,0,0,0,0],"a","iso1000",false,null,null,1,false,false,0,"years; a; yr, yrs; annum","UCUM","Time","Clinical","","a_j","ANN_J","1",1,false],[false,"week","wk","WK","time",604800,[0,1,0,0,0,0,0],"wk","iso1000",false,null,null,1,false,false,0,"weeks; wks","UCUM","Time","Clinical","","d","D","7",7,false],[false,"synodal month","mo_s","MO_S","time",2551442.976,[0,1,0,0,0,0,0],"mo<sub>s</sub>","iso1000",false,null,null,1,false,false,0,"Moon; synodic month; lunar month; mo-s; mo s; months; moons","UCUM","Time","Nonclinical","has an average of 29.53 days per month, unit used in astronomy","d","D","29.53059",29.53059,false],[false,"mean Julian month","mo_j","MO_J","time",2629800,[0,1,0,0,0,0,0],"mo<sub>j</sub>","iso1000",false,null,null,1,false,false,0,"mo-julian; mo Julian; months","UCUM","Time","Clinical","has an average of 30.435 days per month","a_j/12","ANN_J/12","1",1,false],[false,"mean Gregorian month","mo_g","MO_G","time",2629746,[0,1,0,0,0,0,0],"mo<sub>g</sub>","iso1000",false,null,null,1,false,false,0,"months; month-gregorian; mo-gregorian","UCUM","Time","Clinical","has an average 30.436875 days per month and is from the most internationally used civil calendar.","a_g/12","ANN_G/12","1",1,false],[false,"month","mo","MO","time",2629800,[0,1,0,0,0,0,0],"mo","iso1000",false,null,null,1,false,false,0,"months; duration","UCUM","Time","Clinical","based on Julian calendar which has an average of 30.435 days per month (this unit is used in astronomy but not in everyday life - see mo_g)","mo_j","MO_J","1",1,false],[false,"metric ton","t","TNE","mass",1000000,[0,0,1,0,0,0,0],"t","iso1000",true,null,null,1,false,false,0,"tonnes; megagrams; tons","UCUM","Mass","Nonclinical","equal to 1000 kg used in the US (recognized by NIST as metric ton), and internationally (recognized as tonne)","kg","KG","1e3",1000,false],[false,"bar","bar","BAR","pressure",100000000,[-1,-2,1,0,0,0,0],"bar","iso1000",true,null,null,1,false,false,0,"bars","UCUM","Pres","Nonclinical","unit of pressure equal to 10^5 Pascals, primarily used by meteorologists and in weather forecasting","Pa","PAL","1e5",100000,false],[false,"unified atomic mass unit","u","AMU","mass",1.6605402e-24,[0,0,1,0,0,0,0],"u","iso1000",true,null,null,1,false,false,0,"unified atomic mass units; amu; Dalton; Da","UCUM","Mass","Clinical","the mass of 1/12 of an unbound Carbon-12 atom nuclide equal to 1.6606x10^-27 kg ","g","G","1.6605402e-24",1.6605402e-24,false],[false,"astronomic unit","AU","ASU","length",149597870691,[1,0,0,0,0,0,0],"AU","iso1000",false,null,null,1,false,false,0,"AU; units","UCUM","Len","Clinical","unit of length used in astronomy for measuring distance in Solar system","Mm","MAM","149597.870691",149597.870691,false],[false,"parsec","pc","PRS","length",30856780000000000,[1,0,0,0,0,0,0],"pc","iso1000",true,null,null,1,false,false,0,"parsecs","UCUM","Len","Clinical","unit of length equal to 3.26 light years, nad used to measure large distances to objects outside our Solar System","m","M","3.085678e16",30856780000000000,false],[false,"velocity of light in a vacuum","[c]","[C]","velocity",299792458,[1,-1,0,0,0,0,0],"<i>c</i>","const",true,null,null,1,false,false,0,"speed of light","UCUM","Vel","Constant","equal to 299792458 m/s (approximately 3 x 10^8 m/s)","m/s","M/S","299792458",299792458,false],[false,"Planck constant","[h]","[H]","action",6.6260755e-31,[2,-1,1,0,0,0,0],"<i>h</i>","const",true,null,null,1,false,false,0,"Planck\'s constant","UCUM","","Constant","constant = 6.62607004 × 10-34 m2.kg/s; defined as quantum of action","J.s","J.S","6.6260755e-34",6.6260755e-34,false],[false,"Boltzmann constant","[k]","[K]","(unclassified)",1.380658e-20,[2,-2,1,0,-1,0,0],"<i>k</i>","const",true,null,null,1,false,false,0,"k; kB","UCUM","","Constant","physical constant relating energy at the individual particle level with temperature = 1.38064852 ×10^−23 J/K","J/K","J/K","1.380658e-23",1.380658e-23,false],[false,"permittivity of vacuum - electric","[eps_0]","[EPS_0]","electric permittivity",8.854187817000001e-15,[-3,2,-1,0,0,2,0],"<i>ε<sub><r>0</r></sub></i>","const",true,null,null,1,false,false,0,"ε0; Electric Constant; vacuum permittivity; permittivity of free space ","UCUM","","Constant","approximately equal to 8.854 × 10^−12 F/m (farads per meter)","F/m","F/M","8.854187817e-12",8.854187817e-12,false],[false,"permeability of vacuum - magnetic","[mu_0]","[MU_0]","magnetic permeability",0.0012566370614359172,[1,0,1,0,0,-2,0],"<i>μ<sub><r>0</r></sub></i>","const",true,null,null,1,false,false,0,"μ0; vacuum permeability; permeability of free space; magnetic constant","UCUM","","Constant","equal to 4π×10^−7 N/A2 (Newtons per square ampere) ≈ 1.2566×10^−6 H/m (Henry per meter)","N/A2","4.[PI].10*-7.N/A2","1",0.0000012566370614359173,false],[false,"elementary charge","[e]","[E]","electric charge",1.60217733e-19,[0,0,0,0,0,1,0],"<i>e</i>","const",true,null,null,1,false,false,0,"e; q; electric charges","UCUM","","Constant","the magnitude of the electric charge carried by a single electron or proton ≈ 1.60217×10^-19 Coulombs","C","C","1.60217733e-19",1.60217733e-19,false],[false,"electronvolt","eV","EV","energy",1.60217733e-16,[2,-2,1,0,0,0,0],"eV","iso1000",true,null,null,1,false,false,0,"Electron Volts; electronvolts","UCUM","Eng","Clinical","unit of kinetic energy = 1 V * 1.602×10^−19 C = 1.6×10−19 Joules","[e].V","[E].V","1",1,false],[false,"electron mass","[m_e]","[M_E]","mass",9.1093897e-28,[0,0,1,0,0,0,0],"<i>m<sub><r>e</r></sub></i>","const",true,null,null,1,false,false,0,"electron rest mass; me","UCUM","Mass","Constant","approximately equal to 9.10938356 × 10-31 kg; defined as the mass of a stationary electron","g","g","9.1093897e-28",9.1093897e-28,false],[false,"proton mass","[m_p]","[M_P]","mass",1.6726231e-24,[0,0,1,0,0,0,0],"<i>m<sub><r>p</r></sub></i>","const",true,null,null,1,false,false,0,"mp; masses","UCUM","Mass","Constant","approximately equal to 1.672622×10−27 kg","g","g","1.6726231e-24",1.6726231e-24,false],[false,"Newtonian constant of gravitation","[G]","[GC]","(unclassified)",6.67259e-14,[3,-2,-1,0,0,0,0],"<i>G</i>","const",true,null,null,1,false,false,0,"G; gravitational constant; Newton\'s constant","UCUM","","Constant","gravitational constant = 6.674×10−11 N⋅m2/kg2","m3.kg-1.s-2","M3.KG-1.S-2","6.67259e-11",6.67259e-11,false],[false,"standard acceleration of free fall","[g]","[G]","acceleration",9.80665,[1,-2,0,0,0,0,0],"<i>g<sub>n</sub></i>","const",true,null,null,1,false,false,0,"standard gravity; g; ɡ0; ɡn","UCUM","Accel","Constant","defined by standard = 9.80665 m/s2","m/s2","M/S2","980665e-5",9.80665,false],[false,"Torr","Torr","Torr","pressure",133322,[-1,-2,1,0,0,0,0],"Torr","const",false,null,null,1,false,false,0,"torrs","UCUM","Pres","Clinical","1 torr = 1 mmHg; unit used to measure blood pressure","Pa","PAL","133.322",133.322,false],[false,"standard atmosphere","atm","ATM","pressure",101325000,[-1,-2,1,0,0,0,0],"atm","const",false,null,null,1,false,false,0,"reference pressure; atmos; std atmosphere","UCUM","Pres","Clinical","defined as being precisely equal to 101,325 Pa","Pa","PAL","101325",101325,false],[false,"light-year","[ly]","[LY]","length",9460730472580800,[1,0,0,0,0,0,0],"l.y.","const",true,null,null,1,false,false,0,"light years; ly","UCUM","Len","Constant","unit of astronomal distance = 5.88×10^12 mi","[c].a_j","[C].ANN_J","1",1,false],[false,"gram-force","gf","GF","force",9.80665,[1,-2,1,0,0,0,0],"gf","const",true,null,null,1,false,false,0,"Newtons; gram forces","UCUM","Force","Clinical","May be specific to unit related to cardiac output","g.[g]","G.[G]","1",1,false],[false,"Kayser","Ky","KY","lineic number",100,[-1,0,0,0,0,0,0],"K","cgs",true,null,null,1,false,false,0,"wavenumbers; kaysers","UCUM","InvLen","Clinical","unit of wavelength equal to cm^-1","cm-1","CM-1","1",1,false],[false,"Gal","Gal","GL","acceleration",0.01,[1,-2,0,0,0,0,0],"Gal","cgs",true,null,null,1,false,false,0,"galileos; Gals","UCUM","Accel","Clinical","unit of acceleration used in gravimetry; equivalent to cm/s2 ","cm/s2","CM/S2","1",1,false],[false,"dyne","dyn","DYN","force",0.01,[1,-2,1,0,0,0,0],"dyn","cgs",true,null,null,1,false,false,0,"dynes","UCUM","Force","Clinical","unit of force equal to 10^-5 Newtons","g.cm/s2","G.CM/S2","1",1,false],[false,"erg","erg","ERG","energy",0.0001,[2,-2,1,0,0,0,0],"erg","cgs",true,null,null,1,false,false,0,"10^-7 Joules, 10-7 Joules; 100 nJ; 100 nanoJoules; 1 dyne cm; 1 g.cm2/s2","UCUM","Eng","Clinical","unit of energy = 1 dyne centimeter = 10^-7 Joules","dyn.cm","DYN.CM","1",1,false],[false,"Poise","P","P","dynamic viscosity",100,[-1,-1,1,0,0,0,0],"P","cgs",true,null,null,1,false,false,0,"dynamic viscosity; poises","UCUM","Visc","Clinical","unit of dynamic viscosity where 1 Poise = 1/10 Pascal second","dyn.s/cm2","DYN.S/CM2","1",1,false],[false,"Biot","Bi","BI","electric current",10,[0,-1,0,0,0,1,0],"Bi","cgs",true,null,null,1,false,false,0,"Bi; abamperes; abA","UCUM","ElpotRat","Clinical","equal to 10 amperes","A","A","10",10,false],[false,"Stokes","St","ST","kinematic viscosity",0.0001,[2,-1,0,0,0,0,0],"St","cgs",true,null,null,1,false,false,0,"kinematic viscosity","UCUM","Visc","Clinical","unit of kimematic viscosity with units cm2/s","cm2/s","CM2/S","1",1,false],[false,"Maxwell","Mx","MX","flux of magnetic induction",0.00001,[2,-1,1,0,0,-1,0],"Mx","cgs",true,null,null,1,false,false,0,"magnetix flux; Maxwells","UCUM","","Clinical","unit of magnetic flux","Wb","WB","1e-8",1e-8,false],[false,"Gauss","G","GS","magnetic flux density",0.1,[0,-1,1,0,0,-1,0],"Gs","cgs",true,null,null,1,false,false,0,"magnetic fields; magnetic flux density; induction; B","UCUM","magnetic","Clinical","CGS unit of magnetic flux density, known as magnetic field B; defined as one maxwell unit per square centimeter (see Oersted for CGS unit for H field)","T","T","1e-4",0.0001,false],[false,"Oersted","Oe","OE","magnetic field intensity",79.57747154594767,[-1,-1,0,0,0,1,0],"Oe","cgs",true,null,null,1,false,false,0,"H magnetic B field; Oersteds","UCUM","","Clinical","CGS unit of the auxiliary magnetic field H defined as 1 dyne per unit pole = 1000/4π amperes per meter (see Gauss for CGS unit for B field)","A/m","/[PI].A/M","250",79.57747154594767,false],[false,"Gilbert","Gb","GB","magnetic tension",0.7957747154594768,[0,-1,0,0,0,1,0],"Gb","cgs",true,null,null,1,false,false,0,"Gi; magnetomotive force; Gilberts","UCUM","","Clinical","unit of magnetomotive force (magnetic potential)","Oe.cm","OE.CM","1",1,false],[false,"stilb","sb","SB","lum. intensity density",10000,[-2,0,0,0,0,0,1],"sb","cgs",true,null,null,1,false,false,0,"stilbs","UCUM","","Obsolete","unit of luminance; equal to and replaced by unit candela per square centimeter (cd/cm2)","cd/cm2","CD/CM2","1",1,false],[false,"Lambert","Lmb","LMB","brightness",3183.098861837907,[-2,0,0,0,0,0,1],"L","cgs",true,null,null,1,false,false,0,"luminance; lamberts","UCUM","","Clinical","unit of luminance defined as 1 lambert = 1/ π candela per square meter","cd/cm2/[pi]","CD/CM2/[PI]","1",1,false],[false,"phot","ph","PHT","illuminance",0.0001,[-2,0,0,2,0,0,1],"ph","cgs",true,null,null,1,false,false,0,"phots","UCUM","","Clinical","CGS photometric unit of illuminance, or luminous flux through an area equal to 10000 lumens per square meter = 10000 lux","lx","LX","1e-4",0.0001,false],[false,"Curie","Ci","CI","radioactivity",37000000000,[0,-1,0,0,0,0,0],"Ci","cgs",true,null,null,1,false,false,0,"curies","UCUM","","Obsolete","unit for measuring atomic disintegration rate; replaced by the Bequerel (Bq) unit","Bq","BQ","37e9",37000000000,false],[false,"Roentgen","R","ROE","ion dose",2.58e-7,[0,0,-1,0,0,1,0],"R","cgs",true,null,null,1,false,false,0,"röntgen; Roentgens","UCUM","","Clinical","unit of exposure of X-rays and gamma rays in air; unit used primarily in the US but strongly discouraged by NIST","C/kg","C/KG","2.58e-4",0.000258,false],[false,"radiation absorbed dose","RAD","[RAD]","energy dose",0.01,[2,-2,0,0,0,0,0],"RAD","cgs",true,null,null,1,false,false,0,"doses","UCUM","","Clinical","unit of radiation absorbed dose used primarily in the US with base units 100 ergs per gram of material. Also see the SI unit Gray (Gy).","erg/g","ERG/G","100",100,false],[false,"radiation equivalent man","REM","[REM]","dose equivalent",0.01,[2,-2,0,0,0,0,0],"REM","cgs",true,null,null,1,false,false,0,"Roentgen Equivalent in Man; rems; dose equivalents","UCUM","","Clinical","unit of equivalent dose which measures the effect of radiation on humans equal to 0.01 sievert. Used primarily in the US. Also see SI unit Sievert (Sv)","RAD","[RAD]","1",1,false],[false,"inch","[in_i]","[IN_I]","length",0.025400000000000002,[1,0,0,0,0,0,0],"in","intcust",false,null,null,1,false,false,0,"inches; in; international inch; body height","UCUM","Len","Clinical","standard unit for inch in the US and internationally","cm","CM","254e-2",2.54,false],[false,"foot","[ft_i]","[FT_I]","length",0.3048,[1,0,0,0,0,0,0],"ft","intcust",false,null,null,1,false,false,0,"ft; fts; foot; international foot; feet; international feet; height","UCUM","Len","Clinical","unit used in the US and internationally","[in_i]","[IN_I]","12",12,false],[false,"yard","[yd_i]","[YD_I]","length",0.9144000000000001,[1,0,0,0,0,0,0],"yd","intcust",false,null,null,1,false,false,0,"international yards; yds; distance","UCUM","Len","Clinical","standard unit used in the US and internationally","[ft_i]","[FT_I]","3",3,false],[false,"mile","[mi_i]","[MI_I]","length",1609.344,[1,0,0,0,0,0,0],"mi","intcust",false,null,null,1,false,false,0,"international miles; mi I; statute mile","UCUM","Len","Clinical","standard unit used in the US and internationally","[ft_i]","[FT_I]","5280",5280,false],[false,"fathom","[fth_i]","[FTH_I]","depth of water",1.8288000000000002,[1,0,0,0,0,0,0],"fth","intcust",false,null,null,1,false,false,0,"international fathoms","UCUM","Len","Nonclinical","unit used in the US and internationally to measure depth of water; same length as the US fathom","[ft_i]","[FT_I]","6",6,false],[false,"nautical mile","[nmi_i]","[NMI_I]","length",1852,[1,0,0,0,0,0,0],"n.mi","intcust",false,null,null,1,false,false,0,"nautical mile; nautical miles; international nautical mile; international nautical miles; nm; n.m.; nmi","UCUM","Len","Nonclinical","standard unit used in the US and internationally","m","M","1852",1852,false],[false,"knot","[kn_i]","[KN_I]","velocity",0.5144444444444445,[1,-1,0,0,0,0,0],"knot","intcust",false,null,null,1,false,false,0,"kn; kt; international knots","UCUM","Vel","Nonclinical","defined as equal to one nautical mile (1.852 km) per hour","[nmi_i]/h","[NMI_I]/H","1",1,false],[false,"square inch","[sin_i]","[SIN_I]","area",0.0006451600000000001,[2,0,0,0,0,0,0],null,"intcust",false,null,null,1,false,false,0,"in2; in^2; inches squared; sq inch; inches squared; international","UCUM","Area","Clinical","standard unit used in the US and internationally","[in_i]2","[IN_I]2","1",1,false],[false,"square foot","[sft_i]","[SFT_I]","area",0.09290304,[2,0,0,0,0,0,0],null,"intcust",false,null,null,1,false,false,0,"ft2; ft^2; ft squared; sq ft; feet; international","UCUM","Area","Clinical","standard unit used in the US and internationally","[ft_i]2","[FT_I]2","1",1,false],[false,"square yard","[syd_i]","[SYD_I]","area",0.8361273600000002,[2,0,0,0,0,0,0],null,"intcust",false,null,null,1,false,false,0,"yd2; yd^2; sq. yds; yards squared; international","UCUM","Area","Clinical","standard unit used in the US and internationally","[yd_i]2","[YD_I]2","1",1,false],[false,"cubic inch","[cin_i]","[CIN_I]","volume",0.000016387064000000003,[3,0,0,0,0,0,0],null,"intcust",false,null,null,1,false,false,0,"in3; in^3; in*3; inches^3; inches*3; cu. in; cu in; cubic inches; inches cubed; cin","UCUM","Vol","Clinical","standard unit used in the US and internationally","[in_i]3","[IN_I]3","1",1,false],[false,"cubic foot","[cft_i]","[CFT_I]","volume",0.028316846592000004,[3,0,0,0,0,0,0],null,"intcust",false,null,null,1,false,false,0,"ft3; ft^3; ft*3; cu. ft; cubic feet; cubed; [ft_i]3; international","UCUM","Vol","Clinical","","[ft_i]3","[FT_I]3","1",1,false],[false,"cubic yard","[cyd_i]","[CYD_I]","volume",0.7645548579840002,[3,0,0,0,0,0,0],"cu.yd","intcust",false,null,null,1,false,false,0,"cubic yards; cubic yds; cu yards; CYs; yards^3; yd^3; yds^3; yd3; yds3","UCUM","Vol","Nonclinical","standard unit used in the US and internationally","[yd_i]3","[YD_I]3","1",1,false],[false,"board foot","[bf_i]","[BF_I]","volume",0.002359737216,[3,0,0,0,0,0,0],null,"intcust",false,null,null,1,false,false,0,"BDFT; FBM; BF; board feet; international","UCUM","Vol","Nonclinical","unit of volume used to measure lumber","[in_i]3","[IN_I]3","144",144,false],[false,"cord","[cr_i]","[CR_I]","volume",3.6245563637760005,[3,0,0,0,0,0,0],null,"intcust",false,null,null,1,false,false,0,"crd I; international cords","UCUM","Vol","Nonclinical","unit of measure of dry volume used to measure firewood equal 128 ft3","[ft_i]3","[FT_I]3","128",128,false],[false,"mil","[mil_i]","[MIL_I]","length",0.000025400000000000004,[1,0,0,0,0,0,0],"mil","intcust",false,null,null,1,false,false,0,"thou, thousandth; mils; international","UCUM","Len","Clinical","equal to 0.001 international inch","[in_i]","[IN_I]","1e-3",0.001,false],[false,"circular mil","[cml_i]","[CML_I]","area",5.067074790974979e-10,[2,0,0,0,0,0,0],"circ.mil","intcust",false,null,null,1,false,false,0,"circular mils; cml I; international","UCUM","Area","Clinical","","[pi]/4.[mil_i]2","[PI]/4.[MIL_I]2","1",1,false],[false,"hand","[hd_i]","[HD_I]","height of horses",0.10160000000000001,[1,0,0,0,0,0,0],"hd","intcust",false,null,null,1,false,false,0,"hands; international","UCUM","Len","Nonclinical","used to measure horse height","[in_i]","[IN_I]","4",4,false],[false,"foot - US","[ft_us]","[FT_US]","length",0.3048006096012192,[1,0,0,0,0,0,0],"ft<sub>us</sub>","us-lengths",false,null,null,1,false,false,0,"US foot; foot US; us ft; ft us; height; visual distance; feet","UCUM","Len","Obsolete","Better to use [ft_i] which refers to the length used worldwide, including in the US;  [ft_us] may be confused with land survey units. ","m/3937","M/3937","1200",1200,false],[false,"yard - US","[yd_us]","[YD_US]","length",0.9144018288036575,[1,0,0,0,0,0,0],null,"us-lengths",false,null,null,1,false,false,0,"US yards; us yds; distance","UCUM","Len; Nrat","Obsolete","Better to use [yd_i] which refers to the length used worldwide, including in the US; [yd_us] refers to unit used in land surveys in the US","[ft_us]","[FT_US]","3",3,false],[false,"inch - US","[in_us]","[IN_US]","length",0.0254000508001016,[1,0,0,0,0,0,0],null,"us-lengths",false,null,null,1,false,false,0,"US inches; in us; us in; inch US","UCUM","Len","Obsolete","Better to use [in_i] which refers to the length used worldwide, including in the US","[ft_us]/12","[FT_US]/12","1",1,false],[false,"rod - US","[rd_us]","[RD_US]","length",5.029210058420117,[1,0,0,0,0,0,0],null,"us-lengths",false,null,null,1,false,false,0,"US rod; US rods; rd US; US rd","UCUM","Len","Obsolete","","[ft_us]","[FT_US]","16.5",16.5,false],[false,"Gunter\'s chain - US","[ch_us]","[CH_US]","length",20.116840233680467,[1,0,0,0,0,0,0],null,"us-lengths",false,null,null,1,false,false,0,"surveyor\'s chain; Surveyor\'s chain USA; Gunter’s measurement; surveyor’s measurement; Gunter\'s Chain USA","UCUM","Len","Obsolete","historical unit used for land survey used only in the US","[rd_us]","[RD_US]","4",4,false],[false,"link for Gunter\'s chain - US","[lk_us]","[LK_US]","length",0.20116840233680466,[1,0,0,0,0,0,0],null,"us-lengths",false,null,null,1,false,false,0,"Links for Gunter\'s Chain USA","UCUM","Len","Obsolete","","[ch_us]/100","[CH_US]/100","1",1,false],[false,"Ramden\'s chain - US","[rch_us]","[RCH_US]","length",30.480060960121918,[1,0,0,0,0,0,0],null,"us-lengths",false,null,null,1,false,false,0,"Ramsden\'s chain; engineer\'s chains","UCUM","Len","Obsolete","distance measuring device used for land survey","[ft_us]","[FT_US]","100",100,false],[false,"link for Ramden\'s chain - US","[rlk_us]","[RLK_US]","length",0.3048006096012192,[1,0,0,0,0,0,0],null,"us-lengths",false,null,null,1,false,false,0,"links for Ramsden\'s chain","UCUM","Len","Obsolete","","[rch_us]/100","[RCH_US]/100","1",1,false],[false,"fathom - US","[fth_us]","[FTH_US]","length",1.828803657607315,[1,0,0,0,0,0,0],null,"us-lengths",false,null,null,1,false,false,0,"US fathoms; fathom USA; fth us","UCUM","Len","Obsolete","same length as the international fathom - better to use international fathom ([fth_i])","[ft_us]","[FT_US]","6",6,false],[false,"furlong - US","[fur_us]","[FUR_US]","length",201.16840233680466,[1,0,0,0,0,0,0],null,"us-lengths",false,null,null,1,false,false,0,"US furlongs; fur us","UCUM","Len","Nonclinical","distance unit in horse racing","[rd_us]","[RD_US]","40",40,false],[false,"mile - US","[mi_us]","[MI_US]","length",1609.3472186944373,[1,0,0,0,0,0,0],null,"us-lengths",false,null,null,1,false,false,0,"U.S. Survey Miles; US statute miles; survey mi; US mi; distance","UCUM","Len","Nonclinical","Better to use [mi_i] which refers to the length used worldwide, including in the US","[fur_us]","[FUR_US]","8",8,false],[false,"acre - US","[acr_us]","[ACR_US]","area",4046.872609874252,[2,0,0,0,0,0,0],null,"us-lengths",false,null,null,1,false,false,0,"Acre USA Survey; Acre USA; survey acres","UCUM","Area","Nonclinical","an older unit based on pre 1959 US statute lengths that is still sometimes used in the US only for land survey purposes. ","[rd_us]2","[RD_US]2","160",160,false],[false,"square rod - US","[srd_us]","[SRD_US]","area",25.292953811714074,[2,0,0,0,0,0,0],null,"us-lengths",false,null,null,1,false,false,0,"rod2; rod^2; sq. rod; rods squared","UCUM","Area","Nonclinical","Used only in the US to measure land area, based on US statute land survey length units","[rd_us]2","[RD_US]2","1",1,false],[false,"square mile - US","[smi_us]","[SMI_US]","area",2589998.470319521,[2,0,0,0,0,0,0],null,"us-lengths",false,null,null,1,false,false,0,"mi2; mi^2; sq mi; miles squared","UCUM","Area","Nonclinical","historical unit used only in the US for land survey purposes (based on the US survey mile), not the internationally recognized [mi_i]","[mi_us]2","[MI_US]2","1",1,false],[false,"section","[sct]","[SCT]","area",2589998.470319521,[2,0,0,0,0,0,0],null,"us-lengths",false,null,null,1,false,false,0,"sct; sections","UCUM","Area","Nonclinical","tract of land approximately equal to 1 mile square containing 640 acres","[mi_us]2","[MI_US]2","1",1,false],[false,"township","[twp]","[TWP]","area",93239944.93150276,[2,0,0,0,0,0,0],null,"us-lengths",false,null,null,1,false,false,0,"twp; townships","UCUM","Area","Nonclinical","land measurement equal to 6 mile square","[sct]","[SCT]","36",36,false],[false,"mil - US","[mil_us]","[MIL_US]","length",0.0000254000508001016,[1,0,0,0,0,0,0],null,"us-lengths",false,null,null,1,false,false,0,"thou, thousandth; mils","UCUM","Len","Obsolete","better to use [mil_i] which is based on the internationally recognized inch","[in_us]","[IN_US]","1e-3",0.001,false],[false,"inch - British","[in_br]","[IN_BR]","length",0.025399980000000003,[1,0,0,0,0,0,0],null,"brit-length",false,null,null,1,false,false,0,"imperial inches; imp in; br in; british inches","UCUM","Len","Obsolete","","cm","CM","2.539998",2.539998,false],[false,"foot - British","[ft_br]","[FT_BR]","length",0.30479976000000003,[1,0,0,0,0,0,0],null,"brit-length",false,null,null,1,false,false,0,"British Foot; Imperial Foot; feet; imp fts; br fts","UCUM","Len","Obsolete","","[in_br]","[IN_BR]","12",12,false],[false,"rod - British","[rd_br]","[RD_BR]","length",5.02919604,[1,0,0,0,0,0,0],null,"brit-length",false,null,null,1,false,false,0,"British rods; br rd","UCUM","Len","Obsolete","","[ft_br]","[FT_BR]","16.5",16.5,false],[false,"Gunter\'s chain - British","[ch_br]","[CH_BR]","length",20.11678416,[1,0,0,0,0,0,0],null,"brit-length",false,null,null,1,false,false,0,"Gunter\'s Chain British; Gunters Chain British; Surveyor\'s Chain British","UCUM","Len","Obsolete","historical unit used for land survey used only in Great Britain","[rd_br]","[RD_BR]","4",4,false],[false,"link for Gunter\'s chain - British","[lk_br]","[LK_BR]","length",0.2011678416,[1,0,0,0,0,0,0],null,"brit-length",false,null,null,1,false,false,0,"Links for Gunter\'s Chain British","UCUM","Len","Obsolete","","[ch_br]/100","[CH_BR]/100","1",1,false],[false,"fathom - British","[fth_br]","[FTH_BR]","length",1.82879856,[1,0,0,0,0,0,0],null,"brit-length",false,null,null,1,false,false,0,"British fathoms; imperial fathoms; br fth; imp fth","UCUM","Len","Obsolete","","[ft_br]","[FT_BR]","6",6,false],[false,"pace - British","[pc_br]","[PC_BR]","length",0.7619994000000001,[1,0,0,0,0,0,0],null,"brit-length",false,null,null,1,false,false,0,"British paces; br pc","UCUM","Len","Nonclinical","traditional unit of length equal to 152.4 centimeters, or 1.52 meter. ","[ft_br]","[FT_BR]","2.5",2.5,false],[false,"yard - British","[yd_br]","[YD_BR]","length",0.91439928,[1,0,0,0,0,0,0],null,"brit-length",false,null,null,1,false,false,0,"British yards; Br yds; distance","UCUM","Len","Obsolete","","[ft_br]","[FT_BR]","3",3,false],[false,"mile - British","[mi_br]","[MI_BR]","length",1609.3427328000002,[1,0,0,0,0,0,0],null,"brit-length",false,null,null,1,false,false,0,"imperial miles; British miles; English statute miles; imp mi, br mi","UCUM","Len","Obsolete","","[ft_br]","[FT_BR]","5280",5280,false],[false,"nautical mile - British","[nmi_br]","[NMI_BR]","length",1853.1825408000002,[1,0,0,0,0,0,0],null,"brit-length",false,null,null,1,false,false,0,"British nautical miles; Imperial nautical miles; Admiralty miles; n.m. br; imp nm","UCUM","Len","Obsolete","","[ft_br]","[FT_BR]","6080",6080,false],[false,"knot - British","[kn_br]","[KN_BR]","velocity",0.5147729280000001,[1,-1,0,0,0,0,0],null,"brit-length",false,null,null,1,false,false,0,"British knots; kn br; kt","UCUM","Vel","Obsolete","based on obsolete British nautical mile ","[nmi_br]/h","[NMI_BR]/H","1",1,false],[false,"acre","[acr_br]","[ACR_BR]","area",4046.850049400269,[2,0,0,0,0,0,0],null,"brit-length",false,null,null,1,false,false,0,"Imperial acres; British; a; ac; ar; acr","UCUM","Area","Nonclinical","the standard unit for acre used in the US and internationally","[yd_br]2","[YD_BR]2","4840",4840,false],[false,"gallon - US","[gal_us]","[GAL_US]","fluid volume",0.0037854117840000006,[3,0,0,0,0,0,0],null,"us-volumes",false,null,null,1,false,false,0,"US gallons; US liquid gallon; gal us; Queen Anne\'s wine gallon","UCUM","Vol","Nonclinical","only gallon unit used in the US; [gal_us] is only used in some other countries in South American and Africa to measure gasoline volume","[in_i]3","[IN_I]3","231",231,false],[false,"barrel - US","[bbl_us]","[BBL_US]","fluid volume",0.158987294928,[3,0,0,0,0,0,0],null,"us-volumes",false,null,null,1,false,false,0,"bbl","UCUM","Vol","Nonclinical","[bbl_us] is the standard unit for oil barrel, which is a unit only used in the US to measure the volume oil. ","[gal_us]","[GAL_US]","42",42,false],[false,"quart - US","[qt_us]","[QT_US]","fluid volume",0.0009463529460000001,[3,0,0,0,0,0,0],null,"us-volumes",false,null,null,1,false,false,0,"US quarts; us qts","UCUM","Vol","Clinical","Used only in the US","[gal_us]/4","[GAL_US]/4","1",1,false],[false,"pint - US","[pt_us]","[PT_US]","fluid volume",0.00047317647300000007,[3,0,0,0,0,0,0],null,"us-volumes",false,null,null,1,false,false,0,"US pints; pint US; liquid pint; pt us; us pt","UCUM","Vol","Clinical","Used only in the US","[qt_us]/2","[QT_US]/2","1",1,false],[false,"gill - US","[gil_us]","[GIL_US]","fluid volume",0.00011829411825000002,[3,0,0,0,0,0,0],null,"us-volumes",false,null,null,1,false,false,0,"US gills; gil us","UCUM","Vol","Nonclinical","only used in the context of alcohol volume in the US","[pt_us]/4","[PT_US]/4","1",1,false],[false,"fluid ounce - US","[foz_us]","[FOZ_US]","fluid volume",0.000029573529562500005,[3,0,0,0,0,0,0],"oz fl","us-volumes",false,null,null,1,false,false,0,"US fluid ounces; fl ozs; FO; fl. oz.; foz us","UCUM","Vol","Clinical","unit used only in the US","[gil_us]/4","[GIL_US]/4","1",1,false],[false,"fluid dram - US","[fdr_us]","[FDR_US]","fluid volume",0.0000036966911953125006,[3,0,0,0,0,0,0],null,"us-volumes",false,null,null,1,false,false,0,"US fluid drams; fdr us","UCUM","Vol","Nonclinical","equal to 1/8 US fluid ounce = 3.69 mL; used informally to mean small amount of liquor, especially Scotch whiskey","[foz_us]/8","[FOZ_US]/8","1",1,false],[false,"minim - US","[min_us]","[MIN_US]","fluid volume",6.1611519921875e-8,[3,0,0,0,0,0,0],null,"us-volumes",false,null,null,1,false,false,0,"min US; US min; ♏ US","UCUM","Vol","Obsolete","","[fdr_us]/60","[FDR_US]/60","1",1,false],[false,"cord - US","[crd_us]","[CRD_US]","fluid volume",3.6245563637760005,[3,0,0,0,0,0,0],null,"us-volumes",false,null,null,1,false,false,0,"US cord; US cords; crd us; us crd","UCUM","Vol","Nonclinical","unit of measure of dry volume used to measure firewood equal 128 ft3 (the same as international cord [cr_i])","[ft_i]3","[FT_I]3","128",128,false],[false,"bushel - US","[bu_us]","[BU_US]","dry volume",0.03523907016688001,[3,0,0,0,0,0,0],null,"us-volumes",false,null,null,1,false,false,0,"US bushels; US bsh; US bu","UCUM","Vol","Obsolete","Historical unit of dry volume that is rarely used today","[in_i]3","[IN_I]3","2150.42",2150.42,false],[false,"gallon - historical","[gal_wi]","[GAL_WI]","dry volume",0.004404883770860001,[3,0,0,0,0,0,0],null,"us-volumes",false,null,null,1,false,false,0,"Corn Gallon British; Dry Gallon US; Gallons Historical; Grain Gallon British; Winchester Corn Gallon; historical winchester gallons; wi gal","UCUM","Vol","Obsolete","historical unit of dry volume no longer used","[bu_us]/8","[BU_US]/8","1",1,false],[false,"peck - US","[pk_us]","[PK_US]","dry volume",0.008809767541720002,[3,0,0,0,0,0,0],null,"us-volumes",false,null,null,1,false,false,0,"US pecks; US pk","UCUM","Vol","Nonclinical","unit of dry volume rarely used today (can be used to measure volume of apples)","[bu_us]/4","[BU_US]/4","1",1,false],[false,"dry quart - US","[dqt_us]","[DQT_US]","dry volume",0.0011012209427150002,[3,0,0,0,0,0,0],null,"us-volumes",false,null,null,1,false,false,0,"dry quarts; dry quart US; US dry quart; dry qt; us dry qt; dqt; dqt us","UCUM","Vol","Nonclinical","historical unit of dry volume only in the US, but is rarely used today","[pk_us]/8","[PK_US]/8","1",1,false],[false,"dry pint - US","[dpt_us]","[DPT_US]","dry volume",0.0005506104713575001,[3,0,0,0,0,0,0],null,"us-volumes",false,null,null,1,false,false,0,"dry pints; dry pint US; US dry pint; dry pt; dpt; dpt us","UCUM","Vol","Nonclinical","historical unit of dry volume only in the US, but is rarely used today","[dqt_us]/2","[DQT_US]/2","1",1,false],[false,"tablespoon - US","[tbs_us]","[TBS_US]","volume",0.000014786764781250002,[3,0,0,0,0,0,0],null,"us-volumes",false,null,null,1,false,false,0,"Tbs; tbsp; tbs us; US tablespoons","UCUM","Vol","Clinical","unit defined as 0.5 US fluid ounces or 3 teaspoons - used only in the US. See [tbs_m] for the unit used internationally and in the US for nutrional labelling. ","[foz_us]/2","[FOZ_US]/2","1",1,false],[false,"teaspoon - US","[tsp_us]","[TSP_US]","volume",0.0000049289215937500005,[3,0,0,0,0,0,0],null,"us-volumes",false,null,null,1,false,false,0,"tsp; t; US teaspoons","UCUM","Vol","Nonclinical","unit defined as 1/6 US fluid ounces - used only in the US. See [tsp_m] for the unit used internationally and in the US for nutrional labelling. ","[tbs_us]/3","[TBS_US]/3","1",1,false],[false,"cup - US customary","[cup_us]","[CUP_US]","volume",0.00023658823650000004,[3,0,0,0,0,0,0],null,"us-volumes",false,null,null,1,false,false,0,"cup us; us cups","UCUM","Vol","Nonclinical","Unit defined as 1/2 US pint or 16 US tablespoons ≈ 236.59 mL, which is not the standard unit defined by the FDA of 240 mL - see [cup_m] (metric cup)","[tbs_us]","[TBS_US]","16",16,false],[false,"fluid ounce - metric","[foz_m]","[FOZ_M]","fluid volume",0.000029999999999999997,[3,0,0,0,0,0,0],"oz fl","us-volumes",false,null,null,1,false,false,0,"metric fluid ounces; fozs m; fl ozs m","UCUM","Vol","Clinical","unit used only in the US for nutritional labelling, as set by the FDA","mL","ML","30",30,false],[false,"cup - US legal","[cup_m]","[CUP_M]","volume",0.00023999999999999998,[3,0,0,0,0,0,0],null,"us-volumes",false,null,null,1,false,false,0,"cup m; metric cups","UCUM","Vol","Clinical","standard unit equal to 240 mL used in the US for nutritional labelling, as defined by the FDA. Note that this is different from the US customary cup (236.59 mL) and the metric cup used in Commonwealth nations (250 mL).","mL","ML","240",240,false],[false,"teaspoon - metric","[tsp_m]","[TSP_M]","volume",0.0000049999999999999996,[3,0,0,0,0,0,0],null,"us-volumes",false,null,null,1,false,false,0,"tsp; t; metric teaspoons","UCUM","Vol","Clinical","standard unit used in the US and internationally","mL","mL","5",5,false],[false,"tablespoon - metric","[tbs_m]","[TBS_M]","volume",0.000014999999999999999,[3,0,0,0,0,0,0],null,"us-volumes",false,null,null,1,false,false,0,"metric tablespoons; Tbs; tbsp; T; tbs m","UCUM","Vol","Clinical","standard unit used in the US and internationally","mL","mL","15",15,false],[false,"gallon- British","[gal_br]","[GAL_BR]","volume",0.004546090000000001,[3,0,0,0,0,0,0],null,"brit-volumes",false,null,null,1,false,false,0,"imperial gallons, UK gallons; British gallons; br gal; imp gal","UCUM","Vol","Nonclinical","Used only in Great Britain and other Commonwealth countries","l","L","4.54609",4.54609,false],[false,"peck - British","[pk_br]","[PK_BR]","volume",0.009092180000000002,[3,0,0,0,0,0,0],null,"brit-volumes",false,null,null,1,false,false,0,"imperial pecks; British pecks; br pk; imp pk","UCUM","Vol","Nonclinical","unit of dry volume rarely used today (can be used to measure volume of apples)","[gal_br]","[GAL_BR]","2",2,false],[false,"bushel - British","[bu_br]","[BU_BR]","volume",0.03636872000000001,[3,0,0,0,0,0,0],null,"brit-volumes",false,null,null,1,false,false,0,"British bushels; imperial; br bsh; br bu; imp","UCUM","Vol","Obsolete","Historical unit of dry volume that is rarely used today","[pk_br]","[PK_BR]","4",4,false],[false,"quart - British","[qt_br]","[QT_BR]","volume",0.0011365225000000002,[3,0,0,0,0,0,0],null,"brit-volumes",false,null,null,1,false,false,0,"British quarts; imperial quarts; br qts","UCUM","Vol","Clinical","Used only in Great Britain and other Commonwealth countries","[gal_br]/4","[GAL_BR]/4","1",1,false],[false,"pint - British","[pt_br]","[PT_BR]","volume",0.0005682612500000001,[3,0,0,0,0,0,0],null,"brit-volumes",false,null,null,1,false,false,0,"British pints; imperial pints; pt br; br pt; imp pt; pt imp","UCUM","Vol","Clinical","Used only in Great Britain and other Commonwealth countries","[qt_br]/2","[QT_BR]/2","1",1,false],[false,"gill - British","[gil_br]","[GIL_BR]","volume",0.00014206531250000003,[3,0,0,0,0,0,0],null,"brit-volumes",false,null,null,1,false,false,0,"imperial gills; British gills; imp gill, br gill","UCUM","Vol","Nonclinical","only used in the context of alcohol volume in Great Britain","[pt_br]/4","[PT_BR]/4","1",1,false],[false,"fluid ounce - British","[foz_br]","[FOZ_BR]","volume",0.000028413062500000005,[3,0,0,0,0,0,0],null,"brit-volumes",false,null,null,1,false,false,0,"British fluid ounces; Imperial fluid ounces; br fozs; imp fozs; br fl ozs","UCUM","Vol","Clinical","Used only in Great Britain and other Commonwealth countries","[gil_br]/5","[GIL_BR]/5","1",1,false],[false,"fluid dram - British","[fdr_br]","[FDR_BR]","volume",0.0000035516328125000006,[3,0,0,0,0,0,0],null,"brit-volumes",false,null,null,1,false,false,0,"British fluid drams; fdr br","UCUM","Vol","Nonclinical","equal to 1/8 Imperial fluid ounce = 3.55 mL; used informally to mean small amount of liquor, especially Scotch whiskey","[foz_br]/8","[FOZ_BR]/8","1",1,false],[false,"minim - British","[min_br]","[MIN_BR]","volume",5.919388020833334e-8,[3,0,0,0,0,0,0],null,"brit-volumes",false,null,null,1,false,false,0,"min br; br min; ♏ br","UCUM","Vol","Obsolete","","[fdr_br]/60","[FDR_BR]/60","1",1,false],[false,"grain","[gr]","[GR]","mass",0.06479891,[0,0,1,0,0,0,0],null,"avoirdupois",false,null,null,1,false,false,0,"gr; grains","UCUM","Mass","Nonclinical","an apothecary measure of mass rarely used today","mg","MG","64.79891",64.79891,false],[false,"pound","[lb_av]","[LB_AV]","mass",453.59237,[0,0,1,0,0,0,0],"lb","avoirdupois",false,null,null,1,false,false,0,"avoirdupois pounds, international pounds; av lbs; pounds","UCUM","Mass","Clinical","standard unit used in the US and internationally","[gr]","[GR]","7000",7000,false],[false,"pound force - US","[lbf_av]","[LBF_AV]","force",4448.2216152605,[1,-2,1,0,0,0,0],"lbf","const",false,null,null,1,false,false,0,"lbfs; US lbf; US pound forces","UCUM","Force","Clinical","only rarely needed in health care - see [lb_av] which is the more common unit to express weight","[lb_av].[g]","[LB_AV].[G]","1",1,false],[false,"ounce","[oz_av]","[OZ_AV]","mass",28.349523125,[0,0,1,0,0,0,0],"oz","avoirdupois",false,null,null,1,false,false,0,"ounces; international ounces; avoirdupois ounces; av ozs","UCUM","Mass","Clinical","standard unit used in the US and internationally","[lb_av]/16","[LB_AV]/16","1",1,false],[false,"Dram mass unit","[dr_av]","[DR_AV]","mass",1.7718451953125,[0,0,1,0,0,0,0],null,"avoirdupois",false,null,null,1,false,false,0,"Dram; drams avoirdupois; avoidupois dram; international dram","UCUM","Mass","Clinical","unit from the avoirdupois system, which is used in the US and internationally","[oz_av]/16","[OZ_AV]/16","1",1,false],[false,"short hundredweight","[scwt_av]","[SCWT_AV]","mass",45359.237,[0,0,1,0,0,0,0],null,"avoirdupois",false,null,null,1,false,false,0,"hundredweights; s cwt; scwt; avoirdupois","UCUM","Mass","Nonclinical","Used only in the US to equal 100 pounds","[lb_av]","[LB_AV]","100",100,false],[false,"long hundredweight","[lcwt_av]","[LCWT_AV]","mass",50802.345440000005,[0,0,1,0,0,0,0],null,"avoirdupois",false,null,null,1,false,false,0,"imperial hundredweights; imp cwt; lcwt; avoirdupois","UCUM","Mass","Obsolete","","[lb_av]","[LB_AV]","112",112,false],[false,"short ton - US","[ston_av]","[STON_AV]","mass",907184.74,[0,0,1,0,0,0,0],null,"avoirdupois",false,null,null,1,false,false,0,"ton; US tons; avoirdupois tons","UCUM","Mass","Clinical","Used only in the US","[scwt_av]","[SCWT_AV]","20",20,false],[false,"long ton - British","[lton_av]","[LTON_AV]","mass",1016046.9088000001,[0,0,1,0,0,0,0],null,"avoirdupois",false,null,null,1,false,false,0,"imperial tons; weight tons; British long tons; long ton avoirdupois","UCUM","Mass","Nonclinical","Used only in Great Britain and other Commonwealth countries","[lcwt_av]","[LCWT_AV]","20",20,false],[false,"stone - British","[stone_av]","[STONE_AV]","mass",6350.293180000001,[0,0,1,0,0,0,0],null,"avoirdupois",false,null,null,1,false,false,0,"British stones; avoirdupois","UCUM","Mass","Nonclinical","Used primarily in the UK and Ireland to measure body weight","[lb_av]","[LB_AV]","14",14,false],[false,"pennyweight - troy","[pwt_tr]","[PWT_TR]","mass",1.5551738400000001,[0,0,1,0,0,0,0],null,"troy",false,null,null,1,false,false,0,"dwt; denarius weights","UCUM","Mass","Obsolete","historical unit used to measure mass and cost of precious metals","[gr]","[GR]","24",24,false],[false,"ounce - troy","[oz_tr]","[OZ_TR]","mass",31.103476800000003,[0,0,1,0,0,0,0],null,"troy",false,null,null,1,false,false,0,"troy ounces; tr ozs","UCUM","Mass","Nonclinical","unit of mass for precious metals and gemstones only","[pwt_tr]","[PWT_TR]","20",20,false],[false,"pound - troy","[lb_tr]","[LB_TR]","mass",373.2417216,[0,0,1,0,0,0,0],null,"troy",false,null,null,1,false,false,0,"troy pounds; tr lbs","UCUM","Mass","Nonclinical","only used for weighing precious metals","[oz_tr]","[OZ_TR]","12",12,false],[false,"scruple","[sc_ap]","[SC_AP]","mass",1.2959782,[0,0,1,0,0,0,0],null,"apoth",false,null,null,1,false,false,0,"scruples; sc ap","UCUM","Mass","Obsolete","","[gr]","[GR]","20",20,false],[false,"dram - apothecary","[dr_ap]","[DR_AP]","mass",3.8879346,[0,0,1,0,0,0,0],null,"apoth",false,null,null,1,false,false,0,"ʒ; drachm; apothecaries drams; dr ap; dram ap","UCUM","Mass","Nonclinical","unit still used in the US occasionally to measure amount of drugs in pharmacies","[sc_ap]","[SC_AP]","3",3,false],[false,"ounce - apothecary","[oz_ap]","[OZ_AP]","mass",31.1034768,[0,0,1,0,0,0,0],null,"apoth",false,null,null,1,false,false,0,"apothecary ounces; oz ap; ap ozs; ozs ap","UCUM","Mass","Obsolete","","[dr_ap]","[DR_AP]","8",8,false],[false,"pound - apothecary","[lb_ap]","[LB_AP]","mass",373.2417216,[0,0,1,0,0,0,0],null,"apoth",false,null,null,1,false,false,0,"apothecary pounds; apothecaries pounds; ap lb; lb ap; ap lbs; lbs ap","UCUM","Mass","Obsolete","","[oz_ap]","[OZ_AP]","12",12,false],[false,"ounce - metric","[oz_m]","[OZ_M]","mass",28,[0,0,1,0,0,0,0],null,"apoth",false,null,null,1,false,false,0,"metric ounces; m ozs","UCUM","Mass","Clinical","see [oz_av] (the avoirdupois ounce) for the standard ounce used internationally; [oz_m] is equal to 28 grams and is based on the apothecaries\' system of mass units which is used in some US pharmacies. ","g","g","28",28,false],[false,"line","[lne]","[LNE]","length",0.002116666666666667,[1,0,0,0,0,0,0],null,"typeset",false,null,null,1,false,false,0,"British lines; br L; L; l","UCUM","Len","Obsolete","","[in_i]/12","[IN_I]/12","1",1,false],[false,"point (typography)","[pnt]","[PNT]","length",0.0003527777777777778,[1,0,0,0,0,0,0],null,"typeset",false,null,null,1,false,false,0,"DTP points; desktop publishing point; pt; pnt","UCUM","Len","Nonclinical","typography unit for typesetter\'s length","[lne]/6","[LNE]/6","1",1,false],[false,"pica (typography)","[pca]","[PCA]","length",0.004233333333333334,[1,0,0,0,0,0,0],null,"typeset",false,null,null,1,false,false,0,"picas","UCUM","Len","Nonclinical","typography unit for typesetter\'s length","[pnt]","[PNT]","12",12,false],[false,"Printer\'s point (typography)","[pnt_pr]","[PNT_PR]","length",0.00035145980000000004,[1,0,0,0,0,0,0],null,"typeset",false,null,null,1,false,false,0,"pnt pr","UCUM","Len","Nonclinical","typography unit for typesetter\'s length","[in_i]","[IN_I]","0.013837",0.013837,false],[false,"Printer\'s pica  (typography)","[pca_pr]","[PCA_PR]","length",0.004217517600000001,[1,0,0,0,0,0,0],null,"typeset",false,null,null,1,false,false,0,"pca pr; Printer\'s picas","UCUM","Len","Nonclinical","typography unit for typesetter\'s length","[pnt_pr]","[PNT_PR]","12",12,false],[false,"pied","[pied]","[PIED]","length",0.3248,[1,0,0,0,0,0,0],null,"typeset",false,null,null,1,false,false,0,"pieds du roi; Paris foot; royal; French; feet","UCUM","Len","Obsolete","","cm","CM","32.48",32.48,false],[false,"pouce","[pouce]","[POUCE]","length",0.027066666666666666,[1,0,0,0,0,0,0],null,"typeset",false,null,null,1,false,false,0,"historical French inches; French royal inches","UCUM","Len","Obsolete","","[pied]/12","[PIED]/12","1",1,false],[false,"ligne","[ligne]","[LIGNE]","length",0.0022555555555555554,[1,0,0,0,0,0,0],null,"typeset",false,null,null,1,false,false,0,"Paris lines; lignes","UCUM","Len","Obsolete","","[pouce]/12","[POUCE]/12","1",1,false],[false,"didot","[didot]","[DIDOT]","length",0.0003759259259259259,[1,0,0,0,0,0,0],null,"typeset",false,null,null,1,false,false,0,"Didot point; dd; Didots Point; didots; points","UCUM","Len","Obsolete","typography unit for typesetter\'s length","[ligne]/6","[LIGNE]/6","1",1,false],[false,"cicero","[cicero]","[CICERO]","length",0.004511111111111111,[1,0,0,0,0,0,0],null,"typeset",false,null,null,1,false,false,0,"Didot\'s pica; ciceros; picas","UCUM","Len","Obsolete","typography unit for typesetter\'s length","[didot]","[DIDOT]","12",12,false],[false,"degrees Fahrenheit","[degF]","[DEGF]","temperature",0.5555555555555556,[0,0,0,0,1,0,0],"°F","heat",false,null,"degF",1,true,false,0,"°F; deg F","UCUM","Temp","Clinical","","K",null,null,0.5555555555555556,false],[false,"degrees Rankine","[degR]","[degR]","temperature",0.5555555555555556,[0,0,0,0,1,0,0],"°R","heat",false,null,null,1,false,false,0,"°R; °Ra; Rankine","UCUM","Temp","Obsolete","Replaced by Kelvin","K/9","K/9","5",5,false],[false,"degrees Réaumur","[degRe]","[degRe]","temperature",1.25,[0,0,0,0,1,0,0],"°Ré","heat",false,null,"degRe",1,true,false,0,"°Ré, °Re, °r; Réaumur; degree Reaumur; Reaumur","UCUM","Temp","Obsolete","replaced by Celsius","K",null,null,1.25,false],[false,"calorie at 15°C","cal_[15]","CAL_[15]","energy",4185.8,[2,-2,1,0,0,0,0],"cal<sub>15°C</sub>","heat",true,null,null,1,false,false,0,"calorie 15 C; cals 15 C; calories at 15 C","UCUM","Enrg","Nonclinical","equal to 4.1855 joules; calorie most often used in engineering","J","J","4.18580",4.1858,false],[false,"calorie at 20°C","cal_[20]","CAL_[20]","energy",4181.9,[2,-2,1,0,0,0,0],"cal<sub>20°C</sub>","heat",true,null,null,1,false,false,0,"calorie 20 C; cal 20 C; calories at 20 C","UCUM","Enrg","Clinical","equal to 4.18190  joules. ","J","J","4.18190",4.1819,false],[false,"mean calorie","cal_m","CAL_M","energy",4190.0199999999995,[2,-2,1,0,0,0,0],"cal<sub>m</sub>","heat",true,null,null,1,false,false,0,"mean cals; mean calories","UCUM","Enrg","Clinical","equal to 4.19002 joules. ","J","J","4.19002",4.19002,false],[false,"international table calorie","cal_IT","CAL_IT","energy",4186.8,[2,-2,1,0,0,0,0],"cal<sub>IT</sub>","heat",true,null,null,1,false,false,0,"calories IT; IT cals; international steam table calories","UCUM","Enrg","Nonclinical","used in engineering steam tables and defined as 1/860 international watt-hour; equal to 4.1868 joules","J","J","4.1868",4.1868,false],[false,"thermochemical calorie","cal_th","CAL_TH","energy",4184,[2,-2,1,0,0,0,0],"cal<sub>th</sub>","heat",true,null,null,1,false,false,0,"thermochemical calories; th cals","UCUM","Enrg","Clinical","equal to 4.184 joules; used as the unit in medicine and biochemistry (equal to cal)","J","J","4.184",4.184,false],[false,"calorie","cal","CAL","energy",4184,[2,-2,1,0,0,0,0],"cal","heat",true,null,null,1,false,false,0,"gram calories; small calories","UCUM","Enrg","Clinical","equal to 4.184 joules (the same value as the thermochemical calorie, which is the most common calorie used in medicine and biochemistry)","cal_th","CAL_TH","1",1,false],[false,"nutrition label Calories","[Cal]","[CAL]","energy",4184000,[2,-2,1,0,0,0,0],"Cal","heat",false,null,null,1,false,false,0,"food calories; Cal; kcal","UCUM","Eng","Clinical","","kcal_th","KCAL_TH","1",1,false],[false,"British thermal unit at 39°F","[Btu_39]","[BTU_39]","energy",1059670,[2,-2,1,0,0,0,0],"Btu<sub>39°F</sub>","heat",false,null,null,1,false,false,0,"BTU 39F; BTU 39 F; B.T.U. 39 F; B.Th.U. 39 F; BThU 39 F; British thermal units","UCUM","Eng","Nonclinical","equal to 1.05967 kJ; used as a measure of power in the electric power, steam generation, heating, and air conditioning industries","kJ","kJ","1.05967",1.05967,false],[false,"British thermal unit at 59°F","[Btu_59]","[BTU_59]","energy",1054800,[2,-2,1,0,0,0,0],"Btu<sub>59°F</sub>","heat",false,null,null,1,false,false,0,"BTU 59 F; BTU 59F; B.T.U. 59 F; B.Th.U. 59 F; BThU 59F; British thermal units","UCUM","Eng","Nonclinical","equal to  1.05480 kJ; used as a measure of power in the electric power, steam generation, heating, and air conditioning industries","kJ","kJ","1.05480",1.0548,false],[false,"British thermal unit at 60°F","[Btu_60]","[BTU_60]","energy",1054680,[2,-2,1,0,0,0,0],"Btu<sub>60°F</sub>","heat",false,null,null,1,false,false,0,"BTU 60 F; BTU 60F; B.T.U. 60 F; B.Th.U. 60 F; BThU 60 F; British thermal units 60 F","UCUM","Eng","Nonclinical","equal to 1.05468 kJ; used as a measure of power in the electric power, steam generation, heating, and air conditioning industries","kJ","kJ","1.05468",1.05468,false],[false,"mean British thermal unit","[Btu_m]","[BTU_M]","energy",1055870,[2,-2,1,0,0,0,0],"Btu<sub>m</sub>","heat",false,null,null,1,false,false,0,"BTU mean; B.T.U. mean; B.Th.U. mean; BThU mean; British thermal units mean; ","UCUM","Eng","Nonclinical","equal to 1.05587 kJ; used as a measure of power in the electric power, steam generation, heating, and air conditioning industries","kJ","kJ","1.05587",1.05587,false],[false,"international table British thermal unit","[Btu_IT]","[BTU_IT]","energy",1055055.85262,[2,-2,1,0,0,0,0],"Btu<sub>IT</sub>","heat",false,null,null,1,false,false,0,"BTU IT; B.T.U. IT; B.Th.U. IT; BThU IT; British thermal units IT","UCUM","Eng","Nonclinical","equal to 1.055 kJ; used as a measure of power in the electric power, steam generation, heating, and air conditioning industries","kJ","kJ","1.05505585262",1.05505585262,false],[false,"thermochemical British thermal unit","[Btu_th]","[BTU_TH]","energy",1054350,[2,-2,1,0,0,0,0],"Btu<sub>th</sub>","heat",false,null,null,1,false,false,0,"BTU Th; B.T.U. Th; B.Th.U. Th; BThU Th; thermochemical British thermal units","UCUM","Eng","Nonclinical","equal to 1.054350 kJ; used as a measure of power in the electric power, steam generation, heating, and air conditioning industries","kJ","kJ","1.054350",1.05435,false],[false,"British thermal unit","[Btu]","[BTU]","energy",1054350,[2,-2,1,0,0,0,0],"btu","heat",false,null,null,1,false,false,0,"BTU; B.T.U. ; B.Th.U.; BThU; British thermal units","UCUM","Eng","Nonclinical","equal to the thermochemical British thermal unit equal to 1.054350 kJ; used as a measure of power in the electric power, steam generation, heating, and air conditioning industries","[Btu_th]","[BTU_TH]","1",1,false],[false,"horsepower - mechanical","[HP]","[HP]","power",745699.8715822703,[2,-3,1,0,0,0,0],null,"heat",false,null,null,1,false,false,0,"imperial horsepowers","UCUM","EngRat","Nonclinical","refers to mechanical horsepower, which is unit used to measure engine power primarily in the US. ","[ft_i].[lbf_av]/s","[FT_I].[LBF_AV]/S","550",550,false],[false,"tex","tex","TEX","linear mass density (of textile thread)",0.001,[-1,0,1,0,0,0,0],"tex","heat",true,null,null,1,false,false,0,"linear mass density; texes","UCUM","","Clinical","unit of linear mass density for fibers equal to gram per 1000 meters","g/km","G/KM","1",1,false],[false,"Denier (linear mass density)","[den]","[DEN]","linear mass density (of textile thread)",0.0001111111111111111,[-1,0,1,0,0,0,0],"den","heat",false,null,null,1,false,false,0,"den; deniers","UCUM","","Nonclinical","equal to the mass in grams per 9000 meters of the fiber (1 denier = 1 strand of silk)","g/9/km","G/9/KM","1",1,false],[false,"meter of water column","m[H2O]","M[H2O]","pressure",9806650,[-1,-2,1,0,0,0,0],"m HO<sub><r>2</r></sub>","clinical",true,null,null,1,false,false,0,"mH2O; m H2O; meters of water column; metres; pressure","UCUM","Pres","Clinical","","kPa","KPAL","980665e-5",9.80665,false],[false,"meter of mercury column","m[Hg]","M[HG]","pressure",133322000,[-1,-2,1,0,0,0,0],"m Hg","clinical",true,null,null,1,false,false,0,"mHg; m Hg; meters of mercury column; metres; pressure","UCUM","Pres","Clinical","","kPa","KPAL","133.3220",133.322,false],[false,"inch of water column","[in_i\'H2O]","[IN_I\'H2O]","pressure",249088.91000000003,[-1,-2,1,0,0,0,0],"in HO<sub><r>2</r></sub>","clinical",false,null,null,1,false,false,0,"inches WC; inAq; in H2O; inch of water gauge; iwg; pressure","UCUM","Pres","Clinical","unit of pressure, especially in respiratory and ventilation care","m[H2O].[in_i]/m","M[H2O].[IN_I]/M","1",1,false],[false,"inch of mercury column","[in_i\'Hg]","[IN_I\'HG]","pressure",3386378.8000000003,[-1,-2,1,0,0,0,0],"in Hg","clinical",false,null,null,1,false,false,0,"inHg; in Hg; pressure; inches","UCUM","Pres","Clinical","unit of pressure used in US to measure barometric pressure and occasionally blood pressure (see mm[Hg] for unit used internationally)","m[Hg].[in_i]/m","M[HG].[IN_I]/M","1",1,false],[false,"peripheral vascular resistance unit","[PRU]","[PRU]","fluid resistance",133322000000,[-4,-1,1,0,0,0,0],"P.R.U.","clinical",false,null,null,1,false,false,0,"peripheral vascular resistance units; peripheral resistance unit; peripheral resistance units; PRU","UCUM","FldResist","Clinical","used to assess blood flow in the capillaries; equal to 1 mmH.min/mL = 133.3 Pa·min/mL","mm[Hg].s/ml","MM[HG].S/ML","1",1,false],[false,"Wood unit","[wood\'U]","[WOOD\'U]","fluid resistance",7999320000,[-4,-1,1,0,0,0,0],"Wood U.","clinical",false,null,null,1,false,false,0,"hybrid reference units; HRU; mmHg.min/L; vascular resistance","UCUM","Pres","Clinical","simplified unit of measurement for for measuring pulmonary vascular resistance that uses pressure; equal to mmHg.min/L","mm[Hg].min/L","MM[HG].MIN/L","1",1,false],[false,"diopter (lens)","[diop]","[DIOP]","refraction of a lens",1,[1,0,0,0,0,0,0],"dpt","clinical",false,null,"inv",1,false,false,0,"diopters; diop; dioptre; dpt; refractive power","UCUM","InvLen","Clinical","unit of optical power of lens represented by inverse meters (m^-1)","m","/M","1",1,false],[false,"prism diopter (magnifying power)","[p\'diop]","[P\'DIOP]","refraction of a prism",1,[0,0,0,1,0,0,0],"PD","clinical",false,null,"tanTimes100",1,true,false,0,"diopters; dioptres; p diops; pdiop; dpt; pdptr; Δ; cm/m; centimeter per meter; centimetre; metre","UCUM","Angle","Clinical","unit for prism correction in eyeglass prescriptions","rad",null,null,1,false],[false,"percent of slope","%[slope]","%[SLOPE]","slope",0.017453292519943295,[0,0,0,1,0,0,0],"%","clinical",false,null,"100tan",1,true,false,0,"% slope; %slope; percents slopes","UCUM","VelFr; ElpotRatFr; VelRtoFr; AccelFr","Clinical","","deg",null,null,1,false],[false,"mesh","[mesh_i]","[MESH_I]","lineic number",0.025400000000000002,[1,0,0,0,0,0,0],null,"clinical",false,null,"inv",1,false,false,0,"meshes","UCUM","NLen (lineic number)","Clinical","traditional unit of length defined as the number of strands or particles per inch","[in_i]","/[IN_I]","1",1,false],[false,"French (catheter gauge) ","[Ch]","[CH]","gauge of catheters",0.0003333333333333333,[1,0,0,0,0,0,0],"Ch","clinical",false,null,null,1,false,false,0,"Charrières, French scales; French gauges; Fr, Fg, Ga, FR, Ch","UCUM","Len; Circ; Diam","Clinical","","mm/3","MM/3","1",1,false],[false,"drop - metric (1/20 mL)","[drp]","[DRP]","volume",5e-8,[3,0,0,0,0,0,0],"drp","clinical",false,null,null,1,false,false,0,"drop dosing units; metric drops; gtt","UCUM","Vol","Clinical","standard unit used in the US and internationally for clinical medicine but note that although [drp] is defined as 1/20 milliliter, in practice, drop sizes will vary due to external factors","ml/20","ML/20","1",1,false],[false,"Hounsfield unit","[hnsf\'U]","[HNSF\'U]","x-ray attenuation",1,[0,0,0,0,0,0,0],"HF","clinical",false,null,null,1,false,false,0,"HU; units","UCUM","","Clinical","used to measure X-ray attenuation, especially in CT scans.","1","1","1",1,false],[false,"Metabolic Equivalent of Task ","[MET]","[MET]","metabolic cost of physical activity",5.833333333333334e-11,[3,-1,-1,0,0,0,0],"MET","clinical",false,null,null,1,false,false,0,"metabolic equivalents","UCUM","RelEngRat","Clinical","unit used to measure rate of energy expenditure per power in treadmill and other functional tests","mL/min/kg","ML/MIN/KG","3.5",3.5,false],[false,"homeopathic potency of decimal series (retired)","[hp\'_X]","[HP\'_X]","homeopathic potency (retired)",1,[0,0,0,0,0,0,0],"X","clinical",false,null,"hpX",1,true,false,0,null,"UCUM",null,null,null,"1",null,null,1,false],[false,"homeopathic potency of centesimal series (retired)","[hp\'_C]","[HP\'_C]","homeopathic potency (retired)",1,[0,0,0,0,0,0,0],"C","clinical",false,null,"hpC",1,true,false,0,null,"UCUM",null,null,null,"1",null,null,1,false],[false,"homeopathic potency of millesimal series (retired)","[hp\'_M]","[HP\'_M]","homeopathic potency (retired)",1,[0,0,0,0,0,0,0],"M","clinical",false,null,"hpM",1,true,false,0,null,"UCUM",null,null,null,"1",null,null,1,false],[false,"homeopathic potency of quintamillesimal series (retired)","[hp\'_Q]","[HP\'_Q]","homeopathic potency (retired)",1,[0,0,0,0,0,0,0],"Q","clinical",false,null,"hpQ",1,true,false,0,null,"UCUM",null,null,null,"1",null,null,1,false],[false,"homeopathic potency of decimal hahnemannian series","[hp_X]","[HP_X]","homeopathic potency (Hahnemann)",1,[0,0,0,0,0,0,0],"X","clinical",false,null,null,1,false,true,0,null,"UCUM",null,null,null,"1","1","1",1,false],[false,"homeopathic potency of centesimal hahnemannian series","[hp_C]","[HP_C]","homeopathic potency (Hahnemann)",1,[0,0,0,0,0,0,0],"C","clinical",false,null,null,1,false,true,0,null,"UCUM",null,null,null,"1","1","1",1,false],[false,"homeopathic potency of millesimal hahnemannian series","[hp_M]","[HP_M]","homeopathic potency (Hahnemann)",1,[0,0,0,0,0,0,0],"M","clinical",false,null,null,1,false,true,0,null,"UCUM",null,null,null,"1","1","1",1,false],[false,"homeopathic potency of quintamillesimal hahnemannian series","[hp_Q]","[HP_Q]","homeopathic potency (Hahnemann)",1,[0,0,0,0,0,0,0],"Q","clinical",false,null,null,1,false,true,0,null,"UCUM",null,null,null,"1","1","1",1,false],[false,"homeopathic potency of decimal korsakovian series","[kp_X]","[KP_X]","homeopathic potency (Korsakov)",1,[0,0,0,0,0,0,0],"X","clinical",false,null,null,1,false,true,0,null,"UCUM",null,null,null,"1","1","1",1,false],[false,"homeopathic potency of centesimal korsakovian series","[kp_C]","[KP_C]","homeopathic potency (Korsakov)",1,[0,0,0,0,0,0,0],"C","clinical",false,null,null,1,false,true,0,null,"UCUM",null,null,null,"1","1","1",1,false],[false,"homeopathic potency of millesimal korsakovian series","[kp_M]","[KP_M]","homeopathic potency (Korsakov)",1,[0,0,0,0,0,0,0],"M","clinical",false,null,null,1,false,true,0,null,"UCUM",null,null,null,"1","1","1",1,false],[false,"homeopathic potency of quintamillesimal korsakovian series","[kp_Q]","[KP_Q]","homeopathic potency (Korsakov)",1,[0,0,0,0,0,0,0],"Q","clinical",false,null,null,1,false,true,0,null,"UCUM",null,null,null,"1","1","1",1,false],[false,"equivalent","eq","EQ","amount of substance",6.0221367e+23,[0,0,0,0,0,0,0],"eq","chemical",true,null,null,1,false,false,1,"equivalents","UCUM","Sub","Clinical","equivalence equals moles per valence","mol","MOL","1",1,false],[false,"osmole","osm","OSM","amount of substance (dissolved particles)",6.0221367e+23,[0,0,0,0,0,0,0],"osm","chemical",true,null,null,1,false,false,1,"osmoles; osmols","UCUM","Osmol","Clinical","the number of moles of solute that contribute to the osmotic pressure of a solution","mol","MOL","1",1,false],[false,"pH","[pH]","[PH]","acidity",6.0221366999999994e+26,[-3,0,0,0,0,0,0],"pH","chemical",false,null,"pH",1,true,false,0,"pH scale","UCUM","LogCnc","Clinical","Log concentration of H+","mol/l",null,null,1,false],[false,"gram percent","g%","G%","mass concentration",10000,[-3,0,1,0,0,0,0],"g%","chemical",true,null,null,1,false,false,0,"gram %; gram%; grams per deciliter; g/dL; gm per dL; gram percents","UCUM","MCnc","Clinical","equivalent to unit gram per deciliter (g/dL), a unit often used in medical tests to represent solution concentrations","g/dl","G/DL","1",1,false],[false,"Svedberg unit","[S]","[S]","sedimentation coefficient",1e-13,[0,1,0,0,0,0,0],"S","chemical",false,null,null,1,false,false,0,"Sv; 10^-13 seconds; 100 fs; 100 femtoseconds","UCUM","Time","Clinical","unit of time used in measuring particle\'s sedimentation rate, usually after centrifugation. ","s","10*-13.S","1",1e-13,false],[false,"high power field (microscope)","[HPF]","[HPF]","view area in microscope",1,[0,0,0,0,0,0,0],"HPF","chemical",false,null,null,1,false,false,0,"HPF","UCUM","Area","Clinical","area visible under the maximum magnification power of the objective in microscopy (usually 400x)\\n","1","1","1",1,false],[false,"low power field (microscope)","[LPF]","[LPF]","view area in microscope",1,[0,0,0,0,0,0,0],"LPF","chemical",false,null,null,1,false,false,0,"LPF; fields","UCUM","Area","Clinical","area visible under the low magnification of the objective in microscopy (usually 100 x)\\n","1","1","100",100,false],[false,"katal","kat","KAT","catalytic activity",6.0221367e+23,[0,-1,0,0,0,0,0],"kat","chemical",true,null,null,1,false,false,1,"mol/secs; moles per second; mol*sec-1; mol*s-1; mol.s-1; katals; catalytic activity; enzymatic; enzyme units; activities","UCUM","CAct","Clinical","kat is a unit of catalytic activity with base units = mol/s. Rarely used because its units are too large to practically express catalytic activity. See enzyme unit [U] which is the standard unit for catalytic activity.","mol/s","MOL/S","1",1,false],[false,"enzyme unit","U","U","catalytic activity",10036894500000000,[0,-1,0,0,0,0,0],"U","chemical",true,null,null,1,false,false,1,"micromoles per minute; umol/min; umol per minute; umol min-1; enzymatic activity; enzyme activity","UCUM","CAct","Clinical","1 U is the standard enzyme unit which equals 1 micromole substrate catalyzed per minute (1 umol/min)","umol/min","UMOL/MIN","1",1,false],[false,"international unit - arbitrary","[iU]","[IU]","arbitrary",1,[0,0,0,0,0,0,0],"IU","chemical",true,null,null,1,false,true,0,"international units; IE; F2","UCUM","Arb","Clinical","International units (IU) are analyte and reference specimen  specific arbitrary units (held at WHO)","1","1","1",1,false],[false,"international unit - arbitrary","[IU]","[IU]","arbitrary",1,[0,0,0,0,0,0,0],"i.U.","chemical",true,null,null,1,false,true,0,"international units; IE; F2","UCUM","Arb","Clinical","International units (IU) are analyte and reference specimen  specific arbitrary units (held at WHO)","[iU]","[IU]","1",1,false],[false,"arbitary unit","[arb\'U]","[ARB\'U]","arbitrary",1,[0,0,0,0,0,0,0],"arb. U","chemical",false,null,null,1,false,true,0,"arbitary units; arb units; arbU","UCUM","Arb","Clinical","relative unit of measurement to show the ratio of test measurement to reference measurement","1","1","1",1,false],[false,"United States Pharmacopeia unit","[USP\'U]","[USP\'U]","arbitrary",1,[0,0,0,0,0,0,0],"U.S.P.","chemical",false,null,null,1,false,true,0,"USP U; USP\'U","UCUM","Arb","Clinical","a dose unit to express potency of drugs and vitamins defined by the United States Pharmacopoeia; usually 1 USP = 1 IU","1","1","1",1,false],[false,"GPL unit","[GPL\'U]","[GPL\'U]","biologic activity of anticardiolipin IgG",1,[0,0,0,0,0,0,0],null,"chemical",false,null,null,1,false,true,0,"GPL Units; GPL U; IgG anticardiolipin units; IgG Phospholipid","UCUM","ACnc; AMass","Clinical","Units for an antiphospholipid test","1","1","1",1,false],[false,"MPL unit","[MPL\'U]","[MPL\'U]","biologic activity of anticardiolipin IgM",1,[0,0,0,0,0,0,0],null,"chemical",false,null,null,1,false,true,0,"MPL units; MPL U; MPL\'U; IgM anticardiolipin units; IgM Phospholipid Units ","UCUM","ACnc","Clinical","units for antiphospholipid test","1","1","1",1,false],[false,"APL unit","[APL\'U]","[APL\'U]","biologic activity of anticardiolipin IgA",1,[0,0,0,0,0,0,0],null,"chemical",false,null,null,1,false,true,0,"APL units; APL U; IgA anticardiolipin; IgA Phospholipid; biologic activity of","UCUM","AMass; ACnc","Clinical","Units for an anti phospholipid syndrome test","1","1","1",1,false],[false,"Bethesda unit","[beth\'U]","[BETH\'U]","biologic activity of factor VIII inhibitor",1,[0,0,0,0,0,0,0],null,"chemical",false,null,null,1,false,true,0,"BU","UCUM","ACnc","Clinical","measures of blood coagulation inhibitior for many blood factors","1","1","1",1,false],[false,"anti factor Xa unit","[anti\'Xa\'U]","[ANTI\'XA\'U]","biologic activity of factor Xa inhibitor (heparin)",1,[0,0,0,0,0,0,0],null,"chemical",false,null,null,1,false,true,0,"units","UCUM","ACnc","Clinical","[anti\'Xa\'U] unit is equivalent to and can be converted to IU/mL. ","1","1","1",1,false],[false,"Todd unit","[todd\'U]","[TODD\'U]","biologic activity antistreptolysin O",1,[0,0,0,0,0,0,0],null,"chemical",false,null,null,1,false,true,0,"units","UCUM","InvThres; RtoThres","Clinical","the unit for the results of the testing for antistreptolysin O (ASO)","1","1","1",1,false],[false,"Dye unit","[dye\'U]","[DYE\'U]","biologic activity of amylase",1,[0,0,0,0,0,0,0],null,"chemical",false,null,null,1,false,true,0,"units","UCUM","CCnc","Obsolete","equivalent to the Somogyi unit, which is an enzyme unit for amylase but better to use U, the standard enzyme unit for measuring catalytic activity","1","1","1",1,false],[false,"Somogyi unit","[smgy\'U]","[SMGY\'U]","biologic activity of amylase",1,[0,0,0,0,0,0,0],null,"chemical",false,null,null,1,false,true,0,"Somogyi units; smgy U","UCUM","CAct","Clinical","measures the enzymatic activity of amylase in blood serum - better to use base units mg/mL ","1","1","1",1,false],[false,"Bodansky unit","[bdsk\'U]","[BDSK\'U]","biologic activity of phosphatase",1,[0,0,0,0,0,0,0],null,"chemical",false,null,null,1,false,true,0,"","UCUM","ACnc","Obsolete","Enzyme unit specific to alkaline phosphatase - better to use standard enzyme unit of U","1","1","1",1,false],[false,"King-Armstrong unit","[ka\'U]","[KA\'U]","biologic activity of phosphatase",1,[0,0,0,0,0,0,0],null,"chemical",false,null,null,1,false,true,0,"King-Armstrong Units; King units","UCUM","AMass","Obsolete","enzyme units for acid phosphatase - better to use enzyme unit [U]","1","1","1",1,false],[false,"Kunkel unit","[knk\'U]","[KNK\'U]","arbitrary biologic activity",1,[0,0,0,0,0,0,0],null,"chemical",false,null,null,1,false,true,0,null,"UCUM",null,null,null,"1","1","1",1,false],[false,"Mac Lagan unit","[mclg\'U]","[MCLG\'U]","arbitrary biologic activity",1,[0,0,0,0,0,0,0],null,"chemical",false,null,null,1,false,true,0,"galactose index; galactose tolerance test; thymol turbidity test unit; mclg U; units; indexes","UCUM","ACnc","Obsolete","unit for liver tests - previously used in thymol turbidity tests for liver disease diagnoses, and now is sometimes referred to in the oral galactose tolerance test","1","1","1",1,false],[false,"tuberculin unit","[tb\'U]","[TB\'U]","biologic activity of tuberculin",1,[0,0,0,0,0,0,0],null,"chemical",false,null,null,1,false,true,0,"TU; units","UCUM","Arb","Clinical","amount of tuberculin antigen -usually in reference to a TB skin test ","1","1","1",1,false],[false,"50% cell culture infectious dose","[CCID_50]","[CCID_50]","biologic activity (infectivity) of an infectious agent preparation",1,[0,0,0,0,0,0,0],"CCID<sub>50</sub>","chemical",false,null,null,1,false,true,0,"CCID50; 50% cell culture infective doses","UCUM","NumThres","Clinical","","1","1","1",1,false],[false,"50% tissue culture infectious dose","[TCID_50]","[TCID_50]","biologic activity (infectivity) of an infectious agent preparation",1,[0,0,0,0,0,0,0],"TCID<sub>50</sub>","chemical",false,null,null,1,false,true,0,"TCID50; 50% tissue culture infective dose","UCUM","NumThres","Clinical","","1","1","1",1,false],[false,"50% embryo infectious dose","[EID_50]","[EID_50]","biologic activity (infectivity) of an infectious agent preparation",1,[0,0,0,0,0,0,0],"EID<sub>50</sub>","chemical",false,null,null,1,false,true,0,"EID50; 50% embryo infective doses; EID50 Egg Infective Dosage","UCUM","thresNum","Clinical","","1","1","1",1,false],[false,"plaque forming units","[PFU]","[PFU]","amount of an infectious agent",1,[0,0,0,0,0,0,0],"PFU","chemical",false,null,null,1,false,true,0,"PFU","UCUM","ACnc","Clinical","tests usually report unit as number of PFU per unit volume","1","1","1",1,false],[false,"focus forming units (cells)","[FFU]","[FFU]","amount of an infectious agent",1,[0,0,0,0,0,0,0],"FFU","chemical",false,null,null,1,false,true,0,"FFU","UCUM","EntNum","Clinical","","1","1","1",1,false],[false,"colony forming units","[CFU]","[CFU]","amount of a proliferating organism",1,[0,0,0,0,0,0,0],"CFU","chemical",false,null,null,1,false,true,0,"CFU","UCUM","Num","Clinical","","1","1","1",1,false],[false,"index of reactivity (allergen)","[IR]","[IR]","amount of an allergen callibrated through in-vivo testing using the Stallergenes® method.",1,[0,0,0,0,0,0,0],"IR","chemical",false,null,null,1,false,true,0,"IR; indexes","UCUM","Acnc","Clinical","amount of an allergen callibrated through in-vivo testing using the Stallergenes method. Usually reported in tests as IR/mL","1","1","1",1,false],[false,"bioequivalent allergen unit","[BAU]","[BAU]","amount of an allergen callibrated through in-vivo testing based on the ID50EAL method of (intradermal dilution for 50mm sum of erythema diameters",1,[0,0,0,0,0,0,0],"BAU","chemical",false,null,null,1,false,true,0,"BAU; Bioequivalent Allergy Units; bioequivalent allergen units","UCUM","Arb","Clinical","","1","1","1",1,false],[false,"allergy unit","[AU]","[AU]","procedure defined amount of an allergen using some reference standard",1,[0,0,0,0,0,0,0],"AU","chemical",false,null,null,1,false,true,0,"allergy units; allergen units; AU","UCUM","Arb","Clinical","Most standard test allergy units are reported as [IU] or as %. ","1","1","1",1,false],[false,"allergen unit for Ambrosia artemisiifolia","[Amb\'a\'1\'U]","[AMB\'A\'1\'U]","procedure defined amount of the major allergen of ragweed.",1,[0,0,0,0,0,0,0],"Amb a 1 U","chemical",false,null,null,1,false,true,0,"Amb a 1 unit; Antigen E; AgE U; allergen units","UCUM","Arb","Clinical","Amb a 1 is the major allergen in short ragweed, and can be converted Bioequivalent allergen units (BAU) where 350 Amb a 1 U/mL = 100,000 BAU/mL","1","1","1",1,false],[false,"protein nitrogen unit (allergen testing)","[PNU]","[PNU]","procedure defined amount of a protein substance",1,[0,0,0,0,0,0,0],"PNU","chemical",false,null,null,1,false,true,0,"protein nitrogen units; PNU","UCUM","Mass","Clinical","defined as 0.01 ug of phosphotungstic acid-precipitable protein nitrogen. Being replaced by bioequivalent allergy units (BAU).","1","1","1",1,false],[false,"Limit of flocculation","[Lf]","[LF]","procedure defined amount of an antigen substance",1,[0,0,0,0,0,0,0],"Lf","chemical",false,null,null,1,false,true,0,"Lf doses","UCUM","Arb","Clinical","the antigen content  forming 1:1 ratio against 1 unit of antitoxin","1","1","1",1,false],[false,"D-antigen unit (polio)","[D\'ag\'U]","[D\'AG\'U]","procedure defined amount of a poliomyelitis d-antigen substance",1,[0,0,0,0,0,0,0],null,"chemical",false,null,null,1,false,true,0,"DAgU; units","UCUM","Acnc","Clinical","unit of potency of poliovirus vaccine used for poliomyelitis prevention reported as D antigen units/mL. The unit is poliovirus type-specific.","1","1","1",1,false],[false,"fibrinogen equivalent units","[FEU]","[FEU]","amount of fibrinogen broken down into the measured d-dimers",1,[0,0,0,0,0,0,0],null,"chemical",false,null,null,1,false,true,0,"FEU","UCUM","MCnc","Clinical","Note both the FEU and DDU units are used to report D-dimer measurements. 1 DDU = 1/2 FFU","1","1","1",1,false],[false,"ELISA unit","[ELU]","[ELU]","arbitrary ELISA unit",1,[0,0,0,0,0,0,0],null,"chemical",false,null,null,1,false,true,0,"Enzyme-Linked Immunosorbent Assay Units; ELU; EL. U","UCUM","ACnc","Clinical","","1","1","1",1,false],[false,"Ehrlich units (urobilinogen)","[EU]","[EU]","Ehrlich unit",1,[0,0,0,0,0,0,0],null,"chemical",false,null,null,1,false,true,0,"EU/dL; mg{urobilinogen}/dL","UCUM","ACnc","Clinical","","1","1","1",1,false],[false,"neper","Np","NEP","level",1,[0,0,0,0,0,0,0],"Np","levels",true,null,"ln",1,true,false,0,"nepers","UCUM","LogRto","Clinical","logarithmic unit for ratios of measurements of physical field and power quantities, such as gain and loss of electronic signals","1",null,null,1,false],[false,"bel","B","B","level",1,[0,0,0,0,0,0,0],"B","levels",true,null,"lg",1,true,false,0,"bels","UCUM","LogRto","Clinical","Logarithm of the ratio of power- or field-type quantities; usually expressed in decibels ","1",null,null,1,false],[false,"bel sound pressure","B[SPL]","B[SPL]","pressure level",0.02,[-1,-2,1,0,0,0,0],"B(SPL)","levels",true,null,"lgTimes2",1,true,false,0,"bel SPL; B SPL; sound pressure bels","UCUM","LogRto","Clinical","used to measure sound level in acoustics","Pa",null,null,0.00002,false],[false,"bel volt","B[V]","B[V]","electric potential level",1000,[2,-2,1,0,0,-1,0],"B(V)","levels",true,null,"lgTimes2",1,true,false,0,"bel V; B V; volts bels","UCUM","LogRtoElp","Clinical","used to express power gain in electrical circuits","V",null,null,1,false],[false,"bel millivolt","B[mV]","B[MV]","electric potential level",1,[2,-2,1,0,0,-1,0],"B(mV)","levels",true,null,"lgTimes2",1,true,false,0,"bel mV; B mV; millivolt bels; 10^-3V bels; 10*-3V ","UCUM","LogRtoElp","Clinical","used to express power gain in electrical circuits","mV",null,null,1,false],[false,"bel microvolt","B[uV]","B[UV]","electric potential level",0.001,[2,-2,1,0,0,-1,0],"B(μV)","levels",true,null,"lgTimes2",1,true,false,0,"bel uV; B uV; microvolts bels; 10^-6V bel; 10*-6V bel","UCUM","LogRto","Clinical","used to express power gain in electrical circuits","uV",null,null,1,false],[false,"bel 10 nanovolt","B[10.nV]","B[10.NV]","electric potential level",0.000010000000000000003,[2,-2,1,0,0,-1,0],"B(10 nV)","levels",true,null,"lgTimes2",1,true,false,0,"bel 10 nV; B 10 nV; 10 nanovolts bels","UCUM","LogRtoElp","Clinical","used to express power gain in electrical circuits","nV",null,null,10,false],[false,"bel watt","B[W]","B[W]","power level",1000,[2,-3,1,0,0,0,0],"B(W)","levels",true,null,"lg",1,true,false,0,"bel W; b W; b Watt; Watts bels","UCUM","LogRto","Clinical","used to express power","W",null,null,1,false],[false,"bel kilowatt","B[kW]","B[KW]","power level",1000000,[2,-3,1,0,0,0,0],"B(kW)","levels",true,null,"lg",1,true,false,0,"bel kW; B kW; kilowatt bel; kW bel; kW B","UCUM","LogRto","Clinical","used to express power","kW",null,null,1,false],[false,"stere","st","STR","volume",1,[3,0,0,0,0,0,0],"st","misc",true,null,null,1,false,false,0,"stère; m3; cubic meter; m^3; meters cubed; metre","UCUM","Vol","Nonclinical","equal to one cubic meter, usually used for measuring firewoord","m3","M3","1",1,false],[false,"Ångström","Ao","AO","length",1.0000000000000002e-10,[1,0,0,0,0,0,0],"Å","misc",false,null,null,1,false,false,0,"Å; Angstroms; Ao; Ångströms","UCUM","Len","Clinical","equal to 10^-10 meters; used to express wave lengths and atom scaled differences ","nm","NM","0.1",0.1,false],[false,"barn","b","BRN","action area",9.999999999999999e-29,[2,0,0,0,0,0,0],"b","misc",false,null,null,1,false,false,0,"barns","UCUM","Area","Clinical","used in high-energy physics to express cross-sectional areas","fm2","FM2","100",100,false],[false,"technical atmosphere","att","ATT","pressure",98066499.99999999,[-1,-2,1,0,0,0,0],"at","misc",false,null,null,1,false,false,0,"at; tech atm; tech atmosphere; kgf/cm2; atms; atmospheres","UCUM","Pres","Obsolete","non-SI unit of pressure equal to one kilogram-force per square centimeter","kgf/cm2","KGF/CM2","1",1,false],[false,"mho","mho","MHO","electric conductance",0.001,[-2,1,-1,0,0,2,0],"mho","misc",true,null,null,1,false,false,0,"siemens; ohm reciprocals; Ω^−1; Ω-1 ","UCUM","","Obsolete","unit of electric conductance (the inverse of electrical resistance) equal to ohm^-1","S","S","1",1,false],[false,"pound per square inch","[psi]","[PSI]","pressure",6894757.293168359,[-1,-2,1,0,0,0,0],"psi","misc",false,null,null,1,false,false,0,"psi; lb/in2; lb per in2","UCUM","Pres","Clinical","","[lbf_av]/[in_i]2","[LBF_AV]/[IN_I]2","1",1,false],[false,"circle - plane angle","circ","CIRC","plane angle",6.283185307179586,[0,0,0,1,0,0,0],"circ","misc",false,null,null,1,false,false,0,"angles; circles","UCUM","Angle","Clinical","","[pi].rad","[PI].RAD","2",2,false],[false,"spere - solid angle","sph","SPH","solid angle",12.566370614359172,[0,0,0,2,0,0,0],"sph","misc",false,null,null,1,false,false,0,"speres","UCUM","Angle","Clinical","equal to the solid angle of an entire sphere = 4πsr (sr = steradian) ","[pi].sr","[PI].SR","4",4,false],[false,"metric carat","[car_m]","[CAR_M]","mass",0.2,[0,0,1,0,0,0,0],"ct<sub>m</sub>","misc",false,null,null,1,false,false,0,"carats; ct; car m","UCUM","Mass","Nonclinical","unit of mass for gemstones","g","G","2e-1",0.2,false],[false,"carat of gold alloys","[car_Au]","[CAR_AU]","mass fraction",0.041666666666666664,[0,0,0,0,0,0,0],"ct<sub><r>Au</r></sub>","misc",false,null,null,1,false,false,0,"karats; k; kt; car au; carats","UCUM","MFr","Nonclinical","unit of purity for gold alloys","/24","/24","1",1,false],[false,"Smoot","[smoot]","[SMOOT]","length",1.7018000000000002,[1,0,0,0,0,0,0],null,"misc",false,null,null,1,false,false,0,"","UCUM","Len","Nonclinical","prank unit of length from MIT","[in_i]","[IN_I]","67",67,false],[false,"meter per square seconds per square root of hertz","[m/s2/Hz^(1/2)]","[M/S2/HZ^(1/2)]","amplitude spectral density",1,[2,-3,0,0,0,0,0],null,"misc",false,null,"sqrt",1,true,false,0,"m/s2/(Hz^.5); m/s2/(Hz^(1/2)); m per s2 per Hz^1/2","UCUM","","Constant","measures amplitude spectral density, and is equal to the square root of power spectral density\\n ","m2/s4/Hz",null,null,1,false],[false,"bit - logarithmic","bit_s","BIT_S","amount of information",1,[0,0,0,0,0,0,0],"bit<sub>s</sub>","infotech",false,null,"ld",1,true,false,0,"bit-s; bit s; bit logarithmic","UCUM","LogA","Nonclinical","defined as the log base 2 of the number of distinct signals; cannot practically be used to express more than 1000 bits\\n\\nIn information theory, the definition of the amount of self-information and information entropy is often expressed with the binary logarithm (log base 2)","1",null,null,1,false],[false,"bit","bit","BIT","amount of information",1,[0,0,0,0,0,0,0],"bit","infotech",true,null,null,1,false,false,0,"bits","UCUM","","Nonclinical","dimensionless information unit of 1 used in computing and digital communications","1","1","1",1,false],[false,"byte","By","BY","amount of information",8,[0,0,0,0,0,0,0],"B","infotech",true,null,null,1,false,false,0,"bytes","UCUM","","Nonclinical","equal to 8 bits","bit","bit","8",8,false],[false,"baud","Bd","BD","signal transmission rate",1,[0,1,0,0,0,0,0],"Bd","infotech",true,null,"inv",1,false,false,0,"Bd; bauds","UCUM","Freq","Nonclinical","unit to express rate in symbols per second or pulses per second. ","s","/s","1",1,false],[false,"per twelve hour","/(12.h)","/HR","",0.000023148148148148147,[0,-1,0,0,0,0,0],"/h",null,false,null,null,1,false,false,0,"per 12 hours; 12hrs; 12 hrs; /12hrs","LOINC","Rat","Clinical","",null,null,null,null,false],[false,"per arbitrary unit","/[arb\'U]","/[ARB\'U]","",1,[0,0,0,0,0,0,0],"/arb/ U",null,false,null,null,1,false,true,0,"/arbU","LOINC","InvA ","Clinical","",null,null,null,null,false],[false,"per high power field","/[HPF]","/[HPF]","",1,[0,0,0,0,0,0,0],"/HPF",null,false,null,null,1,false,false,0,"/HPF; per HPF","LOINC","Naric","Clinical","",null,null,null,null,false],[false,"per international unit","/[IU]","/[IU]","",1,[0,0,0,0,0,0,0],"/i/U.",null,false,null,null,1,false,true,0,"international units; /IU; per IU","LOINC","InvA","Clinical","International units (IU) are analyte and reference specimen  specific arbitrary units (held at WHO)",null,null,null,null,false],[false,"per low power field","/[LPF]","/[LPF]","",1,[0,0,0,0,0,0,0],"/LPF",null,false,null,null,1,false,false,0,"/LPF; per LPF","LOINC","Naric","Clinical","",null,null,null,null,false],[false,"per 10 billion  ","/10*10","/10*10","",1e-10,[0,0,0,0,0,0,0],"/10<sup>10<.sup>",null,false,null,null,1,false,false,0,"/10^10; per 10*10","LOINC","NFr","Clinical","used for counting entities, e.g. blood cells; usually these kinds of terms have numerators such as moles or milligrams, and counting that amount per the number in the denominator",null,null,null,null,false],[false,"per trillion ","/10*12","/10*12","",1e-12,[0,0,0,0,0,0,0],"/10<sup>12<.sup>",null,false,null,null,1,false,false,0,"/10^12; per 10*12","LOINC","NFr","Clinical","used for counting entities, e.g. blood cells; usually these kinds of terms have numerators such as moles or milligrams, and counting that amount per the number in the denominator",null,null,null,null,false],[false,"per thousand","/10*3","/10*3","",0.001,[0,0,0,0,0,0,0],"/10<sup>3<.sup>",null,false,null,null,1,false,false,0,"/10^3; per 10*3","LOINC","NFr","Clinical","used for counting entities, e.g. blood cells; usually these kinds of terms have numerators such as moles or milligrams, and counting that amount per the number in the denominator",null,null,null,null,false],[false,"per million","/10*6","/10*6","",0.000001,[0,0,0,0,0,0,0],"/10<sup>6<.sup>",null,false,null,null,1,false,false,0,"/10^6; per 10*6;","LOINC","NFr","Clinical","used for counting entities, e.g. blood cells; usually these kinds of terms have numerators such as moles or milligrams, and counting that amount per the number in the denominator",null,null,null,null,false],[false,"per billion","/10*9","/10*9","",1e-9,[0,0,0,0,0,0,0],"/10<sup>9<.sup>",null,false,null,null,1,false,false,0,"/10^9; per 10*9","LOINC","NFr","Clinical","used for counting entities, e.g. blood cells; usually these kinds of terms have numerators such as moles or milligrams, and counting that amount per the number in the denominator",null,null,null,null,false],[false,"per 100","/100","","",0.01,[0,0,0,0,0,0,0],null,null,false,null,null,1,false,false,0,"per hundred; 10^2; 10*2","LOINC","NFr","Clinical","used for counting entities, e.g. blood cells; usually these kinds of terms have numerators such as moles or milligrams, and counting that amount per the number in the denominator",null,null,null,null,false],[false,"per 100 cells","/100{cells}","","",0.01,[0,0,0,0,0,0,0],null,null,false,null,null,1,false,false,0,"/100 cells; /100cells; per hundred","LOINC","EntMass; EntNum; NFr","Clinical","",null,null,null,null,false],[false,"per 100 neutrophils","/100{neutrophils}","","",0.01,[0,0,0,0,0,0,0],null,null,false,null,null,1,false,false,0,"/100 neutrophils; /100neutrophils; per hundred","LOINC","EntMass; EntNum; NFr","Clinical","",null,null,null,null,false],[false,"per 100 spermatozoa","/100{spermatozoa}","","",0.01,[0,0,0,0,0,0,0],null,null,false,null,null,1,false,false,0,"/100 spermatozoa; /100spermatozoa; per hundred","LOINC","NFr","Clinical","",null,null,null,null,false],[false,"per 100 white blood cells","/100{WBCs}","","",0.01,[0,0,0,0,0,0,0],null,null,false,null,null,1,false,false,0,"/100 WBCs; /100WBCs; per hundred","LOINC","Ratio; NFr","Clinical","",null,null,null,null,false],[false,"per year","/a","/ANN","",3.168808781402895e-8,[0,-1,0,0,0,0,0],"/a",null,false,null,null,1,false,false,0,"/Years; /yrs; yearly","LOINC","NRat","Clinical","",null,null,null,null,false],[false,"per centimeter of water","/cm[H2O]","/CM[H2O]","",0.000010197162129779282,[1,2,-1,0,0,0,0],"/cm HO<sub><r>2<.r></sub>",null,false,null,null,1,false,false,0,"/cmH2O; /cm H2O; centimeters; centimetres","LOINC","InvPress","Clinical","",null,null,null,null,false],[false,"per day","/d","/D","",0.000011574074074074073,[0,-1,0,0,0,0,0],"/d",null,false,null,null,1,false,false,0,"/dy; per day","LOINC","NRat","Clinical","",null,null,null,null,false],[false,"per deciliter","/dL","/DL","",10000,[-3,0,0,0,0,0,0],"/dL",null,false,null,null,1,false,false,0,"per dL; /deciliter; decilitre","LOINC","NCnc","Clinical","",null,null,null,null,false],[false,"per gram","/g","/G","",1,[0,0,-1,0,0,0,0],"/g",null,false,null,null,1,false,false,0,"/gm; /gram; per g","LOINC","NCnt","Clinical","",null,null,null,null,false],[false,"per hour","/h","/HR","",0.0002777777777777778,[0,-1,0,0,0,0,0],"/h",null,false,null,null,1,false,false,0,"/hr; /hour; per hr","LOINC","NRat","Clinical","",null,null,null,null,false],[false,"per kilogram","/kg","/KG","",0.001,[0,0,-1,0,0,0,0],"/kg",null,false,null,null,1,false,false,0,"per kg; per kilogram","LOINC","NCnt","Clinical","",null,null,null,null,false],[false,"per liter","/L","/L","",1000,[-3,0,0,0,0,0,0],"/L",null,false,null,null,1,false,false,0,"/liter; litre","LOINC","NCnc","Clinical","",null,null,null,null,false],[false,"per square meter","/m2","/M2","",1,[-2,0,0,0,0,0,0],"/m<sup>2<.sup>",null,false,null,null,1,false,false,0,"/m^2; /m*2; /sq. m; per square meter; meter squared; metre","LOINC","Naric","Clinical","",null,null,null,null,false],[false,"per cubic meter","/m3","/M3","",1,[-3,0,0,0,0,0,0],"/m<sup>3<.sup>",null,false,null,null,1,false,false,0,"/m^3; /m*3; /cu. m; per cubic meter; meter cubed; per m3; metre","LOINC","NCncn","Clinical","",null,null,null,null,false],[false,"per milligram","/mg","/MG","",1000,[0,0,-1,0,0,0,0],"/mg",null,false,null,null,1,false,false,0,"/milligram; per mg","LOINC","NCnt","Clinical","",null,null,null,null,false],[false,"per minute","/min","/MIN","",0.016666666666666666,[0,-1,0,0,0,0,0],"/min",null,false,null,null,1,false,false,0,"/minute; per mins; breaths beats per minute","LOINC","NRat","Clinical","",null,null,null,null,false],[false,"per milliliter","/mL","/ML","",1000000,[-3,0,0,0,0,0,0],"/mL",null,false,null,null,1,false,false,0,"/milliliter; per mL; millilitre","LOINC","NCncn","Clinical","",null,null,null,null,false],[false,"per millimeter","/mm","/MM","",1000,[-1,0,0,0,0,0,0],"/mm",null,false,null,null,1,false,false,0,"/millimeter; per mm; millimetre","LOINC","InvLen","Clinical","",null,null,null,null,false],[false,"per month","/mo","/MO","",3.802570537683474e-7,[0,-1,0,0,0,0,0],"/mo",null,false,null,null,1,false,false,0,"/month; per mo; monthly; month","LOINC","NRat","Clinical","",null,null,null,null,false],[false,"per second","/s","/S","",1,[0,-1,0,0,0,0,0],"/s",null,false,null,null,1,false,false,0,"/second; /sec; per sec; frequency; Hertz; Herz; Hz; becquerels; Bq; s-1; s^-1","LOINC","NRat","Clinical","",null,null,null,null,false],[false,"per enzyme unit","/U","/U","",9.963241120049633e-17,[0,1,0,0,0,0,0],"/U",null,false,null,null,1,false,false,-1,"/enzyme units; per U","LOINC","InvC; NCat","Clinical","1 U is the standard enzyme unit which equals 1 micromole substrate catalyzed per minute (1 umol/min)",null,null,null,null,false],[false,"per microliter","/uL","/UL","",999999999.9999999,[-3,0,0,0,0,0,0],"/μL",null,false,null,null,1,false,false,0,"/microliter; microlitre; /mcl; per uL","LOINC","ACnc","Clinical","",null,null,null,null,false],[false,"per week","/wk","/WK","",0.0000016534391534391535,[0,-1,0,0,0,0,0],"/wk",null,false,null,null,1,false,false,0,"/week; per wk; weekly, weeks","LOINC","NRat","Clinical","",null,null,null,null,false],[false,"APL unit per milliliter","[APL\'U]/mL","[APL\'U]/ML","biologic activity of anticardiolipin IgA",1000000,[-3,0,0,0,0,0,0],"/mL","chemical",false,null,null,1,false,true,0,"APL/mL; APL\'U/mL; APL U/mL; APL/milliliter; IgA anticardiolipin units per milliliter; IgA Phospholipid Units; millilitre; biologic activity of","LOINC","ACnc","Clinical","Units for an anti phospholipid syndrome test","1","1","1",1,false],[false,"arbitrary unit per milliliter","[arb\'U]/mL","[ARB\'U]/ML","arbitrary",1000000,[-3,0,0,0,0,0,0],"(arb. U)/mL","chemical",false,null,null,1,false,true,0,"arb\'U/mL; arbU/mL; arb U/mL; arbitrary units per milliliter; millilitre","LOINC","ACnc","Clinical","relative unit of measurement to show the ratio of test measurement to reference measurement","1","1","1",1,false],[false,"colony forming units per liter","[CFU]/L","[CFU]/L","amount of a proliferating organism",1000,[-3,0,0,0,0,0,0],"CFU/L","chemical",false,null,null,1,false,true,0,"CFU per Liter; CFU/L","LOINC","NCnc","Clinical","","1","1","1",1,false],[false,"colony forming units per milliliter","[CFU]/mL","[CFU]/ML","amount of a proliferating organism",1000000,[-3,0,0,0,0,0,0],"CFU/mL","chemical",false,null,null,1,false,true,0,"CFU per mL; CFU/mL","LOINC","NCnc","Clinical","","1","1","1",1,false],[false,"foot per foot - US","[ft_us]/[ft_us]","[FT_US]/[FT_US]","length",1,[0,0,0,0,0,0,0],"(ft<sub>us</sub>)/(ft<sub>us</sub>)","us-lengths",false,null,null,1,false,false,0,"ft/ft; ft per ft; feet per feet; visual acuity","","LenRto","Clinical","distance ratio to measure 20:20 vision","m/3937","M/3937","1200",1200,false],[false,"GPL unit per milliliter","[GPL\'U]/mL","[GPL\'U]/ML","biologic activity of anticardiolipin IgG",1000000,[-3,0,0,0,0,0,0],"/mL","chemical",false,null,null,1,false,true,0,"GPL U/mL; GPL\'U/mL; GPL/mL; GPL U per mL; IgG Phospholipid Units per milliliters; IgG anticardiolipin units; millilitres ","LOINC","ACnc; AMass","Clinical","Units for an antiphospholipid test","1","1","1",1,false],[false,"international unit per 2 hour","[IU]/(2.h)","[IU]/HR","arbitrary",0.0001388888888888889,[0,-1,0,0,0,0,0],"(i.U.)/h","chemical",true,null,null,1,false,true,0,"IU/2hrs; IU/2 hours; IU per 2 hrs; international units per 2 hours","LOINC","ARat","Clinical","International units (IU) are analyte and reference specimen  specific arbitrary units (held at WHO)","[iU]","[IU]","1",1,false],[false,"international unit per 24 hour","[IU]/(24.h)","[IU]/HR","arbitrary",0.000011574074074074073,[0,-1,0,0,0,0,0],"(i.U.)/h","chemical",true,null,null,1,false,true,0,"IU/24hr; IU/24 hours; IU per 24 hrs; international units per 24 hours","LOINC","ARat","Clinical","International units (IU) are analyte and reference specimen  specific arbitrary units (held at WHO)","[iU]","[IU]","1",1,false],[false,"international unit per day","[IU]/d","[IU]/D","arbitrary",0.000011574074074074073,[0,-1,0,0,0,0,0],"(i.U.)/d","chemical",true,null,null,1,false,true,0,"IU/dy; IU/days; IU per dys; international units per day","LOINC","ARat","Clinical","International units (IU) are analyte and reference specimen  specific arbitrary units (held at WHO)","[iU]","[IU]","1",1,false],[false,"international unit per deciliter","[IU]/dL","[IU]/DL","arbitrary",10000,[-3,0,0,0,0,0,0],"(i.U.)/dL","chemical",true,null,null,1,false,true,0,"IU/dL; IU per dL; international units per deciliters; decilitres","LOINC","ACnc","Clinical","International units (IU) are analyte and reference specimen  specific arbitrary units (held at WHO)","[iU]","[IU]","1",1,false],[false,"international unit per gram","[IU]/g","[IU]/G","arbitrary",1,[0,0,-1,0,0,0,0],"(i.U.)/g","chemical",true,null,null,1,false,true,0,"IU/gm; IU/gram; IU per gm; IU per g; international units per gram","LOINC","ACnt","Clinical","International units (IU) are analyte and reference specimen  specific arbitrary units (held at WHO)","[iU]","[IU]","1",1,false],[false,"international unit per hour","[IU]/h","[IU]/HR","arbitrary",0.0002777777777777778,[0,-1,0,0,0,0,0],"(i.U.)/h","chemical",true,null,null,1,false,true,0,"IU/hrs; IU per hours; international units per hour","LOINC","ARat","Clinical","International units (IU) are analyte and reference specimen  specific arbitrary units (held at WHO)","[iU]","[IU]","1",1,false],[false,"international unit per kilogram","[IU]/kg","[IU]/KG","arbitrary",0.001,[0,0,-1,0,0,0,0],"(i.U.)/kg","chemical",true,null,null,1,false,true,0,"IU/kg; IU/kilogram; IU per kg; units","LOINC","ACnt","Clinical","International units (IU) are analyte and reference specimen  specific arbitrary units (held at WHO)","[iU]","[IU]","1",1,false],[false,"international unit per kilogram per day","[IU]/kg/d","[IU]/KG/D","arbitrary",1.1574074074074074e-8,[0,-1,-1,0,0,0,0],"(i.U.)/kg/d","chemical",true,null,null,1,false,true,0,"IU/kg/dy; IU/kg/day; IU/kilogram/day; IU per kg per day; units","LOINC","ACntRat","Clinical","International units (IU) are analyte and reference specimen  specific arbitrary units (held at WHO)","[iU]","[IU]","1",1,false],[false,"international unit per liter","[IU]/L","[IU]/L","arbitrary",1000,[-3,0,0,0,0,0,0],"(i.U.)/L","chemical",true,null,null,1,false,true,0,"IU/L; IU/liter; IU per liter; units; litre","LOINC","ACnc","Clinical","International units (IU) are analyte and reference specimen  specific arbitrary units (held at WHO)","[iU]","[IU]","1",1,false],[false,"international unit per minute","[IU]/min","[IU]/MIN","arbitrary",0.016666666666666666,[0,-1,0,0,0,0,0],"(i.U.)/min","chemical",true,null,null,1,false,true,0,"IU/min; IU/minute; IU per minute; international units","LOINC","ARat","Clinical","International units (IU) are analyte and reference specimen  specific arbitrary units (held at WHO)","[iU]","[IU]","1",1,false],[false,"international unit per milliliter","[IU]/mL","[IU]/ML","arbitrary",1000000,[-3,0,0,0,0,0,0],"(i.U.)/mL","chemical",true,null,null,1,false,true,0,"IU/mL; IU per mL; international units per milliliter; millilitre","LOINC","ACnc","Clinical","International units (IU) are analyte and reference specimen  specific arbitrary units (held at WHO)","[iU]","[IU]","1",1,false],[false,"MPL unit per milliliter","[MPL\'U]/mL","[MPL\'U]/ML","biologic activity of anticardiolipin IgM",1000000,[-3,0,0,0,0,0,0],"/mL","chemical",false,null,null,1,false,true,0,"MPL/mL; MPL U/mL; MPL\'U/mL; IgM anticardiolipin units; IgM Phospholipid Units; millilitre ","LOINC","ACnc","Clinical","units for antiphospholipid test\\n","1","1","1",1,false],[false,"number per high power field","{#}/[HPF]","/[HPF]","",1,[0,0,0,0,0,0,0],"/HPF",null,false,null,null,1,false,false,0,"#/HPF; # per HPF; number/HPF; numbers per high power field","LOINC","Naric","Clinical","",null,null,null,null,false],[false,"number per low power field","{#}/[LPF]","/[LPF]","",1,[0,0,0,0,0,0,0],"/LPF",null,false,null,null,1,false,false,0,"#/LPF; # per LPF; number/LPF; numbers per low power field","LOINC","Naric","Clinical","",null,null,null,null,false],[false,"IgA antiphosphatidylserine unit ","{APS\'U}","","",1,[0,0,0,0,0,0,0],null,null,false,null,null,1,false,false,0,"APS Unit; Phosphatidylserine Antibody IgA Units","LOINC","ACnc","Clinical","unit for antiphospholipid test",null,null,null,null,false],[false,"EIA index","{EIA_index}","","",1,[0,0,0,0,0,0,0],null,null,false,null,null,1,false,false,0,"enzyme immunoassay index","LOINC","ACnc","Clinical","",null,null,null,null,false],[false,"kaolin clotting time","{KCT\'U}","","",1,[0,0,0,0,0,0,0],null,null,false,null,null,1,false,false,0,"KCT","LOINC","Time","Clinical","sensitive test to detect lupus anticoagulants; measured in seconds",null,null,null,null,false],[false,"IgM antiphosphatidylserine unit","{MPS\'U}","","",1,[0,0,0,0,0,0,0],null,null,false,null,null,1,false,false,0,"Phosphatidylserine Antibody IgM Measurement ","LOINC","ACnc","Clinical","",null,null,null,null,false],[false,"trillion per liter","10*12/L","(10*12)/L","number",1000000000000000,[-3,0,0,0,0,0,0],"(10<sup>12</sup>)/L","dimless",false,null,null,1,false,false,0,"10^12/L; 10*12 per Liter; trillion per liter; litre","LOINC","NCncn","Clinical","","1","1","10",10,false],[false,"10^3 (used for cell count)","10*3","10*3","number",1000,[0,0,0,0,0,0,0],"10<sup>3</sup>","dimless",false,null,null,1,false,false,0,"10^3; thousand","LOINC","Num","Clinical","usually used for counting entities (e.g. blood cells) per volume","1","1","10",10,false],[false,"thousand per liter","10*3/L","(10*3)/L","number",1000000,[-3,0,0,0,0,0,0],"(10<sup>3</sup>)/L","dimless",false,null,null,1,false,false,0,"10^3/L; 10*3 per liter; litre","LOINC","NCncn","Clinical","","1","1","10",10,false],[false,"thousand per milliliter","10*3/mL","(10*3)/ML","number",1000000000,[-3,0,0,0,0,0,0],"(10<sup>3</sup>)/mL","dimless",false,null,null,1,false,false,0,"10^3/mL; 10*3 per mL; thousand per milliliter; millilitre","LOINC","NCncn","Clinical","","1","1","10",10,false],[false,"thousand per microliter","10*3/uL","(10*3)/UL","number",999999999999.9999,[-3,0,0,0,0,0,0],"(10<sup>3</sup>)/μL","dimless",false,null,null,1,false,false,0,"10^3/uL; 10*3 per uL; thousand per microliter; microlitre","LOINC","NCncn","Clinical","","1","1","10",10,false],[false,"10 thousand per microliter","10*4/uL","(10*4)/UL","number",10000000000000,[-3,0,0,0,0,0,0],"(10<sup>4</sup>)/μL","dimless",false,null,null,1,false,false,0,"10^4/uL; 10*4 per uL; microlitre","LOINC","NCncn","Clinical","","1","1","10",10,false],[false,"10^5 ","10*5","10*5","number",100000,[0,0,0,0,0,0,0],"10<sup>5</sup>","dimless",false,null,null,1,false,false,0,"one hundred thousand","LOINC","Num","Clinical","","1","1","10",10,false],[false,"10^6","10*6","10*6","number",1000000,[0,0,0,0,0,0,0],"10<sup>6</sup>","dimless",false,null,null,1,false,false,0,"","LOINC","Num","Clinical","","1","1","10",10,false],[false,"million colony forming unit per liter","10*6.[CFU]/L","(10*6).[CFU]/L","number",1000000000,[-3,0,0,0,0,0,0],"(10<sup>6</sup>).CFU/L","dimless",false,null,null,1,false,true,0,"10*6 CFU/L; 10^6 CFU/L; 10^6CFU; 10^6 CFU per liter; million colony forming units; litre","LOINC","ACnc","Clinical","","1","1","10",10,false],[false,"million international unit","10*6.[IU]","(10*6).[IU]","number",1000000,[0,0,0,0,0,0,0],"(10<sup>6</sup>).(i.U.)","dimless",false,null,null,1,false,true,0,"10*6 IU; 10^6 IU; international units","LOINC","arb","Clinical","International units (IU) are analyte and reference specimen  specific arbitrary units (held at WHO)","1","1","10",10,false],[false,"million per 24 hour","10*6/(24.h)","(10*6)/HR","number",11.574074074074074,[0,-1,0,0,0,0,0],"(10<sup>6</sup>)/h","dimless",false,null,null,1,false,false,0,"10*6/24hrs; 10^6/24 hrs; 10*6 per 24 hrs; 10^6 per 24 hours","LOINC","NRat","Clinical","","1","1","10",10,false],[false,"million per kilogram","10*6/kg","(10*6)/KG","number",1000,[0,0,-1,0,0,0,0],"(10<sup>6</sup>)/kg","dimless",false,null,null,1,false,false,0,"10^6/kg; 10*6 per kg; 10*6 per kilogram; millions","LOINC","NCnt","Clinical","","1","1","10",10,false],[false,"million per liter","10*6/L","(10*6)/L","number",1000000000,[-3,0,0,0,0,0,0],"(10<sup>6</sup>)/L","dimless",false,null,null,1,false,false,0,"10^6/L; 10*6 per Liter; 10^6 per Liter; litre","LOINC","NCncn","Clinical","","1","1","10",10,false],[false,"million per milliliter","10*6/mL","(10*6)/ML","number",1000000000000,[-3,0,0,0,0,0,0],"(10<sup>6</sup>)/mL","dimless",false,null,null,1,false,false,0,"10^6/mL; 10*6 per mL; 10*6 per milliliter; millilitre","LOINC","NCncn","Clinical","","1","1","10",10,false],[false,"million per microliter","10*6/uL","(10*6)/UL","number",1000000000000000,[-3,0,0,0,0,0,0],"(10<sup>6</sup>)/μL","dimless",false,null,null,1,false,false,0,"10^6/uL; 10^6 per uL; 10^6/mcl; 10^6 per mcl; 10^6 per microliter; microlitre","LOINC","NCncn","Clinical","","1","1","10",10,false],[false,"10^8","10*8","10*8","number",100000000,[0,0,0,0,0,0,0],"10<sup>8</sup>","dimless",false,null,null,1,false,false,0,"100 million; one hundred million; 10^8","LOINC","Num","Clinical","","1","1","10",10,false],[false,"billion per liter","10*9/L","(10*9)/L","number",1000000000000,[-3,0,0,0,0,0,0],"(10<sup>9</sup>)/L","dimless",false,null,null,1,false,false,0,"10^9/L; 10*9 per Liter; litre","LOINC","NCncn","Clinical","","1","1","10",10,false],[false,"billion per milliliter","10*9/mL","(10*9)/ML","number",1000000000000000,[-3,0,0,0,0,0,0],"(10<sup>9</sup>)/mL","dimless",false,null,null,1,false,false,0,"10^9/mL; 10*9 per mL; 10^9 per mL; 10*9 per milliliter; millilitre","LOINC","NCncn","Clinical","","1","1","10",10,false],[false,"billion per microliter","10*9/uL","(10*9)/UL","number",1000000000000000000,[-3,0,0,0,0,0,0],"(10<sup>9</sup>)/μL","dimless",false,null,null,1,false,false,0,"10^9/uL; 10^9 per uL; 10^9/mcl; 10^9 per mcl; 10*9 per uL; 10*9 per mcl; 10*9/mcl; 10^9 per microliter; microlitre","LOINC","NCncn","Clinical","","1","1","10",10,false],[false,"10 liter per minute per square meter","10.L/(min.m2)","L/(MIN.M2)","",0.00016666666666666666,[1,-1,0,0,0,0,0],"L/(min.(m<sup>2</sup>))",null,false,null,null,1,false,false,0,"10 liters per minutes per square meter; 10 L per min per m2; m^2; 10 L/(min*m2); 10L/(min*m^2); litres; sq. meter; metre; meters squared","LOINC","ArVRat","Clinical","",null,null,null,null,false],[false,"10 liter per minute","10.L/min","L/MIN","",0.00016666666666666666,[3,-1,0,0,0,0,0],"L/min",null,false,null,null,1,false,false,0,"10 liters per minute; 10 L per min; 10L; 10 L/min; litre","LOINC","VRat","Clinical","",null,null,null,null,false],[false,"10 micronewton second per centimeter to the fifth power per square meter","10.uN.s/(cm5.m2)","(UN.S)/(CM5.M2)","",100000000,[-6,-1,1,0,0,0,0],"(μN.s)/(cm<sup>5</sup>).(m<sup>2</sup>)",null,false,null,null,1,false,false,0,"dyne seconds per centimeter5 and square meter; dyn.s/(cm5.m2); dyn.s/cm5/m2; cm^5; m^2","LOINC","","Clinical","unit to measure systemic vascular resistance per body surface area",null,null,null,null,false],[false,"24 hour","24.h","HR","",86400,[0,1,0,0,0,0,0],"h",null,false,null,null,1,false,false,0,"24hrs; 24 hrs; 24 hours; days; dy","LOINC","Time","Clinical","",null,null,null,null,false],[false,"ampere per meter","A/m","A/M","electric current",1,[-1,-1,0,0,0,1,0],"A/m","si",true,null,null,1,false,false,0,"A/m; amp/meter; magnetic field strength; H; B; amperes per meter; metre","LOINC","","Clinical","unit of magnetic field strength","C/s","C/S","1",1,false],[true,"centigram","cg","CG","mass",0.01,[0,0,1,0,0,0,0],"cg",null,false,"M",null,1,false,false,0,"centigrams; cg; cgm","LOINC","Mass","Clinical","",null,null,null,null,false],[false,"centiliter","cL","CL","volume",0.00001,[3,0,0,0,0,0,0],"cL","iso1000",true,null,null,1,false,false,0,"centiliters; centilitres","LOINC","Vol","Clinical","","l",null,"1",1,false],[true,"centimeter","cm","CM","length",0.01,[1,0,0,0,0,0,0],"cm",null,false,"L",null,1,false,false,0,"centimeters; centimetres","LOINC","Len","Clinical","",null,null,null,null,false],[false,"centimeter of water","cm[H2O]","CM[H2O]","pressure",98066.5,[-1,-2,1,0,0,0,0],"cm HO<sub><r>2</r></sub>","clinical",true,null,null,1,false,false,0,"cm H2O; cmH2O; centimetres; pressure","LOINC","Pres","Clinical","unit of pressure mostly applies to blood pressure","kPa","KPAL","980665e-5",9.80665,false],[false,"centimeter of water per liter per second","cm[H2O]/L/s","(CM[H2O]/L)/S","pressure",98066500,[-4,-3,1,0,0,0,0],"(cm HO<sub><r>2</r></sub>)/L/s","clinical",true,null,null,1,false,false,0,"cm[H2O]/(L/s); cm[H2O].s/L; cm H2O/L/sec; cmH2O/L/sec; cmH2O/Liter; cmH2O per L per secs; centimeters of water per liters per second; centimetres; litres; cm[H2O]/(L/s)","LOINC","PresRat","Clinical","unit used to measure mean pulmonary resistance","kPa","KPAL","980665e-5",9.80665,false],[false,"centimeter of water per second per meter","cm[H2O]/s/m","(CM[H2O]/S)/M","pressure",98066.5,[-2,-3,1,0,0,0,0],"(cm HO<sub><r>2</r></sub>)/s/m","clinical",true,null,null,1,false,false,0,"cm[H2O]/(s.m); cm H2O/s/m; cmH2O; cmH2O/sec/m; cmH2O per secs per meters; centimeters of water per seconds per meter; centimetres; metre","LOINC","PresRat","Clinical","unit used to measure pulmonary pressure time product","kPa","KPAL","980665e-5",9.80665,false],[false,"centimeter of mercury","cm[Hg]","CM[HG]","pressure",1333220,[-1,-2,1,0,0,0,0],"cm Hg","clinical",true,null,null,1,false,false,0,"centimeters of mercury; centimetres; cmHg; cm Hg","LOINC","Pres","Clinical","unit of pressure where 1 cmHg = 10 torr","kPa","KPAL","133.3220",133.322,false],[true,"square centimeter","cm2","CM2","length",0.0001,[2,0,0,0,0,0,0],"cm<sup>2</sup>",null,false,"L",null,1,false,false,0,"cm^2; sq cm; centimeters squared; square centimeters; centimetre; area","LOINC","Area","Clinical","",null,null,null,null,false],[true,"square centimeter per second","cm2/s","CM2/S","length",0.0001,[2,-1,0,0,0,0,0],"(cm<sup>2</sup>)/s",null,false,"L",null,1,false,false,0,"cm^2/sec; square centimeters per second; sq cm per sec; cm2; centimeters squared; centimetres","LOINC","AreaRat","Clinical","",null,null,null,null,false],[false,"centipoise","cP","CP","dynamic viscosity",1,[-1,-1,1,0,0,0,0],"cP","cgs",true,null,null,1,false,false,0,"cps; centiposes","LOINC","Visc","Clinical","unit of dynamic viscosity in the CGS system with base units: 10^−3 Pa.s = 1 mPa·.s (1 millipascal second)","dyn.s/cm2","DYN.S/CM2","1",1,false],[false,"centistoke","cSt","CST","kinematic viscosity",0.0000010000000000000002,[2,-1,0,0,0,0,0],"cSt","cgs",true,null,null,1,false,false,0,"centistokes","LOINC","Visc","Clinical","unit for kinematic viscosity with base units of mm^2/s (square millimeter per second)","cm2/s","CM2/S","1",1,false],[false,"dekaliter per minute","daL/min","DAL/MIN","volume",0.00016666666666666666,[3,-1,0,0,0,0,0],"daL/min","iso1000",true,null,null,1,false,false,0,"dekalitres; dekaliters per minute; per min","LOINC","VRat","Clinical","","l",null,"1",1,false],[false,"dekaliter per minute per square meter","daL/min/m2","(DAL/MIN)/M2","volume",0.00016666666666666666,[1,-1,0,0,0,0,0],"(daL/min)/(m<sup>2</sup>)","iso1000",true,null,null,1,false,false,0,"daL/min/m^2; daL/minute/m2; sq. meter; dekaliters per minutes per square meter; meter squared; dekalitres; metre","LOINC","ArVRat","Clinical","The area usually is the body surface area used to normalize cardiovascular measures for patient\'s size","l",null,"1",1,false],[false,"decibel","dB","DB","level",1,[0,0,0,0,0,0,0],"dB","levels",true,null,"lg",0.1,true,false,0,"decibels","LOINC","LogRto","Clinical","unit most commonly used in acoustics as unit of sound pressure level. (also see B[SPL] or bel sound pressure level). ","1",null,null,1,false],[false,"degree per second","deg/s","DEG/S","plane angle",0.017453292519943295,[0,-1,0,1,0,0,0],"°/s","iso1000",false,null,null,1,false,false,0,"deg/sec; deg per sec; °/sec; twist rate; angular speed; rotational speed","LOINC","ARat","Clinical","unit of angular (rotational) speed used to express turning rate","[pi].rad/360","[PI].RAD/360","2",2,false],[true,"decigram","dg","DG","mass",0.1,[0,0,1,0,0,0,0],"dg",null,false,"M",null,1,false,false,0,"decigrams; dgm; 0.1 grams; 1/10 gm","LOINC","Mass","Clinical","equal to 1/10 gram",null,null,null,null,false],[false,"deciliter","dL","DL","volume",0.0001,[3,0,0,0,0,0,0],"dL","iso1000",true,null,null,1,false,false,0,"deciliters; decilitres; 0.1 liters; 1/10 L","LOINC","Vol","Clinical","equal to 1/10 liter","l",null,"1",1,false],[true,"decimeter","dm","DM","length",0.1,[1,0,0,0,0,0,0],"dm",null,false,"L",null,1,false,false,0,"decimeters; decimetres; 0.1 meters; 1/10 m; 10 cm; centimeters","LOINC","Len","Clinical","equal to 1/10 meter or 10 centimeters",null,null,null,null,false],[true,"square decimeter per square second","dm2/s2","DM2/S2","length",0.010000000000000002,[2,-2,0,0,0,0,0],"(dm<sup>2</sup>)/(s<sup>2</sup>)",null,false,"L",null,1,false,false,0,"dm2 per s2; dm^2/s^2; decimeters squared per second squared; sq dm; sq sec","LOINC","EngMass (massic energy)","Clinical","units for energy per unit mass or Joules per kilogram (J/kg = kg.m2/s2/kg = m2/s2) ",null,null,null,null,false],[false,"dyne second per centimeter per square meter","dyn.s/(cm.m2)","(DYN.S)/(CM.M2)","force",1,[-2,-1,1,0,0,0,0],"(dyn.s)/(cm.(m<sup>2</sup>))","cgs",true,null,null,1,false,false,0,"(dyn*s)/(cm*m2); (dyn*s)/(cm*m^2); dyn s per cm per m2; m^2; dyne seconds per centimeters per square meter; centimetres; sq. meter; squared","LOINC","","Clinical","","g.cm/s2","G.CM/S2","1",1,false],[false,"dyne second per centimeter","dyn.s/cm","(DYN.S)/CM","force",1,[0,-1,1,0,0,0,0],"(dyn.s)/cm","cgs",true,null,null,1,false,false,0,"(dyn*s)/cm; dyn sec per cm; seconds; centimetre; dyne seconds","LOINC","","Clinical","","g.cm/s2","G.CM/S2","1",1,false],[false,"equivalent per liter","eq/L","EQ/L","amount of substance",6.0221366999999994e+26,[-3,0,0,0,0,0,0],"eq/L","chemical",true,null,null,1,false,false,1,"eq/liter; eq/litre; eqs; equivalents per liter; litre","LOINC","SCnc","Clinical","equivalence equals moles per valence","mol","MOL","1",1,false],[false,"equivalent per milliliter","eq/mL","EQ/ML","amount of substance",6.0221367e+29,[-3,0,0,0,0,0,0],"eq/mL","chemical",true,null,null,1,false,false,1,"equivalent/milliliter; equivalents per milliliter; eq per mL; millilitre","LOINC","SCnc","Clinical","equivalence equals moles per valence","mol","MOL","1",1,false],[false,"equivalent per millimole","eq/mmol","EQ/MMOL","amount of substance",1000,[0,0,0,0,0,0,0],"eq/mmol","chemical",true,null,null,1,false,false,0,"equivalent/millimole; equivalents per millimole; eq per mmol","LOINC","SRto","Clinical","equivalence equals moles per valence","mol","MOL","1",1,false],[false,"equivalent per micromole","eq/umol","EQ/UMOL","amount of substance",1000000,[0,0,0,0,0,0,0],"eq/μmol","chemical",true,null,null,1,false,false,0,"equivalent/micromole; equivalents per micromole; eq per umol","LOINC","SRto","Clinical","equivalence equals moles per valence","mol","MOL","1",1,false],[true,"femtogram","fg","FG","mass",1e-15,[0,0,1,0,0,0,0],"fg",null,false,"M",null,1,false,false,0,"fg; fgm; femtograms; weight","LOINC","Mass","Clinical","equal to 10^-15 grams",null,null,null,null,false],[false,"femtoliter","fL","FL","volume",1e-18,[3,0,0,0,0,0,0],"fL","iso1000",true,null,null,1,false,false,0,"femtolitres; femtoliters","LOINC","Vol; EntVol","Clinical","equal to 10^-15 liters","l",null,"1",1,false],[true,"femtometer","fm","FM","length",1e-15,[1,0,0,0,0,0,0],"fm",null,false,"L",null,1,false,false,0,"femtometres; femtometers","LOINC","Len","Clinical","equal to 10^-15 meters",null,null,null,null,false],[false,"femtomole","fmol","FMOL","amount of substance",602213670,[0,0,0,0,0,0,0],"fmol","si",true,null,null,1,false,false,1,"femtomoles","LOINC","EntSub","Clinical","equal to 10^-15 moles","10*23","10*23","6.0221367",6.0221367,false],[false,"femtomole per gram","fmol/g","FMOL/G","amount of substance",602213670,[0,0,-1,0,0,0,0],"fmol/g","si",true,null,null,1,false,false,1,"femtomoles; fmol/gm; fmol per gm","LOINC","SCnt","Clinical","","10*23","10*23","6.0221367",6.0221367,false],[false,"femtomole per liter","fmol/L","FMOL/L","amount of substance",602213670000,[-3,0,0,0,0,0,0],"fmol/L","si",true,null,null,1,false,false,1,"femtomoles; fmol per liter; litre","LOINC","SCnc","Clinical","","10*23","10*23","6.0221367",6.0221367,false],[false,"femtomole per milligram","fmol/mg","FMOL/MG","amount of substance",602213670000,[0,0,-1,0,0,0,0],"fmol/mg","si",true,null,null,1,false,false,1,"fmol per mg; femtomoles","LOINC","SCnt","Clinical","","10*23","10*23","6.0221367",6.0221367,false],[false,"femtomole per milliliter","fmol/mL","FMOL/ML","amount of substance",602213670000000,[-3,0,0,0,0,0,0],"fmol/mL","si",true,null,null,1,false,false,1,"femtomoles; millilitre; fmol per mL; fmol per milliliter","LOINC","SCnc","Clinical","","10*23","10*23","6.0221367",6.0221367,false],[true,"gram meter","g.m","G.M","mass",1,[1,0,1,0,0,0,0],"g.m",null,false,"M",null,1,false,false,0,"g*m; gxm; meters; metres","LOINC","Enrg","Clinical","Unit for measuring stroke work (heart work)",null,null,null,null,false],[true,"gram per 100 gram","g/(100.g)","G/G","mass",0.01,[0,0,0,0,0,0,0],"g/g",null,false,"M",null,1,false,false,0,"g/100 gm; 100gm; grams per 100 grams; gm per 100 gm","LOINC","MCnt","Clinical","",null,null,null,null,false],[true,"gram per 12 hour","g/(12.h)","G/HR","mass",0.000023148148148148147,[0,-1,1,0,0,0,0],"g/h",null,false,"M",null,1,false,false,0,"gm/12hrs; 12 hrs; gm per 12 hrs; 12hrs; grams per 12 hours","LOINC","MRat","Clinical","",null,null,null,null,false],[true,"gram per 24 hour","g/(24.h)","G/HR","mass",0.000011574074074074073,[0,-1,1,0,0,0,0],"g/h",null,false,"M",null,1,false,false,0,"gm/24hrs; gm/24 hrs; gm per 24 hrs; 24hrs; grams per 24 hours; gm/dy; gm per dy; grams per day","LOINC","MRat","Clinical","",null,null,null,null,false],[true,"gram per 3 days","g/(3.d)","G/D","mass",0.000003858024691358025,[0,-1,1,0,0,0,0],"g/d",null,false,"M",null,1,false,false,0,"gm/3dy; gm/3 dy; gm per 3 days; grams","LOINC","MRat","Clinical","",null,null,null,null,false],[true,"gram per 4 hour","g/(4.h)","G/HR","mass",0.00006944444444444444,[0,-1,1,0,0,0,0],"g/h",null,false,"M",null,1,false,false,0,"gm/4hrs; gm/4 hrs; gm per 4 hrs; 4hrs; grams per 4 hours","LOINC","MRat","Clinical","",null,null,null,null,false],[true,"gram per 48 hour","g/(48.h)","G/HR","mass",0.000005787037037037037,[0,-1,1,0,0,0,0],"g/h",null,false,"M",null,1,false,false,0,"gm/48hrs; gm/48 hrs; gm per 48 hrs; 48hrs; grams per 48 hours","LOINC","MRat","Clinical","",null,null,null,null,false],[true,"gram per 5 hour","g/(5.h)","G/HR","mass",0.00005555555555555556,[0,-1,1,0,0,0,0],"g/h",null,false,"M",null,1,false,false,0,"gm/5hrs; gm/5 hrs; gm per 5 hrs; 5hrs; grams per 5 hours","LOINC","MRat","Clinical","",null,null,null,null,false],[true,"gram per 6 hour","g/(6.h)","G/HR","mass",0.000046296296296296294,[0,-1,1,0,0,0,0],"g/h",null,false,"M",null,1,false,false,0,"gm/6hrs; gm/6 hrs; gm per 6 hrs; 6hrs; grams per 6 hours","LOINC","MRat","Clinical","",null,null,null,null,false],[true,"gram per 72 hour","g/(72.h)","G/HR","mass",0.000003858024691358025,[0,-1,1,0,0,0,0],"g/h",null,false,"M",null,1,false,false,0,"gm/72hrs; gm/72 hrs; gm per 72 hrs; 72hrs; grams per 72 hours","LOINC","MRat","Clinical","",null,null,null,null,false],[true,"gram per cubic centimeter","g/cm3","G/CM3","mass",999999.9999999999,[-3,0,1,0,0,0,0],"g/(cm<sup>3</sup>)",null,false,"M",null,1,false,false,0,"g/cm^3; gm per cm3; g per cm^3; grams per centimeter cubed; cu. cm; centimetre; g/mL; gram per milliliter; millilitre","LOINC","MCnc","Clinical","g/cm3 = g/mL",null,null,null,null,false],[true,"gram per day","g/d","G/D","mass",0.000011574074074074073,[0,-1,1,0,0,0,0],"g/d",null,false,"M",null,1,false,false,0,"gm/dy; gm per dy; grams per day; gm/24hrs; gm/24 hrs; gm per 24 hrs; 24hrs; grams per 24 hours; serving","LOINC","MRat","Clinical","",null,null,null,null,false],[true,"gram per deciliter","g/dL","G/DL","mass",10000,[-3,0,1,0,0,0,0],"g/dL",null,false,"M",null,1,false,false,0,"gm/dL; gm per dL; grams per deciliter; decilitre","LOINC","MCnc","Clinical","",null,null,null,null,false],[true,"gram per gram","g/g","G/G","mass",1,[0,0,0,0,0,0,0],"g/g",null,false,"M",null,1,false,false,0,"gm; grams","LOINC","MRto ","Clinical","",null,null,null,null,false],[true,"gram per hour","g/h","G/HR","mass",0.0002777777777777778,[0,-1,1,0,0,0,0],"g/h",null,false,"M",null,1,false,false,0,"gm/hr; gm per hr; grams; intake; output","LOINC","MRat","Clinical","",null,null,null,null,false],[true,"gram per hour per square meter","g/h/m2","(G/HR)/M2","mass",0.0002777777777777778,[-2,-1,1,0,0,0,0],"(g/h)/(m<sup>2</sup>)",null,false,"M",null,1,false,false,0,"gm/hr/m2; gm/h/m2; /m^2; sq. m; g per hr per m2; grams per hours per square meter; meter squared; metre","LOINC","ArMRat","Clinical","",null,null,null,null,false],[true,"gram per kilogram","g/kg ","G/KG","mass",0.001,[0,0,0,0,0,0,0],"g/kg",null,false,"M",null,1,false,false,0,"g per kg; gram per kilograms","LOINC","MCnt","Clinical","",null,null,null,null,false],[true,"gram per kilogram per 8 hour ","g/kg/(8.h)","(G/KG)/HR","mass",3.472222222222222e-8,[0,-1,0,0,0,0,0],"(g/kg)/h",null,false,"M",null,1,false,false,0,"g/(8.kg.h); gm/kg/8hrs; 8 hrs; g per kg per 8 hrs; 8hrs; grams per kilograms per 8 hours; shift","LOINC","MCntRat; RelMRat","Clinical","unit often used to describe mass in grams of protein consumed in a 8 hours, divided by the subject\'s body weight in kilograms. Also used to measure mass dose rate per body mass",null,null,null,null,false],[true,"gram per kilogram per day","g/kg/d","(G/KG)/D","mass",1.1574074074074074e-8,[0,-1,0,0,0,0,0],"(g/kg)/d",null,false,"M",null,1,false,false,0,"g/(kg.d); gm/kg/dy; gm per kg per dy; grams per kilograms per day","LOINC","RelMRat","Clinical","unit often used to describe mass in grams of protein consumed in a day, divided by the subject\'s body weight in kilograms. Also used to measure mass dose rate per body mass",null,null,null,null,false],[true,"gram per kilogram per hour","g/kg/h","(G/KG)/HR","mass",2.7777777777777776e-7,[0,-1,0,0,0,0,0],"(g/kg)/h",null,false,"M",null,1,false,false,0,"g/(kg.h); g/kg/hr; g per kg per hrs; grams per kilograms per hour","LOINC","MCntRat; RelMRat","Clinical","unit used to measure mass dose rate per body mass",null,null,null,null,false],[true,"gram per kilogram per minute","g/kg/min","(G/KG)/MIN","mass",0.000016666666666666667,[0,-1,0,0,0,0,0],"(g/kg)/min",null,false,"M",null,1,false,false,0,"g/(kg.min); g/kg/min; g per kg per min; grams per kilograms per minute","LOINC","MCntRat; RelMRat","Clinical","unit used to measure mass dose rate per body mass",null,null,null,null,false],[true,"gram per liter","g/L","G/L","mass",1000,[-3,0,1,0,0,0,0],"g/L",null,false,"M",null,1,false,false,0,"gm per liter; g/liter; grams per liter; litre","LOINC","MCnc","Clinical","",null,null,null,null,false],[true,"gram per square meter","g/m2","G/M2","mass",1,[-2,0,1,0,0,0,0],"g/(m<sup>2</sup>)",null,false,"M",null,1,false,false,0,"g/m^2; gram/square meter; g/sq m; g per m2; g per m^2; grams per square meter; meters squared; metre","LOINC","ArMass","Clinical","Tests measure myocardial mass (heart ventricle system) per body surface area; unit used to measure mass dose per body surface area",null,null,null,null,false],[true,"gram per milligram","g/mg","G/MG","mass",1000,[0,0,0,0,0,0,0],"g/mg",null,false,"M",null,1,false,false,0,"g per mg; grams per milligram","LOINC","MCnt; MRto","Clinical","",null,null,null,null,false],[true,"gram per minute","g/min","G/MIN","mass",0.016666666666666666,[0,-1,1,0,0,0,0],"g/min",null,false,"M",null,1,false,false,0,"g per min; grams per minute; gram/minute","LOINC","MRat","Clinical","",null,null,null,null,false],[true,"gram per milliliter","g/mL","G/ML","mass",1000000,[-3,0,1,0,0,0,0],"g/mL",null,false,"M",null,1,false,false,0,"g per mL; grams per milliliter; millilitre","LOINC","MCnc","Clinical","",null,null,null,null,false],[true,"gram per millimole","g/mmol","G/MMOL","mass",1.6605401866749388e-21,[0,0,1,0,0,0,0],"g/mmol",null,false,"M",null,1,false,false,-1,"grams per millimole; g per mmol","LOINC","Ratio","Clinical","",null,null,null,null,false],[false,"joule per liter","J/L","J/L","energy",1000000,[-1,-2,1,0,0,0,0],"J/L","si",true,null,null,1,false,false,0,"joules per liter; litre; J per L","LOINC","EngCnc","Clinical","","N.m","N.M","1",1,false],[true,"degree Kelvin per Watt","K/W","K/W","temperature",0.001,[-2,3,-1,0,1,0,0],"K/W",null,false,"C",null,1,false,false,0,"degree Kelvin/Watt; K per W; thermal ohm; thermal resistance; degrees","LOINC","TempEngRat","Clinical","unit for absolute thermal resistance equal to the reciprocal of thermal conductance. Unit used for tests to measure work of breathing",null,null,null,null,false],[false,"kilo international unit per liter","k[IU]/L","K[IU]/L","arbitrary",1000000,[-3,0,0,0,0,0,0],"(ki.U.)/L","chemical",true,null,null,1,false,true,0,"kIU/L; kIU per L; kIU per liter; kilo international units; litre; allergens; allergy units","LOINC","ACnc","Clinical","IgE has an WHO reference standard so IgE allergen testing can be reported as k[IU]/L","[iU]","[IU]","1",1,false],[false,"kilo international unit per milliliter","k[IU]/mL","K[IU]/ML","arbitrary",1000000000,[-3,0,0,0,0,0,0],"(ki.U.)/mL","chemical",true,null,null,1,false,true,0,"kIU/mL; kIU per mL; kIU per milliliter; kilo international units; millilitre; allergens; allergy units","LOINC","ACnc","Clinical","IgE has an WHO reference standard so IgE allergen testing can be reported as k[IU]/mL","[iU]","[IU]","1",1,false],[false,"katal per kilogram","kat/kg","KAT/KG","catalytic activity",602213670000000000000,[0,-1,-1,0,0,0,0],"kat/kg","chemical",true,null,null,1,false,false,1,"kat per kg; katals per kilogram; mol/s/kg; moles per seconds per kilogram","LOINC","CCnt","Clinical","kat is a unit of catalytic activity with base units = mol/s. Rarely used because its units are too large to practically express catalytic activity. See enzyme unit [U] which is the standard unit for catalytic activity.","mol/s","MOL/S","1",1,false],[false,"katal per liter","kat/L","KAT/L","catalytic activity",6.0221366999999994e+26,[-3,-1,0,0,0,0,0],"kat/L","chemical",true,null,null,1,false,false,1,"kat per L; katals per liter; litre; mol/s/L; moles per seconds per liter","LOINC","CCnc","Clinical","kat is a unit of catalytic activity with base units = mol/s. Rarely used because its units are too large to practically express catalytic activity. See enzyme unit [U] which is the standard unit for catalytic activity.","mol/s","MOL/S","1",1,false],[false,"kilocalorie","kcal","KCAL","energy",4184000,[2,-2,1,0,0,0,0],"kcal","heat",true,null,null,1,false,false,0,"kilogram calories; large calories; food calories; kcals","LOINC","EngRat","Clinical","It is equal to 1000 calories (equal to 4.184 kJ). But in practical usage, kcal refers to food calories which excludes caloric content in fiber and other constitutes that is not digestible by humans. Also see nutrition label Calories ([Cal])","cal_th","CAL_TH","1",1,false],[false,"kilocalorie per 24 hour","kcal/(24.h)","KCAL/HR","energy",48.425925925925924,[2,-3,1,0,0,0,0],"kcal/h","heat",true,null,null,1,false,false,0,"kcal/24hrs; kcal/24 hrs; kcal per 24hrs; kilocalories per 24 hours; kilojoules; kJ/24hr; kJ/(24.h); kJ/dy; kilojoules per days; intake; calories burned; metabolic rate; food calories","","EngRat","Clinical","","cal_th","CAL_TH","1",1,false],[false,"kilocalorie per ounce","kcal/[oz_av]","KCAL/[OZ_AV]","energy",147586.25679704445,[2,-2,0,0,0,0,0],"kcal/oz","heat",true,null,null,1,false,false,0,"kcal/oz; kcal per ozs; large calories per ounces; food calories; servings; international","LOINC","EngCnt","Clinical","used in nutrition to represent calorie of food","cal_th","CAL_TH","1",1,false],[false,"kilocalorie per day","kcal/d","KCAL/D","energy",48.425925925925924,[2,-3,1,0,0,0,0],"kcal/d","heat",true,null,null,1,false,false,0,"kcal/dy; kcal per day; kilocalories per days; kilojoules; kJ/dy; kilojoules per days; intake; calories burned; metabolic rate; food calories","LOINC","EngRat","Clinical","unit in nutrition for food intake (measured in calories) in a day","cal_th","CAL_TH","1",1,false],[false,"kilocalorie per hour","kcal/h","KCAL/HR","energy",1162.2222222222222,[2,-3,1,0,0,0,0],"kcal/h","heat",true,null,null,1,false,false,0,"kcal/hrs; kcals per hr; intake; kilocalories per hours; kilojoules","LOINC","EngRat","Clinical","used in nutrition to represent caloric requirement or consumption","cal_th","CAL_TH","1",1,false],[false,"kilocalorie per kilogram per 24 hour","kcal/kg/(24.h)","(KCAL/KG)/HR","energy",0.04842592592592593,[2,-3,0,0,0,0,0],"(kcal/kg)/h","heat",true,null,null,1,false,false,0,"kcal/kg/24hrs; 24 hrs; kcal per kg per 24hrs; kilocalories per kilograms per 24 hours; kilojoules","LOINC","EngCntRat","Clinical","used in nutrition to represent caloric requirement per day based on subject\'s body weight in kilograms","cal_th","CAL_TH","1",1,false],[true,"kilogram","kg","KG","mass",1000,[0,0,1,0,0,0,0],"kg",null,false,"M",null,1,false,false,0,"kilograms; kgs","LOINC","Mass","Clinical","",null,null,null,null,false],[true,"kilogram meter per second","kg.m/s","(KG.M)/S","mass",1000,[1,-1,1,0,0,0,0],"(kg.m)/s",null,false,"M",null,1,false,false,0,"kg*m/s; kg.m per sec; kg*m per sec; p; momentum","LOINC","","Clinical","unit for momentum =  mass times velocity",null,null,null,null,false],[true,"kilogram per second per square meter","kg/(s.m2)","KG/(S.M2)","mass",1000,[-2,-1,1,0,0,0,0],"kg/(s.(m<sup>2</sup>))",null,false,"M",null,1,false,false,0,"kg/(s*m2); kg/(s*m^2); kg per s per m2; per sec; per m^2; kilograms per seconds per square meter; meter squared; metre","LOINC","ArMRat","Clinical","",null,null,null,null,false],[true,"kilogram per hour","kg/h","KG/HR","mass",0.2777777777777778,[0,-1,1,0,0,0,0],"kg/h",null,false,"M",null,1,false,false,0,"kg/hr; kg per hr; kilograms per hour","LOINC","MRat","Clinical","",null,null,null,null,false],[true,"kilogram per liter","kg/L","KG/L","mass",1000000,[-3,0,1,0,0,0,0],"kg/L",null,false,"M",null,1,false,false,0,"kg per liter; litre; kilograms","LOINC","MCnc","Clinical","",null,null,null,null,false],[true,"kilogram per square meter","kg/m2","KG/M2","mass",1000,[-2,0,1,0,0,0,0],"kg/(m<sup>2</sup>)",null,false,"M",null,1,false,false,0,"kg/m^2; kg/sq. m; kg per m2; per m^2; per sq. m; kilograms; meter squared; metre; BMI","LOINC","Ratio","Clinical","units for body mass index (BMI)",null,null,null,null,false],[true,"kilogram per cubic meter","kg/m3","KG/M3","mass",1000,[-3,0,1,0,0,0,0],"kg/(m<sup>3</sup>)",null,false,"M",null,1,false,false,0,"kg/m^3; kg/cu. m; kg per m3; per m^3; per cu. m; kilograms; meters cubed; metre","LOINC","MCnc","Clinical","",null,null,null,null,false],[true,"kilogram per minute","kg/min","KG/MIN","mass",16.666666666666668,[0,-1,1,0,0,0,0],"kg/min",null,false,"M",null,1,false,false,0,"kilogram/minute; kg per min; kilograms per minute","LOINC","MRat","Clinical","",null,null,null,null,false],[true,"kilogram per mole","kg/mol","KG/MOL","mass",1.6605401866749388e-21,[0,0,1,0,0,0,0],"kg/mol",null,false,"M",null,1,false,false,-1,"kilogram/mole; kg per mol; kilograms per mole","LOINC","SCnt","Clinical","",null,null,null,null,false],[true,"kilogram per second","kg/s","KG/S","mass",1000,[0,-1,1,0,0,0,0],"kg/s",null,false,"M",null,1,false,false,0,"kg/sec; kilogram/second; kg per sec; kilograms; second","LOINC","MRat","Clinical","",null,null,null,null,false],[false,"kiloliter","kL","KL","volume",1,[3,0,0,0,0,0,0],"kL","iso1000",true,null,null,1,false,false,0,"kiloliters; kilolitres; m3; m^3; meters cubed; metre","LOINC","Vol","Clinical","","l",null,"1",1,false],[true,"kilometer","km","KM","length",1000,[1,0,0,0,0,0,0],"km",null,false,"L",null,1,false,false,0,"kilometers; kilometres; distance","LOINC","Len","Clinical","",null,null,null,null,false],[false,"kilopascal","kPa","KPAL","pressure",1000000,[-1,-2,1,0,0,0,0],"kPa","si",true,null,null,1,false,false,0,"kilopascals; pressure","LOINC","Pres; PPresDiff","Clinical","","N/m2","N/M2","1",1,false],[true,"kilosecond","ks","KS","time",1000,[0,1,0,0,0,0,0],"ks",null,false,"T",null,1,false,false,0,"kiloseconds; ksec","LOINC","Time","Clinical","",null,null,null,null,false],[false,"kilo enzyme unit","kU","KU","catalytic activity",10036894500000000000,[0,-1,0,0,0,0,0],"kU","chemical",true,null,null,1,false,false,1,"units; mmol/min; millimoles per minute","LOINC","CAct","Clinical","1 U is the standard enzyme unit which equals 1 micromole substrate catalyzed per minute (1 umol/min); 1 kU = 1 mmol/min","umol/min","UMOL/MIN","1",1,false],[false,"kilo enzyme unit per gram","kU/g","KU/G","catalytic activity",10036894500000000000,[0,-1,-1,0,0,0,0],"kU/g","chemical",true,null,null,1,false,false,1,"units per grams; kU per gm","LOINC","CCnt","Clinical","1 U is the standard enzyme unit which equals 1 micromole substrate catalyzed per minute (1 umol/min); 1 kU = 1 mmol/min","umol/min","UMOL/MIN","1",1,false],[false,"kilo enzyme unit per liter","kU/L","KU/L","catalytic activity",1.00368945e+22,[-3,-1,0,0,0,0,0],"kU/L","chemical",true,null,null,1,false,false,1,"units per liter; litre; enzymatic activity; enzyme activity per volume; activities","LOINC","ACnc; CCnc","Clinical","1 U is the standard enzyme unit which equals 1 micromole substrate catalyzed per minute (1 umol/min); 1 kU = 1 mmol/min","umol/min","UMOL/MIN","1",1,false],[false,"kilo enzyme unit per milliliter","kU/mL","KU/ML","catalytic activity",1.00368945e+25,[-3,-1,0,0,0,0,0],"kU/mL","chemical",true,null,null,1,false,false,1,"kU per mL; units per milliliter; millilitre; enzymatic activity per volume; enzyme activities","LOINC","CCnc","Clinical","1 U is the standard enzyme unit which equals 1 micromole substrate catalyzed per minute (1 umol/min); 1 kU = 1 mmol/min","umol/min","UMOL/MIN","1",1,false],[false,"Liters per 24 hour","L/(24.h)","L/HR","volume",1.1574074074074074e-8,[3,-1,0,0,0,0,0],"L/h","iso1000",true,null,null,1,false,false,0,"L/24hrs; L/24 hrs; L per 24hrs; liters per 24 hours; day; dy; litres; volume flow rate","LOINC","VRat","Clinical","","l",null,"1",1,false],[false,"Liters per 8 hour","L/(8.h)","L/HR","volume",3.472222222222222e-8,[3,-1,0,0,0,0,0],"L/h","iso1000",true,null,null,1,false,false,0,"L/8hrs; L/8 hrs; L per 8hrs; liters per 8 hours; litres; volume flow rate; shift","LOINC","VRat","Clinical","","l",null,"1",1,false],[false,"Liters per minute per square meter","L/(min.m2) ","L/(MIN.M2)","volume",0.000016666666666666667,[1,-1,0,0,0,0,0],"L/(min.(m<sup>2</sup>))","iso1000",true,null,null,1,false,false,0,"L/(min.m2); L/min/m^2; L/min/sq. meter; L per min per m2; m^2; liters per minutes per square meter; meter squared; litres; metre ","LOINC","ArVRat","Clinical","unit for tests that measure cardiac output per body surface area (cardiac index)","l",null,"1",1,false],[false,"Liters per day","L/d","L/D","volume",1.1574074074074074e-8,[3,-1,0,0,0,0,0],"L/d","iso1000",true,null,null,1,false,false,0,"L/dy; L per day; 24hrs; 24 hrs; 24 hours; liters; litres","LOINC","VRat","Clinical","","l",null,"1",1,false],[false,"Liters per hour","L/h","L/HR","volume",2.7777777777777776e-7,[3,-1,0,0,0,0,0],"L/h","iso1000",true,null,null,1,false,false,0,"L/hr; L per hr; litres","LOINC","VRat","Clinical","","l",null,"1",1,false],[false,"Liters per kilogram","L/kg","L/KG","volume",0.000001,[3,0,-1,0,0,0,0],"L/kg","iso1000",true,null,null,1,false,false,0,"L per kg; litre","LOINC","VCnt","Clinical","","l",null,"1",1,false],[false,"Liters per liter","L/L","L/L","volume",1,[0,0,0,0,0,0,0],"L/L","iso1000",true,null,null,1,false,false,0,"L per L; liter/liter; litre","LOINC","VFr","Clinical","","l",null,"1",1,false],[false,"Liters per minute","L/min","L/MIN","volume",0.000016666666666666667,[3,-1,0,0,0,0,0],"L/min","iso1000",true,null,null,1,false,false,0,"liters per minute; litre","LOINC","VRat","Clinical","","l",null,"1",1,false],[false,"Liters per minute per square meter","L/min/m2","(L/MIN)/M2","volume",0.000016666666666666667,[1,-1,0,0,0,0,0],"(L/min)/(m<sup>2</sup>)","iso1000",true,null,null,1,false,false,0,"L/(min.m2); L/min/m^2; L/min/sq. meter; L per min per m2; m^2; liters per minutes per square meter; meter squared; litres; metre ","","ArVRat","Clinical","unit for tests that measure cardiac output per body surface area (cardiac index)","l",null,"1",1,false],[false,"Liters per second","L/s","L/S","volume",0.001,[3,-1,0,0,0,0,0],"L/s","iso1000",true,null,null,1,false,false,0,"L per sec; litres","LOINC","VRat","Clinical","unit used often to measure gas flow and peak expiratory flow","l",null,"1",1,false],[false,"Liters per second per square second","L/s/s2","(L/S)/S2","volume",0.001,[3,-3,0,0,0,0,0],"(L/s)/(s<sup>2</sup>)","iso1000",true,null,null,1,false,false,0,"L/s/s^2; L/sec/sec2; L/sec/sec^2; L/sec/sq. sec; L per s per s2; L per sec per sec2; s^2; sec^2; liters per seconds per square second; second squared; litres ","LOINC","ArVRat","Clinical","unit for tests that measure cardiac output/body surface area","l",null,"1",1,false],[false,"lumen square meter","lm.m2","LM.M2","luminous flux",1,[2,0,0,2,0,0,1],"lm.(m<sup>2</sup>)","si",true,null,null,1,false,false,0,"lm*m2; lm*m^2; lumen meters squared; lumen sq. meters; metres","LOINC","","Clinical","","cd.sr","CD.SR","1",1,false],[true,"meter per second","m/s","M/S","length",1,[1,-1,0,0,0,0,0],"m/s",null,false,"L",null,1,false,false,0,"meter/second; m per sec; meters per second; metres; velocity; speed","LOINC","Vel","Clinical","unit of velocity",null,null,null,null,false],[true,"meter per square second","m/s2","M/S2","length",1,[1,-2,0,0,0,0,0],"m/(s<sup>2</sup>)",null,false,"L",null,1,false,false,0,"m/s^2; m/sq. sec; m per s2; per s^2; meters per square second; second squared; sq second; metres; acceleration","LOINC","Accel","Clinical","unit of acceleration",null,null,null,null,false],[false,"milli international unit per liter","m[IU]/L","M[IU]/L","arbitrary",1,[-3,0,0,0,0,0,0],"(mi.U.)/L","chemical",true,null,null,1,false,true,0,"mIU/L; m IU/L; mIU per liter; units; litre","LOINC","ACnc","Clinical","International units (IU) are analyte and reference specimen  specific arbitrary units (held at WHO)","[iU]","[IU]","1",1,false],[false,"milli  international unit per milliliter","m[IU]/mL","M[IU]/ML","arbitrary",1000.0000000000001,[-3,0,0,0,0,0,0],"(mi.U.)/mL","chemical",true,null,null,1,false,true,0,"mIU/mL; m IU/mL; mIU per mL; milli international units per milliliter; millilitre","LOINC","ACnc","Clinical","International units (IU) are analyte and reference specimen  specific arbitrary units (held at WHO)","[iU]","[IU]","1",1,false],[true,"square meter","m2","M2","length",1,[2,0,0,0,0,0,0],"m<sup>2</sup>",null,false,"L",null,1,false,false,0,"m^2; sq m; square meters; meters squared; metres","LOINC","Area","Clinical","unit often used to represent body surface area",null,null,null,null,false],[true,"square meter per second","m2/s","M2/S","length",1,[2,-1,0,0,0,0,0],"(m<sup>2</sup>)/s",null,false,"L",null,1,false,false,0,"m^2/sec; m2 per sec; m^2 per sec; sq m/sec; meters squared/seconds; sq m per sec; meters squared; metres","LOINC","ArRat","Clinical","",null,null,null,null,false],[true,"cubic meter per second","m3/s","M3/S","length",1,[3,-1,0,0,0,0,0],"(m<sup>3</sup>)/s",null,false,"L",null,1,false,false,0,"m^3/sec; m3 per sec; m^3 per sec; cu m/sec; cubic meters per seconds; meters cubed; metres","LOINC","VRat","Clinical","",null,null,null,null,false],[false,"milliampere","mA","MA","electric current",0.001,[0,-1,0,0,0,1,0],"mA","si",true,null,null,1,false,false,0,"mamp; milliamperes","LOINC","ElpotRat","Clinical","unit of electric current","C/s","C/S","1",1,false],[false,"millibar","mbar","MBAR","pressure",100000,[-1,-2,1,0,0,0,0],"mbar","iso1000",true,null,null,1,false,false,0,"millibars","LOINC","Pres","Clinical","unit of pressure","Pa","PAL","1e5",100000,false],[false,"millibar second per liter","mbar.s/L","(MBAR.S)/L","pressure",100000000,[-4,-1,1,0,0,0,0],"(mbar.s)/L","iso1000",true,null,null,1,false,false,0,"mbar*s/L; mbar.s per L; mbar*s per L; millibar seconds per liter; millibar second per litre","LOINC","","Clinical","unit to measure expiratory resistance","Pa","PAL","1e5",100000,false],[false,"millibar per liter per second","mbar/L/s","(MBAR/L)/S","pressure",100000000,[-4,-3,1,0,0,0,0],"(mbar/L)/s","iso1000",true,null,null,1,false,false,0,"mbar/(L.s); mbar/L/sec; mbar/liter/second; mbar per L per sec; mbar per liter per second; millibars per liters per seconds; litres","LOINC","PresCncRat","Clinical","unit to measure expiratory resistance","Pa","PAL","1e5",100000,false],[false,"milliequivalent","meq","MEQ","amount of substance",602213670000000000000,[0,0,0,0,0,0,0],"meq","chemical",true,null,null,1,false,false,1,"milliequivalents; meqs","LOINC","Sub","Clinical","equivalence equals moles per valence","mol","MOL","1",1,false],[false,"milliequivalent per 2 hour","meq/(2.h)","MEQ/HR","amount of substance",83640787500000000,[0,-1,0,0,0,0,0],"meq/h","chemical",true,null,null,1,false,false,1,"meq/2hrs; meq/2 hrs; meq per 2 hrs; milliequivalents per 2 hours","LOINC","SRat","Clinical","equivalence equals moles per valence","mol","MOL","1",1,false],[false,"milliequivalent per 24 hour","meq/(24.h)","MEQ/HR","amount of substance",6970065625000000,[0,-1,0,0,0,0,0],"meq/h","chemical",true,null,null,1,false,false,1,"meq/24hrs; meq/24 hrs; meq per 24 hrs; milliequivalents per 24 hours","LOINC","SRat","Clinical","equivalence equals moles per valence","mol","MOL","1",1,false],[false,"milliequivalent per 8 hour","meq/(8.h)","MEQ/HR","amount of substance",20910196875000000,[0,-1,0,0,0,0,0],"meq/h","chemical",true,null,null,1,false,false,1,"meq/8hrs; meq/8 hrs; meq per 8 hrs; milliequivalents per 8 hours; shift","LOINC","SRat","Clinical","equivalence equals moles per valence","mol","MOL","1",1,false],[false,"milliequivalent per day","meq/d","MEQ/D","amount of substance",6970065625000000,[0,-1,0,0,0,0,0],"meq/d","chemical",true,null,null,1,false,false,1,"meq/dy; meq per day; milliquivalents per days; meq/24hrs; meq/24 hrs; meq per 24 hrs; milliequivalents per 24 hours","LOINC","SRat","Clinical","equivalence equals moles per valence","mol","MOL","1",1,false],[false,"milliequivalent per deciliter","meq/dL","MEQ/DL","amount of substance",6.022136699999999e+24,[-3,0,0,0,0,0,0],"meq/dL","chemical",true,null,null,1,false,false,1,"meq per dL; milliequivalents per deciliter; decilitre","LOINC","SCnc","Clinical","equivalence equals moles per valence","mol","MOL","1",1,false],[false,"milliequivalent per gram","meq/g","MEQ/G","amount of substance",602213670000000000000,[0,0,-1,0,0,0,0],"meq/g","chemical",true,null,null,1,false,false,1,"mgq/gm; meq per gm; milliequivalents per gram","LOINC","MCnt","Clinical","equivalence equals moles per valence","mol","MOL","1",1,false],[false,"milliequivalent per hour","meq/h","MEQ/HR","amount of substance",167281575000000000,[0,-1,0,0,0,0,0],"meq/h","chemical",true,null,null,1,false,false,1,"meq/hrs; meq per hrs; milliequivalents per hour","LOINC","SRat","Clinical","equivalence equals moles per valence","mol","MOL","1",1,false],[false,"milliequivalent per kilogram","meq/kg","MEQ/KG","amount of substance",602213670000000000,[0,0,-1,0,0,0,0],"meq/kg","chemical",true,null,null,1,false,false,1,"meq per kg; milliequivalents per kilogram","LOINC","SCnt","Clinical","equivalence equals moles per valence; used to measure dose per patient body mass","mol","MOL","1",1,false],[false,"milliequivalent per kilogram per hour","meq/kg/h","(MEQ/KG)/HR","amount of substance",167281575000000,[0,-1,-1,0,0,0,0],"(meq/kg)/h","chemical",true,null,null,1,false,false,1,"meq/(kg.h); meq/kg/hr; meq per kg per hr; milliequivalents per kilograms per hour","LOINC","SCntRat","Clinical","equivalence equals moles per valence; unit used to measure dose rate per patient body mass","mol","MOL","1",1,false],[false,"milliequivalent per liter","meq/L","MEQ/L","amount of substance",6.0221367e+23,[-3,0,0,0,0,0,0],"meq/L","chemical",true,null,null,1,false,false,1,"milliequivalents per liter; litre; meq per l; acidity","LOINC","SCnc","Clinical","equivalence equals moles per valence","mol","MOL","1",1,false],[false,"milliequivalent per square meter","meq/m2","MEQ/M2","amount of substance",602213670000000000000,[-2,0,0,0,0,0,0],"meq/(m<sup>2</sup>)","chemical",true,null,null,1,false,false,1,"meq/m^2; meq/sq. m; milliequivalents per square meter; meter squared; metre","LOINC","ArSub","Clinical","equivalence equals moles per valence; note that the use of m2 in clinical units ofter refers to body surface area","mol","MOL","1",1,false],[false,"milliequivalent per minute","meq/min","MEQ/MIN","amount of substance",10036894500000000000,[0,-1,0,0,0,0,0],"meq/min","chemical",true,null,null,1,false,false,1,"meq per min; milliequivalents per minute","LOINC","SRat","Clinical","equivalence equals moles per valence","mol","MOL","1",1,false],[false,"milliequivalent per milliliter","meq/mL","MEQ/ML","amount of substance",6.0221367e+26,[-3,0,0,0,0,0,0],"meq/mL","chemical",true,null,null,1,false,false,1,"meq per mL; milliequivalents per milliliter; millilitre","LOINC","SCnc","Clinical","equivalence equals moles per valence","mol","MOL","1",1,false],[true,"milligram","mg","MG","mass",0.001,[0,0,1,0,0,0,0],"mg",null,false,"M",null,1,false,false,0,"milligrams","LOINC","Mass","Clinical","",null,null,null,null,false],[true,"milligram per 10 hour","mg/(10.h)","MG/HR","mass",2.7777777777777777e-8,[0,-1,1,0,0,0,0],"mg/h",null,false,"M",null,1,false,false,0,"mg/10hrs; mg/10 hrs; mg per 10 hrs; milligrams per 10 hours","LOINC","MRat","Clinical","",null,null,null,null,false],[true,"milligram per 12 hour","mg/(12.h)","MG/HR","mass",2.3148148148148148e-8,[0,-1,1,0,0,0,0],"mg/h",null,false,"M",null,1,false,false,0,"mg/12hrs; mg/12 hrs; per 12 hrs; 12hrs; milligrams per 12 hours","LOINC","MRat","Clinical","units used for tests in urine",null,null,null,null,false],[true,"milligram per 2 hour","mg/(2.h)","MG/HR","mass",1.3888888888888888e-7,[0,-1,1,0,0,0,0],"mg/h",null,false,"M",null,1,false,false,0,"mg/2hrs; mg/2 hrs; mg per 2 hrs; 2hrs; milligrams per 2 hours","LOINC","MRat","Clinical","units used for tests in urine",null,null,null,null,false],[true,"milligram per 24 hour","mg/(24.h)","MG/HR","mass",1.1574074074074074e-8,[0,-1,1,0,0,0,0],"mg/h",null,false,"M",null,1,false,false,0,"mg/24hrs; mg/24 hrs; milligrams per 24 hours; mg/kg/dy; mg per kg per day; milligrams per kilograms per days","LOINC","MRat","Clinical","",null,null,null,null,false],[true,"milligram per 6 hour","mg/(6.h)","MG/HR","mass",4.6296296296296295e-8,[0,-1,1,0,0,0,0],"mg/h",null,false,"M",null,1,false,false,0,"mg/6hrs; mg/6 hrs; mg per 6 hrs; 6hrs; milligrams per 6 hours","LOINC","MRat","Clinical","",null,null,null,null,false],[true,"milligram per 72 hour","mg/(72.h)","MG/HR","mass",3.858024691358025e-9,[0,-1,1,0,0,0,0],"mg/h",null,false,"M",null,1,false,false,0,"mg/72hrs; mg/72 hrs; 72 hrs; 72hrs; milligrams per 72 hours","LOINC","MRat","Clinical","",null,null,null,null,false],[true,"milligram per 8 hour","mg/(8.h)","MG/HR","mass",3.472222222222222e-8,[0,-1,1,0,0,0,0],"mg/h",null,false,"M",null,1,false,false,0,"mg/8hrs; mg/8 hrs; milligrams per 8 hours; shift","LOINC","MRat","Clinical","",null,null,null,null,false],[true,"milligram per day","mg/d","MG/D","mass",1.1574074074074074e-8,[0,-1,1,0,0,0,0],"mg/d",null,false,"M",null,1,false,false,0,"mg/24hrs; mg/24 hrs; milligrams per 24 hours; mg/dy; mg per day; milligrams","LOINC","MRat","Clinical","",null,null,null,null,false],[true,"milligram per deciliter","mg/dL","MG/DL","mass",10,[-3,0,1,0,0,0,0],"mg/dL",null,false,"M",null,1,false,false,0,"mg per dL; milligrams per deciliter; decilitre","LOINC","MCnc","Clinical","",null,null,null,null,false],[true,"milligram per gram","mg/g","MG/G","mass",0.001,[0,0,0,0,0,0,0],"mg/g",null,false,"M",null,1,false,false,0,"mg per gm; milligrams per gram","LOINC","MCnt; MRto","Clinical","",null,null,null,null,false],[true,"milligram per hour","mg/h","MG/HR","mass",2.7777777777777776e-7,[0,-1,1,0,0,0,0],"mg/h",null,false,"M",null,1,false,false,0,"mg/hr; mg per hr; milligrams","LOINC","MRat","Clinical","",null,null,null,null,false],[true,"milligram per kilogram","mg/kg","MG/KG","mass",0.000001,[0,0,0,0,0,0,0],"mg/kg",null,false,"M",null,1,false,false,0,"mg per kg; milligrams per kilograms","LOINC","MCnt","Clinical","",null,null,null,null,false],[true,"milligram per kilogram per 8 hour","mg/kg/(8.h)","(MG/KG)/HR","mass",3.472222222222222e-11,[0,-1,0,0,0,0,0],"(mg/kg)/h",null,false,"M",null,1,false,false,0,"mg/(8.h.kg); mg/kg/8hrs; mg/kg/8 hrs; mg per kg per 8hrs; 8 hrs; milligrams per kilograms per 8 hours; shift","LOINC","RelMRat; MCntRat","Clinical","unit used to measure mass dose rate per patient body mass",null,null,null,null,false],[true,"milligram per kilogram per day","mg/kg/d","(MG/KG)/D","mass",1.1574074074074074e-11,[0,-1,0,0,0,0,0],"(mg/kg)/d",null,false,"M",null,1,false,false,0,"mg/(kg.d); mg/(kg.24.h)mg/kg/dy; mg per kg per day; milligrams per kilograms per days; mg/kg/(24.h); mg/kg/24hrs; 24 hrs; 24 hours","LOINC","RelMRat ","Clinical","unit used to measure mass dose rate per patient body mass",null,null,null,null,false],[true,"milligram per kilogram per hour","mg/kg/h","(MG/KG)/HR","mass",2.7777777777777777e-10,[0,-1,0,0,0,0,0],"(mg/kg)/h",null,false,"M",null,1,false,false,0,"mg/(kg.h); mg/kg/hr; mg per kg per hr; milligrams per kilograms per hour","LOINC","RelMRat; MCntRat","Clinical","unit used to measure mass dose rate per patient body mass",null,null,null,null,false],[true,"milligram per kilogram per minute","mg/kg/min","(MG/KG)/MIN","mass",1.6666666666666667e-8,[0,-1,0,0,0,0,0],"(mg/kg)/min",null,false,"M",null,1,false,false,0,"mg/(kg.min); mg per kg per min; milligrams per kilograms per minute","LOINC","RelMRat; MCntRat","Clinical","unit used to measure mass dose rate per patient body mass",null,null,null,null,false],[true,"milligram per liter","mg/L","MG/L","mass",1,[-3,0,1,0,0,0,0],"mg/L",null,false,"M",null,1,false,false,0,"mg per l; milligrams per liter; litre","LOINC","MCnc","Clinical","",null,null,null,null,false],[true,"milligram per square meter","mg/m2","MG/M2","mass",0.001,[-2,0,1,0,0,0,0],"mg/(m<sup>2</sup>)",null,false,"M",null,1,false,false,0,"mg/m^2; mg/sq. m; mg per m2; mg per m^2; mg per sq. milligrams; meter squared; metre","LOINC","ArMass","Clinical","",null,null,null,null,false],[true,"milligram per cubic meter","mg/m3","MG/M3","mass",0.001,[-3,0,1,0,0,0,0],"mg/(m<sup>3</sup>)",null,false,"M",null,1,false,false,0,"mg/m^3; mg/cu. m; mg per m3; milligrams per cubic meter; meter cubed; metre","LOINC","MCnc","Clinical","",null,null,null,null,false],[true,"milligram per milligram","mg/mg","MG/MG","mass",1,[0,0,0,0,0,0,0],"mg/mg",null,false,"M",null,1,false,false,0,"mg per mg; milligrams; milligram/milligram","LOINC","MRto","Clinical","",null,null,null,null,false],[true,"milligram per minute","mg/min","MG/MIN","mass",0.000016666666666666667,[0,-1,1,0,0,0,0],"mg/min",null,false,"M",null,1,false,false,0,"mg per min; milligrams per minutes; milligram/minute","LOINC","MRat","Clinical","",null,null,null,null,false],[true,"milligram per milliliter","mg/mL","MG/ML","mass",1000.0000000000001,[-3,0,1,0,0,0,0],"mg/mL",null,false,"M",null,1,false,false,0,"mg per mL; milligrams per milliliters; millilitre","LOINC","MCnc","Clinical","",null,null,null,null,false],[true,"milligram per millimole","mg/mmol","MG/MMOL","mass",1.660540186674939e-24,[0,0,1,0,0,0,0],"mg/mmol",null,false,"M",null,1,false,false,-1,"mg per mmol; milligrams per millimole; ","LOINC","Ratio","Clinical","",null,null,null,null,false],[true,"milligram per week","mg/wk","MG/WK","mass",1.6534391534391535e-9,[0,-1,1,0,0,0,0],"mg/wk",null,false,"M",null,1,false,false,0,"mg/week; mg per wk; milligrams per weeks; milligram/week","LOINC","Mrat","Clinical","",null,null,null,null,false],[false,"milliliter","mL","ML","volume",0.000001,[3,0,0,0,0,0,0],"mL","iso1000",true,null,null,1,false,false,0,"milliliters; millilitres","LOINC","Vol","Clinical","","l",null,"1",1,false],[false,"milliliter per 10 hour","mL/(10.h)","ML/HR","volume",2.7777777777777777e-11,[3,-1,0,0,0,0,0],"mL/h","iso1000",true,null,null,1,false,false,0,"ml/10hrs; ml/10 hrs; mL per 10hrs; 10 hrs; milliliters per 10 hours; millilitres","LOINC","VRat","Clinical","","l",null,"1",1,false],[false,"milliliter per 12 hour","mL/(12.h)","ML/HR","volume",2.3148148148148147e-11,[3,-1,0,0,0,0,0],"mL/h","iso1000",true,null,null,1,false,false,0,"ml/12hrs; ml/12 hrs; mL per 12hrs; 12 hrs; milliliters per 12 hours; millilitres","LOINC","VRat","Clinical","","l",null,"1",1,false],[false,"milliliter per 2 hour","mL/(2.h)","ML/HR","volume",1.3888888888888888e-10,[3,-1,0,0,0,0,0],"mL/h","iso1000",true,null,null,1,false,false,0,"ml/2hrs; ml/2 hrs; mL per 2hrs; 2 hrs; milliliters per 2 hours; millilitres ","LOINC","VRat","Clinical","","l",null,"1",1,false],[false,"milliliter per 24 hour","mL/(24.h)","ML/HR","volume",1.1574074074074074e-11,[3,-1,0,0,0,0,0],"mL/h","iso1000",true,null,null,1,false,false,0,"ml/24hrs; ml/24 hrs; mL per 24hrs; 24 hrs; milliliters per 24 hours; millilitres; ml/dy; /day; ml per dy; days; fluid outputs; fluid inputs; flow rate","LOINC","VRat","Clinical","","l",null,"1",1,false],[false,"milliliter per 4 hour","mL/(4.h)","ML/HR","volume",6.944444444444444e-11,[3,-1,0,0,0,0,0],"mL/h","iso1000",true,null,null,1,false,false,0,"ml/4hrs; ml/4 hrs; mL per 4hrs; 4 hrs; milliliters per 4 hours; millilitres","LOINC","VRat","Clinical","","l",null,"1",1,false],[false,"milliliter per 5 hour","mL/(5.h)","ML/HR","volume",5.5555555555555553e-11,[3,-1,0,0,0,0,0],"mL/h","iso1000",true,null,null,1,false,false,0,"ml/5hrs; ml/5 hrs; mL per 5hrs; 5 hrs; milliliters per 5 hours; millilitres","LOINC","VRat","Clinical","","l",null,"1",1,false],[false,"milliliter per 6 hour","mL/(6.h)","ML/HR","volume",4.6296296296296294e-11,[3,-1,0,0,0,0,0],"mL/h","iso1000",true,null,null,1,false,false,0,"ml/6hrs; ml/6 hrs; mL per 6hrs; 6 hrs; milliliters per 6 hours; millilitres","LOINC","VRat","Clinical","","l",null,"1",1,false],[false,"milliliter per 72 hour","mL/(72.h)","ML/HR","volume",3.8580246913580245e-12,[3,-1,0,0,0,0,0],"mL/h","iso1000",true,null,null,1,false,false,0,"ml/72hrs; ml/72 hrs; mL per 72hrs; 72 hrs; milliliters per 72 hours; millilitres","LOINC","VRat","Clinical","","l",null,"1",1,false],[false,"milliliter per 8 hour","mL/(8.h)","ML/HR","volume",3.472222222222222e-11,[3,-1,0,0,0,0,0],"mL/h","iso1000",true,null,null,1,false,false,0,"ml/8hrs; ml/8 hrs; mL per 8hrs; 8 hrs; milliliters per 8 hours; millilitres; shift","LOINC","VRat","Clinical","","l",null,"1",1,false],[false,"milliliter per 8 hour per kilogram","mL/(8.h)/kg","(ML/HR)/KG","volume",3.472222222222222e-14,[3,-1,-1,0,0,0,0],"(mL/h)/kg","iso1000",true,null,null,1,false,false,0,"mL/kg/(8.h); ml/8h/kg; ml/8 h/kg; ml/8hr/kg; ml/8 hr/kgr; mL per 8h per kg; 8 h; 8hr; 8 hr; milliliters per 8 hours per kilogram; millilitres; shift","LOINC","VRatCnt","Clinical","unit used to measure renal excretion volume rate per body mass","l",null,"1",1,false],[false,"milliliter per square inch (international)","mL/[sin_i]","ML/[SIN_I]","volume",0.0015500031000061998,[1,0,0,0,0,0,0],"mL","iso1000",true,null,null,1,false,false,0,"mL/sin; mL/in2; mL/in^2; mL per sin; in2; in^2; sq. in; milliliters per square inch; inch squared","LOINC","ArVol","Clinical","","l",null,"1",1,false],[false,"milliliter per centimeter of water","mL/cm[H2O]","ML/CM[H2O]","volume",1.0197162129779282e-11,[4,2,-1,0,0,0,0],"mL/(cm HO<sub><r>2</r></sub>)","iso1000",true,null,null,1,false,false,0,"milliliters per centimeter of water; millilitre per centimetre of water; millilitres per centimetre of water; mL/cmH2O; mL/cm H2O; mL per cmH2O; mL per cm H2O","LOINC","Compli","Clinical","unit used to measure dynamic lung compliance","l",null,"1",1,false],[false,"milliliter per day","mL/d","ML/D","volume",1.1574074074074074e-11,[3,-1,0,0,0,0,0],"mL/d","iso1000",true,null,null,1,false,false,0,"ml/day; ml per day; milliliters per day; 24 hours; 24hrs; millilitre;","LOINC","VRat","Clinical","usually used to measure fluid output or input; flow rate","l",null,"1",1,false],[false,"milliliter per deciliter","mL/dL","ML/DL","volume",0.009999999999999998,[0,0,0,0,0,0,0],"mL/dL","iso1000",true,null,null,1,false,false,0,"mL per dL; millilitres; decilitre; milliliters","LOINC","VFr; VFrDiff","Clinical","","l",null,"1",1,false],[false,"milliliter per hour","mL/h","ML/HR","volume",2.7777777777777777e-10,[3,-1,0,0,0,0,0],"mL/h","iso1000",true,null,null,1,false,false,0,"mL/hr; mL per hr; milliliters per hour; millilitres; fluid intake; fluid output","LOINC","VRat","Clinical","","l",null,"1",1,false],[false,"milliliter per kilogram","mL/kg","ML/KG","volume",9.999999999999999e-10,[3,0,-1,0,0,0,0],"mL/kg","iso1000",true,null,null,1,false,false,0,"mL per kg; milliliters per kilogram; millilitres","LOINC","VCnt","Clinical","","l",null,"1",1,false],[false,"milliliter per kilogram per 8 hour","mL/kg/(8.h)","(ML/KG)/HR","volume",3.472222222222222e-14,[3,-1,-1,0,0,0,0],"(mL/kg)/h","iso1000",true,null,null,1,false,false,0,"mL/(8.h.kg); mL/kg/8hrs; mL/kg/8 hrs; mL per kg per 8hrs; 8 hrs; milliliters per kilograms per 8 hours; millilitres; shift","LOINC","VCntRat; RelEngRat","Clinical","unit used to measure renal excretion volume rate per body mass","l",null,"1",1,false],[false,"milliliter per kilogram per day","mL/kg/d","(ML/KG)/D","volume",1.1574074074074072e-14,[3,-1,-1,0,0,0,0],"(mL/kg)/d","iso1000",true,null,null,1,false,false,0,"mL/(kg.d); mL/kg/dy; mL per kg per day; milliliters per kilograms per day; mg/kg/24hrs; 24 hrs; per 24 hours millilitres","LOINC","VCntRat; RelEngRat","Clinical","unit used to measure renal excretion volume rate per body mass","l",null,"1",1,false],[false,"milliliter per kilogram per hour","mL/kg/h","(ML/KG)/HR","volume",2.7777777777777774e-13,[3,-1,-1,0,0,0,0],"(mL/kg)/h","iso1000",true,null,null,1,false,false,0,"mL/(kg.h); mL/kg/hr; mL per kg per hr; milliliters per kilograms per hour; millilitres","LOINC","VCntRat; RelEngRat","Clinical","unit used to measure renal excretion volume rate per body mass","l",null,"1",1,false],[false,"milliliter per kilogram per minute","mL/kg/min","(ML/KG)/MIN","volume",1.6666666666666664e-11,[3,-1,-1,0,0,0,0],"(mL/kg)/min","iso1000",true,null,null,1,false,false,0,"mL/(kg.min); mL/kg/dy; mL per kg per day; milliliters per kilograms per day; millilitres","LOINC","RelEngRat","Clinical","used for tests that measure activity metabolic rate compared to standard resting metabolic rate ","l",null,"1",1,false],[false,"milliliter per square meter","mL/m2","ML/M2","volume",0.000001,[1,0,0,0,0,0,0],"mL/(m<sup>2</sup>)","iso1000",true,null,null,1,false,false,0,"mL/m^2; mL/sq. meter; mL per m2; m^2; sq. meter; milliliters per square meter; millilitres; meter squared","LOINC","ArVol","Clinical","used for tests that relate to heart work - e.g. ventricular stroke volume; atrial volume per body surface area","l",null,"1",1,false],[false,"milliliter per millibar","mL/mbar","ML/MBAR","volume",1e-11,[4,2,-1,0,0,0,0],"mL/mbar","iso1000",true,null,null,1,false,false,0,"mL per mbar; milliliters per millibar; millilitres","LOINC","","Clinical","unit used to measure dynamic lung compliance","l",null,"1",1,false],[false,"milliliter per minute","mL/min","ML/MIN","volume",1.6666666666666667e-8,[3,-1,0,0,0,0,0],"mL/min","iso1000",true,null,null,1,false,false,0,"mL per min; milliliters; millilitres","LOINC","VRat","Clinical","","l",null,"1",1,false],[false,"milliliter per minute per square meter","mL/min/m2","(ML/MIN)/M2","volume",1.6666666666666667e-8,[1,-1,0,0,0,0,0],"(mL/min)/(m<sup>2</sup>)","iso1000",true,null,null,1,false,false,0,"ml/min/m^2; ml/min/sq. meter; mL per min per m2; m^2; sq. meter; milliliters per minutes per square meter; millilitres; metre; meter squared","LOINC","ArVRat","Clinical","unit used to measure volume per body surface area; oxygen consumption index","l",null,"1",1,false],[false,"milliliter per millimeter","mL/mm","ML/MM","volume",0.001,[2,0,0,0,0,0,0],"mL/mm","iso1000",true,null,null,1,false,false,0,"mL per mm; milliliters per millimeter; millilitres; millimetre","LOINC","Lineic Volume","Clinical","","l",null,"1",1,false],[false,"milliliter per second","mL/s","ML/S","volume",0.000001,[3,-1,0,0,0,0,0],"mL/s","iso1000",true,null,null,1,false,false,0,"ml/sec; mL per sec; milliliters per second; millilitres","LOINC","Vel; VelRat; VRat","Clinical","","l",null,"1",1,false],[true,"millimeter","mm","MM","length",0.001,[1,0,0,0,0,0,0],"mm",null,false,"L",null,1,false,false,0,"millimeters; millimetres; height; length; diameter; thickness; axis; curvature; size","LOINC","Len","Clinical","",null,null,null,null,false],[true,"millimeter per hour","mm/h","MM/HR","length",2.7777777777777776e-7,[1,-1,0,0,0,0,0],"mm/h",null,false,"L",null,1,false,false,0,"mm/hr; mm per hr; millimeters per hour; millimetres","LOINC","Vel","Clinical","unit to measure sedimentation rate",null,null,null,null,false],[true,"millimeter per minute","mm/min","MM/MIN","length",0.000016666666666666667,[1,-1,0,0,0,0,0],"mm/min",null,false,"L",null,1,false,false,0,"mm per min; millimeters per minute; millimetres","LOINC","Vel","Clinical","",null,null,null,null,false],[false,"millimeter of water","mm[H2O]","MM[H2O]","pressure",9806.65,[-1,-2,1,0,0,0,0],"mm HO<sub><r>2</r></sub>","clinical",true,null,null,1,false,false,0,"mmH2O; mm H2O; millimeters of water; millimetres","LOINC","Pres","Clinical","","kPa","KPAL","980665e-5",9.80665,false],[false,"millimeter of mercury","mm[Hg]","MM[HG]","pressure",133322,[-1,-2,1,0,0,0,0],"mm Hg","clinical",true,null,null,1,false,false,0,"mmHg; mm Hg; millimeters of mercury; millimetres","LOINC","Pres; PPres; Ratio","Clinical","1 mm[Hg] = 1 torr; unit to measure blood pressure","kPa","KPAL","133.3220",133.322,false],[true,"square millimeter","mm2","MM2","length",0.000001,[2,0,0,0,0,0,0],"mm<sup>2</sup>",null,false,"L",null,1,false,false,0,"mm^2; sq. mm.; sq. millimeters; millimeters squared; millimetres","LOINC","Area","Clinical","",null,null,null,null,false],[false,"millimole","mmol","MMOL","amount of substance",602213670000000000000,[0,0,0,0,0,0,0],"mmol","si",true,null,null,1,false,false,1,"millimoles","LOINC","Sub","Clinical","","10*23","10*23","6.0221367",6.0221367,false],[false,"millimole per 12 hour","mmol/(12.h)","MMOL/HR","amount of substance",13940131250000000,[0,-1,0,0,0,0,0],"mmol/h","si",true,null,null,1,false,false,1,"mmol/12hrs; mmol/12 hrs; mmol per 12 hrs; 12hrs; millimoles per 12 hours","LOINC","SRat","Clinical","unit for tests related to urine","10*23","10*23","6.0221367",6.0221367,false],[false,"millimole per 2 hour","mmol/(2.h)","MMOL/HR","amount of substance",83640787500000000,[0,-1,0,0,0,0,0],"mmol/h","si",true,null,null,1,false,false,1,"mmol/2hrs; mmol/2 hrs; mmol per 2 hrs; 2hrs; millimoles per 2 hours","LOINC","SRat","Clinical","unit for tests related to urine","10*23","10*23","6.0221367",6.0221367,false],[false,"millimole per 24 hour","mmol/(24.h)","MMOL/HR","amount of substance",6970065625000000,[0,-1,0,0,0,0,0],"mmol/h","si",true,null,null,1,false,false,1,"mmol/24hrs; mmol/24 hrs; mmol per 24 hrs; 24hrs; millimoles per 24 hours","LOINC","SRat","Clinical","","10*23","10*23","6.0221367",6.0221367,false],[false,"millimole per 5 hour","mmol/(5.h)","MMOL/HR","amount of substance",33456315000000000,[0,-1,0,0,0,0,0],"mmol/h","si",true,null,null,1,false,false,1,"mmol/5hrs; mmol/5 hrs; mmol per 5 hrs; 5hrs; millimoles per 5 hours","LOINC","SRat","Clinical","unit for tests related to doses","10*23","10*23","6.0221367",6.0221367,false],[false,"millimole per 6 hour","mmol/(6.h)","MMOL/HR","amount of substance",27880262500000000,[0,-1,0,0,0,0,0],"mmol/h","si",true,null,null,1,false,false,1,"mmol/6hrs; mmol/6 hrs; mmol per 6 hrs; 6hrs; millimoles per 6 hours","LOINC","SRat","Clinical","unit for tests related to urine","10*23","10*23","6.0221367",6.0221367,false],[false,"millimole per 8 hour","mmol/(8.h)","MMOL/HR","amount of substance",20910196875000000,[0,-1,0,0,0,0,0],"mmol/h","si",true,null,null,1,false,false,1,"mmol/8hrs; mmol/8 hrs; mmol per 8 hrs; 8hrs; millimoles per 8 hours; shift","LOINC","SRat","Clinical","","10*23","10*23","6.0221367",6.0221367,false],[false,"millimole per day","mmol/d","MMOL/D","amount of substance",6970065625000000,[0,-1,0,0,0,0,0],"mmol/d","si",true,null,null,1,false,false,1,"mmol/24hrs; mmol/24 hrs; mmol per 24 hrs; 24hrs; millimoles per 24 hours","LOINC","SRat","Clinical","","10*23","10*23","6.0221367",6.0221367,false],[false,"millimole per deciliter","mmol/dL","MMOL/DL","amount of substance",6.022136699999999e+24,[-3,0,0,0,0,0,0],"mmol/dL","si",true,null,null,1,false,false,1,"mmol per dL; millimoles; decilitre","LOINC","SCnc","Clinical","","10*23","10*23","6.0221367",6.0221367,false],[false,"millimole per gram","mmol/g","MMOL/G","amount of substance",602213670000000000000,[0,0,-1,0,0,0,0],"mmol/g","si",true,null,null,1,false,false,1,"mmol per gram; millimoles","LOINC","SCnt","Clinical","","10*23","10*23","6.0221367",6.0221367,false],[false,"millimole per hour","mmol/h","MMOL/HR","amount of substance",167281575000000000,[0,-1,0,0,0,0,0],"mmol/h","si",true,null,null,1,false,false,1,"mmol/hr; mmol per hr; millimoles per hour","LOINC","SRat","Clinical","unit for tests related to urine","10*23","10*23","6.0221367",6.0221367,false],[false,"millimole per kilogram","mmol/kg","MMOL/KG","amount of substance",602213670000000000,[0,0,-1,0,0,0,0],"mmol/kg","si",true,null,null,1,false,false,1,"mmol per kg; millimoles per kilogram","LOINC","SCnt","Clinical","unit for tests related to stool","10*23","10*23","6.0221367",6.0221367,false],[false,"millimole per kilogram per 8 hour","mmol/kg/(8.h)","(MMOL/KG)/HR","amount of substance",20910196875000,[0,-1,-1,0,0,0,0],"(mmol/kg)/h","si",true,null,null,1,false,false,1,"mmol/(8.h.kg); mmol/kg/8hrs; mmol/kg/8 hrs; mmol per kg per 8hrs; 8 hrs; millimoles per kilograms per 8 hours; shift","LOINC","CCnt","Clinical","unit used to measure molar dose rate per patient body mass","10*23","10*23","6.0221367",6.0221367,false],[false,"millimole per kilogram per day","mmol/kg/d","(MMOL/KG)/D","amount of substance",6970065625000,[0,-1,-1,0,0,0,0],"(mmol/kg)/d","si",true,null,null,1,false,false,1,"mmol/kg/dy; mmol/kg/day; mmol per kg per dy; millimoles per kilograms per day","LOINC","RelSRat","Clinical","unit used to measure molar dose rate per patient body mass","10*23","10*23","6.0221367",6.0221367,false],[false,"millimole per kilogram per hour","mmol/kg/h","(MMOL/KG)/HR","amount of substance",167281575000000,[0,-1,-1,0,0,0,0],"(mmol/kg)/h","si",true,null,null,1,false,false,1,"mmol/kg/hr; mmol per kg per hr; millimoles per kilograms per hour","LOINC","CCnt","Clinical","unit used to measure molar dose rate per patient body mass","10*23","10*23","6.0221367",6.0221367,false],[false,"millimole per kilogram per minute","mmol/kg/min","(MMOL/KG)/MIN","amount of substance",10036894500000000,[0,-1,-1,0,0,0,0],"(mmol/kg)/min","si",true,null,null,1,false,false,1,"mmol/(kg.min); mmol/kg/min; mmol per kg per min; millimoles per kilograms per minute","LOINC","CCnt","Clinical","unit used to measure molar dose rate per patient body mass; note that the unit for the enzyme unit U = umol/min. mmol/kg/min = kU/kg; ","10*23","10*23","6.0221367",6.0221367,false],[false,"millimole per liter","mmol/L","MMOL/L","amount of substance",6.0221367e+23,[-3,0,0,0,0,0,0],"mmol/L","si",true,null,null,1,false,false,1,"mmol per L; millimoles per liter; litre","LOINC","SCnc","Clinical","unit for tests related to doses","10*23","10*23","6.0221367",6.0221367,false],[false,"millimole per square meter","mmol/m2","MMOL/M2","amount of substance",602213670000000000000,[-2,0,0,0,0,0,0],"mmol/(m<sup>2</sup>)","si",true,null,null,1,false,false,1,"mmol/m^2; mmol/sq. meter; mmol per m2; m^2; sq. meter; millimoles; meter squared; metre","LOINC","ArSub","Clinical","unit used to measure molar dose per patient body surface area","10*23","10*23","6.0221367",6.0221367,false],[false,"millimole per minute","mmol/min","MMOL/MIN","amount of substance",10036894500000000000,[0,-1,0,0,0,0,0],"mmol/min","si",true,null,null,1,false,false,1,"mmol per min; millimoles per minute","LOINC","Srat; CAct","Clinical","unit for the enzyme unit U = umol/min. mmol/min = kU","10*23","10*23","6.0221367",6.0221367,false],[false,"millimole per millimole","mmol/mmol","MMOL/MMOL","amount of substance",1,[0,0,0,0,0,0,0],"mmol/mmol","si",true,null,null,1,false,false,0,"mmol per mmol; millimoles per millimole","LOINC","SRto","Clinical","","10*23","10*23","6.0221367",6.0221367,false],[false,"millimole per mole","mmol/mol","MMOL/MOL","amount of substance",0.001,[0,0,0,0,0,0,0],"mmol/mol","si",true,null,null,1,false,false,0,"mmol per mol; millimoles per mole","LOINC","SRto","Clinical","","10*23","10*23","6.0221367",6.0221367,false],[false,"millimole per second per liter","mmol/s/L","(MMOL/S)/L","amount of substance",6.0221367e+23,[-3,-1,0,0,0,0,0],"(mmol/s)/L","si",true,null,null,1,false,false,1,"mmol/sec/L; mmol per s per L; per sec; millimoles per seconds per liter; litre","LOINC","CCnc ","Clinical","","10*23","10*23","6.0221367",6.0221367,false],[false,"mole per kilogram","mol/kg","MOL/KG","amount of substance",602213670000000000000,[0,0,-1,0,0,0,0],"mol/kg","si",true,null,null,1,false,false,1,"mol per kg; moles; mols","LOINC","SCnt","Clinical","unit for tests related to stool","10*23","10*23","6.0221367",6.0221367,false],[false,"mole per kilogram per second","mol/kg/s","(MOL/KG)/S","amount of substance",602213670000000000000,[0,-1,-1,0,0,0,0],"(mol/kg)/s","si",true,null,null,1,false,false,1,"mol/kg/sec; mol per kg per sec; moles per kilograms per second; mols","LOINC","CCnt","Clinical","unit of catalytic activity (mol/s) per mass (kg)","10*23","10*23","6.0221367",6.0221367,false],[false,"mole per liter","mol/L","MOL/L","amount of substance",6.0221366999999994e+26,[-3,0,0,0,0,0,0],"mol/L","si",true,null,null,1,false,false,1,"mol per L; moles per liter; litre; moles; mols","LOINC","SCnc","Clinical","unit often used in tests measuring oxygen content","10*23","10*23","6.0221367",6.0221367,false],[false,"mole per cubic meter","mol/m3","MOL/M3","amount of substance",6.0221367e+23,[-3,0,0,0,0,0,0],"mol/(m<sup>3</sup>)","si",true,null,null,1,false,false,1,"mol/m^3; mol/cu. m; mol per m3; m^3; cu. meter; mols; moles; meters cubed; metre; mole per kiloliter; kilolitre; mol/kL","LOINC","SCnc","Clinical","","10*23","10*23","6.0221367",6.0221367,false],[false,"mole per milliliter","mol/mL","MOL/ML","amount of substance",6.0221367e+29,[-3,0,0,0,0,0,0],"mol/mL","si",true,null,null,1,false,false,1,"mol per mL; moles; millilitre; mols","LOINC","SCnc","Clinical","","10*23","10*23","6.0221367",6.0221367,false],[false,"mole per mole","mol/mol","MOL/MOL","amount of substance",1,[0,0,0,0,0,0,0],"mol/mol","si",true,null,null,1,false,false,0,"mol per mol; moles per mol; mols","LOINC","SRto","Clinical","","10*23","10*23","6.0221367",6.0221367,false],[false,"mole per second","mol/s","MOL/S","amount of substance",6.0221367e+23,[0,-1,0,0,0,0,0],"mol/s","si",true,null,null,1,false,false,1,"mol per sec; moles per second; mols","LOINC","SRat","Clinical","","10*23","10*23","6.0221367",6.0221367,false],[false,"milliosmole","mosm","MOSM","amount of substance (dissolved particles)",602213670000000000000,[0,0,0,0,0,0,0],"mosm","chemical",true,null,null,1,false,false,1,"milliosmoles","LOINC","Osmol","Clinical","equal to 1/1000 of an osmole","mol","MOL","1",1,false],[false,"milliosmole per kilogram","mosm/kg","MOSM/KG","amount of substance (dissolved particles)",602213670000000000,[0,0,-1,0,0,0,0],"mosm/kg","chemical",true,null,null,1,false,false,1,"mosm per kg; milliosmoles per kilogram","LOINC","Osmol","Clinical","","mol","MOL","1",1,false],[false,"milliosmole per liter","mosm/L","MOSM/L","amount of substance (dissolved particles)",6.0221367e+23,[-3,0,0,0,0,0,0],"mosm/L","chemical",true,null,null,1,false,false,1,"mosm per liter; litre; milliosmoles","LOINC","Osmol","Clinical","","mol","MOL","1",1,false],[false,"millipascal","mPa","MPAL","pressure",1,[-1,-2,1,0,0,0,0],"mPa","si",true,null,null,1,false,false,0,"millipascals","LOINC","Pres","Clinical","unit of pressure","N/m2","N/M2","1",1,false],[false,"millipascal second","mPa.s","MPAL.S","pressure",1,[-1,-1,1,0,0,0,0],"mPa.s","si",true,null,null,1,false,false,0,"mPa*s; millipoise; mP; dynamic viscosity","LOINC","Visc","Clinical","base units for millipoise, a measurement of dynamic viscosity","N/m2","N/M2","1",1,false],[true,"megasecond","Ms","MAS","time",1000000,[0,1,0,0,0,0,0],"Ms",null,false,"T",null,1,false,false,0,"megaseconds","LOINC","Time","Clinical","",null,null,null,null,false],[true,"millisecond","ms","MS","time",0.001,[0,1,0,0,0,0,0],"ms",null,false,"T",null,1,false,false,0,"milliseconds; duration","LOINC","Time","Clinical","",null,null,null,null,false],[false,"milli enzyme unit per gram","mU/g","MU/G","catalytic activity",10036894500000,[0,-1,-1,0,0,0,0],"mU/g","chemical",true,null,null,1,false,false,1,"mU per gm; milli enzyme units per gram; enzyme activity; enzymatic activity per mass","LOINC","CCnt","Clinical","1 U is the standard enzyme unit which equals 1 micromole substrate catalyzed per minute (1 umol/min); 1 mU = 1 nmol/min","umol/min","UMOL/MIN","1",1,false],[false,"milli enzyme unit per liter","mU/L","MU/L","catalytic activity",10036894500000000,[-3,-1,0,0,0,0,0],"mU/L","chemical",true,null,null,1,false,false,1,"mU per liter; litre; milli enzyme units enzymatic activity per volume; enzyme activity","LOINC","CCnc","Clinical","1 U is the standard enzyme unit which equals 1 micromole substrate catalyzed per minute (1 umol/min); 1 mU = 1 nmol/min","umol/min","UMOL/MIN","1",1,false],[false,"milli enzyme unit per milligram","mU/mg","MU/MG","catalytic activity",10036894500000000,[0,-1,-1,0,0,0,0],"mU/mg","chemical",true,null,null,1,false,false,1,"mU per mg; milli enzyme units per milligram","LOINC","CCnt","Clinical","1 U is the standard enzyme unit which equals 1 micromole substrate catalyzed per minute (1 umol/min); 1 mU = 1 nmol/min","umol/min","UMOL/MIN","1",1,false],[false,"milli enzyme unit per milliliter","mU/mL","MU/ML","catalytic activity",10036894500000000000,[-3,-1,0,0,0,0,0],"mU/mL","chemical",true,null,null,1,false,false,1,"mU per mL; milli enzyme units per milliliter; millilitre; enzymatic activity per volume; enzyme activity","LOINC","CCnc","Clinical","1 U is the standard enzyme unit which equals 1 micromole substrate catalyzed per minute (1 umol/min); 1 mU = 1 nmol/min","umol/min","UMOL/MIN","1",1,false],[false,"milli enzyme unit per milliliter per minute","mU/mL/min","(MU/ML)/MIN","catalytic activity",167281575000000000,[-3,-2,0,0,0,0,0],"(mU/mL)/min","chemical",true,null,null,1,false,false,1,"mU per mL per min; mU per milliliters per minute; millilitres; milli enzyme units; enzymatic activity; enzyme activity","LOINC","CCncRat","Clinical","1 U is the standard enzyme unit which equals 1 micromole substrate catalyzed per minute (1 umol/min); 1 mU = 1 nmol/min","umol/min","UMOL/MIN","1",1,false],[false,"millivolt","mV","MV","electric potential",1,[2,-2,1,0,0,-1,0],"mV","si",true,null,null,1,false,false,0,"millivolts","LOINC","Elpot","Clinical","unit of electric potential (voltage)","J/C","J/C","1",1,false],[false,"Newton centimeter","N.cm","N.CM","force",10,[2,-2,1,0,0,0,0],"N.cm","si",true,null,null,1,false,false,0,"N*cm; Ncm; N cm; Newton*centimeters; Newton* centimetres; torque; work","LOINC","","Clinical","as a measurement of work, N.cm = 1/100 Joules;\\nnote that N.m is the standard unit of measurement for torque (although dimensionally equivalent to Joule), and N.cm can also be thought of as a torqe unit","kg.m/s2","KG.M/S2","1",1,false],[false,"Newton second","N.s","N.S","force",1000,[1,-1,1,0,0,0,0],"N.s","si",true,null,null,1,false,false,0,"Newton*seconds; N*s; N s; Ns; impulse; imp","LOINC","","Clinical","standard unit of impulse","kg.m/s2","KG.M/S2","1",1,false],[true,"nanogram","ng","NG","mass",1e-9,[0,0,1,0,0,0,0],"ng",null,false,"M",null,1,false,false,0,"nanograms","LOINC","Mass","Clinical","",null,null,null,null,false],[true,"nanogram per 24 hour","ng/(24.h)","NG/HR","mass",1.1574074074074075e-14,[0,-1,1,0,0,0,0],"ng/h",null,false,"M",null,1,false,false,0,"ng/24hrs; ng/24 hrs; nanograms per 24 hours","LOINC","MRat","Clinical","",null,null,null,null,false],[true,"nanogram per 8 hour","ng/(8.h)","NG/HR","mass",3.4722222222222224e-14,[0,-1,1,0,0,0,0],"ng/h",null,false,"M",null,1,false,false,0,"ng/8hrs; ng/8 hrs; nanograms per 8 hours","LOINC","MRat","Clinical","",null,null,null,null,false],[true,"nanogram per million","ng/10*6","NG/(10*6)","mass",1e-15,[0,0,1,0,0,0,0],"ng/(10<sup>6</sup>)",null,false,"M",null,1,false,false,0,"ng/10^6; ng per 10*6; 10^6; nanograms","LOINC","MNum","Clinical","",null,null,null,null,false],[true,"nanogram per day","ng/d","NG/D","mass",1.1574074074074075e-14,[0,-1,1,0,0,0,0],"ng/d",null,false,"M",null,1,false,false,0,"ng/dy; ng per day; nanograms ","LOINC","MRat","Clinical","",null,null,null,null,false],[true,"nanogram per deciliter","ng/dL","NG/DL","mass",0.00001,[-3,0,1,0,0,0,0],"ng/dL",null,false,"M",null,1,false,false,0,"ng per dL; nanograms per deciliter; decilitre","LOINC","MCnc","Clinical","",null,null,null,null,false],[true,"nanogram per gram","ng/g","NG/G","mass",1e-9,[0,0,0,0,0,0,0],"ng/g",null,false,"M",null,1,false,false,0,"ng/gm; ng per gm; nanograms per gram","LOINC","MCnt","Clinical","",null,null,null,null,false],[true,"nanogram per hour","ng/h","NG/HR","mass",2.777777777777778e-13,[0,-1,1,0,0,0,0],"ng/h",null,false,"M",null,1,false,false,0,"ng/hr; ng per hr; nanograms per hour","LOINC","MRat","Clinical","",null,null,null,null,false],[true,"nanogram per kilogram","ng/kg","NG/KG","mass",1e-12,[0,0,0,0,0,0,0],"ng/kg",null,false,"M",null,1,false,false,0,"ng per kg; nanograms per kilogram","LOINC","MCnt","Clinical","",null,null,null,null,false],[true,"nanogram per kilogram per 8 hour","ng/kg/(8.h)","(NG/KG)/HR","mass",3.472222222222222e-17,[0,-1,0,0,0,0,0],"(ng/kg)/h",null,false,"M",null,1,false,false,0,"ng/(8.h.kg); ng/kg/8hrs; ng/kg/8 hrs; ng per kg per 8hrs; 8 hrs; nanograms per kilograms per 8 hours; shift","LOINC","MRtoRat ","Clinical","unit used to measure mass dose rate per patient body mass",null,null,null,null,false],[true,"nanogram per kilogram per hour","ng/kg/h","(NG/KG)/HR","mass",2.7777777777777775e-16,[0,-1,0,0,0,0,0],"(ng/kg)/h",null,false,"M",null,1,false,false,0,"ng/(kg.h); ng/kg/hr; ng per kg per hr; nanograms per kilograms per hour","LOINC","MRtoRat ","Clinical","unit used to measure mass dose rate per patient body mass",null,null,null,null,false],[true,"nanogram per kilogram per minute","ng/kg/min","(NG/KG)/MIN","mass",1.6666666666666667e-14,[0,-1,0,0,0,0,0],"(ng/kg)/min",null,false,"M",null,1,false,false,0,"ng/(kg.min); ng per kg per min; nanograms per kilograms per minute","LOINC","MRtoRat ","Clinical","unit used to measure mass dose rate per patient body mass",null,null,null,null,false],[true,"nanogram per liter","ng/L","NG/L","mass",0.000001,[-3,0,1,0,0,0,0],"ng/L",null,false,"M",null,1,false,false,0,"ng per L; nanograms per liter; litre","LOINC","MCnc","Clinical","",null,null,null,null,false],[true,"nanogram per square meter","ng/m2","NG/M2","mass",1e-9,[-2,0,1,0,0,0,0],"ng/(m<sup>2</sup>)",null,false,"M",null,1,false,false,0,"ng/m^2; ng/sq. m; ng per m2; m^2; sq. meter; nanograms; meter squared; metre","LOINC","ArMass","Clinical","unit used to measure mass dose per patient body surface area",null,null,null,null,false],[true,"nanogram per milligram","ng/mg","NG/MG","mass",0.000001,[0,0,0,0,0,0,0],"ng/mg",null,false,"M",null,1,false,false,0,"ng per mg; nanograms","LOINC","MCnt","Clinical","",null,null,null,null,false],[true,"nanogram per milligram per hour","ng/mg/h","(NG/MG)/HR","mass",2.7777777777777777e-10,[0,-1,0,0,0,0,0],"(ng/mg)/h",null,false,"M",null,1,false,false,0,"ng/mg/hr; ng per mg per hr; nanograms per milligrams per hour","LOINC","MRtoRat ","Clinical","",null,null,null,null,false],[true,"nanogram per minute","ng/min","NG/MIN","mass",1.6666666666666667e-11,[0,-1,1,0,0,0,0],"ng/min",null,false,"M",null,1,false,false,0,"ng per min; nanograms","LOINC","MRat","Clinical","",null,null,null,null,false],[true,"nanogram per millliiter","ng/mL","NG/ML","mass",0.001,[-3,0,1,0,0,0,0],"ng/mL",null,false,"M",null,1,false,false,0,"ng per mL; nanograms; millilitre","LOINC","MCnc","Clinical","",null,null,null,null,false],[true,"nanogram per milliliter per hour","ng/mL/h","(NG/ML)/HR","mass",2.7777777777777776e-7,[-3,-1,1,0,0,0,0],"(ng/mL)/h",null,false,"M",null,1,false,false,0,"ng/mL/hr; ng per mL per mL; nanograms per milliliter per hour; nanogram per millilitre per hour; nanograms per millilitre per hour; enzymatic activity per volume; enzyme activity per milliliters","LOINC","CCnc","Clinical","tests that measure enzymatic activity",null,null,null,null,false],[true,"nanogram per second","ng/s","NG/S","mass",1e-9,[0,-1,1,0,0,0,0],"ng/s",null,false,"M",null,1,false,false,0,"ng/sec; ng per sec; nanograms per second","LOINC","MRat","Clinical","",null,null,null,null,false],[true,"nanogram per enzyme unit","ng/U","NG/U","mass",9.963241120049634e-26,[0,1,1,0,0,0,0],"ng/U",null,false,"M",null,1,false,false,-1,"ng per U; nanograms per enzyme unit","LOINC","CMass","Clinical","1 U is the standard enzyme unit which equals 1 micromole substrate catalyzed per minute (1 umol/min)",null,null,null,null,false],[false,"nanokatal","nkat","NKAT","catalytic activity",602213670000000,[0,-1,0,0,0,0,0],"nkat","chemical",true,null,null,1,false,false,1,"nanokatals","LOINC","CAct","Clinical","kat is a unit of catalytic activity with base units = mol/s. Rarely used because its units are too large to practically express catalytic activity. See enzyme unit [U] which is the standard unit for catalytic activity.","mol/s","MOL/S","1",1,false],[false,"nanoliter","nL","NL","volume",1.0000000000000002e-12,[3,0,0,0,0,0,0],"nL","iso1000",true,null,null,1,false,false,0,"nanoliters; nanolitres","LOINC","Vol","Clinical","","l",null,"1",1,false],[true,"nanometer","nm","NM","length",1e-9,[1,0,0,0,0,0,0],"nm",null,false,"L",null,1,false,false,0,"nanometers; nanometres","LOINC","Len","Clinical","",null,null,null,null,false],[true,"nanometer per second per liter","nm/s/L","(NM/S)/L","length",0.000001,[-2,-1,0,0,0,0,0],"(nm/s)/L",null,false,"L",null,1,false,false,0,"nm/sec/liter; nm/sec/litre; nm per s per l; nm per sec per l; nanometers per second per liter; nanometre per second per litre; nanometres per second per litre","LOINC","VelCnc","Clinical","",null,null,null,null,false],[false,"nanomole","nmol","NMOL","amount of substance",602213670000000,[0,0,0,0,0,0,0],"nmol","si",true,null,null,1,false,false,1,"nanomoles","LOINC","Sub","Clinical","","10*23","10*23","6.0221367",6.0221367,false],[false,"nanomole per 24 hour","nmol/(24.h)","NMOL/HR","amount of substance",6970065625,[0,-1,0,0,0,0,0],"nmol/h","si",true,null,null,1,false,false,1,"nmol/24hr; nmol/24 hr; nanomoles per 24 hours; nmol/day; nanomoles per day; nmol per day; nanomole/day; nanomol/day","LOINC","SRat","Clinical","","10*23","10*23","6.0221367",6.0221367,false],[false,"nanomole per day","nmol/d","NMOL/D","amount of substance",6970065625,[0,-1,0,0,0,0,0],"nmol/d","si",true,null,null,1,false,false,1,"nmol/day; nanomoles per day; nmol per day; nanomole/day; nanomol/day; nmol/24hr; nmol/24 hr; nanomoles per 24 hours; ","LOINC","SRat","Clinical","","10*23","10*23","6.0221367",6.0221367,false],[false,"nanomole per deciliter","nmol/dL","NMOL/DL","amount of substance",6022136700000000000,[-3,0,0,0,0,0,0],"nmol/dL","si",true,null,null,1,false,false,1,"nmol per dL; nanomoles per deciliter; nanomole per decilitre; nanomoles per decilitre; nanomole/deciliter; nanomole/decilitre; nanomol/deciliter; nanomol/decilitre","LOINC","SCnc","Clinical","","10*23","10*23","6.0221367",6.0221367,false],[false,"nanomole per gram","nmol/g","NMOL/G","amount of substance",602213670000000,[0,0,-1,0,0,0,0],"nmol/g","si",true,null,null,1,false,false,1,"nmol per gram; nanomoles per gram; nanomole/gram","LOINC","SCnt","Clinical","","10*23","10*23","6.0221367",6.0221367,false],[false,"nanomole per hour per liter","nmol/h/L","(NMOL/HR)/L","amount of substance",167281575000000,[-3,-1,0,0,0,0,0],"(nmol/h)/L","si",true,null,null,1,false,false,1,"nmol/hrs/L; nmol per hrs per L; nanomoles per hours per liter; litre; enzymatic activity per volume; enzyme activities","LOINC","CCnc","Clinical","","10*23","10*23","6.0221367",6.0221367,false],[false,"nanomole per liter","nmol/L","NMOL/L","amount of substance",602213670000000000,[-3,0,0,0,0,0,0],"nmol/L","si",true,null,null,1,false,false,1,"nmol per L; nanomoles per liter; litre","LOINC","SCnc","Clinical","","10*23","10*23","6.0221367",6.0221367,false],[false,"nanomole per milligram","nmol/mg","NMOL/MG","amount of substance",602213670000000000,[0,0,-1,0,0,0,0],"nmol/mg","si",true,null,null,1,false,false,1,"nmol per mg; nanomoles per milligram","LOINC","SCnt","Clinical","","10*23","10*23","6.0221367",6.0221367,false],[false,"nanomole per milligram per hour","nmol/mg/h","(NMOL/MG)/HR","amount of substance",167281575000000,[0,-1,-1,0,0,0,0],"(nmol/mg)/h","si",true,null,null,1,false,false,1,"nmol/mg/hr; nmol per mg per hr; nanomoles per milligrams per hour","LOINC","SCntRat","Clinical","","10*23","10*23","6.0221367",6.0221367,false],[false,"nanomole per milligram of protein","nmol/mg{prot}","NMOL/MG","amount of substance",602213670000000000,[0,0,-1,0,0,0,0],"nmol/mg","si",true,null,null,1,false,false,1,"nanomoles; nmol/mg prot; nmol per mg prot","LOINC","Ratio; CCnt","Clinical","","10*23","10*23","6.0221367",6.0221367,false],[false,"nanomole per minute","nmol/min","NMOL/MIN","amount of substance",10036894500000,[0,-1,0,0,0,0,0],"nmol/min","si",true,null,null,1,false,false,1,"nmol per min; nanomoles per minute; milli enzyme units; enzyme activity per volume; enzymatic activity","LOINC","CCnc","Clinical","unit for the enzyme unit U = umol/min. nmol/min = mU (milli enzyme unit)","10*23","10*23","6.0221367",6.0221367,false],[false,"nanomole per minute per milliliter","nmol/min/mL","(NMOL/MIN)/ML","amount of substance",10036894500000000000,[-3,-1,0,0,0,0,0],"(nmol/min)/mL","si",true,null,null,1,false,false,1,"nmol per min per mL; nanomoles per minutes per milliliter; millilitre; milli enzyme units per volume; enzyme activity; enzymatic activity","LOINC","CCnc","Clinical","unit for the enzyme unit U = umol/min. nmol/mL/min = mU/mL","10*23","10*23","6.0221367",6.0221367,false],[false,"nanomole per milliliter","nmol/mL","NMOL/ML","amount of substance",602213670000000000000,[-3,0,0,0,0,0,0],"nmol/mL","si",true,null,null,1,false,false,1,"nmol per mL; nanomoles per milliliter; millilitre","LOINC","SCnc","Clinical","","10*23","10*23","6.0221367",6.0221367,false],[false,"nanomole per milliliter per hour","nmol/mL/h","(NMOL/ML)/HR","amount of substance",167281575000000000,[-3,-1,0,0,0,0,0],"(nmol/mL)/h","si",true,null,null,1,false,false,1,"nmol/mL/hr; nmol per mL per hr; nanomoles per milliliters per hour; millilitres; milli enzyme units per volume; enzyme activity; enzymatic activity","LOINC","CCnc","Clinical","unit for the enzyme unit U = umol/min.","10*23","10*23","6.0221367",6.0221367,false],[false,"nanomole per milliliter per minute","nmol/mL/min","(NMOL/ML)/MIN","amount of substance",10036894500000000000,[-3,-1,0,0,0,0,0],"(nmol/mL)/min","si",true,null,null,1,false,false,1,"nmol per mL per min; nanomoles per milliliters per min; millilitres; milli enzyme units per volume; enzyme activity; enzymatic activity","LOINC","CCnc","Clinical","unit for the enzyme unit U = umol/min. nmol/mL/min = mU/mL","10*23","10*23","6.0221367",6.0221367,false],[false,"nanomole per millimole","nmol/mmol","NMOL/MMOL","amount of substance",0.000001,[0,0,0,0,0,0,0],"nmol/mmol","si",true,null,null,1,false,false,0,"nmol per mmol; nanomoles per millimole","LOINC","SRto","Clinical","","10*23","10*23","6.0221367",6.0221367,false],[false,"nanomole per millimole of creatinine","nmol/mmol{creat}","NMOL/MMOL","amount of substance",0.000001,[0,0,0,0,0,0,0],"nmol/mmol","si",true,null,null,1,false,false,0,"nanomoles","LOINC","SRto","Clinical","","10*23","10*23","6.0221367",6.0221367,false],[false,"nanomole per mole","nmol/mol","NMOL/MOL","amount of substance",1e-9,[0,0,0,0,0,0,0],"nmol/mol","si",true,null,null,1,false,false,0,"nmol per mole; nanomoles","LOINC","SRto","Clinical","","10*23","10*23","6.0221367",6.0221367,false],[false,"nanomole per nanomole","nmol/nmol","NMOL/NMOL","amount of substance",1,[0,0,0,0,0,0,0],"nmol/nmol","si",true,null,null,1,false,false,0,"nmol per nmol; nanomoles","LOINC","SRto","Clinical","","10*23","10*23","6.0221367",6.0221367,false],[false,"nanomole per second","nmol/s","NMOL/S","amount of substance",602213670000000,[0,-1,0,0,0,0,0],"nmol/s","si",true,null,null,1,false,false,1,"nmol/sec; nmol per sec; nanomoles per sercond; milli enzyme units; enzyme activity; enzymatic activity","LOINC","CCnc","Clinical","unit for the enzyme unit U = umol/min.","10*23","10*23","6.0221367",6.0221367,false],[false,"nanomole per second per liter","nmol/s/L","(NMOL/S)/L","amount of substance",602213670000000000,[-3,-1,0,0,0,0,0],"(nmol/s)/L","si",true,null,null,1,false,false,1,"nmol/sec/L; nmol per s per L; nmol per sec per L; nanomoles per seconds per liter; litre; milli enzyme units per volume; enzyme activity; enzymatic activity","LOINC","CCnc","Clinical","unit for the enzyme unit U = umol/min.","10*23","10*23","6.0221367",6.0221367,false],[true,"nanosecond","ns","NS","time",1e-9,[0,1,0,0,0,0,0],"ns",null,false,"T",null,1,false,false,0,"nanoseconds","LOINC","Time","Clinical","",null,null,null,null,false],[false,"nanoenzyme unit per milliliter","nU/mL","NU/ML","catalytic activity",10036894500000,[-3,-1,0,0,0,0,0],"nU/mL","chemical",true,null,null,1,false,false,1,"nU per mL; nanoenzyme units per milliliter; millilitre; enzymatic activity per volume; enzyme activity","LOINC","CCnc","Clinical","1 U is the standard enzyme unit which equals 1 micromole substrate catalyzed per minute (1 umol/min); 1 fU = pmol/min","umol/min","UMOL/MIN","1",1,false],[false,"Ohm meter","Ohm.m","OHM.M","electric resistance",1000,[3,-1,1,0,0,-2,0],"Ω.m","si",true,null,null,1,false,false,0,"electric resistivity; meters; metres","LOINC","","Clinical","unit of electric resistivity","V/A","V/A","1",1,false],[false,"osmole per kilogram","osm/kg","OSM/KG","amount of substance (dissolved particles)",602213670000000000000,[0,0,-1,0,0,0,0],"osm/kg","chemical",true,null,null,1,false,false,1,"osm per kg; osmoles per kilogram; osmols","LOINC","Osmol","Clinical","","mol","MOL","1",1,false],[false,"osmole per liter","osm/L","OSM/L","amount of substance (dissolved particles)",6.0221366999999994e+26,[-3,0,0,0,0,0,0],"osm/L","chemical",true,null,null,1,false,false,1,"osm per L; osmoles per liter; litre; osmols","LOINC","Osmol","Clinical","","mol","MOL","1",1,false],[false,"picoampere","pA","PA","electric current",1e-12,[0,-1,0,0,0,1,0],"pA","si",true,null,null,1,false,false,0,"picoamperes","LOINC","","Clinical","equal to 10^-12 amperes","C/s","C/S","1",1,false],[true,"picogram","pg","PG","mass",1e-12,[0,0,1,0,0,0,0],"pg",null,false,"M",null,1,false,false,0,"picograms","LOINC","Mass; EntMass","Clinical","",null,null,null,null,false],[true,"picogram per deciliter","pg/dL","PG/DL","mass",9.999999999999999e-9,[-3,0,1,0,0,0,0],"pg/dL",null,false,"M",null,1,false,false,0,"pg per dL; picograms; decilitre","LOINC","MCnc","Clinical","",null,null,null,null,false],[true,"picogram per liter","pg/L","PG/L","mass",1e-9,[-3,0,1,0,0,0,0],"pg/L",null,false,"M",null,1,false,false,0,"pg per L; picograms; litre","LOINC","MCnc","Clinical","",null,null,null,null,false],[true,"picogram per milligram","pg/mg","PG/MG","mass",1e-9,[0,0,0,0,0,0,0],"pg/mg",null,false,"M",null,1,false,false,0,"pg per mg; picograms","LOINC","MCnt","Clinical","",null,null,null,null,false],[true,"picogram per milliliter","pg/mL","PG/ML","mass",0.000001,[-3,0,1,0,0,0,0],"pg/mL",null,false,"M",null,1,false,false,0,"pg per mL; picograms per milliliter; millilitre","LOINC","MCnc","Clinical","",null,null,null,null,false],[true,"picogram per millimeter","pg/mm","PG/MM","mass",1e-9,[-1,0,1,0,0,0,0],"pg/mm",null,false,"M",null,1,false,false,0,"pg per mm; picogram/millimeter; picogram/millimetre; picograms per millimeter; millimetre","LOINC","Lineic Mass","Clinical","",null,null,null,null,false],[false,"picokatal","pkat","PKAT","catalytic activity",602213670000,[0,-1,0,0,0,0,0],"pkat","chemical",true,null,null,1,false,false,1,"pkats; picokatals","LOINC","CAct","Clinical","kat is a unit of catalytic activity with base units = mol/s. Rarely used because its units are too large to practically express catalytic activity. See enzyme unit [U] which is the standard unit for catalytic activity.","mol/s","MOL/S","1",1,false],[false,"picoliter","pL","PL","volume",1e-15,[3,0,0,0,0,0,0],"pL","iso1000",true,null,null,1,false,false,0,"picoliters; picolitres","LOINC","Vol","Clinical","","l",null,"1",1,false],[true,"picometer","pm","PM","length",1e-12,[1,0,0,0,0,0,0],"pm",null,false,"L",null,1,false,false,0,"picometers; picometres","LOINC","Len","Clinical","",null,null,null,null,false],[false,"picomole","pmol","PMOL","amount of substance",602213670000,[0,0,0,0,0,0,0],"pmol","si",true,null,null,1,false,false,1,"picomoles; pmols","LOINC","Sub","Clinical","","10*23","10*23","6.0221367",6.0221367,false],[false,"picomole per 24 hour","pmol/(24.h)","PMOL/HR","amount of substance",6970065.625,[0,-1,0,0,0,0,0],"pmol/h","si",true,null,null,1,false,false,1,"pmol/24hrs; pmol/24 hrs; pmol per 24 hrs; 24hrs; days; dy; picomoles per 24 hours","LOINC","SRat","Clinical","","10*23","10*23","6.0221367",6.0221367,false],[false,"picomole per day","pmol/d","PMOL/D","amount of substance",6970065.625,[0,-1,0,0,0,0,0],"pmol/d","si",true,null,null,1,false,false,1,"pmol/dy; pmol per day; 24 hours; 24hrs; 24 hrs; picomoles","LOINC","SRat","Clinical","","10*23","10*23","6.0221367",6.0221367,false],[false,"picomole per deciliter","pmol/dL","PMOL/DL","amount of substance",6022136700000000,[-3,0,0,0,0,0,0],"pmol/dL","si",true,null,null,1,false,false,1,"pmol per dL; picomoles per deciliter; decilitre","LOINC","SCnc","Clinical","","10*23","10*23","6.0221367",6.0221367,false],[false,"picomole per gram","pmol/g","PMOL/G","amount of substance",602213670000,[0,0,-1,0,0,0,0],"pmol/g","si",true,null,null,1,false,false,1,"pmol per gm; picomoles per gram; picomole/gram","LOINC","SCnt","Clinical","","10*23","10*23","6.0221367",6.0221367,false],[false,"picomole per hour per milliliter ","pmol/h/mL","(PMOL/HR)/ML","amount of substance",167281575000000,[-3,-1,0,0,0,0,0],"(pmol/h)/mL","si",true,null,null,1,false,false,1,"pmol/hrs/mL; pmol per hrs per mL; picomoles per hour per milliliter; millilitre; micro enzyme units per volume; enzymatic activity; enzyme activity","LOINC","CCnc","Clinical","unit for the enzyme unit U = umol/min. ","10*23","10*23","6.0221367",6.0221367,false],[false,"picomole per liter","pmol/L","PMOL/L","amount of substance",602213670000000,[-3,0,0,0,0,0,0],"pmol/L","si",true,null,null,1,false,false,1,"picomole/liter; pmol per L; picomoles; litre","LOINC","SCnc","Clinical","","10*23","10*23","6.0221367",6.0221367,false],[false,"picomole per minute","pmol/min","PMOL/MIN","amount of substance",10036894500,[0,-1,0,0,0,0,0],"pmol/min","si",true,null,null,1,false,false,1,"picomole/minute; pmol per min; picomoles per minute; micro enzyme units; enzymatic activity; enzyme activity","LOINC","CCnc","Clinical","unit for the enzyme unit U = umol/min. pmol/min = uU (micro enzyme unit)","10*23","10*23","6.0221367",6.0221367,false],[false,"picomole per milliliter","pmol/mL","PMOL/ML","amount of substance",602213670000000000,[-3,0,0,0,0,0,0],"pmol/mL","si",true,null,null,1,false,false,1,"picomole/milliliter; picomole/millilitre; pmol per mL; picomoles; millilitre; picomols; pmols","LOINC","SCnc","Clinical","","10*23","10*23","6.0221367",6.0221367,false],[false,"picomole per micromole","pmol/umol","PMOL/UMOL","amount of substance",0.000001,[0,0,0,0,0,0,0],"pmol/μmol","si",true,null,null,1,false,false,0,"pmol/mcgmol; picomole/micromole; pmol per umol; pmol per mcgmol; picomoles ","LOINC","SRto","Clinical","","10*23","10*23","6.0221367",6.0221367,false],[true,"picosecond","ps","PS","time",1e-12,[0,1,0,0,0,0,0],"ps",null,false,"T",null,1,false,false,0,"picoseconds; psec","LOINC","Time","Clinical","",null,null,null,null,false],[false,"picotesla","pT","PT","magnetic flux density",1e-9,[0,-1,1,0,0,-1,0],"pT","si",true,null,null,1,false,false,0,"picoteslas","LOINC","","Clinical","SI unit of magnetic field strength for magnetic field B","Wb/m2","WB/M2","1",1,false],[false,"enzyme unit per 12 hour","U/(12.h)","U/HR","catalytic activity",232335520833.33334,[0,-2,0,0,0,0,0],"U/h","chemical",true,null,null,1,false,false,1,"U/12hrs; U/ 12hrs; U per 12 hrs; 12hrs; enzyme units per 12 hours; enzyme activity; enzymatic activity per time; umol per min per 12 hours; micromoles per minute per 12 hours; umol/min/12hr","LOINC","CRat","Clinical","1 U is the standard enzyme unit which equals 1 micromole substrate catalyzed per minute (1 umol/min)","umol/min","UMOL/MIN","1",1,false],[false,"enzyme unit per 2 hour","U/(2.h)","U/HR","catalytic activity",1394013125000,[0,-2,0,0,0,0,0],"U/h","chemical",true,null,null,1,false,false,1,"U/2hrs; U/ 2hrs; U per 2 hrs; 2hrs; enzyme units per 2 hours; enzyme activity; enzymatic activity per time; umol per minute per 2 hours; micromoles per minute; umol/min/2hr; umol per min per 2hr","LOINC","CRat","Clinical","1 U is the standard enzyme unit which equals 1 micromole substrate catalyzed per minute (1 umol/min)","umol/min","UMOL/MIN","1",1,false],[false,"enzyme unit per 24 hour","U/(24.h)","U/HR","catalytic activity",116167760416.66667,[0,-2,0,0,0,0,0],"U/h","chemical",true,null,null,1,false,false,1,"U/24hrs; U/ 24hrs; U per 24 hrs; 24hrs; enzyme units per 24 hours; enzyme activity; enzymatic activity per time; micromoles per minute per 24 hours; umol/min/24hr; umol per min per 24hr","LOINC","CRat","Clinical","1 U is the standard enzyme unit which equals 1 micromole substrate catalyzed per minute (1 umol/min)","umol/min","UMOL/MIN","1",1,false],[false,"enzyme unit per 10","U/10","U","catalytic activity",1003689450000000,[0,-1,0,0,0,0,0],"U","chemical",true,null,null,1,false,false,1,"enzyme unit/10; U per 10; enzyme units per 10; enzymatic activity; enzyme activity; micromoles per minute; umol/min/10","LOINC","CCnc","Clinical","1 U is the standard enzyme unit which equals 1 micromole substrate catalyzed per minute (1 umol/min)","umol/min","UMOL/MIN","1",1,false],[false,"enzyme unit per 10 billion","U/10*10","U/(10*10)","catalytic activity",1003689.45,[0,-1,0,0,0,0,0],"U/(10<sup>10</sup>)","chemical",true,null,null,1,false,false,1,"U per 10*10; enzyme units per 10*10; U per 10 billion; enzyme units; enzymatic activity; micromoles per minute per 10 billion; umol/min/10*10","LOINC","CCnc","Clinical","1 U is the standard enzyme unit which equals 1 micromole substrate catalyzed per minute (1 umol/min)","umol/min","UMOL/MIN","1",1,false],[false,"enzyme unit per trillion","U/10*12","U/(10*12)","catalytic activity",10036.8945,[0,-1,0,0,0,0,0],"U/(10<sup>12</sup>)","chemical",true,null,null,1,false,false,1,"enzyme unit/10*12; U per 10*12; enzyme units per 10*12; enzyme units per trillion; enzymatic activity; micromoles per minute per trillion; umol/min/10*12; umol per min per 10*12","LOINC","CCnc","Clinical","1 U is the standard enzyme unit which equals 1 micromole substrate catalyzed per minute (1 umol/min)","umol/min","UMOL/MIN","1",1,false],[false,"enzyme unit per million","U/10*6","U/(10*6)","catalytic activity",10036894500,[0,-1,0,0,0,0,0],"U/(10<sup>6</sup>)","chemical",true,null,null,1,false,false,1,"enzyme unit/10*6; U per 10*6; enzyme units per 10*6; enzyme units; enzymatic activity per volume; micromoles per minute per million; umol/min/10*6; umol per min per 10*6","LOINC","CCnc","Clinical","1 U is the standard enzyme unit which equals 1 micromole substrate catalyzed per minute (1 umol/min)","umol/min","UMOL/MIN","1",1,false],[false,"enzyme unit per billion","U/10*9","U/(10*9)","catalytic activity",10036894.5,[0,-1,0,0,0,0,0],"U/(10<sup>9</sup>)","chemical",true,null,null,1,false,false,1,"enzyme unit/10*9; U per 10*9; enzyme units per 10*9; enzymatic activity per volume; micromoles per minute per billion; umol/min/10*9; umol per min per 10*9","LOINC","CCnc","Clinical","1 U is the standard enzyme unit which equals 1 micromole substrate catalyzed per minute (1 umol/min)","umol/min","UMOL/MIN","1",1,false],[false,"enzyme unit per day","U/d","U/D","catalytic activity",116167760416.66667,[0,-2,0,0,0,0,0],"U/d","chemical",true,null,null,1,false,false,1,"U/dy; enzyme units per day; enzyme units; enzyme activity; enzymatic activity per time; micromoles per minute per day; umol/min/day; umol per min per day","LOINC","CRat","Clinical","1 U is the standard enzyme unit which equals 1 micromole substrate catalyzed per minute (1 umol/min)","umol/min","UMOL/MIN","1",1,false],[false,"enzyme unit per deciliter","U/dL","U/DL","catalytic activity",100368945000000000000,[-3,-1,0,0,0,0,0],"U/dL","chemical",true,null,null,1,false,false,1,"U per dL; enzyme units per deciliter; decilitre; micromoles per minute per deciliter; umol/min/dL; umol per min per dL","LOINC","CCnc","Clinical","1 U is the standard enzyme unit which equals 1 micromole substrate catalyzed per minute (1 umol/min)","umol/min","UMOL/MIN","1",1,false],[false,"enzyme unit per gram","U/g","U/G","catalytic activity",10036894500000000,[0,-1,-1,0,0,0,0],"U/g","chemical",true,null,null,1,false,false,1,"U/gm; U per gm; enzyme units per gram; micromoles per minute per gram; umol/min/g; umol per min per g","LOINC","CCnt","Clinical","1 U is the standard enzyme unit which equals 1 micromole substrate catalyzed per minute (1 umol/min)","umol/min","UMOL/MIN","1",1,false],[false,"enzyme unit per hour","U/h","U/HR","catalytic activity",2788026250000,[0,-2,0,0,0,0,0],"U/h","chemical",true,null,null,1,false,false,1,"U/hr; U per hr; enzyme units per hour; micromoles per minute per hour; umol/min/hr; umol per min per hr","LOINC","CRat","Clinical","1 U is the standard enzyme unit which equals 1 micromole substrate catalyzed per minute (1 umol/min)","umol/min","UMOL/MIN","1",1,false],[false,"enzyme unit per liter","U/L","U/L","catalytic activity",10036894500000000000,[-3,-1,0,0,0,0,0],"U/L","chemical",true,null,null,1,false,false,1,"enzyme unit/liter; enzyme unit/litre; U per L; enzyme units per liter; enzyme unit per litre; micromoles per minute per liter; umol/min/L; umol per min per L","LOINC","CCnc","Clinical","1 U is the standard enzyme unit which equals 1 micromole substrate catalyzed per minute (1 umol/min)","umol/min","UMOL/MIN","1",1,false],[false,"enzyme unit per minute","U/min","U/MIN","catalytic activity",167281575000000,[0,-2,0,0,0,0,0],"U/min","chemical",true,null,null,1,false,false,1,"enzyme unit/minute; U per min; enzyme units; umol/min/min; micromoles per minute per minute; micromoles per min per min; umol","LOINC","CRat","Clinical","1 U is the standard enzyme unit which equals 1 micromole substrate catalyzed per minute (1 umol/min)","umol/min","UMOL/MIN","1",1,false],[false,"enzyme unit per milliliter","U/mL","U/ML","catalytic activity",1.00368945e+22,[-3,-1,0,0,0,0,0],"U/mL","chemical",true,null,null,1,false,false,1,"U per mL; enzyme units per milliliter; millilitre; micromoles per minute per milliliter; umol/min/mL; umol per min per mL","LOINC","CCnc","Clinical","1 U is the standard enzyme unit which equals 1 micromole substrate catalyzed per minute (1 umol/min)","umol/min","UMOL/MIN","1",1,false],[false,"enzyme unit per second","U/s","U/S","catalytic activity",10036894500000000,[0,-2,0,0,0,0,0],"U/s","chemical",true,null,null,1,false,false,1,"U/sec; U per second; enzyme units per second; micromoles per minute per second; umol/min/sec; umol per min per sec","LOINC","CRat","Clinical","1 U is the standard enzyme unit which equals 1 micromole substrate catalyzed per minute (1 umol/min)","umol/min","UMOL/MIN","1",1,false],[false,"micro international unit","u[IU]","U[IU]","arbitrary",0.000001,[0,0,0,0,0,0,0],"μi.U.","chemical",true,null,null,1,false,true,0,"uIU; u IU; microinternational units","LOINC","Arb","Clinical","International units (IU) are analyte and reference specimen  specific arbitrary units (held at WHO)","[iU]","[IU]","1",1,false],[false,"micro international unit per liter","u[IU]/L","U[IU]/L","arbitrary",0.001,[-3,0,0,0,0,0,0],"(μi.U.)/L","chemical",true,null,null,1,false,true,0,"uIU/L; u IU/L; uIU per L; microinternational units per liter; litre; ","LOINC","ACnc","Clinical","International units (IU) are analyte and reference specimen  specific arbitrary units (held at WHO)","[iU]","[IU]","1",1,false],[false,"micro international unit per milliliter","u[IU]/mL","U[IU]/ML","arbitrary",1,[-3,0,0,0,0,0,0],"(μi.U.)/mL","chemical",true,null,null,1,false,true,0,"uIU/mL; u IU/mL; uIU per mL; microinternational units per milliliter; millilitre","LOINC","ACnc","Clinical","International units (IU) are analyte and reference specimen  specific arbitrary units (held at WHO)","[iU]","[IU]","1",1,false],[false,"microequivalent","ueq","UEQ","amount of substance",602213670000000000,[0,0,0,0,0,0,0],"μeq","chemical",true,null,null,1,false,false,1,"microequivalents; 10^-6 equivalents; 10-6 equivalents","LOINC","Sub","Clinical","","mol","MOL","1",1,false],[false,"microequivalent per liter","ueq/L","UEQ/L","amount of substance",602213670000000000000,[-3,0,0,0,0,0,0],"μeq/L","chemical",true,null,null,1,false,false,1,"ueq per liter; litre; microequivalents","LOINC","MCnc","Clinical","","mol","MOL","1",1,false],[false,"microequivalent per milliliter","ueq/mL","UEQ/ML","amount of substance",6.0221367000000003e+23,[-3,0,0,0,0,0,0],"μeq/mL","chemical",true,null,null,1,false,false,1,"ueq per milliliter; millilitre; microequivalents","LOINC","MCnc","Clinical","","mol","MOL","1",1,false],[true,"microgram","ug","UG","mass",0.000001,[0,0,1,0,0,0,0],"μg",null,false,"M",null,1,false,false,0,"mcg; micrograms; 10^-6 grams; 10-6 grams","LOINC","Mass","Clinical","",null,null,null,null,false],[true,"microgram per 100 gram","ug/(100.g)","UG/G","mass",1e-8,[0,0,0,0,0,0,0],"μg/g",null,false,"M",null,1,false,false,0,"ug/100gm; ug/100 gm; mcg; ug per 100g; 100 gm; mcg per 100g; micrograms per 100 grams","LOINC","MCnt","Clinical","",null,null,null,null,false],[true,"microgram per 24 hour","ug/(24.h)","UG/HR","mass",1.1574074074074074e-11,[0,-1,1,0,0,0,0],"μg/h",null,false,"M",null,1,false,false,0,"ug/24hrs; ug/24 hrs; mcg/24hrs; ug per 24hrs; mcg per 24hrs; 24 hrs; micrograms per 24 hours","LOINC","MRat","Clinical","",null,null,null,null,false],[true,"microgram per 8 hour","ug/(8.h)","UG/HR","mass",3.472222222222222e-11,[0,-1,1,0,0,0,0],"μg/h",null,false,"M",null,1,false,false,0,"ug/8hrs; ug/8 hrs; mcg/8hrs; ug per 8hrs; mcg per 8hrs; 8 hrs; micrograms per 8 hours; shift","LOINC","MRat","Clinical","",null,null,null,null,false],[true,"microgram per square foot (international)","ug/[sft_i]","UG/[SFT_I]","mass",0.000010763910416709721,[-2,0,1,0,0,0,0],"μg",null,false,"M",null,1,false,false,0,"ug/sft; ug/ft2; ug/ft^2; ug/sq. ft; micrograms; sq. foot; foot squared","LOINC","ArMass","Clinical","",null,null,null,null,false],[true,"microgram per day","ug/d","UG/D","mass",1.1574074074074074e-11,[0,-1,1,0,0,0,0],"μg/d",null,false,"M",null,1,false,false,0,"ug/dy; mcg/dy; ug per day; mcg; micrograms per day","LOINC","MRat","Clinical","",null,null,null,null,false],[true,"microgram per deciliter","ug/dL","UG/DL","mass",0.009999999999999998,[-3,0,1,0,0,0,0],"μg/dL",null,false,"M",null,1,false,false,0,"ug per dL; mcg/dl; mcg per dl; micrograms per deciliter; decilitre","LOINC","MCnc","Clinical","",null,null,null,null,false],[true,"microgram per gram","ug/g","UG/G","mass",0.000001,[0,0,0,0,0,0,0],"μg/g",null,false,"M",null,1,false,false,0,"ug per gm; mcg/gm; mcg per g; micrograms per gram","LOINC","MCnt","Clinical","",null,null,null,null,false],[true,"microgram per hour","ug/h","UG/HR","mass",2.7777777777777777e-10,[0,-1,1,0,0,0,0],"μg/h",null,false,"M",null,1,false,false,0,"ug/hr; mcg/hr; mcg per hr; ug per hr; ug per hour; micrograms","LOINC","MRat","Clinical","",null,null,null,null,false],[true,"microgram per kilogram","ug/kg","UG/KG","mass",9.999999999999999e-10,[0,0,0,0,0,0,0],"μg/kg",null,false,"M",null,1,false,false,0,"ug per kg; mcg/kg; mcg per kg; micrograms per kilogram","LOINC","MCnt","Clinical","",null,null,null,null,false],[true,"microgram per kilogram per 8 hour","ug/kg/(8.h)","(UG/KG)/HR","mass",3.472222222222222e-14,[0,-1,0,0,0,0,0],"(μg/kg)/h",null,false,"M",null,1,false,false,0,"ug/kg/8hrs; mcg/kg/8hrs; ug/kg/8 hrs; mcg/kg/8 hrs; ug per kg per 8hrs; 8 hrs; mcg per kg per 8hrs; micrograms per kilograms per 8 hours; shift","LOINC","","Clinical","unit used to measure mass dose rate per patient body mass",null,null,null,null,false],[true,"microgram per kilogram per day","ug/kg/d","(UG/KG)/D","mass",1.1574074074074072e-14,[0,-1,0,0,0,0,0],"(μg/kg)/d",null,false,"M",null,1,false,false,0,"ug/(kg.d); ug/kg/dy; mcg/kg/day; ug per kg per dy; 24 hours; 24hrs; mcg; kilograms; microgram per kilogram and day","LOINC","","Clinical","unit used to measure mass dose rate per patient body mass",null,null,null,null,false],[true,"microgram per kilogram per hour","ug/kg/h","(UG/KG)/HR","mass",2.7777777777777774e-13,[0,-1,0,0,0,0,0],"(μg/kg)/h",null,false,"M",null,1,false,false,0,"ug/(kg.h); ug/kg/hr; mcg/kg/hr; ug per kg per hr; mcg per kg per hr; kilograms","LOINC","","Clinical","unit used to measure mass dose rate per patient body mass",null,null,null,null,false],[true,"microgram per kilogram per minute","ug/kg/min","(UG/KG)/MIN","mass",1.6666666666666664e-11,[0,-1,0,0,0,0,0],"(μg/kg)/min",null,false,"M",null,1,false,false,0,"ug/kg/min; ug/kg/min; mcg/kg/min; ug per kg per min; mcg; micrograms per kilograms per minute ","LOINC","","Clinical","unit used to measure mass dose rate per patient body mass",null,null,null,null,false],[true,"microgram per liter","ug/L","UG/L","mass",0.001,[-3,0,1,0,0,0,0],"μg/L",null,false,"M",null,1,false,false,0,"mcg/L; ug per L; mcg; micrograms per liter; litre ","LOINC","MCnc","Clinical","",null,null,null,null,false],[true,"microgram per liter per 24 hour","ug/L/(24.h)","(UG/L)/HR","mass",1.1574074074074074e-8,[-3,-1,1,0,0,0,0],"(μg/L)/h",null,false,"M",null,1,false,false,0,"ug/L/24hrs; ug/L/24 hrs; mcg/L/24hrs; ug per L per 24hrs; 24 hrs; day; dy mcg; micrograms per liters per 24 hours; litres","LOINC","","Clinical","unit used to measure mass dose rate per patient body mass",null,null,null,null,false],[true,"microgram per square meter","ug/m2","UG/M2","mass",0.000001,[-2,0,1,0,0,0,0],"μg/(m<sup>2</sup>)",null,false,"M",null,1,false,false,0,"ug/m^2; ug/sq. m; mcg/m2; mcg/m^2; mcg/sq. m; ug per m2; m^2; sq. meter; mcg; micrograms per square meter; meter squared; metre","LOINC","ArMass","Clinical","unit used to measure mass dose per patient body surface area",null,null,null,null,false],[true,"microgram per cubic meter","ug/m3","UG/M3","mass",0.000001,[-3,0,1,0,0,0,0],"μg/(m<sup>3</sup>)",null,false,"M",null,1,false,false,0,"ug/m^3; ug/cu. m; mcg/m3; mcg/m^3; mcg/cu. m; ug per m3; ug per m^3; ug per cu. m; mcg; micrograms per cubic meter; meter cubed; metre","LOINC","MCnc","Clinical","",null,null,null,null,false],[true,"microgram per milligram","ug/mg","UG/MG","mass",0.001,[0,0,0,0,0,0,0],"μg/mg",null,false,"M",null,1,false,false,0,"ug per mg; mcg/mg; mcg per mg; micromilligrams per milligram","LOINC","MCnt","Clinical","",null,null,null,null,false],[true,"microgram per minute","ug/min","UG/MIN","mass",1.6666666666666667e-8,[0,-1,1,0,0,0,0],"μg/min",null,false,"M",null,1,false,false,0,"ug per min; mcg/min; mcg per min; microminutes per minute","LOINC","MRat","Clinical","",null,null,null,null,false],[true,"microgram per milliliter","ug/mL","UG/ML","mass",1,[-3,0,1,0,0,0,0],"μg/mL",null,false,"M",null,1,false,false,0,"ug per mL; mcg/mL; mcg per mL; micrograms per milliliter; millilitre","LOINC","MCnc","Clinical","",null,null,null,null,false],[true,"microgram per millimole","ug/mmol","UG/MMOL","mass",1.660540186674939e-27,[0,0,1,0,0,0,0],"μg/mmol",null,false,"M",null,1,false,false,-1,"ug per mmol; mcg/mmol; mcg per mmol; micrograms per millimole","LOINC","Ratio","Clinical","",null,null,null,null,false],[true,"microgram per nanogram","ug/ng","UG/NG","mass",999.9999999999999,[0,0,0,0,0,0,0],"μg/ng",null,false,"M",null,1,false,false,0,"ug per ng; mcg/ng; mcg per ng; micrograms per nanogram","LOINC","MCnt","Clinical","",null,null,null,null,false],[false,"microkatal","ukat","UKAT","catalytic activity",602213670000000000,[0,-1,0,0,0,0,0],"μkat","chemical",true,null,null,1,false,false,1,"microkatals; ukats","LOINC","CAct","Clinical","kat is a unit of catalytic activity with base units = mol/s. Rarely used because its units are too large to practically express catalytic activity. See enzyme unit [U] which is the standard unit for catalytic activity.","mol/s","MOL/S","1",1,false],[false,"microliter","uL","UL","volume",1e-9,[3,0,0,0,0,0,0],"μL","iso1000",true,null,null,1,false,false,0,"microliters; microlitres; mcl","LOINC","Vol","Clinical","","l",null,"1",1,false],[false,"microliter per 2 hour","uL/(2.h)","UL/HR","volume",1.388888888888889e-13,[3,-1,0,0,0,0,0],"μL/h","iso1000",true,null,null,1,false,false,0,"uL/2hrs; uL/2 hrs; mcg/2hr; mcg per 2hr; uL per 2hr; uL per 2 hrs; microliters per 2 hours; microlitres ","LOINC","VRat","Clinical","","l",null,"1",1,false],[false,"microliter per hour","uL/h","UL/HR","volume",2.777777777777778e-13,[3,-1,0,0,0,0,0],"μL/h","iso1000",true,null,null,1,false,false,0,"uL/hr; mcg/hr; mcg per hr; uL per hr; microliters per hour; microlitres","LOINC","VRat","Clinical","","l",null,"1",1,false],[true,"micrometer","um","UM","length",0.000001,[1,0,0,0,0,0,0],"μm",null,false,"L",null,1,false,false,0,"micrometers; micrometres; μm; microns","LOINC","Len","Clinical","Unit of length that is usually used in tests related to the eye",null,null,null,null,false],[true,"microns per second","um/s","UM/S","length",0.000001,[1,-1,0,0,0,0,0],"μm/s",null,false,"L",null,1,false,false,0,"um/sec; micron/second; microns/second; um per sec; micrometers per second; micrometres","LOINC","Vel","Clinical","",null,null,null,null,false],[false,"micromole","umol","UMOL","amount of substance",602213670000000000,[0,0,0,0,0,0,0],"μmol","si",true,null,null,1,false,false,1,"micromoles; umols","LOINC","Sub","Clinical","","10*23","10*23","6.0221367",6.0221367,false],[false,"micromole per 2 hour","umol/(2.h)","UMOL/HR","amount of substance",83640787500000,[0,-1,0,0,0,0,0],"μmol/h","si",true,null,null,1,false,false,1,"umol/2hrs; umol/2 hrs; umol per 2 hrs; 2hrs; micromoles per 2 hours","LOINC","SRat","Clinical","","10*23","10*23","6.0221367",6.0221367,false],[false,"micromole per 24 hour","umol/(24.h)","UMOL/HR","amount of substance",6970065625000,[0,-1,0,0,0,0,0],"μmol/h","si",true,null,null,1,false,false,1,"umol/24hrs; umol/24 hrs; umol per 24 hrs; per 24hrs; micromoles per 24 hours","LOINC","SRat","Clinical","","10*23","10*23","6.0221367",6.0221367,false],[false,"micromole per 8 hour","umol/(8.h)","UMOL/HR","amount of substance",20910196875000,[0,-1,0,0,0,0,0],"μmol/h","si",true,null,null,1,false,false,1,"umol/8hr; umol/8 hr; umol per 8 hr; umol per 8hr; umols per 8hr; umol per 8 hours; micromoles per 8 hours; shift","LOINC","SRat","Clinical","","10*23","10*23","6.0221367",6.0221367,false],[false,"micromole per day","umol/d","UMOL/D","amount of substance",6970065625000,[0,-1,0,0,0,0,0],"μmol/d","si",true,null,null,1,false,false,1,"umol/day; umol per day; umols per day; umol per days; micromoles per days; umol/24hr; umol/24 hr; umol per 24 hr; umol per 24hr; umols per 24hr; umol per 24 hours; micromoles per 24 hours","LOINC","SRat","Clinical","","10*23","10*23","6.0221367",6.0221367,false],[false,"micromole per deciliter","umol/dL","UMOL/DL","amount of substance",6.0221367e+21,[-3,0,0,0,0,0,0],"μmol/dL","si",true,null,null,1,false,false,1,"micromole/deciliter; micromole/decilitre; umol per dL; micromoles per deciliters; micromole per decilitres","LOINC","SCnc","Clinical","","10*23","10*23","6.0221367",6.0221367,false],[false,"micromole per gram","umol/g","UMOL/G","amount of substance",602213670000000000,[0,0,-1,0,0,0,0],"μmol/g","si",true,null,null,1,false,false,1,"micromole/gram; umol per g; micromoles per gram","LOINC","SCnt; Ratio","Clinical","","10*23","10*23","6.0221367",6.0221367,false],[false,"micromole per hour","umol/h","UMOL/HR","amount of substance",167281575000000,[0,-1,0,0,0,0,0],"μmol/h","si",true,null,null,1,false,false,1,"umol/hr; umol per hr; umol per hour; micromoles per hours","LOINC","SRat","Clinical","","10*23","10*23","6.0221367",6.0221367,false],[false,"micromole per kilogram","umol/kg","UMOL/KG","amount of substance",602213670000000,[0,0,-1,0,0,0,0],"μmol/kg","si",true,null,null,1,false,false,1,"umol per kg; micromoles per kilogram","LOINC","SCnt","Clinical","","10*23","10*23","6.0221367",6.0221367,false],[false,"micromole per liter","umol/L","UMOL/L","amount of substance",602213670000000000000,[-3,0,0,0,0,0,0],"μmol/L","si",true,null,null,1,false,false,1,"micromole/liter; micromole/litre; umol per liter; micromoles per liter; litre","LOINC","SCnc","Clinical","","10*23","10*23","6.0221367",6.0221367,false],[false,"micromole per liter per hour","umol/L/h","(UMOL/L)/HR","amount of substance",167281575000000000,[-3,-1,0,0,0,0,0],"(μmol/L)/h","si",true,null,null,1,false,false,1,"umol/liter/hr; umol/litre/hr; umol per L per hr; umol per liter per hour; micromoles per liters per hour; litre","LOINC","CCnc","Clinical","unit for the enzyme unit U = umol/min; umol/L/h is a derived unit of enzyme units","10*23","10*23","6.0221367",6.0221367,false],[false,"micromole per milligram","umol/mg","UMOL/MG","amount of substance",602213670000000000000,[0,0,-1,0,0,0,0],"μmol/mg","si",true,null,null,1,false,false,1,"micromole/milligram; umol per mg; micromoles per milligram","LOINC","SCnt","Clinical","","10*23","10*23","6.0221367",6.0221367,false],[false,"micromole per minute","umol/min","UMOL/MIN","amount of substance",10036894500000000,[0,-1,0,0,0,0,0],"μmol/min","si",true,null,null,1,false,false,1,"micromole/minute; umol per min; micromoles per minute; enzyme units","LOINC","CAct","Clinical","unit for the enzyme unit U = umol/min","10*23","10*23","6.0221367",6.0221367,false],[false,"micromole per minute per gram","umol/min/g","(UMOL/MIN)/G","amount of substance",10036894500000000,[0,-1,-1,0,0,0,0],"(μmol/min)/g","si",true,null,null,1,false,false,1,"umol/min/gm; umol per min per gm; micromoles per minutes per gram; U/g; enzyme units","LOINC","CCnt","Clinical","unit for the enzyme unit U = umol/min. umol/min/g = U/g","10*23","10*23","6.0221367",6.0221367,false],[false,"micromole per minute per liter","umol/min/L","(UMOL/MIN)/L","amount of substance",10036894500000000000,[-3,-1,0,0,0,0,0],"(μmol/min)/L","si",true,null,null,1,false,false,1,"umol/min/liter; umol/minute/liter; micromoles per minutes per liter; litre; enzyme units; U/L","LOINC","CCnc","Clinical","unit for the enzyme unit U = umol/min. umol/min/L = U/L","10*23","10*23","6.0221367",6.0221367,false],[false,"micromole per milliliter","umol/mL","UMOL/ML","amount of substance",6.0221367000000003e+23,[-3,0,0,0,0,0,0],"μmol/mL","si",true,null,null,1,false,false,1,"umol per mL; micromoles per milliliter; millilitre","LOINC","SCnc","Clinical","","10*23","10*23","6.0221367",6.0221367,false],[false,"micromole per milliliter per minute","umol/mL/min","(UMOL/ML)/MIN","amount of substance",1.00368945e+22,[-3,-1,0,0,0,0,0],"(μmol/mL)/min","si",true,null,null,1,false,false,1,"umol per mL per min; micromoles per milliliters per minute; millilitres","LOINC","CCnc","Clinical","unit for the enzyme unit U = umol/min. umol/mL/min = U/mL","10*23","10*23","6.0221367",6.0221367,false],[false,"micromole per millimole","umol/mmol","UMOL/MMOL","amount of substance",0.001,[0,0,0,0,0,0,0],"μmol/mmol","si",true,null,null,1,false,false,0,"umol per mmol; micromoles per millimole","LOINC","SRto","Clinical","","10*23","10*23","6.0221367",6.0221367,false],[false,"micromole per mole","umol/mol","UMOL/MOL","amount of substance",0.000001,[0,0,0,0,0,0,0],"μmol/mol","si",true,null,null,1,false,false,0,"umol per mol; micromoles per mole","LOINC","SRto","Clinical","","10*23","10*23","6.0221367",6.0221367,false],[false,"micromole per micromole","umol/umol","UMOL/UMOL","amount of substance",1,[0,0,0,0,0,0,0],"μmol/μmol","si",true,null,null,1,false,false,0,"umol per umol; micromoles per micromole","LOINC","Srto; SFr; EntSRto","Clinical","","10*23","10*23","6.0221367",6.0221367,false],[false,"microOhm","uOhm","UOHM","electric resistance",0.001,[2,-1,1,0,0,-2,0],"μΩ","si",true,null,null,1,false,false,0,"microOhms; µΩ","LOINC","","Clinical","unit of electric resistance","V/A","V/A","1",1,false],[true,"microsecond","us","US","time",0.000001,[0,1,0,0,0,0,0],"μs",null,false,"T",null,1,false,false,0,"microseconds","LOINC","Time","Clinical","",null,null,null,null,false],[false,"micro enzyme unit per gram","uU/g","UU/G","catalytic activity",10036894500,[0,-1,-1,0,0,0,0],"μU/g","chemical",true,null,null,1,false,false,1,"uU per gm; micro enzyme units per gram; micro enzymatic activity per mass; enzyme activity","LOINC","CCnt","Clinical","1 U is the standard enzyme unit which equals 1 micromole substrate catalyzed per minute (1 umol/min); 1 uU = 1pmol/min","umol/min","UMOL/MIN","1",1,false],[false,"micro enzyme unit per liter","uU/L","UU/L","catalytic activity",10036894500000,[-3,-1,0,0,0,0,0],"μU/L","chemical",true,null,null,1,false,false,1,"uU per L; micro enzyme units per liter; litre; enzymatic activity per volume; enzyme activity ","LOINC","CCnc","Clinical","1 U is the standard enzyme unit which equals 1 micromole substrate catalyzed per minute (1 umol/min); 1 uU = 1pmol/min","umol/min","UMOL/MIN","1",1,false],[false,"micro enzyme unit per milliliter","uU/mL","UU/ML","catalytic activity",10036894500000000,[-3,-1,0,0,0,0,0],"μU/mL","chemical",true,null,null,1,false,false,1,"uU per mL; micro enzyme units per milliliter; millilitre; enzymatic activity per volume; enzyme activity","LOINC","CCnc","Clinical","1 U is the standard enzyme unit which equals 1 micromole substrate catalyzed per minute (1 umol/min); 1 uU = 1pmol/min","umol/min","UMOL/MIN","1",1,false],[false,"microvolt","uV","UV","electric potential",0.001,[2,-2,1,0,0,-1,0],"μV","si",true,null,null,1,false,false,0,"microvolts","LOINC","Elpot","Clinical","unit of electric potential (voltage)","J/C","J/C","1",1,false]]}}');},function(e,t,n){"use strict";function l(){var e=function(e,t){t||(t=e.slice(0));return Object.freeze(Object.defineProperties(e,{raw:{value:Object.freeze(t)}}));}([""," is invalid.\n"],[""," is invalid.\\n"]);return l=function l(){return e;},e;}function i(e,t){for(var n=0;n<t.length;n++){var l=t[n];l.enumerable=l.enumerable||!1,l.configurable=!0,"value"in l&&(l.writable=!0),Object.defineProperty(e,l.key,l);}}function r(e){return(r="function"==typeof Symbol&&"symbol"==_typeof(Symbol.iterator)?function(e){return _typeof(e);}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":_typeof(e);})(e);}Object.defineProperty(t,"__esModule",{value:!0}),t.UnitString=void 0;var s=function(e){if(e&&e.__esModule)return e;if(null===e||"object"!==r(e)&&"function"!=typeof e)return{default:e};var t=a();if(t&&t.has(e))return t.get(e);var n={},l=Object.defineProperty&&Object.getOwnPropertyDescriptor;for(var i in e){if(Object.prototype.hasOwnProperty.call(e,i)){var s=l?Object.getOwnPropertyDescriptor(e,i):null;s&&(s.get||s.set)?Object.defineProperty(n,i,s):n[i]=e[i];}}n.default=e,t&&t.set(e,n);return n;}(n(25));function a(){if("function"!=typeof WeakMap)return null;var e=new WeakMap();return a=function a(){return e;},e;}var o=n(12).Ucum,u=n(40).Unit,c=n(15).UnitTables,f=n(39).PrefixTables,m=function(){function e(){!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function");}(this,e),this.utabs_=c.getInstance(),this.pfxTabs_=f.getInstance(),this.openEmph_=o.openEmph_,this.closeEmph_=o.closeEmph_,this.bracesMsg_="",this.parensFlag_="parens_placeholder",this.pFlagLen_=this.parensFlag_.length,this.braceFlag_="braces_placeholder",this.bFlagLen_=this.braceFlag_.length,this.vcMsgStart_=null,this.vcMsgEnd_=null,this.retMsg_=[],this.parensUnits_=[],this.annotations_=[],this.suggestions=[];}var t,n,r;return t=e,(n=[{key:"useHTMLInMessages",value:function value(e){void 0===e||e?(this.openEmph_=o.openEmphHTML_,this.closeEmph_=o.closeEmphHTML_):(this.openEmph_=o.openEmph_,this.closeEmph_=o.closeEmph_);}},{key:"useBraceMsgForEachString",value:function value(e){this.bracesMsg_=void 0===e||e?o.bracesMsg_:"";}},{key:"parseString",value:function value(e,t,n){if(""===(e=e.trim())||null===e)throw new Error("Please specify a unit expression to be validated.");"validate"===t?(this.vcMsgStart_=o.valMsgStart_,this.vcMsgEnd_=o.valMsgEnd_):(this.vcMsgStart_=o.cnvMsgStart_,this.vcMsgEnd_=o.cnvMsgEnd_),this.suggestions_=void 0===n||!1===n?null:[],this.retMsg_=[],this.parensUnits_=[],this.annotations_=[];var l=e,i=[];if(e=this._getAnnotations(e),this.retMsg_.length>0)i[0]=null,i[1]=null;else{this.retMsg_.length;var r=null;for(r in o.specUnits_){for(;-1!==e.indexOf(r);){e=e.replace(r,o.specUnits_[r]);}}if(e.indexOf(" ")>-1)throw new Error("Blank spaces are not allowed in unit expressions.");var a=(i=this._parseTheString(e,l))[0];(s.isIntegerUnit(a)||"number"==typeof a)&&(a=new u({csCode_:l,magnitude_:a,name_:l}),i[0]=a);}return i[2]=this.retMsg_,this.suggestions_&&this.suggestions_.length>0&&(i[3]=this.suggestions_),i;}},{key:"_parseTheString",value:function value(e,t){var n=null,l=this.retMsg_.length>0,i=this._processParens(e,t),r=[];if(!(l=i[2])){e=i[0],t=i[1];var a=this._makeUnitsArray(e,t);if(!(l=a[2])){r=a[0],t=a[1];for(var o=r.length,u=0;u<o;u++){var c=r[u].un;if(s.isIntegerUnit(c))r[u].un=Number(c);else if(c.indexOf(this.parensFlag_)>=0){var f=this._getParensUnit(c,t);l||(l=f[1]),l||(r[u].un=f[0]);}else{var m=this._makeUnit(c,t);null===m[0]?l=!0:(r[u].un=m[0],t=m[1]);}}}}return l||null!==r[0]&&" "!==r[0]&&void 0!==r[0].un&&null!==r[0].un||0!==this.retMsg_.length||(this.retMsg_.push("Unit string (".concat(t,") did not contain ")+"anything that could be used to create a unit, or else something that is not handled yet by this package.  Sorry"),l=!0),l||(n=this._performUnitArithmetic(r,t)),[n,t];}},{key:"_getAnnotations",value:function value(e){for(var t=e.indexOf("{");t>=0;){var n=e.indexOf("}");if(n<0)this.retMsg_.push("Missing closing brace for annotation starting at "+this.openEmph_+e.substr(t)+this.closeEmph_),t=-1;else{var l=e.substring(t,n+1),i=this.annotations_.length.toString();e=e.replace(l,this.braceFlag_+i+this.braceFlag_),this.annotations_.push(l),t=e.indexOf("{");}}var r=e.indexOf("}");return r>=0&&this.retMsg_.push("Missing opening brace for closing brace found at "+this.openEmph_+e.substring(0,r+1)+this.closeEmph_),e;}},{key:"_processParens",value:function value(e,t){for(var n=[],l=0,i=!1,r=this.parensUnits_.length,s=0;""!==e&&!i;){var a=0,o=0,u=e.indexOf("(");if(u<0){var c=e.indexOf(")");if(c>=0){var f="Missing open parenthesis for close "+"parenthesis at ".concat(e.substring(0,c+s))+"".concat(this.openEmph_).concat(e.substr(c,1)).concat(this.closeEmph_);c<e.length-1&&(f+="".concat(e.substr(c+1))),this.retMsg_.push(f),n[l]=e,i=!0;}else n[l]=e,e="";}else{a+=1;var m=e.length;u>0&&(n[l++]=e.substr(0,u));for(var p=0,h=u+1;h<m&&a!=o;h++){"("===e[h]?a+=1:")"===e[h]&&(o+=1);}if(a===o){p=h,n[l++]=this.parensFlag_+r.toString()+this.parensFlag_;var d=this._parseTheString(e.substring(u+1,p-1),t);null===d[0]?i=!0:(t=d[1],this.parensUnits_[r++]=d[0],e=e.substr(p),s=p);}else n.push(t.substr(u)),this.retMsg_.push("Missing close parenthesis for open parenthesis at "+"".concat(t.substring(0,u+s))+"".concat(this.openEmph_).concat(t.substr(u,1))+"".concat(this.closeEmph_).concat(t.substr(u+1))),i=!0;}}return i&&(this.parensUnits_=[]),[n.join(""),t,i];}},{key:"_makeUnitsArray",value:function value(e,t){var n=e.match(/([./]|[^./]+)/g),l=!1,i=[],r=/(^[0-9]+)(\[?[a-zA-Z\_0-9a-zA-Z\_]+\]?$)/;if("/"===n[0]?n.unshift("1"):"."===n[0]&&(this.retMsg_.push("".concat(t," is not a valid UCUM code. ")+"The multiplication operator at the beginning of the expression is not valid. A multiplication operator must appear only between two codes."),l=!0),!l){if(!s.isNumericString(n[0])){var a=n[0].match(r);if(a&&3===a.length&&""!==a[1]&&""!==a[2]&&0!==a[2].indexOf(this.braceFlag_)){var u=a[2];if(!l&&-1!==a[2].indexOf(this.parensFlag_)){var c=this._getParensUnit(a[2],t);a[2]=c[0].csCode_,u="(".concat(a[2],")"),l=c[1];}l||(this.retMsg_.push("".concat(a[1]).concat(u," is not a valid UCUM code.")+"  ".concat(this.vcMsgStart_).concat(a[1],".").concat(u).concat(this.vcMsgEnd_)),t=t.replace("".concat(a[1]).concat(u),"".concat(a[1],".").concat(u)),n[0]=a[2],n.unshift(a[1],"."));}}if(!l){var f=n.length;i=[{op:"",un:n[0]}];for(var m=1;m<f;m++){var p=n[m++];if(n[m]){if(-1!==o.validOps_.indexOf(n[m]))this.retMsg_.push("".concat(t," is not a valid UCUM code. ")+"A unit code is missing between".concat(this.openEmph_)+"".concat(p).concat(this.closeEmph_,"and").concat(this.openEmph_)+"".concat(n[m]).concat(this.closeEmph_,"in").concat(this.openEmph_)+"".concat(p).concat(n[m]).concat(this.closeEmph_,".")),m=f,l=!0;else if(s.isNumericString(n[m]))i.push({op:p,un:n[m]});else{var h=n[m].match(r);if(h&&3===h.length&&""!==h[1]&&""!==h[2]&&0!==h[2].indexOf(this.braceFlag_)){var d=h[0];if(l||-1===h[2].indexOf(this.parensFlag_)){var g="("+h[1]+"."+h[2]+")",y=this._processParens(g,t);y[2]?(m=f,l=!0):(this.retMsg_.push("".concat(h[0]," is not a ")+"valid UCUM code.  ".concat(this.vcMsgStart_).concat(h[1],".").concat(h[2])+"".concat(this.vcMsgEnd_)),t=t.replace(h[0],g),i.push({op:p,un:y[0]}));}else{var C=this._getParensUnit(h[2],t);if(h[2]=C[0].csCode_,d="(".concat(h[2],")"),!(l=C[1])){this.retMsg_.push("".concat(h[1]).concat(d," is not a ")+"valid UCUM code.  ".concat(this.vcMsgStart_).concat(h[1],".").concat(d)+"".concat(this.vcMsgEnd_));var _="(".concat(h[1],".").concat(d,")");t=t.replace("".concat(h[1]).concat(d),_);var v=this._processParens(_,t);(l=v[2])||i.push({op:p,un:v[0]});}}}else i.push({op:p,un:n[m]});}}else this.retMsg_.push("".concat(t," is not a valid UCUM code. ")+"It is terminated with the operator ".concat(this.openEmph_)+"".concat(p).concat(this.closeEmph_,".")),m=f,l=!0;}}}return[i,t,l];}},{key:"_getParensUnit",value:function value(e,t){var n=!1,l=null,i=e.indexOf(this.parensFlag_),r=null;i>0&&(r=e.substr(0,i-1));var a=e.lastIndexOf(this.parensFlag_),o=null;a+this.pFlagLen_<e.length&&(o=e.substr(a+this.pFlagLen_));var c=e.substring(i+this.pFlagLen_,a);if(!s.isNumericString(c))throw new Error("Processing error - invalid parens number ".concat(c," ")+"found in ".concat(e,"."));if(l=this.parensUnits_[Number(c)],e=s.isIntegerUnit(l)?l:l.csCode_,r)if(s.isNumericString(r)){var f=l.getProperty("magnitude_");f*=Number(r),l.assignVals({magnitude_:f}),e="".concat(r,".").concat(e),this.retMsg_.push("".concat(r).concat(e," is not a valid UCUM code.\n")+this.vcMsgStart_+e+this.vcMsgEnd_);}else if(r.indexOf(this.braceFlag_)>=0){var m=this._getAnnoText(r,t);if(m[1]||m[2])throw new Error("Text found before the parentheses ("+"".concat(r,") included an annotation along with other text ")+"for parenthetical unit ".concat(l.csCode_));e+=m[0],this.retMsg_.push("The annotation ".concat(m[0]," before the unit ")+"code is invalid.\n"+this.vcMsgStart_+e+this.vcMsgEnd_);}else this.suggestions_?n="succeeded"!==this._getSuggestions(r):(this.retMsg_.push("".concat(r," preceding the unit code ").concat(e," ")+"is invalid.  Unable to make a substitution."),n=!0);if(o)if(o.indexOf(this.braceFlag_)>=0){var p=this._getAnnoText(o,t);if(p[1]||p[2])throw new Error("Text found after the parentheses ("+"".concat(o,") included an annotation along with other text ")+"for parenthetical unit ".concat(l.csCode_));e+=p[0];}else s.isNumericString(o)?(e+=o,l=l.power(Number(o)),this.retMsg_.push("An exponent (".concat(o,") following a parenthesis ")+"is invalid as of revision 1.9 of the UCUM Specification.\n  "+this.vcMsgStart_+e+this.vcMsgEnd_)):this.suggestions_?n="succeeded"!==this._getSuggestions(r):(this.retMsg_.push("Text ".concat(o," following the unit code ").concat(e," ")+"is invalid.  Unable to make a substitution."),n=!0);return n||(l?s.isIntegerUnit(l)?l=new u({csCode_:l,magnitude_:l,name_:l}):l.csCode_=e:l=new u({csCode_:e,magnitude_:1,name_:e})),[l,n];}},{key:"_getAnnoText",value:function value(e,t){var n=e.indexOf(this.braceFlag_),l=n>0?e.substring(0,n):null;0!==n&&(e=e.substr(n));var i=e.indexOf(this.braceFlag_,1),r=i+this.bFlagLen_<e.length?e.substr(i+this.bFlagLen_):null,a=e.substring(this.bFlagLen_,i),o=Number(a);if(!s.isNumericString(a)||o>=this.annotations_.length)throw new Error("Processing Error - invalid annotation index ".concat(a," found ")+"in ".concat(e," that was created from ").concat(t));return[e=this.annotations_[o],l,r];}},{key:"_getSuggestions",value:function value(e){var t=s.getSynonyms(e);if("succeeded"===t.status){var n={};n.msg="".concat(e," is not a valid UCUM code.  We found possible ")+"units that might be what was meant:",n.invalidUnit=e;var l=t.units.length;n.units=[];for(var i=0;i<l;i++){var r=t.units[i],a=[r.code,r.name,r.guidance];n.units.push(a);}this.suggestions_.push(n);}else this.retMsg_.push("".concat(e," is not a valid UCUM code.  No alternatives ")+"were found.");return t.status;}},{key:"_makeUnit",value:function value(e,t){var n=this.utabs_.getUnitByCode(e);if(n)n=n.clone();else if(e.indexOf(this.braceFlag_)>=0){var l=this._getUnitWithAnnotation(e,t);(n=l[0])&&(t=l[1]);}else{if(e.indexOf("^")>-1){var i=e.replace("^","*");(n=this.utabs_.getUnitByCode(i))&&((n=n.clone()).csCode_=n.csCode_.replace("*","^"),n.ciCode_=n.ciCode_.replace("*","^"));}if(!n){var r="["+e+"]";(n=this.utabs_.getUnitByCode(r))&&(n=n.clone(),t=t.replace(e,r),this.retMsg_.push("".concat(e," is not a valid unit expression, but ")+"".concat(r," is.\n")+this.vcMsgStart_+"".concat(r," (").concat(n.name_,")").concat(this.vcMsgEnd_)));}if(!n){var s=this.utabs_.getUnitByName(e);if(s&&s.length>0){for(var a="The UCUM code for "+e+" is "+(n=s[0].clone()).csCode_+".\n"+this.vcMsgStart_+n.csCode_+this.vcMsgEnd_,u=!1,c=0;c<this.retMsg_.length&&!u;c++){u=this.retMsg_[c]===a;}u||this.retMsg_.push(a);var f=new RegExp("(^|[./({])("+e+")($|[./)}])"),m=t.match(f);t=t.replace(f,m[1]+n.csCode_+m[3]),e=n.csCode_;}}if(!n){var p=null;for(p in o.specUnits_){-1!==e.indexOf(o.specUnits_[p])&&(e=e.replace(o.specUnits_[p],p));}(n=this.utabs_.getUnitByCode(e))&&(n=n.clone());}if(!n){var h=e,d=null,g=null,y=null,C=null,_=null,v=null,L=this._isCodeWithExponent(e);if(L&&(e=L[0],g=L[1],d=this.utabs_.getUnitByCode(e)),!d&&(y=e.charAt(0),C=this.pfxTabs_.getPrefixByCode(y))){_=C.getValue(),v=C.getExp();var b=y.length;e=e.substr(b),(d=this.utabs_.getUnitByCode(e))||"d"!=y||"a"!=e.substr(0,1)||(y="da",_=(C=this.pfxTabs_.getPrefixByCode(y)).getValue(),e=e.substr(1),d=this.utabs_.getUnitByCode(e));}if(d){(n=d.clone()).guidance_="";var U=n.getProperty("dim_"),T=n.getProperty("magnitude_"),M=n.getProperty("name_"),x=n.getProperty("ciCode_"),S=n.getProperty("printSymbol_");if(g){var I=g=parseInt(g);U&&(U=U.mul(g)),T=Math.pow(T,g),n.assignVals({magnitude_:T}),C&&v&&(I*=C.getExp(),_=Math.pow(10,I));}C&&(n.cnv_?n.assignVals({cnvPfx_:_}):(T*=_,n.assignVals({magnitude_:T})));var N=n.csCode_;if(C&&(M=C.getName()+M,N=y+N,x=C.getCiCode()+x,S=C.getPrintSymbol()+S,n.assignVals({name_:M,csCode_:N,ciCode_:x,printSymbol_:S})),g){var O=g.toString();n.assignVals({name_:M+"<sup>"+O+"</sup>",csCode_:N+O,ciCode_:x+O,printSymbol_:S+"<sup>"+O+"</sup>"});}}else n=null,this.suggestions_?this._getSuggestions(h):this.retMsg_.push("".concat(h," is not a valid UCUM code."));}}return[n,t];}},{key:"_getUnitWithAnnotation",value:function value(e,t){var n=null,i=this._getAnnoText(e,t),r=i[0],a=i[1],o=i[2];this.bracesMsg_&&-1===this.retMsg_.indexOf(this.bracesMsg_)&&this.retMsg_.push(this.bracesMsg_);var u=this.retMsg_.length;if(a||o){if(a&&!o){if(s.isIntegerUnit(a))n=a;else{var c=this._makeUnit(a,t);c[0]?((n=c[0]).csCode_+=r,t=c[1]):this.retMsg_.push("Unable to find a unit for ".concat(a," that ")+"precedes the annotation ".concat(r,"."));}}else if(!a&&o){if(s.isIntegerUnit(o))n=o+r,this.retMsg_.push("The annotation ".concat(r," before the ")(l(),o)+this.vcMsgStart_+n+this.vcMsgEnd_);else{var f=this._makeUnit(o,t);f[0]?((n=f[0]).csCode_+=r,t=n.csCode_,this.retMsg_.push("The annotation ".concat(r," before the unit ")+"code is invalid.\n"+this.vcMsgStart_+n.csCode_+this.vcMsgEnd_)):this.retMsg_.push("Unable to find a unit for ".concat(a," that ")+"follows the annotation ".concat(r,"."));}}else this.retMsg_.push("Unable to find a unit for ".concat(a).concat(r)+"".concat(o,".\nWe are not sure how to interpret text both before ")+"and after the annotation.  Sorry");}else{var m="["+r.substring(1,r.length-1)+"]",p=this._makeUnit(m,t);p[0]?(n=p[0],t=t.replace(r,m),this.retMsg_.push("".concat(r," is not a valid unit expression, but ")+"".concat(m," is.\n")+this.vcMsgStart_+"".concat(m," (").concat(n.name_,")").concat(this.vcMsgEnd_))):(this.retMsg_.length>u&&this.retMsg_.pop(),e=1,n=1);}return[n,t];}},{key:"_performUnitArithmetic",value:function value(e,t){var n=e[0].un;s.isIntegerUnit(n)&&(n=new u({csCode_:n,magnitude_:Number(n),name_:n}));for(var l=e.length,i=!1,r=1;r<l&&!i;r++){var a=e[r].un;if(s.isIntegerUnit(a)&&(a=new u({csCode_:a,magnitude_:Number(a),name_:a})),null===a||"number"!=typeof a&&!a.getProperty){var o="Unit string (".concat(t,") contains unrecognized ")+"element";a&&(o+=" (".concat(this.openEmph_).concat(a.toString())+"".concat(this.closeEmph_,")")),o+="; could not parse full string.  Sorry",this.retMsg_.push(o),i=!0;}else try{n="/"===e[r].op?n.divide(a):n.multiplyThese(a);}catch(e){this.retMsg_.unshift(e.message),i=!0,n=null;}}return n;}},{key:"_isCodeWithExponent",value:function value(e){var t=[],n=e.match(/(^[^\-\+]+?)([\-\+\d]+)$/);return n&&n[2]&&""!==n[2]?(t.push(n[1]),t.push(n[2])):t=null,t;}}])&&i(t.prototype,n),r&&i(t,r),e;}();t.UnitString=m,m.getInstance=function(){return new m();};},function(e,t,n){var l=n(43);e.exports=function(e,t){var n=Number(t);return l(e,12*n);};},function(e,t,n){var l=n(23);e.exports=function(e){var t=l(e),n=t.getFullYear(),i=t.getMonth(),r=new Date(0);return r.setFullYear(n,i+1,0),r.setHours(0,0,0,0),r.getDate();};},function(e,t,n){var l=n(44);e.exports=function(e,t){var n=Number(t);return l(e,7*n);};},function(e,t,n){var l=n(22);e.exports=function(e,t){var n=Number(t);return l(e,36e5*n);};},function(e,t,n){var l=n(22);e.exports=function(e,t){var n=Number(t);return l(e,1e3*n);};},function(e,t){var n=Function.prototype.call.bind(Array.prototype.slice);Number.isInteger=Number.isInteger||function(e){return"number"==typeof e&&isFinite(e)&&Math.floor(e)===e;},String.prototype.startsWith||Object.defineProperty(String.prototype,"startsWith",{value:function value(e,t){return t=t||0,this.indexOf(e,t)===t;}}),String.prototype.endsWith||Object.defineProperty(String.prototype,"endsWith",{value:function value(e,t){var n=this.toString();(void 0===t||t>n.length)&&(t=n.length),t-=e.length;var l=n.indexOf(e,t);return-1!==l&&l===t;}}),String.prototype.includes||Object.defineProperty(String.prototype,"includes",{value:function value(){return-1!==this.indexOf.apply(this,arguments);}}),Object.assign||Object.defineProperty(Object,"assign",{value:function value(e){if(null==e)throw new TypeError("Cannot convert undefined or null to object");return n(arguments,1).reduce(function(e,t){return Object.keys(Object(t)).forEach(function(n){e[n]=t[n];}),e;},Object(e));}});},function(e,t,n){var l={},i=n(46);l.unionOp=function(e,t){return i.distinctFn(e.concat(t));},l.combineFn=function(e,t){return e.concat(t);},e.exports=l;},function(e,t,n){var l=n(7),i=n(10),r=i.FP_Quantity,s={iifMacro:function iifMacro(e,t,n,i){return l.isTrue(t(e))?n(e):i(e);},traceFn:function traceFn(e,t){return console.log("TRACE:["+(t||"")+"]",JSON.stringify(e,null," ")),e;}},a=/^[+-]?\d+$/;s.toInteger=function(e){if(1!=e.length)return[];var t=l.valData(e[0]);if(!1===t)return 0;if(!0===t)return 1;if("number"==typeof t)return Number.isInteger(t)?t:[];if("string"==typeof t){if(a.test(t))return parseInt(t);throw new Error("Could not convert to ineger: "+t);}return[];};var o=/((\+|-)?\d+(\.\d+)?)\s*(('[^']+')|([a-zA-Z]+))?/,u=1,c=5,f=6;s.toQuantity=function(e,t){var n;if(e.length>1)throw new Error("Could not convert to quantity: input collection contains multiple items");if(1===e.length){var i,s=e[0],a=l.valData(s);if("number"==typeof a)n=new r(a,"'1'");else if(a instanceof r)n=a;else if("string"==typeof a&&(i=o.exec(a))){var m=i[u],p=i[c],h=i[f];n=new r(Number(m),p||h||"'1'");}n&&t&&n.unit!==t&&(n=r.convUnitTo(n.unit,n.value,t));}return n||[];};var m=/^[+-]?\d+(\.\d+)?$/;function p(e){var t=e.slice(3);s["to"+t]=function(n){var r=[];if(n.length>1)throw Error("to "+t+" called for a collection of length "+n.length);if(1===n.length){var s=i[e].checkString(l.valData(n[0]));s&&(r[0]=s);}return r;};}s.toDecimal=function(e){if(1!=e.length)return[];var t=l.valData(e[0]);if(!1===t)return 0;if(!0===t)return 1;if("number"==typeof t)return t;if("string"==typeof t){if(m.test(t))return parseFloat(t);throw new Error("Could not convert to decimal: "+t);}return[];},s.toString=function(e){return 1!=e.length?[]:l.valData(e[0]).toString();},p("FP_DateTime"),p("FP_Time"),e.exports=s;},function(e,t,n){var l=n(7),i=n(48),r=n(10),s=r.FP_Type,a=r.FP_DateTime,o=r.FP_Time,u={};function c(e,t){return l.isEmpty(e)||l.isEmpty(t)?[]:i(e,t);}function f(e,t){return l.isEmpty(e)&&l.isEmpty(t)?[!0]:l.isEmpty(e)||l.isEmpty(t)?[]:i(e,t,{fuzzy:!0});}function m(e,t){var n=null;l.assertAtMostOne(e,"Singleton was expected"),l.assertAtMostOne(t,"Singleton was expected"),e=l.valData(e[0]),t=l.valData(t[0]);var i,r=e.constructor,s=t.constructor;r!=s&&(r!==String||s!==a&&s!==o?s!==String||r!==a&&r!==o||(i=r.checkString(t))&&(n=[e,i]):(i=s.checkString(e))&&(n=[i,t]),n||l.raiseError('Type of "'+e+'" ('+r.name+') did not match type of "'+t+'" ('+s.name+")","InequalityExpression"));return n||[e,t];}u.equal=function(e,t){return c(e,t);},u.unequal=function(e,t){var n=c(e,t);return void 0===n?void 0:!n;},u.equival=function(e,t){return f(e,t);},u.unequival=function(e,t){return!f(e,t);},u.lt=function(e,t){if(!e.length||!t.length)return[];var n=m(e,t),l=n[0],i=n[1];return l instanceof s?-1==l.compare(i):l<i;},u.gt=function(e,t){if(!e.length||!t.length)return[];var n=m(e,t),l=n[0],i=n[1];return l instanceof s?1==l.compare(i):l>i;},u.lte=function(e,t){if(!e.length||!t.length)return[];var n=m(e,t),l=n[0],i=n[1];return l instanceof s?l.compare(i)<=0:l<=i;},u.gte=function(e,t){if(!e.length||!t.length)return[];var n=m(e,t),l=n[0],i=n[1];return l instanceof s?l.compare(i)>=0:l>=i;},e.exports=u;},function(e,t,n){var l=n(48),i={};function r(e,t){if(0==t.length)return!0;for(var n=0;n<e.length;n++){if(l(e[n],t[0]))return!0;}return!1;}i.contains=function(e,t){if(0==t.length)return[];if(0==e.length)return!1;if(t.length>1)throw new Error("Expected singleton on right side of contains, got "+JSON.stringify(t));return r(e,t);},i.in=function(e,t){if(0==e.length)return[];if(0==t.length)return!1;if(e.length>1)throw new Error("Expected singleton on right side of in, got "+JSON.stringify(t));return r(t,e);},e.exports=i;},function(e,t,n){var l=n(10),i=l.FP_TimeBase,r=l.FP_Quantity,s=n(7),a={};function o(e){var t=s.valData(e);if("number"!=typeof t){if(1==t.length&&"number"==typeof(t=s.valData(t[0])))return t;throw new Error("Expected number, but got "+JSON.stringify(t||e));}return t;}function u(e){return"number"!=typeof e&&0==e.length;}a.amp=function(e,t){return(e||"")+(t||"");},a.plus=function(e,t){if(1==e.length&&1==t.length){var n=s.valData(e[0]),l=s.valData(t[0]);if("string"==typeof n&&"string"==typeof l)return n+l;if("number"==typeof n&&"number"==typeof l)return n+l;if(n instanceof i&&l instanceof r)return n.plus(l);}throw new Error("Cannot "+JSON.stringify(e)+" + "+JSON.stringify(t));},a.minus=function(e,t){if(1==e.length&&1==t.length){var n=s.valData(e[0]),l=s.valData(t[0]);if("number"==typeof n&&"number"==typeof l)return n-l;if(n instanceof i&&l instanceof r)return n.plus(new r(-l.value,l.unit));}throw new Error("Cannot "+JSON.stringify(e)+" - "+JSON.stringify(t));},a.mul=function(e,t){return e*t;},a.div=function(e,t){return e/t;},a.intdiv=function(e,t){return Math.floor(e/t);},a.mod=function(e,t){return e%t;},a.abs=function(e){if(u(e))return[];var t=o(e);return Math.abs(t);},a.ceiling=function(e){if(u(e))return[];var t=o(e);return Math.ceil(t);},a.exp=function(e){if(u(e))return[];var t=o(e);return Math.exp(t);},a.floor=function(e){if(u(e))return[];var t=o(e);return Math.floor(t);},a.ln=function(e){if(u(e))return[];var t=o(e);return Math.log(t);},a.log=function(e,t){if(u(e)||u(t))return[];var n=o(e),l=o(t);return Math.log(n)/Math.log(l);},a.power=function(e,t){if(u(e)||u(t))return[];var n=o(e),l=o(t);return n<0&&Math.floor(l)!=l?[]:Math.pow(n,l);},a.round=function(e,t){if(u(e))return[];var n=o(e);if(u(t))return Math.round(n);var l=o(t),i=Math.pow(10,l);return Math.round(n*i)/i;},a.sqrt=function(e){if(u(e))return[];var t=o(e);return t<0?[]:Math.sqrt(t);},a.truncate=function(e){if(u(e))return[];var t=o(e);return Math.trunc(t);},e.exports=a;},function(e,t,n){var l=n(7),i={};function r(e){var t;if(1==e.length&&"string"==typeof(t=l.valData(e[0])))return t;throw new Error("Expected string, but got "+JSON.stringify(t||e));}i.indexOf=function(e,t){return r(e).indexOf(t);},i.substring=function(e,t,n){return r(e).substring(t,t+n);},i.startsWith=function(e,t){return r(e).startsWith(t);},i.endsWith=function(e,t){return r(e).endsWith(t);},i.containsFn=function(e,t){return r(e).includes(t);},i.matches=function(e,t){var n=r(e);return new RegExp(t).test(n);},i.replace=function(e,t,n){return r(e).replace(t,n);},i.replaceMatches=function(e,t,n){var l=r(e),i=new RegExp(t);return l.replace(i,n);},i.length=function(e){return r(e).length;},e.exports=i;},function(e,t,n){function l(e){return(l="function"==typeof Symbol&&"symbol"==_typeof(Symbol.iterator)?function(e){return _typeof(e);}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":_typeof(e);})(e);}var i=n(7),r=n(10).ResourceNode.makeResNode,s={children:function children(e){var t=this.model;return e.reduce(function(e,n){var s=i.valData(n);if(n=r(n),"object"===l(s)){for(var a=0,o=Object.keys(s);a<o.length;a++){var u=o[a],c=s[u],f=n.path+"."+u;if(t){var m=t.pathsDefinedElsewhere[f];m&&(f=m);}Array.isArray(c)?e.push.apply(e,c.map(function(e){return r(e,f);})):e.push(r(c,f));}return e;}return e;},[]);},descendants:function descendants(e){for(var t=s.children.call(this,e),n=[];t.length>0;){n.push.apply(n,t),t=s.children.call(this,t);}return n;}};e.exports=s;},function(e,t,n){var l={},i=n(10),r=n(45),s=i.FP_DateTime;l.now=function(){if(!r.now){var e=r.nowDate,t=s.isoDateTime(e);r.now=new s(t);}return r.now;},l.today=function(){if(!r.today){var e=r.nowDate,t=s.isoDate(e);r.today=new s(t);}return r.today;},e.exports=l;},function(e,t){var n={orOp:function orOp(e,t){if(Array.isArray(t)){if(!0===e)return!0;if(!1===e)return[];if(Array.isArray(e))return[];}return Array.isArray(e)?!0===t||[]:e||t;},andOp:function andOp(e,t){if(Array.isArray(t)){if(!0===e)return[];if(!1===e)return!1;if(Array.isArray(e))return[];}return Array.isArray(e)?!0===t&&[]:e&&t;},xorOp:function xorOp(e,t){return Array.isArray(e)||Array.isArray(t)?[]:e&&!t||!e&&t;},impliesOp:function impliesOp(e,t){if(Array.isArray(t)){if(!0===e)return[];if(!1===e)return!0;if(Array.isArray(e))return[];}return Array.isArray(e)?!0===t||[]:!1===e||e&&t;}};e.exports=n;}]);/* harmony default export */ var fhirpath_min = (fhirpath);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/questions/IntegerQuestion.vue?vue&type=script&lang=js&


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * This Component adds a single Integer-Question and reacts to the users input
 */



var FHIRPATH_SLIDER = "extension.where(url='http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl' and valueCodeableConcept.coding.code = 'slider')";
var FHIRPATH_SLIDER_MIN = "extension.where(url='http://hl7.org/fhir/StructureDefinition/minValue').valueInteger";
var FHIRPATH_SLIDER_MAX = "extension.where(url='http://hl7.org/fhir/StructureDefinition/maxValue').valueInteger";
var FHIRPATH_SLIDER_STEP = "extension.where(url='http://hl7.org/fhir/StructureDefinition/questionnaire-sliderStepValue').valueInteger";
var FHIRPATH_SLIDER_LOWER = "item.where(extension.url='http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl' and extension.valueCodeableConcept.coding.code = 'lower').text";
var FHIRPATH_SLIDER_UPPER = "item.where(extension.url='http://hl7.org/fhir/StructureDefinition/questionnaire-itemControl' and extension.valueCodeableConcept.coding.code = 'upper').text";
/* harmony default export */ var IntegerQuestionvue_type_script_lang_js_ = ({
  data: function data() {
    return {
      /**
       * Variable to store the value of the input
       */
      selected: null,

      /**
       * Allows events to be emitted if true
       */
      allow_events: false
    };
  },
  components: {
    VasQuestion: VasQuestion
  },
  props: {
    question: Object,
    mode: String,
    questionnaireResponse: {
      type: Object,
      default: null
    },

    /**
     * Primary color
     */
    primary: {
      type: String
    },

    /**
     * Secondary color
     */
    secondary: {
      type: String
    },

    /**
     * Color used to symbolise danger
     */
    danger: {
      type: String
    },

    /**
     *  Object containing the translations for the current locale
     */
    language: {
      type: Object
    }
  },
  computed: {
    validate: function validate() {
      return this.selected || this.selected === [];
    },
    isVasQuestion: function isVasQuestion() {
      var vas = fhirpath_min.evaluate(this.question, FHIRPATH_SLIDER);

      if (vas.length) {
        return true;
      } else {
        return false;
      }
    },
    minVas: function minVas() {
      if (this.isVasQuestion === true) {
        return fhirpath_min.evaluate(this.question, FHIRPATH_SLIDER_MIN)[0];
      } else {
        return null;
      }
    },
    maxVas: function maxVas() {
      if (this.isVasQuestion === true) {
        return fhirpath_min.evaluate(this.question, FHIRPATH_SLIDER_MAX)[0];
      } else {
        return null;
      }
    },
    stepVas: function stepVas() {
      if (this.isVasQuestion === true) {
        return fhirpath_min.evaluate(this.question, FHIRPATH_SLIDER_STEP)[0];
      } else {
        return null;
      }
    },
    labelLowerVas: function labelLowerVas() {
      if (this.isVasQuestion === true) {
        return fhirpath_min.evaluate(this.question, FHIRPATH_SLIDER_LOWER)[0];
      } else {
        return null;
      }
    },
    labelUpperVas: function labelUpperVas() {
      if (this.isVasQuestion === true) {
        return fhirpath_min.evaluate(this.question, FHIRPATH_SLIDER_UPPER)[0];
      } else {
        return null;
      }
    }
  },
  methods: {
    handleInputVas: function handleInputVas(value) {
      this.selected = parseInt(value, 10);
    },
    emitEvent: function emitEvent(string) {
      this.$emit(string);
    },

    /**
     *  Handles KeyPresses by adding Eventlisteners
     */
    handleKeyPress: function handleKeyPress() {
      var input = document.getElementById("integer" + this.question.linkId);
      var object = this;
      input.addEventListener("keyup", function (event) {
        event.preventDefault();

        if (event.keyCode === 13) {
          object.$emit("next");
        }
      });
    },

    /**
     *
     */
    setSelected: function setSelected() {
      this.selected = questionnaireResponseController.getAnswersFromQuestionnaireResponse(this.questionnaireResponse, this.question.linkId, "integer");
    },

    /**
     * Parses a String into a integer
     */
    toInteger: function toInteger(value) {
      return parseInt(value);
    }
  },
  watch: {
    questionnaireResponse: function questionnaireResponse() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.allow_events = false;
                _context.next = 3;
                return _this.setSelected();

              case 3:
                _this.allow_events = true;

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    selected: function selected() {
      if (this.allow_events) {
        var object = null;

        if (this.selected) {
          object = {
            type: "integer",
            question: this.question,
            value: [this.selected]
          };
        } else {
          object = {
            type: "integer",
            question: this.question,
            value: []
          };
        }

        this.$emit("answer", object);
      }
    },
    question: function question() {
      /**Note: This code prevents the input from showing the invalid value as long as the type of the question
       * doesnt change. If a invalid Number is entered, selected is "" - the code will then force the input
       * to have the value "" aswell
       **/
      if (this.selected === "") {
        this.$refs.integerInput.value = "";
      }

      this.setSelected();
    }
  },
  mounted: function mounted() {
    this.handleKeyPress();
  },
  created: function created() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this2.setSelected();

            case 2:
              _this2.allow_events = true;

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  }
});
// CONCATENATED MODULE: ./src/components/questions/IntegerQuestion.vue?vue&type=script&lang=js&
 /* harmony default export */ var questions_IntegerQuestionvue_type_script_lang_js_ = (IntegerQuestionvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/questions/IntegerQuestion.vue?vue&type=style&index=0&id=c279d800&lang=scss&scoped=true&
var IntegerQuestionvue_type_style_index_0_id_c279d800_lang_scss_scoped_true_ = __webpack_require__("2be5");

// CONCATENATED MODULE: ./src/components/questions/IntegerQuestion.vue






/* normalize component */

var IntegerQuestion_component = normalizeComponent(
  questions_IntegerQuestionvue_type_script_lang_js_,
  IntegerQuestionvue_type_template_id_c279d800_scoped_true_render,
  IntegerQuestionvue_type_template_id_c279d800_scoped_true_staticRenderFns,
  false,
  null,
  "c279d800",
  null
  
)

/* harmony default export */ var IntegerQuestion = (IntegerQuestion_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"465b08a6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/questions/DecimalQuestion.vue?vue&type=template&id=5987878e&scoped=true&
var DecimalQuestionvue_type_template_id_5987878e_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"card"},[_c('h2',[_vm._v(_vm._s(_vm.question.prefix)+" "+_vm._s(_vm.question.text))]),(_vm.language)?_c('div',{class:[{ hidden: _vm.selected || !_vm.question.required }],style:({ color: this.danger })},[_vm._v(" "+_vm._s(_vm.language.mandatory_question)+" ")]):_vm._e()]),_c('hr'),_c('div',{staticClass:"card option-card"},[_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"size",class:[{ 'was-validated': _vm.selected !== '' && _vm.selected }],attrs:{"id":'decimal' + _vm.question.linkId}},[_c('label',{attrs:{"for":"decimalInput"}},[_vm._v(_vm._s(_vm.language.decimal.text)+":")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected),expression:"selected"}],ref:"decimalInput",staticClass:"form-control",attrs:{"step":"any","value":"selected","type":"number","id":"decimal"},domProps:{"value":(_vm.selected)},on:{"input":function($event){if($event.target.composing){ return; }_vm.selected=$event.target.value}}}),(_vm.language)?_c('div',{staticClass:"my-invalid-feedback",class:_vm.naN === false ? 'hidden' : _vm.naN === null ? 'hidden' : 'visible'},[_vm._v(" "+_vm._s(_vm.language.decimal.invalid)+" ")]):_vm._e()])])])])}
var DecimalQuestionvue_type_template_id_5987878e_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/questions/DecimalQuestion.vue?vue&type=template&id=5987878e&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/questions/DecimalQuestion.vue?vue&type=script&lang=js&


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * This Component adds a single Decimal-Question and reacts to the users input
 */

/* harmony default export */ var DecimalQuestionvue_type_script_lang_js_ = ({
  data: function data() {
    return {
      /**
       * Variable to store the value of the input
       */
      selected: null,

      /**
       * Allows events to be emitted if true
       */
      allow_events: false,
      started: false,
      naN: null
    };
  },
  props: {
    question: Object,
    mode: String,
    questionnaireResponse: {
      type: Object,
      default: null
    },

    /**
     * Primary color
     */
    primary: {
      type: String
    },

    /**
     * Secondary color
     */
    secondary: {
      type: String
    },

    /**
     * Color used to symbolise danger
     */
    danger: {
      type: String
    },

    /**
     *  Object containing the translations for the current locale
     */
    language: {
      type: Object
    }
  },
  methods: {
    /**
     *  Handles KeyPresses by adding Eventlisteners
     */
    handleKeyPress: function handleKeyPress() {
      var input = document.getElementById("decimal" + this.question.linkId);
      var object = this;
      input.addEventListener("keyup", function (event) {
        event.preventDefault();

        if (event.keyCode === 13) {
          object.$emit("next");
        }
      });
    },

    /**
     *
     */
    setSelected: function setSelected() {
      this.selected = questionnaireResponseController.getAnswersFromQuestionnaireResponse(this.questionnaireResponse, this.question.linkId, "decimal");
    },
    checkInput: function checkInput(input) {
      this.naN = isNaN(parseFloat(input));
    }
  },
  watch: {
    questionnaireResponse: function questionnaireResponse() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.allow_events = false;
                _context.next = 3;
                return _this.setSelected();

              case 3:
                _this.allow_events = true;

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    selected: function selected() {
      if (this.allow_events) {
        var object = null;
        this.checkInput(this.selected);

        if (!this.naN) {
          object = {
            type: "decimal",
            question: this.question,
            value: [this.selected]
          };
        } else {
          object = {
            type: "decimal",
            question: this.question,
            value: []
          };
        }

        this.$emit("answer", object);
      }
    },
    question: function question() {
      /**Note: This code prevents the input from showing the invalid value as long as the type of the question
       * doesnt change. If a invalid Number is entered, selected is "" - the code will then force the input
       * to have the value "" aswell
       **/
      if (this.selected === "") {
        this.$refs.decimalInput.value = "";
      }

      this.setSelected();
    }
  },
  mounted: function mounted() {
    this.handleKeyPress();
  },
  created: function created() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this2.setSelected();

            case 2:
              _this2.allow_events = true;

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  }
});
// CONCATENATED MODULE: ./src/components/questions/DecimalQuestion.vue?vue&type=script&lang=js&
 /* harmony default export */ var questions_DecimalQuestionvue_type_script_lang_js_ = (DecimalQuestionvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/questions/DecimalQuestion.vue?vue&type=style&index=0&id=5987878e&lang=scss&scoped=true&
var DecimalQuestionvue_type_style_index_0_id_5987878e_lang_scss_scoped_true_ = __webpack_require__("d5f8");

// CONCATENATED MODULE: ./src/components/questions/DecimalQuestion.vue






/* normalize component */

var DecimalQuestion_component = normalizeComponent(
  questions_DecimalQuestionvue_type_script_lang_js_,
  DecimalQuestionvue_type_template_id_5987878e_scoped_true_render,
  DecimalQuestionvue_type_template_id_5987878e_scoped_true_staticRenderFns,
  false,
  null,
  "5987878e",
  null
  
)

/* harmony default export */ var DecimalQuestion = (DecimalQuestion_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"465b08a6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/questions/DateTimeQuestion.vue?vue&type=template&id=75a65e6a&scoped=true&
var DateTimeQuestionvue_type_template_id_75a65e6a_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"card"},[_c('h2',[_vm._v(_vm._s(_vm.question.prefix)+" "+_vm._s(_vm.question.text))]),(_vm.language)?_c('div',{class:[{ hidden: _vm.validate || !_vm.question.required }],style:({ color: this.danger })},[_vm._v(" "+_vm._s(_vm.language.mandatory_question)+" ")]):_vm._e()]),_c('hr'),_c('div',{staticClass:"card option-card"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[(_vm.language)?_c('label',{attrs:{"for":"date"}},[_vm._v(_vm._s(_vm.language.date.text)+":")]):_vm._e(),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.date),expression:"date"}],staticClass:"form-control",attrs:{"required":_vm.question.required,"sm":"6","id":"date","type":"date"},domProps:{"value":(_vm.date)},on:{"input":function($event){if($event.target.composing){ return; }_vm.date=$event.target.value}}})]),_c('div',{staticClass:"col-sm-6"},[(_vm.language)?_c('label',{attrs:{"for":"time"}},[_vm._v(_vm._s(_vm.language.time.text)+":")]):_vm._e(),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.time),expression:"time"}],staticClass:"form-control",attrs:{"required":_vm.question.required,"sm":"6","id":"time","type":"time"},domProps:{"value":(_vm.time)},on:{"input":function($event){if($event.target.composing){ return; }_vm.time=$event.target.value}}})])])])]),_c('br')])}
var DateTimeQuestionvue_type_template_id_75a65e6a_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/questions/DateTimeQuestion.vue?vue&type=template&id=75a65e6a&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/questions/DateTimeQuestion.vue?vue&type=script&lang=js&








//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import dateTimeController from "@/util/dateTimeController";

/**
 * This Component adds a single DateTime-Question and reacts to the users input
 */


/* harmony default export */ var DateTimeQuestionvue_type_script_lang_js_ = ({
  data: function data() {
    return {
      date: "",
      time: "",
      dateTime: "",

      /**
       * Allows events to be emitted if true
       */
      allow_events: false,

      /**
       * Official FHIR-Date Regex
       */
      dateRegex: "^([0-9]([0-9]([0-9][1-9]|[1-9]0)|[1-9]00)|[1-9]000)(-(0[1-9]|1[0-2])(-(0[1-9]|[1-2][0-9]|3[0-1]))?)?$"
    };
  },
  props: {
    question: Object,
    mode: String,
    questionnaireResponse: {
      type: Object,
      default: null
    },

    /**
     * Primary color
     */
    primary: {
      type: String
    },

    /**
     * Secondary color
     */
    secondary: {
      type: String
    },

    /**
     * Color used to symbolise danger
     */
    danger: {
      type: String
    },

    /**
     *  Object containing the translations for the current locale
     */
    language: {
      type: Object
    }
  },
  watch: {
    questionnaireResponse: function questionnaireResponse() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.allow_events = false;
                _context.next = 3;
                return _this.getDateAndTime();

              case 3:
                _this.allow_events = true;

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    date: function date() {
      this.dateTime = external_moment_default()(this.date + "T" + this.time + ":00").format();
    },
    time: function time() {
      this.dateTime = external_moment_default()(this.date + "T" + this.time + ":00").format();
    },
    dateTime: function dateTime() {
      if (this.allow_events) {
        var object = null;

        if (this.dateTime && this.dateTime !== "" && this.time !== "" && this.date !== "" && this.validate) {
          object = {
            type: "dateTime",
            question: this.question,
            value: [this.dateTime]
          };
        } else {
          object = {
            type: "dateTime",
            question: this.question,
            value: []
          };
        }

        this.$emit("answer", object);
      }
    },
    question: function question() {
      this.getDateAndTime();
    }
  },
  computed: {
    validate: function validate() {
      var regex = new RegExp(this.dateRegex);
      return (this.dateTime || this.dateTime === []) && regex.test(this.date);
    }
  },
  methods: {
    getAnswer: function getAnswer() {
      return questionnaireResponseController.getAnswersFromQuestionnaireResponse(this.questionnaireResponse, this.question.linkId, "dateTime");
    },

    /**
     *
     */
    getDateAndTime: function getDateAndTime() {
      if (this.getAnswer()) {
        var datetime = this.getAnswer();
        this.date = external_moment_default()(datetime).format("YYYY-MM-DD");
        this.time = external_moment_default()(datetime).format("HH:mm");
      } else {
        this.date = "";
        this.time = "";
      }
    }
  },
  created: function created() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this2.allow_events = false;
              _context2.next = 3;
              return _this2.getDateAndTime();

            case 3:
              _this2.allow_events = true;

            case 4:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  }
});
// CONCATENATED MODULE: ./src/components/questions/DateTimeQuestion.vue?vue&type=script&lang=js&
 /* harmony default export */ var questions_DateTimeQuestionvue_type_script_lang_js_ = (DateTimeQuestionvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/questions/DateTimeQuestion.vue?vue&type=style&index=0&id=75a65e6a&lang=scss&scoped=true&
var DateTimeQuestionvue_type_style_index_0_id_75a65e6a_lang_scss_scoped_true_ = __webpack_require__("9c81");

// CONCATENATED MODULE: ./src/components/questions/DateTimeQuestion.vue






/* normalize component */

var DateTimeQuestion_component = normalizeComponent(
  questions_DateTimeQuestionvue_type_script_lang_js_,
  DateTimeQuestionvue_type_template_id_75a65e6a_scoped_true_render,
  DateTimeQuestionvue_type_template_id_75a65e6a_scoped_true_staticRenderFns,
  false,
  null,
  "75a65e6a",
  null
  
)

/* harmony default export */ var DateTimeQuestion = (DateTimeQuestion_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"465b08a6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/questions/DateQuestion.vue?vue&type=template&id=faa9c936&scoped=true&
var DateQuestionvue_type_template_id_faa9c936_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"card"},[_c('h2',[_vm._v(_vm._s(_vm.question.prefix)+" "+_vm._s(_vm.question.text))]),(_vm.language)?_c('div',{class:[{ hidden: _vm.validate || !_vm.question.required }],style:({ color: this.danger })},[_vm._v(" "+_vm._s(_vm.language.mandatory_question)+" ")]):_vm._e()]),_c('hr'),_c('div',{staticClass:"option-card"},[(_vm.language)?_c('label',{attrs:{"for":"date"}},[_vm._v(_vm._s(_vm.language.date.text)+":")]):_vm._e(),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected),expression:"selected"}],staticClass:"form-control",attrs:{"id":"date","type":"date"},domProps:{"value":(_vm.selected)},on:{"input":function($event){if($event.target.composing){ return; }_vm.selected=$event.target.value}}})]),_c('br')])}
var DateQuestionvue_type_template_id_faa9c936_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/questions/DateQuestion.vue?vue&type=template&id=faa9c936&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/questions/DateQuestion.vue?vue&type=script&lang=js&








//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * This Component adds a single Date-Question and reacts to the users input
 */

/* harmony default export */ var DateQuestionvue_type_script_lang_js_ = ({
  data: function data() {
    return {
      /**
       * Variable to store the value of the input
       */
      selected: null,

      /**
       * Allows events to be emitted if true
       */
      allow_events: false,

      /**
       * Official FHIR-Date Regex
       */
      dateRegex: "^([0-9]([0-9]([0-9][1-9]|[1-9]0)|[1-9]00)|[1-9]000)(-(0[1-9]|1[0-2])(-(0[1-9]|[1-2][0-9]|3[0-1]))?)?$"
    };
  },
  props: {
    question: Object,
    mode: String,
    questionnaireResponse: {
      type: Object,
      default: null
    },

    /**
     * Primary color
     */
    primary: {
      type: String
    },

    /**
     * Secondary color
     */
    secondary: {
      type: String
    },

    /**
     * Color used to symbolise danger
     */
    danger: {
      type: String
    },

    /**
     *  Object containing the translations for the current locale
     */
    language: {
      type: Object
    }
  },
  computed: {
    validate: function validate() {
      var regex = new RegExp(this.dateRegex);
      return (this.selected || this.selected === []) && regex.test(this.selected);
    }
  },
  methods: {
    setSelected: function setSelected() {
      this.selected = questionnaireResponseController.getAnswersFromQuestionnaireResponse(this.questionnaireResponse, this.question.linkId, "date");
    }
  },
  watch: {
    questionnaireResponse: function questionnaireResponse() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.allow_events = false;
                _context.next = 3;
                return _this.setSelected();

              case 3:
                _this.allow_events = true;

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    selected: function selected() {
      var object = null;

      if (this.validate) {
        object = {
          type: "date",
          question: this.question,
          value: [this.selected]
        };
      } else {
        object = {
          type: "date",
          question: this.question,
          value: []
        };
      }

      this.$emit("answer", object);
    },
    question: function question() {
      this.setSelected();
      this.filled = false;
    }
  },
  created: function created() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this2.setSelected();

            case 2:
              _this2.allow_events = true;

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  }
});
// CONCATENATED MODULE: ./src/components/questions/DateQuestion.vue?vue&type=script&lang=js&
 /* harmony default export */ var questions_DateQuestionvue_type_script_lang_js_ = (DateQuestionvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/questions/DateQuestion.vue?vue&type=style&index=0&id=faa9c936&lang=scss&scoped=true&
var DateQuestionvue_type_style_index_0_id_faa9c936_lang_scss_scoped_true_ = __webpack_require__("bb9e");

// CONCATENATED MODULE: ./src/components/questions/DateQuestion.vue






/* normalize component */

var DateQuestion_component = normalizeComponent(
  questions_DateQuestionvue_type_script_lang_js_,
  DateQuestionvue_type_template_id_faa9c936_scoped_true_render,
  DateQuestionvue_type_template_id_faa9c936_scoped_true_staticRenderFns,
  false,
  null,
  "faa9c936",
  null
  
)

/* harmony default export */ var DateQuestion = (DateQuestion_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"465b08a6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/questions/TimeQuestion.vue?vue&type=template&id=3dc00ce8&scoped=true&
var TimeQuestionvue_type_template_id_3dc00ce8_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"card"},[_c('h2',[_vm._v(_vm._s(_vm.question.prefix)+" "+_vm._s(_vm.question.text))]),(_vm.language)?_c('div',{class:[{ hidden: _vm.validate || !_vm.question.required }],style:({ color: this.danger })},[_vm._v(" "+_vm._s(_vm.language.mandatory_question)+" ")]):_vm._e()]),_c('hr'),_c('div',{staticClass:"card option-card"},[_c('div',[(_vm.language)?_c('label',{attrs:{"for":"time"}},[_vm._v(_vm._s(_vm.language.time.text)+":")]):_vm._e(),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected),expression:"selected"}],staticClass:"form-control",attrs:{"id":"time","type":"time"},domProps:{"value":(_vm.selected)},on:{"input":function($event){if($event.target.composing){ return; }_vm.selected=$event.target.value}}})])]),_c('br')])}
var TimeQuestionvue_type_template_id_3dc00ce8_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/questions/TimeQuestion.vue?vue&type=template&id=3dc00ce8&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/questions/TimeQuestion.vue?vue&type=script&lang=js&


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * This Component adds a single Time-Question and reacts to the users input
 */

/* harmony default export */ var TimeQuestionvue_type_script_lang_js_ = ({
  data: function data() {
    return {
      /**
       * Variable to store the value of the input
       */
      selected: null,

      /**
       * Allows events to be emitted if true
       */
      allow_events: false
    };
  },
  props: {
    question: Object,
    questionnaireResponse: {
      type: Object,
      default: null
    },
    mode: String,

    /**
     * Primary color
     */
    primary: {
      type: String
    },

    /**
     * Secondary color
     */
    secondary: {
      type: String
    },

    /**
     * Color used to symbolise danger
     */
    danger: {
      type: String
    },

    /**
     *  Object containing the translations for the current locale
     */
    language: {
      type: Object
    }
  },
  computed: {
    validate: function validate() {
      return this.selected || this.selected === [];
    }
  },
  methods: {
    setSelected: function setSelected() {
      this.selected = questionnaireResponseController.getAnswersFromQuestionnaireResponse(this.questionnaireResponse, this.question.linkId, "time");
    }
  },
  watch: {
    questionnaireResponse: function questionnaireResponse() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.allow_events = false;
                _context.next = 3;
                return _this.setSelected();

              case 3:
                _this.allow_events = true;

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    selected: function selected() {
      if (this.allow_events) {
        var object = null;

        if (this.selected) {
          object = {
            type: "time",
            question: this.question,
            value: [this.selected]
          };
        } else {
          object = {
            type: "time",
            question: this.question,
            value: []
          };
        }

        this.$emit("answer", object);
      }
    },
    question: function question() {
      this.setSelected();
    }
  },
  created: function created() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this2.setSelected();

            case 2:
              _this2.allow_events = true;

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  }
});
// CONCATENATED MODULE: ./src/components/questions/TimeQuestion.vue?vue&type=script&lang=js&
 /* harmony default export */ var questions_TimeQuestionvue_type_script_lang_js_ = (TimeQuestionvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/questions/TimeQuestion.vue?vue&type=style&index=0&id=3dc00ce8&lang=scss&scoped=true&
var TimeQuestionvue_type_style_index_0_id_3dc00ce8_lang_scss_scoped_true_ = __webpack_require__("b316");

// CONCATENATED MODULE: ./src/components/questions/TimeQuestion.vue






/* normalize component */

var TimeQuestion_component = normalizeComponent(
  questions_TimeQuestionvue_type_script_lang_js_,
  TimeQuestionvue_type_template_id_3dc00ce8_scoped_true_render,
  TimeQuestionvue_type_template_id_3dc00ce8_scoped_true_staticRenderFns,
  false,
  null,
  "3dc00ce8",
  null
  
)

/* harmony default export */ var TimeQuestion = (TimeQuestion_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"465b08a6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/questions/TextQuestion.vue?vue&type=template&id=6b31ed0b&scoped=true&
var TextQuestionvue_type_template_id_6b31ed0b_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{},[_c('h2',[_vm._v(_vm._s(_vm.question.prefix)+" "+_vm._s(_vm.question.text))]),(_vm.language)?_c('div',{class:[{ hidden: _vm.validate || !_vm.question.required }],style:({ color: this.danger })},[_vm._v(" "+_vm._s(_vm.language.mandatory_question)+" ")]):_vm._e()]),_c('hr'),_c('div',{staticClass:"option-card"},[_c('div',[(_vm.language)?_c('label',{attrs:{"for":"textarea"}},[_vm._v(_vm._s(_vm.language.text.text)+":")]):_vm._e(),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected),expression:"selected"}],staticClass:"form-control",attrs:{"id":"textarea","rows":3},domProps:{"value":(_vm.selected)},on:{"input":function($event){if($event.target.composing){ return; }_vm.selected=$event.target.value}}})])]),_c('br')])}
var TextQuestionvue_type_template_id_6b31ed0b_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/questions/TextQuestion.vue?vue&type=template&id=6b31ed0b&scoped=true&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.trim-start.js
var es_string_trim_start = __webpack_require__("eee7");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/questions/TextQuestion.vue?vue&type=script&lang=js&



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * This Component adds a single Text-Question and reacts to the users input
 */

/* harmony default export */ var TextQuestionvue_type_script_lang_js_ = ({
  data: function data() {
    return {
      /**
       * Variable to store the value of the input
       */
      selected: null,

      /**
       * Allows events to be emitted if true
       */
      allow_events: false
    };
  },
  props: {
    question: Object,
    mode: String,
    questionnaireResponse: {
      type: Object,
      default: null
    },

    /**
     * Primary color
     */
    primary: {
      type: String
    },

    /**
     * Secondary color
     */
    secondary: {
      type: String
    },

    /**
     * Color used to symbolise danger
     */
    danger: {
      type: String
    },

    /**
     *  Object containing the translations for the current locale
     */
    language: {
      type: Object
    }
  },
  computed: {
    validate: function validate() {
      return this.selected || this.selected === [];
    }
  },
  methods: {
    /**
     *  Handles KeyPresses by adding Eventlisteners
     */
    handleKeyPress: function handleKeyPress() {
      var input = document.getElementById("decimal");
      var object = this;
      input.addEventListener("keyup", function (event) {
        event.preventDefault();

        if (event.keyCode === 13) {
          object.$emit("next");
        }
      });
    },

    /**
     *
     */
    setSelected: function setSelected() {
      this.selected = questionnaireResponseController.getAnswersFromQuestionnaireResponse(this.questionnaireResponse, this.question.linkId, "text");
    }
  },
  watch: {
    questionnaireResponse: function questionnaireResponse() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.allow_events = false;
                _context.next = 3;
                return _this.setSelected();

              case 3:
                _this.allow_events = true;

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    selected: function selected() {
      if (this.allow_events) {
        var object = null;

        if (this.selected) {
          this.selected = this.selected.trimLeft();
          object = {
            type: "text",
            question: this.question,
            value: [this.selected]
          };
        } else {
          object = {
            type: "text",
            question: this.question,
            value: []
          };
        }

        this.$emit("answer", object);
      }
    },
    question: function question() {
      this.setSelected();
    }
  },
  created: function created() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this2.setSelected();

            case 2:
              _this2.allow_events = true;

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  }
});
// CONCATENATED MODULE: ./src/components/questions/TextQuestion.vue?vue&type=script&lang=js&
 /* harmony default export */ var questions_TextQuestionvue_type_script_lang_js_ = (TextQuestionvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/questions/TextQuestion.vue?vue&type=style&index=0&id=6b31ed0b&lang=scss&scoped=true&
var TextQuestionvue_type_style_index_0_id_6b31ed0b_lang_scss_scoped_true_ = __webpack_require__("7479");

// CONCATENATED MODULE: ./src/components/questions/TextQuestion.vue






/* normalize component */

var TextQuestion_component = normalizeComponent(
  questions_TextQuestionvue_type_script_lang_js_,
  TextQuestionvue_type_template_id_6b31ed0b_scoped_true_render,
  TextQuestionvue_type_template_id_6b31ed0b_scoped_true_staticRenderFns,
  false,
  null,
  "6b31ed0b",
  null
  
)

/* harmony default export */ var TextQuestion = (TextQuestion_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"465b08a6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/questions/UrlQuestion.vue?vue&type=template&id=544dc1c0&scoped=true&
var UrlQuestionvue_type_template_id_544dc1c0_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"card"},[_c('h2',[_vm._v(_vm._s(_vm.question.prefix)+" "+_vm._s(_vm.question.text))]),_c('div',{class:[{ hidden: _vm.validate || !_vm.question.required }],style:({ color: this.danger }),attrs:{"id":"url-mandatory"}},[(_vm.language)?_c('span',[_vm._v(_vm._s(_vm.language.mandatory_question))]):_vm._e()])]),_c('hr'),_c('div',{staticClass:"card option-card"},[(_vm.question)?_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"size",class:[{ 'was-validated': _vm.selected !== '' && _vm.selected }],attrs:{"id":'url' + _vm.question.linkId}},[_c('label',{attrs:{"for":"url-text"}},[_vm._v(_vm._s(_vm.language.url.text)+":")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected),expression:"selected"}],staticClass:"form-control",attrs:{"value":"selected","type":"text","id":"url-text","pattern":"\\S*"},domProps:{"value":(_vm.selected)},on:{"input":function($event){if($event.target.composing){ return; }_vm.selected=$event.target.value}}}),(_vm.language)?_c('div',{staticClass:"invalid-feedback"},[_vm._v(" "+_vm._s(_vm.language.url.invalid)+" ")]):_vm._e(),(_vm.language)?_c('div',{staticClass:"valid-feedback"},[_vm._v(" "+_vm._s(_vm.language.url.valid)+" ")]):_vm._e()])]):_vm._e()]),_c('br')])}
var UrlQuestionvue_type_template_id_544dc1c0_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/questions/UrlQuestion.vue?vue&type=template&id=544dc1c0&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/questions/UrlQuestion.vue?vue&type=script&lang=js&






//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * This Component adds a single Url-Question and reacts to the users input
 */

/* harmony default export */ var UrlQuestionvue_type_script_lang_js_ = ({
  data: function data() {
    return {
      selected: ""
    };
  },
  props: {
    question: Object,
    mode: String,
    questionnaireResponse: {
      type: Object,
      default: null
    },

    /**
     * Primary color
     */
    primary: {
      type: String
    },

    /**
     * Secondary color
     */
    secondary: {
      type: String
    },

    /**
     * Color used to symbolise danger
     */
    danger: {
      type: String
    },

    /**
     *  Object containing the translations for the current locale
     */
    language: {
      type: Object
    }
  },
  computed: {
    validate: function validate() {
      return this.selected || this.selected === [];
    }
  },
  methods: {
    /**
     *
     */
    validateUrl: function validateUrl() {
      if (this.selected) {
        var regex = new RegExp("^\\S*$");
        return this.selected.match(regex) ? true : false;
      }
    },

    /**
     *  Handles KeyPresses by adding Eventlisteners
     */
    handleKeyPress: function handleKeyPress() {
      var input = document.getElementById("url" + this.question.linkId);
      var object = this;

      if (input) {
        input.addEventListener("keyup", function (event) {
          event.preventDefault();

          if (event.keyCode === 13) {
            object.$emit("next");
          }
        });
      }
    },

    /**
     *
     */
    setSelected: function setSelected() {
      this.selected = "";
      this.selected = questionnaireResponseController.getAnswersFromQuestionnaireResponse(this.questionnaireResponse, this.question.linkId, "url");
    }
  },
  watch: {
    questionnaireResponse: function questionnaireResponse() {
      this.setSelected();
    },
    selected: function selected() {
      var object = null;

      if (this.selected) {
        // if (!this.validateUrl()) {
        //   this.$emit("removeRequiredAnswer", this.question);
        // } else {
        //   this.$emit("addRequiredAnswer", this.question);
        // }
        object = {
          type: "url",
          question: this.question,
          value: [this.selected]
        };
      } else {
        object = {
          type: "url",
          question: this.question,
          value: []
        };
      }

      this.$emit("answer", object);
    },
    question: function question() {
      this.setSelected();
    }
  },
  mounted: function mounted() {
    this.handleKeyPress();
  },
  created: function created() {
    this.$emit("removeRequiredAnswer", this.question);
    this.setSelected();
  }
});
// CONCATENATED MODULE: ./src/components/questions/UrlQuestion.vue?vue&type=script&lang=js&
 /* harmony default export */ var questions_UrlQuestionvue_type_script_lang_js_ = (UrlQuestionvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/questions/UrlQuestion.vue?vue&type=style&index=0&id=544dc1c0&lang=scss&scoped=true&
var UrlQuestionvue_type_style_index_0_id_544dc1c0_lang_scss_scoped_true_ = __webpack_require__("ea92");

// CONCATENATED MODULE: ./src/components/questions/UrlQuestion.vue






/* normalize component */

var UrlQuestion_component = normalizeComponent(
  questions_UrlQuestionvue_type_script_lang_js_,
  UrlQuestionvue_type_template_id_544dc1c0_scoped_true_render,
  UrlQuestionvue_type_template_id_544dc1c0_scoped_true_staticRenderFns,
  false,
  null,
  "544dc1c0",
  null
  
)

/* harmony default export */ var UrlQuestion = (UrlQuestion_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"465b08a6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/questions/ChoiceQuestion.vue?vue&type=template&id=f44c2f94&scoped=true&
var ChoiceQuestionvue_type_template_id_f44c2f94_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.language)?_c('div',{staticClass:"card"},[_c('h2',[_vm._v(_vm._s(_vm.question.prefix)+" "+_vm._s(_vm.question.text))]),(!_vm.repeats)?_c('div',{class:[{ hidden: _vm.validate || !_vm.question.required }],style:({ color: _vm.danger })},[_vm._v(" "+_vm._s(_vm.language.mandatory_question)+" ")]):_vm._e(),(_vm.repeats)?_c('div',{class:[{ hidden: !_vm.validateCheckBox() }],style:({ color: _vm.danger })},[_vm._v(" "+_vm._s(_vm.language.mandatory_question)+" ")]):_vm._e()]):_vm._e(),_c('hr'),(!_vm.repeats)?_c('div',{staticClass:"form-group"},_vm._l((_vm.optionsList),function(answer){return _c('div',{key:answer.code},[_c('div',{staticClass:"card radio-button-card",style:([
          {
            background: _vm.selected && _vm.selected.code === answer.code ? '#e8f4fd' : 'white'
          }
        ]),attrs:{"id":answer.code},on:{"click":function($event){return _vm.onBoxClickedSingleChoice(answer.display, answer.code)}}},[(!_vm.repeats)?_c('div',{staticClass:"form-check"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected),expression:"selected"}],staticClass:"form-check-input radio-button",attrs:{"type":"radio","name":'Radio' + _vm.question.linkId,"id":answer.code},domProps:{"value":_vm.formatAnswer(answer.display, answer.code),"checked":_vm._q(_vm.selected,_vm.formatAnswer(answer.display, answer.code))},on:{"change":function($event){_vm.selected=_vm.formatAnswer(answer.display, answer.code)}}}),_c('label',{staticClass:"form-check-label title",attrs:{"for":answer.code},on:{"click":function($event){return _vm.onBoxClickedSingleChoice(answer.display, answer.code)}}},[_vm._v(" "+_vm._s(answer.display)+" ")])]):_vm._e()])])}),0):_vm._e(),(_vm.repeats)?_c('div',{staticClass:"form-group"},_vm._l((_vm.optionsList),function(answer){return _c('div',{key:answer.code},[_c('div',{staticClass:"card radio-button-card",style:([
          {
            background: _vm.checkIfSelected(answer) ? '#e8f4fd' : 'white'
          }
        ]),attrs:{"id":answer.code}},[_c('div',{staticClass:"form-check"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected),expression:"selected"}],staticClass:"form-check-input radio-button",attrs:{"type":"checkbox","name":'Checkbox' + _vm.question.linkId,"id":answer.code},domProps:{"value":_vm.formatAnswer(answer.display, answer.code),"checked":Array.isArray(_vm.selected)?_vm._i(_vm.selected,_vm.formatAnswer(answer.display, answer.code))>-1:(_vm.selected)},on:{"change":function($event){var $$a=_vm.selected,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=_vm.formatAnswer(answer.display, answer.code),$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.selected=$$a.concat([$$v]))}else{$$i>-1&&(_vm.selected=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.selected=$$c}}}}),_c('label',{staticClass:"form-check-label title",attrs:{"for":answer.code},on:{"click":function (event) { return _vm.onBoxClickedMultipleChoice(answer.display, answer.code, event); }}},[_vm._v(" "+_vm._s(answer.display)+" ")])])])])}),0):_vm._e()])}
var ChoiceQuestionvue_type_template_id_f44c2f94_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/questions/ChoiceQuestion.vue?vue&type=template&id=f44c2f94&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/questions/ChoiceQuestion.vue?vue&type=script&lang=js&



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * This Component adds a single Multiple-Choice-Question and reacts to the users input
 */


/* harmony default export */ var ChoiceQuestionvue_type_script_lang_js_ = ({
  data: function data() {
    return {
      /**
       * Variable to store the value of the input
       */
      selected: null,

      /**
       * Allows events to be emitted if true
       */
      allow_events: false,
      optionsList: null,
      repeats: null
    };
  },
  props: {
    questionnaire: {
      type: Object
    },
    question: {
      type: Object,
      required: true
    },
    answers: Object,
    mode: String,
    baseUrl: {
      type: String
    },
    valueSets: {
      type: Array
    },
    questionnaireResponse: {
      type: Object
    },

    /**
     * Primary color
     */
    primary: {
      type: String
    },

    /**
     * Secondary color
     */
    secondary: {
      type: String
    },

    /**
     * Color used to symbolise danger
     */
    danger: {
      type: String
    },

    /**
     *  Object containing the translations for the current locale
     */
    language: {
      type: Object
    }
  },
  computed: {
    validate: function validate() {
      return this.selected || this.selected === [];
    }
  },
  watch: {
    questionnaireResponse: function questionnaireResponse() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.allow_events = false;
                _context.next = 3;
                return _this.setSelected();

              case 3:
                _this.allow_events = true;

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    selected: function selected() {
      if (this.allow_events) {
        var object = null;

        if (this.repeats) {
          //CHECKBOXES
          object = {
            type: "coding",
            question: this.question,
            value: this.selected
          };
        } else {
          //RADIOBUTTONS
          if (this.selected) {
            object = {
              type: "coding",
              question: this.question,
              value: [this.selected]
            };
          } else {
            object = {
              type: "coding",
              question: this.question,
              value: this.selected
            };
          }
        }

        this.$emit("answer", object);
      }
    },
    valueSets: function valueSets() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return _this2.getChoiceOptions();

              case 3:
                _this2.optionsList = _context2.sent;
                _context2.next = 9;
                break;

              case 6:
                _context2.prev = 6;
                _context2.t0 = _context2["catch"](0);
                alert(_context2.t0);

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[0, 6]]);
      }))();
    },
    question: function question() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return _this3.getChoiceOptions();

              case 3:
                _this3.optionsList = _context3.sent;
                _context3.next = 9;
                break;

              case 6:
                _context3.prev = 6;
                _context3.t0 = _context3["catch"](0);
                alert(_context3.t0);

              case 9:
                _this3.setSelected();

                _this3.repeats = _this3.question.repeats;

              case 11:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[0, 6]]);
      }))();
    }
  },
  methods: {
    checkIfSelected: function checkIfSelected(answer) {
      for (var i = 0; i < this.selected.length; i++) {
        if (this.selected[i].code === answer.code) {
          return true;
        }
      }

      return false;
    },

    /**
     *
     */
    validateCheckBox: function validateCheckBox() {
      return this.selected && this.selected.length === 0 && this.question.required;
    },

    /**
     *
     */
    onBoxClickedSingleChoice: function onBoxClickedSingleChoice(display, code) {
      this.selected = this.formatAnswer(display, code);
    },

    /**
     *
     */
    onBoxClickedMultipleChoice: function onBoxClickedMultipleChoice(display, code, event) {
      if (event.srcElement.type && event.srcElement.type === "checkbox") {
        return false;
      } else {
        var currentSelected = this.selected;
        var selectedAnswer = this.formatAnswer(display, code);
        var deletedAnswer = false; //if selected Answer is not in the selected-Array, add it, else delete it

        for (var i = 0; i < currentSelected.length; i++) {
          if (currentSelected[i].code === selectedAnswer.code) {
            currentSelected.splice(i, 1);
            deletedAnswer = true;
          }
        }

        if (!deletedAnswer) {
          this.selected.push(selectedAnswer);
        }
      }
    },

    /**
     * Returns a Object with display and code
     */
    formatAnswer: function formatAnswer(display, code) {
      var data = {
        display: display,
        code: code
      };
      return data;
    },

    /**
     * Returns the options for in the Question for the view to display
     */
    getChoiceOptions: function getChoiceOptions() {
      return questionnaireController.getChoiceOptions(this.questionnaire, this.question, this.valueSets, this.baseUrl);
    },

    /**
     * Sets the value of the variable selected.
     */
    setSelected: function setSelected() {
      var data = questionnaireResponseController.getAnswersFromQuestionnaireResponse(this.questionnaireResponse, this.question.linkId, "coding");

      if (this.question.repeats) {
        this.selected = data;
      } else {
        this.selected = data[0];
      }
    }
  },
  created: function created() {
    var _this4 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              _context4.next = 3;
              return _this4.getChoiceOptions();

            case 3:
              _this4.optionsList = _context4.sent;
              _context4.next = 9;
              break;

            case 6:
              _context4.prev = 6;
              _context4.t0 = _context4["catch"](0);
              alert(_context4.t0);

            case 9:
              _context4.next = 11;
              return _this4.setSelected();

            case 11:
              _this4.repeats = _this4.question.repeats; // this.removeQuestionFromRequiredAnsweredQuestionsList(this.question);

              _this4.$emit("removeRequiredAnswer", _this4.question);

              _this4.allow_events = true;

            case 14:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[0, 6]]);
    }))();
  }
});
// CONCATENATED MODULE: ./src/components/questions/ChoiceQuestion.vue?vue&type=script&lang=js&
 /* harmony default export */ var questions_ChoiceQuestionvue_type_script_lang_js_ = (ChoiceQuestionvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/questions/ChoiceQuestion.vue?vue&type=style&index=0&id=f44c2f94&lang=scss&scoped=true&
var ChoiceQuestionvue_type_style_index_0_id_f44c2f94_lang_scss_scoped_true_ = __webpack_require__("8225");

// EXTERNAL MODULE: ./src/components/questions/ChoiceQuestion.vue?vue&type=style&index=1&lang=scss&
var ChoiceQuestionvue_type_style_index_1_lang_scss_ = __webpack_require__("0179");

// CONCATENATED MODULE: ./src/components/questions/ChoiceQuestion.vue







/* normalize component */

var ChoiceQuestion_component = normalizeComponent(
  questions_ChoiceQuestionvue_type_script_lang_js_,
  ChoiceQuestionvue_type_template_id_f44c2f94_scoped_true_render,
  ChoiceQuestionvue_type_template_id_f44c2f94_scoped_true_staticRenderFns,
  false,
  null,
  "f44c2f94",
  null
  
)

/* harmony default export */ var ChoiceQuestion = (ChoiceQuestion_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"465b08a6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/questions/StringQuestion.vue?vue&type=template&id=1aeb363e&scoped=true&
var StringQuestionvue_type_template_id_1aeb363e_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"card"},[_c('h2',[_vm._v(_vm._s(_vm.question.prefix)+" "+_vm._s(_vm.question.text))]),(_vm.language)?_c('div',{class:[{ hidden: _vm.validate || !_vm.question.required }],style:({ color: this.danger })},[_vm._v(" "+_vm._s(_vm.language.mandatory_question)+" ")]):_vm._e()]),_c('hr'),_c('div',{staticClass:"card option-card"},[_c('div',[(_vm.language)?_c('label',{attrs:{"for":"string"}},[_vm._v(_vm._s(_vm.language.text.text)+":")]):_vm._e(),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected),expression:"selected"}],staticClass:"form-control",attrs:{"id":"string","type":"text","rows":2},domProps:{"value":(_vm.selected)},on:{"input":function($event){if($event.target.composing){ return; }_vm.selected=$event.target.value}}})])]),_c('br')])}
var StringQuestionvue_type_template_id_1aeb363e_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/questions/StringQuestion.vue?vue&type=template&id=1aeb363e&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/questions/StringQuestion.vue?vue&type=script&lang=js&



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * This Component adds a single String-Question and reacts to the users input
 */

/* harmony default export */ var StringQuestionvue_type_script_lang_js_ = ({
  computed: {
    validate: function validate() {
      return this.selected || this.selected === [];
    }
  },
  data: function data() {
    return {
      /**
       * Variable to store the value of the input
       */
      selected: null,

      /**
       * Allows events to be emitted if true
       */
      allow_events: false,
      required: false
    };
  },
  props: {
    questionnaireResponse: {
      type: Object
    },
    question: Object,
    mode: String,

    /**
     * Primary color
     */
    primary: {
      type: String
    },

    /**
     * Secondary color
     */
    secondary: {
      type: String
    },

    /**
     * Color used to symbolise danger
     */
    danger: {
      type: String
    },

    /**
     *  Object containing the translations for the current locale
     */
    language: {
      type: Object
    }
  },
  methods: {
    /**
     *  Handles KeyPresses by adding Eventlisteners
     */
    handleKeyPress: function handleKeyPress() {
      var input = document.getElementById("string");
      var object = this;
      input.addEventListener("keyup", function (event) {
        event.preventDefault();

        if (event.keyCode === 13) {
          object.$emit("next");
        }
      });
    },

    /**
     *
     */
    setSelected: function setSelected() {
      this.selected = questionnaireResponseController.getAnswersFromQuestionnaireResponse(this.questionnaireResponse, this.question.linkId, "string");
    }
  },
  watch: {
    questionnaireResponse: function questionnaireResponse() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.allow_events = false;
                _context.next = 3;
                return _this.setSelected();

              case 3:
                _this.allow_events = true;

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    selected: function selected() {
      if (this.allow_events) {
        var object = null;

        if (this.selected) {
          this.selected = this.selected.trimLeft();
          object = {
            type: "string",
            question: this.question,
            value: [this.selected]
          };
        } else {
          object = {
            type: "string",
            question: this.question,
            value: []
          };
        }

        this.$emit("answer", object);
      }
    },
    question: function question() {
      this.setSelected();
      this.filled = false;
    }
  },
  mounted: function mounted() {
    this.handleKeyPress();
  },
  created: function created() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this2.setSelected();

            case 2:
              _this2.allow_events = true;

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  }
});
// CONCATENATED MODULE: ./src/components/questions/StringQuestion.vue?vue&type=script&lang=js&
 /* harmony default export */ var questions_StringQuestionvue_type_script_lang_js_ = (StringQuestionvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/questions/StringQuestion.vue?vue&type=style&index=0&id=1aeb363e&lang=scss&scoped=true&
var StringQuestionvue_type_style_index_0_id_1aeb363e_lang_scss_scoped_true_ = __webpack_require__("6bb0");

// CONCATENATED MODULE: ./src/components/questions/StringQuestion.vue






/* normalize component */

var StringQuestion_component = normalizeComponent(
  questions_StringQuestionvue_type_script_lang_js_,
  StringQuestionvue_type_template_id_1aeb363e_scoped_true_render,
  StringQuestionvue_type_template_id_1aeb363e_scoped_true_staticRenderFns,
  false,
  null,
  "1aeb363e",
  null
  
)

/* harmony default export */ var StringQuestion = (StringQuestion_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"465b08a6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/questions/BooleanQuestion.vue?vue&type=template&id=605b57c9&scoped=true&
var BooleanQuestionvue_type_template_id_605b57c9_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{},[_c('h2',[_vm._v(_vm._s(_vm.question.prefix)+" "+_vm._s(_vm.question.text))]),(_vm.language)?_c('div',{class:[{ hidden: _vm.validate || !_vm.question.required }],style:({ color: this.danger })},[_vm._v(" "+_vm._s(_vm.language.mandatory_question)+" ")]):_vm._e()]),_c('hr'),_c('div',[(_vm.question)?_c('div',{staticClass:"form-group",attrs:{"id":'radio-boolean-' + _vm.question.linkId}},[_c('div',{staticClass:"card radio-button-card",class:[{ 'card-selected': _vm.selected && 'yes' === _vm.selected }]},[_c('div',{staticClass:"form-check"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected),expression:"selected"}],staticClass:"form-check-input radio-button",attrs:{"id":'radioYes' + _vm.question.linkId,"type":"radio","name":'Radio' + _vm.question.linkId,"value":"yes"},domProps:{"checked":_vm._q(_vm.selected,"yes")},on:{"change":function($event){_vm.selected="yes"}}}),(_vm.language)?_c('label',{staticClass:"form-check-label title",attrs:{"for":'radioYes' + _vm.question.linkId},on:{"click":function($event){return _vm.onCardClick('yes')}}},[_vm._v(" "+_vm._s(_vm.language.yes)+" ")]):_vm._e()])]),_c('div',{staticClass:"card radio-button-card",class:[{ 'card-selected': _vm.selected && 'no' === _vm.selected }]},[_c('div',{staticClass:"form-check"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected),expression:"selected"}],staticClass:"form-check-input radio-button",attrs:{"id":'radioNo' + _vm.question.linkId,"type":"radio","name":'Radio' + _vm.question.linkId,"value":"no"},domProps:{"checked":_vm._q(_vm.selected,"no")},on:{"change":function($event){_vm.selected="no"}}}),(_vm.language)?_c('label',{staticClass:"form-check-label title",attrs:{"for":'radioNo' + _vm.question.linkId},on:{"click":function($event){return _vm.onCardClick('no')}}},[_vm._v(" "+_vm._s(_vm.language.no)+" ")]):_vm._e()])])]):_vm._e()]),_c('br')])}
var BooleanQuestionvue_type_template_id_605b57c9_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/questions/BooleanQuestion.vue?vue&type=template&id=605b57c9&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/questions/BooleanQuestion.vue?vue&type=script&lang=js&


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * This Component adds a Boolean-Question and reacts to the users input
 */

/* harmony default export */ var BooleanQuestionvue_type_script_lang_js_ = ({
  data: function data() {
    return {
      /**
       * Variable to store the value of the input
       */
      selected: null,

      /**
       * Allows events to be emitted if true
       */
      allow_events: false
    };
  },
  props: {
    question: Object,
    mode: String,
    questionnaireResponse: {
      type: Object,
      default: null
    },

    /**
     * Primary color
     */
    primary: {
      type: String
    },

    /**
     * Secondary color
     */
    secondary: {
      type: String
    },

    /**
     * Color used to symbolise danger
     */
    danger: {
      type: String
    },

    /**
     *  Object containing the translations for the current locale
     */
    language: {
      type: Object
    }
  },
  computed: {
    validate: function validate() {
      return this.selected || this.selected === [];
    }
  },
  methods: {
    /**
     *
     */
    onCardClick: function onCardClick(selectedValue) {
      this.selected = selectedValue;
    },
    setSelected: function setSelected() {
      var value = questionnaireResponseController.getAnswersFromQuestionnaireResponse(this.questionnaireResponse, this.question.linkId, "boolean");

      if (value === true) {
        this.selected = "yes";
      } else if (value === false) {
        this.selected = "no";
      } else {
        this.selected = null;
      }
    }
  },
  watch: {
    questionnaireResponse: function questionnaireResponse() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.allow_events = false;
                _context.next = 3;
                return _this.setSelected();

              case 3:
                _this.allow_events = true;

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    selected: function selected() {
      if (this.allow_events) {
        if (this.selected !== null) {
          var object = {
            type: "boolean",
            question: this.question,
            value: [this.selected]
          };
          this.$emit("answer", object);
        }
      }
    },
    question: function question() {
      this.setSelected();
    }
  },
  created: function created() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this2.setSelected();

            case 2:
              _this2.allow_events = true;

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  }
});
// CONCATENATED MODULE: ./src/components/questions/BooleanQuestion.vue?vue&type=script&lang=js&
 /* harmony default export */ var questions_BooleanQuestionvue_type_script_lang_js_ = (BooleanQuestionvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/questions/BooleanQuestion.vue?vue&type=style&index=0&id=605b57c9&lang=scss&scoped=true&
var BooleanQuestionvue_type_style_index_0_id_605b57c9_lang_scss_scoped_true_ = __webpack_require__("ed8c");

// EXTERNAL MODULE: ./src/components/questions/BooleanQuestion.vue?vue&type=custom&index=0&blockType=i18n
var BooleanQuestionvue_type_custom_index_0_blockType_i18n = __webpack_require__("610f");
var BooleanQuestionvue_type_custom_index_0_blockType_i18n_default = /*#__PURE__*/__webpack_require__.n(BooleanQuestionvue_type_custom_index_0_blockType_i18n);

// CONCATENATED MODULE: ./src/components/questions/BooleanQuestion.vue






/* normalize component */

var BooleanQuestion_component = normalizeComponent(
  questions_BooleanQuestionvue_type_script_lang_js_,
  BooleanQuestionvue_type_template_id_605b57c9_scoped_true_render,
  BooleanQuestionvue_type_template_id_605b57c9_scoped_true_staticRenderFns,
  false,
  null,
  "605b57c9",
  null
  
)

/* custom blocks */

if (typeof BooleanQuestionvue_type_custom_index_0_blockType_i18n_default.a === 'function') BooleanQuestionvue_type_custom_index_0_blockType_i18n_default()(BooleanQuestion_component)

/* harmony default export */ var BooleanQuestion = (BooleanQuestion_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"465b08a6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/questions/GroupQuestion.vue?vue&type=template&id=32607e7a&scoped=true&
var GroupQuestionvue_type_template_id_32607e7a_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.mode !== 'GROUPS')?_c('div',{style:({ color: this.primary })},[_c('svg',{staticClass:"material-design-icon__svg",staticStyle:{"width":"80px","height":"80px"},attrs:{"viewBox":"0 0 24 24"}},[_c('path',{attrs:{"fill":"#000000","d":"M19,7H9V5H19M15,15H9V13H15M19,11H9V9H19M20,2H8A2,2 0 0,0 6,4V16A2,2 0 0,0 8,18H20A2,2 0 0,0 22,16V4A2,2 0 0,0 20,2M4,6H2V20A2,2 0 0,0 4,22H18V20H4V6Z"}})]),(_vm.language)?_c('div',{staticClass:"group-subtitle"},[_vm._v(_vm._s(_vm.language.questionGroup)+" "+_vm._s(_vm.question.prefix))]):_vm._e(),_c('div',{staticClass:"group-title"},[_vm._v(_vm._s(_vm.question.prefix)+" "+_vm._s(_vm.question.text))])]):_vm._e(),(_vm.mode === 'GROUPS')?_c('div',[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('svg',{staticClass:"material-design-icon__svg",staticStyle:{"width":"80px","height":"80px"},attrs:{"viewBox":"0 0 24 24"}},[_c('path',{attrs:{"fill":"#000000","d":"M19,7H9V5H19M15,15H9V13H15M19,11H9V9H19M20,2H8A2,2 0 0,0 6,4V16A2,2 0 0,0 8,18H20A2,2 0 0,0 22,16V4A2,2 0 0,0 20,2M4,6H2V20A2,2 0 0,0 4,22H18V20H4V6Z"}})]),(_vm.language)?_c('div',{staticClass:"group-subtitle"},[_vm._v(_vm._s(_vm.language.questionGroup)+" "+_vm._s(_vm.question.prefix))]):_vm._e(),_c('div',{staticClass:"group-title"},[_vm._v(_vm._s(_vm.question.prefix)+" "+_vm._s(_vm.question.text))])])]),_c('transition-group',{attrs:{"name":"list-complete","tag":"p"}},_vm._l((_vm.question.item),function(groupquestion){return _c('div',{key:groupquestion.linkId,staticClass:"card-margin-top"},[(groupquestion.type == 'group')?_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('svg',{staticClass:"material-design-icon__svg",staticStyle:{"width":"80px","height":"80px"},attrs:{"viewBox":"0 0 24 24"}},[_c('path',{attrs:{"fill":"#000000","d":"M19,7H9V5H19M15,15H9V13H15M19,11H9V9H19M20,2H8A2,2 0 0,0 6,4V16A2,2 0 0,0 8,18H20A2,2 0 0,0 22,16V4A2,2 0 0,0 20,2M4,6H2V20A2,2 0 0,0 4,22H18V20H4V6Z"}})]),(_vm.language)?_c('div',{staticClass:"group-subtitle"},[_vm._v(_vm._s(_vm.language.questionGroup)+" "+_vm._s(groupquestion.prefix))]):_vm._e(),_c('div',{staticClass:"group-title"},[_vm._v(_vm._s(groupquestion.prefix)+" "+_vm._s(groupquestion.text))])])]):_vm._e(),(groupquestion.type !== 'group')?_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[(groupquestion.groupId && !groupquestion.item)?_c('div',{staticClass:"question-group-text"},[_vm._v(" "+_vm._s(_vm.getGroupText(groupquestion))+" ")]):_vm._e(),_c(_vm.getQuestionType(groupquestion),{tag:"component",attrs:{"id":groupquestion.linkId,"question":groupquestion,"mode":"ITEMS","questionnaireResponse":_vm.questionnaireResponse,"questionnaire":_vm.questionnaire,"valueSets":_vm.valueSets,"baseUrl":_vm.baseUrl,"primary":_vm.primary,"secondary":_vm.secondary,"danger":_vm.danger,"language":_vm.language},on:{"answer":function($event){return _vm.relayAnswer($event)}}})],1)]):_vm._e()])}),0)],1):_vm._e()])}
var GroupQuestionvue_type_template_id_32607e7a_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/questions/GroupQuestion.vue?vue&type=template&id=32607e7a&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/questions/GroupQuestion.vue?vue&type=script&lang=js&



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/**
 * This Component adds a Group-Question
 */

/* harmony default export */ var GroupQuestionvue_type_script_lang_js_ = ({
  name: "groupQuestion",
  props: {
    filteredItemList: {
      type: Array
    },
    questionnaire: {
      type: Object,
      required: true
    },
    questionnaireResponse: {
      type: Object,
      default: null
    },
    requiredQuestionList: {
      type: Array
    },
    valueSets: {
      type: Array
    },
    baseUrl: {
      type: String
    },
    editMode: {
      type: Boolean,
      default: false
    },
    startCount: Number,
    lastQuestion: {
      type: Boolean,
      default: false
    },

    /**
     * Primary color
     */
    primary: {
      type: String
    },

    /**
     * Secondary color
     */
    secondary: {
      type: String
    },

    /**
     * Color used to symbolise danger
     */
    danger: {
      type: String
    },
    enableReturn: {
      type: Boolean,
      default: true
    },

    /**
     *  Object containing the translations for the current locale
     */
    language: {
      type: Object
    },
    question: Object,
    mode: String
  },
  components: {
    DisplayQuestion: DisplayQuestion,
    IntegerQuestion: IntegerQuestion,
    DateQuestion: DateQuestion,
    DateTimeQuestion: DateTimeQuestion,
    DecimalQuestion: DecimalQuestion,
    StringQuestion: StringQuestion,
    TextQuestion: TextQuestion,
    TimeQuestion: TimeQuestion,
    UrlQuestion: UrlQuestion,
    ChoiceQuestion: ChoiceQuestion,
    BooleanQuestion: BooleanQuestion
  },
  computed: {},
  methods: {
    /**
     *
     */
    getGroupText: function getGroupText(currentQuestion) {
      var groupQuestion = this.filteredItemList.find(function (element) {
        return element.linkId === currentQuestion.groupId;
      });

      if (groupQuestion) {
        return groupQuestion.text;
      } else {
        return "";
      }
    },

    /**
     *
     */
    getQuestionType: function getQuestionType(question) {
      return question.type + "Question";
    },

    /**
     * Relays the Event from the question-components to the top-component
     */
    relayAnswer: function relayAnswer(object) {
      this.$emit("answer", object);
    },

    /**
     * Emits new Event to give the required Question to Parent-Component
     * to be removed from the List of answered Questions
     */
    removeRequiredQuestionEvent: function removeRequiredQuestionEvent(question) {
      this.$emit("removeRequiredAnswer", question);
    },

    /**
     * Emits new Event to give the required Question to Parent-Component
     * to be added to the List of answered Questions
     */
    addRequiredQuestionEvent: function addRequiredQuestionEvent(question) {
      this.$emit("addRequiredAnswer", question);
    }
  }
});
// CONCATENATED MODULE: ./src/components/questions/GroupQuestion.vue?vue&type=script&lang=js&
 /* harmony default export */ var questions_GroupQuestionvue_type_script_lang_js_ = (GroupQuestionvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/questions/GroupQuestion.vue?vue&type=style&index=0&id=32607e7a&lang=scss&scoped=true&
var GroupQuestionvue_type_style_index_0_id_32607e7a_lang_scss_scoped_true_ = __webpack_require__("3b3f");

// CONCATENATED MODULE: ./src/components/questions/GroupQuestion.vue






/* normalize component */

var GroupQuestion_component = normalizeComponent(
  questions_GroupQuestionvue_type_script_lang_js_,
  GroupQuestionvue_type_template_id_32607e7a_scoped_true_render,
  GroupQuestionvue_type_template_id_32607e7a_scoped_true_staticRenderFns,
  false,
  null,
  "32607e7a",
  null
  
)

/* harmony default export */ var GroupQuestion = (GroupQuestion_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/questionnaire/FullQuestionnaire.vue?vue&type=script&lang=js&




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













/* harmony default export */ var FullQuestionnairevue_type_script_lang_js_ = ({
  name: "questionnaire",
  props: {
    /**
     *
     */
    filteredItemList: {
      type: Array
    },

    /**
     *
     */
    startCount: {
      type: Number
    },

    /**
     *
     */
    questionnaire: {
      type: Object,
      required: true
    },

    /**
     *
     */
    questionnaireResponse: {
      type: Object,
      default: null
    },

    /**
     *
     */
    requiredQuestionList: {
      type: Array
    },

    /**
     *
     */
    valueSets: {
      type: Array
    },

    /**
     *
     */
    baseUrl: {
      type: String
    },

    /**
     * Primary color
     */
    primary: {
      type: String
    },

    /**
     * Secondary color
     */
    secondary: {
      type: String
    },

    /**
     * Color used to symbolise danger
     */
    danger: {
      type: String
    },
    language: {
      type: Object
    },

    /**
     *
     */
    spinner: {
      type: Object
    }
  },
  data: function data() {
    return {
      disabled: true,
      scrollToQuestion: true
    };
  },
  computed: {
    /**
     * Returns the total Number of Required Questions
     */
    numberOfRequiredQuestions: function numberOfRequiredQuestions() {
      var totalNumber = 0;

      if (this.filteredItemList) {
        for (var i = 0; i < this.filteredItemList.length; i++) {
          if (this.filteredItemList[i].required) {
            totalNumber++;
          }
        }
      }

      return totalNumber;
    },

    /**
     * Checks if not all required Question have been completed
     */
    notAllRequiredQuestionsCompleted: function notAllRequiredQuestionsCompleted() {
      return this.requiredQuestionList.length !== this.numberOfRequiredQuestions;
    },

    /**
     *
     */
    questionsList: function questionsList() {
      return this.filteredItemList.filter(function (question) {
        return question.type !== "group";
      });
    }
  },
  methods: {
    /**
     *
     */
    getGroupText: function getGroupText(currentQuestion) {
      var groupQuestion = this.filteredItemList.find(function (element) {
        return element.linkId === currentQuestion.groupId;
      });

      if (groupQuestion) {
        return groupQuestion.text;
      } else {
        return "";
      }
    },

    /**
     *
     */
    goToSummary: function goToSummary() {
      this.$emit("summary");
    },

    /**
     * Relays the Event from the question-components to the top-component
     */
    relayAnswer: function relayAnswer(object) {
      this.$emit("answer", object);
    },

    /**
     *
     */
    backToQuestionnaireList: function backToQuestionnaireList() {
      this.$emit("return");
    },

    /**
     * returns the position number of the given question
     */
    getQuestionIndex: function getQuestionIndex(question) {
      return this.questionsList.indexOf(question);
    }
  },
  updated: function updated() {
    if (this.startCount && this.scrollToQuestion) {
      this.scrollToQuestion = false;
      var elmnt = document.getElementById(this.startCount);
      elmnt.scrollIntoView();
    }
  },
  components: {
    Spinner: external_vue_simple_spinner_default.a,
    DisplayQuestion: DisplayQuestion,
    IntegerQuestion: IntegerQuestion,
    TimeQuestion: TimeQuestion,
    DateTimeQuestion: DateTimeQuestion,
    DecimalQuestion: DecimalQuestion,
    DateQuestion: DateQuestion,
    TextQuestion: TextQuestion,
    UrlQuestion: UrlQuestion,
    ChoiceQuestion: ChoiceQuestion,
    StringQuestion: StringQuestion,
    BooleanQuestion: BooleanQuestion,
    GroupQuestion: GroupQuestion
  }
});
// CONCATENATED MODULE: ./src/components/questionnaire/FullQuestionnaire.vue?vue&type=script&lang=js&
 /* harmony default export */ var questionnaire_FullQuestionnairevue_type_script_lang_js_ = (FullQuestionnairevue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/questionnaire/FullQuestionnaire.vue?vue&type=style&index=0&id=612ed1f2&lang=scss&scoped=true&
var FullQuestionnairevue_type_style_index_0_id_612ed1f2_lang_scss_scoped_true_ = __webpack_require__("48f4");

// CONCATENATED MODULE: ./src/components/questionnaire/FullQuestionnaire.vue






/* normalize component */

var FullQuestionnaire_component = normalizeComponent(
  questionnaire_FullQuestionnairevue_type_script_lang_js_,
  FullQuestionnairevue_type_template_id_612ed1f2_scoped_true_render,
  FullQuestionnairevue_type_template_id_612ed1f2_scoped_true_staticRenderFns,
  false,
  null,
  "612ed1f2",
  null
  
)

/* harmony default export */ var FullQuestionnaire = (FullQuestionnaire_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"465b08a6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/questionnaire/GroupsQuestionnaire.vue?vue&type=template&id=3cbd7814&scoped=true&
var GroupsQuestionnairevue_type_template_id_3cbd7814_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.questionnaire)?_c('div',{staticClass:"card"},[(_vm.spinner.loading)?_c('div',{staticClass:"center-vertical spinner"},[_c('spinner',{staticClass:"mt4",attrs:{"size":"large","message":_vm.spinner.message}})],1):_vm._e(),(!_vm.spinner.loading && _vm.getQuestionType === 'groupQuestion')?_c('div',{staticClass:"component-container container"},[_c(_vm.getQuestionType,{tag:"component",attrs:{"question":_vm.getQuestion,"mode":"GROUPS","questionnaireResponse":_vm.questionnaireResponse,"questionnaire":_vm.questionnaire,"valueSets":_vm.valueSets,"baseUrl":_vm.baseUrl,"primary":_vm.primary,"secondary":_vm.secondary,"danger":_vm.danger,"language":_vm.language,"filteredItemList":_vm.filteredItemList},on:{"answer":function($event){return _vm.relayAnswer($event)}}})],1):_c('div',{staticClass:"container"},[(!_vm.spinner.loading)?_c('div',{staticClass:"card"},[_c('div',{staticClass:"column card-body"},[_c(_vm.getQuestionType,{tag:"component",attrs:{"question":_vm.getQuestion,"mode":"GROUPS","questionnaireResponse":_vm.questionnaireResponse,"questionnaire":_vm.questionnaire,"valueSets":_vm.valueSets,"baseUrl":_vm.baseUrl,"primary":_vm.primary,"secondary":_vm.secondary,"danger":_vm.danger,"language":_vm.language},on:{"answer":function($event){return _vm.relayAnswer($event)}}})],1)]):_vm._e()]),(!_vm.spinner.loading)?_c('div',{staticClass:"bottom-container margin-bottom-container"},[(_vm.language)?_c('div',{staticClass:"button-container"},[((!this.editMode && this.count !== 0) || (!this.editMode && this.enableReturn && this.count === 0))?_c('button',{staticClass:"btn button btn-outline-primary btn-lg",attrs:{"type":"button"},on:{"click":_vm.countDown}},[_vm._v(" "+_vm._s(_vm.language.back)+" ")]):_vm._e(),(this.editMode || (this.count === 0 && !this.enablereturn))?_c('button',{staticClass:"btn button btn-outline-secondary btn-lg",attrs:{"type":"button","disabled":""}},[_vm._v(" "+_vm._s(_vm.language.back)+" ")]):_vm._e(),_c('div',{staticClass:"progress-counter large"},[_vm._v(" "+_vm._s(_vm.language.page)+" "+_vm._s(_vm.questionCount)+" "+_vm._s(_vm.language.of)+" "+_vm._s(_vm.numberOfQuestions)+" ")]),_c('div',{staticClass:"progress-counter small"},[_vm._v(_vm._s(_vm.questionCount)+" "+_vm._s(_vm.language.of)+" "+_vm._s(_vm.numberOfQuestions))]),_c('span',[(_vm.count <= _vm.filteredList.length - 1 && !_vm.disabled && !this.editMode)?_c('button',{staticClass:"button button btn-primary btn-lg",attrs:{"id":"return-button","type":"button"},on:{"click":_vm.countUp}},[_vm._v(" "+_vm._s(_vm.language.next)+" ")]):_vm._e(),(_vm.disabled)?_c('button',{staticClass:"button btn-secondary btn-lg",attrs:{"id":"disabed-return-button","type":"button","disabled":""}},[_vm._v(" "+_vm._s(_vm.language.next)+" ")]):_vm._e(),(this.editMode && !_vm.disabled)?_c('button',{staticClass:"button btn-primary btn-lg",attrs:{"id":"summary-button","type":"button"},on:{"click":function($event){return _vm.goToSummary()}}},[_vm._v(" "+_vm._s(_vm.language.accept)+" ")]):_vm._e()])]):_vm._e()]):_vm._e()]):_vm._e()}
var GroupsQuestionnairevue_type_template_id_3cbd7814_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/questionnaire/GroupsQuestionnaire.vue?vue&type=template&id=3cbd7814&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/questionnaire/GroupsQuestionnaire.vue?vue&type=script&lang=js&


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//














/* harmony default export */ var GroupsQuestionnairevue_type_script_lang_js_ = ({
  props: {
    /**
     *
     */
    filteredItemList: {
      type: Array
    },

    /**
     *
     */
    questionnaire: {
      type: Object,
      required: true
    },

    /**
     *
     */
    questionnaireResponse: {
      type: Object,
      default: null
    },

    /**
     *
     */
    requiredQuestionList: {
      type: Array
    },

    /**
     *
     */
    valueSets: {
      type: Array
    },

    /**
     *
     */
    baseUrl: {
      type: String
    },

    /**
     *
     */
    editMode: {
      type: Boolean,
      default: false
    },

    /**
     *
     */
    startCount: Number,

    /**
     *
     */
    lastQuestion: {
      type: Boolean,
      default: false
    },

    /**
     * Primary color
     */
    primary: {
      type: String
    },

    /**
     * Secondary color
     */
    secondary: {
      type: String
    },

    /**
     * Color used to symbolise danger
     */
    danger: {
      type: String
    },

    /**
     *
     */
    enableReturn: {
      type: Boolean,
      default: true
    },

    /**
     *
     */
    language: {
      type: Object
    },

    /**
     *
     */
    spinner: {
      type: Object
    }
  },
  data: function data() {
    return {
      scrollToQuestion: true,
      count: 0,
      questionCount: 1,
      disabled: false,
      currentQuestion: Object,
      lastquestion: false,
      enablereturn: true
    };
  },
  computed: {
    /**
     *
     */
    filteredList: function filteredList() {
      var newItemList = [];
      var lastMainGroupId = "";

      if (this.questionnaire && this.questionnaire.item && this.questionnaireResponse) {
        for (var i = 0; i < this.filteredItemList.length; i++) {
          if (this.filteredItemList && this.filteredItemList[i].type === "group" && !this.filteredItemList[i].groupId) {
            lastMainGroupId = this.filteredItemList[i].linkId;
            var group = util_questionnaireResponse.Item.create();
            group.linkId = this.filteredItemList[i].linkId;
            group.definition = this.filteredItemList[i].definition;
            group.text = this.filteredItemList[i].text;
            group.type = "group";
            newItemList.push(group);
          } else if (!this.filteredItemList[i].groupId) {
            newItemList.push(this.filteredItemList[i]);
          } else if (this.filteredItemList[i].groupId) {
            var result = newItemList.findIndex(function (item) {
              return item.linkId === lastMainGroupId;
            });

            if (result !== -1 && newItemList[result].item) {
              newItemList[result].item.push(this.filteredItemList[i]);
            }
          }
        }
      }

      return newItemList;
    },

    /**
     *
     */
    getQuestionType: function getQuestionType() {
      return this.getQuestionFromItemList().type + "Question";
    },

    /**
     *
     */
    getQuestion: function getQuestion() {
      return this.getQuestionFromItemList();
    },

    /**
     *
     */
    getLastQuestion: function getLastQuestion() {
      return this.lastQuestion;
    },

    /**
     * Returns the total Number of Required Questions
     */
    numberOfRequiredQuestions: function numberOfRequiredQuestions() {
      var totalNumber = 0;

      for (var i = 0; i < this.filteredList.length; i++) {
        if (this.filteredList[i].required) {
          totalNumber++;
        }
      }

      return totalNumber;
    },

    /**
     * Counts all Questions from ItemList excluding Groups
     */
    numberOfQuestions: function numberOfQuestions() {
      return this.filteredList.length;
    },

    /**
     * Checks if not all required Question have been completed
     */
    notAllRequiredQuestionsCompleted: function notAllRequiredQuestionsCompleted() {
      return this.requiredQuestionList.length !== this.numberOfRequiredQuestions(this.filteredList);
    }
  },
  methods: {
    /**
     *
     */
    goToSummary: function goToSummary() {
      this.$emit("summary");
    },

    /**
     * Relays the Event from the question-components to the top-component
     */
    relayAnswer: function relayAnswer(object) {
      this.$emit("answer", object);
    },

    /**
     *
     */
    scrollToTop: function scrollToTop() {
      window.scrollTo(0, 0);
    },

    /**
     * Returns the number of all required questions in the given list
     */
    numberOfRequiredQuestionsInItem: function numberOfRequiredQuestionsInItem(question) {
      var flatList = question.item;
      var totalNumber = 0;

      for (var i = 0; i < flatList.length; i++) {
        if (flatList[i].required) {
          totalNumber++;
        }
      }

      return totalNumber;
    },

    /**
     * Returns the positionnumber of the current question without groups
     */
    getQuestionPositionNumber: function getQuestionPositionNumber() {
      var positionnumber = 1;

      for (var i = 0; i < this.count; i++) {
        // if (this.itemList[i].type !== "group") {
        positionnumber++; // }
      }

      return positionnumber;
    },

    /**
     * Returns a Question from the itemList
     */
    getQuestionFromItemList: function getQuestionFromItemList() {
      return this.filteredList[this.count];
    },

    /**
     * Counts up the Question-Number
     */
    countUp: function countUp() {
      if (this.count < this.filteredList.length - 1 && !this.disabled && !this.editMode) {
        this.count++;
        this.questionCount = this.getQuestionPositionNumber();
        this.scrollToTop();
      } else if (this.count === this.filteredList.length - 1 && !this.disabled && !this.editMode) {
        this.$emit("finished");
      } else if (this.startCount !== null && this.editMode) {
        this.$emit("finished");
      }
    },

    /**
     * Counts down the Question-Number
     */
    countDown: function countDown() {
      //If count bigger than 0 and startCount is null
      if (this.count > 0 && !this.editMode) {
        this.count--; //update questionPositionNumber

        this.questionCount = this.getQuestionPositionNumber();
        this.scrollToTop(); //if count = 0 go back to Metadata
      } else if (this.count === 0) {
        this.$emit("return");
      }
    },

    /**
     *
     */
    setDisabled: function setDisabled() {
      this.disabled = false;
      var currentQuestion = this.getQuestion;
      var numberOfAnsweredRequiredQuestionsInItem = 0;

      if (currentQuestion) {
        if (currentQuestion.required || currentQuestion.type === "group" && this.numberOfRequiredQuestionsInItem(currentQuestion) > 0) {
          this.disabled = true;
        }

        for (var i = 0; i < this.requiredQuestionList.length; i++) {
          if (currentQuestion.type === "group") {
            for (var e = 0; e < currentQuestion.item.length; e++) {
              if (this.requiredQuestionList[i].groupId && this.requiredQuestionList[i].groupId === currentQuestion.item[e].groupId) {
                if (currentQuestion.item[e].required) {
                  this.disabled = true;
                }

                if (this.requiredQuestionList[i] === currentQuestion.item[e]) {
                  this.disabled = false;
                  numberOfAnsweredRequiredQuestionsInItem++;
                }
              }
            } //TODO check if all questions are answered, else set disabled to true


            if (numberOfAnsweredRequiredQuestionsInItem !== this.numberOfRequiredQuestionsInItem(currentQuestion)) {
              this.disabled = true;
            } else {
              this.disabled = false;
            }
          } else if (this.requiredQuestionList[i] === currentQuestion) {
            this.disabled = false;
          }
        }
      }
    }
  },
  watch: {
    questionnaire: function questionnaire() {
      this.count = 0;
    },
    count: function count() {
      this.setDisabled();
    },
    requiredQuestionList: function requiredQuestionList() {
      this.setDisabled();
    },
    questionnaireResponse: function questionnaireResponse() {
      this.setDisabled();
    },
    filteredList: {
      deep: true,
      handler: function handler() {
        this.setDisabled();
      }
    },
    editMode: function editMode() {
      if (this.editMode) {
        this.enablereturn = false;
      } else {
        this.enablereturn = true;
      }
    }
  },
  updated: function updated() {
    if (this.lastquestion && this.filteredList && this.filteredList.length > 0) {
      this.count = this.filteredList.length - 1;
      this.lastquestion = false;
      this.questionCount = this.getQuestionPositionNumber();
    }

    if (this.startCount && this.editMode && this.filteredList && this.filteredList.length > 0) {
      this.count = this.startCount;
      this.questionCount = this.getQuestionPositionNumber();
    }
  },
  created: function created() {
    //sets count if startcount was given from the summarypage through the questionnaire.view
    if (this.startCount && this.filteredList && this.filteredList.length > 0) {
      this.count = this.startCount;
      this.questionCount = this.getQuestionPositionNumber();
    }

    this.lastquestion = this.lastQuestion;
    this.setDisabled();
  },
  components: {
    Spinner: external_vue_simple_spinner_default.a,
    displayQuestion: DisplayQuestion,
    integerQuestion: IntegerQuestion,
    timeQuestion: TimeQuestion,
    dateTimeQuestion: DateTimeQuestion,
    decimalQuestion: DecimalQuestion,
    dateQuestion: DateQuestion,
    textQuestion: TextQuestion,
    urlQuestion: UrlQuestion,
    choiceQuestion: ChoiceQuestion,
    stringQuestion: StringQuestion,
    booleanQuestion: BooleanQuestion,
    groupQuestion: GroupQuestion
  }
});
// CONCATENATED MODULE: ./src/components/questionnaire/GroupsQuestionnaire.vue?vue&type=script&lang=js&
 /* harmony default export */ var questionnaire_GroupsQuestionnairevue_type_script_lang_js_ = (GroupsQuestionnairevue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/questionnaire/GroupsQuestionnaire.vue?vue&type=style&index=0&id=3cbd7814&lang=scss&scoped=true&
var GroupsQuestionnairevue_type_style_index_0_id_3cbd7814_lang_scss_scoped_true_ = __webpack_require__("127b");

// CONCATENATED MODULE: ./src/components/questionnaire/GroupsQuestionnaire.vue






/* normalize component */

var GroupsQuestionnaire_component = normalizeComponent(
  questionnaire_GroupsQuestionnairevue_type_script_lang_js_,
  GroupsQuestionnairevue_type_template_id_3cbd7814_scoped_true_render,
  GroupsQuestionnairevue_type_template_id_3cbd7814_scoped_true_staticRenderFns,
  false,
  null,
  "3cbd7814",
  null
  
)

/* harmony default export */ var GroupsQuestionnaire = (GroupsQuestionnaire_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"465b08a6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/questionnaire/StepperQuestionnaire.vue?vue&type=template&id=640840c0&scoped=true&
var StepperQuestionnairevue_type_template_id_640840c0_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"column card-body"},[(_vm.spinner.loading && _vm.filteredItemList && _vm.count !== null)?_c('div',{staticClass:"center-vertical"},[_c('spinner',{staticClass:"mt4",attrs:{"size":"large","message":_vm.spinner.message}})],1):_vm._e(),(!_vm.spinner.loading)?_c('div',[_c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar",style:({
            width: (_vm.questionCount / _vm.numberOfQuestions) * 100 + '%'
          }),attrs:{"role":"progressbar","aria-valuenow":_vm.questionCount,"aria-valuemin":"1","aria-valuemax":_vm.numberOfQuestions}})]),_c('div',{staticClass:"progress-counter title"},[(_vm.language)?_c('span',{style:({ color: this.primary })},[_vm._v(" "+_vm._s(_vm.language.question)+" "+_vm._s(_vm.questionCount))]):_vm._e(),_vm._v("  "),(_vm.language)?_c('span',{staticClass:"color-grey"},[_vm._v(_vm._s(_vm.language.of)+" "+_vm._s(_vm.numberOfQuestions))]):_vm._e()]),(_vm.getQuestion.groupId && !_vm.getQuestion.item)?_c('div',{staticClass:"question-group-text"},[_vm._v(" "+_vm._s(_vm.getGroupText(_vm.getQuestion))+" ")]):_vm._e()]):_vm._e(),_c('br'),(!_vm.spinner.loading && _vm.count !== null && _vm.filteredItemList)?_c('div',[_c(_vm.getQuestionType,{key:_vm.getQuestion.id,tag:"component",attrs:{"question":_vm.getQuestion,"mode":"STEPPER","questionnaireResponse":_vm.questionnaireResponse,"questionnaire":_vm.questionnaire,"valueSets":_vm.valueSets,"baseUrl":_vm.baseUrl,"primary":_vm.primary,"secondary":_vm.secondary,"danger":_vm.danger,"language":_vm.language},on:{"next":_vm.countUp,"answer":function($event){return _vm.relayAnswer($event)}}})],1):_vm._e(),(!_vm.spinner.loading)?_c('div',{staticClass:"spacer"}):_vm._e(),(!_vm.spinner.loading && _vm.language)?_c('div',{staticClass:"button-container"},[((!this.editMode && this.count !== 0) || (!this.editMode && this.enableReturn && this.count === 0))?_c('button',{staticClass:"btn button btn-outline-primary btn-lg",attrs:{"type":"button"},on:{"click":_vm.countDown}},[_vm._v(" "+_vm._s(_vm.language.back)+" ")]):_vm._e(),(this.editMode || (this.count === 0 && !this.enableReturn))?_c('button',{staticClass:"btn button btn-outline-secondary btn-lg",attrs:{"type":"button","disabled":""}},[_vm._v(" "+_vm._s(_vm.language.back)+" ")]):_vm._e(),_c('span',[(_vm.count <= _vm.filteredItemList.length - 1 && !_vm.disabled && !this.editMode)?_c('button',{staticClass:"button btn-primary btn-lg",attrs:{"id":"next-button","type":"button"},on:{"click":_vm.countUp}},[_vm._v(" "+_vm._s(_vm.language.next)+" ")]):_vm._e(),(_vm.count < _vm.filteredItemList.length && _vm.disabled)?_c('button',{staticClass:"button btn-secondary btn-lg",attrs:{"id":"disabled-next-button","type":"button","disabled":""}},[_vm._v(" "+_vm._s(_vm.language.next)+" ")]):_vm._e(),(this.editMode && !_vm.disabled)?_c('button',{staticClass:"button btn-primary btn-lg",attrs:{"id":"summary-button","type":"button"},on:{"click":function($event){return _vm.goToSummary()}}},[_vm._v(" "+_vm._s(_vm.language.accept)+" ")]):_vm._e()])]):_vm._e()])])}
var StepperQuestionnairevue_type_template_id_640840c0_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/questionnaire/StepperQuestionnaire.vue?vue&type=template&id=640840c0&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/questionnaire/StepperQuestionnaire.vue?vue&type=script&lang=js&




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













/* harmony default export */ var StepperQuestionnairevue_type_script_lang_js_ = ({
  props: {
    /**
     *
     */
    filteredItemList: {
      type: Array
    },

    /**
     *
     */
    questionnaire: {
      type: Object,
      required: true
    },

    /**
     *
     */
    questionnaireResponse: {
      type: Object,
      default: null
    },

    /**
     *
     */
    requiredQuestionList: {
      type: Array
    },

    /**
     *
     */
    valueSets: {
      type: Array
    },

    /**
     *
     */
    baseUrl: {
      type: String
    },

    /**
     *
     */
    editMode: {
      type: Boolean,
      default: false
    },

    /**
     *
     */
    startCount: Number,

    /**
     *
     */
    lastQuestion: {
      type: Boolean,
      default: false
    },

    /**
     * Primary color
     */
    primary: {
      type: String
    },

    /**
     * Secondary color
     */
    secondary: {
      type: String
    },

    /**
     * Color used to symbolise danger
     */
    danger: {
      type: String
    },

    /**
     *
     */
    enableReturn: {
      type: Boolean,
      default: true
    },

    /**
     *
     */
    language: {
      type: Object
    },

    /**
     *
     */
    spinner: {
      type: Object
    }
  },
  data: function data() {
    return {
      /**
       * Number representing the index in the questions-list
       */
      count: 0,

      /**
       * Number for visual count-representation
       */
      questionCount: 0,

      /**
       * If true disables the next-button
       */
      disabled: false,

      /**
       *
       */
      lastquestion: null,

      /**
       * If true enables the return button
       */
      enablereturn: true
    };
  },
  computed: {
    /**
     * Returns the Type of the current Question
     */
    getQuestionType: function getQuestionType() {
      var type = null;

      if (this.getQuestionFromItemList()) {
        type = this.getQuestionFromItemList().type + "Question";
      }

      return type;
    },

    /**
     *Returns the current Question
     */
    getQuestion: function getQuestion() {
      return this.getQuestionFromItemList();
    },

    /**
     *
     */
    getLastQuestion: function getLastQuestion() {
      return this.lastQuestion;
    },

    /**
     * Returns the total Number of Required Questions
     */
    numberOfRequiredQuestions: function numberOfRequiredQuestions() {
      var totalNumber = 0;

      if (this.filteredItemList) {
        for (var i = 0; i < this.filteredItemList.length; i++) {
          if (this.filteredItemList[i].required) {
            totalNumber++;
          }
        }
      }

      return totalNumber;
    },

    /**
     * Checks if not all required Question have been completed
     */
    notAllRequiredQuestionsCompleted: function notAllRequiredQuestionsCompleted() {
      return this.requiredQuestionList.length !== this.numberOfRequiredQuestions;
    },

    /**
     * Counts all Questions from ItemList excluding Groups
     */
    numberOfQuestions: function numberOfQuestions() {
      var number = 0;

      for (var i = 0; i < this.filteredItemList.length; i++) {
        if (this.filteredItemList[i].type !== "group") {
          number++;
        }
      }

      return number;
    }
  },
  methods: {
    /**
     *
     */
    getGroupText: function getGroupText(currentQuestion) {
      var groupQuestion = this.filteredItemList.find(function (element) {
        return element.linkId === currentQuestion.groupId;
      });

      if (groupQuestion) {
        return groupQuestion.text;
      } else {
        return "";
      }
    },

    /**
     *
     */
    goToSummary: function goToSummary() {
      this.$emit("summary");
    },

    /**
     * Relays the Event from the question-components to the top-component
     */
    relayAnswer: function relayAnswer(object) {
      this.$emit("answer", object);
    },

    /**
     * Returns a Question from the itemList
     */
    getQuestionFromItemList: function getQuestionFromItemList() {
      return this.filteredItemList[this.count];
    },

    /**
     * Returns the positionnumber of the current question without groups
     */
    getQuestionPositionNumber: function getQuestionPositionNumber() {
      var positionnumber = 1;

      for (var i = 0; i < this.count; i++) {
        if (this.filteredItemList[i].type !== "group") {
          positionnumber++;
        }
      }

      return positionnumber;
    },

    /**
     *
     */
    scrollToTop: function scrollToTop() {
      window.scrollTo(0, 0);
    },

    /**
     * Counts up the Question-Number
     */
    countUp: function countUp() {
      if (this.count < this.filteredItemList.length - 1 && !this.disabled && !this.editMode) {
        //next button
        this.count++;

        if (this.filteredItemList[this.count].type !== "group") {
          this.questionCount = this.getQuestionPositionNumber();
        }

        this.scrollToTop();
      } else if (this.count === this.filteredItemList.length - 1 && !this.disabled && !this.editMode) {
        this.$emit("finished");
      } else if (this.startCount !== null && this.editMode) {
        this.$emit("finished");
      }
    },

    /**
     * Counts down the Question-Number
     */
    countDown: function countDown() {
      //If count bigger than 0 and startCount is null
      if (this.count > 0 && !this.editMode) {
        this.count--; //update questionPositionNumber

        if (this.filteredItemList[this.count].type !== "group") {
          this.questionCount = this.getQuestionPositionNumber();
        } else if (this.filteredItemList[this.count].type === "group" && this.questionCount === 1) {
          this.questionCount = 0;
        }

        this.scrollToTop(); //if count = 0 go back to Metadata
      } else if (this.count === 0) {
        this.$emit("return");
      }
    },

    /**
     *
     */
    setDisabled: function setDisabled() {
      //Set questionCount to 1 if first Question is not a group
      if (this.filteredItemList) {
        if (this.filteredItemList[this.count] && this.filteredItemList[this.count].type !== "group" && this.count === 0) {
          this.questionCount = 1;
        }

        this.disabled = false;
        var currentQuestion = this.getQuestion;

        if (currentQuestion && currentQuestion.required) {
          this.disabled = true;

          for (var i = 0; i < this.requiredQuestionList.length; i++) {
            if ( // this.requiredQuestionList[i] === currentQuestion
            JSON.stringify(this.requiredQuestionList[i]) === JSON.stringify(currentQuestion)) {
              this.disabled = false;
            }
          }
        }
      }
    }
  },
  watch: {
    questionnaire: function questionnaire() {
      this.count = 0;
    },
    count: function count() {
      this.setDisabled();
    },
    requiredQuestionList: function requiredQuestionList() {
      this.setDisabled();
    },
    questionnaireResponse: function questionnaireResponse() {
      this.setDisabled();
    },
    filteredItemList: {
      deep: true,
      handler: function handler() {
        if (this.filteredItemList[this.count].type !== "group" && this.count === 0) {
          // this.questionCount = 1;
          this.questionCount = this.getQuestionPositionNumber();
        }

        this.setDisabled();
      }
    },
    editMode: function editMode() {
      if (this.editMode) {
        this.enablereturn = false;
      } else {
        this.enablereturn = true;
      }
    }
  },
  updated: function updated() {
    if (this.lastquestion && this.filteredItemList && this.filteredItemList.length > 0) {
      this.count = this.filteredItemList.length - 1;
      this.lastquestion = false;
      this.questionCount = this.getQuestionPositionNumber();
    }

    if (this.startCount && this.editMode && this.filteredItemList && this.filteredItemList.length > 0) {
      this.count = this.startCount;
      this.questionCount = this.getQuestionPositionNumber();
    }
  },
  created: function created() {
    //sets count if startcount was given from the summarypage through the questionnaire.view
    if (this.startCount && this.filteredItemList && this.filteredItemList.length > 0) {
      this.count = this.startCount;
      this.questionCount = this.getQuestionPositionNumber();
    } else if (this.lastquestion === true && this.filteredItemList && this.filteredItemList.length > 0) {
      this.count = this.filteredItemList.length - 1;
      this.lastquestion = false;
      this.questionCount = this.getQuestionPositionNumber();
    }

    this.lastquestion = this.lastQuestion;
    this.setDisabled();
  },
  components: {
    Spinner: external_vue_simple_spinner_default.a,
    displayQuestion: DisplayQuestion,
    integerQuestion: IntegerQuestion,
    timeQuestion: TimeQuestion,
    dateTimeQuestion: DateTimeQuestion,
    decimalQuestion: DecimalQuestion,
    dateQuestion: DateQuestion,
    textQuestion: TextQuestion,
    urlQuestion: UrlQuestion,
    choiceQuestion: ChoiceQuestion,
    stringQuestion: StringQuestion,
    booleanQuestion: BooleanQuestion,
    groupQuestion: GroupQuestion
  }
});
// CONCATENATED MODULE: ./src/components/questionnaire/StepperQuestionnaire.vue?vue&type=script&lang=js&
 /* harmony default export */ var questionnaire_StepperQuestionnairevue_type_script_lang_js_ = (StepperQuestionnairevue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/questionnaire/StepperQuestionnaire.vue?vue&type=style&index=0&id=640840c0&lang=scss&scoped=true&
var StepperQuestionnairevue_type_style_index_0_id_640840c0_lang_scss_scoped_true_ = __webpack_require__("1ee0");

// CONCATENATED MODULE: ./src/components/questionnaire/StepperQuestionnaire.vue






/* normalize component */

var StepperQuestionnaire_component = normalizeComponent(
  questionnaire_StepperQuestionnairevue_type_script_lang_js_,
  StepperQuestionnairevue_type_template_id_640840c0_scoped_true_render,
  StepperQuestionnairevue_type_template_id_640840c0_scoped_true_staticRenderFns,
  false,
  null,
  "640840c0",
  null
  
)

/* harmony default export */ var StepperQuestionnaire = (StepperQuestionnaire_component.exports);
// CONCATENATED MODULE: ./src/util/valueSetController.js






/**
 * Returns all ValueSets needed for the currently stored questionnaires. This Method takes all Questionnaires
 * and gets all valueSet references. These references are then used to fetch the ValueSets.
 * @param {Array} questionnaireList
 * @param {*} FHIR_URL
 */

function getNewValueSets(_x, _x2) {
  return _getNewValueSets.apply(this, arguments);
}
/**
 * Returns alle Questions with a ValueSet
 * @param {Array} fullQuestionsList List with all questions
 */


function _getNewValueSets() {
  _getNewValueSets = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(questionnaireList, FHIR_URL) {
    var questionsValueSetList, fullQuestionsList, referenceList, i;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!questionnaireList) {
              _context.next = 16;
              break;
            }

            questionsValueSetList = [];
            fullQuestionsList = [];
            referenceList = []; //get flat itemList

            for (i = 0; i < questionnaireList.length; i++) {
              fullQuestionsList.push(questionnaireResponseController.createItemList(questionnaireList[i]));
            } //get all questions with valueset


            questionsValueSetList = getQuestionsWithValueSet(fullQuestionsList); //put all References in Array, avoid doubles

            referenceList = getReferencesFromValueSets(questionsValueSetList); //load all ValueSets and return the List

            if (!FHIR_URL) {
              _context.next = 13;
              break;
            }

            _context.next = 10;
            return getValueSetsWithReferences(FHIR_URL, referenceList);

          case 10:
            return _context.abrupt("return", _context.sent);

          case 13:
            throw new Error("The given FHIR_URL was null or undefined");

          case 14:
            _context.next = 17;
            break;

          case 16:
            throw new Error("The given QuestionnaireList was null or undefined");

          case 17:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _getNewValueSets.apply(this, arguments);
}

function getQuestionsWithValueSet(fullQuestionsList) {
  var list = [];

  for (var e = 0; e < fullQuestionsList.length; e++) {
    var questions = fullQuestionsList[e];

    for (var l = 0; l < questions.length; l++) {
      var question = questions[l];

      if (question.answerValueSet && !question.answerValueSet.startsWith("#")) {
        list.push(question);
      }
    }
  }

  return list;
}
/**
 * Returns a list of References ,avoiding duplicates
 * @param {Array} questionsValueSetList List with all questions that contain ValueSets
 */


function getReferencesFromValueSets(questionsValueSetList) {
  var list = [];

  if (questionsValueSetList) {
    for (var u = 0; u < questionsValueSetList.length; u++) {
      var reference = questionsValueSetList[u].answerValueSet;
      var push = true; //check for doubles

      for (var h = 0; h < list.length; h++) {
        if (reference === list[h]) {
          push = false;
        }
      }

      if (push) {
        list.push(reference);
      }
    }
  }

  return list;
}
/**
 * Fetches all ValueSets with their references
 * @param {*} FHIR_URL baseUrl
 * @param {*} referenceList List of valueSet-references
 */


function getValueSetsWithReferences(_x3, _x4) {
  return _getValueSetsWithReferences.apply(this, arguments);
}

function _getValueSetsWithReferences() {
  _getValueSetsWithReferences = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(FHIR_URL, referenceList) {
    var list, o, valueSetBundle, valueSet;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            list = [];
            _context2.prev = 1;
            o = 0;

          case 3:
            if (!(o < referenceList.length)) {
              _context2.next = 11;
              break;
            }

            _context2.next = 6;
            return fhir_api_["fetchByUrl"](FHIR_URL + "/ValueSet?url=" + referenceList[o]);

          case 6:
            valueSetBundle = _context2.sent;

            if (valueSetBundle.data.entry) {
              valueSet = valueSetBundle.data.entry[0].resource;
              list.push(valueSet);
            }

          case 8:
            o++;
            _context2.next = 3;
            break;

          case 11:
            return _context2.abrupt("return", list);

          case 14:
            _context2.prev = 14;
            _context2.t0 = _context2["catch"](1);
            throw new Error(_context2.t0.message);

          case 17:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[1, 14]]);
  }));
  return _getValueSetsWithReferences.apply(this, arguments);
}

/* harmony default export */ var valueSetController = ({
  getNewValueSets: getNewValueSets,
  getQuestionsWithValueSet: getQuestionsWithValueSet,
  getReferencesFromValueSets: getReferencesFromValueSets,
  getValueSetsWithReferences: getValueSetsWithReferences
});
// CONCATENATED MODULE: ./src/i18n/de.js
var de = {
  mandatory_question: "Dies ist eine Pflichtfrage",
  summary: "Zusammenfassung",
  backtoSummary: "Zurück zur Zusammenfassung",
  questionDeactivated: "Die ausgewählte Frage ist deaktiviert oder konnte nicht gefunden werden.",
  question: "Frage",
  of: "von",
  placeholder: "Hier Antwort eingeben",
  questionGroup: "Fragengruppe",
  page: "Seite",
  accept: "Änderung übernehmen",
  back: "Zurück",
  next: "Weiter",
  yes: "Ja",
  no: "Nein",
  loading: {
    data: "Lade Daten",
    questionnaire: "Lade Fragebogen",
    valueset: "Lade ValueSets"
  },
  url: {
    text: "Geben Sie hier die Url ein",
    invalid: "Die angegebene Url ist nicht korrekt.",
    valid: "Die angegebene Url ist korrekt."
  },
  time: {
    text: "Geben Sie hier die Zeit ein"
  },
  text: {
    text: "Geben Sie hier den Text ein"
  },
  integer: {
    text: "Geben Sie hier die Zahl ein",
    invalid: "Die von Ihnen angegebene Zahl ist nicht gültig."
  },
  decimal: {
    text: "Geben Sie hier die Zahl ein",
    invalid: "Die von Ihnen angegebene Zahl ist nicht gültig."
  },
  date: {
    text: "Geben Sie hier das Datum ein"
  }
};
/* harmony default export */ var i18n_de = (de);
// CONCATENATED MODULE: ./src/i18n/en.js
var en = {
  mandatory_question: "This is a mandatory question",
  summary: "Summary",
  backtoSummary: "Back to summary",
  questionDeactivated: "The selected question is deactivated or was not found",
  question: "Question",
  of: "of",
  questionGroup: "Question group",
  page: "Page",
  accept: "Accept change",
  back: "Back",
  next: "Next",
  yes: "yes",
  no: "no",
  loading: {
    data: "Loading Data",
    questionnaire: "Loading Questionnaire",
    valueset: "Loading Valuesets"
  },
  url: {
    text: "Enter the url here",
    invalid: "The specified URL was not correct.",
    valid: "The specified URL was correct."
  },
  time: {
    text: "Enter the time here"
  },
  text: {
    text: "Enter the text here"
  },
  integer: {
    text: "Enter the number here",
    invalid: "The specified number was not correct."
  },
  decimal: {
    text: "Enter the number here",
    invalid: "The specified number was not correct."
  },
  date: {
    text: "Enter the date here"
  }
};
/* harmony default export */ var i18n_en = (en);
// CONCATENATED MODULE: ./src/i18n/es.js
var es = {
  mandatory_question: "Esta es una pregunta obligatoria",
  summary: "Resumen",
  backtoSummary: "Volver al resumen",
  questionDeactivated: "La pregunta seleccionada está desactivada o no se encontró",
  question: "Pregunta",
  of: "de",
  questionGroup: "Grupo de preguntas",
  page: "Página",
  accept: "Aceptar el cambio",
  back: "Atrás",
  next: "Siguiente",
  yes: "sí",
  no: "no",
  loading: {
    data: "Cargando datos",
    questionnaire: "Cargando cuestionario",
    valueset: "Carga de conjuntos de valores"
  },
  url: {
    text: "Ingrese la url aquí",
    invalid: "La URL especificada no es correcta.",
    valid: "La URL especificada era correcta."
  },
  time: {
    text: "Ingrese la hora aquí"
  },
  text: {
    text: "Ingrese el texto aquí"
  },
  integer: {
    text: "Ingrese el número aquí",
    invalid: "El número especificado no es correcto."
  },
  decimal: {
    text: "Ingrese el número aquí",
    invalid: "El número especificado no es correcto."
  },
  date: {
    text: "Ingrese la fecha aquí"
  }
};
/* harmony default export */ var i18n_es = (es);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/QuestionnaireRenderer.vue?vue&type=script&lang=js&











//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










 // @group Questionnaire

/* harmony default export */ var QuestionnaireRenderervue_type_script_lang_js_ = ({
  components: {
    Spinner: external_vue_simple_spinner_default.a,
    FullQuestionnaire: FullQuestionnaire,
    StepperQuestionnaire: StepperQuestionnaire,
    GroupedQuestionnaire: GroupsQuestionnaire
  },
  props: {
    /**
     * FHIR-Resource QuestionnaireResponse
     */
    questionnaireResponse: {
      type: Object,
      default: null
    },

    /**
     * FHIR-Resource Questionnaire
     */
    questionnaire: {
      type: Object,
      default: null
    },

    /**
     * FHIR-Resource Patient
     */
    subject: {
      type: Object,
      default: null
    },

    /**
     * FHIR-Base Url
     */
    baseUrl: {
      type: String // required: true

    },

    /**
     * List of ValueSets that are needed to display the given questionnaire
     */
    valueSets: {
      type: Array,
      default: null
    },

    /**
     * Current type of Questionnaire-Style to display
     * Available: StepperQuestionnaire, GroupedQuestionnaire, FullQuestionnaire
     */
    mode: {
      type: String,
      default: "StepperQuestionnaire"
    },

    /**
     * The Url to fetch the Questionnaire from
     */
    questionnaireUrl: {
      type: String,
      default: null
    },

    /**
     * ID of the question in the ItemList where in the list of questions the renderer should start
     */
    startQuestion: {
      type: Object,
      default: null
    },

    /**
     * If true the render will show the button to exit the renderer
     */
    editMode: {
      type: Boolean,
      default: false
    },

    /**
     * Enable the return-button to exit the render-view
     */
    enableReturn: {
      type: Boolean,
      default: true
    },

    /**
     * If true, the Renderer will show the last question
     */
    lastQuestion: {
      type: Boolean,
      default: false
    },

    /**
     * Primary color
     */
    primary: {
      type: String
    },

    /**
     * Secondary color
     */
    secondary: {
      type: String
    },

    /**
     * Color used to symbolise danger
     */
    danger: {
      type: String,
      default: "red"
    },

    /**
     * Current locale
     */
    locale: {
      type: String,
      default: "de"
    },

    /**
     * Text for back-button
     */
    back: {
      type: String
    },

    /**
     * Text for next-button
     */
    next: {
      type: String
    }
  },
  data: function data() {
    return {
      filteredItemList: [],
      answeredRequiredQuestionsList: [],
      currentMode: null,
      currentQuestionnaireResponse: null,
      currentQuestionnaire: null,
      currentValueSets: [],
      currentStartCount: null,
      lastAnsweredQuestion: null,
      language: null,
      spinner: {
        loading: true,
        message: ""
      },
      modal: false
    };
  },
  computed: {
    /**
     * Checks if there are already Answers in the QuestionnaireResponse
     */
    wasStarted: function wasStarted() {
      var returnValue = false;

      if (this.questionnaireResponse) {
        for (var i = 0; i < this.questionnaireResponse.item.length; i++) {
          if (this.questionnaireResponse.item[i]) {
            returnValue = true;
          }
        }
      }

      return returnValue;
    }
  },
  watch: {
    mode: function mode() {
      if (this.currentMode && this.mode !== this.currentMode) {
        this.handleStartQuestion(this.lastAnsweredQuestion);
      }

      this.currentMode = this.mode;
    },
    questionnaire: function questionnaire() {
      this.handleQuestionnaireResponse();
    },
    questionnaireResponse: function questionnaireResponse() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.handleQuestionnaireResponse();

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    locale: function locale() {
      this.handlei18n();
    },
    currentQuestionnaireResponse: {
      deep: true,
      handler: function () {
        var _handler = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.next = 2;
                  return this.filterItemList();

                case 2:
                  this.handleAnsweredQuestionsList();
                  this.$emit("updated", this.currentQuestionnaireResponse);

                case 4:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, this);
        }));

        function handler() {
          return _handler.apply(this, arguments);
        }

        return handler;
      }()
    }
  },
  methods: {
    handlei18n: function handlei18n() {
      switch (this.locale) {
        case "en":
          this.language = i18n_en;
          break;

        case "de":
          this.language = i18n_de;
          break;

        case "es":
          this.language = i18n_es;
          break;

        default:
          break;
      }

      if (this.back != null) {
        this.language.back = this.back;
      }

      if (this.next != null) {
        this.language.next = this.next;
      }
    },

    /**
     *
     */
    backToSummary: function backToSummary() {
      this.modal = false;
      this.$emit("finished", this.currentQuestionnaireResponse);
    },

    /**
     * Takes the given object, adds new answers to the curren QuestionnaireRespons and saves the question as the last answered Question
     */
    handleQuestionnaireResponseEvent: function handleQuestionnaireResponseEvent(object) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this2.lastAnsweredQuestion = object.question;
                _context3.next = 3;
                return questionnaireResponseController.addAnswersToQuestionnaireResponse(_this2.currentQuestionnaireResponse, object.question.linkId, object.value, object.type);

              case 3:
                _this2.currentQuestionnaireResponse = _context3.sent;

                _this2.handleAnsweredQuestionsList();

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },

    /**
     * Creates a new QuestionnaireResponse
     */
    createQuestionnaireResponse: function createQuestionnaireResponse() {
      this.currentQuestionnaireResponse = questionnaireResponseController.createQuestionnaireResponse(this.questionnaire, this.subject);
    },

    /**
     * Adds an Answer to a QuestionnaireResponse
     */
    addAnswerToQuestionnaireResponse: function addAnswerToQuestionnaireResponse(linkId, type, answers) {
      if (linkId && type && answers !== null) {
        this.currentQuestionnaireResponse = questionnaireResponseController.addAnswersToQuestionnaireResponse(this.currentQuestionnaireResponse, linkId, answers, type);
      }
    },

    /**
     * adds a required answered Question to the requiredAnsweredQuestionsList
     */
    addQuestionToRequiredAnsweredQuestionsList: function addQuestionToRequiredAnsweredQuestionsList(question) {
      if (question) {
        var requiredAnsweredQuestionsList = this.answeredRequiredQuestionsList;

        if (question.required) {
          var addQuestion = true;

          for (var i = 0; i < requiredAnsweredQuestionsList.length; i++) {
            if (JSON.stringify(requiredAnsweredQuestionsList[i]) === JSON.stringify(question)) {
              addQuestion = false;
            }
          }

          if (addQuestion) {
            requiredAnsweredQuestionsList.push(question);
          }
        }

        this.answeredRequiredQuestionsList = requiredAnsweredQuestionsList;
      } else {
        throw new Error("The given Question was ", question);
      }
    },

    /**
     * Removes a Question from the List of answered Questions
     * @param {Object} question Required Question that needs to be removed from the list of answered Questions
     */
    removeQuestionFromRequiredAnsweredQuestionsList: function removeQuestionFromRequiredAnsweredQuestionsList(question) {
      if (question) {
        var requiredAnsweredQuestionsList = this.answeredRequiredQuestionsList;

        if (question.required) {
          //check if question is already in the list and remove it
          for (var i = 0; i < requiredAnsweredQuestionsList.length; i++) {
            if (JSON.stringify(requiredAnsweredQuestionsList[i]) === JSON.stringify(question)) {
              requiredAnsweredQuestionsList.splice(i, 1);
            }
          }
        }

        this.answeredRequiredQuestionsList = requiredAnsweredQuestionsList;
      } else {
        throw new Error("The given Question was ", question);
      }
    },

    /**
     *
     */
    resetAnsweredQuestionsList: function resetAnsweredQuestionsList() {
      this.answeredRequiredQuestionsList = [];
    },

    /**
     * load Questionnaire if questionnaire is null and questionnaireUrl is given
     */
    handleQuestionnaire: function handleQuestionnaire() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var i, _i;

        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!_this3.questionnaire) {
                  _context4.next = 5;
                  break;
                }

                _this3.currentQuestionnaire = _this3.questionnaire; // Add Group-Ids to Questions in Groups

                for (i = 0; i < _this3.currentQuestionnaire.item.length; i++) {
                  if (_this3.currentQuestionnaire.item[i].type === "group") {
                    _this3.addGroupIdToItems(_this3.currentQuestionnaire.item[i].item, _this3.currentQuestionnaire.item[i].linkId);
                  }
                }

                _context4.next = 17;
                break;

              case 5:
                if (!_this3.questionnaireUrl) {
                  _context4.next = 17;
                  break;
                }

                _context4.prev = 6;
                _context4.next = 9;
                return fhir_api_["fetchByUrl"](_this3.questionnaireUrl);

              case 9:
                _this3.currentQuestionnaire = _context4.sent;

                // Add Group-Ids to Questions in Groups
                for (_i = 0; _i < _this3.currentQuestionnaire.item.length; _i++) {
                  if (_this3.currentQuestionnaire.item[_i].type === "group") {
                    _this3.addGroupIdToItems(_this3.currentQuestionnaire.item[_i].item, _this3.currentQuestionnaire.item[_i].linkId);
                  }
                }

                _context4.next = 15;
                break;

              case 13:
                _context4.prev = 13;
                _context4.t0 = _context4["catch"](6);

              case 15:
                _context4.next = 17;
                break;

              case 17:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, null, [[6, 13]]);
      }))();
    },

    /**
     * Adds GroupId to all Questions inside a Group.
     */
    addGroupIdToItems: function addGroupIdToItems(item, linkId) {
      for (var i = 0; i < item.length; i++) {
        item[i].groupId = linkId;

        if (item[i].type === "group") {
          this.addGroupIdToItems(item[i].item, item[i].linkId);
        }
      }
    },

    /**
     * Adds and Removes Questions from the requiredAnswersList
     */
    handleAnsweredQuestionsList: function handleAnsweredQuestionsList() {
      var _this4 = this;

      if (this.currentQuestionnaireResponse) {
        (function () {
          var qr = questionnaireResponseController.createItemList(_this4.currentQuestionnaireResponse);
          var aRQL = _this4.answeredRequiredQuestionsList;

          var _loop = function _loop(i) {
            var result = _this4.filteredItemList.find(function (element) {
              return element.linkId === qr[i].linkId;
            });

            if (result) {
              if (qr[i].answer && qr[i].answer.length >= 1) {
                _this4.addQuestionToRequiredAnsweredQuestionsList(_this4.filteredItemList[_this4.filteredItemList.findIndex(function (item) {
                  return item.linkId === qr[i].linkId;
                })]);
              } else {
                _this4.removeQuestionFromRequiredAnsweredQuestionsList(_this4.filteredItemList[_this4.filteredItemList.findIndex(function (item) {
                  return item.linkId === qr[i].linkId;
                })]);
              }
            } else {
              var questionToRemove = aRQL.find(function (element) {
                return element.linkId === qr[i].linkId;
              });

              if (questionToRemove) {
                _this4.removeQuestionFromRequiredAnsweredQuestionsList(questionToRemove);
              }
            }
          };

          for (var i = 0; i < qr.length; i++) {
            _loop(i);
          }
        })();
      }
    },

    /**
     *  Creates a new QuestionnaireResponse if no QuestionnaireResponse was given via props or the given questionnaire-reference-id
     *  does not match the id of the given questionnaire
     */
    handleQuestionnaireResponse: function handleQuestionnaireResponse() {
      if (this.questionnaireResponse) {
        var split = this.questionnaireResponse.questionnaire.split("/");
        var id = split[1];

        if (id === this.questionnaire.id) {
          this.currentQuestionnaireResponse = this.questionnaireResponse;
        } else {
          this.createQuestionnaireResponse();
        }
      } else {
        this.createQuestionnaireResponse();
      }
    },

    /**
     * Gets a list of all ValueSets needed to display the questionnaire, then compares the list to the list of valuesets
     * given as properties. If the lists are not the same or no valueSets were given, then new ValueSets will be fetched, added and used
     */
    handleValueSets: function handleValueSets() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var neededReferencesList, givenValueSetReferences, itemList, valueSets, missingReferences, i, push, a;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                neededReferencesList = [];
                givenValueSetReferences = [];
                itemList = questionnaireResponseController.createItemList(_this5.currentQuestionnaire);
                valueSets = valueSetController.getQuestionsWithValueSet(itemList);
                neededReferencesList = valueSetController.getReferencesFromValueSets(valueSets);
                givenValueSetReferences = valueSetController.getReferencesFromValueSets(_this5.valueSets);

                if (!_this5.valueSets) {
                  _context5.next = 19;
                  break;
                }

                missingReferences = [];

                for (i = 0; i < neededReferencesList.length; i++) {
                  push = true;

                  for (a = 0; a < givenValueSetReferences.length; a++) {
                    if (neededReferencesList[i] === givenValueSetReferences[a]) {
                      push = false;
                    }
                  }

                  if (push) {
                    missingReferences.push(neededReferencesList[i]);
                  }
                }

                _this5.currentValueSets.push(_this5.valueSets);

                if (!(missingReferences.length !== 0)) {
                  _context5.next = 17;
                  break;
                }

                if (!_this5.baseUrl) {
                  _context5.next = 17;
                  break;
                }

                _context5.t0 = _this5.currentValueSets;
                _context5.next = 15;
                return valueSetController.getValueSetsWithReferences(_this5.baseUrl, missingReferences);

              case 15:
                _context5.t1 = _context5.sent;

                _context5.t0.concat.call(_context5.t0, _context5.t1);

              case 17:
                _context5.next = 27;
                break;

              case 19:
                _context5.prev = 19;
                _context5.next = 22;
                return valueSetController.getNewValueSets([_this5.currentQuestionnaire], _this5.baseUrl);

              case 22:
                _this5.currentValueSets = _context5.sent;
                _context5.next = 27;
                break;

              case 25:
                _context5.prev = 25;
                _context5.t2 = _context5["catch"](19);

              case 27:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, null, [[19, 25]]);
      }))();
    },

    /**
     *
     */
    handleStartQuestion: function handleStartQuestion(question) {
      if (question && this.filteredItemList) {
        if (this.mode === "GroupedQuestionnaire") {
          var questionItem = null;

          for (var i = 0; i < this.filteredItemList.length; i++) {
            if (question.linkId === this.filteredItemList[i].linkId) {
              questionItem = this.filteredItemList[i];
            }
          }

          if (questionItem && questionItem.groupId) {
            var groupQuestion = this.getParentGroupQuestion(questionItem.groupId);
            this.handleCurrentStartCount(groupQuestion);
          } else {
            this.handleCurrentStartCount(question);
          }
        } else {
          this.handleCurrentStartCount(question);
        }
      }
    },

    /**
     * finds the index of the given question in the filtered ItemList and sets the startCount
     */
    handleCurrentStartCount: function handleCurrentStartCount(question) {
      if (this.mode === "GroupedQuestionnaire") {
        this.currentStartCount = this.questionnaire.item.findIndex(function (object) {
          return object.linkId === question.linkId;
        });
      } else {
        this.currentStartCount = this.filteredItemList.findIndex(function (object) {
          return object.linkId === question.linkId;
        });
      }

      if (this.currentStartCount < 0) {
        this.modal = true;
        this.currentStartCount = 0;
      }
    },

    /**
     * Takes the given groupId and searches for the fitting Group-Question with the matching link-Id. If the Group-Question is in a Group itself, the Method will
     * call itself to find the parent Group-Question.
     *
     * @returns the parent groupQuestion
     */
    getParentGroupQuestion: function getParentGroupQuestion(groupId) {
      var parentQuestion = null;

      for (var i = 0; i < this.filteredItemList.length; i++) {
        if (this.filteredItemList[i].linkId === groupId) {
          if (this.filteredItemList[i].groupId) {
            parentQuestion = this.getParentGroupQuestion(this.filteredItemList[i].groupId);
          } else {
            parentQuestion = this.filteredItemList[i];
          }
        }
      }

      return parentQuestion;
    },

    /**
     *
     */
    filterItemList: function filterItemList() {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var newList;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                newList = [];

                if (!(_this6.currentQuestionnaireResponse && _this6.questionnaire)) {
                  _context6.next = 5;
                  break;
                }

                _context6.next = 4;
                return questionnaireController.handleEnableWhen(_this6.currentQuestionnaireResponse, _this6.currentQuestionnaire.item);

              case 4:
                newList = _context6.sent;

              case 5:
                _this6.filteredItemList = newList;

              case 6:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }))();
    },

    /**
     * Emits an Event wich includes the finished Questionnaire Response
     */
    finishQuestionnaire: function finishQuestionnaire() {
      this.$emit("finished", this.currentQuestionnaireResponse);
    },

    /**
     * Emits an Event to exit the Renderer
     */
    leaveQuestionnaireRenderer: function leaveQuestionnaireRenderer() {
      this.$emit("exit", this.currentQuestionnaireResponse);
    }
  },
  created: function created() {
    var _this7 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
      return regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _this7.spinner.loading = true;

              _this7.handlei18n();

              _this7.spinner.message = _this7.language.loading.questionnaire;
              _context7.next = 5;
              return _this7.handleQuestionnaire();

            case 5:
              _this7.spinner.message = _this7.language.loading.valueset;
              _context7.next = 8;
              return _this7.handleValueSets();

            case 8:
              _this7.spinner.message = _this7.language.loading.data;
              _context7.next = 11;
              return _this7.handleQuestionnaireResponse();

            case 11:
              _context7.next = 13;
              return _this7.filterItemList();

            case 13:
              _this7.handleAnsweredQuestionsList();

              _this7.currentMode = _this7.mode;

              _this7.handleStartQuestion(_this7.startQuestion);

              setTimeout(function () {
                _this7.spinner.loading = false;
              }, 250);

            case 17:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }))();
  }
});
// CONCATENATED MODULE: ./src/components/QuestionnaireRenderer.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_QuestionnaireRenderervue_type_script_lang_js_ = (QuestionnaireRenderervue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/QuestionnaireRenderer.vue?vue&type=style&index=0&id=4e53f25c&lang=scss&scoped=true&
var QuestionnaireRenderervue_type_style_index_0_id_4e53f25c_lang_scss_scoped_true_ = __webpack_require__("4849");

// CONCATENATED MODULE: ./src/components/QuestionnaireRenderer.vue






/* normalize component */

var QuestionnaireRenderer_component = normalizeComponent(
  components_QuestionnaireRenderervue_type_script_lang_js_,
  QuestionnaireRenderervue_type_template_id_4e53f25c_scoped_true_render,
  QuestionnaireRenderervue_type_template_id_4e53f25c_scoped_true_staticRenderFns,
  false,
  null,
  "4e53f25c",
  null
  
)

/* harmony default export */ var QuestionnaireRenderer = (QuestionnaireRenderer_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/QuestionnaireList.vue?vue&type=script&lang=js&
 // @group Lists

/* harmony default export */ var QuestionnaireListvue_type_script_lang_js_ = ({
  extends: BaseList,
  props: {
    detailPageName: {
      type: String,
      default: "questionnaire"
    },
    titleAttributes: {
      type: Array,
      default: function _default() {
        return [{
          value: "title",
          type: ""
        }];
      }
    },
    subtitleAttributes: {
      type: Array,
      default: function _default() {
        return [{
          value: "description",
          type: ""
        }, {
          value: "publisher",
          type: ""
        }];
      }
    },
    searchAttributes: {
      type: Array,
      default: function _default() {
        return [{
          name: "Title",
          value: "title"
        }];
      }
    }
  },
  data: function data() {
    return {
      resourceName: "Questionnaire"
    };
  }
});
// CONCATENATED MODULE: ./src/components/QuestionnaireList.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_QuestionnaireListvue_type_script_lang_js_ = (QuestionnaireListvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/QuestionnaireList.vue
var QuestionnaireList_render, QuestionnaireList_staticRenderFns




/* normalize component */

var QuestionnaireList_component = normalizeComponent(
  components_QuestionnaireListvue_type_script_lang_js_,
  QuestionnaireList_render,
  QuestionnaireList_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var QuestionnaireList = (QuestionnaireList_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"465b08a6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/resources/Patient-de-basis.vue?vue&type=template&id=1a32faf7&
var Patient_de_basisvue_type_template_id_1a32faf7_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"resource-form"},[_c('h2',[_vm._v("Patient")]),_c('fieldset',[_c('label',[_vm._v("Name")]),_c('dt-array',{attrs:{"resources":_vm.resourceData.name,"type":"DtHumanName-de-basis","edit":_vm.editMode},on:{"update:resources":function($event){return _vm.$set(_vm.resourceData, "name", $event)}}})],1),_c('dt-date',{attrs:{"value":_vm.resourceData.birthDate,"edit":_vm.editMode,"label":"Geburtsdatum"},on:{"update:value":function($event){return _vm.$set(_vm.resourceData, "birthDate", $event)}}}),_c('dt-code',{attrs:{"value":_vm.resourceData.gender,"edit":_vm.editMode,"label":"gender","valueSet":_vm.administrativeGender},on:{"update:value":function($event){return _vm.$set(_vm.resourceData, "gender", $event)}}}),_c('fieldset',[_c('label',[_vm._v("Identifier")]),_c('dt-array',{attrs:{"resources":_vm.resourceData.identifier,"type":"DtIdentifier","edit":_vm.editMode},on:{"update:resources":function($event){return _vm.$set(_vm.resourceData, "identifier", $event)}}})],1),_c('dt-boolean',{attrs:{"value":_vm.resourceData.active,"edit":_vm.editMode,"label":"active"},on:{"update:value":function($event){return _vm.$set(_vm.resourceData, "active", $event)}}}),_c('fieldset',[_c('label',[_vm._v("Telecom")]),_c('dt-array',{attrs:{"resources":_vm.resourceData.telecom,"type":"DtContactPoint","edit":_vm.editMode},on:{"update:resources":function($event){return _vm.$set(_vm.resourceData, "telecom", $event)}}})],1),_c('fieldset',[_c('label',[_vm._v("Adresse")]),_c('dt-array',{attrs:{"resources":_vm.resourceData.address,"type":"DtAddress-de-basis","edit":_vm.editMode},on:{"update:resources":function($event){return _vm.$set(_vm.resourceData, "address", $event)}}})],1),_c('button',{staticClass:"btn btn-secondary",on:{"click":_vm.toggleEditMode}},[_vm._v("Edit")])],1)}
var Patient_de_basisvue_type_template_id_1a32faf7_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/resources/Patient-de-basis.vue?vue&type=template&id=1a32faf7&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/resources/BaseResource.vue?vue&type=script&lang=js&
/* harmony default export */ var BaseResourcevue_type_script_lang_js_ = ({
  props: {
    resource: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      resourceData: null
    };
  },
  created: function created() {
    this.resourceData = this.resource;
  }
});
// CONCATENATED MODULE: ./src/components/resources/BaseResource.vue?vue&type=script&lang=js&
 /* harmony default export */ var resources_BaseResourcevue_type_script_lang_js_ = (BaseResourcevue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/resources/BaseResource.vue
var BaseResource_render, BaseResource_staticRenderFns




/* normalize component */

var BaseResource_component = normalizeComponent(
  resources_BaseResourcevue_type_script_lang_js_,
  BaseResource_render,
  BaseResource_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var BaseResource = (BaseResource_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"465b08a6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/data-types/helper/DtArray.vue?vue&type=template&id=56c83ae0&scoped=true&
var DtArrayvue_type_template_id_56c83ae0_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._l((_vm.resources),function(value,index){return _c('div',{key:index,staticClass:"entry"},[_c(_vm.type,{tag:"component",staticClass:"component",attrs:{"resource":value,"edit":_vm.edit},on:{"update:resource":function($event){value=$event}}}),(_vm.edit)?_c('div',[_c('button',{staticClass:"btn btn-link",on:{"click":function($event){return _vm.remove(index)}}},[_vm._t("default",function(){return [_vm._v("X")]})],2)]):_vm._e()],1)}),(_vm.edit)?_c('a',{attrs:{"href":"#"},on:{"click":function($event){return _vm.resources.push({})}}},[_vm._v(_vm._s(_vm.addString))]):_vm._e()],2)}
var DtArrayvue_type_template_id_56c83ae0_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/data-types/helper/DtArray.vue?vue&type=template&id=56c83ae0&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"465b08a6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/data-types/complex/DtAddress-de-basis.vue?vue&type=template&id=726dc48e&
var DtAddress_de_basisvue_type_template_id_726dc48e_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"form-row"},[_c('dt-code',{staticClass:"col-md-6",attrs:{"label":"use","value":_vm.resourceData.use,"valueSet":_vm.addressUse,"edit":_vm.edit},on:{"update:value":function($event){return _vm.$set(_vm.resourceData, "use", $event)}}}),_c('dt-code',{staticClass:"col-md-6",attrs:{"label":"type","value":_vm.resourceData.type,"valueSet":_vm.addressType,"edit":_vm.edit},on:{"update:value":function($event){return _vm.$set(_vm.resourceData, "type", $event)}}})],1),_c('div',{staticClass:"form-row"},[_c('dt-string',{staticClass:"col-md-3",attrs:{"label":"postalCode","value":_vm.resourceData.postalCode,"edit":_vm.edit},on:{"update:value":function($event){return _vm.$set(_vm.resourceData, "postalCode", $event)}}}),_c('dt-string',{staticClass:"col-md-9",attrs:{"label":"city","value":_vm.resourceData.city,"edit":_vm.edit},on:{"update:value":function($event){return _vm.$set(_vm.resourceData, "city", $event)}}})],1),_c('dt-string',{attrs:{"label":"state","value":_vm.resourceData.state,"edit":_vm.edit},on:{"update:value":function($event){return _vm.$set(_vm.resourceData, "state", $event)}}}),_c('dt-string',{attrs:{"label":"country","value":_vm.resourceData.country,"edit":_vm.edit},on:{"update:value":function($event){return _vm.$set(_vm.resourceData, "country", $event)}}}),_c('dt-period',{attrs:{"resource":_vm.resourceData.period,"edit":_vm.edit},on:{"update:resource":function($event){return _vm.$set(_vm.resourceData, "period", $event)}}})],1)}
var DtAddress_de_basisvue_type_template_id_726dc48e_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/data-types/complex/DtAddress-de-basis.vue?vue&type=template&id=726dc48e&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/data-types/complex/BaseDataType.vue?vue&type=script&lang=js&
/* harmony default export */ var BaseDataTypevue_type_script_lang_js_ = ({
  props: {
    resource: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    edit: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    resourceData: {
      get: function get() {
        return this.resource;
      }
    }
  },
  watch: {
    resourceData: {
      handler: function handler(newValue) {
        this.$emit("update:resource", newValue);
      },
      deep: true
    }
  }
});
// CONCATENATED MODULE: ./src/components/data-types/complex/BaseDataType.vue?vue&type=script&lang=js&
 /* harmony default export */ var complex_BaseDataTypevue_type_script_lang_js_ = (BaseDataTypevue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/data-types/complex/BaseDataType.vue
var BaseDataType_render, BaseDataType_staticRenderFns




/* normalize component */

var BaseDataType_component = normalizeComponent(
  complex_BaseDataTypevue_type_script_lang_js_,
  BaseDataType_render,
  BaseDataType_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var BaseDataType = (BaseDataType_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"465b08a6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/data-types/primitive/DtCode.vue?vue&type=template&id=92e800da&
var DtCodevue_type_template_id_92e800da_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.edit)?_c('div',{staticClass:"form-group"},[(_vm.label)?_c('label',{attrs:{"for":_vm.localId}},[_vm._v(_vm._s(_vm.label))]):_vm._e(),(_vm.valueSet)?_c('div',[(_vm.inputType === _vm.singleChoiceType.SELECT)?_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.localValue),expression:"localValue"}],staticClass:"form-control",class:{ 'is-invalid': _vm.invalid === true },staticStyle:{"background-position":"right calc(0.375em + 0.85rem) center"},attrs:{"id":_vm.localId},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.localValue=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"disabled":"","selected":""},domProps:{"value":undefined}},[_vm._v(_vm._s(_vm.selectText))]),_vm._l((_vm.valueSet.expansion.contains),function(v){return _c('option',{key:v.code,domProps:{"value":v.code}},[_vm._v(_vm._s(v.display))])})],2):_vm._l((_vm.valueSet.expansion.contains),function(v,i){return _c('div',{key:v.code,staticClass:"form-check"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.localValue),expression:"localValue"}],staticClass:"form-check-input",attrs:{"id":_vm.localId + '' + i,"type":"radio"},domProps:{"value":v.code,"checked":_vm._q(_vm.localValue,v.code)},on:{"change":function($event){_vm.localValue=v.code}}}),_c('label',{staticClass:"form-check-label",attrs:{"for":_vm.localId + '' + i}},[_vm._v(" "+_vm._s(v.display)+" ")])])})],2):_vm._e()]):_c('div',{staticClass:"form-group"},[(_vm.label)?_c('label',{attrs:{"for":_vm.localId}},[_vm._v(_vm._s(_vm.label))]):_vm._e(),(_vm.localValue)?_c('div',[_vm._v(" "+_vm._s(_vm.localValue)+" ")]):_c('div',[_vm._v("-")])])])}
var DtCodevue_type_template_id_92e800da_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/data-types/primitive/DtCode.vue?vue&type=template&id=92e800da&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"465b08a6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/data-types/primitive/DtBase.vue?vue&type=template&id=02f4599c&
var DtBasevue_type_template_id_02f4599c_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group"},[(_vm.label)?_c('label',{attrs:{"for":_vm.localId}},[_vm._v(_vm._s(_vm.label))]):_vm._e(),((_vm.type)==='checkbox'&&(_vm.edit))?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.localValue),expression:"localValue"}],staticClass:"form-control",class:{ 'is-invalid': _vm.invalid === true },attrs:{"id":_vm.localId,"placeholder":_vm.localPlaceholder,"max":_vm.max,"min":_vm.min,"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.localValue)?_vm._i(_vm.localValue,null)>-1:(_vm.localValue)},on:{"change":function($event){var $$a=_vm.localValue,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.localValue=$$a.concat([$$v]))}else{$$i>-1&&(_vm.localValue=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.localValue=$$c}}}}):((_vm.type)==='radio'&&(_vm.edit))?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.localValue),expression:"localValue"}],staticClass:"form-control",class:{ 'is-invalid': _vm.invalid === true },attrs:{"id":_vm.localId,"placeholder":_vm.localPlaceholder,"max":_vm.max,"min":_vm.min,"type":"radio"},domProps:{"checked":_vm._q(_vm.localValue,null)},on:{"change":function($event){_vm.localValue=null}}}):(_vm.edit)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.localValue),expression:"localValue"}],staticClass:"form-control",class:{ 'is-invalid': _vm.invalid === true },attrs:{"id":_vm.localId,"placeholder":_vm.localPlaceholder,"max":_vm.max,"min":_vm.min,"type":_vm.type},domProps:{"value":(_vm.localValue)},on:{"input":function($event){if($event.target.composing){ return; }_vm.localValue=$event.target.value}}}):_vm._e(),(!_vm.edit && _vm.localValue)?_c('div',[_vm._v(_vm._s(_vm.localValue))]):_vm._e(),(!_vm.edit && !_vm.localValue)?_c('div',[_vm._v("-")]):_vm._e()])}
var DtBasevue_type_template_id_02f4599c_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/data-types/primitive/DtBase.vue?vue&type=template&id=02f4599c&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/data-types/primitive/DtBase.vue?vue&type=script&lang=js&


//
//
//
//
//
//
//
//
//
/* harmony default export */ var DtBasevue_type_script_lang_js_ = ({
  props: {
    label: {
      type: String,
      required: true
    },
    value: {
      required: true
    },
    id: null,
    placeholder: {
      type: String
    },
    edit: {
      type: Boolean,
      default: false
    },
    invalid: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      type: "text",
      localId: ""
    };
  },
  computed: {
    localValue: {
      get: function get() {
        return this.value;
      },
      set: function set(newValue) {
        this.$emit("update:value", newValue);
      }
    },
    localPlaceholder: function localPlaceholder() {
      if (this.placeholder) {
        return this.placeholder;
      } else {
        return this.label;
      }
    }
  },
  created: function created() {
    if (this.id) {
      this.localId = this.id;
    } else {
      this.localId = "id-" + Math.random().toString(36).substr(2, 16);
    }
  }
});
// CONCATENATED MODULE: ./src/components/data-types/primitive/DtBase.vue?vue&type=script&lang=js&
 /* harmony default export */ var primitive_DtBasevue_type_script_lang_js_ = (DtBasevue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/data-types/primitive/DtBase.vue





/* normalize component */

var DtBase_component = normalizeComponent(
  primitive_DtBasevue_type_script_lang_js_,
  DtBasevue_type_template_id_02f4599c_render,
  DtBasevue_type_template_id_02f4599c_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var DtBase = (DtBase_component.exports);
// CONCATENATED MODULE: ./src/util/enums/single-choice-type.js

var single_choice_type_singleChoiceType = Object.freeze({
  SELECT: 1,
  RADIO: 2
});
/* harmony default export */ var single_choice_type = (single_choice_type_singleChoiceType);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/data-types/primitive/DtCode.vue?vue&type=script&lang=js&

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var DtCodevue_type_script_lang_js_ = ({
  extends: DtBase,
  props: {
    valueSet: {
      type: Object
    },
    selectText: {
      type: String,
      default: "Select one"
    },
    inputType: {
      type: Number,
      default: single_choice_type.SELECT
    }
  },
  computed: {
    singleChoiceType: function singleChoiceType() {
      return single_choice_type;
    }
  }
});
// CONCATENATED MODULE: ./src/components/data-types/primitive/DtCode.vue?vue&type=script&lang=js&
 /* harmony default export */ var primitive_DtCodevue_type_script_lang_js_ = (DtCodevue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/data-types/primitive/DtCode.vue





/* normalize component */

var DtCode_component = normalizeComponent(
  primitive_DtCodevue_type_script_lang_js_,
  DtCodevue_type_template_id_92e800da_render,
  DtCodevue_type_template_id_92e800da_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var DtCode = (DtCode_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"465b08a6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/data-types/complex/DtPeriod.vue?vue&type=template&id=9e5e16f8&
var DtPeriodvue_type_template_id_9e5e16f8_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('dt-date-time',{attrs:{"label":"start","value":_vm.resourceData.start,"edit":_vm.edit},on:{"update:value":function($event){return _vm.$set(_vm.resourceData, "start", $event)}}}),_c('dt-date-time',{attrs:{"label":"end","value":_vm.resourceData.end,"edit":_vm.edit},on:{"update:value":function($event){return _vm.$set(_vm.resourceData, "end", $event)}}})],1)}
var DtPeriodvue_type_template_id_9e5e16f8_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/data-types/complex/DtPeriod.vue?vue&type=template&id=9e5e16f8&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"465b08a6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/data-types/primitive/DtDateTime.vue?vue&type=template&id=87da8b8a&
var DtDateTimevue_type_template_id_87da8b8a_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-row"},[_c('div',{staticClass:"form-group col-md-4"},[_c('label',{attrs:{"for":_vm.localId}},[_vm._v(_vm._s(_vm.label))]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.localValue),expression:"localValue"}],staticClass:"form-control",attrs:{"type":"date","id":_vm.localId},domProps:{"value":(_vm.localValue)},on:{"input":function($event){if($event.target.composing){ return; }_vm.localValue=$event.target.value}}})]),_c('div',{staticClass:"form-group col-md-2"},[_c('label',{attrs:{"for":_vm.localId}},[_vm._v(" ")]),_c('input',{staticClass:"form-control",attrs:{"type":"time"}})]),_c('div',{staticClass:"form-group col-md-6"},[_c('label',{attrs:{"for":_vm.localId}},[_vm._v(" ")]),_vm._m(0)])])}
var DtDateTimevue_type_template_id_87da8b8a_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select',{staticClass:"form-control"},[_c('option',[_vm._v("1")]),_c('option',[_vm._v("2")]),_c('option',[_vm._v("3")])])}]


// CONCATENATED MODULE: ./src/components/data-types/primitive/DtDateTime.vue?vue&type=template&id=87da8b8a&

// EXTERNAL MODULE: external "moment-timezone"
var external_moment_timezone_ = __webpack_require__("4d72");
var external_moment_timezone_default = /*#__PURE__*/__webpack_require__.n(external_moment_timezone_);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/data-types/primitive/DtDateTime.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var DtDateTimevue_type_script_lang_js_ = ({
  extends: DtBase,
  computed: {
    localValue: {
      get: function get() {
        return this.value;
      },
      set: function set(newValue) {
        this.$emit("update:value", newValue);
      }
    }
  },
  created: function created() {
    this.type = "date";
    console.log(external_moment_timezone_default.a);
  }
});
// CONCATENATED MODULE: ./src/components/data-types/primitive/DtDateTime.vue?vue&type=script&lang=js&
 /* harmony default export */ var primitive_DtDateTimevue_type_script_lang_js_ = (DtDateTimevue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/data-types/primitive/DtDateTime.vue





/* normalize component */

var DtDateTime_component = normalizeComponent(
  primitive_DtDateTimevue_type_script_lang_js_,
  DtDateTimevue_type_template_id_87da8b8a_render,
  DtDateTimevue_type_template_id_87da8b8a_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var DtDateTime = (DtDateTime_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/data-types/complex/DtPeriod.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//


/* harmony default export */ var DtPeriodvue_type_script_lang_js_ = ({
  extends: BaseDataType,
  props: {
    resource: {
      type: Object,
      default: function _default() {
        return {
          start: undefined,
          end: undefined
        };
      }
    }
  },
  components: {
    DtDateTime: DtDateTime
  }
});
// CONCATENATED MODULE: ./src/components/data-types/complex/DtPeriod.vue?vue&type=script&lang=js&
 /* harmony default export */ var complex_DtPeriodvue_type_script_lang_js_ = (DtPeriodvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/data-types/complex/DtPeriod.vue





/* normalize component */

var DtPeriod_component = normalizeComponent(
  complex_DtPeriodvue_type_script_lang_js_,
  DtPeriodvue_type_template_id_9e5e16f8_render,
  DtPeriodvue_type_template_id_9e5e16f8_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var DtPeriod = (DtPeriod_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/data-types/primitive/DtString.vue?vue&type=script&lang=js&

/* harmony default export */ var DtStringvue_type_script_lang_js_ = ({
  extends: DtBase
});
// CONCATENATED MODULE: ./src/components/data-types/primitive/DtString.vue?vue&type=script&lang=js&
 /* harmony default export */ var primitive_DtStringvue_type_script_lang_js_ = (DtStringvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/data-types/primitive/DtString.vue
var DtString_render, DtString_staticRenderFns




/* normalize component */

var DtString_component = normalizeComponent(
  primitive_DtStringvue_type_script_lang_js_,
  DtString_render,
  DtString_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var DtString = (DtString_component.exports);
// EXTERNAL MODULE: ./src/assets/fhir/value-sets/address-use.json
var address_use = __webpack_require__("60d4");

// EXTERNAL MODULE: ./src/assets/fhir/value-sets/address-type.json
var address_type = __webpack_require__("93f7");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/data-types/complex/DtAddress-de-basis.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var DtAddress_de_basisvue_type_script_lang_js_ = ({
  extends: BaseDataType,
  computed: {
    addressUse: function addressUse() {
      return address_use;
    },
    addressType: function addressType() {
      return address_type;
    }
  },
  components: {
    DtCode: DtCode,
    DtPeriod: DtPeriod,
    DtString: DtString
  }
});
// CONCATENATED MODULE: ./src/components/data-types/complex/DtAddress-de-basis.vue?vue&type=script&lang=js&
 /* harmony default export */ var complex_DtAddress_de_basisvue_type_script_lang_js_ = (DtAddress_de_basisvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/data-types/complex/DtAddress-de-basis.vue





/* normalize component */

var DtAddress_de_basis_component = normalizeComponent(
  complex_DtAddress_de_basisvue_type_script_lang_js_,
  DtAddress_de_basisvue_type_template_id_726dc48e_render,
  DtAddress_de_basisvue_type_template_id_726dc48e_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var DtAddress_de_basis = (DtAddress_de_basis_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"465b08a6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/data-types/complex/DtContactPoint.vue?vue&type=template&id=7c7e295e&
var DtContactPointvue_type_template_id_7c7e295e_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('dt-code',{attrs:{"label":"use","value":_vm.resourceData.use,"valueSet":_vm.contactPointUse,"edit":_vm.edit},on:{"update:value":function($event){return _vm.$set(_vm.resourceData, "use", $event)}}}),_c('div',{staticClass:"form-row"},[_c('dt-code',{staticClass:"col-md-6",attrs:{"label":"system","value":_vm.resourceData.system,"valueSet":_vm.contactPointSystem,"edit":_vm.edit},on:{"update:value":function($event){return _vm.$set(_vm.resourceData, "system", $event)}}}),_c('dt-string',{staticClass:"col-md-6",attrs:{"label":"value","value":_vm.resourceData.value,"edit":_vm.edit},on:{"update:value":function($event){return _vm.$set(_vm.resourceData, "value", $event)}}})],1),_c('dt-period',{attrs:{"label":"period","resource":_vm.resourceData.period,"edit":_vm.edit},on:{"update:resource":function($event){return _vm.$set(_vm.resourceData, "period", $event)}}}),_c('pre',[_c('code',[_vm._v(_vm._s(_vm.resourceData))])])],1)}
var DtContactPointvue_type_template_id_7c7e295e_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/data-types/complex/DtContactPoint.vue?vue&type=template&id=7c7e295e&

// EXTERNAL MODULE: ./src/assets/fhir/value-sets/contact-point-system.json
var contact_point_system = __webpack_require__("dab1");

// EXTERNAL MODULE: ./src/assets/fhir/value-sets/contact-point-use.json
var contact_point_use = __webpack_require__("4c60");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/data-types/complex/DtContactPoint.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var DtContactPointvue_type_script_lang_js_ = ({
  extends: BaseDataType,
  computed: {
    contactPointSystem: function contactPointSystem() {
      return contact_point_system;
    },
    contactPointUse: function contactPointUse() {
      return contact_point_use;
    }
  },
  components: {
    DtCode: DtCode,
    DtPeriod: DtPeriod,
    DtString: DtString
  }
});
// CONCATENATED MODULE: ./src/components/data-types/complex/DtContactPoint.vue?vue&type=script&lang=js&
 /* harmony default export */ var complex_DtContactPointvue_type_script_lang_js_ = (DtContactPointvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/data-types/complex/DtContactPoint.vue





/* normalize component */

var DtContactPoint_component = normalizeComponent(
  complex_DtContactPointvue_type_script_lang_js_,
  DtContactPointvue_type_template_id_7c7e295e_render,
  DtContactPointvue_type_template_id_7c7e295e_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var DtContactPoint = (DtContactPoint_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"465b08a6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/data-types/complex/DtHumanName-de-basis.vue?vue&type=template&id=9381ab08&scoped=true&
var DtHumanName_de_basisvue_type_template_id_9381ab08_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.edit)?_c('div',[(_vm.viewUse)?_c('div',{staticClass:"form-row"},[_c('dt-code',{staticClass:"col-md-12",attrs:{"label":"Use","value":_vm.resourceData.use,"valueSet":_vm.nameUse,"edit":_vm.edit},on:{"update:value":function($event){return _vm.$set(_vm.resourceData, "use", $event)}}})],1):_vm._e(),_c('div',{staticClass:"form-row"},[_c('dt-string',{staticClass:"col-md-2",attrs:{"label":_vm.prefix,"value":_vm.resourceData.prefix,"edit":_vm.edit,"invalid":_vm.prefixInvalid},on:{"update:value":function($event){return _vm.$set(_vm.resourceData, "prefix", $event)}}}),_c('dt-string-array',{staticClass:"col-md-4",attrs:{"label":_vm.firstname,"value":_vm.resourceData.given,"edit":_vm.edit,"invalid":_vm.firstnameInvalid},on:{"update:value":function($event){return _vm.$set(_vm.resourceData, "given", $event)}}}),_c('dt-string',{staticClass:"col-md-4",attrs:{"label":_vm.lastname,"value":_vm.resourceData.family,"edit":_vm.edit,"invalid":_vm.lastnameInvalid},on:{"update:value":function($event){return _vm.$set(_vm.resourceData, "family", $event)}}}),_c('dt-string-array',{staticClass:"col-md-2",attrs:{"label":"Suffix","value":_vm.resourceData.suffix,"edit":_vm.edit,"invalid":_vm.suffixInvalid},on:{"update:value":function($event){return _vm.$set(_vm.resourceData, "suffix", $event)}}})],1)]):_c('div',[_c('div',[_vm._v(" "+_vm._s(_vm.getDisplayForArray(_vm.resourceData.prefix))+" "+_vm._s(_vm.getDisplayForArray(_vm.resourceData.given))+" "+_vm._s(_vm.resourceData.family)+" "+_vm._s(_vm.getDisplayForArray(_vm.resourceData.suffix))+" ")]),(_vm.viewUse)?_c('div',{staticClass:"text-muted"},[_vm._v(" "+_vm._s(_vm.getDisplayForCode(_vm.nameUse, _vm.resourceData.use))+" ")]):_vm._e()])])}
var DtHumanName_de_basisvue_type_template_id_9381ab08_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/data-types/complex/DtHumanName-de-basis.vue?vue&type=template&id=9381ab08&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/data-types/primitive/DtStringArray.vue?vue&type=script&lang=js&




/* harmony default export */ var DtStringArrayvue_type_script_lang_js_ = ({
  extends: DtString,
  props: {
    value: {
      type: Array
    }
  },
  computed: {
    localValue: {
      get: function get() {
        if (this.value) {
          return this.value.join(" ");
        } else {
          return "";
        }
      },
      set: function set(newValue) {
        this.$emit("update:value", newValue.split(" "));
      }
    }
  }
});
// CONCATENATED MODULE: ./src/components/data-types/primitive/DtStringArray.vue?vue&type=script&lang=js&
 /* harmony default export */ var primitive_DtStringArrayvue_type_script_lang_js_ = (DtStringArrayvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/data-types/primitive/DtStringArray.vue
var DtStringArray_render, DtStringArray_staticRenderFns




/* normalize component */

var DtStringArray_component = normalizeComponent(
  primitive_DtStringArrayvue_type_script_lang_js_,
  DtStringArray_render,
  DtStringArray_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var DtStringArray = (DtStringArray_component.exports);
// EXTERNAL MODULE: ./src/assets/fhir/value-sets/name-use.json
var name_use = __webpack_require__("4a9f");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/data-types/complex/DtHumanName-de-basis.vue?vue&type=script&lang=js&



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var DtHumanName_de_basisvue_type_script_lang_js_ = ({
  extends: BaseDataType,
  props: {
    firstname: {
      type: String,
      default: "Firstname"
    },
    lastname: {
      type: String,
      default: "Lastname"
    },
    prefix: {
      type: String,
      default: "Prefix"
    },
    viewUse: {
      type: Boolean,
      default: false
    },
    firstnameInvalid: {
      type: Boolean,
      default: false
    },
    lastnameInvalid: {
      type: Boolean,
      default: false
    },
    prefixInvalid: {
      type: Boolean,
      default: false
    },
    suffixInvalid: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    nameUse: function nameUse() {
      return name_use;
    } // text() {
    //   return this.resourceData
    //     ? this.resourceData.prefix +
    //         " " +
    //         this.resourceData.given.join(" ") +
    //         " " +
    //         this.resourceData.family
    //     : "";
    // }

  },
  watch: {
    text: function text(newText) {
      this.resourceData.text = newText;
    }
  },
  methods: {
    getDisplayForCode: function getDisplayForCode(valueSet, code) {
      var valueSetItem = valueSet.expansion.contains.find(function (v) {
        return v.code === code;
      });

      if (valueSetItem) {
        return valueSetItem.display;
      }

      return undefined;
    },
    getDisplayForArray: function getDisplayForArray(array) {
      if (array && Array.isArray(array)) {
        return array.join(" ");
      } else {
        return "";
      }
    }
  },
  components: {
    DtCode: DtCode,
    DtString: DtString,
    DtStringArray: DtStringArray
  }
});
// CONCATENATED MODULE: ./src/components/data-types/complex/DtHumanName-de-basis.vue?vue&type=script&lang=js&
 /* harmony default export */ var complex_DtHumanName_de_basisvue_type_script_lang_js_ = (DtHumanName_de_basisvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/data-types/complex/DtHumanName-de-basis.vue?vue&type=style&index=0&id=9381ab08&lang=scss&scoped=true&
var DtHumanName_de_basisvue_type_style_index_0_id_9381ab08_lang_scss_scoped_true_ = __webpack_require__("9cd7");

// CONCATENATED MODULE: ./src/components/data-types/complex/DtHumanName-de-basis.vue






/* normalize component */

var DtHumanName_de_basis_component = normalizeComponent(
  complex_DtHumanName_de_basisvue_type_script_lang_js_,
  DtHumanName_de_basisvue_type_template_id_9381ab08_scoped_true_render,
  DtHumanName_de_basisvue_type_template_id_9381ab08_scoped_true_staticRenderFns,
  false,
  null,
  "9381ab08",
  null
  
)

/* harmony default export */ var DtHumanName_de_basis = (DtHumanName_de_basis_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"465b08a6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/data-types/complex/DtIdentifier.vue?vue&type=template&id=2dd78c0b&
var DtIdentifiervue_type_template_id_2dd78c0b_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.edit)?_c('div',[_c('dt-code',{attrs:{"label":"use","value":_vm.resourceData.use,"valueSet":_vm.identifierUse,"edit":_vm.edit},on:{"update:value":function($event){return _vm.$set(_vm.resourceData, "use", $event)}}}),(_vm.resourceData.type)?_c('dt-codeable-concept',{attrs:{"label":"type","resource":_vm.resourceData.type,"edit":_vm.edit}}):_vm._e(),_c('div',{staticClass:"form-row"},[_c('dt-uri',{staticClass:"col-md-6",attrs:{"label":"system","value":_vm.resourceData.system,"edit":_vm.edit},on:{"update:value":function($event){return _vm.$set(_vm.resourceData, "system", $event)}}}),_c('dt-string',{staticClass:"col-md-6",attrs:{"label":"value","value":_vm.resourceData.value,"edit":_vm.edit},on:{"update:value":function($event){return _vm.$set(_vm.resourceData, "value", $event)}}})],1),_c('dt-period',{attrs:{"label":"period","resource":_vm.resourceData.period,"edit":_vm.edit},on:{"update:resource":function($event){return _vm.$set(_vm.resourceData, "period", $event)}}})],1):_c('div',[_c('div',{staticClass:"form-row"},[_c('dt-code',{staticClass:"col-md-2",attrs:{"label":"use","value":_vm.resourceData.use,"valueSet":_vm.identifierUse,"edit":_vm.edit},on:{"update:value":function($event){return _vm.$set(_vm.resourceData, "use", $event)}}}),_c('dt-uri',{staticClass:"col-md-5",attrs:{"label":"system","value":_vm.resourceData.system,"edit":_vm.edit},on:{"update:value":function($event){return _vm.$set(_vm.resourceData, "system", $event)}}}),_c('dt-string',{staticClass:"col-md-5",attrs:{"label":"value","value":_vm.resourceData.value,"edit":_vm.edit},on:{"update:value":function($event){return _vm.$set(_vm.resourceData, "value", $event)}}})],1)])])}
var DtIdentifiervue_type_template_id_2dd78c0b_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/data-types/complex/DtIdentifier.vue?vue&type=template&id=2dd78c0b&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"465b08a6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/data-types/complex/DtCodeableConcept.vue?vue&type=template&id=d2297852&
var DtCodeableConceptvue_type_template_id_d2297852_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"form-row"},[_vm._l((_vm.resourceData.coding),function(value,index){return _c('dt-coding',{key:index,attrs:{"resource":value,"edit":_vm.edit}})}),_c('dt-string',{attrs:{"label":"text","value":_vm.resourceData.text,"edit":_vm.edit},on:{"update:value":function($event){return _vm.$set(_vm.resourceData, "text", $event)}}})],2),_c('pre',[_c('code',[_vm._v(_vm._s(_vm.resourceData))])])])}
var DtCodeableConceptvue_type_template_id_d2297852_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/data-types/complex/DtCodeableConcept.vue?vue&type=template&id=d2297852&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"465b08a6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/data-types/complex/DtCoding.vue?vue&type=template&id=37d13877&
var DtCodingvue_type_template_id_37d13877_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"form-row"},[_c('dt-uri',{attrs:{"label":"system","value":_vm.resourceData.system,"edit":_vm.edit},on:{"update:value":function($event){return _vm.$set(_vm.resourceData, "system", $event)}}}),_c('dt-string',{attrs:{"label":"version","value":_vm.resourceData.version,"edit":_vm.edit},on:{"update:value":function($event){return _vm.$set(_vm.resourceData, "version", $event)}}}),_c('dt-code',{attrs:{"label":"code","value":_vm.resourceDate.code,"edit":_vm.edit},on:{"update:value":function($event){return _vm.$set(_vm.resourceDate, "code", $event)}}}),_c('dt-string',{attrs:{"label":"display","value":_vm.resourceDate.display,"edit":_vm.edit},on:{"update:value":function($event){return _vm.$set(_vm.resourceDate, "display", $event)}}}),_c('dt-boolean',{attrs:{"label":"userSelected","value":_vm.resourceData.userSelected,"edit":_vm.edit},on:{"update:value":function($event){return _vm.$set(_vm.resourceData, "userSelected", $event)}}})],1),_c('pre',[_c('code',[_vm._v(_vm._s(_vm.resourceData))])])])}
var DtCodingvue_type_template_id_37d13877_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/data-types/complex/DtCoding.vue?vue&type=template&id=37d13877&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"465b08a6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/data-types/primitive/DtBoolean.vue?vue&type=template&id=64a5cfba&
var DtBooleanvue_type_template_id_64a5cfba_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":_vm.localId}},[_vm._v(_vm._s(_vm.label))]),_c('div',{staticClass:"form-check"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.localValue),expression:"localValue"}],staticClass:"form-check-input",attrs:{"id":_vm.localId + '1',"type":"radio"},domProps:{"value":true,"checked":_vm._q(_vm.localValue,true)},on:{"change":function($event){_vm.localValue=true}}}),_c('label',{staticClass:"form-check-label",attrs:{"for":_vm.localId + '1'}},[_vm._v(" yes ")])]),_c('div',{staticClass:"form-check"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.localValue),expression:"localValue"}],staticClass:"form-check-input",attrs:{"id":_vm.localId + '2',"type":"radio"},domProps:{"value":false,"checked":_vm._q(_vm.localValue,false)},on:{"change":function($event){_vm.localValue=false}}}),_c('label',{staticClass:"form-check-label",attrs:{"for":_vm.localId + '2'}},[_vm._v(" no ")])])])}
var DtBooleanvue_type_template_id_64a5cfba_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/data-types/primitive/DtBoolean.vue?vue&type=template&id=64a5cfba&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/data-types/primitive/DtBoolean.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var DtBooleanvue_type_script_lang_js_ = ({
  extends: DtBase
});
// CONCATENATED MODULE: ./src/components/data-types/primitive/DtBoolean.vue?vue&type=script&lang=js&
 /* harmony default export */ var primitive_DtBooleanvue_type_script_lang_js_ = (DtBooleanvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/data-types/primitive/DtBoolean.vue





/* normalize component */

var DtBoolean_component = normalizeComponent(
  primitive_DtBooleanvue_type_script_lang_js_,
  DtBooleanvue_type_template_id_64a5cfba_render,
  DtBooleanvue_type_template_id_64a5cfba_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var DtBoolean = (DtBoolean_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/data-types/primitive/DtUri.vue?vue&type=script&lang=js&

/* harmony default export */ var DtUrivue_type_script_lang_js_ = ({
  extends: DtBase
});
// CONCATENATED MODULE: ./src/components/data-types/primitive/DtUri.vue?vue&type=script&lang=js&
 /* harmony default export */ var primitive_DtUrivue_type_script_lang_js_ = (DtUrivue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/data-types/primitive/DtUri.vue
var DtUri_render, DtUri_staticRenderFns




/* normalize component */

var DtUri_component = normalizeComponent(
  primitive_DtUrivue_type_script_lang_js_,
  DtUri_render,
  DtUri_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var DtUri = (DtUri_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/data-types/complex/DtCoding.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var DtCodingvue_type_script_lang_js_ = ({
  extends: BaseDataType,
  components: {
    DtBoolean: DtBoolean,
    DtCode: DtCode,
    DtString: DtString,
    DtUri: DtUri
  }
});
// CONCATENATED MODULE: ./src/components/data-types/complex/DtCoding.vue?vue&type=script&lang=js&
 /* harmony default export */ var complex_DtCodingvue_type_script_lang_js_ = (DtCodingvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/data-types/complex/DtCoding.vue





/* normalize component */

var DtCoding_component = normalizeComponent(
  complex_DtCodingvue_type_script_lang_js_,
  DtCodingvue_type_template_id_37d13877_render,
  DtCodingvue_type_template_id_37d13877_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var DtCoding = (DtCoding_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/data-types/complex/DtCodeableConcept.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var DtCodeableConceptvue_type_script_lang_js_ = ({
  extends: BaseDataType,
  components: {
    DtCoding: DtCoding,
    DtString: DtString
  }
});
// CONCATENATED MODULE: ./src/components/data-types/complex/DtCodeableConcept.vue?vue&type=script&lang=js&
 /* harmony default export */ var complex_DtCodeableConceptvue_type_script_lang_js_ = (DtCodeableConceptvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/data-types/complex/DtCodeableConcept.vue





/* normalize component */

var DtCodeableConcept_component = normalizeComponent(
  complex_DtCodeableConceptvue_type_script_lang_js_,
  DtCodeableConceptvue_type_template_id_d2297852_render,
  DtCodeableConceptvue_type_template_id_d2297852_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var DtCodeableConcept = (DtCodeableConcept_component.exports);
// EXTERNAL MODULE: ./src/assets/fhir/value-sets/identifier-use.json
var identifier_use = __webpack_require__("14dc");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/data-types/complex/DtIdentifier.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var DtIdentifiervue_type_script_lang_js_ = ({
  extends: BaseDataType,
  props: {
    resource: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  computed: {
    identifierUse: function identifierUse() {
      return identifier_use;
    }
  },
  components: {
    DtCode: DtCode,
    DtCodeableConcept: DtCodeableConcept,
    DtPeriod: DtPeriod,
    DtString: DtString,
    DtUri: DtUri
  }
});
// CONCATENATED MODULE: ./src/components/data-types/complex/DtIdentifier.vue?vue&type=script&lang=js&
 /* harmony default export */ var complex_DtIdentifiervue_type_script_lang_js_ = (DtIdentifiervue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/data-types/complex/DtIdentifier.vue





/* normalize component */

var DtIdentifier_component = normalizeComponent(
  complex_DtIdentifiervue_type_script_lang_js_,
  DtIdentifiervue_type_template_id_2dd78c0b_render,
  DtIdentifiervue_type_template_id_2dd78c0b_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var DtIdentifier = (DtIdentifier_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/data-types/helper/DtArray.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var DtArrayvue_type_script_lang_js_ = ({
  props: {
    resources: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    type: {
      type: String,
      required: true
    },
    edit: {
      type: Boolean,
      default: false
    },
    addString: {
      type: String,
      default: "Add"
    }
  },
  watch: {
    resources: {
      handler: function handler(newValue) {
        this.$emit("update:resources", newValue);
      },
      deep: true
    }
  },
  methods: {
    remove: function remove(index) {
      this.$delete(this.resources, index);
    }
  },
  components: {
    DtAddressDeBasis: DtAddress_de_basis,
    DtContactPoint: DtContactPoint,
    DtHumanNameDeBasis: DtHumanName_de_basis,
    DtIdentifier: DtIdentifier
  }
});
// CONCATENATED MODULE: ./src/components/data-types/helper/DtArray.vue?vue&type=script&lang=js&
 /* harmony default export */ var helper_DtArrayvue_type_script_lang_js_ = (DtArrayvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/data-types/helper/DtArray.vue?vue&type=style&index=0&id=56c83ae0&lang=scss&scoped=true&
var DtArrayvue_type_style_index_0_id_56c83ae0_lang_scss_scoped_true_ = __webpack_require__("0f53");

// CONCATENATED MODULE: ./src/components/data-types/helper/DtArray.vue






/* normalize component */

var DtArray_component = normalizeComponent(
  helper_DtArrayvue_type_script_lang_js_,
  DtArrayvue_type_template_id_56c83ae0_scoped_true_render,
  DtArrayvue_type_template_id_56c83ae0_scoped_true_staticRenderFns,
  false,
  null,
  "56c83ae0",
  null
  
)

/* harmony default export */ var DtArray = (DtArray_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/data-types/primitive/DtDate.vue?vue&type=script&lang=js&


/* harmony default export */ var DtDatevue_type_script_lang_js_ = ({
  extends: DtBase,
  props: {
    maxValue: {
      type: String,
      default: null
    },
    minValue: {
      type: String,
      default: null
    }
  },
  computed: {
    max: function max() {
      if (!this.maxValue) {
        return null;
      }

      return external_moment_default()(this.maxValue).format("YYYY-MM-DD");
    },
    min: function min() {
      if (!this.minValue) {
        return null;
      }

      return external_moment_default()(this.maxValue).format("YYYY-MM-DD");
    }
  },
  created: function created() {
    this.type = "date";
  }
});
// CONCATENATED MODULE: ./src/components/data-types/primitive/DtDate.vue?vue&type=script&lang=js&
 /* harmony default export */ var primitive_DtDatevue_type_script_lang_js_ = (DtDatevue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/data-types/primitive/DtDate.vue
var DtDate_render, DtDate_staticRenderFns




/* normalize component */

var DtDate_component = normalizeComponent(
  primitive_DtDatevue_type_script_lang_js_,
  DtDate_render,
  DtDate_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var DtDate = (DtDate_component.exports);
// EXTERNAL MODULE: ./src/assets/fhir/value-sets/administrative-gender.json
var administrative_gender = __webpack_require__("b409");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/resources/Patient-de-basis.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var Patient_de_basisvue_type_script_lang_js_ = ({
  extends: BaseResource,
  props: {
    edit: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      editMode: false
    };
  },
  computed: {
    administrativeGender: function administrativeGender() {
      return administrative_gender;
    }
  },
  methods: {
    toggleEditMode: function toggleEditMode() {
      this.editMode = !this.editMode;
    }
  },
  created: function created() {
    this.editMode = this.edit;
  },
  components: {
    DtArray: DtArray,
    DtBoolean: DtBoolean,
    DtCode: DtCode,
    DtDate: DtDate
  }
});
// CONCATENATED MODULE: ./src/components/resources/Patient-de-basis.vue?vue&type=script&lang=js&
 /* harmony default export */ var resources_Patient_de_basisvue_type_script_lang_js_ = (Patient_de_basisvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/resources/Patient-de-basis.vue





/* normalize component */

var Patient_de_basis_component = normalizeComponent(
  resources_Patient_de_basisvue_type_script_lang_js_,
  Patient_de_basisvue_type_template_id_1a32faf7_render,
  Patient_de_basisvue_type_template_id_1a32faf7_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Patient_de_basis = (Patient_de_basis_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"465b08a6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/data-types/complex/DtAttachment.vue?vue&type=template&id=edd66052&
var DtAttachmentvue_type_template_id_edd66052_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"form-group col"},[_c('label',{attrs:{"for":"localId"}},[_vm._v("photo")]),_c('input',{staticClass:"form-control",attrs:{"type":"file","id":"localId","placeholder":"localPlaceholder"},on:{"change":_vm.fileChanged}})]),_c('dt-uri',{attrs:{"label":"text","value":_vm.resourceData.url},on:{"update:value":function($event){return _vm.$set(_vm.resourceData, "url", $event)}}})],1),_c('pre',[_c('code',[_vm._v(_vm._s(_vm.resourceData))])])])}
var DtAttachmentvue_type_template_id_edd66052_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/data-types/complex/DtAttachment.vue?vue&type=template&id=edd66052&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/data-types/complex/DtAttachment.vue?vue&type=script&lang=js&





//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var DtAttachmentvue_type_script_lang_js_ = ({
  extends: BaseDataType,
  methods: {
    fileChanged: function fileChanged(event) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var file, data, attachment;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                file = event.target.files[0];

                if (!file) {
                  _context.next = 7;
                  break;
                }

                _context.next = 4;
                return _this.getBase64(file);

              case 4:
                data = _context.sent;
                attachment = {
                  contentType: file.type,
                  data: data,
                  size: file.size,
                  title: file.name,
                  creation: new Date().toISOString()
                };

                _this.$emit("update:resource", attachment);

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    // https://stackoverflow.com/questions/36280818/how-to-convert-file-to-base64-in-javascript
    getBase64: function getBase64(file) {
      return new Promise(function (resolve, reject) {
        var reader = new FileReader();
        reader.readAsDataURL(file);

        reader.onload = function () {
          return resolve(reader.result);
        };

        reader.onerror = function (error) {
          return reject(error);
        };
      });
    }
  },
  watch: {
    binary: function binary() {}
  },
  components: {
    DtUri: DtUri
  }
});
// CONCATENATED MODULE: ./src/components/data-types/complex/DtAttachment.vue?vue&type=script&lang=js&
 /* harmony default export */ var complex_DtAttachmentvue_type_script_lang_js_ = (DtAttachmentvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/data-types/complex/DtAttachment.vue





/* normalize component */

var DtAttachment_component = normalizeComponent(
  complex_DtAttachmentvue_type_script_lang_js_,
  DtAttachmentvue_type_template_id_edd66052_render,
  DtAttachmentvue_type_template_id_edd66052_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var DtAttachment = (DtAttachment_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"465b08a6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/data-types/primitive/DtBase64Binary.vue?vue&type=template&id=69b5cc66&
var DtBase64Binaryvue_type_template_id_69b5cc66_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":_vm.localId}},[_vm._v(_vm._s(_vm.label))]),_c('input',{staticClass:"form-control",attrs:{"type":"file","id":_vm.localId,"placeholder":_vm.localPlaceholder},on:{"change":_vm.previewFiles}})])}
var DtBase64Binaryvue_type_template_id_69b5cc66_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/data-types/primitive/DtBase64Binary.vue?vue&type=template&id=69b5cc66&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/data-types/primitive/DtBase64Binary.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//

/* harmony default export */ var DtBase64Binaryvue_type_script_lang_js_ = ({
  extends: DtBase,
  methods: {
    previewFiles: function previewFiles(event) {
      console.log(event.target.files);
    }
  }
});
// CONCATENATED MODULE: ./src/components/data-types/primitive/DtBase64Binary.vue?vue&type=script&lang=js&
 /* harmony default export */ var primitive_DtBase64Binaryvue_type_script_lang_js_ = (DtBase64Binaryvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/data-types/primitive/DtBase64Binary.vue





/* normalize component */

var DtBase64Binary_component = normalizeComponent(
  primitive_DtBase64Binaryvue_type_script_lang_js_,
  DtBase64Binaryvue_type_template_id_69b5cc66_render,
  DtBase64Binaryvue_type_template_id_69b5cc66_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var DtBase64Binary = (DtBase64Binary_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/data-types/primitive/DtInteger.vue?vue&type=script&lang=js&


/* harmony default export */ var DtIntegervue_type_script_lang_js_ = ({
  extends: DtBase,
  props: {
    max: {
      type: Number,
      default: null
    },
    min: {
      type: Number,
      default: null
    }
  },
  created: function created() {
    this.type = "number";
  }
});
// CONCATENATED MODULE: ./src/components/data-types/primitive/DtInteger.vue?vue&type=script&lang=js&
 /* harmony default export */ var primitive_DtIntegervue_type_script_lang_js_ = (DtIntegervue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/data-types/primitive/DtInteger.vue
var DtInteger_render, DtInteger_staticRenderFns




/* normalize component */

var DtInteger_component = normalizeComponent(
  primitive_DtIntegervue_type_script_lang_js_,
  DtInteger_render,
  DtInteger_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var DtInteger = (DtInteger_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/data-types/primitive/DtMarkdown.vue?vue&type=script&lang=js&

/* harmony default export */ var DtMarkdownvue_type_script_lang_js_ = ({
  extends: DtBase
});
// CONCATENATED MODULE: ./src/components/data-types/primitive/DtMarkdown.vue?vue&type=script&lang=js&
 /* harmony default export */ var primitive_DtMarkdownvue_type_script_lang_js_ = (DtMarkdownvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/data-types/primitive/DtMarkdown.vue
var DtMarkdown_render, DtMarkdown_staticRenderFns




/* normalize component */

var DtMarkdown_component = normalizeComponent(
  primitive_DtMarkdownvue_type_script_lang_js_,
  DtMarkdown_render,
  DtMarkdown_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var DtMarkdown = (DtMarkdown_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"465b08a6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/ResourceSelector.vue?vue&type=template&id=65e7b3b6&scoped=true&
var ResourceSelectorvue_type_template_id_65e7b3b6_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{class:[{ 'molit-modal-dialog': _vm.modalDialog }],on:{"click":_vm.modalClicked}},[_c('div',[(_vm.modalDialog)?_c('div',{staticClass:"molit-modal-title"},[_c('h5',[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"close-icon",attrs:{"aria-hidden":"true"},on:{"click":_vm.cancel}},[_vm._v("×")])]):_vm._e(),_c('div',{class:[{ 'molit-modal-dialog-body': _vm.modalDialog }]},[_c('paginated-list',{staticClass:"paginated-list",attrs:{"resourceName":_vm.resourceName,"fhirBaseUrl":_vm.fhirBaseUrl,"searchAttributes":_vm.searchAttributes,"searchParams":_vm.queryParams,"showPagination":false,"token":_vm.token,"searchInputPlaceholder":_vm.searchInputPlaceholder},on:{"update":_vm.bundleUpdated,"error":_vm.error}},[(_vm.bundle)?_c('div',{staticClass:"list-group"},_vm._l((_vm.bundle.entry),function(entry){return _c('a',{key:entry.resource.id,class:['list-group-item', 'list-group-item-action', 'flex-column', 'align-items-start', { active: _vm.selectedResource === entry.resource }],attrs:{"href":"javascript:void(0);"},on:{"click":function($event){return _vm.setResource(entry.resource)},"dblclick":_vm.onDoubleClick}},[_c('div',{staticClass:"d-flex w-100 justify-content-between"},[_c('h6',{staticClass:"mb-0"},[_vm._v(_vm._s(_vm.getAttribute(entry.resource, _vm.titleAttribute.value, _vm.titleAttribute.type)))])]),_c('p',{staticClass:"mb-0"},_vm._l((_vm.subtitleAttributes),function(attribute,index){return _c('span',{key:attribute.value},[(attribute.value && attribute.value !== '')?_c('span',[_c('span',[_vm._v(_vm._s(attribute.name)+": ")]),_c('span',[_vm._v(_vm._s(_vm.getAttribute(entry.resource, attribute.value, attribute.type)))]),(index < _vm.subtitleAttributes.length - 1)?_c('span',[_vm._v(" · ")]):_vm._e()]):_vm._e()])}),0)])}),0):_c('div',{staticClass:"spinner-container"},[_c('spinner')],1)])],1),_c('div',{class:[{ 'molit-modal-dialog-footer': _vm.modalDialog }]},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button"},on:{"click":_vm.cancel}},[_vm._v(_vm._s(_vm.cancelText))]),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","disabled":!_vm.selectedResource},on:{"click":_vm.ok}},[_vm._v(_vm._s(_vm.okText))])])])])])}
var ResourceSelectorvue_type_template_id_65e7b3b6_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/ResourceSelector.vue?vue&type=template&id=65e7b3b6&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/ResourceSelector.vue?vue&type=script&lang=js&



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var ResourceSelectorvue_type_script_lang_js_ = ({
  props: {
    resourceName: {
      type: String,
      required: true
    },
    fhirBaseUrl: {
      type: String,
      required: true
    },
    modalDialog: {
      type: Boolean,
      default: true
    },
    queryParams: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    searchAttributes: {
      type: Array,
      default: function _default() {
        return [{
          name: "ID",
          value: "_id"
        }];
      }
    },
    titleAttribute: {
      type: Object,
      default: function _default() {
        return {
          value: "id"
        };
      }
    },
    subtitleAttributes: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    token: {
      type: String,
      default: null
    },
    title: {
      type: String,
      default: "Choose..."
    },
    cancelText: {
      type: String,
      default: "Cancel"
    },
    okText: {
      type: String,
      default: "OK"
    },
    searchInputPlaceholder: {
      type: String,
      default: "Search.."
    }
  },
  data: function data() {
    return {
      bundle: null,
      selectedResource: null
    };
  },
  methods: {
    bundleUpdated: function bundleUpdated(bundle) {
      this.bundle = bundle;
    },
    onDoubleClick: function onDoubleClick() {
      if (this.selectedResource) {
        this.ok();
      }
    },
    setResource: function setResource(resource) {
      this.selectedResource = resource;
    },
    byString: function byString(o, s) {
      s = s.replace(/\[(\w+)\]/g, ".$1"); // https://stackoverflow.com/questions/6491463/accessing-nested-javascript-objects-with-string-key

      s = s.replace(/^\./, "");
      var a = s.split(".");

      for (var i = 0, n = a.length; i < n; ++i) {
        var k = a[i];

        if (k in o) {
          o = o[k];
        } else {
          return;
        }
      }

      return o;
    },
    getAttribute: function getAttribute(resource, attributeName, attributeType) {
      if (!resource) {
        return "";
      } else if (!attributeName) {
        return resource.id;
      }

      var attribute = this.byString(resource, attributeName);

      if (!attribute) {
        return "-";
      }

      switch (attributeType) {
        case "HumanName":
          return Object(fhir_util_["getStringFromHumanName"])(attribute);

        case "date":
        case "Date":
          return new Date(attribute).toLocaleDateString();

        default:
          return attribute;
      }
    },
    cancel: function cancel() {
      this.$emit("cancel");
    },
    ok: function ok() {
      this.$emit("update", this.selectedResource);
    },
    error: function error(e) {
      this.$emit("error", e);
    },
    modalClicked: function modalClicked(e) {
      if (this.modalDialog && e.target.className === "molit-modal-dialog") {// this.cancel();
      }
    }
  },
  components: {
    PaginatedList: PaginatedList,
    Spinner: external_vue_simple_spinner_default.a
  }
});
// CONCATENATED MODULE: ./src/components/ResourceSelector.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_ResourceSelectorvue_type_script_lang_js_ = (ResourceSelectorvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/ResourceSelector.vue?vue&type=style&index=0&id=65e7b3b6&lang=scss&scoped=true&
var ResourceSelectorvue_type_style_index_0_id_65e7b3b6_lang_scss_scoped_true_ = __webpack_require__("9d78");

// CONCATENATED MODULE: ./src/components/ResourceSelector.vue






/* normalize component */

var ResourceSelector_component = normalizeComponent(
  components_ResourceSelectorvue_type_script_lang_js_,
  ResourceSelectorvue_type_template_id_65e7b3b6_scoped_true_render,
  ResourceSelectorvue_type_template_id_65e7b3b6_scoped_true_staticRenderFns,
  false,
  null,
  "65e7b3b6",
  null
  
)

/* harmony default export */ var ResourceSelector = (ResourceSelector_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"465b08a6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MolecularReport.vue?vue&type=template&id=133eff7a&scoped=true&
var MolecularReportvue_type_template_id_133eff7a_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.showColumnHideOptions)?_c('div',{class:['column-hide-options', { right: _vm.columnHideOptionsRight }]},[_c('div',{staticClass:"form-check form-check-inline"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.showId),expression:"showId"}],staticClass:"form-check-input",attrs:{"type":"checkbox","id":"id"},domProps:{"checked":Array.isArray(_vm.showId)?_vm._i(_vm.showId,null)>-1:(_vm.showId)},on:{"change":function($event){var $$a=_vm.showId,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.showId=$$a.concat([$$v]))}else{$$i>-1&&(_vm.showId=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.showId=$$c}}}}),_c('label',{staticClass:"form-check-label",attrs:{"for":"id"}},[_vm._v("Id")])]),(_vm.variantType === 'SNV')?_c('div',{staticClass:"form-check form-check-inline"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.showGene),expression:"showGene"}],staticClass:"form-check-input",attrs:{"type":"checkbox","id":"gene"},domProps:{"checked":Array.isArray(_vm.showGene)?_vm._i(_vm.showGene,null)>-1:(_vm.showGene)},on:{"change":function($event){var $$a=_vm.showGene,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.showGene=$$a.concat([$$v]))}else{$$i>-1&&(_vm.showGene=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.showGene=$$c}}}}),_c('label',{staticClass:"form-check-label",attrs:{"for":"gene"}},[_vm._v("Gene Symbol")])]):_vm._e(),(_vm.variantType === 'CNV')?_c('div',{staticClass:"form-check form-check-inline"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.showLocation),expression:"showLocation"}],staticClass:"form-check-input",attrs:{"type":"checkbox","id":"location"},domProps:{"checked":Array.isArray(_vm.showLocation)?_vm._i(_vm.showLocation,null)>-1:(_vm.showLocation)},on:{"change":function($event){var $$a=_vm.showLocation,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.showLocation=$$a.concat([$$v]))}else{$$i>-1&&(_vm.showLocation=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.showLocation=$$c}}}}),_c('label',{staticClass:"form-check-label",attrs:{"for":"location"}},[_vm._v("Location")])]):_vm._e(),(_vm.variantType === 'CNV')?_c('div',{staticClass:"form-check form-check-inline"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.showRegion),expression:"showRegion"}],staticClass:"form-check-input",attrs:{"type":"checkbox","id":"region"},domProps:{"checked":Array.isArray(_vm.showRegion)?_vm._i(_vm.showRegion,null)>-1:(_vm.showRegion)},on:{"change":function($event){var $$a=_vm.showRegion,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.showRegion=$$a.concat([$$v]))}else{$$i>-1&&(_vm.showRegion=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.showRegion=$$c}}}}),_c('label',{staticClass:"form-check-label",attrs:{"for":"region"}},[_vm._v("Region")])]):_vm._e(),(_vm.variantType === 'CNV')?_c('div',{staticClass:"form-check form-check-inline"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.showEffect),expression:"showEffect"}],staticClass:"form-check-input",attrs:{"type":"checkbox","id":"effect"},domProps:{"checked":Array.isArray(_vm.showEffect)?_vm._i(_vm.showEffect,null)>-1:(_vm.showEffect)},on:{"change":function($event){var $$a=_vm.showEffect,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.showEffect=$$a.concat([$$v]))}else{$$i>-1&&(_vm.showEffect=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.showEffect=$$c}}}}),_c('label',{staticClass:"form-check-label",attrs:{"for":"effect"}},[_vm._v("Effect")])]):_vm._e(),_c('div',{staticClass:"form-check form-check-inline"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.showReference),expression:"showReference"}],staticClass:"form-check-input",attrs:{"type":"checkbox","id":"reference"},domProps:{"checked":Array.isArray(_vm.showReference)?_vm._i(_vm.showReference,null)>-1:(_vm.showReference)},on:{"change":function($event){var $$a=_vm.showReference,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.showReference=$$a.concat([$$v]))}else{$$i>-1&&(_vm.showReference=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.showReference=$$c}}}}),_c('label',{staticClass:"form-check-label",attrs:{"for":"reference"}},[_vm._v("Reference")])]),(_vm.variantType === 'SNV')?_c('div',{staticClass:"form-check form-check-inline"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.showType),expression:"showType"}],staticClass:"form-check-input",attrs:{"type":"checkbox","if":"type"},domProps:{"checked":Array.isArray(_vm.showType)?_vm._i(_vm.showType,null)>-1:(_vm.showType)},on:{"change":function($event){var $$a=_vm.showType,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.showType=$$a.concat([$$v]))}else{$$i>-1&&(_vm.showType=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.showType=$$c}}}}),_c('label',{staticClass:"form-check-label",attrs:{"for":"type"}},[_vm._v("DNA Change Type")])]):_vm._e(),_c('div',{staticClass:"form-check form-check-inline"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.showSource),expression:"showSource"}],staticClass:"form-check-input",attrs:{"type":"checkbox","id":"source"},domProps:{"checked":Array.isArray(_vm.showSource)?_vm._i(_vm.showSource,null)>-1:(_vm.showSource)},on:{"change":function($event){var $$a=_vm.showSource,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.showSource=$$a.concat([$$v]))}else{$$i>-1&&(_vm.showSource=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.showSource=$$c}}}}),_c('label',{staticClass:"form-check-label",attrs:{"for":"source"}},[_vm._v("Genomic Source Class")])]),(_vm.variantType === 'SNV')?_c('div',{staticClass:"form-check form-check-inline"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.showFunctionalClass),expression:"showFunctionalClass"}],staticClass:"form-check-input",attrs:{"type":"checkbox","id":"functional-class"},domProps:{"checked":Array.isArray(_vm.showFunctionalClass)?_vm._i(_vm.showFunctionalClass,null)>-1:(_vm.showFunctionalClass)},on:{"change":function($event){var $$a=_vm.showFunctionalClass,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.showFunctionalClass=$$a.concat([$$v]))}else{$$i>-1&&(_vm.showFunctionalClass=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.showFunctionalClass=$$c}}}}),_c('label',{staticClass:"form-check-label",attrs:{"for":"functional-class"}},[_vm._v("Functional Class")])]):_vm._e(),(_vm.variantType === 'SNV')?_c('div',{staticClass:"form-check form-check-inline"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.showVariant),expression:"showVariant"}],staticClass:"form-check-input",attrs:{"type":"checkbox","id":"dna-change"},domProps:{"checked":Array.isArray(_vm.showVariant)?_vm._i(_vm.showVariant,null)>-1:(_vm.showVariant)},on:{"change":function($event){var $$a=_vm.showVariant,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.showVariant=$$a.concat([$$v]))}else{$$i>-1&&(_vm.showVariant=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.showVariant=$$c}}}}),_c('label',{staticClass:"form-check-label",attrs:{"for":"dna-change"}},[_vm._v("DNA Change (c.HGVS)")])]):_vm._e(),(_vm.variantType === 'SNV')?_c('div',{staticClass:"form-check form-check-inline"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.showTranscript),expression:"showTranscript"}],staticClass:"form-check-input",attrs:{"type":"checkbox","id":"transcript"},domProps:{"checked":Array.isArray(_vm.showTranscript)?_vm._i(_vm.showTranscript,null)>-1:(_vm.showTranscript)},on:{"change":function($event){var $$a=_vm.showTranscript,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.showTranscript=$$a.concat([$$v]))}else{$$i>-1&&(_vm.showTranscript=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.showTranscript=$$c}}}}),_c('label',{staticClass:"form-check-label",attrs:{"for":"transcript"}},[_vm._v("Transcript")])]):_vm._e(),(_vm.variantType === 'SNV')?_c('div',{staticClass:"form-check form-check-inline"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.showNaf),expression:"showNaf"}],staticClass:"form-check-input",attrs:{"type":"checkbox","id":"naf"},domProps:{"checked":Array.isArray(_vm.showNaf)?_vm._i(_vm.showNaf,null)>-1:(_vm.showNaf)},on:{"change":function($event){var $$a=_vm.showNaf,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.showNaf=$$a.concat([$$v]))}else{$$i>-1&&(_vm.showNaf=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.showNaf=$$c}}}}),_c('label',{staticClass:"form-check-label",attrs:{"for":"naf"}},[_vm._v("NAF")])]):_vm._e(),(_vm.variantType === 'SNV')?_c('div',{staticClass:"form-check form-check-inline"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.showReadDepth),expression:"showReadDepth"}],staticClass:"form-check-input",attrs:{"type":"checkbox","id":"read-depth"},domProps:{"checked":Array.isArray(_vm.showReadDepth)?_vm._i(_vm.showReadDepth,null)>-1:(_vm.showReadDepth)},on:{"change":function($event){var $$a=_vm.showReadDepth,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.showReadDepth=$$a.concat([$$v]))}else{$$i>-1&&(_vm.showReadDepth=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.showReadDepth=$$c}}}}),_c('label',{staticClass:"form-check-label",attrs:{"for":"read-depth"}},[_vm._v("Read Depth")])]):_vm._e(),(_vm.variantType === 'CNV')?_c('div',{staticClass:"form-check form-check-inline"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.showCnvSize),expression:"showCnvSize"}],staticClass:"form-check-input",attrs:{"type":"checkbox","id":"cnv-size"},domProps:{"checked":Array.isArray(_vm.showCnvSize)?_vm._i(_vm.showCnvSize,null)>-1:(_vm.showCnvSize)},on:{"change":function($event){var $$a=_vm.showCnvSize,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.showCnvSize=$$a.concat([$$v]))}else{$$i>-1&&(_vm.showCnvSize=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.showCnvSize=$$c}}}}),_c('label',{staticClass:"form-check-label",attrs:{"for":"cnv-size"}},[_vm._v("CNV Size")])]):_vm._e(),(_vm.variantType === 'CNV')?_c('div',{staticClass:"form-check form-check-inline"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.showCopyNumber),expression:"showCopyNumber"}],staticClass:"form-check-input",attrs:{"type":"checkbox","id":"copy-number"},domProps:{"checked":Array.isArray(_vm.showCopyNumber)?_vm._i(_vm.showCopyNumber,null)>-1:(_vm.showCopyNumber)},on:{"change":function($event){var $$a=_vm.showCopyNumber,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.showCopyNumber=$$a.concat([$$v]))}else{$$i>-1&&(_vm.showCopyNumber=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.showCopyNumber=$$c}}}}),_c('label',{staticClass:"form-check-label",attrs:{"for":"copy-number"}},[_vm._v("Copy Number")])]):_vm._e(),(_vm.variantType === 'SNV')?_c('div',{staticClass:"form-check form-check-inline"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.showLinks),expression:"showLinks"}],staticClass:"form-check-input",attrs:{"type":"checkbox","id":"links"},domProps:{"checked":Array.isArray(_vm.showLinks)?_vm._i(_vm.showLinks,null)>-1:(_vm.showLinks)},on:{"change":function($event){var $$a=_vm.showLinks,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.showLinks=$$a.concat([$$v]))}else{$$i>-1&&(_vm.showLinks=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.showLinks=$$c}}}}),_c('label',{staticClass:"form-check-label",attrs:{"for":"links"}},[_vm._v("Links")])]):_vm._e()]):_vm._e(),_c('table',{staticClass:"table snv-table"},[_c('thead',[_c('tr',[(_vm.showId)?_c('th',[_vm._v("Id")]):_vm._e(),(_vm.showGene && _vm.variantType === 'SNV')?_c('th',[_vm._v("Gene Symbol")]):_vm._e(),(_vm.showLocation && _vm.variantType === 'CNV')?_c('th',[_vm._v("Location")]):_vm._e(),(_vm.showRegion && _vm.variantType === 'CNV')?_c('th',[_vm._v("Region")]):_vm._e(),(_vm.showEffect && _vm.variantType === 'CNV')?_c('th',[_vm._v("Effect")]):_vm._e(),(_vm.showReference)?_c('th',[_vm._v("Reference")]):_vm._e(),(_vm.showType && _vm.variantType === 'SNV')?_c('th',[_vm._v("DNA Change Type")]):_vm._e(),(_vm.showSource)?_c('th',[_vm._v("Genomic Source Class")]):_vm._e(),(_vm.showFunctionalClass && _vm.variantType === 'SNV')?_c('th',[_vm._v("Functional Class")]):_vm._e(),(_vm.showVariant && _vm.variantType === 'SNV')?_c('th',[_vm._v("DNA Change (c.HGVS)")]):_vm._e(),(_vm.showTranscript && _vm.variantType === 'SNV')?_c('th',[_vm._v("Transcript")]):_vm._e(),(_vm.showNaf && _vm.variantType === 'SNV')?_c('th',[_vm._v("NAF")]):_vm._e(),(_vm.showReadDepth && _vm.variantType === 'SNV')?_c('th',[_vm._v("Read Depth")]):_vm._e(),(_vm.showCnvSize && _vm.variantType === 'CNV')?_c('th',[_vm._v("CNV Size")]):_vm._e(),(_vm.showCopyNumber && _vm.variantType === 'CNV')?_c('th',[_vm._v("Copy Number")]):_vm._e(),(_vm.showLinks && _vm.variantType === 'SNV')?_c('th',[_vm._v("Links")]):_vm._e()])]),_c('tbody',_vm._l((_vm.resources),function(resource){return _c('tr',{key:resource.id},[(_vm.showId)?_c('td',[_vm._v(_vm._s(resource.id))]):_vm._e(),(_vm.showGene && _vm.variantType === 'SNV')?_c('td',[(_vm.showOncoKBLinks)?_c('a',{attrs:{"href":("https://oncokb.org/gene/" + (_vm.getValueByLoincCode(resource.component, '48018-6'))),"target":"_blank"}},[_vm._v(_vm._s(_vm.getValueByLoincCode(resource.component, "48018-6")))]):_c('span',[_vm._v(_vm._s(_vm.getValueByLoincCode(resource.component, "48018-6")))])]):_vm._e(),(_vm.showLocation && _vm.variantType === 'CNV')?_c('td',[_vm._v(_vm._s(_vm.getValueByLoincCode(resource.component, "48001-2")))]):_vm._e(),(_vm.showRegion && _vm.variantType === 'CNV')?_c('td',[_vm._v(_vm._s(_vm.getValueByLoincCode(resource.component, "81254-5")))]):_vm._e(),(_vm.showEffect && _vm.variantType === 'CNV')?_c('td',[_vm._v(_vm._s(_vm.getValueByLoincCode(resource.component, "effect")))]):_vm._e(),(_vm.showReference)?_c('td',[_vm._v(_vm._s(_vm.getValueByLoincCode(resource.component, "62374-4")))]):_vm._e(),(_vm.showType && _vm.variantType === 'SNV')?_c('td',[_vm._v(_vm._s(_vm.getValueByLoincCode(resource.component, "48019-4")))]):_vm._e(),(_vm.showSource)?_c('td',[_vm._v(_vm._s(_vm.getValueByLoincCode(resource.component, "48002-0")))]):_vm._e(),(_vm.showFunctionalClass && _vm.variantType === 'SNV')?_c('td',[_vm._v(_vm._s(_vm.getValueByLoincCode(resource.component, "functional-annotation")))]):_vm._e(),(_vm.showVariant && _vm.variantType === 'SNV')?_c('td',[_vm._v(" "+_vm._s(_vm.getValueByLoincCode(resource.component, "48004-6"))),(_vm.getValueByLoincCode(resource.component, '48005-3'))?_c('span',[_vm._v(";")]):_vm._e(),_vm._v(" "+_vm._s(_vm.getValueByLoincCode(resource.component, "48005-3"))+" ")]):_vm._e(),(_vm.showTranscript && _vm.variantType === 'SNV')?_c('td',[(_vm.showNCBILinks)?_c('a',{attrs:{"href":("https://www.ncbi.nlm.nih.gov/nuccore/" + (_vm.getValueByLoincCode(resource.component, '51958-7'))),"target":"_blank"}},[_vm._v(_vm._s(_vm.getValueByLoincCode(resource.component, "51958-7")))]):_c('span',[_vm._v(_vm._s(_vm.getValueByLoincCode(resource.component, "51958-7")))])]):_vm._e(),(_vm.showNaf && _vm.variantType === 'SNV')?_c('td',[_vm._v(_vm._s(_vm.getValueByLoincCode(resource.component, "81258-6") ? _vm.getValueByLoincCode(resource.component, "81258-6").toFixed(_vm.nafDecimalPlaces) : ""))]):_vm._e(),(_vm.showReadDepth && _vm.variantType === 'SNV')?_c('td',[_vm._v(_vm._s(_vm.getValueByLoincCode(resource.component, "82121-5")))]):_vm._e(),(_vm.showCnvSize && _vm.variantType === 'CNV')?_c('td',[_vm._v(_vm._s(_vm.getValueByLoincCode(resource.component, "cnv-size")))]):_vm._e(),(_vm.showCopyNumber && _vm.variantType === 'CNV')?_c('td',[_vm._v(_vm._s(_vm.getValueByLoincCode(resource.component, "82155-3")))]):_vm._e(),(_vm.showLinks && _vm.variantType === 'SNV')?_c('td',[(_vm.showOncoKBLinks)?_c('a',{attrs:{"href":("https://www.cbioportal.org/results/cancerTypesSummary?case_set_id=all&gene_list=" + (_vm.getValueByLoincCode(resource.component, '48018-6')) + "&cancer_study_list=5c8a7d55e4b046111fee2296"),"target":"_blank"}},[_vm._v("cBioPortal")]):_vm._e()]):_vm._e()])}),0)])])}
var MolecularReportvue_type_template_id_133eff7a_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/MolecularReport.vue?vue&type=template&id=133eff7a&scoped=true&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MolecularReport.vue?vue&type=script&lang=js&

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import fhirpath from "fhirpath";

/* harmony default export */ var MolecularReportvue_type_script_lang_js_ = ({
  props: {
    resources: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    variantType: {
      type: String,
      default: "SNV"
    },
    showColumnHideOptions: {
      type: Boolean,
      default: true
    },
    columnHideOptionsRight: {
      type: Boolean,
      default: true
    },
    hideId: {
      type: Boolean,
      default: false
    },
    hideGene: {
      type: Boolean,
      default: false
    },
    hideLocation: {
      type: Boolean,
      default: false
    },
    hideRegion: {
      type: Boolean,
      default: false
    },
    hideEffect: {
      type: Boolean,
      default: false
    },
    hideReference: {
      type: Boolean,
      default: false
    },
    hideType: {
      type: Boolean,
      default: false
    },
    hideSource: {
      type: Boolean,
      default: false
    },
    hideFunctionalClass: {
      type: Boolean,
      default: false
    },
    hideVariant: {
      type: Boolean,
      default: false
    },
    hideTranscript: {
      type: Boolean,
      default: false
    },
    hideNaf: {
      type: Boolean,
      default: false
    },
    hideReadDepth: {
      type: Boolean,
      default: false
    },
    hideCnvSize: {
      type: Boolean,
      default: false
    },
    hideCopyNumber: {
      type: Boolean,
      default: false
    },
    hideLinks: {
      type: Boolean,
      default: false
    },
    showOncoKBLinks: {
      type: Boolean,
      default: true
    },
    showNCBILinks: {
      type: Boolean,
      default: true
    },
    nafDecimalPlaces: {
      type: Number,
      default: 4
    }
  },
  data: function data() {
    return {
      columns: [],
      showId: true,
      showGene: true,
      showLocation: true,
      showRegion: true,
      showEffect: true,
      showReference: true,
      showType: true,
      showSource: true,
      showFunctionalClass: true,
      showVariant: true,
      showTranscript: true,
      showNaf: true,
      showReadDepth: true,
      showCnvSize: true,
      showCopyNumber: true,
      showLinks: true
    };
  },
  methods: {
    getValueByLoincCode: function getValueByLoincCode(components, loincCode) {
      return Object(fhir_util_["getValueByLoincCode"])(components, loincCode);
    }
  },
  mounted: function mounted() {
    // const a = fhirpath.evaluate({ resourceType: "Patient" }, "Patient.name.given");
    // console.log(a);
    this.showGene = !this.hideGene;
    this.showLocation = !this.hideLocation;
    this.showRegion = !this.hideRegion;
    this.showReference = !this.hideReference;
    this.showType = !this.hideType;
    this.showSource = !this.hideSource;
    this.showFunctionalClass = !this.hideFunctionalClass;
    this.showVariant = !this.hideVariant;
    this.showTranscript = !this.hideTranscript;
    this.showNaf = !this.hideNaf;
    this.showReadDepth = !this.hideReadDepth;
    this.showCnvSize = !this.hideCnvSize;
    this.showCopyNumber = !this.hideCopyNumber;
    this.showLinks = !this.hideLinks;
  }
});
// CONCATENATED MODULE: ./src/components/MolecularReport.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_MolecularReportvue_type_script_lang_js_ = (MolecularReportvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/MolecularReport.vue?vue&type=style&index=0&id=133eff7a&lang=scss&scoped=true&
var MolecularReportvue_type_style_index_0_id_133eff7a_lang_scss_scoped_true_ = __webpack_require__("2b16");

// CONCATENATED MODULE: ./src/components/MolecularReport.vue






/* normalize component */

var MolecularReport_component = normalizeComponent(
  components_MolecularReportvue_type_script_lang_js_,
  MolecularReportvue_type_template_id_133eff7a_scoped_true_render,
  MolecularReportvue_type_template_id_133eff7a_scoped_true_staticRenderFns,
  false,
  null,
  "133eff7a",
  null
  
)

/* harmony default export */ var MolecularReport = (MolecularReport_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"465b08a6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/GeneticReport.vue?vue&type=template&id=3c67fb3e&scoped=true&
var GeneticReportvue_type_template_id_3c67fb3e_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.diagnosticReport)?_c('div',[_c('h4',[_vm._v("Genetic Report")]),_c('div',[(!_vm.metaAsTable)?_c('div',[_c('h5',[_vm._v("Meta")]),_c('div',{staticClass:"form-row"},[_c('label',{staticClass:"col-md-3 col-form-label"},[_vm._v("Issued")]),(_vm.diagnosticReport.issued)?_c('label',{staticClass:"col-md-9 col-form-label"},[_vm._v(_vm._s(new Date(_vm.diagnosticReport.issued).toLocaleString()))]):_vm._e()]),_c('div',{staticClass:"form-row"},[_c('label',{staticClass:"col-md-3 col-form-label"},[_vm._v("Status")]),_c('label',{staticClass:"col-md-9 col-form-label"},[_vm._v(_vm._s(_vm.diagnosticReport.status))])]),_c('div',{staticClass:"form-row"},[_c('label',{staticClass:"col-md-3 col-form-label"},[_vm._v("Documents")]),_c('label',{staticClass:"col-md-9 col-form-label"},_vm._l((_vm.presentedForms),function(document,index){return _c('a',{key:document.url,attrs:{"href":_vm.getDocumentUrl(document.url),"target":"_blank"}},[_vm._v(_vm._s(index + 1))])}),0)]),_c('h5',[_vm._v("Other Observations")]),_c('div',{staticClass:"form-row"},[_c('label',{staticClass:"col-md-3 col-form-label"},[_vm._v("Chromosomal Instability")]),_c('label',{staticClass:"col-md-9 col-form-label"},[_vm._v(_vm._s(_vm.chromosomalInstability))])]),_c('div',{staticClass:"form-row"},[_c('label',{staticClass:"col-md-3 col-form-label"},[_vm._v("Germline Pathogenicity")]),_c('label',{staticClass:"col-md-9 col-form-label"},[_vm._v(_vm._s(_vm.germlinePathogenicity))])]),_c('div',{staticClass:"form-row"},[_c('label',{staticClass:"col-md-3 col-form-label"},[_vm._v("Percentage Tumor Tissue")]),_c('label',{staticClass:"col-md-9 col-form-label"},[_vm._v(_vm._s(_vm.percentTumorTissue))])]),_c('div',{staticClass:"form-row"},[_c('label',{staticClass:"col-md-3 col-form-label"},[_vm._v("Quality")]),_c('label',{staticClass:"col-md-9 col-form-label"},[_vm._v(_vm._s(_vm.qualityFlags))])]),_c('div',{staticClass:"form-row"},[_c('label',{staticClass:"col-md-3 col-form-label"},[_vm._v("MSI")]),_c('label',{staticClass:"col-md-9 col-form-label"},[_vm._v(_vm._s(_vm.msi))])]),_c('div',{staticClass:"form-row"},[_c('label',{staticClass:"col-md-3 col-form-label"},[_vm._v("TMB")]),_c('label',{staticClass:"col-md-9 col-form-label"},[_vm._v(_vm._s(_vm.tmb))])])]):_c('table',{staticClass:"table table-sm table-hover meta-table"},[_c('tbody',[_c('tr',[_c('th',[_vm._v("Issued")]),_c('td',[(_vm.diagnosticReport.issued)?_c('span',[_vm._v(_vm._s(new Date(_vm.diagnosticReport.issued).toLocaleString()))]):_vm._e()])]),_c('tr',[_c('th',[_vm._v("Status")]),_c('td',[_vm._v(_vm._s(_vm.diagnosticReport.status))])]),_c('tr',[_c('th',[_vm._v("Documents")]),_c('td',_vm._l((_vm.presentedForms),function(document,index){return _c('a',{key:document.url,attrs:{"href":_vm.getDocumentUrl(document.url),"target":"_blank"}},[_vm._v(_vm._s(index + 1))])}),0)]),_c('tr',[_c('th',[_vm._v("Chromosomal Instability")]),_c('td',[_vm._v(_vm._s(_vm.chromosomalInstability))])]),_c('tr',[_c('th',[_vm._v("Germline Pathogenicity")]),_c('td',[_vm._v(_vm._s(_vm.germlinePathogenicity))])]),_c('tr',[_c('th',[_vm._v("Percentage Tumor Tissue")]),_c('td',[_vm._v(_vm._s(_vm.percentTumorTissue))])]),_c('tr',[_c('th',[_vm._v("Quality")]),_c('td',[_vm._v(_vm._s(_vm.qualityFlags))])]),_c('tr',[_c('th',[_vm._v("MSI")]),_c('td',[_vm._v(_vm._s(_vm.msi))])]),_c('tr',[_c('th',[_vm._v("TMB")]),_c('td',[_vm._v(_vm._s(_vm.tmb))])])])])]),_c('div',[_c('h5',[_vm._v("All Variants")]),(_vm.snvs && _vm.snvs.length)?_c('genetic-variant-table',{attrs:{"geneticObservations":_vm.snvs,"type":"snv","title":"SNVs","tableBackground":_vm.tableBackground,"tableHeaderBackground":_vm.tableHeaderBackground}}):_vm._e(),(_vm.cnvs && _vm.cnvs.length)?_c('genetic-variant-table',{attrs:{"geneticObservations":_vm.cnvs,"type":"cnv","title":"CNVs","tableBackground":_vm.tableBackground,"tableHeaderBackground":_vm.tableHeaderBackground}}):_vm._e(),(_vm.svs && _vm.svs.length)?_c('genetic-variant-table',{attrs:{"geneticObservations":_vm.svs,"type":"sv","title":"SVs","tableBackground":_vm.tableBackground,"tableHeaderBackground":_vm.tableHeaderBackground}}):_vm._e()],1)]):_vm._e()])}
var GeneticReportvue_type_template_id_3c67fb3e_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/GeneticReport.vue?vue&type=template&id=3c67fb3e&scoped=true&

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.url-search-params.js
var web_url_search_params = __webpack_require__("9861");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.to-fixed.js
var es_number_to_fixed = __webpack_require__("b680");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"465b08a6-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/GeneticVariantTable.vue?vue&type=template&id=d6788aaa&scoped=true&
var GeneticVariantTablevue_type_template_id_d6788aaa_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"genetic-header"},[_c('h6',[_vm._v(_vm._s(_vm.title))]),(_vm.showColumnHideOptions)?_c('div',{staticClass:"column-hide-options"},[_c('button',{staticClass:"btn btn-link",attrs:{"type":"button"},on:{"click":_vm.toggleDropdown}},[_vm._v("Column selection ▾")])]):_vm._e()]),_c('div',{staticClass:"dropdown-wrapper"},[(_vm.showDropdown)?_c('div',{staticClass:"dropdown"},[_c('div',{staticClass:"dropdown-top"},[_vm._m(0),_c('div',[_c('button',{staticClass:"btn btn-link",attrs:{"type":"button"},on:{"click":_vm.toggleDropdown}},[_c('strong',[_vm._v("×")])])])]),_c('div',[_c('div',{staticClass:"form-check form-check-inline"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.showId),expression:"showId"}],staticClass:"form-check-input",attrs:{"type":"checkbox","id":_vm.id},domProps:{"checked":Array.isArray(_vm.showId)?_vm._i(_vm.showId,null)>-1:(_vm.showId)},on:{"change":function($event){var $$a=_vm.showId,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.showId=$$a.concat([$$v]))}else{$$i>-1&&(_vm.showId=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.showId=$$c}}}}),_c('label',{staticClass:"form-check-label",attrs:{"for":_vm.id}},[_vm._v("Id")])])]),_vm._l((_vm.filteredComponents),function(component){return _c('div',{key:_vm.id + '/' + component.system + '/' + component.code},[_c('div',{staticClass:"form-check form-check-inline"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(component.visible),expression:"component.visible"}],staticClass:"form-check-input",attrs:{"type":"checkbox","id":_vm.id + '/' + component.system + '/' + component.code},domProps:{"checked":Array.isArray(component.visible)?_vm._i(component.visible,null)>-1:(component.visible)},on:{"change":function($event){var $$a=component.visible,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(component, "visible", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(component, "visible", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(component, "visible", $$c)}}}}),_c('label',{staticClass:"form-check-label",attrs:{"for":_vm.id + '/' + component.system + '/' + component.code}},[_vm._v(_vm._s(component.display))])])])})],2):_vm._e()]),_c('table',{staticClass:"table table-sm",style:({ background: _vm.tableBackground })},[_c('thead',[_c('tr',{style:({ background: _vm.tableHeaderBackground })},[_c('th'),(_vm.showId)?_c('th',[_vm._v("Id")]):_vm._e(),_vm._l((_vm.visibleComponents),function(component){return _c('th',{key:component.system + '/' + component.code},[_vm._v(_vm._s(component.display))])})],2)]),_c('tbody',_vm._l((_vm.geneticObservations),function(resource){return _c('tr',{key:resource.id},[_c('td',[_vm._v("☆")]),(_vm.showId)?_c('td',[_vm._v(_vm._s(resource.id))]):_vm._e(),_vm._l((_vm.visibleComponents),function(component){return _c('td',{key:component.system + '/' + component.code},_vm._l((_vm.getComponentValues(resource, component.expression)),function(value){return _c('span',{key:value},[(component.link && component.link.url && component.link.attribute)?_c('span',[_c('a',{attrs:{"href":_vm.createLink(component, value),"target":"_blank"}},[_vm._v(_vm._s(value))])]):_c('span',[_vm._v(_vm._s(value)+" ")])])}),0)})],2)}),0)])])}
var GeneticVariantTablevue_type_template_id_d6788aaa_scoped_true_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('strong',[_vm._v("Columns")])])}]


// CONCATENATED MODULE: ./src/components/GeneticVariantTable.vue?vue&type=template&id=d6788aaa&scoped=true&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.link.js
var es_string_link = __webpack_require__("9911");

// EXTERNAL MODULE: external "lodash"
var external_lodash_ = __webpack_require__("60bb");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/GeneticVariantTable.vue?vue&type=script&lang=js&








//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var EXPRESSION_BASE = "Observation.component.where(code.coding.system='%system' and code.coding.code='%code')";
var EXPRESSION_CODEABLE_CONCEPT = EXPRESSION_BASE + ".valueCodeableConcept.coding.iif($this.display.exists(), $this.display, $this.code)";
var EXPRESSION_QUANTITY = EXPRESSION_BASE + ".valueQuantity.value";
var EXPRESSION_RANGE = EXPRESSION_BASE + ".valueRange.select(iif($this.low.value.exists(), $this.low.value.toString(), '') + '-' + iif($this.high.value.exists(), $this.high.value.toString(), ''))";
var EXPRESSION_INTEGER = EXPRESSION_BASE + ".valueInteger";
var EXPRESSION_STRING = EXPRESSION_BASE + ".valueString";
/* harmony default export */ var GeneticVariantTablevue_type_script_lang_js_ = ({
  props: {
    hideId: {
      type: Boolean,
      default: true
    },
    showColumnHideOptions: {
      type: Boolean,
      default: true
    },
    components: {
      type: Array
    },
    geneticObservations: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    type: {
      type: String,
      default: "snv"
    },
    title: {
      type: String,
      default: "Variants"
    },
    tableHeaderBackground: {
      type: String,
      default: ""
    },
    tableBackground: {
      type: String,
      default: ""
    }
  },
  data: function data() {
    return {
      showId: true,
      showDropdown: false,
      allComponents: [{
        system: "http://loinc.org",
        code: "48018-6",
        display: "Gene",
        expression: null,
        visible: true,
        valueType: "CodeableConcept",
        variantTypes: ["snv", "cnv", "sv"],
        link: {
          url: "https://oncokb.org/gene/%s",
          attribute: "display"
        }
      }, {
        system: "http://loinc.org",
        code: "48001-2",
        display: "Chromosome",
        expression: null,
        visible: true,
        valueType: "CodeableConcept",
        variantTypes: ["cnv", "snv"]
      }, {
        system: "http://loinc.org",
        code: "82155-3",
        display: "Copy Number",
        expression: null,
        visible: true,
        valueType: "Quantity",
        variantTypes: ["cnv"]
      }, {
        system: "http://loinc.org",
        code: "62374-4",
        display: "Reference",
        expression: null,
        visible: false,
        valueType: "CodeableConcept",
        variantTypes: ["snv", "cnv", "sv"]
      }, {
        system: "http://loinc.org",
        code: "48002-0",
        display: "Genomic source class",
        expression: null,
        visible: true,
        valueType: "CodeableConcept",
        variantTypes: ["snv", "cnv", "sv"]
      }, {
        system: "http://loinc.org",
        code: "48019-4",
        display: "DNA change type",
        expression: null,
        visible: true,
        valueType: "CodeableConcept",
        variantTypes: ["snv", "cnv", "sv"]
      }, {
        system: "http://loinc.org",
        code: "48004-6",
        display: "c.HGVS",
        expression: null,
        visible: true,
        valueType: "CodeableConcept",
        variantTypes: ["snv"]
      }, {
        system: "http://loinc.org",
        code: "48005-3",
        display: "p.HGVS",
        expression: null,
        visible: true,
        valueType: "CodeableConcept",
        variantTypes: ["snv"]
      }, {
        system: "http://loinc.org",
        code: "51958-7",
        display: "Transcript ID",
        expression: null,
        visible: true,
        valueType: "CodeableConcept",
        variantTypes: ["snv", "cnv"],
        link: {
          url: "https://www.ncbi.nlm.nih.gov/nuccore/%s",
          attribute: "display"
        }
      }, {
        system: "http://loinc.org",
        code: "81258-6",
        display: "Sample Allelic Frequency",
        expression: null,
        visible: true,
        valueType: "Quantity",
        variantTypes: ["snv"]
      }, {
        system: "http://loinc.org",
        code: "82121-5",
        display: "Allelic read depth",
        expression: null,
        visible: false,
        valueType: "integer",
        variantTypes: ["snv", "cnv"]
      }, {
        system: "http://loinc.org",
        code: "81259-4",
        display: "Associated phenotype",
        expression: null,
        visible: false,
        valueType: "CodeableConcept",
        variantTypes: ["snv", "cnv", "sv"]
      }, {
        system: "http://loinc.org",
        code: "53037-8",
        display: "Clinical significance",
        expression: null,
        visible: true,
        valueType: "CodeableConcept",
        variantTypes: ["snv", "cnv", "sv"]
      }, {
        system: "http://hl7.org/fhir/uv/genomics-reporting/CodeSystem/tbd-codes",
        code: "exact-start-end",
        display: "Start & End",
        expression: null,
        visible: false,
        valueType: "Range",
        variantTypes: ["snv", "cnv"]
      }, {
        system: "http://loinc.org",
        code: "69547-8",
        display: "Ref allele",
        expression: null,
        visible: false,
        valueType: "string",
        variantTypes: ["snv", "cnv"]
      }, {
        system: "http://loinc.org",
        code: "69551-0",
        display: "Alt allele",
        expression: null,
        visible: false,
        valueType: "string",
        variantTypes: ["snv", "cnv"]
      }, {
        system: "http://molit.eu/fhir/vitu-tbd-codes",
        code: "left-bp",
        display: "Left breakpoint position",
        expression: null,
        visible: true,
        valueType: "CodeableConcept",
        variantTypes: ["sv"]
      }, {
        system: "http://molit.eu/fhir/vitu-tbd-codes",
        code: "right-bp",
        display: "Right breakpoint position",
        expression: null,
        visible: true,
        valueType: "CodeableConcept",
        variantTypes: ["sv"]
      }, {
        system: "http://molit.eu/fhir/vitu-tbd-codes",
        code: "cnv-size",
        display: "CNV Size",
        expression: null,
        visible: true,
        valueType: "CodeableConcept",
        variantTypes: ["cnv"]
      }, {
        system: "http://molit.eu/fhir/vitu-tbd-codes",
        code: "exons",
        display: "Exons",
        expression: null,
        visible: false,
        valueType: "Range",
        variantTypes: ["cnv"]
      }],
      filteredComponents: []
    };
  },
  computed: {
    visibleComponents: function visibleComponents() {
      return this.filteredComponents ? this.filteredComponents.filter(function (c) {
        return c.visible !== false;
      }) : [];
    },
    id: function id() {
      return Object(external_lodash_["uniqueId"])();
    }
  },
  methods: {
    getComponentValues: function getComponentValues(observation, expression) {
      if (!observation || !expression) {
        return [];
      }

      return fhirpath_min.evaluate(observation, expression).filter(function (s) {
        return s !== "SNV" && s !== "copy_number_variation" && s !== "structural_alteration";
      });
    },
    createLink: function createLink(component, value) {
      if (!component || !component.link || !component.link.url || !component.link.attribute) {
        return null;
      }

      return component.link.url.replace("%s", value);
    },
    toggleDropdown: function toggleDropdown() {
      this.showDropdown = !this.showDropdown;
    },
    addExpressionsToComponents: function addExpressionsToComponents(components) {
      if (!components) {
        return [];
      }

      return components.map(function (c) {
        switch (c.valueType) {
          case "Quantity":
            c.expression = EXPRESSION_QUANTITY;
            break;

          case "string":
            c.expression = EXPRESSION_STRING;
            break;

          case "integer":
            c.expression = EXPRESSION_INTEGER;
            break;

          case "Range":
            c.expression = EXPRESSION_RANGE;
            break;

          default:
            c.expression = EXPRESSION_CODEABLE_CONCEPT;
        }

        c.expression = c.expression.replace("%system", c.system).replace("%code", c.code);
        return c;
      });
    },
    initializeComponents: function initializeComponents() {
      var _this = this;

      if (this.components) {
        this.filteredComponents = this.addExpressionsToComponents(this.components);
      } else {
        this.allComponents = this.addExpressionsToComponents(this.allComponents);
        this.filteredComponents = this.allComponents.filter(function (c) {
          return c && c.variantTypes && c.variantTypes.includes(_this.type);
        });
      }
    }
  },
  created: function created() {
    this.showId = !this.hideId;
    this.initializeComponents();
  }
});
// CONCATENATED MODULE: ./src/components/GeneticVariantTable.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_GeneticVariantTablevue_type_script_lang_js_ = (GeneticVariantTablevue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/GeneticVariantTable.vue?vue&type=style&index=0&id=d6788aaa&lang=scss&scoped=true&
var GeneticVariantTablevue_type_style_index_0_id_d6788aaa_lang_scss_scoped_true_ = __webpack_require__("f674");

// CONCATENATED MODULE: ./src/components/GeneticVariantTable.vue






/* normalize component */

var GeneticVariantTable_component = normalizeComponent(
  components_GeneticVariantTablevue_type_script_lang_js_,
  GeneticVariantTablevue_type_template_id_d6788aaa_scoped_true_render,
  GeneticVariantTablevue_type_template_id_d6788aaa_scoped_true_staticRenderFns,
  false,
  null,
  "d6788aaa",
  null
  
)

/* harmony default export */ var GeneticVariantTable = (GeneticVariantTable_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/GeneticReport.vue?vue&type=script&lang=js&












//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var FHIRPATH_CHROMOSOMAL_INSTABILITY = "Bundle.entry.resource.where(resourceType='Observation').where(code.coding.system='http://ncit.nci.nih.gov' and code.coding.code='C48195').valueBoolean";
var FHIRPATH_CNVS = "Bundle.entry.resource.where(resourceType='Observation')\n.where(code.coding.system='http://loinc.org' and code.coding.code='69548-6')\n.where(component.code.coding.exists(system='http://loinc.org' and code='48019-4') and component.valueCodeableConcept.coding.exists(system='http://sequenceontology.org' and code='SO:0001019'))";
var FHIRPATH_DIAGNOSTIC_REPORT = "Bundle.entry.resource.where(resourceType='DiagnosticReport').single()";
var FHIRPATH_GERMLINE_PATHOGENICITY = "Bundle.entry.resource.where(resourceType='Observation').where(code.coding.system='http://ncit.nci.nih.gov' and code.coding.code='C168797')\n  .valueCodeableConcept.coding.where(system='http://terminology.hl7.org/CodeSystem/v2-0136').display";
var FHIRPATH_MSI = "Bundle.entry.resource.where(resourceType='Observation')\n  .where(code.coding.system='http://loinc.org' and code.coding.code='81695-9')\n  .valueCodeableConcept.coding.where(system='http://loinc.org').display";
var FHIRPATH_PATIENT = "Bundle.entry.resource.where(resourceType='Patient').single()";
var FHIRPATH_PERCENT_TUMOR_TISSUE = "Bundle.entry.resource.where(resourceType='Observation').where(code.coding.system='http://ncit.nci.nih.gov' and code.coding.code='C166246').valueQuantity.value";
var FHIRPATH_QUALITY_FLAGS = "Bundle.entry.resource.where(resourceType='Observation')\n  .where(code.coding.system='http://molit.eu/fhir/vitu-tbd-codes' and code.coding.code='quality_flags')\n  .valueCodeableConcept.coding.where(system='http://molit.eu/fhir/vitu-tbd-codes').display";
var FHIRPATH_RESULTS = "Bundle.entry.resource.where(resourceType='Observation').where(code.coding.system='http://loinc.org' and code.coding.code='69548-6')";
var FHIRPATH_SNVS = "Bundle.entry.resource.where(resourceType='Observation')\n  .where(code.coding.system='http://loinc.org' and code.coding.code='69548-6')\n  .where(component.code.coding.exists(system='http://loinc.org' and code='48019-4') and component.valueCodeableConcept.coding.exists(system='http://sequenceontology.org' and code='SO:0001483'))";
var FHIRPATH_SVS = "Bundle.entry.resource.where(resourceType='Observation')\n  .where(code.coding.system='http://loinc.org' and code.coding.code='69548-6')\n  .where(component.code.coding.exists(system='http://loinc.org' and code='48019-4') and component.valueCodeableConcept.coding.exists(system='http://sequenceontology.org' and code='SO:0001785'))";
var FHIRPATH_SPECIMEN = "Bundle.entry.resource.where(resourceType='Specimen').single()";
var FHIRPATH_TMB = "Bundle.entry.resource.where(resourceType='Observation').where(code.coding.system='http://loinc.org' and code.coding.code='94076-7')\n  .interpretation.coding.where(system='http://terminology.hl7.org/CodeSystem/v3-ObservationInterpretation').display";
/* harmony default export */ var GeneticReportvue_type_script_lang_js_ = ({
  props: {
    fhirBaseUrl: {
      type: String,
      required: true
    },
    id: {
      type: String,
      required: true
    },
    token: {
      type: String
    },
    tableBackground: {
      type: String,
      default: "#ecf0f1"
    },
    tableHeaderBackground: {
      type: String,
      default: "#ecf0f1"
    },
    tableRelevantBackground: {
      type: String,
      default: "#ecf0f1"
    },
    tableRelevantHeaderBackground: {
      type: String,
      default: "#ecf0f1"
    },
    enableRelevantVariants: {
      type: Boolean,
      default: false
    },
    metaAsTable: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      bundle: null
    };
  },
  computed: {
    params: function params() {
      var params = new URLSearchParams();
      params.append("_id", this.id);
      params.append("_include", "DiagnosticReport:result");
      params.append("_include", "DiagnosticReport:performer");
      params.append("_include", "DiagnosticReport:specimen");
      params.append("_include", "DiagnosticReport:subject");
      params.append("_count", 1);
      return params;
    },
    chromosomalInstability: function chromosomalInstability() {
      return fhirpath_min.evaluate(this.bundle, FHIRPATH_CHROMOSOMAL_INSTABILITY)[0];
    },
    cnvs: function cnvs() {
      return fhirpath_min.evaluate(this.bundle, FHIRPATH_CNVS);
    },
    diagnosticReport: function diagnosticReport() {
      return fhirpath_min.evaluate(this.bundle, FHIRPATH_DIAGNOSTIC_REPORT)[0];
    },
    germlinePathogenicity: function germlinePathogenicity() {
      return fhirpath_min.evaluate(this.bundle, FHIRPATH_GERMLINE_PATHOGENICITY).join(",");
    },
    msi: function msi() {
      return fhirpath_min.evaluate(this.bundle, FHIRPATH_MSI).join(",");
    },
    patient: function patient() {
      return fhirpath_min.evaluate(this.bundle, FHIRPATH_PATIENT)[0];
    },
    percentTumorTissue: function percentTumorTissue() {
      return fhirpath_min.evaluate(this.bundle, FHIRPATH_PERCENT_TUMOR_TISSUE).map(function (p) {
        return p.toFixed(2);
      }).join(",");
    },
    presentedForms: function presentedForms() {
      if (!this.diagnosticReport || !this.diagnosticReport.presentedForm) {
        return [];
      } else {
        return this.diagnosticReport.presentedForm;
      }
    },
    qualityFlags: function qualityFlags() {
      return fhirpath_min.evaluate(this.bundle, FHIRPATH_QUALITY_FLAGS).join(",");
    },
    results: function results() {
      return fhirpath_min.evaluate(this.bundle, FHIRPATH_RESULTS);
    },
    snvs: function snvs() {
      return fhirpath_min.evaluate(this.bundle, FHIRPATH_SNVS);
    },
    svs: function svs() {
      return fhirpath_min.evaluate(this.bundle, FHIRPATH_SVS);
    },
    specimen: function specimen() {
      return fhirpath_min.evaluate(this.bundle, FHIRPATH_SPECIMEN)[0];
    },
    tmb: function tmb() {
      return fhirpath_min.evaluate(this.bundle, FHIRPATH_TMB).join(",");
    }
  },
  methods: {
    fetchResources: function fetchResources() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var response;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return Object(fhir_api_["fetchResources"])(_this.fhirBaseUrl, "DiagnosticReport", _this.params, _this.token);

              case 3:
                response = _context.sent;
                _this.bundle = response.data;
                _context.next = 11;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](0);
                console.error(_context.t0);

                _this.$emit("error", _context.t0);

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 7]]);
      }))();
    },
    getDocumentUrl: function getDocumentUrl(url) {
      if (url.startsWith("http")) {
        return url;
      } else {
        return "".concat(this.fhirBaseUrl, "/").concat(url);
      }
    }
  },
  created: function created() {
    this.fetchResources();
  },
  components: {
    GeneticVariantTable: GeneticVariantTable
  }
});
// CONCATENATED MODULE: ./src/components/GeneticReport.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_GeneticReportvue_type_script_lang_js_ = (GeneticReportvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/GeneticReport.vue?vue&type=style&index=0&id=3c67fb3e&lang=scss&scoped=true&
var GeneticReportvue_type_style_index_0_id_3c67fb3e_lang_scss_scoped_true_ = __webpack_require__("5d38");

// CONCATENATED MODULE: ./src/components/GeneticReport.vue






/* normalize component */

var GeneticReport_component = normalizeComponent(
  components_GeneticReportvue_type_script_lang_js_,
  GeneticReportvue_type_template_id_3c67fb3e_scoped_true_render,
  GeneticReportvue_type_template_id_3c67fb3e_scoped_true_staticRenderFns,
  false,
  null,
  "3c67fb3e",
  null
  
)

/* harmony default export */ var GeneticReport = (GeneticReport_component.exports);
// CONCATENATED MODULE: ./src/library-entry.js





























// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/entry-lib-no-default.js




/***/ }),

/***/ "fb6a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var global = __webpack_require__("da84");
var isArray = __webpack_require__("e8b5");
var isConstructor = __webpack_require__("68ee");
var isObject = __webpack_require__("861d");
var toAbsoluteIndex = __webpack_require__("23cb");
var lengthOfArrayLike = __webpack_require__("07fa");
var toIndexedObject = __webpack_require__("fc6a");
var createProperty = __webpack_require__("8418");
var wellKnownSymbol = __webpack_require__("b622");
var arrayMethodHasSpeciesSupport = __webpack_require__("1dde");
var un$Slice = __webpack_require__("f36a");

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('slice');

var SPECIES = wellKnownSymbol('species');
var Array = global.Array;
var max = Math.max;

// `Array.prototype.slice` method
// https://tc39.es/ecma262/#sec-array.prototype.slice
// fallback for not array-like ES3 strings and DOM objects
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  slice: function slice(start, end) {
    var O = toIndexedObject(this);
    var length = lengthOfArrayLike(O);
    var k = toAbsoluteIndex(start, length);
    var fin = toAbsoluteIndex(end === undefined ? length : end, length);
    // inline `ArraySpeciesCreate` for usage native `Array#slice` where it's possible
    var Constructor, result, n;
    if (isArray(O)) {
      Constructor = O.constructor;
      // cross-realm fallback
      if (isConstructor(Constructor) && (Constructor === Array || isArray(Constructor.prototype))) {
        Constructor = undefined;
      } else if (isObject(Constructor)) {
        Constructor = Constructor[SPECIES];
        if (Constructor === null) Constructor = undefined;
      }
      if (Constructor === Array || Constructor === undefined) {
        return un$Slice(O, k, fin);
      }
    }
    result = new (Constructor === undefined ? Array : Constructor)(max(fin - k, 0));
    for (n = 0; k < fin; k++, n++) if (k in O) createProperty(result, n, O[k]);
    result.length = n;
    return result;
  }
});


/***/ }),

/***/ "fc6a":
/***/ (function(module, exports, __webpack_require__) {

// toObject with fallback for non-array-like ES3 strings
var IndexedObject = __webpack_require__("44ad");
var requireObjectCoercible = __webpack_require__("1d80");

module.exports = function (it) {
  return IndexedObject(requireObjectCoercible(it));
};


/***/ }),

/***/ "fce3":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");
var global = __webpack_require__("da84");

// babel-minify and Closure Compiler transpiles RegExp('.', 's') -> /./s and it causes SyntaxError
var $RegExp = global.RegExp;

module.exports = fails(function () {
  var re = $RegExp('.', 's');
  return !(re.dotAll && re.exec('\n') && re.flags === 's');
});


/***/ }),

/***/ "fdbc":
/***/ (function(module, exports) {

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
module.exports = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};


/***/ }),

/***/ "fdbf":
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable es-x/no-symbol -- required for testing */
var NATIVE_SYMBOL = __webpack_require__("4930");

module.exports = NATIVE_SYMBOL
  && !Symbol.sham
  && typeof Symbol.iterator == 'symbol';


/***/ }),

/***/ "fe0f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VasQuestion_vue_vue_type_style_index_0_id_24872054_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("4a33");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VasQuestion_vue_vue_type_style_index_0_id_24872054_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_9_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_9_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_9_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_9_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_1_0_node_modules_vue_loader_lib_index_js_vue_loader_options_VasQuestion_vue_vue_type_style_index_0_id_24872054_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ })

/******/ });
//# sourceMappingURL=fhir-components.common.js.map